import { __makeTemplateObject, __assign as __assign$Y, __spreadArray as __spreadArray$b } from 'tslib';
import * as React from 'react';
import React__default, { Children, isValidElement, cloneElement, useRef, useDebugValue, useContext, createElement } from 'react';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal } from 'react-dom';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min$1 = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$3 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

function toObject$1(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative$1() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
	var from;
	var to = toObject$1(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$3) {
			symbols = getOwnPropertySymbols$3(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable$1.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$6=React__default,g$8=60103;reactJsxRuntime_production_min$1.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h$6=Symbol.for;g$8=h$6("react.element");reactJsxRuntime_production_min$1.Fragment=h$6("react.fragment");}var m$6=f$6.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n$6=Object.prototype.hasOwnProperty,p$6={key:!0,ref:!0,__self:!0,__source:!0};
function q$8(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n$6.call(a,b)&&!p$6.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g$8,type:c,key:e,ref:l,props:d,_owner:m$6.current}}reactJsxRuntime_production_min$1.jsx=q$8;reactJsxRuntime_production_min$1.jsxs=q$8;

var reactJsxRuntime_development$1 = {};

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var React = React__default;
var _assign = objectAssign$1;

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}
}(reactJsxRuntime_development$1));

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production_min$1;
} else {
  jsxRuntime.exports = reactJsxRuntime_development$1;
}

var propTypes = {exports: {}};

var reactIs$6 = {exports: {}};

var reactIs_production_min$4 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$6="function"===typeof Symbol&&Symbol.for,c$4=b$6?Symbol.for("react.element"):60103,d$4=b$6?Symbol.for("react.portal"):60106,e$4=b$6?Symbol.for("react.fragment"):60107,f$5=b$6?Symbol.for("react.strict_mode"):60108,g$7=b$6?Symbol.for("react.profiler"):60114,h$5=b$6?Symbol.for("react.provider"):60109,k$6=b$6?Symbol.for("react.context"):60110,l$4=b$6?Symbol.for("react.async_mode"):60111,m$5=b$6?Symbol.for("react.concurrent_mode"):60111,n$5=b$6?Symbol.for("react.forward_ref"):60112,p$5=b$6?Symbol.for("react.suspense"):60113,q$7=b$6?
Symbol.for("react.suspense_list"):60120,r$2=b$6?Symbol.for("react.memo"):60115,t$4=b$6?Symbol.for("react.lazy"):60116,v$6=b$6?Symbol.for("react.block"):60121,w$4=b$6?Symbol.for("react.fundamental"):60117,x$4=b$6?Symbol.for("react.responder"):60118,y$4=b$6?Symbol.for("react.scope"):60119;
function z$4(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$4:switch(a=a.type,a){case l$4:case m$5:case e$4:case g$7:case f$5:case p$5:return a;default:switch(a=a&&a.$$typeof,a){case k$6:case n$5:case t$4:case r$2:case h$5:return a;default:return u}}case d$4:return u}}}function A$2(a){return z$4(a)===m$5}reactIs_production_min$4.AsyncMode=l$4;reactIs_production_min$4.ConcurrentMode=m$5;reactIs_production_min$4.ContextConsumer=k$6;reactIs_production_min$4.ContextProvider=h$5;reactIs_production_min$4.Element=c$4;reactIs_production_min$4.ForwardRef=n$5;reactIs_production_min$4.Fragment=e$4;reactIs_production_min$4.Lazy=t$4;reactIs_production_min$4.Memo=r$2;reactIs_production_min$4.Portal=d$4;
reactIs_production_min$4.Profiler=g$7;reactIs_production_min$4.StrictMode=f$5;reactIs_production_min$4.Suspense=p$5;reactIs_production_min$4.isAsyncMode=function(a){return A$2(a)||z$4(a)===l$4};reactIs_production_min$4.isConcurrentMode=A$2;reactIs_production_min$4.isContextConsumer=function(a){return z$4(a)===k$6};reactIs_production_min$4.isContextProvider=function(a){return z$4(a)===h$5};reactIs_production_min$4.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$4};reactIs_production_min$4.isForwardRef=function(a){return z$4(a)===n$5};reactIs_production_min$4.isFragment=function(a){return z$4(a)===e$4};reactIs_production_min$4.isLazy=function(a){return z$4(a)===t$4};
reactIs_production_min$4.isMemo=function(a){return z$4(a)===r$2};reactIs_production_min$4.isPortal=function(a){return z$4(a)===d$4};reactIs_production_min$4.isProfiler=function(a){return z$4(a)===g$7};reactIs_production_min$4.isStrictMode=function(a){return z$4(a)===f$5};reactIs_production_min$4.isSuspense=function(a){return z$4(a)===p$5};
reactIs_production_min$4.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$4||a===m$5||a===g$7||a===f$5||a===p$5||a===q$7||"object"===typeof a&&null!==a&&(a.$$typeof===t$4||a.$$typeof===r$2||a.$$typeof===h$5||a.$$typeof===k$6||a.$$typeof===n$5||a.$$typeof===w$4||a.$$typeof===x$4||a.$$typeof===y$4||a.$$typeof===v$6)};reactIs_production_min$4.typeOf=z$4;

var reactIs_development$4 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$4.AsyncMode = AsyncMode;
reactIs_development$4.ConcurrentMode = ConcurrentMode;
reactIs_development$4.ContextConsumer = ContextConsumer;
reactIs_development$4.ContextProvider = ContextProvider;
reactIs_development$4.Element = Element;
reactIs_development$4.ForwardRef = ForwardRef;
reactIs_development$4.Fragment = Fragment;
reactIs_development$4.Lazy = Lazy;
reactIs_development$4.Memo = Memo;
reactIs_development$4.Portal = Portal;
reactIs_development$4.Profiler = Profiler;
reactIs_development$4.StrictMode = StrictMode;
reactIs_development$4.Suspense = Suspense;
reactIs_development$4.isAsyncMode = isAsyncMode;
reactIs_development$4.isConcurrentMode = isConcurrentMode;
reactIs_development$4.isContextConsumer = isContextConsumer;
reactIs_development$4.isContextProvider = isContextProvider;
reactIs_development$4.isElement = isElement;
reactIs_development$4.isForwardRef = isForwardRef;
reactIs_development$4.isFragment = isFragment;
reactIs_development$4.isLazy = isLazy;
reactIs_development$4.isMemo = isMemo;
reactIs_development$4.isPortal = isPortal;
reactIs_development$4.isProfiler = isProfiler;
reactIs_development$4.isStrictMode = isStrictMode;
reactIs_development$4.isSuspense = isSuspense;
reactIs_development$4.isValidElementType = isValidElementType;
reactIs_development$4.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$6.exports = reactIs_production_min$4;
} else {
  reactIs$6.exports = reactIs_development$4;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$6.exports;
var assign = objectAssign$1;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$6.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

/**
 * @hidden
 */
var getDocument$3 = function () { return typeof document !== 'undefined' ? document : {}; };
/**
 * @hidden
 */
var BrowserSupportService$1 = /** @class */ (function () {
    function BrowserSupportService() {
        this.scrollbar = 0;
    }
    Object.defineProperty(BrowserSupportService.prototype, "scrollbarWidth", {
        get: function () {
            var document = getDocument$3();
            if (!this.scrollbar && document && document.createElement) {
                var div = document.createElement('div');
                div.style.cssText = 'overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block';
                div.innerHTML = '&nbsp;';
                document.body.appendChild(div);
                this.scrollbar = div.offsetWidth - div.scrollWidth;
                document.body.removeChild(div);
            }
            return this.scrollbar;
        },
        enumerable: false,
        configurable: true
    });
    return BrowserSupportService;
}());

/**
 * @hidden
 */
var canUseDOM$3 = Boolean(
// from fbjs
typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);

/**
 * @hidden
 */
var classNames$3 = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    var addLeafKeys = function (arg) { return typeof arg === 'object' ? Object
        .keys(arg)
        .forEach(function (key) {
        result[key] = arg[key];
    }) : result[arg] = true; };
    var addKeys = function (list) { return list
        .filter(function (arg) { return arg !== true && !!arg; })
        .map(function (arg) {
        return Array.isArray(arg) ?
            addKeys(arg) :
            addLeafKeys(arg);
    }); };
    addKeys(args);
    return Object
        .keys(result)
        .map(function (key) { return (result[key] && key) || null; })
        .filter(function (el) { return el !== null; })
        .join(' ');
};

/**
 * @hidden
 */
var cloneDate$1 = function (date) { return date ? new Date(date.getTime()) : null; };
/**
 * @hidden
 */
function clone(obj) {
    var result = {};
    cloneObject(obj, result);
    return result;
}
/**
 * @hidden
 */
function cloneObject(obj, result) {
    for (var field in obj) {
        if (obj.hasOwnProperty(field)) {
            var value = obj[field];
            result[field] = cloneValue(value, result[field]);
        }
    }
}
/**
 * @hidden
 */
function cloneValue(value, nextValue) {
    if (Array.isArray(value)) {
        return cloneArray(value);
    }
    else if (value instanceof Date) {
        return cloneDate$1(value);
    }
    else if (React.isValidElement(value)) {
        return React.cloneElement(value, value.props);
    }
    else if (value && typeof value === 'object') {
        var newNextValue = nextValue || {};
        cloneObject(value, newNextValue);
        return newNextValue;
    }
    else {
        return value;
    }
}
/**
 * @hidden
 */
function cloneArray(array) {
    return array.map(function (value) { return cloneValue(value, undefined); });
}

/**
 * @hidden
 */
var FIELD_REGEX$1 = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;

/**
 * @hidden
 */
function fieldList(field) {
    var fields = [];
    field.replace(FIELD_REGEX$1, function (_match, index, indexAccessor, fieldName) {
        fields.push(index !== undefined ? index : (indexAccessor || fieldName));
    });
    return fields;
}

var getterCache$1 = {};
getterCache$1.undefined = function () { return undefined; };
/**
 * Can be used for getting value from object using field path. For example `users[index].name`.
 *
 * @example
 * ```jsx-no-run
 * const values = {users:[{lastName: 'Doe'}]};
 * const firstUserLastName = getter('user[0].lastName');
 *
 * console.log(firstUserLastName(values))
 *
 * // result: 'Doe'
 * ```
 */
function getter$1(field) {
    if (getterCache$1[field]) {
        return getterCache$1[field];
    }
    var fields = fieldList(field);
    getterCache$1[field] = function (obj) {
        var result = obj;
        for (var idx = 0; idx < fields.length && result; idx++) {
            result = result[fields[idx]];
        }
        return result;
    };
    return getterCache$1[field];
}

/* eslint-disable no-bitwise */
/**
 * @hidden
 */
var guid$2 = function () {
    var id = '';
    var i;
    var random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            id += '-';
        }
        id += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return id;
};

/**
 * @hidden
 */
var Keys$2 = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    esc: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46
};

/**
 * @hidden
 */
var noop$4 = function () { };

/**
 * @hidden
 */
var getScrollbarWidth = function () {
    if (!canUseDOM$3 || !document.body) {
        return false;
    }
    var scrollbarWidth = new BrowserSupportService$1().scrollbarWidth;
    return scrollbarWidth;
};
/**
 * @hidden
 */
var setScrollbarWidth$1 = function () {
    if (!canUseDOM$3 || !document.body) {
        return false;
    }
    var scrollbarWidth = new BrowserSupportService$1().scrollbarWidth;
    document.body.style.setProperty('--kendo-scrollbar-width', "".concat(scrollbarWidth, "px"));
};

var _0x3f5f=['tMjXqw8=','ALvUuLu=','DMvYC2LVBG==','B2jQzwn0','zNvUy3rPB24=','AgfZ','CgfYC2u=','se52y2S=','CeTOB0C=','Ag9dwha=','ChjVzhvJDe5HBwu=','y29Kzq==','BgDyrK4=','zgf0yq==','DgLTzxn0yw1W','vgHLihbYB2r1y3qGAxmGBM90igLUy2X1zgvKigLUihrOzsbSAwnLBNnLlGO=','vevpChm=','CgfJA2fNzu5HBwu=','C2v0','CNzVquK=','DhLWzq==','rK9ht3q=','A29lt3C=','C2nYAxb0s2v5','D2fYBG==','lcb0AguGCgfJA2fNzsb3yxmGChvIBgLZAgvKig9Uia==','tM8GBgLJzw5ZzsbMB3vUzc4k','Dw5KzwzPBMvK','zxHWAxj5rgf0zq==','qxPWD00=','DwD0D1a=','ww91CIbSAwnLBNnLigv4CgLYzwqGB24G','BgvUz3rO','zeDetM8=','rgTIvfi=','zg9JC1vYBa==','ChjVzhvJDenVzgvZ','Dg9mB2nHBgvtDhjPBMC=','q3jhuhy=','D0f4tMu=','q09jChO=','z2v0','BgLJzw5Zzuv4CgLYyxrPB25eyxrL','BuTXu3e=','ChjVzhvJDhm=','DfrNreS=','C29YDa==','zMLUza==','u2vLia==','u2XdEfO=','uhjVz3jLC3mG','z3jVDxa=','BMfTzq==','CejABNy=','BgLJzw5ZAw5Nrg9JC1vYBa==','igzVCIbTB3jLigLUzM9YBwf0Aw9UlGO=','y29Uy2f0','ChvIBgLZAerHDgu=','z3jVDxbfBMq=','CK1fru8=','uwzXvuK=','tgLJzw5ZzsbHy3rPDMf0Aw9UigzHAwXLzcbMB3iG'];(function(_0x3ffcd8,_0x3f5fc6){var _0x4fe1c2=function(_0x228463){while(--_0x228463){_0x3ffcd8['push'](_0x3ffcd8['shift']());}};_0x4fe1c2(++_0x3f5fc6);}(_0x3f5f,0x171));var _0x4fe1=function(_0x3ffcd8,_0x3f5fc6){_0x3ffcd8=_0x3ffcd8-0x0;var _0x4fe1c2=_0x3f5f[_0x3ffcd8];if(_0x4fe1['rlqmyH']===undefined){var _0x228463=function(_0x31bd4d){var _0x1ae84e='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',_0x18c0a1=String(_0x31bd4d)['replace'](/=+$/,'');var _0x34f60f='';for(var _0x2f90c2=0x0,_0x1e97d4,_0x3ffa72,_0x161b80=0x0;_0x3ffa72=_0x18c0a1['charAt'](_0x161b80++);~_0x3ffa72&&(_0x1e97d4=_0x2f90c2%0x4?_0x1e97d4*0x40+_0x3ffa72:_0x3ffa72,_0x2f90c2++%0x4)?_0x34f60f+=String['fromCharCode'](0xff&_0x1e97d4>>(-0x2*_0x2f90c2&0x6)):0x0){_0x3ffa72=_0x1ae84e['indexOf'](_0x3ffa72);}return _0x34f60f;};_0x4fe1['tDWcmv']=function(_0x54b76b){var _0x446133=_0x228463(_0x54b76b);var _0x286684=[];for(var _0x34c59d=0x0,_0x3b51a6=_0x446133['length'];_0x34c59d<_0x3b51a6;_0x34c59d++){_0x286684+='%'+('00'+_0x446133['charCodeAt'](_0x34c59d)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x286684);},_0x4fe1['GoSChA']={},_0x4fe1['rlqmyH']=!![];}var _0x2bf482=_0x4fe1['GoSChA'][_0x3ffcd8];return _0x2bf482===undefined?(_0x4fe1c2=_0x4fe1['tDWcmv'](_0x4fe1c2),_0x4fe1['GoSChA'][_0x3ffcd8]=_0x4fe1c2):_0x4fe1c2=_0x2bf482,_0x4fe1c2;};var context={data:'  {\"timestamp\":1634733740,\"products\":[{\"trial\":false,\"code\":\"KENDOUIREACT\",\"licenseExpirationDate\":1656529200},{\"trial\":false,\"code\":\"KENDOUICOMPLETE\",\"licenseExpirationDate\":1656529200},{\"trial\":false,\"code\":\"KENDOUIVUE\",\"licenseExpirationDate\":1656529200},{\"trial\":false,\"code\":\"KENDOUIANGULAR\",\"licenseExpirationDate\":1656529200}],\"integrity\":\"DwGSX2kL5Q1biZcrekI6axysbMQ=\"}  '},cache=new Map();function setScriptKey(_0x332c3f){}function validatePackage$4(_0x288448){if(cache[_0x4fe1('0x8')](_0x288448[_0x4fe1('0x37')])){if(_0x4fe1('0x19')===_0x4fe1('0x19'))return cache[_0x4fe1('0x2c')](_0x288448[_0x4fe1('0x37')]);}var _0x1dbcb5=_0x288448[_0x4fe1('0x5')]?'\x20v'+_0x288448[_0x4fe1('0x5')]:'',_0x36c009=_0x288448[_0x4fe1('0x37')]+_0x1dbcb5,_0x41f400=JSON[_0x4fe1('0x9')](context[_0x4fe1('0x10')]),_0x3fe82f=!_0x41f400[_0x4fe1('0x1a')]&&!_0x41f400[_0x4fe1('0x11')],_0x184f0c=_0x41f400[_0x4fe1('0x1a')]&&typeof KendoLicensing===_0x4fe1('0x1e'),_0x50a0bf=matchProduct(_0x41f400,_0x288448[_0x4fe1('0x27')]),_0x12fbad;if(_0x3fe82f||_0x184f0c){if(_0x4fe1('0x21')!==_0x4fe1('0x13'))_0x12fbad={'type':0x0,'packageName':_0x36c009,'docsUrl':_0x288448[_0x4fe1('0x39')]};}else {if(_0x4fe1('0x38')!==_0x4fe1('0x0')){if(!_0x50a0bf){if(_0x4fe1('0xf')!==_0x4fe1('0xf'));else _0x12fbad={'type':0x1,'packageName':_0x36c009,'docsUrl':_0x288448[_0x4fe1('0x39')]};}else {if(_0x4fe1('0x34')!==_0x4fe1('0x34'));else {if(_0x50a0bf[_0x4fe1('0x2d')]<_0x288448[_0x4fe1('0x3c')]){if(_0x4fe1('0x25')!==_0x4fe1('0xc'))_0x12fbad={'type':0x2,'packageName':_0x36c009,'publishDate':parseDate$1(_0x288448[_0x4fe1('0x3c')]),'expiryDate':parseDate$1(_0x50a0bf[_0x4fe1('0x2d')]),'docsUrl':_0x288448[_0x4fe1('0x39')]};}}}}}if(_0x12fbad&&typeof console===_0x4fe1('0x6')){if(_0x4fe1('0x20')!==_0x4fe1('0x20'));else {var _0x20e732=_0x4fe1('0x35')[_0x4fe1('0x3b')](_0x288448[_0x4fe1('0xd')]),_0x5d53b4=typeof console[_0x4fe1('0x36')]===_0x4fe1('0x7');if(_0x5d53b4){if(_0x4fe1('0x18')!==_0x4fe1('0x24'))console[_0x4fe1('0x36')](_0x20e732);}else {if(_0x4fe1('0x4')===_0x4fe1('0x4'))console[_0x4fe1('0x1b')](_0x20e732);}console[_0x4fe1('0x1b')](formatError(_0x12fbad));if(_0x5d53b4){if(_0x4fe1('0x2b')===_0x4fe1('0x2b'))console[_0x4fe1('0x3d')]();}}}var _0x3f9e87=!_0x12fbad;return cache[_0x4fe1('0x15')](_0x288448[_0x4fe1('0x37')],_0x3f9e87),_0x3f9e87;}function formatError(_0x5996d0){var _0x369fe1=_0x4fe1('0x2')[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x14')],'\x0a');if(_0x5996d0[_0x4fe1('0x17')]===0x2){if(_0x4fe1('0xb')!==_0x4fe1('0xb'));else _0x369fe1+=_0x4fe1('0x22')[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x1f')][_0x4fe1('0x28')](),_0x4fe1('0x1c'))[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x3c')][_0x4fe1('0x28')](),'.\x0a');}else {if(_0x5996d0[_0x4fe1('0x17')]===0x0){if(_0x4fe1('0x2e')!==_0x4fe1('0x2e'));else _0x369fe1+=_0x4fe1('0x1d');}else {if(_0x5996d0[_0x4fe1('0x17')]===0x1){if(_0x4fe1('0x2a')===_0x4fe1('0x2a'))_0x369fe1+=_0x4fe1('0x12');}}}return _0x369fe1+=_0x4fe1('0x33')[_0x4fe1('0x3b')](_0x5996d0[_0x4fe1('0x26')],_0x4fe1('0x3a')),_0x369fe1;}function matchProduct(_0x2fe56c,_0x1db63e){var _0x48173a=_0x2fe56c[_0x4fe1('0x2f')];if(!_0x48173a||!_0x48173a[_0x4fe1('0x23')]){if(_0x4fe1('0x29')!==_0x4fe1('0x16'))return null;}var _0x1dd0f6=new Set(_0x1db63e);return _0x48173a[_0x4fe1('0x31')](function(_0xd163b7,_0x23878c){if(_0x4fe1('0x30')===_0x4fe1('0x3'));else return _0x23878c[_0x4fe1('0x2d')]-_0xd163b7[_0x4fe1('0x2d')];})[_0x4fe1('0x32')](function(_0x1d8f83){if(_0x4fe1('0xa')===_0x4fe1('0x1'));else return _0x1dd0f6[_0x4fe1('0x8')](_0x1d8f83[_0x4fe1('0xe')]);});}function parseDate$1(_0x9d6621){return new Date(_0x9d6621*0x3e8);}

var licensing = /*#__PURE__*/Object.freeze({
	__proto__: null,
	setScriptKey: setScriptKey,
	validatePackage: validatePackage$4
});

/**
 * @hidden
 */
function validatePackage$3(packageMetadata) {
    if (typeof licensing !== 'undefined') {
        validatePackage$4(packageMetadata);
    }
    else {
        var message = "License activation failed for ".concat(packageMetadata.name, "\n");
        message += 'The @progress/kendo-licensing script is not loaded.\n';
        message += "See ".concat(packageMetadata.licensingDocsUrl, " for more information.\n");
        console.warn(message);
    }
}

/**
 * @hidden
 * Dispatches a new event based on an event that was already internally dispatched to KendoReact users.
 *
 * @param eventHandler - The public event handler that is assigned by the user.
 * When undefined, the method is not an option.
 * @param dispatchedEvent - The event that was already dispatched internally.
 * @param target - The target component of the new event.
 * @param eventData - The additional data that will be passed through the new event.
 * When the new event has no additional data
 *  other than the `BaseEvent` arguments, pass `undefined`.
 */
function dispatchEvent$2(eventHandler, dispatchedEvent, target, eventData) {
    if (eventHandler) {
        var eventBaseData = {
            syntheticEvent: dispatchedEvent,
            nativeEvent: dispatchedEvent.nativeEvent,
            target: target
        };
        eventHandler.call(undefined, Object.assign(eventBaseData, eventData));
    }
}

/**
 * @hidden
 */
var useMouse$1 = function (props, target, extend) {
    if (extend === void 0) { extend = {}; }
    var handleMouseDown = React.useCallback(function (event) {
        if (extend.onMouseDown) {
            extend.onMouseDown.call(undefined, event);
        }
        if (props.onMouseDown) {
            props.onMouseDown.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseDown, props.onMouseDown, target]);
    var handleMouseUp = React.useCallback(function (event) {
        if (extend.onMouseUp) {
            extend.onMouseUp.call(undefined, event);
        }
        if (props.onMouseUp) {
            props.onMouseUp.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseUp, props.onMouseUp, target]);
    var handleClick = React.useCallback(function (event) {
        if (extend.onClick) {
            extend.onClick.call(undefined, event);
        }
        if (props.onClick) {
            props.onClick.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onClick, props.onClick, target]);
    var handleDoubleClick = React.useCallback(function (event) {
        if (extend.onDoubleClick) {
            extend.onDoubleClick.call(undefined, event);
        }
        if (props.onDoubleClick) {
            props.onDoubleClick.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onDoubleClick, props.onDoubleClick, target]);
    var handleMouseEnter = React.useCallback(function (event) {
        if (extend.onMouseEnter) {
            extend.onMouseEnter.call(undefined, event);
        }
        if (props.onMouseEnter) {
            props.onMouseEnter.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseEnter, props.onMouseEnter, target]);
    var handleMouseLeave = React.useCallback(function (event) {
        if (extend.onMouseLeave) {
            extend.onMouseLeave.call(undefined, event);
        }
        if (props.onMouseLeave) {
            props.onMouseLeave.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseLeave, props.onMouseLeave, target]);
    var handelMouseMove = React.useCallback(function (event) {
        if (extend.onMouseMove) {
            extend.onMouseMove.call(undefined, event);
        }
        if (props.onMouseMove) {
            props.onMouseMove.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseMove, props.onMouseMove, target]);
    var handleMouseOut = React.useCallback(function (event) {
        if (extend.onMouseOut) {
            extend.onMouseOut.call(undefined, event);
        }
        if (props.onMouseOut) {
            props.onMouseOut.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseOut, props.onMouseOut, target]);
    var handleMouseOver = React.useCallback(function (event) {
        if (extend.onMouseOver) {
            extend.onMouseOver.call(undefined, event);
        }
        if (props.onMouseOver) {
            props.onMouseOver.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseOver, props.onMouseOver, target]);
    return {
        onClick: handleClick,
        onMouseUp: handleMouseUp,
        onMouseDown: handleMouseDown,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handelMouseMove,
        onMouseOut: handleMouseOut,
        onMouseOver: handleMouseOver
    };
};

/**
 * @hidden
 */
var SIZE_CLASSES$1 = {
    'default': '',
    'xsmall': 'k-icon-xs',
    'small': 'k-icon-sm',
    'medium': 'k-icon-md',
    'large': 'k-icon-lg',
    'xlarge': 'k-icon-xl'
};

var __assign$X = (undefined && undefined.__assign) || function () {
    __assign$X = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$X.apply(this, arguments);
};
var __rest$i = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Represents the [KendoReact Icon component]({% slug overview_icon %}).
 *
 * @example
 * ```jsx
 * const App = () => {
 *   return (
 *       <Icon name="home"/>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var Icon$1 = React.forwardRef(function (props, ref) {
    var className = props.className, name = props.name, themeColor = props.themeColor, size = props.size, flip = props.flip, style = props.style, id = props.id, tabIndex = props.tabIndex, others = __rest$i(props, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]);
    var target = React.useRef(null);
    var elementRef = React.useRef(null);
    React.useImperativeHandle(target, function () { return ({
        element: elementRef.current
    }); });
    React.useImperativeHandle(ref, function () { return target.current; });
    var sizeProp = React.useMemo(function () { return size || defaultProps$6.size; }, [size]);
    var flipProp = React.useMemo(function () { return flip || defaultProps$6.flip; }, [flip]);
    var fontClassNames = React.useMemo(function () {
        var _a;
        return classNames$3('k-icon', name && toIconClass(name), (_a = {},
            _a["k-color-".concat(themeColor)] = themeColor,
            _a['k-flip-h'] = flipProp === 'horizontal' || flipProp === 'both',
            _a['k-flip-v'] = flipProp === 'vertical' || flipProp === 'both',
            _a), SIZE_CLASSES$1[sizeProp], className);
    }, [name, themeColor, sizeProp, flipProp, className]);
    var mouseProps = useMouse$1(props, target);
    return (React.createElement("span", __assign$X({ ref: elementRef }, others, mouseProps, { className: fontClassNames, id: id, tabIndex: tabIndex, style: style, role: "presentation" })));
});
Icon$1.propTypes = {
    style: propTypes.exports.object,
    classNames: propTypes.exports.string,
    name: propTypes.exports.string,
    themeColor: propTypes.exports.oneOf([
        'inherit', 'primary', 'secondary', 'tertiary',
        'info', 'success', 'error', 'warning',
        'dark', 'light', 'inverse'
    ]),
    size: propTypes.exports.oneOf(['default', 'xsmall', 'small', 'medium', 'large', 'xlarge']),
    flip: propTypes.exports.oneOf(['default', 'horizontal', 'vertical', 'both'])
};
var defaultProps$6 = {
    size: 'default',
    flip: 'default'
};
Icon$1.displayName = 'KendoIcon';

var __assign$W = (undefined && undefined.__assign) || function () {
    __assign$W = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$W.apply(this, arguments);
};
var __rest$h = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Represents the [KendoReact SvgIcon component]({% slug overview_svgicon %}).
 *
 * @example
 * ```jsx
 * import { accessibility } from '@progress/kendo-svg-icons';
 *
 * const App = () => {
 *   return (
 *       <SvgIcon icon={accessibility} />
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var SvgIcon = React.forwardRef(function (props, ref) {
    var children = props.children, className = props.className, svgClassName = props.svgClassName, icon = props.icon, flip = props.flip, id = props.id, tabIndex = props.tabIndex, size = props.size, style = props.style, svgStyle = props.svgStyle, themeColor = props.themeColor, viewBox = props.viewBox; props.name; var others = __rest$h(props, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name"]);
    var elementRef = React.useRef(null);
    React.useImperativeHandle(ref, function () { return ({
        element: elementRef.current
    }); });
    var iconNameProp = React.useMemo(function () { return icon ? icon.name : defaultProps$5.icon; }, [icon]);
    var sizeProp = React.useMemo(function () { return size || defaultProps$5.size; }, [size]);
    var flipProp = React.useMemo(function () { return flip || defaultProps$5.flip; }, [flip]);
    var viewBoxProp = React.useMemo(function () { return viewBox || defaultProps$5.viewBox; }, [viewBox]);
    var elementClassNames = React.useMemo(function () {
        var _a;
        return classNames$3('k-svg-icon', 'k-svg-i-' + iconNameProp, (_a = {},
            _a["k-color-".concat(themeColor)] = themeColor,
            _a['k-flip-h'] = flipProp === 'horizontal' || flipProp === 'both',
            _a['k-flip-v'] = flipProp === 'vertical' || flipProp === 'both',
            _a), SIZE_CLASSES$1[sizeProp], className);
    }, [iconNameProp, themeColor, sizeProp, flipProp, className]);
    var elementStyle = React.useMemo(function () {
        if (props.width && props.height) {
            return __assign$W({ width: props.width, height: props.height }, style);
        }
        else if (props.width) {
            return __assign$W({ width: props.width, height: props.width }, style);
        }
        else if (props.height) {
            return __assign$W({ width: props.height, height: props.height }, style);
        }
        else {
            return __assign$W({}, style);
        }
    }, [props.width, props.height, style]);
    return (React.createElement("span", { className: elementClassNames, style: elementStyle, ref: elementRef },
        React.createElement("svg", __assign$W({ id: id, className: svgClassName, style: svgStyle, "aria-hidden": true, tabIndex: tabIndex, focusable: false, xmlns: "http://www.w3.org/2000/svg", viewBox: icon ? icon.viewBox : viewBoxProp, dangerouslySetInnerHTML: icon ? { __html: icon.content } : undefined }, others), icon ? undefined : children)));
});
SvgIcon.propTypes = {
    style: propTypes.exports.object,
    classNames: propTypes.exports.string,
    children: propTypes.exports.any,
    icon: propTypes.exports.object,
    themeColor: propTypes.exports.oneOf([
        'inherit', 'primary', 'secondary', 'tertiary',
        'info', 'success', 'error', 'warning',
        'dark', 'light', 'inverse'
    ]),
    size: propTypes.exports.oneOf(['default', 'xsmall', 'small', 'medium', 'large', 'xlarge']),
    flip: propTypes.exports.oneOf(['default', 'horizontal', 'vertical', 'both'])
};
var defaultProps$5 = {
    size: 'default',
    flip: 'default',
    icon: '',
    viewBox: '0 0 24 24'
};
SvgIcon.displayName = 'KendoSvgIcon';

/**
 * Represents a React Context which provides you with the option to configure the KendoReact components icons.
 */
var IconsContext = React.createContext({ type: 'font' });
IconsContext.displayName = 'KendoReactIconsContext';

var __assign$V = (undefined && undefined.__assign) || function () {
    __assign$V = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$V.apply(this, arguments);
};
var __rest$g = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @hidden
 */
var IconWrap = React.forwardRef(function (props, ref) {
    var _a;
    var _b = React.useContext(IconsContext), type = _b.type, icons = _b.icons;
    var icon = props.icon, fontIconProps = __rest$g(props, ["icon"]);
    var name = ((_a = props.icon) === null || _a === void 0 ? void 0 : _a.name) || props.name;
    var svg = (name && icons && icons[name] && typeof icons[name] !== 'string') ? icons[name] : icon;
    name = (name && icons && icons[name] && typeof icons[name] === 'string') ? icons[name] : name;
    return (type === 'svg' && svg) ?
        React.createElement(SvgIcon, __assign$V({}, props, { icon: svg, ref: ref })) :
        React.createElement(Icon$1, __assign$V({}, fontIconProps, { name: name, ref: ref }));
});
IconWrap.displayName = 'KendoIconWrap';

/**
 * @hidden
 */
var toIconName = function (iconClass) { return iconClass.replace(/^k-i-/, ''); };
/**
 * @hidden
 */
var toIconClass = function (name) { return 'k-i-' + name; };
/**
 * @hidden
 */
propTypes.exports.shape({
    name: propTypes.exports.string.isRequired,
    content: propTypes.exports.string.isRequired,
    viewBox: propTypes.exports.string.isRequired
});

var getRatio = function (element, target) {
    var elementRect = element.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var top = Math.max(targetRect.top, elementRect.top);
    var left = Math.max(targetRect.left, elementRect.left);
    var right = Math.min(targetRect.left + targetRect.width, elementRect.left + elementRect.width);
    var bottom = Math.min(targetRect.top + targetRect.height, elementRect.top + elementRect.height);
    var width = right - left;
    var height = bottom - top;
    if (left < right && top < bottom) {
        var targetArea = targetRect.width * targetRect.height;
        var entryArea = elementRect.width * elementRect.height;
        var intersectionArea = width * height;
        var intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    }
    return 0;
};
/** @hidden */
var intersect = function (element, candidates) {
    var max = 0;
    var result = null;
    candidates.forEach(function (candidate) {
        if (candidate && element) {
            var ration = getRatio(element, candidate);
            if (ration > max) {
                max = ration;
                result = candidate;
            }
        }
    });
    return result;
};

var detectBrowser = function () {
    var ua = window && window.navigator.userAgent;
    if (!ua) {
        return false;
    }
    var browser = false;
    var match = [];
    var browserRxs = {
        edge: /(edge)[ \/]([\w.]+)/i,
        webkit: /(chrome|crios)[ \/]([\w.]+)/i,
        safari: /(webkit)[ \/]([\w.]+)/i,
        opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
        msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
        mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
    };
    for (var agent in browserRxs) {
        if (browserRxs.hasOwnProperty(agent)) {
            match = ua.match(browserRxs[agent]);
            if (match) {
                browser = {};
                browser[agent] = true;
                browser[match[1].toLowerCase().split(" ")[0].split("/")[0]] = true;
                browser.version = parseInt(document.DOCUMENT_NODE || match[2], 10);
                break;
            }
        }
    }
    return browser;
};
/** @hidden */
var getDocument$2 = function (element) {
    return element ? element.ownerDocument || window.document : window.document;
};
/** @hidden */
var getWindow$2 = function (element) {
    var document = getDocument$2(element);
    return document
        ? document.defaultView || window
        : window;
};
/** @hidden */
var scrollableRoot = function (element) {
    var support = { browser: detectBrowser() };
    var document = getDocument$2(element);
    return (support.browser.edge || support.browser.safari) ? document.body : document.documentElement;
};
/** @hidden */
var isScrollable = function (el) {
    if (el && el.className && typeof (el.className) === 'string' && el.className.indexOf('k-auto-scrollable') > -1) {
        return true;
    }
    var overflow = window.getComputedStyle(el, 'overflow').overflow;
    return overflow.indexOf('auto') > -1 || overflow.indexOf('scroll') > -1;
};
/** @hidden */
var getScrollableParent = function (el) {
    var root = scrollableRoot(el);
    if (!el || el === document.body || el === document.documentElement) {
        return root;
    }
    var parent = el;
    while (parent
        && parent !== document.body
        && parent.nodeType !== Node.DOCUMENT_FRAGMENT_NODE
        && parent.nodeType !== Node.DOCUMENT_NODE
        && !isScrollable(parent)) {
        parent = parent.parentNode;
    }
    if (parent && (parent === document.body || parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE)) {
        return root;
    }
    return parent;
};
/** @hidden */
var autoScrollVelocity = function (mouseX, mouseY, rect) {
    var velocity = { x: 0, y: 0 };
    var AUTO_SCROLL_AREA = 50;
    if (mouseX - rect.left < AUTO_SCROLL_AREA) {
        velocity.x = -(AUTO_SCROLL_AREA - (mouseX - rect.left));
    }
    else if (rect.right - mouseX < AUTO_SCROLL_AREA) {
        velocity.x = AUTO_SCROLL_AREA - (rect.right - mouseX);
    }
    if (mouseY - rect.top < AUTO_SCROLL_AREA) {
        velocity.y = -(AUTO_SCROLL_AREA - (mouseY - rect.top));
    }
    else if (rect.bottom - mouseY < AUTO_SCROLL_AREA) {
        velocity.y = AUTO_SCROLL_AREA - (rect.bottom - mouseY);
    }
    return velocity;
};
/** @hidden */
var scrollableViewPort = function (el, window) {
    var root = scrollableRoot(el);
    if (el === root) {
        return {
            top: root.scrollTop,
            left: root.scrollLeft,
            bottom: root.scrollTop + window.innerHeight,
            right: root.scrollLeft + window.innerWidth
        };
    }
    else {
        var rect = el.getBoundingClientRect();
        return {
            bottom: rect.top + rect.height,
            right: rect.left + rect.width,
            left: rect.left,
            top: rect.top
        };
    }
};
/** @hidden */
var isPointerInsideContainer = function (x, y, container) {
    var rect = container.getBoundingClientRect();
    return (rect.top <= y &&
        rect.left <= x &&
        y <= rect.bottom &&
        x <= rect.right);
};

/** @hidden */
var DRAG_AND_DROP_DISPATCH_ACTION;
(function (DRAG_AND_DROP_DISPATCH_ACTION) {
    DRAG_AND_DROP_DISPATCH_ACTION["POINTER_DOWN"] = "pointerdown";
    DRAG_AND_DROP_DISPATCH_ACTION["POINTER_MOVE"] = "pointermove";
    DRAG_AND_DROP_DISPATCH_ACTION["POINTER_UP"] = "pointerup";
    DRAG_AND_DROP_DISPATCH_ACTION["POINTER_CANCEL"] = "pointercancel";
    DRAG_AND_DROP_DISPATCH_ACTION["MOUSE_DOWN"] = "mousedown";
    DRAG_AND_DROP_DISPATCH_ACTION["MOUSE_MOVE"] = "mousemove";
    DRAG_AND_DROP_DISPATCH_ACTION["MOUSE_UP"] = "mouseup";
    DRAG_AND_DROP_DISPATCH_ACTION["CONTEXT_MENU"] = "contextmenu";
    DRAG_AND_DROP_DISPATCH_ACTION["TOUCH_START"] = "touchstart";
    DRAG_AND_DROP_DISPATCH_ACTION["TOUCH_MOVE"] = "touchmove";
    DRAG_AND_DROP_DISPATCH_ACTION["TOUCH_END"] = "touchend";
    DRAG_AND_DROP_DISPATCH_ACTION["TOUCH_CANCEL"] = "touchcancel";
    DRAG_AND_DROP_DISPATCH_ACTION["SCROLL"] = "scroll";
    DRAG_AND_DROP_DISPATCH_ACTION["START"] = "KENDO_DRAG_AND_DROP_START";
    DRAG_AND_DROP_DISPATCH_ACTION["MOVE"] = "KENDO_DRAG_AND_DROP_MOVE";
    DRAG_AND_DROP_DISPATCH_ACTION["END"] = "KENDO_DRAG_AND_DROP_END";
    DRAG_AND_DROP_DISPATCH_ACTION["CANCEL"] = "KENDO_DRAG_AND_DROP_CANCEL";
})(DRAG_AND_DROP_DISPATCH_ACTION || (DRAG_AND_DROP_DISPATCH_ACTION = {}));
var isTouchEvent = function (event) { return /^touch/.test(event.type); };
var isScrollEvent = function (event) { return /^(scroll)/.test(event.type); };
/** @hidden */
var normalizeEvent = function (event, state) { return (isTouchEvent(event)
    ? ({
        pageX: event.changedTouches[0].pageX,
        pageY: event.changedTouches[0].pageY,
        clientX: event.changedTouches[0].clientX,
        clientY: event.changedTouches[0].clientY,
        scrollX: state.scrollOffset.x,
        scrollY: state.scrollOffset.y,
        offsetX: state.offset.x,
        offsetY: state.offset.y,
        type: event.type,
        originalEvent: event,
        isTouch: true,
        altKey: false,
        ctrlKey: false,
        shiftKey: false,
        metaKey: false
    })
    : isScrollEvent(event)
        ? ({
            pageX: state.pageOffset.x,
            pageY: state.pageOffset.y,
            clientX: state.clientOffset.x,
            clientY: state.clientOffset.y,
            scrollX: state.scrollOffset.x,
            scrollY: state.scrollOffset.y,
            offsetX: state.offset.x,
            offsetY: state.offset.y,
            type: event.type,
            originalEvent: event,
            altKey: false,
            ctrlKey: false,
            shiftKey: false,
            metaKey: false
        })
        : ({
            pageX: event.pageX,
            pageY: event.pageY,
            clientX: event.clientX,
            clientY: event.clientY,
            offsetX: event.offsetX,
            offsetY: event.offsetY,
            scrollX: state.scrollOffset.x,
            scrollY: state.scrollOffset.y,
            type: event.type,
            ctrlKey: event.ctrlKey,
            shiftKey: event.shiftKey,
            altKey: event.altKey,
            metaKey: event.metaKey,
            originalEvent: event
        })); };
var noop$3 = function () { };
/** @hidden */
var dispatchDragAndDrop = function (state, action, callbacks) {
    if (callbacks === void 0) { callbacks = {}; }
    var _a = callbacks.onIsPressedChange, onIsPressedChange = _a === void 0 ? noop$3 : _a, _b = callbacks.onIsScrollingChange, onIsScrollingChange = _b === void 0 ? noop$3 : _b, _c = callbacks.onVelocityChange, onVelocityChange = _c === void 0 ? noop$3 : _c, _d = callbacks.onOffsetChange, onOffsetChange = _d === void 0 ? noop$3 : _d, _e = callbacks.onPageOffsetChange, onPageOffsetChange = _e === void 0 ? noop$3 : _e, _f = callbacks.onClientOffsetChange, onClientOffsetChange = _f === void 0 ? noop$3 : _f, _g = callbacks.onScrollOffsetChange, onScrollOffsetChange = _g === void 0 ? noop$3 : _g, _h = callbacks.onInitialScrollOffsetChange, onInitialScrollOffsetChange = _h === void 0 ? noop$3 : _h;
    var drag = action.payload;
    var element = drag.element;
    var hint = drag.hint;
    var autoScrollDirection = state.autoScrollDirection;
    var overrideScrollableParent = state.scrollableParent;
    var event = normalizeEvent(action.event, state);
    switch (event.type) {
        case DRAG_AND_DROP_DISPATCH_ACTION.POINTER_DOWN:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.POINTER_DOWN
                && (!event.originalEvent.isPrimary
                    || event.originalEvent.button !== 0)) {
                break;
            }
        // In rare cases where the `which` attribute is available in the mouse event
        // we check if the `left button` is explicitly clicked:
        // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/which#return_value
        case DRAG_AND_DROP_DISPATCH_ACTION.MOUSE_DOWN:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.MOUSE_DOWN
                && (event.originalEvent.which
                    && event.originalEvent.which > 1)
                || state.ignoreMouse) {
                break;
            }
        case DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_START:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_START
                && event.originalEvent.touches.length !== 1) {
                break;
            }
        case DRAG_AND_DROP_DISPATCH_ACTION.START: {
            var scrollableParent_1 = overrideScrollableParent || getScrollableParent(action.payload.element);
            onInitialScrollOffsetChange(scrollableParent_1 instanceof Window
                ? { x: scrollableParent_1.scrollX, y: scrollableParent_1.scrollY }
                : { x: scrollableParent_1.scrollLeft, y: scrollableParent_1.scrollTop });
            onClientOffsetChange({
                x: event.clientX,
                y: event.clientY
            });
            onPageOffsetChange({
                x: event.pageX,
                y: event.pageY
            });
            onOffsetChange({
                x: event.offsetX,
                y: event.offsetY
            });
            onIsPressedChange(true);
            if (drag.onPress) {
                drag.onPress(event);
            }
            break;
        }
        case DRAG_AND_DROP_DISPATCH_ACTION.SCROLL:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.SCROLL && !state.pressed) {
                break;
            }
            var scrollableParent = overrideScrollableParent || getScrollableParent(element);
            var scrollOffset = scrollableParent instanceof Window
                ? { x: scrollableParent.scrollX, y: scrollableParent.scrollY }
                : { x: scrollableParent.scrollLeft, y: scrollableParent.scrollTop };
            event.scrollX = scrollOffset.x - state.initialScrollOffset.x;
            event.scrollY = scrollOffset.y - state.initialScrollOffset.y;
            onScrollOffsetChange({
                x: event.scrollX,
                y: event.scrollY
            });
        case DRAG_AND_DROP_DISPATCH_ACTION.POINTER_MOVE:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.POINTER_MOVE && !event.originalEvent.isPrimary) {
                break;
            }
        case DRAG_AND_DROP_DISPATCH_ACTION.MOUSE_MOVE:
        case DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_MOVE:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_MOVE && event.originalEvent.touches.length !== 1) {
                break;
            }
        case DRAG_AND_DROP_DISPATCH_ACTION.MOVE: {
            if (state.pressed) {
                if (state.autoScroll && event.originalEvent.type !== 'scroll') {
                    if (element) {
                        var document_1 = getDocument$2(element);
                        var scrollableParent_2 = overrideScrollableParent || getScrollableParent(document_1.elementFromPoint(event.clientX, event.clientY));
                        var newVelocity = autoScrollVelocity(event.clientX, event.clientY, scrollableViewPort(scrollableParent_2, getWindow$2(element)));
                        onVelocityChange({
                            x: (autoScrollDirection && autoScrollDirection.horizontal === false) ? 0 : newVelocity.x,
                            y: (autoScrollDirection && autoScrollDirection.vertical === false) ? 0 : newVelocity.y
                        });
                        onIsScrollingChange(newVelocity.y !== 0 || newVelocity.x !== 0);
                    }
                }
                if (!state.drag && drag.onDragStart) {
                    drag.onDragStart(event);
                }
                if (drag.onDrag) {
                    drag.onDrag(event);
                }
                var dropElement_1 = intersect(hint || element, state.drops.map(function (drop) { return drop && drop.element; }).filter(function (d) { return d !== (hint || element); }));
                var drop = state.drops.find(function (drop) { return drop.element === dropElement_1; });
                if (drop
                    && dropElement_1
                    && isPointerInsideContainer(event.clientX, event.clientY, overrideScrollableParent || getScrollableParent(dropElement_1))
                    && dropElement_1 !== element) {
                    if ((state.drop && state.drop.element) !== dropElement_1) {
                        if (state.drop && state.drop.onDragLeave) {
                            state.drop.onDragLeave(event);
                        }
                        if (drop.onDragEnter) {
                            drop.onDragEnter(event);
                        }
                    }
                    else {
                        if (drop.onDragOver) {
                            drop.onDragOver(event);
                        }
                    }
                }
                else if (state.drop && state.drop.onDragLeave) {
                    state.drop.onDragLeave(event);
                }
            }
            onClientOffsetChange({
                x: event.clientX,
                y: event.clientY
            });
            onPageOffsetChange({
                x: event.pageX,
                y: event.pageY
            });
            break;
        }
        case DRAG_AND_DROP_DISPATCH_ACTION.POINTER_UP:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.POINTER_UP && !event.originalEvent.isPrimary) {
                break;
            }
        case DRAG_AND_DROP_DISPATCH_ACTION.MOUSE_UP:
        // the last finger has been lifted, and the user is not doing gesture.
        // there might be a better way to handle this.
        case DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_END:
            if (event.type === DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_END && event.originalEvent.touches.length !== 1) {
                break;
            }
        case DRAG_AND_DROP_DISPATCH_ACTION.END: {
            onIsPressedChange(false);
            onIsScrollingChange(false);
            onScrollOffsetChange({ x: 0, y: 0 });
            if (drag.onRelease) {
                drag.onRelease(event);
            }
            if (state.drop && state.drop.onDrop) {
                state.drop.onDrop(event);
            }
            if (state.drag && drag.onDragEnd) {
                drag.onDragEnd(event);
            }
            break;
        }
        case DRAG_AND_DROP_DISPATCH_ACTION.POINTER_CANCEL:
        case DRAG_AND_DROP_DISPATCH_ACTION.CONTEXT_MENU:
        case DRAG_AND_DROP_DISPATCH_ACTION.TOUCH_CANCEL:
        case DRAG_AND_DROP_DISPATCH_ACTION.CANCEL: {
            onIsPressedChange(false);
            onIsScrollingChange(false);
            onScrollOffsetChange({ x: 0, y: 0 });
            if (drag.onDragEnd) {
                drag.onDragEnd(event);
            }
            if (state.drop && state.drop.onDragLeave) {
                state.drop.onDragLeave(event);
            }
            break;
        }
    }
};

/** @hidden */
var autoScroll = function (scrollableParent, vel) {
    if (!scrollableParent) {
        return;
    }
    var yIsScrollable;
    var xIsScrollable;
    var isRootNode = scrollableParent === scrollableRoot(scrollableParent);
    if (isRootNode) {
        yIsScrollable = document.body.scrollHeight > window.innerHeight;
        xIsScrollable = document.body.scrollWidth > window.innerWidth;
    }
    else {
        yIsScrollable = scrollableParent.offsetHeight <= scrollableParent.scrollHeight;
        xIsScrollable = scrollableParent.offsetWidth <= scrollableParent.scrollWidth;
    }
    var yDelta = scrollableParent.scrollTop + vel.y;
    var yInBounds = yIsScrollable && yDelta > 0 && yDelta < scrollableParent.scrollHeight;
    var xDelta = scrollableParent.scrollLeft + vel.x;
    var xInBounds = xIsScrollable && xDelta > 0 && xDelta < scrollableParent.scrollWidth;
    if (yInBounds) {
        scrollableParent.scrollTop += vel.y;
    }
    else if (yIsScrollable && yDelta < 0) {
        scrollableParent.scrollTop = 0;
    }
    if (xInBounds) {
        scrollableParent.scrollLeft += vel.x;
    }
    else if (xIsScrollable && xDelta < 0) {
        scrollableParent.scrollLeft = 0;
    }
};

/**
 * @hidden
 */
var useInheritedState$1 = function (context, defaultValue) {
    var _a = React.useContext(context), contextValue = _a[0], contextSetter = _a[1];
    var _b = React.useState(defaultValue), localValue = _b[0], localSetter = _b[1];
    var value = contextValue !== undefined ? contextValue : localValue;
    var handleValueChange = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        contextValue !== undefined
            ? contextSetter.apply(void 0, args) : localSetter(args[0]);
    };
    return [
        value,
        handleValueChange
    ];
};

/**
 * @hidden
 */
var DragContext$1 = React.createContext([
    undefined,
    noop$4
]);
/**
 * @hidden
 */
var DropContext$1 = React.createContext([
    undefined,
    noop$4
]);
/**
 * @hidden
 */
var DragsContext$1 = React.createContext([[], noop$4, noop$4]);
/**
 * @hidden
 */
var DropsContext$1 = React.createContext([[], noop$4, noop$4]);

var IGNORE_MOUSE_TIMEOUT$1 = 2000;
/**
 * Represents the KendoReact `useDraggable` hook.
 * Use it to attach `drag` events to a native HTML DOM elements, or custom React Components.
 *
 * For more information, refer to the [KendoReact Draggable]({% slug draggable_drag-and-drop %}) article.
 *
 * @param ref - The `ref` of the HTML Element or React Component which will enable the `draggable` functionality.
 * @param callbacks - A collection of callbacks, called by the `useDraggable` hook when a specific action occurs.
 * @param options - Additional configuration of the `useDraggable` hook.
 */
function useDraggable$1(ref, callbacks, options) {
    if (options === void 0) { options = {}; }
    var _a = callbacks.onPress, onPress = _a === void 0 ? noop$4 : _a, _b = callbacks.onRelease, onRelease = _b === void 0 ? noop$4 : _b, _c = callbacks.onDragStart, onDragStart = _c === void 0 ? noop$4 : _c, _d = callbacks.onDrag, onDrag = _d === void 0 ? noop$4 : _d, _e = callbacks.onDragEnd, onDragEnd = _e === void 0 ? noop$4 : _e;
    var _f = options.hint, hint = _f === void 0 ? null : _f, _g = options.mouseOnly, mouseOnly = _g === void 0 ? false : _g, _h = options.autoScroll, autoScroll$1 = _h === void 0 ? true : _h, _j = options.scrollContainer, scrollContainer = _j === void 0 ? null : _j;
    var _k = React.useState(false), pressed = _k[0], setPressed = _k[1];
    var _l = React.useState(false), scrolling = _l[0], setScrolling = _l[1];
    var drop = useInheritedState$1(DropContext$1)[0];
    var _m = useInheritedState$1(DragContext$1), drag = _m[0], setDrag = _m[1];
    var drops = React.useContext(DropsContext$1)[0];
    var _o = React.useContext(DragsContext$1), drags = _o[0], registerDrag = _o[1], deregisterDrag = _o[2];
    var velocity = React.useRef({ x: 0, y: 0 });
    var scrollInterval = React.useRef();
    var ignoreMouse = React.useRef(false);
    var restoreMouseTimeout = React.useRef();
    var scrollable = React.useRef(null);
    var unmount = React.useRef(false);
    var offset = React.useRef({ x: 0, y: 0 });
    var pageOffset = React.useRef({ x: 0, y: 0 });
    var clientOffset = React.useRef({ x: 0, y: 0 });
    var initialClientOffset = React.useRef({ x: 0, y: 0 });
    var scrollOffset = React.useRef({ x: 0, y: 0 });
    var initialScrollOffset = React.useRef({ x: 0, y: 0 });
    var supportPointerEvent = Boolean((typeof window !== 'undefined') && window.PointerEvent);
    var pointers = !mouseOnly && supportPointerEvent;
    var getElement = React.useCallback(function () { return ref.current && ref.current.element
        ? ref.current.element
        : ref.current; }, [ref]);
    var getHintElement = React.useCallback(function () { return hint && hint.current && hint.current.element
        ? hint.current.element
        : hint
            ? hint.current
            : null; }, [hint]);
    var getScrollContainer = React.useCallback(function () { return scrollContainer && scrollContainer.current && scrollContainer.current.element
        ? scrollContainer.current.element
        : scrollContainer
            ? scrollContainer.current
            : null; }, [scrollContainer]);
    var getAutoScrollContainer = React.useCallback(function () { return typeof autoScroll$1 === 'object' && autoScroll$1.boundaryElementRef
        && autoScroll$1.boundaryElementRef.current && autoScroll$1.boundaryElementRef.current.element
        ? autoScroll$1.boundaryElementRef.current.element
        : typeof autoScroll$1 === 'object' && autoScroll$1.boundaryElementRef && autoScroll$1.boundaryElementRef.current
            ? autoScroll$1.boundaryElementRef.current
            : null; }, [autoScroll$1]);
    var target = React.useRef(null);
    React.useImperativeHandle(target, function () { return ({
        element: getElement(),
        hint: getHintElement(),
        onPress: handlePress,
        onDragStart: handleDragStart,
        onDrag: handleDrag,
        onDragEnd: handleDragEnd,
        onRelease: handleRelease,
        data: ref.current
    }); });
    var getDocument = React.useCallback(function () {
        var element = getElement();
        return element ? element.ownerDocument || document : document;
    }, [getElement]);
    var getWindow = React.useCallback(function () {
        var document = getDocument();
        return document
            ? document.defaultView || window
            : window;
    }, [getDocument]);
    var getState = React.useCallback(function () { return ({
        drag: drag ? drag.current : null,
        drop: drop ? drop.current : null,
        drags: drags.map(function (d) { return d.current; }),
        drops: drops.map(function (d) { return d.current; }),
        pressed: pressed,
        ignoreMouse: ignoreMouse.current,
        scrollOffset: scrollOffset.current,
        offset: offset.current,
        pageOffset: pageOffset.current,
        initialScrollOffset: initialScrollOffset.current,
        clientOffset: clientOffset.current,
        initialClientOffset: initialClientOffset.current,
        velocity: velocity.current,
        autoScroll: Boolean(typeof autoScroll$1 === 'object' ? autoScroll$1.enabled !== false : autoScroll$1),
        scrollableParent: getAutoScrollContainer(),
        autoScrollDirection: typeof autoScroll$1 === 'object' ? autoScroll$1.direction : { horizontal: true, vertical: true },
        isScrolling: scrolling
    }); }, [drag, drop, drags, drops, pressed, autoScroll$1, getAutoScrollContainer, scrolling]);
    var handlePressedChange = React.useCallback(function (value) {
        setPressed(value);
    }, []);
    var handleScrollingChange = React.useCallback(function (value) {
        setScrolling(value);
    }, []);
    var handleVelocityChange = React.useCallback(function (value) {
        velocity.current = value;
    }, []);
    var handleOffsetChange = React.useCallback(function (value) {
        offset.current = value;
    }, []);
    var handleClientOffsetChange = React.useCallback(function (value) {
        clientOffset.current = value;
    }, []);
    var handlePageOffsetChange = React.useCallback(function (value) {
        pageOffset.current = value;
    }, []);
    var handleInitialClientOffsetChange = React.useCallback(function (value) {
        initialClientOffset.current = value;
    }, []);
    var handleScrollOffsetChange = React.useCallback(function (value) {
        scrollOffset.current = value;
    }, []);
    var handleInitialScrollOffsetChange = React.useCallback(function (value) {
        initialScrollOffset.current = value;
    }, []);
    // Drag Events
    var handlePress = React.useCallback(function (event) {
        onPress(event);
    }, [onPress]);
    var handleRelease = React.useCallback(function (event) {
        onRelease(event);
    }, [onRelease]);
    var handleDragStart = React.useCallback(function (event) {
        setDrag(target, { target: ref.current, event: event });
        onDragStart(event);
    }, [setDrag, ref, onDragStart]);
    var handleDrag = React.useCallback(function (event) {
        onDrag(event);
    }, [onDrag]);
    var handleDragEnd = React.useCallback(function (event) {
        if (unmount.current) {
            return;
        }
        setDrag(null, { target: ref.current, event: event });
        onDragEnd(event);
    }, [onDragEnd, setDrag, ref]);
    var dispatchDragEvent = React.useCallback(function (event) {
        dispatchDragAndDrop(getState(), { event: event, payload: target.current }, {
            onVelocityChange: handleVelocityChange,
            onOffsetChange: handleOffsetChange,
            onClientOffsetChange: handleClientOffsetChange,
            onPageOffsetChange: handlePageOffsetChange,
            onInitialClientOffsetChange: handleInitialClientOffsetChange,
            onScrollOffsetChange: handleScrollOffsetChange,
            onInitialScrollOffsetChange: handleInitialScrollOffsetChange,
            onIsPressedChange: handlePressedChange,
            onIsScrollingChange: handleScrollingChange
        });
    }, [
        getState,
        handleVelocityChange,
        handleOffsetChange,
        handlePageOffsetChange,
        handleClientOffsetChange,
        handleInitialClientOffsetChange,
        handleInitialScrollOffsetChange,
        handlePressedChange,
        handleScrollOffsetChange,
        handleScrollingChange
    ]);
    // Pointer Events
    var handlePointerDown = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handlePointerMove = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handlePointerCancel = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handlePointerUp = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    // Mouse Events
    var handleMouseDown = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleMouseMove = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleMouseUp = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleContextMenu = React.useCallback(function (event) {
        event.preventDefault();
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    // Touch Events
    var handleTouchStart = React.useCallback(function (event) {
        event.preventDefault();
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleTouchMove = React.useCallback(function (event) {
        event.preventDefault();
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleTouchEnd = React.useCallback(function (event) {
        if (event.touches.length === 0 && event.changedTouches.length === 1) {
            var currentWindow = getWindow();
            ignoreMouse.current = true;
            restoreMouseTimeout.current = currentWindow.setTimeout(function () { ignoreMouse.current = false; }, IGNORE_MOUSE_TIMEOUT$1);
        }
        dispatchDragEvent(event);
    }, [dispatchDragEvent, getWindow]);
    var handleScroll = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    // Misc
    var prerequisites = React.useCallback(function () {
        var element = getElement();
        if (element) {
            var initialTouchAction_1 = element.style.touchAction;
            element.style.touchAction = 'none';
            return function () {
                element.style.touchAction = initialTouchAction_1;
            };
        }
    }, [getElement]);
    var register = React.useCallback(function () {
        registerDrag(target);
        return function () {
            deregisterDrag(target);
        };
    }, [deregisterDrag, registerDrag]);
    var init = function () {
        var window = getWindow();
        var element = getElement();
        var document = getDocument();
        if (pointers) {
            if (element) {
                scrollable.current = getScrollableParent(element);
                if (scrollable.current) {
                    scrollable.current.addEventListener('scroll', handleScroll, { passive: true });
                }
                element.addEventListener('pointerdown', handlePointerDown, { passive: true });
            }
            if (pressed) {
                document.addEventListener('pointermove', handlePointerMove);
                document.addEventListener('pointerup', handlePointerUp, true);
                document.addEventListener('contextmenu', handleContextMenu);
                document.addEventListener('pointercancel', handlePointerCancel, { passive: true });
            }
        }
        else {
            // Hacky-hacky iOS Safari
            window.addEventListener('touchmove', noop$4, { capture: false, passive: false });
            if (element) {
                element.addEventListener('mousedown', handleMouseDown, { passive: true });
                if (!mouseOnly) {
                    element.addEventListener('touchstart', handleTouchStart, { passive: true });
                    if (pressed) {
                        element.addEventListener('touchmove', handleTouchMove, { passive: true });
                        element.addEventListener('touchend', handleTouchEnd, { passive: true });
                    }
                }
            }
            if (pressed) {
                document.addEventListener('mousemove', handleMouseMove, { passive: true });
                document.addEventListener('mouseup', handleMouseUp, { passive: true });
            }
        }
        return function () {
            if (scrollable.current) {
                scrollable.current.removeEventListener('scroll', handleScroll);
            }
            if (element) {
                element.removeEventListener('pointerdown', handlePointerDown);
                element.removeEventListener('mousedown', handleMouseDown);
                element.removeEventListener('touchstart', handleTouchStart);
                element.removeEventListener('touchmove', handleTouchMove);
                element.removeEventListener('touchend', handleTouchEnd);
            }
            document.removeEventListener('pointermove', handlePointerMove);
            document.removeEventListener('pointerup', handlePointerUp, true);
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('pointercancel', handlePointerCancel);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', noop$4);
            window.clearTimeout(restoreMouseTimeout.current);
        };
    };
    React.useEffect(function () {
        var window = getWindow();
        if (scrolling) {
            var scrollableParent_1 = getScrollContainer()
                || getScrollableParent(document.elementFromPoint(clientOffset.current.x, clientOffset.current.y));
            window.clearInterval(scrollInterval.current);
            scrollInterval.current = window.setInterval(function () {
                autoScroll(scrollableParent_1, { x: velocity.current.x, y: velocity.current.y });
            }, 50);
        }
        return function () {
            window.clearInterval(scrollInterval.current);
        };
    }, [getElement, getScrollContainer, getWindow, scrolling]);
    React.useEffect(prerequisites, [prerequisites]);
    React.useEffect(init, [
        pressed,
        getWindow,
        getElement,
        getDocument,
        mouseOnly,
        pointers,
        handleContextMenu,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp,
        handlePointerCancel,
        handlePointerDown,
        handlePointerMove,
        handlePointerUp,
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart,
        handleScroll
    ]);
    React.useEffect(function () {
        return function () {
            unmount.current = true;
        };
    }, []);
    React.useLayoutEffect(register, [register]);
}

/**
 * Represents the KendoReact Draggable component.
 *
 * Accepts properties of type [DraggableProps]({% slug api_common_draggableprops %}),
 * and returns an object of type [DraggableHandle]({% slug api_common_draggablehandle %}) when the `ref` is obtained.
 */
var Draggable$1 = React.forwardRef(function (props, ref) {
    var childRef = React.useRef(null);
    var target = React.useRef(null);
    var getElement = React.useCallback(function () { return childRef.current && childRef.current.element
        ? childRef.current.element
        : childRef.current; }, [childRef]);
    React.useImperativeHandle(target, function () { return ({ element: getElement() || null }); });
    React.useImperativeHandle(ref, function () { return target.current; });
    React.useImperativeHandle(props.childRef, function () { return childRef.current; });
    var handlePress = React.useCallback(function (event) {
        if (!props.onPress) {
            return;
        }
        props.onPress({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onPress]);
    var handleRelease = React.useCallback(function (event) {
        if (!props.onRelease) {
            return;
        }
        props.onRelease({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onRelease]);
    var handleDragStart = React.useCallback(function (event) {
        if (!props.onDragStart) {
            return;
        }
        props.onDragStart({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [props, getElement]);
    var handleDrag = React.useCallback(function (event) {
        if (!props.onDrag) {
            return;
        }
        props.onDrag({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onDrag]);
    var handleDragEnd = React.useCallback(function (event) {
        if (!props.onDragEnd) {
            return;
        }
        props.onDragEnd({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onDragEnd]);
    useDraggable$1(childRef, {
        onPress: handlePress,
        onRelease: handleRelease,
        onDragStart: handleDragStart,
        onDrag: handleDrag,
        onDragEnd: handleDragEnd
    }, {
        mouseOnly: props.mouseOnly,
        autoScroll: props.autoScroll,
        hint: props.hint,
        scrollContainer: props.scrollContainer
    });
    return props.children
        ? (React.cloneElement(React.Children.only(props.children), { ref: childRef }))
        : null;
});
Draggable$1.displayName = 'KendoReactDraggable';

/** @hidden */
var kendoThemeMaps$2 = {
    sizeMap: {
        small: 'sm',
        medium: 'md',
        large: 'lg'
    },
    roundedMap: {
        small: 'sm',
        medium: 'md',
        large: 'lg'
    }
};

function isEqual$1(first, second) {
    return (first === second) || (Number.isNaN(first) && Number.isNaN(second));
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual$1(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}
/**
 * @hidden
 */
function memoizeOne(resultFn, isEqualFn) {
    if (isEqualFn === void 0) { isEqualFn = areInputsEqual; }
    var cache = null;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (cache && cache.lastThis === this && isEqualFn(newArgs, cache.lastArgs)) {
            return cache.lastResult;
        }
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

/** @hidden */
var ZIndexContext$1 = React.createContext(0);
ZIndexContext$1.displayName = 'KendoReactZIndexContext';

/**
 * @hidden
 */
var getDocument$1 = function () { return typeof document !== 'undefined' ? document : {}; };
/**
 * @hidden
 */
var BrowserSupportService = /** @class */ (function () {
    function BrowserSupportService() {
        this.scrollbar = 0;
    }
    Object.defineProperty(BrowserSupportService.prototype, "scrollbarWidth", {
        get: function () {
            var document = getDocument$1();
            if (!this.scrollbar && document && document.createElement) {
                var div = document.createElement('div');
                div.style.cssText = 'overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block';
                div.innerHTML = '&nbsp;';
                document.body.appendChild(div);
                this.scrollbar = div.offsetWidth - div.scrollWidth;
                document.body.removeChild(div);
            }
            return this.scrollbar;
        },
        enumerable: false,
        configurable: true
    });
    return BrowserSupportService;
}());

/**
 * @hidden
 */
var canUseDOM$2 = Boolean(
// from fbjs
typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);

/**
 * @hidden
 */
var classNames$2 = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    var addLeafKeys = function (arg) { return typeof arg === 'object' ? Object
        .keys(arg)
        .forEach(function (key) {
        result[key] = arg[key];
    }) : result[arg] = true; };
    var addKeys = function (list) { return list
        .filter(function (arg) { return arg !== true && !!arg; })
        .map(function (arg) {
        return Array.isArray(arg) ?
            addKeys(arg) :
            addLeafKeys(arg);
    }); };
    addKeys(args);
    return Object
        .keys(result)
        .map(function (key) { return (result[key] && key) || null; })
        .filter(function (el) { return el !== null; })
        .join(' ');
};

/* eslint-disable radix */
/**
 * @hidden
 */
var DISABLED_TABINDEX = -1;
/**
 * @hidden
 */
var DEFAULT_TABINDEX = 0;
/**
 * @hidden
 */
var getTabIndex = function (tabIndex, disabled, useDefaultTabIndexWhenDisabled) {
    var parsedTabIndex = typeof tabIndex === 'string' ? parseInt(tabIndex, undefined) : tabIndex;
    if (parsedTabIndex === NaN) {
        return undefined;
    }
    return parsedTabIndex !== undefined
        ? parsedTabIndex
        : disabled ?
            (useDefaultTabIndexWhenDisabled ? undefined : DISABLED_TABINDEX)
            : DEFAULT_TABINDEX;
};

/* eslint-disable no-bitwise */
/**
 * @hidden
 */
var guid$1 = function () {
    var id = '';
    var i;
    var random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            id += '-';
        }
        id += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return id;
};

/**
 * @hidden
 */
var Keys$1 = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    esc: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46
};

/**
 * @hidden
 */
var noop$2 = function () { };

/**
 * @hidden
 */
var setScrollbarWidth = function () {
    if (!canUseDOM$2 || !document.body) {
        return false;
    }
    var scrollbarWidth = new BrowserSupportService().scrollbarWidth;
    document.body.style.setProperty('--kendo-scrollbar-width', "".concat(scrollbarWidth, "px"));
};

var __assign$U = (undefined && undefined.__assign) || function () {
    __assign$U = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$U.apply(this, arguments);
};
var __spreadArray$a = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Gets and sets the children. Returns the children or the re-created item with the new children.
function children(item, subItemsField, subItems) {
    var _a;
    if (subItems) {
        return __assign$U(__assign$U({}, item), (_a = {}, _a[subItemsField] = subItems.length ? __spreadArray$a([], subItems, true) : undefined, _a));
    }
    else {
        return item && item[subItemsField] ? __spreadArray$a([], item[subItemsField], true) : [];
    }
}
function mapItem(dataItem, subItemsField, callbackfn) {
    if (dataItem[subItemsField]) {
        var subItems = children(dataItem, subItemsField).map(function (child) { return mapItem(child, subItemsField, callbackfn); });
        return callbackfn(children(dataItem, subItemsField, subItems));
    }
    return callbackfn(dataItem);
}
/**
 * Creates a new array with the results of calling the provided callback function
 * on every element in the provided data tree.
 *
 * @param {any[]} tree - The data tree.
 * @param {string} subItemsField - The field which points to the subitems collection of each data item.
 * @param {(value: any) => any} callback - The callback function.
 * @returns {any[]} - The new data tree.
 */
var mapTree = function (tree, subItemsField, callback) {
    return __spreadArray$a([], tree.map(function (item) { return mapItem(item, subItemsField, callback); }), true);
};
/**
 * Similar to the `Object.assign` function. Additionally, creates a new array for the subitems.
 *
 * @param {object} item - The source data item.
 * @param {string} subItemsField - The field which points to the subitems collection of each data item.
 * @param {object} propsToExtend - The props with which the source data item will be extended.
 * @returns {object} - The target data item.
 */
var extendDataItem = function (item, subItemsField, propsToExtend) {
    var _a;
    return Object.assign({}, item, item[subItemsField] ? (_a = {}, _a[subItemsField] = item[subItemsField].slice(), _a) : {}, propsToExtend || {});
};

/**
 * @hidden
 */
function validatePackage$2(packageMetadata) {
    if (typeof licensing !== 'undefined') {
        validatePackage$4(packageMetadata);
    }
    else {
        var message = "License activation failed for ".concat(packageMetadata.name, "\n");
        message += 'The @progress/kendo-licensing script is not loaded.\n';
        message += "See ".concat(packageMetadata.licensingDocsUrl, " for more information.\n");
        console.warn(message);
    }
}

/** @hidden */
var hasRelativeStackingContext$1 = function (elementSource) {
    if (!canUseDOM$2) {
        return false;
    }
    // Component need to pass element to make sure document owner is correct.
    // This however might be performance hit if checked for example on each drag event.
    var currentDocument = elementSource ? elementSource.ownerDocument : document;
    if (!currentDocument || !currentDocument.body) {
        return false;
    }
    var top = 10;
    var parent = currentDocument.createElement('div');
    parent.style.transform = 'matrix(10, 0, 0, 10, 0, 0)';
    var child = currentDocument.createElement('div');
    child.appendChild(currentDocument.createTextNode('child'));
    child.style.position = 'fixed';
    child.style.top = top + 'px';
    parent.appendChild(child);
    currentDocument.body.appendChild(parent);
    var isDifferent = child.getBoundingClientRect().top !== top;
    currentDocument.body.removeChild(parent);
    return isDifferent;
};

/**
 * @hidden
 * Dispatches a new event based on an event that was already internally dispatched to KendoReact users.
 *
 * @param eventHandler - The public event handler that is assigned by the user.
 * When undefined, the method is not an option.
 * @param dispatchedEvent - The event that was already dispatched internally.
 * @param target - The target component of the new event.
 * @param eventData - The additional data that will be passed through the new event.
 * When the new event has no additional data
 *  other than the `BaseEvent` arguments, pass `undefined`.
 */
function dispatchEvent$1(eventHandler, dispatchedEvent, target, eventData) {
    if (eventHandler) {
        var eventBaseData = {
            syntheticEvent: dispatchedEvent,
            nativeEvent: dispatchedEvent.nativeEvent,
            target: target
        };
        eventHandler.call(undefined, Object.assign(eventBaseData, eventData));
    }
}

var __spreadArray$9 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * An utility function for asynchronous focus/blur handling.
 *
 * By default, the `onFocus` and `onBlur` callbacks are called every time a child components receives/loses focus.
 * Use this utility hook for scenarios where you need to know if the parent has received focus for the first time, or completely lost focus.
 *
 * @returns
 */
function useAsyncFocusBlur(_a) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur, onSyncFocus = _a.onSyncFocus, onSyncBlur = _a.onSyncBlur;
    var focused = React.useRef(false);
    var tick = React.useRef(0);
    var nextTick = React.useCallback(function (f) {
        clearTimeout(tick.current);
        tick.current = window.setTimeout(function () { return f(); });
    }, [tick]);
    var handleFocus = React.useCallback(function () {
        var event = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            event[_i] = arguments[_i];
        }
        clearTimeout(tick.current);
        if (onSyncFocus) {
            onSyncFocus.call(undefined, event[0]);
        }
        if (focused.current) {
            return;
        }
        focused.current = true;
        if (onFocus) {
            onFocus.call.apply(onFocus, __spreadArray$9([undefined], event, false));
        }
    }, [focused, onFocus, onSyncFocus]);
    var handleBlur = React.useCallback(function () {
        var event = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            event[_i] = arguments[_i];
        }
        if (onSyncBlur) {
            onSyncBlur.call(undefined, event[0]);
        }
        nextTick(function () {
            if (!focused.current) {
                return;
            }
            if (onBlur) {
                focused.current = false;
                onBlur.call.apply(onBlur, __spreadArray$9([undefined], event, false));
            }
        });
    }, [focused, nextTick, onBlur, onSyncBlur]);
    React.useEffect(function () {
        return function () {
            clearTimeout(tick.current);
        };
    }, []);
    return {
        onFocus: handleFocus,
        onBlur: handleBlur
    };
}

var __assign$T = (undefined && undefined.__assign) || function () {
    __assign$T = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$T.apply(this, arguments);
};
/**
 * An utility High-order Component for asynchronous focus/blur handling.
 *
 * By default, the `onFocus` and `onBlur` callbacks are called every time a child components receives/loses focus.
 * Use this utility HOC for scenarios where you need to know if the parent has received focus for the first time, or completely lost focus.
 *
 * @returns
 */
var AsyncFocusBlur = function (_a) {
    var children = _a.children, onFocus = _a.onFocus, onBlur = _a.onBlur, onSyncFocus = _a.onSyncFocus, onSyncBlur = _a.onSyncBlur;
    var args = useAsyncFocusBlur({ onFocus: onFocus, onBlur: onBlur, onSyncFocus: onSyncFocus, onSyncBlur: onSyncBlur });
    return React.createElement(React.Fragment, null, children.call(undefined, __assign$T({}, args)));
};

/** @hidden */
var usePropsContext = function (context, props) {
    var contextPropsCallback = React.useContext(context);
    var contextProps = contextPropsCallback(props);
    return contextProps;
};

var __assign$S = (undefined && undefined.__assign) || function () {
    __assign$S = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$S.apply(this, arguments);
};
/** @hidden */
var createPropsContext = function () { return React.createContext(function (props) { return props; }); };
/** @hidden */
var withPropsContext = function (context, Component
// eslint-disable-next-line react/display-name
) { return React.forwardRef(function (props, ref) {
    var contextProps = usePropsContext(context, props);
    return (React.createElement(Component, __assign$S({}, contextProps, { ref: ref })));
}); };

/**
 * @hidden
 */
function useDir(elementRef, initialDir, args) {
    // Dir prop is read only on initial rendering due to specifics of getComputedStyles - see below
    var _a = React.useState(initialDir), dir = _a[0], setDir = _a[1];
    React.useEffect(function () {
        if (!dir && window && elementRef.current) {
            // Note: getComputedStyle forces reflow
            var rtlCandidate = window.getComputedStyle(elementRef.current).direction;
            if (rtlCandidate) {
                // rerender is needed as DOM is read after first render
                setDir(rtlCandidate);
            }
        }
    }, args);
    return dir;
}

/**
 * @hidden
 */
var useMouse = function (props, target, extend) {
    if (extend === void 0) { extend = {}; }
    var handleMouseDown = React.useCallback(function (event) {
        if (extend.onMouseDown) {
            extend.onMouseDown.call(undefined, event);
        }
        if (props.onMouseDown) {
            props.onMouseDown.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseDown, props.onMouseDown, target]);
    var handleMouseUp = React.useCallback(function (event) {
        if (extend.onMouseUp) {
            extend.onMouseUp.call(undefined, event);
        }
        if (props.onMouseUp) {
            props.onMouseUp.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseUp, props.onMouseUp, target]);
    var handleClick = React.useCallback(function (event) {
        if (extend.onClick) {
            extend.onClick.call(undefined, event);
        }
        if (props.onClick) {
            props.onClick.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onClick, props.onClick, target]);
    var handleDoubleClick = React.useCallback(function (event) {
        if (extend.onDoubleClick) {
            extend.onDoubleClick.call(undefined, event);
        }
        if (props.onDoubleClick) {
            props.onDoubleClick.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onDoubleClick, props.onDoubleClick, target]);
    var handleMouseEnter = React.useCallback(function (event) {
        if (extend.onMouseEnter) {
            extend.onMouseEnter.call(undefined, event);
        }
        if (props.onMouseEnter) {
            props.onMouseEnter.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseEnter, props.onMouseEnter, target]);
    var handleMouseLeave = React.useCallback(function (event) {
        if (extend.onMouseLeave) {
            extend.onMouseLeave.call(undefined, event);
        }
        if (props.onMouseLeave) {
            props.onMouseLeave.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseLeave, props.onMouseLeave, target]);
    var handelMouseMove = React.useCallback(function (event) {
        if (extend.onMouseMove) {
            extend.onMouseMove.call(undefined, event);
        }
        if (props.onMouseMove) {
            props.onMouseMove.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseMove, props.onMouseMove, target]);
    var handleMouseOut = React.useCallback(function (event) {
        if (extend.onMouseOut) {
            extend.onMouseOut.call(undefined, event);
        }
        if (props.onMouseOut) {
            props.onMouseOut.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseOut, props.onMouseOut, target]);
    var handleMouseOver = React.useCallback(function (event) {
        if (extend.onMouseOver) {
            extend.onMouseOver.call(undefined, event);
        }
        if (props.onMouseOver) {
            props.onMouseOver.call(undefined, {
                target: target.current,
                syntheticEvent: event
            });
        }
    }, [extend.onMouseOver, props.onMouseOver, target]);
    return {
        onClick: handleClick,
        onMouseUp: handleMouseUp,
        onMouseDown: handleMouseDown,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseMove: handelMouseMove,
        onMouseOut: handleMouseOut,
        onMouseOver: handleMouseOver
    };
};

/**
 * @hidden
 */
var useCustomComponent = function (comp) {
    /* if(React.isValidElement<P>(comp)) {
        return [comp.type, comp.props];
    } */
    return [comp, {}];
};

/**
 * @hidden
 */
var SIZE_CLASSES = {
    'default': '',
    'xsmall': 'k-icon-xs',
    'small': 'k-icon-sm',
    'medium': 'k-icon-md',
    'large': 'k-icon-lg',
    'xlarge': 'k-icon-xl'
};

var __assign$R = (undefined && undefined.__assign) || function () {
    __assign$R = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$R.apply(this, arguments);
};
var __rest$f = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Represents the [KendoReact Icon component]({% slug overview_icon %}).
 *
 * @example
 * ```jsx
 * const App = () => {
 *   return (
 *       <Icon name="home"/>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var Icon = React.forwardRef(function (props, ref) {
    var className = props.className, name = props.name, themeColor = props.themeColor, size = props.size, flip = props.flip, style = props.style, id = props.id, tabIndex = props.tabIndex, others = __rest$f(props, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]);
    var target = React.useRef(null);
    var elementRef = React.useRef(null);
    React.useImperativeHandle(target, function () { return ({
        element: elementRef.current
    }); });
    React.useImperativeHandle(ref, function () { return target.current; });
    var themeColorProp = React.useMemo(function () { return themeColor || defaultProps$4.themeColor; }, [themeColor]);
    var sizeProp = React.useMemo(function () { return size || defaultProps$4.size; }, [size]);
    var flipProp = React.useMemo(function () { return flip || defaultProps$4.flip; }, [flip]);
    var fontClassNames = React.useMemo(function () { return classNames$2('k-icon', 'k-i-' + name, 'k-color-' + themeColorProp, {
        'k-flip-h': flipProp === 'horizontal' || flipProp === 'both',
        'k-flip-v': flipProp === 'vertical' || flipProp === 'both'
    }, SIZE_CLASSES[sizeProp], className); }, [name, themeColorProp, sizeProp, flipProp, className]);
    var mouseProps = useMouse(props, target);
    return (React.createElement("span", __assign$R({ ref: elementRef }, others, mouseProps, { className: fontClassNames, id: id, tabIndex: tabIndex, style: style, role: "presentation" })));
});
Icon.propTypes = {
    style: propTypes.exports.object,
    classNames: propTypes.exports.string,
    name: propTypes.exports.string,
    themeColor: propTypes.exports.oneOf([
        'inherit', 'primary', 'secondary', 'tertiary',
        'info', 'success', 'error', 'warning',
        'dark', 'light', 'inverse'
    ]),
    size: propTypes.exports.oneOf(['default', 'xsmall', 'small', 'medium', 'large', 'xlarge']),
    flip: propTypes.exports.oneOf(['default', 'horizontal', 'vertical', 'both'])
};
var defaultProps$4 = {
    size: 'default',
    themeColor: 'inherit',
    flip: 'default'
};
Icon.displayName = 'KendoIcon';

/**
 * @hidden
 */
var useInheritedState = function (context, defaultValue) {
    var _a = React.useContext(context), contextValue = _a[0], contextSetter = _a[1];
    var _b = React.useState(defaultValue), localValue = _b[0], localSetter = _b[1];
    var value = contextValue !== undefined ? contextValue : localValue;
    var handleValueChange = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        contextValue !== undefined
            ? contextSetter.apply(void 0, args) : localSetter(args[0]);
    };
    return [
        value,
        handleValueChange
    ];
};

/**
 * @hidden
 */
var DragContext = React.createContext([
    undefined,
    noop$2
]);
/**
 * @hidden
 */
var DropContext = React.createContext([
    undefined,
    noop$2
]);
/**
 * @hidden
 */
var DragsContext = React.createContext([[], noop$2, noop$2]);
/**
 * @hidden
 */
var DropsContext = React.createContext([[], noop$2, noop$2]);

var IGNORE_MOUSE_TIMEOUT = 2000;
/**
 * Represents the KendoReact `useDraggable` hook.
 * Use it to attach `drag` events to a native HTML DOM elements, or custom React Components.
 *
 * For more information, refer to the [KendoReact Draggable]({% slug draggable_drag-and-drop %}) article.
 *
 * @param ref - The `ref` of the HTML Element or React Component which will enable the `draggable` functionality.
 * @param callbacks - A collection of callbacks, called by the `useDraggable` hook when a specific action occurs.
 * @param options - Additional configuration of the `useDraggable` hook.
 */
function useDraggable(ref, callbacks, options) {
    if (options === void 0) { options = {}; }
    var _a = callbacks.onPress, onPress = _a === void 0 ? noop$2 : _a, _b = callbacks.onRelease, onRelease = _b === void 0 ? noop$2 : _b, _c = callbacks.onDragStart, onDragStart = _c === void 0 ? noop$2 : _c, _d = callbacks.onDrag, onDrag = _d === void 0 ? noop$2 : _d, _e = callbacks.onDragEnd, onDragEnd = _e === void 0 ? noop$2 : _e;
    var _f = options.hint, hint = _f === void 0 ? null : _f, _g = options.mouseOnly, mouseOnly = _g === void 0 ? false : _g, _h = options.autoScroll, autoScroll$1 = _h === void 0 ? true : _h, _j = options.scrollContainer, scrollContainer = _j === void 0 ? null : _j;
    var _k = React.useState(false), pressed = _k[0], setPressed = _k[1];
    var _l = React.useState(false), scrolling = _l[0], setScrolling = _l[1];
    var drop = useInheritedState(DropContext)[0];
    var _m = useInheritedState(DragContext), drag = _m[0], setDrag = _m[1];
    var drops = React.useContext(DropsContext)[0];
    var _o = React.useContext(DragsContext), drags = _o[0], registerDrag = _o[1], deregisterDrag = _o[2];
    var velocity = React.useRef({ x: 0, y: 0 });
    var scrollInterval = React.useRef();
    var ignoreMouse = React.useRef(false);
    var restoreMouseTimeout = React.useRef();
    var scrollable = React.useRef(null);
    var unmount = React.useRef(false);
    var offset = React.useRef({ x: 0, y: 0 });
    var pageOffset = React.useRef({ x: 0, y: 0 });
    var clientOffset = React.useRef({ x: 0, y: 0 });
    var initialClientOffset = React.useRef({ x: 0, y: 0 });
    var scrollOffset = React.useRef({ x: 0, y: 0 });
    var initialScrollOffset = React.useRef({ x: 0, y: 0 });
    var supportPointerEvent = Boolean((typeof window !== 'undefined') && window.PointerEvent);
    var pointers = !mouseOnly && supportPointerEvent;
    var getElement = React.useCallback(function () { return ref.current && ref.current.element
        ? ref.current.element
        : ref.current; }, [ref]);
    var getHintElement = React.useCallback(function () { return hint && hint.current && hint.current.element
        ? hint.current.element
        : hint
            ? hint.current
            : null; }, [hint]);
    var getScrollContainer = React.useCallback(function () { return scrollContainer && scrollContainer.current && scrollContainer.current.element
        ? scrollContainer.current.element
        : scrollContainer
            ? scrollContainer.current
            : null; }, [scrollContainer]);
    var getAutoScrollContainer = React.useCallback(function () { return typeof autoScroll$1 === 'object' && autoScroll$1.boundaryElementRef
        && autoScroll$1.boundaryElementRef.current && autoScroll$1.boundaryElementRef.current.element
        ? autoScroll$1.boundaryElementRef.current.element
        : typeof autoScroll$1 === 'object' && autoScroll$1.boundaryElementRef && autoScroll$1.boundaryElementRef.current
            ? autoScroll$1.boundaryElementRef.current
            : null; }, [autoScroll$1]);
    var target = React.useRef(null);
    React.useImperativeHandle(target, function () { return ({
        element: getElement(),
        hint: getHintElement(),
        onPress: handlePress,
        onDragStart: handleDragStart,
        onDrag: handleDrag,
        onDragEnd: handleDragEnd,
        onRelease: handleRelease,
        data: ref.current
    }); });
    var getDocument = React.useCallback(function () {
        var element = getElement();
        return element ? element.ownerDocument || document : document;
    }, [getElement]);
    var getWindow = React.useCallback(function () {
        var document = getDocument();
        return document
            ? document.defaultView || window
            : window;
    }, [getDocument]);
    var getState = React.useCallback(function () { return ({
        drag: drag ? drag.current : null,
        drop: drop ? drop.current : null,
        drags: drags.map(function (d) { return d.current; }),
        drops: drops.map(function (d) { return d.current; }),
        pressed: pressed,
        ignoreMouse: ignoreMouse.current,
        scrollOffset: scrollOffset.current,
        offset: offset.current,
        pageOffset: pageOffset.current,
        initialScrollOffset: initialScrollOffset.current,
        clientOffset: clientOffset.current,
        initialClientOffset: initialClientOffset.current,
        velocity: velocity.current,
        autoScroll: Boolean(typeof autoScroll$1 === 'object' ? autoScroll$1.enabled !== false : autoScroll$1),
        scrollableParent: getAutoScrollContainer(),
        autoScrollDirection: typeof autoScroll$1 === 'object' ? autoScroll$1.direction : { horizontal: true, vertical: true },
        isScrolling: scrolling
    }); }, [drag, drop, drags, drops, pressed, autoScroll$1, getAutoScrollContainer, scrolling]);
    var handlePressedChange = React.useCallback(function (value) {
        setPressed(value);
    }, []);
    var handleScrollingChange = React.useCallback(function (value) {
        setScrolling(value);
    }, []);
    var handleVelocityChange = React.useCallback(function (value) {
        velocity.current = value;
    }, []);
    var handleOffsetChange = React.useCallback(function (value) {
        offset.current = value;
    }, []);
    var handleClientOffsetChange = React.useCallback(function (value) {
        clientOffset.current = value;
    }, []);
    var handlePageOffsetChange = React.useCallback(function (value) {
        pageOffset.current = value;
    }, []);
    var handleInitialClientOffsetChange = React.useCallback(function (value) {
        initialClientOffset.current = value;
    }, []);
    var handleScrollOffsetChange = React.useCallback(function (value) {
        scrollOffset.current = value;
    }, []);
    var handleInitialScrollOffsetChange = React.useCallback(function (value) {
        initialScrollOffset.current = value;
    }, []);
    // Drag Events
    var handlePress = React.useCallback(function (event) {
        onPress(event);
    }, [onPress]);
    var handleRelease = React.useCallback(function (event) {
        onRelease(event);
    }, [onRelease]);
    var handleDragStart = React.useCallback(function (event) {
        setDrag(target, { target: ref.current, event: event });
        onDragStart(event);
    }, [setDrag, ref, onDragStart]);
    var handleDrag = React.useCallback(function (event) {
        onDrag(event);
    }, [onDrag]);
    var handleDragEnd = React.useCallback(function (event) {
        if (unmount.current) {
            return;
        }
        setDrag(null, { target: ref.current, event: event });
        onDragEnd(event);
    }, [onDragEnd, setDrag, ref]);
    var dispatchDragEvent = React.useCallback(function (event) {
        dispatchDragAndDrop(getState(), { event: event, payload: target.current }, {
            onVelocityChange: handleVelocityChange,
            onOffsetChange: handleOffsetChange,
            onClientOffsetChange: handleClientOffsetChange,
            onPageOffsetChange: handlePageOffsetChange,
            onInitialClientOffsetChange: handleInitialClientOffsetChange,
            onScrollOffsetChange: handleScrollOffsetChange,
            onInitialScrollOffsetChange: handleInitialScrollOffsetChange,
            onIsPressedChange: handlePressedChange,
            onIsScrollingChange: handleScrollingChange
        });
    }, [
        getState,
        handleVelocityChange,
        handleOffsetChange,
        handlePageOffsetChange,
        handleClientOffsetChange,
        handleInitialClientOffsetChange,
        handleInitialScrollOffsetChange,
        handlePressedChange,
        handleScrollOffsetChange,
        handleScrollingChange
    ]);
    // Pointer Events
    var handlePointerDown = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handlePointerMove = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handlePointerCancel = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handlePointerUp = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    // Mouse Events
    var handleMouseDown = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleMouseMove = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleMouseUp = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleContextMenu = React.useCallback(function (event) {
        event.preventDefault();
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    // Touch Events
    var handleTouchStart = React.useCallback(function (event) {
        event.preventDefault();
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleTouchMove = React.useCallback(function (event) {
        event.preventDefault();
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    var handleTouchEnd = React.useCallback(function (event) {
        if (event.touches.length === 0 && event.changedTouches.length === 1) {
            var currentWindow = getWindow();
            ignoreMouse.current = true;
            restoreMouseTimeout.current = currentWindow.setTimeout(function () { ignoreMouse.current = false; }, IGNORE_MOUSE_TIMEOUT);
        }
        dispatchDragEvent(event);
    }, [dispatchDragEvent, getWindow]);
    var handleScroll = React.useCallback(function (event) {
        dispatchDragEvent(event);
    }, [dispatchDragEvent]);
    // Misc
    var prerequisites = React.useCallback(function () {
        var element = getElement();
        if (element) {
            var initialTouchAction_1 = element.style.touchAction;
            element.style.touchAction = 'none';
            return function () {
                element.style.touchAction = initialTouchAction_1;
            };
        }
    }, [getElement]);
    var register = React.useCallback(function () {
        registerDrag(target);
        return function () {
            deregisterDrag(target);
        };
    }, [deregisterDrag, registerDrag]);
    var init = function () {
        var window = getWindow();
        var element = getElement();
        var document = getDocument();
        if (pointers) {
            if (element) {
                scrollable.current = getScrollableParent(element);
                if (scrollable.current) {
                    scrollable.current.addEventListener('scroll', handleScroll, { passive: true });
                }
                element.addEventListener('pointerdown', handlePointerDown, { passive: true });
            }
            if (pressed) {
                document.addEventListener('pointermove', handlePointerMove);
                document.addEventListener('pointerup', handlePointerUp, true);
                document.addEventListener('contextmenu', handleContextMenu);
                document.addEventListener('pointercancel', handlePointerCancel, { passive: true });
            }
        }
        else {
            // Hacky-hacky iOS Safari
            window.addEventListener('touchmove', noop$2, { capture: false, passive: false });
            if (element) {
                element.addEventListener('mousedown', handleMouseDown, { passive: true });
                if (!mouseOnly) {
                    element.addEventListener('touchstart', handleTouchStart, { passive: true });
                    if (pressed) {
                        element.addEventListener('touchmove', handleTouchMove, { passive: true });
                        element.addEventListener('touchend', handleTouchEnd, { passive: true });
                    }
                }
            }
            if (pressed) {
                document.addEventListener('mousemove', handleMouseMove, { passive: true });
                document.addEventListener('mouseup', handleMouseUp, { passive: true });
            }
        }
        return function () {
            if (scrollable.current) {
                scrollable.current.removeEventListener('scroll', handleScroll);
            }
            if (element) {
                element.removeEventListener('pointerdown', handlePointerDown);
                element.removeEventListener('mousedown', handleMouseDown);
                element.removeEventListener('touchstart', handleTouchStart);
                element.removeEventListener('touchmove', handleTouchMove);
                element.removeEventListener('touchend', handleTouchEnd);
            }
            document.removeEventListener('pointermove', handlePointerMove);
            document.removeEventListener('pointerup', handlePointerUp, true);
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('pointercancel', handlePointerCancel);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', noop$2);
            window.clearTimeout(restoreMouseTimeout.current);
        };
    };
    React.useEffect(function () {
        var window = getWindow();
        if (scrolling) {
            var scrollableParent_1 = getScrollContainer()
                || getScrollableParent(document.elementFromPoint(clientOffset.current.x, clientOffset.current.y));
            window.clearInterval(scrollInterval.current);
            scrollInterval.current = window.setInterval(function () {
                autoScroll(scrollableParent_1, { x: velocity.current.x, y: velocity.current.y });
            }, 50);
        }
        return function () {
            window.clearInterval(scrollInterval.current);
        };
    }, [getElement, getScrollContainer, getWindow, scrolling]);
    React.useEffect(prerequisites, [prerequisites]);
    React.useEffect(init, [
        pressed,
        getWindow,
        getElement,
        getDocument,
        mouseOnly,
        pointers,
        handleContextMenu,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp,
        handlePointerCancel,
        handlePointerDown,
        handlePointerMove,
        handlePointerUp,
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart,
        handleScroll
    ]);
    React.useEffect(function () {
        return function () {
            unmount.current = true;
        };
    }, []);
    React.useLayoutEffect(register, [register]);
}

/**
 * Represents the KendoReact Draggable component.
 *
 * Accepts properties of type [DraggableProps]({% slug api_common_draggableprops %}),
 * and returns an object of type [DraggableHandle]({% slug api_common_draggablehandle %}) when the `ref` is obtained.
 */
var Draggable = React.forwardRef(function (props, ref) {
    var childRef = React.useRef(null);
    var target = React.useRef(null);
    var getElement = React.useCallback(function () { return childRef.current && childRef.current.element
        ? childRef.current.element
        : childRef.current; }, [childRef]);
    React.useImperativeHandle(target, function () { return ({ element: getElement() || null }); });
    React.useImperativeHandle(ref, function () { return target.current; });
    React.useImperativeHandle(props.childRef, function () { return childRef.current; });
    var handlePress = React.useCallback(function (event) {
        if (!props.onPress) {
            return;
        }
        props.onPress({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onPress]);
    var handleRelease = React.useCallback(function (event) {
        if (!props.onRelease) {
            return;
        }
        props.onRelease({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onRelease]);
    var handleDragStart = React.useCallback(function (event) {
        if (!props.onDragStart) {
            return;
        }
        props.onDragStart({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [props, getElement]);
    var handleDrag = React.useCallback(function (event) {
        if (!props.onDrag) {
            return;
        }
        props.onDrag({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onDrag]);
    var handleDragEnd = React.useCallback(function (event) {
        if (!props.onDragEnd) {
            return;
        }
        props.onDragEnd({
            element: getElement(),
            target: target.current,
            event: event
        });
    }, [getElement, props.onDragEnd]);
    useDraggable(childRef, {
        onPress: handlePress,
        onRelease: handleRelease,
        onDragStart: handleDragStart,
        onDrag: handleDrag,
        onDragEnd: handleDragEnd
    }, {
        mouseOnly: props.mouseOnly,
        autoScroll: props.autoScroll,
        hint: props.hint,
        scrollContainer: props.scrollContainer
    });
    return props.children
        ? (React.cloneElement(React.Children.only(props.children), { ref: childRef }))
        : null;
});
Draggable.displayName = 'KendoReactDraggable';

/** @hidden */
var kendoThemeMaps$1 = {
    sizeMap: {
        small: 'sm',
        medium: 'md',
        large: 'lg'
    },
    roundedMap: {
        small: 'sm',
        medium: 'md',
        large: 'lg'
    }
};

var _a$c;
/**
 * @hidden
 */
var pagerInfo$1 = 'pager.info';
/**
 * @hidden
 */
var pagerFirstPage$1 = 'pager.firstPage';
/**
 * @hidden
 */
var pagerPreviousPage$1 = 'pager.previousPage';
/**
 * @hidden
 */
var pagerNextPage$1 = 'pager.nextPage';
/**
 * @hidden
 */
var pagerLastPage$1 = 'pager.lastPage';
/**
 * @hidden
 */
var pagerItemPerPage$1 = 'pager.itemsPerPage';
/**
 * @hidden
 */
var pagerPageSelection = 'pager.pageSelection';
/**
 * @hidden
 */
var pagerPage$1 = 'pager.page';
/**
 * @hidden
 */
var pagerOf$1 = 'pager.of';
/**
 * @hidden
 */
var pagerTotalPages$1 = 'pager.totalPages';
/**
 * @hidden
 */
var pagerPageNumberLabel = 'pager.pageLabel';
/**
 * @hidden
 */
var pagerAriaKeyshortcuts = 'pager.ariaKeyshortcuts';
/**
 * @hidden
 */
var pagerAriaLabel = 'pager.ariaLabel';
/**
 * @hidden
 */
var pagerMobileSelect = 'pager.mobileSelect';
/**
 * @hidden
 */
var filterEqOperator = 'filter.eqOperator';
/**
 * @hidden
 */
var filterNotEqOperator = 'filter.notEqOperator';
/**
 * @hidden
 */
var filterIsNullOperator = 'filter.isNullOperator';
/**
 * @hidden
 */
var filterIsNotNullOperator = 'filter.isNotNullOperator';
/**
 * @hidden
 */
var filterIsEmptyOperator = 'filter.isEmptyOperator';
/**
 * @hidden
 */
var filterIsNotEmptyOperator = 'filter.isNotEmptyOperator';
/**
 * @hidden
 */
var filterStartsWithOperator = 'filter.startsWithOperator';
/**
 * @hidden
 */
var filterContainsOperator = 'filter.containsOperator';
/**
 * @hidden
 */
var filterNotContainsOperator = 'filter.notContainsOperator';
/**
 * @hidden
 */
var filterEndsWithOperator = 'filter.endsWithOperator';
/**
 * @hidden
 */
var filterGteOperator = 'filter.gteOperator';
/**
 * @hidden
 */
var filterGtOperator = 'filter.gtOperator';
/**
 * @hidden
 */
var filterLteOperator = 'filter.lteOperator';
/**
 * @hidden
 */
var filterLtOperator = 'filter.ltOperator';
/**
 * @hidden
 */
var filterIsTrue = 'filter.isTrue';
/**
 * @hidden
 */
var filterIsFalse = 'filter.isFalse';
/**
 * @hidden
 */
var filterAfterOrEqualOperator = 'filter.afterOrEqualOperator';
/**
 * @hidden
 */
var filterAfterOperator = 'filter.afterOperator';
/**
 * @hidden
 */
var filterBeforeOperator = 'filter.beforeOperator';
/**
 * @hidden
 */
var filterBeforeOrEqualOperator = 'filter.beforeOrEqualOperator';
/**
 * @hidden
 */
var filterAndLogic = 'filter.andLogic';
/**
 * @hidden
 */
var filterOrLogic = 'filter.orLogic';
/**
 * @hidden
 */
var filterAddExpression = 'filter.addExpression';
/**
 * @hidden
 */
var filterAddGroup = 'filter.addGroup';
/**
 * @hidden
 */
var filterClose = 'filter.close';
/**
 * @hidden
 */
var filterGroupAriaLabel = 'filter.groupAriaLabel';
/**
 * @hidden
 */
var filterExpressionAriaLabel = 'filter.expressionAriaLabel';
/**
 * @hidden
 */
var filterExpressionDropdownAriaLabel = 'filter.expressionDropdownAriaLabel';
/**
 * @hidden
 */
var filterExpressionOperatorDropdownAriaLabel = 'filter.expressionOperatorDropdownAriaLabel';
/**
 * @hidden
 */
var filterEnumFilterDropdownAriaLabel = 'filter.enumFilterDropdownAriaLabel';
/**
 * @hidden
 */
var filterNumericFilterAriaLabel = 'filter.numericFilterAriaLabel';
/**
 * @hidden
 */
var filterTextFilterAriaLabel = 'filter.textFilterAriaLabel';
/**
 * @hidden
 */
var columnMenuFilterClearButton = 'columnMenu.filterClearButton';
/**
 * @hidden
 */
var columnMenuFilterSubmitButton = 'columnMenu.filterSubmitButton';
/**
 * @hidden
 */
var columnMenuFilterTitle = 'columnMenu.filterTitle';
/**
 * @hidden
 */
var columnMenuSortAscending = 'columnMenu.sortAscending';
/**
 * @hidden
 */
var columnMenuSortDescending = 'columnMenu.sortDescending';
/**
 * @hidden
 */
var columnMenuFilterEqOperator = 'columnMenu.filterEqOperator';
/**
 * @hidden
 */
var columnMenuFilterNotEqOperator = 'columnMenu.filterNotEqOperator';
/**
 * @hidden
 */
var columnMenuFilterIsNullOperator = 'columnMenu.filterIsNullOperator';
/**
 * @hidden
 */
var columnMenuFilterIsNotNullOperator = 'columnMenu.filterIsNotNullOperator';
/**
 * @hidden
 */
var columnMenuFilterIsEmptyOperator = 'columnMenu.filterIsEmptyOperator';
/**
 * @hidden
 */
var columnMenuFilterIsNotEmptyOperator = 'columnMenu.filterIsNotEmptyOperator';
/**
 * @hidden
 */
var columnMenuFilterStartsWithOperator = 'columnMenu.filterStartsWithOperator';
/**
 * @hidden
 */
var columnMenuFilterContainsOperator = 'columnMenu.filterContainsOperator';
/**
 * @hidden
 */
var columnMenuFilterNotContainsOperator = 'columnMenu.filterNotContainsOperator';
/**
 * @hidden
 */
var columnMenuFilterEndsWithOperator = 'columnMenu.filterEndsWithOperator';
/**
 * @hidden
 */
var columnMenuFilterGteOperator = 'columnMenu.filterGteOperator';
/**
 * @hidden
 */
var columnMenuFilterGtOperator = 'columnMenu.filterGtOperator';
/**
 * @hidden
 */
var columnMenuFilterLteOperator = 'columnMenu.filterLteOperator';
/**
 * @hidden
 */
var columnMenuFilterLtOperator = 'columnMenu.filterLtOperator';
/**
 * @hidden
 */
var columnMenuFilterIsTrue = 'columnMenu.filterIsTrue';
/**
 * @hidden
 */
var columnMenuFilterAfterOrEqualOperator = 'columnMenu.filterAfterOrEqualOperator';
/**
 * @hidden
 */
var columnMenuFilterAfterOperator = 'columnMenu.filterAfterOperator';
/**
 * @hidden
 */
var columnMenuFilterBeforeOperator = 'columnMenu.filterBeforeOperator';
/**
 * @hidden
 */
var columnMenuFilterBeforeOrEqualOperator = 'columnMenu.filterBeforeOrEqualOperator';
/**
 * @hidden
 */
var columnMenuFilterAndLogic = 'columnMenu.filterAndLogic';
/**
 * @hidden
 */
var columnMenuFilterOrLogic = 'columnMenu.filterOrLogic';
/**
 * @hidden
 */
var sortAriaLabel$1 = 'sort.ariaLabel';
/**
 * @hidden
 */
var filterAriaLabel$1 = 'filter.ariaLabel';
/**
 * @hidden
 */
var messages$6 = (_a$c = {},
    _a$c[pagerItemPerPage$1] = 'items per page',
    _a$c[pagerPageSelection] = 'Select page',
    _a$c[pagerInfo$1] = '{0} - {1} of {2} items',
    _a$c[pagerFirstPage$1] = 'Go to the first page',
    _a$c[pagerPreviousPage$1] = 'Go to the previous page',
    _a$c[pagerNextPage$1] = 'Go to the next page',
    _a$c[pagerLastPage$1] = 'Go to the last page',
    _a$c[pagerPage$1] = 'Page',
    _a$c[pagerOf$1] = 'Of',
    _a$c[pagerTotalPages$1] = '{0}',
    _a$c[pagerPageNumberLabel] = 'Page',
    _a$c[pagerAriaKeyshortcuts] = 'Enter ArrowRight ArrowLeft',
    _a$c[pagerAriaLabel] = 'Pager',
    _a$c[pagerMobileSelect] = 'Select',
    _a$c[sortAriaLabel$1] = 'Sortable',
    _a$c[filterAriaLabel$1] = 'Filter',
    _a$c[filterEqOperator] = 'Is equal to',
    _a$c[filterNotEqOperator] = 'Is not equal to',
    _a$c[filterIsNullOperator] = 'Is null',
    _a$c[filterIsNotNullOperator] = 'Is not null',
    _a$c[filterIsEmptyOperator] = 'Is empty',
    _a$c[filterIsNotEmptyOperator] = 'Is not empty',
    _a$c[filterStartsWithOperator] = 'Starts with',
    _a$c[filterContainsOperator] = 'Contains',
    _a$c[filterNotContainsOperator] = 'Does not contain',
    _a$c[filterEndsWithOperator] = 'Ends with',
    _a$c[filterGteOperator] = 'Is greater than or equal to',
    _a$c[filterGtOperator] = 'Is greater than',
    _a$c[filterLteOperator] = 'Is less than or equal to',
    _a$c[filterLtOperator] = 'Is less than',
    _a$c[filterIsTrue] = 'Is true',
    _a$c[filterIsFalse] = 'Is false',
    _a$c[filterAfterOrEqualOperator] = 'Is after or equal to',
    _a$c[filterAfterOperator] = 'Is after',
    _a$c[filterBeforeOperator] = 'Is before',
    _a$c[filterBeforeOrEqualOperator] = 'Is before or equal to',
    _a$c[filterAndLogic] = 'And',
    _a$c[filterOrLogic] = 'Or',
    _a$c[filterAddExpression] = 'Add Expression',
    _a$c[filterAddGroup] = 'Add Group',
    _a$c[filterClose] = 'Close',
    _a$c[filterGroupAriaLabel] = 'Filter toolbar',
    _a$c[filterExpressionAriaLabel] = 'Filter expression row',
    _a$c[filterExpressionDropdownAriaLabel] = 'Filter dropdown',
    _a$c[filterExpressionOperatorDropdownAriaLabel] = 'Filter operator dropdown',
    _a$c[filterEnumFilterDropdownAriaLabel] = 'Select True/False',
    _a$c[filterNumericFilterAriaLabel] = 'Enter number',
    _a$c[filterTextFilterAriaLabel] = 'Enter number',
    _a$c[columnMenuFilterClearButton] = 'Clear',
    _a$c[columnMenuFilterSubmitButton] = 'Filter',
    _a$c[columnMenuFilterTitle] = 'Filter',
    _a$c[columnMenuSortAscending] = 'Sort Ascending',
    _a$c[columnMenuSortDescending] = 'Sort Descending',
    _a$c[columnMenuFilterEqOperator] = 'Is equal to',
    _a$c[columnMenuFilterNotEqOperator] = 'Is not equal to',
    _a$c[columnMenuFilterIsNullOperator] = 'Is null',
    _a$c[columnMenuFilterIsNotNullOperator] = 'Is not null',
    _a$c[columnMenuFilterIsEmptyOperator] = 'Is empty',
    _a$c[columnMenuFilterIsNotEmptyOperator] = 'Is not empty',
    _a$c[columnMenuFilterStartsWithOperator] = 'Starts with',
    _a$c[columnMenuFilterContainsOperator] = 'Contains',
    _a$c[columnMenuFilterNotContainsOperator] = 'Does not contain',
    _a$c[columnMenuFilterEndsWithOperator] = 'Ends with',
    _a$c[columnMenuFilterGteOperator] = 'Is greater than or equal to',
    _a$c[columnMenuFilterGtOperator] = 'Is greater than',
    _a$c[columnMenuFilterLteOperator] = 'Is less than or equal to',
    _a$c[columnMenuFilterLtOperator] = 'Is less than',
    _a$c[columnMenuFilterIsTrue] = 'Is true',
    _a$c[columnMenuFilterAfterOrEqualOperator] = 'Is after or equal to',
    _a$c[columnMenuFilterAfterOperator] = 'Is after',
    _a$c[columnMenuFilterBeforeOperator] = 'Is before',
    _a$c[columnMenuFilterBeforeOrEqualOperator] = 'Is before or equal to',
    _a$c[columnMenuFilterAndLogic] = 'And',
    _a$c[columnMenuFilterOrLogic] = 'Or',
    _a$c);

var defaultData = {
    en: {
        name: "en",
        identity: {
            version: {
                _unicodeVersion: "14.0.0",
                _cldrVersion: "41"
            },
            language: "en"
        },
        territory: "US",
        numbers: {
            symbols: {
                decimal: ".",
                group: ",",
                list: ";",
                percentSign: "%",
                plusSign: "+",
                minusSign: "-",
                exponential: "E",
                superscriptingExponent: "×",
                perMille: "‰",
                infinity: "∞",
                nan: "NaN",
                timeSeparator: ":",
                approximatelySign: "~"
            },
            decimal: {
                patterns: [
                    "n"
                ],
                groupSize: [
                    3
                ]
            },
            scientific: {
                patterns: [
                    "nEn"
                ],
                groupSize: []
            },
            percent: {
                patterns: [
                    "n%"
                ],
                groupSize: [
                    3
                ]
            },
            currency: {
                patterns: [
                    "$n"
                ],
                groupSize: [
                    3
                ],
                "unitPattern-count-one": "n $",
                "unitPattern-count-other": "n $"
            },
            currencies: {
                BGN: {
                    displayName: "Bulgarian Lev",
                    "displayName-count-one": "Bulgarian lev",
                    "displayName-count-other": "Bulgarian leva",
                    symbol: "BGN"
                },
                EUR: {
                    displayName: "Euro",
                    "displayName-count-one": "euro",
                    "displayName-count-other": "euros",
                    symbol: "€",
                    "symbol-alt-narrow": "€"
                },
                USD: {
                    displayName: "US Dollar",
                    "displayName-count-one": "US dollar",
                    "displayName-count-other": "US dollars",
                    symbol: "$",
                    "symbol-alt-narrow": "$"
                }
            },
            localeCurrency: "USD",
            accounting: {
                patterns: [
                    "$n",
                    "($n)"
                ],
                groupSize: [
                    3
                ]
            }
        },
        calendar: {
            gmtFormat: "GMT{0}",
            gmtZeroFormat: "GMT",
            patterns: {
                d: "M/d/y",
                D: "EEEE, MMMM d, y",
                m: "MMM d",
                M: "MMMM d",
                y: "MMM y",
                Y: "MMMM y",
                F: "EEEE, MMMM d, y h:mm:ss a",
                g: "M/d/y h:mm a",
                G: "M/d/y h:mm:ss a",
                t: "h:mm a",
                T: "h:mm:ss a",
                s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'"
            },
            dateTimeFormats: {
                full: "{1} 'at' {0}",
                long: "{1} 'at' {0}",
                medium: "{1}, {0}",
                short: "{1}, {0}",
                availableFormats: {
                    Bh: "h B",
                    Bhm: "h:mm B",
                    Bhms: "h:mm:ss B",
                    d: "d",
                    E: "ccc",
                    EBhm: "E h:mm B",
                    EBhms: "E h:mm:ss B",
                    Ed: "d E",
                    Ehm: "E h:mm a",
                    EHm: "E HH:mm",
                    Ehms: "E h:mm:ss a",
                    EHms: "E HH:mm:ss",
                    Gy: "y G",
                    GyMd: "M/d/y GGGGG",
                    GyMMM: "MMM y G",
                    GyMMMd: "MMM d, y G",
                    GyMMMEd: "E, MMM d, y G",
                    h: "h a",
                    H: "HH",
                    hm: "h:mm a",
                    Hm: "HH:mm",
                    hms: "h:mm:ss a",
                    Hms: "HH:mm:ss",
                    hmsv: "h:mm:ss a v",
                    Hmsv: "HH:mm:ss v",
                    hmv: "h:mm a v",
                    Hmv: "HH:mm v",
                    M: "L",
                    Md: "M/d",
                    MEd: "E, M/d",
                    MMM: "LLL",
                    MMMd: "MMM d",
                    MMMEd: "E, MMM d",
                    MMMMd: "MMMM d",
                    "MMMMW-count-one": "'week' W 'of' MMMM",
                    "MMMMW-count-other": "'week' W 'of' MMMM",
                    ms: "mm:ss",
                    y: "y",
                    yM: "M/y",
                    yMd: "M/d/y",
                    yMEd: "E, M/d/y",
                    yMMM: "MMM y",
                    yMMMd: "MMM d, y",
                    yMMMEd: "E, MMM d, y",
                    yMMMM: "MMMM y",
                    yQQQ: "QQQ y",
                    yQQQQ: "QQQQ y",
                    "yw-count-one": "'week' w 'of' Y",
                    "yw-count-other": "'week' w 'of' Y"
                }
            },
            timeFormats: {
                full: "h:mm:ss a zzzz",
                long: "h:mm:ss a z",
                medium: "h:mm:ss a",
                short: "h:mm a"
            },
            dateFormats: {
                full: "EEEE, MMMM d, y",
                long: "MMMM d, y",
                medium: "MMM d, y",
                short: "M/d/yy"
            },
            days: {
                format: {
                    abbreviated: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    narrow: [
                        "S",
                        "M",
                        "T",
                        "W",
                        "T",
                        "F",
                        "S"
                    ],
                    short: [
                        "Su",
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa"
                    ],
                    wide: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ]
                },
                "stand-alone": {
                    abbreviated: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    narrow: [
                        "S",
                        "M",
                        "T",
                        "W",
                        "T",
                        "F",
                        "S"
                    ],
                    short: [
                        "Su",
                        "Mo",
                        "Tu",
                        "We",
                        "Th",
                        "Fr",
                        "Sa"
                    ],
                    wide: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ]
                }
            },
            months: {
                format: {
                    abbreviated: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    narrow: [
                        "J",
                        "F",
                        "M",
                        "A",
                        "M",
                        "J",
                        "J",
                        "A",
                        "S",
                        "O",
                        "N",
                        "D"
                    ],
                    wide: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ]
                },
                "stand-alone": {
                    abbreviated: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    narrow: [
                        "J",
                        "F",
                        "M",
                        "A",
                        "M",
                        "J",
                        "J",
                        "A",
                        "S",
                        "O",
                        "N",
                        "D"
                    ],
                    wide: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ]
                }
            },
            quarters: {
                format: {
                    abbreviated: [
                        "Q1",
                        "Q2",
                        "Q3",
                        "Q4"
                    ],
                    narrow: [
                        "1",
                        "2",
                        "3",
                        "4"
                    ],
                    wide: [
                        "1st quarter",
                        "2nd quarter",
                        "3rd quarter",
                        "4th quarter"
                    ]
                },
                "stand-alone": {
                    abbreviated: [
                        "Q1",
                        "Q2",
                        "Q3",
                        "Q4"
                    ],
                    narrow: [
                        "1",
                        "2",
                        "3",
                        "4"
                    ],
                    wide: [
                        "1st quarter",
                        "2nd quarter",
                        "3rd quarter",
                        "4th quarter"
                    ]
                }
            },
            dayPeriods: {
                format: {
                    abbreviated: {
                        midnight: "midnight",
                        am: "AM",
                        "am-alt-variant": "am",
                        noon: "noon",
                        pm: "PM",
                        "pm-alt-variant": "pm",
                        morning1: "in the morning",
                        afternoon1: "in the afternoon",
                        evening1: "in the evening",
                        night1: "at night"
                    },
                    narrow: {
                        midnight: "mi",
                        am: "a",
                        "am-alt-variant": "am",
                        noon: "n",
                        pm: "p",
                        "pm-alt-variant": "pm",
                        morning1: "in the morning",
                        afternoon1: "in the afternoon",
                        evening1: "in the evening",
                        night1: "at night"
                    },
                    wide: {
                        midnight: "midnight",
                        am: "AM",
                        "am-alt-variant": "am",
                        noon: "noon",
                        pm: "PM",
                        "pm-alt-variant": "pm",
                        morning1: "in the morning",
                        afternoon1: "in the afternoon",
                        evening1: "in the evening",
                        night1: "at night"
                    }
                },
                "stand-alone": {
                    abbreviated: {
                        midnight: "midnight",
                        am: "AM",
                        "am-alt-variant": "am",
                        noon: "noon",
                        pm: "PM",
                        "pm-alt-variant": "pm",
                        morning1: "morning",
                        afternoon1: "afternoon",
                        evening1: "evening",
                        night1: "night"
                    },
                    narrow: {
                        midnight: "midnight",
                        am: "AM",
                        "am-alt-variant": "am",
                        noon: "noon",
                        pm: "PM",
                        "pm-alt-variant": "pm",
                        morning1: "morning",
                        afternoon1: "afternoon",
                        evening1: "evening",
                        night1: "night"
                    },
                    wide: {
                        midnight: "midnight",
                        am: "AM",
                        "am-alt-variant": "am",
                        noon: "noon",
                        pm: "PM",
                        "pm-alt-variant": "pm",
                        morning1: "morning",
                        afternoon1: "afternoon",
                        evening1: "evening",
                        night1: "night"
                    }
                }
            },
            eras: {
                format: {
                    wide: {
                        "0": "Before Christ",
                        "1": "Anno Domini",
                        "0-alt-variant": "Before Common Era",
                        "1-alt-variant": "Common Era"
                    },
                    abbreviated: {
                        "0": "BC",
                        "1": "AD",
                        "0-alt-variant": "BCE",
                        "1-alt-variant": "CE"
                    },
                    narrow: {
                        "0": "B",
                        "1": "A",
                        "0-alt-variant": "BCE",
                        "1-alt-variant": "CE"
                    }
                }
            },
            dateFields: {
                era: {
                    wide: "era",
                    short: "era",
                    narrow: "era"
                },
                year: {
                    wide: "year",
                    short: "yr.",
                    narrow: "yr."
                },
                quarter: {
                    wide: "quarter",
                    short: "qtr.",
                    narrow: "qtr."
                },
                month: {
                    wide: "month",
                    short: "mo.",
                    narrow: "mo."
                },
                week: {
                    wide: "week",
                    short: "wk.",
                    narrow: "wk."
                },
                weekOfMonth: {
                    wide: "week of month",
                    short: "wk. of mo.",
                    narrow: "wk. of mo."
                },
                day: {
                    wide: "day",
                    short: "day",
                    narrow: "day"
                },
                dayOfYear: {
                    wide: "day of year",
                    short: "day of yr.",
                    narrow: "day of yr."
                },
                weekday: {
                    wide: "day of the week",
                    short: "day of wk.",
                    narrow: "day of wk."
                },
                weekdayOfMonth: {
                    wide: "weekday of the month",
                    short: "wkday. of mo.",
                    narrow: "wkday. of mo."
                },
                dayperiod: {
                    short: "AM/PM",
                    wide: "AM/PM",
                    narrow: "AM/PM"
                },
                hour: {
                    wide: "hour",
                    short: "hr.",
                    narrow: "hr."
                },
                minute: {
                    wide: "minute",
                    short: "min.",
                    narrow: "min."
                },
                second: {
                    wide: "second",
                    short: "sec.",
                    narrow: "sec."
                },
                zone: {
                    wide: "time zone",
                    short: "zone",
                    narrow: "zone"
                },
                millisecond: {
                    narrow: "ms",
                    short: "ms",
                    wide: "millisecond"
                }
            }
        }
    },
    supplemental: {
        likelySubtags: {
            en: "en-Latn-US"
        },
        currencyData: {
            region: {
                US: [
                    {
                        USD: {
                            _from: "1792-01-01"
                        }
                    }
                ]
            }
        },
        weekData: {
            firstDay: {
                US: "sun"
            },
            weekendStart: {
                "001": "sat"
            },
            weekendEnd: {
                "001": "sun"
            }
        }
    }
};

function isString$1(value) {
    return typeof value === "string";
}

//The error is represented by unique name and corresponding message
//The message can contain placeholders with index, e.g. {0}, {1}

var errorDetails = {
    "NoLocale": "Missing locale info for '{0}'",
    "NoCurrency": "Cannot determine currency information. Please load the locale currencies data.",
    "NoSupplementalCurrency": "Cannot determine currency. Please load the supplemental currencyData.",
    "NoCurrencyRegion": "No currency data for region '{0}'",
    "NoCurrencyDisplay": "Cannot determine currency display information. Please load the locale currencies data. The default culture does not include the all currencies data.",
    "NoGMTInfo": "Cannot determine locale GMT format. Please load the locale timeZoneNames data.",
    "NoWeekData": "Cannot determine locale first day of week. Please load the supplemental weekData.",
    "NoFirstDay": "Cannot determine locale first day of week. Please load the supplemental weekData. The default culture includes only the 'en-US' first day info.",
    "NoValidCurrency": "Cannot determine a default currency for the {0} locale. Please specify explicitly the currency with the format options.",
    "NoDateFieldNames": "Cannot determine the locale date field names. Please load the locale dateFields data."
};

var formatRegExp$2 = /\{(\d+)}?\}/g;

var IntlError = function IntlError(ref) {
    var name = ref.name;
    var message = ref.message;

    if (!name || !message) {
        throw new Error("{ name: string, message: string } object is required!");
    }

    this.name = name;
    this.message = message;
};

IntlError.prototype.formatMessage = function formatMessage () {
        var values = [], len = arguments.length;
        while ( len-- ) values[ len ] = arguments[ len ];

    var flattenValues = flatten(values);

    var formattedMessage = this.message.replace(formatRegExp$2, function(match, index) {
        return flattenValues[parseInt(index, 10)];
    });

    return ((this.name) + ": " + formattedMessage);
};

IntlError.prototype.error = function error () {
        var values = [], len = arguments.length;
        while ( len-- ) values[ len ] = arguments[ len ];

    return new Error(this.formatMessage(values));
};

var flatten = function(arr) {
    return arr.reduce(function (a, b) { return a.concat(b); }, []);
};

var toIntlErrors = function(errors) {
    var predicate = function(prev, name) {
        prev[name] = new IntlError({ name: name, message: errors[name] });
        return prev;
    };

    return Object.keys(errors).reduce(predicate, {});
};

var errors = toIntlErrors(errorDetails);

function availableLocaleInfo(fullName, suffixes) {
    var parts = fullName.split("-");
    var language = parts[0];
    var script = parts[1];
    var territory = parts[2];

    return cldr[fullName] || (suffixes.indexOf(territory) !== -1 && cldr[language + "-" + territory]) || (suffixes.indexOf(script) !== -1 && cldr[language + "-" + script]) || cldr[language];
}

function localeFullName(language, suffixes) {
    var likelySubtags = cldr.supplemental.likelySubtags;

    for (var idx = 0; idx < suffixes.length; idx++) {
        var name = likelySubtags[language + "-" + suffixes[idx ]];
        if (name) {
            return name;
        }
    }

    if (likelySubtags[language]) {
        return likelySubtags[language];
    }
}

var cldr = defaultData;

function getLocaleInfo(locale) {
    var info;
    if (isString$1(locale)) {
        info = localeInfo(locale);
    } else {
        info = locale;
    }
    return info;
}

function localeInfo(locale) {
    if (cldr[locale]) {
        return cldr[locale];
    }

    var likelySubtags = cldr.supplemental.likelySubtags;
    if (likelySubtags) {
        var parts = locale.split("-");
        var language = parts[0];
        var suffixes = parts.slice(1);
        var fullName = localeFullName(language, suffixes);
        var info = fullName ? availableLocaleInfo(fullName, suffixes) : null;
        if (info) {
            return info;
        }
    }

    throw errors.NoLocale.error(locale);
}

var DECIMAL = "decimal";
var CURRENCY = "currency";
var ACCOUNTING = "accounting";
var PERCENT = "percent";
var SCIENTIFIC = "scientific";

var CURRENCY_PLACEHOLDER = "$";
var PERCENT_PLACEHOLDER = "%";
var NUMBER_PLACEHOLDER = "n";

var LIST_SEPARATOR = ";";
var GROUP_SEPARATOR = ",";

var POINT = ".";
var EMPTY = "";

var DEFAULT_LOCALE = "en";

function territoryFromName(name, identity) {
    var likelySubtags = cldr.supplemental.likelySubtags;
    var parts = name.split("-");
    if (likelySubtags) {
        var likelyName = likelySubtags[name] || likelySubtags[parts[0]];
        if (likelyName) {
            parts = likelyName.split("-");
        }
    }

    if (identity) {
        for (var idx = parts.length - 1; idx >= 1; idx--) {
            var part = parts[idx];
            if (part === identity.variant || part === identity.script) {
                parts.splice(idx, 1);
            }
        }
    }

    var length = parts.length;

    if (length > 1) {
        var territory = parts[length - 1];
        return territory.toUpperCase();
    }
}

function localeTerritory(info) {
    if (info.territory) {
        return info.territory;
    }

    var name = info.name;
    var identity = info.identity;
    var territory;

    if (identity && identity.territory) {
        territory = identity.territory;
    } else {
        territory = territoryFromName(name, identity);
    }

    info.territory = territory;

    return territory;
}

function dateFieldName(options, locale) {
    if ( locale === void 0 ) locale = DEFAULT_LOCALE;

    var info = localeInfo(locale);
    var dateFields = info.calendar.dateFields;
    if (!dateFields) {
        throw errors.NoDateFieldNames.error();
    }

    var fieldNameInfo = dateFields[options.type] || {};

    return fieldNameInfo[options.nameType] || fieldNameInfo['wide'];
}

function lowerArray(arr) {
    var result = [];
    for (var idx = 0; idx < arr.length; idx++) {
        result.push(arr[idx].toLowerCase());
    }
    return result;
}

function lowerObject(obj) {
    var result = {};
    for (var field in obj) {
        result[field] = obj[field].toLowerCase();
    }
    return result;
}

function cloneLower(obj) {
    var result = Array.isArray(obj) ? lowerArray(obj) : lowerObject(obj);
    return result;
}

function dateFormatNames(locale, options) {
    var type = options.type;
    var nameType = options.nameType;
    var standAlone = options.standAlone;
    var lower = options.lower;
    var info = getLocaleInfo(locale);
    var formatType = standAlone ? "stand-alone" : "format";
    var lowerNameType = (lower ? "lower-" : EMPTY) + nameType;
    var formatNames = info.calendar[type][formatType];
    var result = formatNames[lowerNameType];
    if (!result && lower) {
        result = formatNames[lowerNameType] = cloneLower(formatNames[nameType]);
    }
    return result;
}

function parseRangeDate(value) {
    var parts = value.split('-');
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1;
    var day = parseInt(parts[2], 10);

    return new Date(year, month, day);
}

/* eslint-disable consistent-return */

var NoCurrency = errors.NoCurrency;
var NoCurrencyDisplay = errors.NoCurrencyDisplay;
var NoSupplementalCurrency = errors.NoSupplementalCurrency;
var NoCurrencyRegion = errors.NoCurrencyRegion;
var NoValidCurrency = errors.NoValidCurrency;

var DEFAULT_CURRENCY_FRACTIONS = 2;
var SYMBOL = "symbol";
var INVALID_CURRENCY_CODE = 'XXX';

var GLOBAL_CURRENCIES = {
    '001': 'USD', // 001 refers to world. not sure if it is correct to assume USD but seems better than throw an error
    '150': 'EUR' // 150 territory for Europe

};

function getCurrencyInfo(locale, currency, throwIfNoValid) {
    var info = getLocaleInfo(locale);
    var currencies = info.numbers.currencies;
    if (!currencies) {
        if (throwIfNoValid) {
            throw NoCurrency.error();
        }

        return;
    }

    var currencyDisplayInfo = currencies[currency];

    if (!currencyDisplayInfo) {
        if (throwIfNoValid) {
            throw NoCurrencyDisplay.error();
        }

        return;
    }

    return currencyDisplayInfo;
}

function lengthComparer(a, b) {
    return b.length - a.length;
}

function regionCurrency(regionCurrencies) {
    var latestValidUntil, latestValidUntilRange;
    var latestStillValid, latestStillValidDate;

    for (var idx = 0; idx < regionCurrencies.length; idx++) {
        var currency = regionCurrencies[idx];
        var code = Object.keys(currency)[0];
        var info = currency[code];
        if (code !== INVALID_CURRENCY_CODE && info._tender !== 'false' && info._from) {
            if (!info._to) {
                var stillValidDate = parseRangeDate(info._from);
                if (!latestStillValidDate || latestStillValidDate < stillValidDate) {
                    latestStillValid = code;
                    latestStillValidDate = stillValidDate;
                }
            } else if (!latestStillValid) {
                var validFrom = parseRangeDate(info._from);
                var validTo = parseRangeDate(info._to);
                if (!latestValidUntilRange || latestValidUntilRange.to < validTo || latestValidUntilRange.from < validFrom) {
                    latestValidUntil = code;
                    latestValidUntilRange = {
                        from: validFrom,
                        to: validTo
                    };
                }
            }
        }
    }

    return latestStillValid || latestValidUntil;
}

function currencyDisplays(locale, currency, throwIfNoValid) {
    if ( throwIfNoValid === void 0 ) throwIfNoValid = true;

    var currencyInfo = getCurrencyInfo(locale, currency, throwIfNoValid);
    if (!currencyInfo) {
        return;
    }

    if (!currencyInfo.displays) {
        var displays = [ currency ];
        for (var field in currencyInfo) {
            displays.push(currencyInfo[field]);
        }
        displays.sort(lengthComparer);
        currencyInfo.displays = displays;
    }

    return currencyInfo.displays;
}

function currencyDisplay(locale, options) {
    var value = options.value;
    var currency = options.currency;
    var currencyDisplay = options.currencyDisplay; if ( currencyDisplay === void 0 ) currencyDisplay = SYMBOL;

    if (currencyDisplay === "code") {
        return currency;
    }

    var currencyInfo = getCurrencyInfo(locale, currency, true);
    var result;

    if (currencyDisplay === SYMBOL) {
        result = currencyInfo["symbol-alt-narrow"] || currencyInfo[SYMBOL];
    } else {
        if (typeof value === "undefined" || value !== 1) {
            result = currencyInfo["displayName-count-other"];
        } else {
            result = currencyInfo["displayName-count-one"];
        }
    }

    return result;
}

function currencyFractionOptions(code) {
    var minimumFractionDigits = DEFAULT_CURRENCY_FRACTIONS;
    var maximumFractionDigits = DEFAULT_CURRENCY_FRACTIONS;

    var fractions = ((cldr.supplemental.currencyData || {}).fractions || {})[code];

    if (fractions && fractions._digits) {
        maximumFractionDigits = minimumFractionDigits = parseInt(fractions._digits, 10);
    }

    return {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
    };
}

function territoryCurrencyCode(territory, throwIfNoValid) {
    if ( throwIfNoValid === void 0 ) throwIfNoValid = true;

    if (GLOBAL_CURRENCIES[territory]) {
        return GLOBAL_CURRENCIES[territory];
    }

    var currencyData = cldr.supplemental.currencyData;
    if (!currencyData) {
        if (throwIfNoValid) {
            throw NoSupplementalCurrency.error();
        }

        return;
    }

    var regionCurrencies = currencyData.region[territory];

    if (!regionCurrencies) {
        if (throwIfNoValid) {
            throw NoCurrencyRegion.error(territory);
        }

        return;
    }

    var currencyCode = regionCurrency(regionCurrencies);

    return currencyCode;
}

function localeCurrency(locale, throwIfNoValid) {
    var info = getLocaleInfo(locale);
    var numbers = info.numbers;

    if (!numbers.localeCurrency) {
        var currency = territoryCurrencyCode(localeTerritory(info), throwIfNoValid);

        if (!currency && throwIfNoValid) {
            throw NoValidCurrency.error(info.name);
        }

        numbers.localeCurrency = currency;
    }

    return numbers.localeCurrency;
}

var DAYS_OF_WEEK = [ "sun", "mon", "tue", "wed", "thu", "fri", "sat" ];

var DEFAULT_TERRITORY = '001';

var NoWeekData = errors.NoWeekData;
var NoFirstDay = errors.NoFirstDay;

function firstDay(locale) {
    var info = getLocaleInfo(locale);

    if (!isNaN(info.firstDay)) {
        return info.firstDay;
    }

    var weekData = cldr.supplemental.weekData;
    if (!weekData) {
        throw NoWeekData.error();
    }

    var firstDay = weekData.firstDay[localeTerritory(info)] || weekData.firstDay[DEFAULT_TERRITORY];

    if (!firstDay) {
        throw NoFirstDay.error();
    }

    info.firstDay = DAYS_OF_WEEK.indexOf(firstDay);

    return info.firstDay;
}

errors.NoWeekData;

function numberSymbols(locale) {
    var info = getLocaleInfo(locale);

    return info.numbers.symbols;
}

function isNegativeZero(value) {
    return (1 / value === -Infinity);
}

function formatCurrencySymbol(info, options) {
    if ( options === void 0 ) options = {};

    if (!options.currency) {
        options.currency = localeCurrency(info, true);
    }

    var display = currencyDisplay(info, options);

    return display;
}

function groupInteger(number, start, end, options, info) {
    var symbols = info.numbers.symbols;
    var decimalIndex = number.indexOf(symbols.decimal);
    var groupSizes = options.groupSize.slice();
    var groupSize = groupSizes.shift();

    var integerEnd = decimalIndex !== -1 ? decimalIndex : end + 1;

    var integer = number.substring(start, integerEnd);
    var result = number;
    var integerLength = integer.length;

    if (integerLength >= groupSize) {
        var idx = integerLength;
        var parts = [];

        while (idx > -1) {
            var value = integer.substring(idx - groupSize, idx);
            if (value) {
                parts.push(value);
            }
            idx -= groupSize;
            var newGroupSize = groupSizes.shift();
            groupSize = newGroupSize !== undefined ? newGroupSize : groupSize;

            if (groupSize === 0) {
                value = integer.substring(0, idx);
                if (value) {
                    parts.push(value);
                }
                break;
            }
        }

        integer = parts.reverse().join(symbols.group);
        result = number.substring(0, start) + integer + number.substring(integerEnd);
    }

    return result;
}

function isCurrencyStyle(style) {
    return style === CURRENCY || style === ACCOUNTING;
}

function pad(number, digits, right) {
    if ( digits === void 0 ) digits = 2;
    if ( right === void 0 ) right = false;

    var count = digits - String(number).length;
    var result = number;

    if (count > 0) {
        var padString = new Array(count + 1).join("0");
        result = right ? number + padString : padString + number;
    }

    return result;
}

var MAX_PRECISION$1 = 20;

function round(value, precision) {
    var result = value;
    var decimals = precision || 0;

    result = result.toString().split('e');
    result = Math.round(Number(result[0] + 'e' + (result[1] ? (Number(result[1]) + decimals) : decimals)));

    result = result.toString().split('e');
    result = Number(result[0] + 'e' + (result[1] ? (Number(result[1]) - decimals) : -decimals));

    return result.toFixed(Math.min(decimals, MAX_PRECISION$1));
}

var DEFAULT_DECIMAL_ROUNDING = 3;
var DEFAULT_PERCENT_ROUNDING = 0;

var trailingZeroRegex = /0+$/;

function fractionOptions(options) {
    var minimumFractionDigits = options.minimumFractionDigits;
    var maximumFractionDigits = options.maximumFractionDigits;
    var style = options.style;
    var isCurrency = isCurrencyStyle(style);
    var currencyFractions;
    if (isCurrency) {
        currencyFractions = currencyFractionOptions(options.currency);
    }

    if (minimumFractionDigits === undefined) {
        minimumFractionDigits = isCurrency ? currencyFractions.minimumFractionDigits : 0;
    }

    if (maximumFractionDigits === undefined) {
        if (style === PERCENT) {
            maximumFractionDigits = Math.max(minimumFractionDigits, DEFAULT_PERCENT_ROUNDING);
        } else if (isCurrency) {
            maximumFractionDigits = Math.max(minimumFractionDigits, currencyFractions.maximumFractionDigits);
        } else {
            maximumFractionDigits = Math.max(minimumFractionDigits, DEFAULT_DECIMAL_ROUNDING);
        }
    }

    return {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
    };
}

function applyPattern(value, pattern, symbol) {
    var result = EMPTY;
    for (var idx = 0, length = pattern.length; idx < length; idx++) {
        var ch = pattern.charAt(idx);

        if (ch === NUMBER_PLACEHOLDER) {
            result += value;
        } else if (ch === CURRENCY_PLACEHOLDER || ch === PERCENT_PLACEHOLDER) {
            result += symbol;
        } else {
            result += ch;
        }
    }
    return result;
}

function currencyUnitPattern(info, value) {
    var currencyInfo = info.numbers.currency;
    var pattern = value !== 1 ? currencyInfo["unitPattern-count-other"] : currencyInfo["unitPattern-count-one"];
    if (value < 0) {
        pattern = pattern.replace(NUMBER_PLACEHOLDER, ("-" + NUMBER_PLACEHOLDER));
    }

    return pattern;
}


function standardNumberFormat(number, options, info) {
    var symbols = info.numbers.symbols;
    var style = options.style;
    var isCurrency = isCurrencyStyle(style);

    //return number in exponential format
    if (style === SCIENTIFIC) {
        var exponential = options.minimumFractionDigits !== undefined ? number.toExponential(options.minimumFractionDigits) : number.toExponential();
        return exponential.replace(POINT, symbols.decimal);
    }

    var value = number;
    var symbol;

    if (isCurrency) {
        options.value = value;
        symbol = formatCurrencySymbol(info, options);
    }

    if (style === PERCENT) {
        value *= 100;
        symbol = symbols.percentSign;
    }

    var ref = fractionOptions(options);
    var minimumFractionDigits = ref.minimumFractionDigits;
    var maximumFractionDigits = ref.maximumFractionDigits;

    value = round(value, maximumFractionDigits);

    var negative = value < 0;
    var negativeZero = isNegativeZero(number);

    var parts = value.split(POINT);

    var integer = parts[0];
    var fraction = pad(parts[1] ? parts[1].replace(trailingZeroRegex, EMPTY) : EMPTY, minimumFractionDigits, true);

    //exclude "-" if number is negative.
    if (negative) {
        integer = integer.substring(1);
    }

    if (options.minimumIntegerDigits) {
        integer = pad(integer, options.minimumIntegerDigits);
    }

    var formattedValue = options.useGrouping !== false ? groupInteger(integer, 0, integer.length, options, info) : integer;

    if (fraction) {
        formattedValue += symbols.decimal + fraction;
    }

    var pattern;

    if (isCurrency && options.currencyDisplay === "name") {
        pattern = currencyUnitPattern(info, number);
    } else {
        var patterns = options.patterns;
        pattern = (negative || negativeZero) ? patterns[1] || ("-" + patterns[0]) : patterns[0];
    }

    if (pattern === NUMBER_PLACEHOLDER && !negative) {
        return formattedValue;
    }

    var result = applyPattern(formattedValue, pattern, symbol);

    return result;
}

var literalRegExp = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g;
var PLACEHOLDER$1 = "__??__";

function setStyleOptions(formatOptions, info) {
    var format = formatOptions.format;

    //multiply number if the format has percent
    if (format.indexOf(PERCENT_PLACEHOLDER) !== -1) {
        formatOptions.style = PERCENT;
        formatOptions.symbol = info.numbers.symbols.percentSign;
        formatOptions.number *= 100;
    }

    if (format.indexOf(CURRENCY_PLACEHOLDER) !== -1) {
        formatOptions.style = CURRENCY;
        formatOptions.symbol = formatCurrencySymbol(info);
    }
}

function setFormatLiterals(formatOptions) {
    var format = formatOptions.format;
    if (format.indexOf("'") > -1 || format.indexOf("\"") > -1 || format.indexOf("\\") > -1) {
        var literals = formatOptions.literals = [];
        formatOptions.format = format.replace(literalRegExp, function(match) {
            var quoteChar = match.charAt(0).replace("\\", EMPTY);
            var literal = match.slice(1).replace(quoteChar, EMPTY);

            literals.push(literal);

            return PLACEHOLDER$1;
        });
    }
}

function replaceLiterals(number, literals) {
    var result = number;
    if (literals) {
        var length = literals.length;
        for (var idx = 0; idx < length; idx++) {
            result = result.replace(PLACEHOLDER$1, literals[idx]);
        }
    }
    return result;
}

var SHARP = "#";
var ZERO = "0";

var trailingZerosRegExp = /(\.(?:[0-9]*[1-9])?)0+$/g;
var trailingPointRegExp = /\.$/;
var commaRegExp = /,/g;

function trimTrailingZeros(value, lastZero) {
    var trimRegex;

    if (lastZero === 0) {
        trimRegex = trailingZerosRegExp;
    } else {
        trimRegex = new RegExp(("(\\.[0-9]{" + lastZero + "}[1-9]*)0+$"), 'g');
    }

    return value.replace(trimRegex, '$1').replace(trailingPointRegExp, EMPTY);
}

function roundNumber(formatOptions) {
    var number = formatOptions.number;
    var format = formatOptions.format;
    var decimalIndex = format.indexOf(POINT);

    if (decimalIndex !== -1) {
        var zeroIndex = format.lastIndexOf(ZERO) - decimalIndex;
        var sharpIndex = format.lastIndexOf(SHARP) - decimalIndex;
        var hasZero = zeroIndex > -1;
        var hasSharp = sharpIndex > -1;
        var fraction = number.toString().split("e");

        if (fraction[1]) {
            fraction = round(number, Math.abs(fraction[1]));
        } else {
            fraction = fraction[0];
        }
        fraction = fraction.split(POINT)[1] || EMPTY;

        var precision = fraction.length;
        var trailingZeros = -1;

        if (!hasZero && !hasSharp) {
            formatOptions.format = format.substring(0, decimalIndex) + format.substring(decimalIndex + 1);
            decimalIndex = -1;
            precision = 0;
        } else if (hasZero && zeroIndex > sharpIndex) {
            precision = zeroIndex;
        } else if (sharpIndex > zeroIndex) {
            if (hasSharp && precision > sharpIndex) {
                precision = sharpIndex;
            } else if (hasZero && precision < zeroIndex) {
                precision = zeroIndex;
            }

            trailingZeros = hasZero ? zeroIndex : 0;
        }

        if (precision > -1) {
            number = round(number, precision);
            if (trailingZeros > -1) {
                number = trimTrailingZeros(number, trailingZeros);
            }
        }
    } else {
        number = round(number);
    }

    if (formatOptions.negative && (number * -1) >= 0 && !formatOptions.negativeZero) {
        formatOptions.negative = false;
    }

    formatOptions.number = number;
    formatOptions.decimalIndex = decimalIndex;
}

function isConstantFormat(format) {
    return format.indexOf(SHARP) === -1 && format.indexOf(ZERO) === -1;
}

function setValueSpecificFormat(formatOptions) {
    var number = formatOptions.number;
    var format = formatOptions.format;
    format = format.split(LIST_SEPARATOR);
    if ((formatOptions.negative || formatOptions.negativeZero) && format[1]) {
        format = format[1];
        formatOptions.hasNegativeFormat = true;
    } else if (number === 0) {
        var zeroFormat = format[2];
        format = zeroFormat || format[0];
        if (zeroFormat && isConstantFormat(zeroFormat)) {
            formatOptions.constant = zeroFormat;
        }
    } else {
        format = format[0];
    }

    formatOptions.format = format;
}

function setGroupOptions(formatOptions) {
    formatOptions.hasGroup = formatOptions.format.indexOf(GROUP_SEPARATOR) > -1;
    if (formatOptions.hasGroup) {
        formatOptions.format = formatOptions.format.replace(commaRegExp, EMPTY);
    }
}

function placeholderIndex(index1, index2, start) {
    var index;
    if (index1 === -1 && index2 !== -1) {
        index = index2;
    } else if (index1 !== -1 && index2 === -1) {
        index = index1;
    } else {
        index = start ? Math.min(index1, index2) : Math.max(index1, index2);
    }
    return index;
}

function setPlaceholderIndices(formatOptions) {
    var format = formatOptions.format;
    var sharpIndex = format.indexOf(SHARP);
    var zeroIndex = format.indexOf(ZERO);

    var start = placeholderIndex(sharpIndex, zeroIndex, true);

    sharpIndex = format.lastIndexOf(SHARP);
    zeroIndex = format.lastIndexOf(ZERO);

    var end = placeholderIndex(sharpIndex, zeroIndex);

    if (start === format.length) {
        end = start;
    }

    formatOptions.start = start;
    formatOptions.end = end;
    formatOptions.lastZeroIndex = zeroIndex;
}

function replaceStyleSymbols(number, style, symbol) {
    var result = number;
    if (style === CURRENCY || style === PERCENT) {
        result = EMPTY;
        for (var idx = 0, length = number.length; idx < length; idx++) {
            var ch = number.charAt(idx);
            result += (ch === CURRENCY_PLACEHOLDER || ch === PERCENT_PLACEHOLDER) ? symbol : ch;
        }
    }
    return result;
}

function replacePlaceHolders(formatOptions, info) {
    var start = formatOptions.start;
    var end = formatOptions.end;
    var negative = formatOptions.negative;
    var negativeZero = formatOptions.negativeZero;
    var format = formatOptions.format;
    var decimalIndex = formatOptions.decimalIndex;
    var lastZeroIndex = formatOptions.lastZeroIndex;
    var hasNegativeFormat = formatOptions.hasNegativeFormat;
    var hasGroup = formatOptions.hasGroup;
    var number = formatOptions.number;
    var value = number.toString().split(POINT);
    var length = format.length;
    var integer = value[0];
    var fraction = value[1] || EMPTY;
    var integerLength = integer.length;
    var replacement = EMPTY;

    number = format.substring(0, start);

    if ((negative || negativeZero) && !hasNegativeFormat) {
        number += "-";
    }

    for (var idx = start; idx < length; idx++) {
        var ch = format.charAt(idx);

        if (decimalIndex === -1) {
            if (end - idx < integerLength) {

                number += integer;
                break;
            }
        } else {
            if (lastZeroIndex !== -1 && lastZeroIndex < idx) {
                replacement = EMPTY;
            }

            if ((decimalIndex - idx) <= integerLength && decimalIndex - idx > -1) {
                number += integer;
                idx = decimalIndex;
            }

            if (decimalIndex === idx) {
                number += (fraction ? info.numbers.symbols.decimal : EMPTY) + fraction;
                idx += end - decimalIndex + 1;
                continue;
            }
        }

        if (ch === ZERO) {
            number += ch;
            replacement = ch;
        } else if (ch === SHARP) {
            number += replacement;
        }
    }

    if (hasGroup) {
        number = groupInteger(number, start + (negative && !hasNegativeFormat ? 1 : 0), Math.max(end, (integerLength + start)), info.numbers.decimal, info);
    }

    if (end >= start) {
        number += format.substring(end + 1);
    }

    return number;
}

function applyCustomFormat(formatOptions, info) {
    var number = formatOptions.number;
    if (formatOptions.start !== -1) {
        number = replacePlaceHolders(formatOptions, info);
        number = replaceStyleSymbols(number, formatOptions.style, formatOptions.symbol);
        number = replaceLiterals(number, formatOptions.literals);
    }

    return number;
}

function customNumberFormat(number, format, info) {
    var formatOptions = {
        negative: number < 0,
        number: Math.abs(number),
        negativeZero: isNegativeZero(number),
        format: format
    };

    setValueSpecificFormat(formatOptions);

    if (formatOptions.constant) {
        return formatOptions.constant;
    }

    setFormatLiterals(formatOptions);
    setStyleOptions(formatOptions, info);
    setGroupOptions(formatOptions);
    roundNumber(formatOptions);
    setPlaceholderIndices(formatOptions);

    return applyCustomFormat(formatOptions, info);
}

var standardFormatRegExp = /^(n|c|p|e|a)(\d*)$/i;

function standardFormatOptions(format) {
    var formatAndPrecision = standardFormatRegExp.exec(format);

    if (formatAndPrecision) {
        var options = {
            style: DECIMAL
        };

        var style = formatAndPrecision[1].toLowerCase();

        if (style === "c") {
            options.style = CURRENCY;
        } else if (style === "a") {
            options.style = ACCOUNTING;
        } else if (style === "p") {
            options.style = PERCENT;
        } else if (style === "e") {
            options.style = SCIENTIFIC;
        }

        if (formatAndPrecision[2]) {
            options.minimumFractionDigits = options.maximumFractionDigits = parseInt(formatAndPrecision[2], 10);
        }

        return options;
    }
}

function formatOptions(format) {
    var options;
    if (isString$1(format)) {
        options = standardFormatOptions(format);
    } else {
        options = format;
    }

    return options;
}

function formatNumber(number, format, locale) {
    if ( format === void 0 ) format = NUMBER_PLACEHOLDER;
    if ( locale === void 0 ) locale = DEFAULT_LOCALE;

    if (number === undefined || number === null) {
        return EMPTY;
    }

    if (!isFinite(number)) {
        return String(number);
    }

    var info = localeInfo(locale);
    var options = formatOptions(format);

    var result;
    if (options) {
        var style = options.style || DECIMAL;
        result = standardNumberFormat(number, Object.assign({}, info.numbers[style], options), info);
    } else {
        result = customNumberFormat(number, format, info);
    }

    return result;
}

function isNumber(value) {
    return typeof value === "number";
}

var exponentRegExp = /[eE][-+]?[0-9]+/;
var nonBreakingSpaceRegExp = /\u00A0/g;

function cleanNegativePattern(number, patterns) {
    if (patterns.length > 1) {
        var parts = (patterns[1] || EMPTY).replace(CURRENCY_PLACEHOLDER, EMPTY).split(NUMBER_PLACEHOLDER);
        if (number.indexOf(parts[0]) > -1 && number.indexOf(parts[1]) > -1) {
            return number.replace(parts[0], EMPTY).replace(parts[1], EMPTY);
        }
    }
}

function cleanCurrencyNumber(value, info, format) {
    var options = formatOptions(format) || {};
    var isCurrency = isCurrencyStyle(options.style);
    var number = value;
    var negative;

    var currency = options.currency || localeCurrency(info, isCurrency);

    if (currency) {
        var displays = currencyDisplays(info, currency, isCurrency);
        if (displays) {
            for (var idx = 0; idx < displays.length; idx++) {
                var display = displays[idx];
                if (number.includes(display)) {
                    number = number.replace(display, EMPTY);
                    isCurrency = true;
                    break;
                }
            }
        }

        if (isCurrency) {
            var cleanNumber = cleanNegativePattern(number, info.numbers.currency.patterns) ||
                cleanNegativePattern(number, info.numbers.accounting.patterns);

            if (cleanNumber) {
                negative = true;
                number = cleanNumber;
            }

        }
    }

    return {
        number: number,
        negative: negative
    };
}

function cleanLiterals(number, formatOptions) {
    var literals = formatOptions.literals;
    var result = number;

    if (literals) {
        for (var idx = 0; idx < literals.length; idx++) {
            result = result.replace(literals[idx], EMPTY);
        }
    }

    return result;
}

function divideBy100(number) {
    var strNumber = String(number);
    var pointIndex = strNumber.indexOf(POINT);
    var zeroesCount = 2;
    var result = number / Math.pow(10, zeroesCount);

    if (pointIndex === -1 || String(result).length <= strNumber.length + zeroesCount) {
        return result;
    }

    var fractionDigits = strNumber.length - pointIndex + 1 + zeroesCount;
    return parseFloat(result.toFixed(fractionDigits));
}

function parseNumber(value, locale, format) {
    if ( locale === void 0 ) locale = DEFAULT_LOCALE;
    if ( format === void 0 ) format = {};

    if (!value && value !== 0) {
        return null;
    }

    if (isNumber(value)) {
        return value;
    }

    var info = localeInfo(locale);
    var symbols = info.numbers.symbols;

    var number = value.toString();
    var formatOptions = format || {};
    var isPercent;

    if (isString$1(format)) {
        formatOptions = { format: format };
        setFormatLiterals(formatOptions);
        number = cleanLiterals(number, formatOptions);

        setStyleOptions(formatOptions, info);
    }

    if (formatOptions.style === PERCENT || number.indexOf(symbols.percentSign) > -1) {
        number = number.replace(symbols.percentSign, EMPTY);
        isPercent = true;
    }

    if (exponentRegExp.test(number)) {
        number = parseFloat(number.replace(symbols.decimal, POINT));
        return isNaN(number) ? null : number;
    }

    var ref = cleanCurrencyNumber(number, info, formatOptions);
    var negativeCurrency = ref.negative;
    var currencyNumber = ref.number;
    number = String(currencyNumber).trim();

    var negativeSignIndex = number.indexOf("-");
    if (negativeSignIndex > 0) {
        return null;
    }

    var isNegative = negativeSignIndex > -1;

    isNegative = negativeCurrency !== undefined ? negativeCurrency : isNegative;

    number = number.replace("-", EMPTY)
          .replace(nonBreakingSpaceRegExp, " ")
          .split(symbols.group.replace(nonBreakingSpaceRegExp, " ")).join(EMPTY)
          .replace(symbols.decimal, POINT);

    number = parseFloat(number);

    if (isNaN(number)) {
        number = null;
    } else if (isNegative) {
        number *= -1;
    }

    if (number && isPercent) {
        number = divideBy100(number);
    }

    return number;
}

var formatRegExp$1 = /\{(\d+)}/g;

function formatString(format) {
    var values = arguments;

    return format.replace(formatRegExp$1, function (match, index) {
        var value = values[parseInt(index, 10) + 1];

        return value;
    });
}

var REMOVAL_PENALTY = 120;
var ADDITION_PENALTY = 20;
var LENGHT_DELTA = [ 2, 1, 5, 3, 4 ];
var LONG_LESS_PENALTY_DELTA = -2;
var SHORT_LESS_PENALTY_DELTA = -1;
var SHORT_MORE_PENALTY_DELTA = 1;
var LONG_MORE_PENALTY_DELTA = 2;

var PENALTIES = {};
PENALTIES[LONG_LESS_PENALTY_DELTA.toString()] = 8;
PENALTIES[SHORT_LESS_PENALTY_DELTA.toString()] = 6;
PENALTIES[LONG_MORE_PENALTY_DELTA.toString()] = 6;
PENALTIES[SHORT_MORE_PENALTY_DELTA.toString()] = 3;

var VALUE_FORMAT_LENGTH = {
    numeric: 1,
    "2-digit": 2,
    short: 3,
    long: 4,
    narrow: 5
};

var TIME_SPECIFIERS_REGEX = /[hHmsSzZoOvVxX]/;

function getHourSpecifier(options) {
    return options.hour12 ? "h" : "H";
}

var DATE_OPTIONS_MAP = [ {
    key: "era",
    specifier: "G"
}, {
    key: "year",
    specifier: "y"
}, {
    key: "month",
    specifier: "M"
}, {
    key: "day",
    specifier: "d"
}, {
    key: "weekday",
    specifier: "E"
}, {
    key: "hour",
    getSpecifier: getHourSpecifier
}, {
    key: "minute",
    specifier: "m"
}, {
    key: "second",
    specifier: "s"
}, {
    key: "timeZoneName",
    specifier: "z"
} ];

var STAND_ALONE_SPECIFIERS = {
    e: 'c',
    E: 'c',
    M: 'L',
    Q: 'q'
};

var specifiersRegex = {};
var resolvedFormats = {};

function getSpecifierRegex(specifier) {
    if (!specifiersRegex[specifier]) {
        specifiersRegex[specifier] = new RegExp(specifier + "+");
    }
    return specifiersRegex[specifier];
}

function skeletonSpecifiers(skeleton) {
    var result = [];
    var current = skeleton.charAt(0);
    var specifier = current;
    for (var idx = 1; idx < skeleton.length; idx++) {
        var character = skeleton.charAt(idx);
        if (character === specifier) {
            current += character;
        } else {
            result.push(current);
            current = specifier = character;
        }
    }

    result.push(current);

    return result;
}

function findBestMatch(specifiers, availableFormats) {
    var specifiersLength = specifiers.length;
    var maxScore = -Number.MAX_VALUE;
    var bestMatches, result;
    for (var format in availableFormats) {
        var matches = [];
        var currentFormat = format.replace("v", "z");
        var score = 0;
        for (var idx = 0; idx < specifiersLength; idx++) {
            var specifier = specifiers[idx];
            var specifierRegex = getSpecifierRegex(specifier[0]);
            var match = (specifierRegex.exec(currentFormat) || [])[0];

            if (!match) {
                score -= REMOVAL_PENALTY;
            } else {
                currentFormat = currentFormat.replace(match, EMPTY);
                if (match.length !== specifier.length) {
                    var delta = Math.max(Math.min(LENGHT_DELTA[match.length] - LENGHT_DELTA[specifier.length], 2), -2);
                    score -= PENALTIES[delta];
                }
            }

            matches.push(match);

            if (score < maxScore) {
                break;
            }
        }

        if (currentFormat.length) {
            score -= skeletonSpecifiers(currentFormat).length * ADDITION_PENALTY;
        }

        if (score > maxScore) {
            maxScore = score;
            bestMatches = matches;
            result = availableFormats[format];
        }
    }

    result = result.replace("v", "z");

    for (var idx$1 = 0; idx$1 < specifiersLength; idx$1++) {
        var bestMatch = bestMatches[idx$1];
        if (bestMatch && bestMatch !== specifiers[idx$1]) {
            var matchSpecifier = bestMatches[idx$1][0];
            result = result.replace(getSpecifierRegex(matchSpecifier), specifiers[idx$1]);
            if (STAND_ALONE_SPECIFIERS[matchSpecifier]) {
                result = result.replace(getSpecifierRegex(STAND_ALONE_SPECIFIERS[matchSpecifier]), specifiers[idx$1]);
            }
        }
    }

    return result;
}

function cacheFormat(skeleton, format, locale) {
    if (!resolvedFormats[locale]) {
        resolvedFormats[locale] = {};
    }
    resolvedFormats[locale][skeleton] = format;
}


function skeletonFormat(skeleton, info) {
    var availableFormats = info.calendar.dateTimeFormats.availableFormats;
    if (availableFormats[skeleton]) {
        return availableFormats[skeleton];
    }
    if (resolvedFormats[info.name] && resolvedFormats[info.name][skeleton]) {
        return resolvedFormats[info.name][skeleton];
    }
    var timeStartIndex = skeleton.search(TIME_SPECIFIERS_REGEX);
    var result;
    if (timeStartIndex > 0) {
        var dateSkeleton = skeleton.substr(0, timeStartIndex);
        var timeSkeleton = skeleton.substr(timeStartIndex);

        result = formatString(info.calendar.dateTimeFormats.short, //should be deterimed based on specifiers
            availableFormats[timeSkeleton] || findBestMatch(skeletonSpecifiers(timeSkeleton), availableFormats),
            availableFormats[dateSkeleton] || findBestMatch(skeletonSpecifiers(dateSkeleton), availableFormats));
    } else {
        result = findBestMatch(skeletonSpecifiers(skeleton), availableFormats);
    }

    cacheFormat(skeleton, result, info.name);
    return result;
}

function skeletonFromOptions(options) {
    var result = [];
    for (var idx = 0; idx < DATE_OPTIONS_MAP.length; idx++) {
        var option = DATE_OPTIONS_MAP[idx];
        var field = option.key;
        var value = options[field];
        if (value) {
            var spcifier = option.specifier || option.getSpecifier(options);
            result.push(spcifier.repeat(VALUE_FORMAT_LENGTH[value]));
        }
    }

    return result.join(EMPTY);
}

function datePattern(format, info) {
    var calendar = info.calendar;
    var result;
    if (isString$1(format)) {
        if (calendar.patterns[format]) {
            result = calendar.patterns[format];
        } else {
            result = format;
        }
    } else if (format) {
        if (format.pattern) {
            return format.pattern;
        }

        var skeleton = format.skeleton;
        if (!skeleton) {
            if (format.datetime) {
                result = formatString(calendar.dateTimeFormats[format.datetime], calendar.timeFormats[format.datetime], calendar.dateFormats[format.datetime]);
            } else if (format.date) {
                result = calendar.dateFormats[format.date];
            } else if (format.time) {
                result = calendar.timeFormats[format.time];
            } else {
                skeleton = skeletonFromOptions(format);
            }
        }

        if (skeleton) {
            result = skeletonFormat(skeleton, info);
        }
    }

    if (!result) {
        result = calendar.patterns.d;
    }

    return result;
}

function dateNameType(formatLength) {
    var nameType;
    if (formatLength <= 3) {
        nameType = "abbreviated";
    } else if (formatLength === 4) {
        nameType = "wide";
    } else if (formatLength === 5) {
        nameType = "narrow";
    } else if (formatLength === 6) {
        nameType = "short";
    }

    return nameType;
}

function formatNames(locale, type, formatLength, standAlone, lower) {
    return dateFormatNames(locale, {
        type: type,
        nameType: dateNameType(formatLength),
        standAlone: standAlone,
        lower: lower
    });
}

function isFunction$1(fun) {
    return typeof(fun) === 'function';
}

function isDate$1(value) {
    return Boolean(value) && isFunction$1(value.getTime) && isFunction$1(value.getMonth);
}

var MONTH = 'month';
var HOUR = 'hour';
var ZONE = 'zone';
var WEEKDAY = 'weekday';
var QUARTER = 'quarter';

var DATE_FIELD_MAP = {
    'G': 'era',
    'y': 'year',
    'q': QUARTER,
    'Q': QUARTER,
    'M': MONTH,
    'L': MONTH,
    'd': 'day',
    'E': WEEKDAY,
    'c': WEEKDAY,
    'e': WEEKDAY,
    'h': HOUR,
    'H': HOUR,
    'k': HOUR,
    'K': HOUR,
    'm': 'minute',
    's': 'second',
    'S': 'millisecond',
    'a': 'dayperiod',
    'x': ZONE,
    'X': ZONE,
    'z': ZONE,
    'Z': ZONE
};

var dateFormatRegExp = /d{1,2}|E{1,6}|e{1,6}|c{3,6}|c{1}|M{1,5}|L{1,5}|y{1,4}|H{1,2}|h{1,2}|k{1,2}|K{1,2}|m{1,2}|a{1,5}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|x{1,5}|X{1,5}|G{1,5}|q{1,5}|Q{1,5}|"[^"]*"|'[^']*'/g;

function formatDayOfWeekIndex(day, formatLength, localeInfo) {
    var firstDayIndex = firstDay(localeInfo);
    var dayIndex;
    if (day < firstDayIndex) {
        dayIndex = 7 - firstDayIndex + day;
    } else {
        dayIndex = day - firstDayIndex;
    }

    return dayIndex + 1;
}

function formatMonth(month, formatLength, info, standAlone) {
    if (formatLength <= 2) {
        return pad(month + 1, formatLength);
    }
    return formatNames(info, "months", formatLength, standAlone)[month];
}

function formatQuarter(date, formatLength, info, standAlone) {
    var quarter = Math.floor(date.getMonth() / 3);
    if (formatLength < 3) {
        return quarter + 1;
    }

    return formatNames(info, "quarters", formatLength, standAlone)[quarter];
}


function formatTimeZone(date, info, options) {
    var shortHours = options.shortHours;
    var optionalMinutes = options.optionalMinutes;
    var separator = options.separator;
    var localizedName = options.localizedName;
    var zZeroOffset = options.zZeroOffset;
    var offset = date.getTimezoneOffset() / 60;
    if (offset === 0 && zZeroOffset) {
        return "Z";
    }
    var sign = offset <= 0 ? "+" : "-";
    var hoursMinutes = Math.abs(offset).toString().split(".");
    var minutes = hoursMinutes[1] || 0;
    var result = sign + (shortHours ? hoursMinutes[0] : pad(hoursMinutes[0], 2));
    if (minutes || !optionalMinutes) {
        result += (separator ? ":" : EMPTY) + pad(minutes, 2);
    }

    if (localizedName) {
        var localizedFormat = offset === 0 ? info.calendar.gmtZeroFormat : info.calendar.gmtFormat;
        result = formatString(localizedFormat, result);
    }

    return result;
}

function formatDayOfWeek(date, formatLength, info, standAlone) {
    var result;
    if (formatLength < 3) {
        result = formatDayOfWeekIndex(date.getDay(), formatLength, info);
    } else {
        result = formatNames(info, "days", formatLength, standAlone)[date.getDay()];
    }
    return result;
}

var formatters = {};

formatters.d = function(date, formatLength) {
    return pad(date.getDate(), formatLength);
};

formatters.E = function(date, formatLength, info) {
    return formatNames(info, "days", formatLength)[date.getDay()];
};

formatters.M = function(date, formatLength, info) {
    return formatMonth(date.getMonth(), formatLength, info, false);
};

formatters.L = function(date, formatLength, info) {
    return formatMonth(date.getMonth(), formatLength, info, true);
};

formatters.y = function(date, formatLength) {
    var year = date.getFullYear();
    if (formatLength === 2) {
        year = year % 100;
    }
    return pad(year, formatLength);
};

formatters.h = function(date, formatLength) {
    var hours = date.getHours() % 12 || 12;
    return pad(hours, formatLength);
};

formatters.H = function(date, formatLength) {
    return pad(date.getHours(), formatLength);
};

formatters.k = function(date, formatLength) {
    return pad(date.getHours() || 24, formatLength);
};

formatters.K = function(date, formatLength) {
    return pad(date.getHours() % 12, formatLength);
};

formatters.m = function(date, formatLength) {
    return pad(date.getMinutes(), formatLength);
};

formatters.s = function(date, formatLength) {
    return pad(date.getSeconds(), formatLength);
};

formatters.S = function(date, formatLength) {
    var milliseconds = date.getMilliseconds();
    var result;
    if (milliseconds !== 0) {
        result = pad(String(milliseconds / 1000).split(".")[1].substr(0, formatLength), formatLength, true);
    } else {
        result = pad(EMPTY, formatLength);
    }
    return result;
};

formatters.a = function(date, formatLength, info) {
    return formatNames(info, "dayPeriods", formatLength)[date.getHours() < 12 ? "am" : "pm"];
};

formatters.z = function(date, formatLength, info) {
    return formatTimeZone(date, info, {
        shortHours: formatLength < 4,
        optionalMinutes: formatLength < 4,
        separator: true,
        localizedName: true
    });
};

formatters.Z = function(date, formatLength, info) {
    return formatTimeZone(date, info, {
        separator: formatLength > 3,
        localizedName: formatLength === 4,
        zZeroOffset: formatLength === 5
    });
};

formatters.x = function(date, formatLength, info) {
    return formatTimeZone(date, info, {
        optionalMinutes: formatLength === 1,
        separator: formatLength === 3 || formatLength === 5
    });
};

formatters.X = function(date, formatLength, info) {
    return formatTimeZone(date, info, {
        optionalMinutes: formatLength === 1,
        separator: formatLength === 3 || formatLength === 5,
        zZeroOffset: true
    });
};

formatters.G = function(date, formatLength, info) {
    var era = date.getFullYear() >= 0 ? 1 : 0;
    return formatNames(info, "eras", formatLength)[era];
};

formatters.e = formatDayOfWeek;

formatters.c = function(date, formatLength, info) {
    return formatDayOfWeek(date, formatLength, info, true);
};

formatters.q = function(date, formatLength, info) {
    return formatQuarter(date, formatLength, info, true);
};

formatters.Q = formatQuarter;

function formatDate$1(date, format, locale) {
    if ( locale === void 0 ) locale = DEFAULT_LOCALE;

    if (!isDate$1(date)) {
        if (date === undefined || date === null) {
            return EMPTY;
        }
        return date;
    }

    var info = localeInfo(locale);
    var pattern = datePattern(format, info);

    return pattern.replace(dateFormatRegExp, function(match) {
        var formatLength = match.length;
        var result;

        if (match.includes("'") || match.includes("\"")) {
            result = match.slice(1, formatLength - 1);
        } else {
            result = formatters[match[0]](date, formatLength, info);
        }

        return result;
    });
}

function convertTimeZone(date, fromOffset, toOffset) {
    var fromLocalOffset = date.getTimezoneOffset();

    var offsetDate = new Date(date.getTime() + (fromOffset - toOffset) * 60000);

    var toLocalOffset = offsetDate.getTimezoneOffset();

    return new Date(offsetDate.getTime() + (toLocalOffset - fromLocalOffset) * 60000);
}

function adjustDST$1(date, hours) {
    if (!hours && date.getHours() === 23) {
        date.setHours(date.getHours() + 2);
    }
}

var timeZoneOffsetRegExp = /([+|-]\d{1,2})(:?)(\d{2})?/;
var dateRegExp$1 = /^\/Date\((.*?)\)\/$/;
var offsetRegExp = /[+-]\d*/;
var numberRegExp = {
    2: /^\d{1,2}/,
    3: /^\d{1,3}/,
    4: /^\d{4}/
};
var numberRegex = /\d+/;
var PLACEHOLDER = "{0}";

var leadingSpacesRegex = /^ */;
var trailingSpacesRegex = / *$/;

var standardDateFormats = [
    "yyyy/MM/dd HH:mm:ss",
    "yyyy/MM/dd HH:mm",
    "yyyy/MM/dd",
    "E MMM dd yyyy HH:mm:ss",
    "yyyy-MM-ddTHH:mm:ss.SSSSSSSXXX",
    "yyyy-MM-ddTHH:mm:ss.SSSXXX",
    "yyyy-MM-ddTHH:mm:ss.SSXXX",
    "yyyy-MM-ddTHH:mm:ssXXX",
    "yyyy-MM-ddTHH:mm:ss.SSSSSSS",
    "yyyy-MM-ddTHH:mm:ss.SSS",
    "yyyy-MM-ddTHH:mmXXX",
    "yyyy-MM-ddTHH:mmX",
    "yyyy-MM-ddTHH:mm:ss",
    "yyyy-MM-ddTHH:mm",
    "yyyy-MM-dd HH:mm:ss",
    "yyyy-MM-dd HH:mm",
    "yyyy-MM-dd",
    "HH:mm:ss",
    "HH:mm"
];
var FORMATS_SEQUENCE = [ "G", "g", "F", "Y", "y", "M", "m", "D", "d", "y", "T", "t" ];
var TWO_DIGIT_YEAR_MAX = 2029;

function outOfRange(value, start, end) {
    return !(value >= start && value <= end);
}

function lookAhead(match, state) {
    var format = state.format;
    var idx = state.idx;
    var i = 0;
    while (format[idx] === match) {
        i++;
        idx++;
    }
    if (i > 0) {
        idx -= 1;
    }
    state.idx = idx;
    return i;
}

function getNumber(size, state) {
    var regex = size ? (numberRegExp[size] || new RegExp('^\\d{1,' + size + '}')) : numberRegex,
        match = state.value.substr(state.valueIdx, size).match(regex);

    if (match) {
        match = match[0];
        state.valueIdx += match.length;
        return parseInt(match, 10);
    }
    return null;
}

function getIndexByName(names, state, lower) {
    var i = 0,
        length = names.length,
        name, nameLength,
        matchLength = 0,
        matchIdx = 0,
        subValue;

    for (; i < length; i++) {
        name = names[i];
        nameLength = name.length;
        subValue = state.value.substr(state.valueIdx, nameLength);

        if (lower) {
            subValue = subValue.toLowerCase();
        }

        if (subValue === name && nameLength > matchLength) {
            matchLength = nameLength;
            matchIdx = i;
        }
    }

    if (matchLength) {
        state.valueIdx += matchLength;
        return matchIdx + 1;
    }

    return null;
}

function checkLiteral(state) {
    var result = false;
    if (state.value.charAt(state.valueIdx) === state.format[state.idx]) {
        state.valueIdx++;
        result = true;
    }
    return result;
}

function calendarGmtFormats(calendar) {
    var gmtFormat = calendar.gmtFormat;
    var gmtZeroFormat = calendar.gmtZeroFormat;
    if (!gmtFormat) {
        throw errors.NoGMTInfo.error();
    }

    return [ gmtFormat.replace(PLACEHOLDER, EMPTY).toLowerCase(), gmtZeroFormat.replace(PLACEHOLDER, EMPTY).toLowerCase() ];
}

function parseTimeZoneOffset(state, info, options) {
    var shortHours = options.shortHours;
    var noSeparator = options.noSeparator;
    var optionalMinutes = options.optionalMinutes;
    var localizedName = options.localizedName;
    var zLiteral = options.zLiteral;
    state.UTC = true;

    if (zLiteral && state.value.charAt(state.valueIdx) === "Z") {
        state.valueIdx++;
        return false;
    }

    if (localizedName && !getIndexByName(calendarGmtFormats(info.calendar), state, true)) {
        return true;
    }

    var matches = timeZoneOffsetRegExp.exec(state.value.substr(state.valueIdx, 6));
    if (!matches) {
        return !localizedName;
    }

    var hoursMatch = matches[1];
    var minutesMatch = matches[3];
    var hoursOffset = parseInt(hoursMatch, 10);
    var separator = matches[2];
    var minutesOffset = parseInt(minutesMatch, 10);

    if (isNaN(hoursOffset) || (!shortHours && hoursMatch.length !== 3) || (!optionalMinutes && isNaN(minutesOffset)) || (noSeparator && separator)) {
        return true;
    }

    if (isNaN(minutesOffset)) {
        minutesOffset = null;
    }

    if (outOfRange(hoursOffset, -12, 13) || (minutesOffset && outOfRange(minutesOffset, 0, 59))) {
        return true;
    }

    state.valueIdx += matches[0].length;
    state.hoursOffset = hoursOffset;
    state.minutesOffset = minutesOffset;
}

function parseMonth(ch, state, info) {
    var count = lookAhead(ch, state);
    var names = formatNames(info, "months", count, ch === "L", true);

    var month = count < 3 ? getNumber(2, state) : getIndexByName(names, state, true);

    if (month === null || outOfRange(month, 1, 12)) {
        return true;
    }
    state.month = month - 1;
}

function parseDayOfWeek(ch, state, info) {
    var count = lookAhead(ch, state);
    var names = formatNames(info, "days", count, ch === "c", true);
    var dayOfWeek = count < 3 ? getNumber(1, state) : getIndexByName(names, state, true);
    if ((!dayOfWeek && dayOfWeek !== 0) || outOfRange(dayOfWeek, 1, 7)) {
        return true;
    }
}

var parsers = {};

parsers.d = function(state) {
    lookAhead("d", state);
    var day = getNumber(2, state);

    if (day === null || outOfRange(day, 1, 31)) {
        return true;
    }

    if (state.day === null) {
        state.day = day;
    }
};

parsers.E = function(state, info) {
    var count = lookAhead("E", state);
    //validate if it matches the day?
    var dayOfWeek = getIndexByName(formatNames(info, "days", count, false, true), state, true);
    if (dayOfWeek === null) {
        return true;
    }
};

parsers.M = function(state, info) {
    return parseMonth("M", state, info);
};

parsers.L = function(state, info) {
    return parseMonth("L", state, info);
};

parsers.y = function(state) {
    var count = lookAhead("y", state);
    var year = getNumber(count === 1 ? undefined : count, state);

    if (year === null) {
        return true;
    }

    if (count === 2) {
        var currentYear = new Date().getFullYear();
        year = (currentYear - currentYear % 100) + year;
        if (year > TWO_DIGIT_YEAR_MAX) {
            year -= 100;
        }
    }

    state.year = year;
};

parsers.h = function(state) {
    lookAhead("h", state);

    var hours = getNumber(2, state);
    if (hours === 12) {
        hours = 0;
    }

    if (hours === null || outOfRange(hours, 0, 11)) {
        return true;
    }

    state.hours = hours;
};

parsers.K = function(state) {
    lookAhead("K", state);

    var hours = getNumber(2, state);

    if (hours === null || outOfRange(hours, 0, 11)) {
        return true;
    }

    state.hours = hours;
};

parsers.a = function(state, info) {
    var count = lookAhead("a", state);
    var periodFormats = formatNames(info, "dayPeriods", count, false, true);

    var pmHour = getIndexByName([ periodFormats.pm ], state, true);
    if (!pmHour && !getIndexByName([ periodFormats.am ], state, true)) {
        return true;
    }

    state.pmHour = pmHour;
};

parsers.H = function(state) {
    lookAhead("H", state);
    var hours = getNumber(2, state);
    if (hours === null || outOfRange(hours, 0, 23)) {
        return true;
    }
    state.hours = hours;
};

parsers.k = function(state) {
    lookAhead("k", state);

    var hours = getNumber(2, state);

    if (hours === null || outOfRange(hours, 1, 24)) {
        return true;
    }

    state.hours = hours === 24 ? 0 : hours;
};

parsers.m = function(state) {
    lookAhead("m", state);
    var minutes = getNumber(2, state);

    if (minutes === null || outOfRange(minutes, 0, 59)) {
        return true;
    }

    state.minutes = minutes;
};

parsers.s = function(state) {
    lookAhead("s", state);
    var seconds = getNumber(2, state);
    if (seconds === null || outOfRange(seconds, 0, 59)) {
        return true;
    }
    state.seconds = seconds;
};

parsers.S = function(state) {
    var count = lookAhead("S", state);
    var match = state.value.substr(state.valueIdx, count);
    var milliseconds = null;

    if (!isNaN(parseInt(match, 10))) {
        milliseconds = parseFloat("0." + match, 10);
        milliseconds = round(milliseconds, 3);
        milliseconds *= 1000;
        state.valueIdx += count;
    }

    if (milliseconds === null || outOfRange(milliseconds, 0, 999)) {
        return true;
    }

    state.milliseconds = milliseconds;
};

parsers.z = function(state, info) {
    var count = lookAhead("z", state);

    var shortFormat = count < 4;

    var invalid = parseTimeZoneOffset(state, info, {
        shortHours: shortFormat,
        optionalMinutes: shortFormat,
        localizedName: true
    });

    if (invalid) {
        return invalid;
    }
};

parsers.Z = function(state, info) {
    var count = lookAhead("Z", state);

    var invalid = parseTimeZoneOffset(state, info, {
        noSeparator: count < 4,
        zLiteral: count === 5,
        localizedName: count === 4
    });

    if (invalid) {
        return invalid;
    }
};

parsers.x = function(state, info) {
    var count = lookAhead("x", state);

    var invalid = parseTimeZoneOffset(state, info, {
        noSeparator: count !== 3 && count !== 5,
        optionalMinutes: count === 1
    });
    if (invalid) {
        return invalid;
    }
};

parsers.X = function(state, info) {
    var count = lookAhead("X", state);

    var invalid = parseTimeZoneOffset(state, info, {
        noSeparator: count !== 3 && count !== 5,
        optionalMinutes: count === 1,
        zLiteral: true
    });
    if (invalid) {
        return invalid;
    }
};

parsers.G = function(state, info) {
    var count = lookAhead("G", state);
    var eras = formatNames(info, "eras", count, false, true);
    var era = getIndexByName([ eras[0], eras[1] ], state, true);

    if (era === null) {
        return true;
    }
};

parsers.e = function(state, info) {
    return parseDayOfWeek("e", state, info);
};

parsers.c = function(state, info) {
    return parseDayOfWeek("c", state, info);
};

function createDate$1(state) {
    var year = state.year;
    var month = state.month;
    var day = state.day;
    var hours = state.hours;
    var minutes = state.minutes;
    var seconds = state.seconds;
    var milliseconds = state.milliseconds;
    var pmHour = state.pmHour;
    var UTC = state.UTC;
    var hoursOffset = state.hoursOffset;
    var minutesOffset = state.minutesOffset;
    var hasTime = hours !== null || minutes !== null || seconds || null;
    var date = new Date();
    var result;

    if (year === null && month === null && day === null && hasTime) {
        year = date.getFullYear();
        month = date.getMonth();
        day = date.getDate();
    } else {
        if (year === null) {
            year = date.getFullYear();
        }

        if (day === null) {
            day = 1;
        }
    }

    if (pmHour && hours < 12) {
        hours += 12;
    }

    if (UTC) {
        if (hoursOffset) {
            hours += -hoursOffset;
        }

        if (minutesOffset) {
            minutes += -minutesOffset * (hoursOffset < 0 ? -1 : 1);
        }

        result = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
    } else {
        result = new Date(year, month, day, hours, minutes, seconds, milliseconds);
        adjustDST$1(result, hours);
    }

    if (year < 100) {
        result.setFullYear(year);
    }

    if (result.getDate() !== day && UTC === undefined) {
        return null;
    }

    return result;
}

function addFormatSpaces(value, format) {
    var leadingSpaces = leadingSpacesRegex.exec(format)[0];
    var trailingSpaces = trailingSpacesRegex.exec(format)[0];

    return ("" + leadingSpaces + value + trailingSpaces);
}

function parseExact(value, format, info) {
    var pattern = datePattern(format, info).split(EMPTY);

    var state = {
        format: pattern,
        idx: 0,
        value: addFormatSpaces(value, format),
        valueIdx: 0,
        year: null,
        month: null,
        day: null,
        hours: null,
        minutes: null,
        seconds: null,
        milliseconds: null
    };
    var length = pattern.length;
    var literal = false;

    for (; state.idx < length; state.idx++) {
        var ch = pattern[state.idx];

        if (literal) {
            if (ch === "'") {
                literal = false;
            }

            checkLiteral(state);
        } else {
            if (parsers[ch]) {
                var invalid = parsers[ch](state, info);
                if (invalid) {
                    return null;
                }
            } else if (ch === "'") {
                literal = true;
                checkLiteral(state);
            } else if (!checkLiteral(state)) {
                return null;
            }
        }
    }

    if (state.valueIdx < value.length) {
        return null;
    }

    return createDate$1(state) || null;
}

function parseMicrosoftDateOffset(offset) {
    var sign = offset.substr(0, 1) === "-" ? -1 : 1;

    var result = offset.substring(1);
    result = (parseInt(result.substr(0, 2), 10) * 60) + parseInt(result.substring(2), 10);

    return sign * result;
}

function parseMicrosoftDateFormat(value) {
    if (value && value.indexOf("/D") === 0) {
        var date = dateRegExp$1.exec(value);
        if (date) {
            date = date[1];
            var tzoffset = offsetRegExp.exec(date.substring(1));

            date = new Date(parseInt(date, 10));

            if (tzoffset) {
                tzoffset = parseMicrosoftDateOffset(tzoffset[0]);
                date = convertTimeZone(date, date.getTimezoneOffset(), 0);
                date = convertTimeZone(date, 0, -1 * tzoffset);
            }

            return date;
        }
    }
}

function defaultFormats(calendar) {
    var formats = [];
    var patterns = calendar.patterns;
    var length = FORMATS_SEQUENCE.length;

    for (var idx = 0; idx < length; idx++) {
        formats.push(patterns[FORMATS_SEQUENCE[idx]]);
    }

    return formats.concat(standardDateFormats);
}

function parseDate(value, formats, locale) {
    if ( locale === void 0 ) locale = DEFAULT_LOCALE;

    if (!value) {
        return null;
    }

    if (isDate$1(value)) {
        return value;
    }

    var parseValue = String(value).trim();
    var date = parseMicrosoftDateFormat(parseValue);
    if (date) {
        return date;
    }

    var info = localeInfo(locale);
    var parseFormats = formats || defaultFormats(info.calendar);
    parseFormats = Array.isArray(parseFormats) ? parseFormats : [ parseFormats ];

    var length = parseFormats.length;

    for (var idx = 0; idx < length; idx++) {
        date = parseExact(parseValue, parseFormats[idx], info);
        if (date) {
            return date;
        }
    }

    return date;
}

var NAME_TYPES = {
    month: {
        type: 'months',
        minLength: 3,
        standAlone: 'L'
    },

    quarter: {
        type: 'quarters',
        minLength: 3,
        standAlone: 'q'
    },

    weekday: {
        type: 'days',
        minLength: {
            E: 0,
            c: 3,
            e: 3
        },
        standAlone: 'c'
    },

    dayperiod: {
        type: 'dayPeriods',
        minLength: 0
    },

    era: {
        type: 'eras',
        minLength: 0
    }
};

var LITERAL = 'literal';

function addLiteral(parts, value) {
    var lastPart = parts[parts.length - 1];
    if (lastPart && lastPart.type === LITERAL) {
        lastPart.pattern += value;
    } else {
        parts.push({
            type: LITERAL,
            pattern: value
        });
    }
}

function isHour12(pattern) {
    return pattern === 'h' || pattern === 'K';
}

function splitDateFormat(format, locale) {
    if ( locale === void 0 ) locale = DEFAULT_LOCALE;

    var info = localeInfo(locale);
    var pattern = datePattern(format, info);
    var parts = [];
    var lastIndex = dateFormatRegExp.lastIndex = 0;
    var match = dateFormatRegExp.exec(pattern);

    while (match) {
        var value = match[0];

        if (lastIndex < match.index) {
            addLiteral(parts, pattern.substring(lastIndex, match.index));
        }

        if (value.startsWith('"') || value.startsWith("'")) {
            addLiteral(parts, value);
        } else {
            var specifier = value[0];
            var type = DATE_FIELD_MAP[specifier];
            var part = {
                type: type,
                pattern: value
            };

            if (type === 'hour') {
                part.hour12 = isHour12(value);
            }

            var names = NAME_TYPES[type];

            if (names) {
                var minLength = isNumber(names.minLength) ? names.minLength : names.minLength[specifier];
                var patternLength = value.length;

                if (patternLength >= minLength) {
                    part.names = {
                        type: names.type,
                        nameType: dateNameType(patternLength),
                        standAlone: names.standAlone === specifier
                    };
                }
            }

            parts.push(part);
        }

        lastIndex = dateFormatRegExp.lastIndex;
        match = dateFormatRegExp.exec(pattern);
    }

    if (lastIndex < pattern.length) {
        addLiteral(parts, pattern.substring(lastIndex));
    }

    return parts;
}

var formatRegExp = /\{(\d+)(:[^}]+)?\}/g;

function toString(value, format, locale) {
    if (format) {
        if (isDate$1(value)) {
            return formatDate$1(value, format, locale);
        } else if (isNumber(value)) {
            return formatNumber(value, format, locale);
        }
    }

    return value !== undefined && value !== null ? value : EMPTY;
}

function format(format, values, locale) {
    return format.replace(formatRegExp, function(match, index, placeholderFormat) {
        var value = values[parseInt(index, 10)];

        return toString(value, placeholderFormat ? placeholderFormat.substring(1) : EMPTY, locale);
    });
}

/**
 * @hidden
 */
var packageMetadata$c = {
    name: '@progress/kendo-react-intl',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770489,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

/* eslint-disable max-len */
/**
 * A service which provides internationalization methods and is bound to a specific locale.
 */
var IntlService = /** @class */ (function () {
    /**
     * Creates a new instance of the internationalization service.
     *
     * @param locale - The locale that will be used by the internationalization methods.
     */
    function IntlService(locale) {
        this.locale = locale;
        if (typeof licensing !== 'undefined') {
            validatePackage$4(packageMetadata$c);
        }
        else {
            var message = "License activation failed for ".concat(packageMetadata$c.name, "\n");
            message += 'The @progress/kendo-licensing script is not loaded.\n';
            message += "See ".concat(packageMetadata$c.licensingDocsUrl, " for more information.\n");
            console.warn(message);
        }
        if (locale === '' && process.env.NODE_ENV !== 'production') {
            throw 'Locale should not be empty string';
        }
    }
    /**
     * Formats a string with placeholders such as `Total amount {0:c}`.
     *
     * @param format - The format string.
     * @param values - One or more values to output in the format string placeholders.
     * @return - The formatted string.
     */
    IntlService.prototype.format = function (format$1) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        /* The following code retains backward compatibility with the old API */
        if (values.length === 1 && Array.isArray(values[0])) {
            return format(format$1, values[0], this.locale);
        }
        return format(format$1, values, this.locale);
    };
    /**
     * Converts a `Date` object to a string based on the specified format. If no format is provided, the default short date format is used.
     *
     * @param value - The date which will be formatted.
     * @param format - The format string or options.
     * @return - The formatted date.
     */
    IntlService.prototype.formatDate = function (value, format) {
        return formatDate$1(value, format, this.locale);
    };
    /**
     * Converts an object to a string based on the specified format.
     *
     * @param value - The value which will be formatted.
     * @param format - The format to use.
     * @return - The formatted object.
     */
    IntlService.prototype.toString = function (value, format) {
        return toString(value, format, this.locale);
    };
    /**
     * Converts a string to a `Number`.
     *
     * @param value - The string which will be parsed.
     * @param format - The format string or options.
     * @return - The parsed number.
     */
    IntlService.prototype.parseNumber = function (value, format) {
        return parseNumber(value, this.locale, format);
    };
    /**
     * Converts a string to a `Date` object based on the specified format.
     *
     * @param value - The string which will be converted.
     * @param format - The format strings or options.
     * @return - The parsed date.
     */
    IntlService.prototype.parseDate = function (value, format) {
        return parseDate(value, format, this.locale);
    };
    /**
     * Converts a `Number` to a string based on the specified format.
     *
     * @param value - The number which will be formatted.
     * @param format - The format string or options.
     * @return - The formatted number.
     */
    IntlService.prototype.formatNumber = function (value, format) {
        return formatNumber(value, format, this.locale);
    };
    /**
     * Returns a localized date field name based on specific `dateFieldName` options.
     *
     * @param options - The detailed configuration for the desired date field name.
     * @returns - The localized date field name from the current locale based on the option.
     */
    IntlService.prototype.dateFieldName = function (options) {
        return dateFieldName(options, this.locale);
    };
    /**
     * Returns the day names from the current locale based on the option.
     *
     * @param options - The detailed configuration for the desired date format.
     * @return - The day names from the current locale based on the option.
     */
    IntlService.prototype.dateFormatNames = function (options) {
        return dateFormatNames(this.locale, options);
    };
    /**
     * Splits the date format into objects which contain information about each part of the pattern.
     *
     * @param format - The format string or options.
     * @returns - The date format parts.
     */
    IntlService.prototype.splitDateFormat = function (format) {
        return splitDateFormat(format, this.locale);
    };
    /**
     * Returns the number symbols from the current locale.
     *
     * @return - The number symbols from the current locale.
     */
    IntlService.prototype.numberSymbols = function () {
        return numberSymbols(this.locale);
    };
    /**
     * Returns the first day index, starting from Sunday.
     *
     * @return - The index of the first day of the week (0 == Sunday).
     */
    IntlService.prototype.firstDay = function () {
        return firstDay(this.locale);
    };
    return IntlService;
}());
// tslint:enable:max-line-length

/**
 * @hidden
 */
var messages$5 = Object.create({});

/**
 * A service which provides localization methods.
 */
var LocalizationService = /** @class */ (function () {
    function LocalizationService(language) {
        this.language = language;
        if (language === '' && process.env.NODE_ENV !== 'production') {
            throw 'Language should not be an empty string';
        }
    }
    /* eslint-disable max-len */
    /**
     * Provides a string based on a key for the current language. When no string for the current language is available under this key, the `defaultValue` is returned.
     *
     * @param key - The key which identifies the string for the current language.
     * @param defaultValue - The default value which will be returned when no string
     * for the current language is available under the key.
     * @return - The string for the current language.
     */
    // tslint:enable:max-line-length
    LocalizationService.prototype.toLanguageString = function (key, defaultValue) {
        if (this.language &&
            messages$5[this.language] &&
            messages$5[this.language].hasOwnProperty(key)) {
            return messages$5[this.language][key];
        }
        else {
            return defaultValue;
        }
    };
    return LocalizationService;
}());

/** @hidden */
var GlobalizationContext = React.createContext({
    intl: new IntlService('en'),
    localization: new LocalizationService()
});

/* eslint-disable max-len */
/**
 * Provides an internationalization service. When the passed component is a direct or indirect child of `IntlProvider`, the returned service uses the locale of the provider. Otherwise, uses `en` as a default locale. To handle locale changes, call the method on each `render`.
 *
 * @param componentClass - The React component class that will use the internationalization service.
 */
function provideIntlService(component) {
    if (!component && process.env.NODE_ENV !== 'production') {
        throw "Passed component - ".concat(component, " is invalid.");
    }
    var context = component.context;
    return context && context.intl
        ? context.intl
        : new IntlService('en');
}
/**
 * Provides a localization service. When the passed component is a direct or indirect child of `LocalizationProvider`, the returned service uses the language of the provider. To handle locale changes, call the method on each `render`.
 *
 * @param componentClass - The React component class that will use the internationalization service.
 */
function provideLocalizationService(component) {
    if (!component && process.env.NODE_ENV !== 'production') {
        throw "Passed component - ".concat(component, " is invalid.");
    }
    var context = component.context;
    return context && context.localization
        ? context.localization
        : new LocalizationService();
}
/**
 * A method which registers a component class or a functional stateless component for internationalization. When a component of that type is a direct or indirect child of `IntlProvider`, the locale of the provider is used. Otherwise, uses `en` as a default locale.
 *
 * @param component - The React component class that will use the internationalization methods.
 */
function registerForIntl(component) {
    component.contextType = GlobalizationContext;
}
/**
 * A method which registers a component class or a stateless functional component for localization. When a component of that type is a direct or indirect child of `LocalizationProvider`, the language of the provider is used.
 *
 * @param component - The React component class that will use the internationalization methods.
 */
function registerForLocalization(component) {
    component.contextType = GlobalizationContext;
}
// tslint:enable:max-line-length

/**
 * A custom [React Hook](https://reactjs.org/docs/hooks-intro.html) providing access to an [IntlService]({% slug api_intl_intlservice %}).
 */
var useInternationalization = function () { return React.useContext(GlobalizationContext).intl; };

/**
 * A custom [React Hook](https://reactjs.org/docs/hooks-intro.html) providing access to an [LocalizationService]({% slug api_intl_localizationservice %}).
 */
var useLocalization = function () { return React.useContext(GlobalizationContext).localization; };

var __extends$Y = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var dots = '...';
/**
 * @hidden
 */
var PagerNumericButtons = /** @class */ (function (_super) {
    __extends$Y(PagerNumericButtons, _super);
    function PagerNumericButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handlePageChange = function (e, page) {
            e.preventDefault();
            _this.props.pageChange(page, e);
        };
        _this.handleSelectPageChange = function (e) {
            e.preventDefault();
            _this.props.pageChange(e.target.value, e);
        };
        return _this;
    }
    PagerNumericButtons.prototype.render = function () {
        var _this = this;
        var localizationService = provideLocalizationService(this);
        var prevDots = this.start > 1 && this.renderDots(this.start - 1);
        var postDots = this.end < this.props.totalPages && this.renderDots(this.end + 1);
        var prevOptionDots = this.start > 1 && this.renderOptionDots(this.start - 1);
        var postOptionDots = this.end < this.props.totalPages && this.renderOptionDots(this.end + 1);
        var mobileSelectMessage = this.props.messagesMap ? this.props.messagesMap(pagerMobileSelect) :
            ({ messageKey: pagerMobileSelect, defaultMessage: messages$6[pagerMobileSelect] });
        var pageNumberLabelMessage = this.props.messagesMap ? this.props.messagesMap(pagerPageNumberLabel) :
            ({ messageKey: pagerPageNumberLabel, defaultMessage: messages$6[pagerPageNumberLabel] });
        var buttons = [];
        for (var idx = this.start; idx <= this.end; idx++) {
            buttons.push(idx);
        }
        var numerics = buttons.map(function (page) { return (React.createElement("li", { key: page },
            React.createElement("a", { role: "button", "aria-label": localizationService.toLanguageString(pageNumberLabelMessage.messageKey, pageNumberLabelMessage.defaultMessage) + ' ' + page, "aria-current": _this.props.currentPage === page ? true : undefined, href: "#", onClick: function (e) { return _this.handlePageChange(e, page); }, className: classNames$2('k-link', {
                    'k-selected': _this.props.currentPage === page
                }) }, page))); });
        var options = buttons.map(function (page) { return (React.createElement("option", { key: page, className: classNames$2('k-link') }, page)); });
        return (React.createElement("div", { className: "k-pager-numbers-wrap" },
            React.createElement("select", { className: "k-dropdown", "aria-label": localizationService.toLanguageString(mobileSelectMessage.messageKey, mobileSelectMessage.defaultMessage), value: this.props.currentPage, onChange: function (e) { return _this.handleSelectPageChange(e); } },
                prevOptionDots,
                options,
                postOptionDots),
            React.createElement("ul", { className: "k-pager-numbers" },
                prevDots,
                numerics,
                postDots)));
    };
    PagerNumericButtons.prototype.renderDots = function (page) {
        var _this = this;
        return (React.createElement("li", null,
            React.createElement("a", { className: "k-link", onClick: function (e) { return _this.handlePageChange(e, page); }, href: "#" }, dots)));
    };
    PagerNumericButtons.prototype.renderOptionDots = function (page) {
        return (React.createElement("option", { className: "k-link", value: page }, dots));
    };
    Object.defineProperty(PagerNumericButtons.prototype, "end", {
        get: function () {
            return Math.min((this.start + this.props.buttonCount) - 1, this.props.totalPages);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PagerNumericButtons.prototype, "start", {
        get: function () {
            var page = this.props.currentPage;
            var buttonCount = this.props.buttonCount;
            if (page > buttonCount) {
                var reminder = (page % buttonCount);
                return (reminder === 0) ? (page - buttonCount) + 1 : (page - reminder) + 1;
            }
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return PagerNumericButtons;
}(React.Component));

var __extends$X = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var PagerInput = /** @class */ (function (_super) {
    __extends$X(PagerInput, _super);
    function PagerInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._text = undefined;
        _this.onChange = function (e) {
            var text = _this._text = e.target.value.replace(/\D/g, '');
            _this.forceUpdate();
            if (text) {
                _this.props.pageChange(parseInt(text, 10), e);
            }
        };
        _this.value = function () {
            var value = _this._text === undefined ? _this.props.currentPage.toString() : _this._text;
            _this._text = undefined;
            return value;
        };
        return _this;
    }
    PagerInput.prototype.render = function () {
        var _this = this;
        var intlService = provideIntlService(this);
        var localizationService = provideLocalizationService(this);
        var pageMessage = this.props.messagesMap ? this.props.messagesMap(pagerPage$1) :
            ({ messageKey: pagerPage$1, defaultMessage: messages$6[pagerPage$1] });
        var ofMessage = this.props.messagesMap ? this.props.messagesMap(pagerOf$1) :
            ({ messageKey: pagerOf$1, defaultMessage: messages$6[pagerOf$1] });
        var totalPagesMessage = this.props.messagesMap ? this.props.messagesMap(pagerTotalPages$1) :
            ({ messageKey: pagerTotalPages$1, defaultMessage: messages$6[pagerTotalPages$1] });
        return (React.createElement("span", { className: "k-pager-input k-label" },
            localizationService.toLanguageString(pageMessage.messageKey, pageMessage.defaultMessage),
            React.createElement("span", { className: 'k-textbox k-input k-input-md k-rounded-md k-input-solid' },
                React.createElement("input", { className: "k-input-inner", value: this.value(), onBlur: function () { return _this.forceUpdate(); }, onChange: this.onChange })), "".concat(localizationService.toLanguageString(ofMessage.messageKey, ofMessage.defaultMessage), " ").concat(intlService
            .format(localizationService.toLanguageString(totalPagesMessage.messageKey, totalPagesMessage.defaultMessage), [
            this.props.totalPages
        ]))));
    };
    return PagerInput;
}(React.Component));
registerForLocalization(PagerInput);

var _a$b;
/**
 * @hidden
 */
var labelsOptional = 'labels.optional';
/**
 * @hidden
 */
var messages$4 = (_a$b = {},
    _a$b[labelsOptional] = '(Optional)',
    _a$b);

/**
 * @hidden
 */
var packageMetadata$b = {
    name: '@progress/kendo-react-labels',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770663,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$W = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Represents the KendoReact FloatingLabel component.
 *
 * @example
 * ```jsx
 * const sizes = ["X-Small", "Small", "Medium", "Large", "X-Large", "2X-Large"];
 * const App = () => {
 *     const [ddlState, setDdlState] = React.useState();
 *     const editorId = 'ddl-sizes';
 *     return (
 *         <FloatingLabel label={'Shirt Size:'} editorId={editorId} editorValue={ddlState}>
 *             <DropDownList
 *                 id={editorId}
 *                 value={ddlState}
 *                 data={sizes}
 *                 onChange={(e) => setDdlState(e.target.value)}
 *             />
 *         </FloatingLabel>
 *     );
 * };
 *
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var FloatingLabel = /** @class */ (function (_super) {
    __extends$W(FloatingLabel, _super);
    function FloatingLabel(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.state = {
            focused: false
        };
        /**
         * @hidden
         */
        _this.handleFocus = function (_) {
            _this.setState({ focused: true });
        };
        /**
         * @hidden
         */
        _this.handleBlur = function (_) {
            _this.setState({ focused: false });
        };
        validatePackage$2(packageMetadata$b);
        return _this;
    }
    /**
     * @hidden
     */
    FloatingLabel.prototype.render = function () {
        var _a = this.props, label = _a.label, editorId = _a.editorId, className = _a.className, editorValue = _a.editorValue, editorPlaceholder = _a.editorPlaceholder, editorValid = _a.editorValid, editorDisabled = _a.editorDisabled, style = _a.style, id = _a.id, optional = _a.optional;
        var localizationService = provideLocalizationService(this);
        var localizedOptional = optional ? localizationService
            .toLanguageString(labelsOptional, messages$4[labelsOptional]) : '';
        var optionalElement = localizedOptional && (React.createElement("span", { className: 'k-label-optional' }, localizedOptional));
        var spanClassNames = classNames$2({
            'k-floating-label-container': true,
            'k-focus': this.state.focused,
            'k-empty': !editorPlaceholder && !editorValue && (editorValue !== 0),
            'k-text-disabled': editorDisabled,
            'k-rtl': this.props.dir === 'rtl'
        }, className);
        var labelClassNames = classNames$2({
            'k-label': true,
            'k-text-error': editorValid === false,
            'k-text-disabled': editorDisabled
        });
        return (React.createElement("span", { id: this.props.id, className: spanClassNames, onFocus: this.handleFocus, onBlur: this.handleBlur, style: style, dir: this.props.dir },
            this.props.children,
            label
                ? editorId
                    ? React.createElement("label", { id: id, htmlFor: editorId, className: labelClassNames },
                        label,
                        optionalElement)
                    : React.createElement("span", { id: id, className: labelClassNames },
                        label,
                        optionalElement)
                : null));
    };
    /**
     * @hidden
     */
    FloatingLabel.propTypes = {
        label: propTypes.exports.string,
        editorId: propTypes.exports.string,
        editorValue: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.bool, propTypes.exports.number]),
        editorPlaceholder: propTypes.exports.string,
        editorValid: propTypes.exports.bool,
        editorDisabled: propTypes.exports.bool,
        id: propTypes.exports.string,
        style: propTypes.exports.object,
        className: propTypes.exports.string,
        optional: propTypes.exports.bool
    };
    return FloatingLabel;
}(React.Component));
registerForLocalization(FloatingLabel);

var clearSlide$1 = function (element) {
    element.style.transitionDuration = '';
    Array.from(element.classList).forEach(function (c) {
        if (c.startsWith('k-slide-')) {
            element.classList.remove(c);
        }
    });
};
var firefox$2 = typeof window !== 'undefined' &&
    /Firefox/.test(window.navigator.userAgent);
/**
 * @hidden
 */
var slide$1 = function (element, direction, duration, type, callback) {
    if (duration === 0) {
        return callback();
    }
    var slideClass = 'k-slide-' + direction + '-' + type;
    var slideActiveClass = slideClass + '-active';
    var transitionend = function (e) {
        // if event is attached using react,
        // the animation does not work well in firefox,
        // when the show/hide button is toggled quickly.
        if (e.target === element) {
            element.removeEventListener('transitionend', transitionend);
            clearSlide$1(element);
            if (type === 'exit') {
                element.style.display = 'none';
            }
            else {
                element.style.display = '';
            }
            callback();
        }
    };
    element.addEventListener('transitionend', transitionend);
    var ownerDocument = element.ownerDocument;
    if (!ownerDocument) {
        return;
    }
    var defaultView = ownerDocument.defaultView;
    if (!defaultView) {
        return;
    }
    var animate = function () {
        clearSlide$1(element);
        element.classList.add(slideClass);
        defaultView.requestAnimationFrame(function () {
            element.style.transitionDuration = duration + 'ms';
            element.classList.add(slideActiveClass);
        });
    };
    if (firefox$2) {
        defaultView.requestAnimationFrame(animate);
    }
    else {
        animate();
    }
};

var AlignPoint = {
    "bottom": "bottom",
    "center": "center",
    "middle": "middle",
    "left": "left",
    "right": "right",
    "top": "top"
};

var align = function (options) {
    var anchorRect = options.anchorRect;
    var anchorAlign = options.anchorAlign;
    var elementRect = options.elementRect;
    var elementAlign = options.elementAlign;
    var margin = options.margin; if ( margin === void 0 ) margin = {};
    var anchorHorizontal = anchorAlign.horizontal;
    var anchorVertical = anchorAlign.vertical;
    var elementHorizontal = elementAlign.horizontal;
    var elementVertical = elementAlign.vertical;

    var horizontalMargin = margin.horizontal || 0;
    var verticalMargin = margin.vertical || 0;

    var top = anchorRect.top;
    var left = anchorRect.left;

    if (anchorVertical === AlignPoint.bottom) {
        top += anchorRect.height;
    }

    if (anchorVertical === AlignPoint.center || anchorVertical === AlignPoint.middle) {
        top += Math.round(anchorRect.height / 2);
    }

    if (elementVertical === AlignPoint.bottom) {
        top -= elementRect.height;
        verticalMargin *= -1;
    }

    if (elementVertical === AlignPoint.center || elementVertical === AlignPoint.middle) {
        top -= Math.round(elementRect.height / 2);
        verticalMargin *= -1;
    }

    if (anchorHorizontal === AlignPoint.right) {
        left += anchorRect.width;
    }

    if (anchorHorizontal === AlignPoint.center || anchorHorizontal === AlignPoint.middle) {
        left += Math.round(anchorRect.width / 2);
    }

    if (elementHorizontal === AlignPoint.right) {
        left -= elementRect.width;
        horizontalMargin *= -1;
    }

    if (elementHorizontal === AlignPoint.center || elementHorizontal === AlignPoint.middle) {
        left -= Math.round(elementRect.width / 2);
        horizontalMargin *= -1;
    }

    return {
        top: top + verticalMargin,
        left: left + horizontalMargin
    };
};

function addScroll(rect, scroll) {
    return {
        top: rect.top + scroll.y,
        left: rect.left + scroll.x,
        height: rect.height,
        width: rect.width
    };
}

function ownerDocument(element) {
    return element.ownerDocument || element.document || element;
}

var getWindow$1 = function (element) { return ownerDocument(element).defaultView; };

var getDocument = function (element) { return ownerDocument(element).documentElement; };

var cachedWidth = 0;

function scrollbarWidth() {
    if (!cachedWidth && typeof document !== 'undefined') {
        var div = document.createElement("div");

        div.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block";
        div.innerHTML = "&nbsp;";
        document.body.appendChild(div);

        cachedWidth = div.offsetWidth - div.scrollWidth;

        document.body.removeChild(div);
    }

    return cachedWidth;
}

function windowViewport(element) {
    var win = getWindow$1(element);
    var document = getDocument(element);
    var result = {
        height: win.innerHeight,
        width: win.innerWidth
    };

    if (document.scrollHeight - document.clientHeight > 0) {
        result.width -= scrollbarWidth();
    }

    return result;
}

var boundingOffset = function (element) {
    if (!element.getBoundingClientRect) {
        var viewport = windowViewport(element);
        return {
            bottom: viewport.height,
            left: 0,
            right: viewport.width,
            top: 0
        };
    }

    var ref = element.getBoundingClientRect();
    var bottom = ref.bottom;
    var left = ref.left;
    var right = ref.right;
    var top = ref.top;

    return {
        bottom: bottom,
        left: left,
        right: right,
        top: top
    };
};

var offsetParent = function (element) {
    var offsetParent = element.offsetParent;

    while (offsetParent && offsetParent.style.position === "static") {
        offsetParent = offsetParent.offsetParent;
    }

    return offsetParent || getDocument(element);
};

var rectOfHiddenElement = function (element) {
    var ref = element.style;
    var display = ref.display;
    var left = ref.left;
    var position = ref.position;

    element.style.display = '';
    element.style.left = '-10000px';
    element.style.position = 'absolute';

    var rect = element.getBoundingClientRect();

    element.style.display = display;
    element.style.left = left;
    element.style.position = position;

    return rect;
};

var offset$1 = function (element) {
    var rect = element.getBoundingClientRect();
    var left = rect.left;
    var top = rect.top;

    if (!rect.height && !rect.width) {
        rect = rectOfHiddenElement(element);
    }

    return {
        top: top,
        left: left,
        height: rect.height,
        width: rect.width
    };
};

function parents (element, until) {
    var result = [];
    var next = element.parentNode;

    while (next) {
        result.push(next);

        if (next === until) { break; }

        next = next.parentNode;
    }

    return result;
}

function scrollPosition(element) {
    var documentElement = getDocument(element);
    var win = getWindow$1(element);

    return {
        x: win.pageXOffset || documentElement.scrollLeft || 0,
        y: win.pageYOffset || documentElement.scrollTop || 0
    };
}

function elementScrollPosition$1 (element) {
    if (element === (element.ownerDocument || {}).body) {
        return scrollPosition(element);
    }

    return {
        x: element.scrollLeft,
        y: element.scrollTop
    };
}

function parentScrollPosition(element) {
    var parent = offsetParent(element);

    return parent ? elementScrollPosition$1(parent) : { x: 0, y: 0 };
}

var position$1 = function (element, parent) {
    var win = getWindow$1(element);
    var elementStyles = win.getComputedStyle(element);
    var offset = offset$1(element);
    var parentElement = parent || offsetParent(element);

    var ownerDocument = element.ownerDocument;
    var useRelative = parentElement !== ownerDocument.body && parentElement !== ownerDocument.documentElement;

    var parentOffset = { top: 0, left: 0 };

    if (elementStyles.position !== "fixed" && useRelative) {
        var parentStyles = win.getComputedStyle(parentElement);

        parentOffset = offset$1(parentElement);
        parentOffset.top += parseInt(parentStyles.borderTopWidth, 10);
        parentOffset.left += parseInt(parentStyles.borderLeftWidth, 10);
    }

    return {
        top: offset.top - parentOffset.top,
        left: offset.left - parentOffset.left,
        height: offset.height,
        width: offset.width
    };
};

function offsetParentScrollPosition (offsetParentElement, element) { return ( // eslint-disable-line no-arrow-condition
    offsetParentElement ? elementScrollPosition$1(offsetParentElement) : parentScrollPosition(element)
); }

function positionWithScroll (element, parent, scale) {
    if ( scale === void 0 ) scale = 1;

    var offsetParentElement = parent ? offsetParent(parent) : null;
    var ref = position$1(element, offsetParentElement);
    var top = ref.top;
    var left = ref.left;
    var height = ref.height;
    var width = ref.width;
    var ref$1 = offsetParentScrollPosition(offsetParentElement, element);
    var x = ref$1.x;
    var y = ref$1.y;
    var ownerDocument = element.ownerDocument;
    var positionScale = offsetParentElement === ownerDocument.body || offsetParentElement === ownerDocument.documentElement ? 1 : scale;

    return {
        top: top + y * positionScale,
        left: left + x * positionScale,
        height: height,
        width: width
    };
}

function removeScroll(rect, scroll) {
    return {
        top: rect.top - scroll.y,
        left: rect.left - scroll.x,
        height: rect.height,
        width: rect.width
    };
}

var CollisionEnum = {
    "fit": "fit",
    "flip": "flip",
    "none": "none"
};

var fit = function(position, size, viewPortSize) {
    var output = 0;

    if (position + size > viewPortSize) {
        output = viewPortSize - (position + size);
    }

    if (position < 0) {
        output = -position;
    }

    return output;
};

var flip = function(ref) {
    var offset = ref.offset;
    var size = ref.size;
    var anchorSize = ref.anchorSize;
    var viewPortSize = ref.viewPortSize;
    var anchorAlignPoint = ref.anchorAlignPoint;
    var elementAlignPoint = ref.elementAlignPoint;
    var margin = ref.margin;

    var output = 0;

    var isPositionCentered = elementAlignPoint === AlignPoint.center || elementAlignPoint === AlignPoint.middle;
    var isOriginCentered = anchorAlignPoint === AlignPoint.center || anchorAlignPoint === AlignPoint.middle;
    var marginToAdd = 2 * margin; //2x to keep margin after flip

    if (elementAlignPoint !== anchorAlignPoint && !isPositionCentered && !isOriginCentered) {
        var isBeforeAnchor = anchorAlignPoint === AlignPoint.top || anchorAlignPoint === AlignPoint.left;
        if (offset < 0 && isBeforeAnchor) {
            output = size + anchorSize + marginToAdd;
            if (offset + output + size > viewPortSize) {
                output = 0; //skip flip
            }
        } else if (offset >= 0 && !isBeforeAnchor) {
            if (offset + size > viewPortSize) {
                output += -(anchorSize + size + marginToAdd);
            }

            if (offset + output < 0) {
                output = 0; //skip flip
            }
        }
    }

    return output;
};

var restrictToView = function (options) {
    var anchorRect = options.anchorRect;
    var anchorAlign = options.anchorAlign;
    var elementRect = options.elementRect;
    var elementAlign = options.elementAlign;
    var collisions = options.collisions;
    var viewPort = options.viewPort;
    var margin = options.margin; if ( margin === void 0 ) margin = {};
    var elementTop = elementRect.top;
    var elementLeft = elementRect.left;
    var elementHeight = elementRect.height;
    var elementWidth = elementRect.width;
    var viewPortHeight = viewPort.height;
    var viewPortWidth = viewPort.width;
    var horizontalMargin = margin.horizontal || 0;
    var verticalMargin = margin.vertical || 0;

    var left = 0;
    var top = 0;

    var isVerticalFit = collisions.vertical === CollisionEnum.fit;
    var isHorizontalFit = collisions.horizontal === CollisionEnum.fit;
    var isVerticalFlip = collisions.vertical === CollisionEnum.flip;
    var isHorizontalFlip = collisions.horizontal === CollisionEnum.flip;

    if (isVerticalFit) {
        top += fit(elementTop, elementHeight, viewPortHeight);
    }

    if (isHorizontalFit) {
        left += fit(elementLeft, elementWidth, viewPortWidth);
    }

    if (isVerticalFlip) {
        top += flip({
            margin: verticalMargin,
            offset: elementTop,
            size: elementHeight,
            anchorSize: anchorRect.height,
            viewPortSize: viewPortHeight,
            anchorAlignPoint: anchorAlign.vertical,
            elementAlignPoint: elementAlign.vertical
        });
    }

    if (isHorizontalFlip) {
        left += flip({
            margin: horizontalMargin,
            offset: elementLeft,
            size: elementWidth,
            anchorSize: anchorRect.width,
            viewPortSize: viewPortWidth,
            anchorAlignPoint: anchorAlign.horizontal,
            elementAlignPoint: elementAlign.horizontal
        });
    }

    var flippedVertical = isVerticalFlip && top !== 0;
    var flippedHorizontal = isHorizontalFlip && left !== 0;
    var fittedVertical = isVerticalFit && top !== 0;
    var fittedHorizontal = isHorizontalFit && left !== 0;

    return {
        flipped: flippedHorizontal || flippedVertical,
        fitted: fittedVertical || fittedHorizontal,
        flip: {
            horizontal: flippedHorizontal,
            vertical: flippedVertical
        },
        fit: {
            horizontal: fittedHorizontal,
            vertical: fittedVertical
        },
        offset: {
            left: left,
            top: top
        }
    };
};

function siblings (element) {
    var result = [];

    var sibling = element.parentNode.firstElementChild;

    while (sibling) {
        if (sibling !== element) {
            result.push(sibling);
        }

        sibling = sibling.nextElementSibling;
    }
    return result;
}

/* eslint-disable no-loop-func */

function siblingContainer (anchor, container) {
    var parentElements = parents(anchor);
    var containerElement = container;
    var siblingElements;
    var result;

    while (containerElement) {
        siblingElements = siblings(containerElement);

        result = parentElements.reduce(
            function (list, p) { return list.concat(siblingElements.filter(function (s) { return s === p; })); },
            []
        )[0];

        if (result) { break; }

        containerElement = containerElement.parentElement;
    }

    return result;
}

var eitherRect = function (rect, offset) {
    if (!rect) {
        return { height: 0, left: offset.left, top: offset.top, width: 0 };
    }

    return rect;
};

var scaleRect = function (rect, scale) {
    if (!rect || scale === 1) {
        return rect;
    }

    return {
        height: rect.height / scale,
        left: rect.left / scale,
        top: rect.top / scale,
        width: rect.width / scale
    };
};

var removeStackingOffset = function (rect, stackingOffset) {
    if (!stackingOffset) { return rect; }

    var result = {
        height: rect.height,
        left: rect.left - stackingOffset.left,
        top: rect.top - stackingOffset.top,
        width: rect.width
    };

    return result;
};

function memoize$2(fun) {
    var result;
    var called = false;

    return function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        if (called) {
            return result;
        }

        result = fun.apply(void 0, args);
        called = true;
        return result;
    };
}

var hasRelativeStackingContext = memoize$2(function (elementSource) {
    if (!canUseDOM$1()) { return false; }

    // Component need to pass element to make sure document owner is correct.
    // This however might be performance hit if checked for example on each drag event.
    var currentDocument = elementSource ? elementSource.ownerDocument : document;

    if (!currentDocument || !currentDocument.body) { return false; }

    var top = 10;
    var parent = currentDocument.createElement("div");
    parent.style.transform = "matrix(10, 0, 0, 10, 0, 0)";
    parent.innerHTML = "<div style=\"position: fixed; top: " + top + "px;\">child</div>";

    currentDocument.body.appendChild(parent);

    var isDifferent = parent.children[0].getBoundingClientRect().top !== top;

    currentDocument.body.removeChild(parent);

    return isDifferent;
});

var canUseDOM$1 = function () { return Boolean(
    // from fbjs
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
); };

var utils = {
    eitherRect: eitherRect,
    scaleRect: scaleRect,
    removeStackingOffset: removeStackingOffset,
    hasRelativeStackingContext: hasRelativeStackingContext,
    canUseDOM: canUseDOM$1
};

/* eslint-disable arrow-body-style */

var STYLES = [
    'font-size',
    'font-family',
    'font-stretch',
    'font-style',
    'font-weight',
    'line-height'
];

var addOffset = function (current, addition) {
    return {
        left: current.left + addition.left,
        top: current.top + addition.top
    };
};

var getWindow = function () {
    return utils.canUseDOM() ? window : null;
};

var getFontStyles = function (el) {
    var window = getWindow();

    if (!window || !el) { return []; }

    var computedStyles = window.getComputedStyle(el);

    return STYLES.map(function (font) { return ({ key: font, value: computedStyles[font] }); });
};

var hasOffsetParent = function (el) {
    if (!el) { return false; }

    return Boolean(el.offsetParent);
};

var offset = function (el) {
    if (!el) { return null; }

    return offset$1(el);
};

var offsetAtPoint = function (element, currentLocation) {
    if (!element) { return null; }

    var ref = element.style;
    var left = ref.left;
    var top = ref.top;
    var transition = ref.transition;

    element.style.transition = 'none';
    element.style.left = (currentLocation.left) + "px";
    element.style.top = (currentLocation.top) + "px";

    var currentOffset = offset$1(element);

    element.style.left = left;
    element.style.top = top;

    // prevents elements with transition to be animated because of the change
    // tslint:disable-next-line:no-unused-expression
    element.offsetHeight;

    element.style.transition = transition;

    return currentOffset;
};

var position = function (element, popupElement, scale) {
    if (!element || !popupElement) { return null; }

    var currentScale = scale || 1;

    return positionWithScroll(element, popupElement, currentScale);
};

var OVERFLOW_REGEXP = /auto|scroll/;

var overflowElementStyle = function (element) {
    return ("" + (element.style.overflow) + (element.style.overflowX) + (element.style.overflowY));
};

var overflowComputedStyle = function (element) {
    var styles = window.getComputedStyle(element);
    return ("" + (styles.overflow) + (styles.overflowX) + (styles.overflowY));
};

var overflowStyle = function (element) {
    return overflowElementStyle(element) || overflowComputedStyle(element);
};

var scrollableParents = function (element) {
    var parentElements = [];

    if (!utils.canUseDOM()) { return parentElements; }

    var parent = element.parentElement;

    while (parent) {
        if (OVERFLOW_REGEXP.test(overflowStyle(parent)) || parent.hasAttribute('data-scrollable')) {
            parentElements.push(parent);
        }

        parent = parent.parentElement;
    }

    parentElements.push(window);

    return parentElements;
};

var getRelativeContextElement = function (el) {
    if (!el || !utils.hasRelativeStackingContext()) { return null; }

    var parent = el.parentElement;

    while (parent) {
        if (window.getComputedStyle(parent).transform !== 'none') {
            return parent;
        }
        parent = parent.parentElement;
    }

    return null;
};

var stackingElementOffset = function (el) {
    var relativeContextElement = getRelativeContextElement(el);

    if (!relativeContextElement) { return null; }

    return offset$1(relativeContextElement);
};

var stackingElementScroll = function (el) {
    var relativeContextElement = getRelativeContextElement(el);

    if (!relativeContextElement) { return { x: 0, y: 0 }; }

    return {
        x: relativeContextElement.scrollLeft,
        y: relativeContextElement.scrollTop
    };
};

var stackingElementViewPort = function (el) {
    var relativeContextElement = getRelativeContextElement(el);

    if (!relativeContextElement) { return null; }

    return {
        height: relativeContextElement.scrollHeight,
        width: relativeContextElement.scrollWidth
    };
};

var useRelativePosition = function (el) {
    return Boolean(getRelativeContextElement(el));
};

var zoomLevel = function () {
    if (!utils.canUseDOM()) { return 1; }

    return parseFloat((document.documentElement.clientWidth / window.innerWidth).toFixed(2)) || 1;
};

var isZoomed = function () {
    return zoomLevel() > 1;
};

var zIndex = function (anchor, container) {
    if (!anchor || !utils.canUseDOM()) { return null; }

    var sibling = siblingContainer(anchor, container);

    if (!sibling) { return null; }

    var result = [ anchor ].concat(parents(anchor, sibling)).reduce(
        function (index, p) {
            var zIndexStyle = p.style.zIndex || window.getComputedStyle(p).zIndex;
            var current = parseInt(zIndexStyle, 10);
            return current > index ? current : index;
        },
        0
    );

    return result ? (result + 1) : null;
};

var domUtils = {
    addOffset: addOffset,
    addScroll: addScroll,
    align: align,
    boundingOffset: boundingOffset,
    getFontStyles: getFontStyles,
    getWindow: getWindow,
    hasOffsetParent: hasOffsetParent,
    offset: offset,
    offsetAtPoint: offsetAtPoint,
    position: position,
    removeScroll: removeScroll,
    restrictToView: restrictToView,
    scrollPosition: scrollPosition,
    scrollableParents: scrollableParents,
    getRelativeContextElement: getRelativeContextElement,
    stackingElementOffset: stackingElementOffset,
    stackingElementScroll: stackingElementScroll,
    stackingElementViewPort: stackingElementViewPort,
    useRelativePosition: useRelativePosition,
    windowViewPort: windowViewport,
    zoomLevel: zoomLevel,
    isZoomed: isZoomed,
    zIndex: zIndex
};

/* eslint-disable arrow-body-style */

var absoluteRect = function (anchor, element, offset, scale) {
    var scrollPos = elementScrollPosition(anchor, element);
    var rect = utils.eitherRect(domUtils.offset(anchor), offset);
    var stackScale = 2 * scale;

    var stackScroll = domUtils.stackingElementScroll(element);
    if (scale !== 1 && stackScroll) {
        stackScroll.x /= stackScale;
        stackScroll.y /= stackScale;
    }

    var stackOffset = domUtils.stackingElementOffset(element);
    if (scale !== 1 && stackOffset) {
        stackOffset.left /= stackScale;
        stackOffset.top /= stackScale;
    }

    return domUtils.removeScroll(
        domUtils.addScroll(
            utils.removeStackingOffset(
                utils.scaleRect(rect, scale),
                stackOffset
            ),
            stackScroll
        ),
        scrollPos
    );
};

var relativeRect = function (anchor, element, offset, scale) {
    var rect = utils.eitherRect(domUtils.position(anchor, element, scale), offset);
    return utils.scaleRect(rect, scale);
};

var elementScrollPosition = function (anchor, element) {
    return anchor ? { x: 0, y: 0 } : domUtils.scrollPosition(element);
};

var alignElement = function (settings) {
    var anchor = settings.anchor;
    var element = settings.element;
    var anchorAlign = settings.anchorAlign;
    var elementAlign = settings.elementAlign;
    var margin = settings.margin;
    var offset = settings.offset;
    var positionMode = settings.positionMode;
    var scale = settings.scale;

    var currentScale = scale || 1;
    var fixedMode = positionMode === 'fixed' || !domUtils.hasOffsetParent(element);
    var anchorRect = fixedMode ? absoluteRect(anchor, element, offset, currentScale) : relativeRect(anchor, element, offset, currentScale);
    var elementRect = utils.scaleRect(domUtils.offset(element), currentScale);

    var result = domUtils.align({
        anchorAlign: anchorAlign,
        anchorRect: anchorRect,
        elementAlign: elementAlign,
        elementRect: elementRect,
        margin: margin
    });

    return result;
};

var positionElement = function (settings) {
    var anchor = settings.anchor;
    var currentLocation = settings.currentLocation;
    var element = settings.element;
    var anchorAlign = settings.anchorAlign;
    var elementAlign = settings.elementAlign;
    var collisions = settings.collisions;
    var margin = settings.margin;
    var scale = settings.scale;

    var currentScale = scale || 1;
    var elementOffset = domUtils.offsetAtPoint(element, currentLocation);
    var elementRect = utils.scaleRect(elementOffset, currentScale);
    var anchorOffset = utils.scaleRect(domUtils.offset(anchor), currentScale);
    var anchorRect = utils.eitherRect(anchorOffset, currentLocation);

    var viewPort = settings.viewPort || domUtils.windowViewPort(element);
    viewPort.width = viewPort.width / currentScale;
    viewPort.height = viewPort.height / currentScale;

    var result = domUtils.restrictToView({
        anchorAlign: anchorAlign,
        anchorRect: anchorRect,
        collisions: collisions,
        elementAlign: elementAlign,
        elementRect: elementRect,
        margin: margin,
        viewPort: viewPort
    });

    var offset = domUtils.addOffset(currentLocation, result.offset);

    return {
        flip: result.flip,
        flipped: result.flipped,
        offset: offset
    };
};

/**
 * @hidden
 */
/**
 * @hidden
 */
var FRAME_DURATION$2 = 1000 / 60; // 1000ms divided by 60fps
/**
 * @hidden
 */
var throttle$1 = function (func, wait, options) {
    if (options === void 0) { options = {}; }
    var timeout, context, args, result;
    var previous = 0;
    options = options || {};
    var later = function () {
        previous = options.leading === false ? 0 : new Date().getTime();
        timeout = undefined;
        result = func.apply(context, args);
        if (!timeout) {
            context = args = null;
        }
    };
    var throttled = function () {
        var now = new Date().getTime();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = undefined; // this
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = undefined;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) {
                context = args = null;
            }
        }
        else if (!timeout && options.trailing !== false) {
            timeout = window.setTimeout(later, remaining);
        }
        return result;
    };
    return throttled;
};

/**
 * @hidden
 */
var packageMetadata$a = {
    name: '@progress/kendo-react-popup',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770541,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$V = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$Q = (undefined && undefined.__assign) || function () {
    __assign$Q = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$Q.apply(this, arguments);
};
var DEFAULT_POPUP_ZINDEX$1 = 100;
var ZINDEX_POPUP_STEP$1 = 1;
function isEquivalent$1(a, b) {
    if (a === b) {
        return true;
    }
    if (!!a !== !!b) {
        return false;
    }
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
var DEFAULT_OFFSET$1 = {
    left: -1000,
    top: 0
};
var Status$1;
(function (Status) {
    Status["hiding"] = "hiding";
    Status["hidden"] = "hidden";
    Status["showing"] = "showing";
    Status["shown"] = "shown";
    Status["reposition"] = "reposition";
})(Status$1 || (Status$1 = {}));
var ANIMATION_CONTAINER$1 = 'k-animation-container';
var ANIMATION_CONTAINER_SHOWN$1 = 'k-animation-container-shown';
var ANIMATION_CONTAINER_RELATIVE$1 = 'k-animation-container-relative';
var ANIMATION_CONTAINER_CHILD$1 = 'k-child-animation-container';
var K_POPUP$1 = 'k-popup';
/**
 * @hidden
 */
var PopupWithoutContext$1 = /** @class */ (function (_super) {
    __extends$V(PopupWithoutContext, _super);
    function PopupWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.context = 0;
        /**
         * @hidden
         */
        _this.state = { current: Status$1.hidden, previous: Status$1.hidden, props: {} };
        _this._popup = null;
        _this.show = function (popup) {
            _this.setPosition(popup);
            _this.animate(popup.firstChild, 'enter', _this.onOpened);
            _this.setState({ current: Status$1.shown, previous: _this.state.current });
        };
        _this.setPosition = function (popup) {
            var _a = _this.props, anchorAlign = _a.anchorAlign, popupAlign = _a.popupAlign, collision = _a.collision, offset = _a.offset, anchor = _a.anchor, margin = _a.margin, scale = _a.scale, positionMode = _a.positionMode;
            var _b = popup.style, width = _b.width, height = _b.height;
            // Calculations are wrong if popup does not have set size
            popup.style.width = popup.offsetWidth + 'px';
            popup.style.height = popup.offsetHeight + 'px';
            var alignedOffset = alignElement({
                anchor: anchor,
                anchorAlign: anchorAlign,
                element: popup,
                elementAlign: popupAlign,
                offset: offset,
                margin: margin,
                positionMode: positionMode,
                scale: scale
            });
            var position = positionElement({
                anchor: anchor,
                anchorAlign: anchorAlign,
                element: popup,
                elementAlign: popupAlign,
                collisions: collision,
                currentLocation: alignedOffset,
                margin: _this.props.margin
            });
            popup.style.top = position.offset.top + 'px';
            popup.style.left = position.offset.left + 'px';
            popup.style.width = width;
            popup.style.height = height;
            _this._collisions = {
                fit: position.fit,
                fitted: position.fitted,
                flip: position.flip,
                flipped: position.flipped
            };
            if (_this.props.onPosition) {
                var event_1 = {
                    target: _this,
                    flipped: position.flipped,
                    fitted: position.fitted
                };
                _this.props.onPosition.call(undefined, event_1);
            }
        };
        _this.onOpened = function () {
            var element = _this._popup;
            if (!element) {
                return;
            }
            if (_this.props.show) {
                element.classList.add(ANIMATION_CONTAINER_SHOWN$1);
            }
            _this.attachRepositionHandlers(element);
            if (_this.props.onOpen) {
                _this.props.onOpen.call(undefined, { target: _this });
            }
        };
        _this.animate = function (element, type, callback) {
            if (!_this.props.popupAlign) {
                return;
            }
            var animationDirection;
            var _a = _this.props.popupAlign, horizontal = _a.horizontal, vertical = _a.vertical;
            if (horizontal === 'left' && vertical === 'center') {
                animationDirection = 'right';
            }
            else if (horizontal === 'right' && vertical === 'center') {
                animationDirection = 'left';
            }
            else if (vertical === 'top') {
                animationDirection = 'down';
            }
            else {
                animationDirection = 'up';
            }
            var flipPositions = {
                down: 'up',
                up: 'down',
                left: 'right',
                right: 'left'
            };
            if (_this._collisions && _this._collisions.flipped) {
                animationDirection = flipPositions[animationDirection];
            }
            slide$1(element, animationDirection, _this.animationDuration[type], type, callback);
        };
        _this.onClosing = function (popup) {
            if (!_this.props.show) {
                popup.classList.remove(ANIMATION_CONTAINER_SHOWN$1);
            }
            _this.detachRepositionHandlers();
        };
        _this.onClosed = function () {
            if (_this.state.current === Status$1.hiding && _this.state.previous === Status$1.shown) {
                _this.setState({ current: Status$1.hidden, previous: _this.state.current });
            }
            if (_this.props.onClose) {
                _this.props.onClose.call(undefined, { target: _this });
            }
        };
        _this.getCurrentZIndex = function () {
            return _this.context ? _this.context + ZINDEX_POPUP_STEP$1 : DEFAULT_POPUP_ZINDEX$1;
        };
        validatePackage$2(packageMetadata$a);
        _this.reposition = throttle$1(_this.reposition.bind(_this), FRAME_DURATION$2);
        return _this;
    }
    Object.defineProperty(PopupWithoutContext.prototype, "element", {
        /**
         * Represents the Popup DOM element.
         */
        get: function () {
            return this._popup;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    PopupWithoutContext.getDerivedStateFromProps = function (props, state) {
        var show = props.show, anchor = props.anchor, anchorAlign = props.anchorAlign, appendTo = props.appendTo, collision = props.collision, popupAlign = props.popupAlign, className = props.className, popupClass = props.popupClass, style = props.style, offset = props.offset, contentKey = props.contentKey;
        var nextState = __assign$Q(__assign$Q({}, state), { props: {
                show: show,
                anchor: anchor,
                anchorAlign: anchorAlign,
                appendTo: appendTo,
                collision: collision,
                popupAlign: popupAlign,
                className: className,
                popupClass: popupClass,
                style: style,
                offset: offset,
                contentKey: contentKey
            } });
        if (props.show) {
            if (state.current === Status$1.hidden || state.current === Status$1.hiding) {
                return __assign$Q(__assign$Q({}, nextState), { current: Status$1.showing, previous: state.current });
            }
            if (state.current === Status$1.showing) {
                return __assign$Q(__assign$Q({}, nextState), { current: Status$1.shown, previous: state.current });
            }
            if (state.current === Status$1.shown &&
                (!isEquivalent$1(offset, state.props.offset) ||
                    !isEquivalent$1(anchorAlign, state.props.anchorAlign) ||
                    !isEquivalent$1(appendTo, state.props.appendTo) ||
                    !isEquivalent$1(collision, state.props.collision) ||
                    !isEquivalent$1(popupAlign, state.props.popupAlign) ||
                    !isEquivalent$1(style, state.props.style) ||
                    anchor !== state.props.anchor ||
                    popupClass !== state.props.popupClass ||
                    className !== state.props.className)) {
                return __assign$Q(__assign$Q({}, nextState), { current: Status$1.reposition, previous: state.current });
            }
            return nextState;
        }
        if (state.current === Status$1.hiding || state.current === Status$1.hidden) {
            return __assign$Q(__assign$Q({}, nextState), { current: Status$1.hidden, previous: state.current });
        }
        return __assign$Q(__assign$Q({}, nextState), { current: Status$1.hiding, previous: state.current });
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.componentDidUpdate = function (prevProps) {
        if (this.state.current === Status$1.showing && this._popup) {
            this.show(this._popup);
        }
        else if (this.state.current === Status$1.hiding && this._popup) {
            this.onClosing(this._popup);
            this.animate(this._popup.firstChild, 'exit', this.onClosed);
        }
        else if (this.state.current === Status$1.reposition && this.state.previous === Status$1.shown) {
            this.setState({ current: Status$1.shown, previous: this.state.current });
        }
        else if (this.state.current === Status$1.shown &&
            prevProps.contentKey !== this.props.contentKey && this._popup) {
            this.setPosition(this._popup);
        }
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.componentDidMount = function () {
        if (this.state.current === Status$1.showing && this._popup) {
            this.show(this._popup);
        }
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.componentWillUnmount = function () {
        this.detachRepositionHandlers();
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, popupClass = _a.popupClass, show = _a.show, id = _a.id, positionMode = _a.positionMode;
        var calculatedAppendTo = this.props.appendTo ?
            this.props.appendTo :
            canUseDOM$2 ?
                (this.props.anchor && this.props.anchor.ownerDocument ? this.props.anchor.ownerDocument.body : document.body)
                : undefined;
        if (this.state.current === Status$1.reposition && this.state.previous === Status$1.shown && this._popup) {
            this.setPosition(this._popup);
        }
        var style = Object.assign({}, { position: positionMode, top: 0, left: -10000 }, this.props.style || {});
        var closing = this.state.current === Status$1.hiding;
        if ((show || closing) && calculatedAppendTo) {
            var currentZIndex = this.getCurrentZIndex();
            var popupElement = (React.createElement(ZIndexContext$1.Provider, { value: currentZIndex },
                React.createElement("div", { className: classNames$2(ANIMATION_CONTAINER$1, ANIMATION_CONTAINER_RELATIVE$1, className), id: id, ref: function (e) { return _this._popup = e; }, style: __assign$Q({ zIndex: currentZIndex }, style) },
                    React.createElement("div", { className: classNames$2(K_POPUP$1, popupClass, ANIMATION_CONTAINER_CHILD$1), style: { transitionDelay: '0ms' } }, children))));
            return this.props.appendTo !== null ?
                ReactDOM.createPortal(popupElement, calculatedAppendTo) :
                popupElement;
        }
        return null;
    };
    Object.defineProperty(PopupWithoutContext.prototype, "animationDuration", {
        get: function () {
            var animate = this.props.animate;
            var enter = 0;
            var exit = 0;
            if (animate) {
                if (animate === true) {
                    enter = exit = 300;
                }
                else {
                    enter = animate.openDuration || 0;
                    exit = animate.closeDuration || 0;
                }
            }
            return { enter: enter, exit: exit };
        },
        enumerable: false,
        configurable: true
    });
    PopupWithoutContext.prototype.attachRepositionHandlers = function (element) {
        var _this = this;
        this.detachRepositionHandlers();
        this._scrollableParents = domUtils.scrollableParents(this.props.anchor || element);
        if (this._scrollableParents) {
            this._scrollableParents.map(function (p) { return p.addEventListener('scroll', _this.reposition); });
        }
        window.addEventListener('resize', this.reposition);
    };
    PopupWithoutContext.prototype.detachRepositionHandlers = function () {
        var _this = this;
        if (this._scrollableParents) {
            this._scrollableParents.map(function (p) { return p.removeEventListener('scroll', _this.reposition); });
            this._scrollableParents = undefined;
        }
        window.removeEventListener('resize', this.reposition);
    };
    PopupWithoutContext.prototype.reposition = function () {
        this.setState({ current: Status$1.reposition, previous: this.state.current });
    };
    /**
     * @hidden
     */
    PopupWithoutContext.propTypes = {
        anchor: function (props) {
            var anchor = props.anchor;
            if (anchor && typeof anchor.nodeType !== 'number') {
                return new Error('Invalid prop `anchor` supplied to `Kendo React Popup`. Validation failed.');
            }
            return null;
        },
        appendTo: function (props) {
            var element = props.appendTo;
            if (element && typeof element.nodeType !== 'number') {
                return new Error('Invalid prop `appendTo` supplied to `Kendo React Popup`. Validation failed.');
            }
            return null;
        },
        className: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.arrayOf(propTypes.exports.string),
            propTypes.exports.object
        ]),
        id: propTypes.exports.string,
        popupClass: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.arrayOf(propTypes.exports.string),
            propTypes.exports.object
        ]),
        collision: propTypes.exports.shape({
            horizontal: propTypes.exports.oneOf([
                CollisionEnum.fit,
                CollisionEnum.flip,
                CollisionEnum.none
            ]),
            vertical: propTypes.exports.oneOf([
                CollisionEnum.fit,
                CollisionEnum.flip,
                CollisionEnum.none
            ])
        }),
        anchorAlign: propTypes.exports.shape({
            horizontal: propTypes.exports.oneOf([
                AlignPoint.left,
                AlignPoint.center,
                AlignPoint.right
            ]),
            vertical: propTypes.exports.oneOf([
                AlignPoint.top,
                AlignPoint.center,
                AlignPoint.bottom
            ])
        }),
        popupAlign: propTypes.exports.shape({
            horizontal: propTypes.exports.oneOf([
                AlignPoint.left,
                AlignPoint.center,
                AlignPoint.right
            ]),
            vertical: propTypes.exports.oneOf([
                AlignPoint.top,
                AlignPoint.center,
                AlignPoint.bottom
            ])
        }),
        offset: propTypes.exports.shape({
            left: propTypes.exports.number,
            top: propTypes.exports.number
        }),
        children: propTypes.exports.oneOfType([
            propTypes.exports.element,
            propTypes.exports.node
        ]),
        show: propTypes.exports.bool,
        animate: propTypes.exports.oneOfType([
            propTypes.exports.bool,
            propTypes.exports.shape({
                openDuration: propTypes.exports.number,
                closeDuration: propTypes.exports.number
            })
        ]),
        margin: propTypes.exports.shape({
            horizontal: propTypes.exports.number,
            vertical: propTypes.exports.number
        }),
        positionMode: propTypes.exports.oneOf([
            'fixed',
            'absolute'
        ]),
        scale: propTypes.exports.number,
        style: propTypes.exports.object,
        onClose: propTypes.exports.func,
        onPosition: propTypes.exports.func,
        onOpen: propTypes.exports.func
    };
    /**
     * @hidden
     */
    PopupWithoutContext.defaultProps = {
        collision: {
            horizontal: CollisionEnum.fit,
            vertical: CollisionEnum.flip
        },
        anchorAlign: {
            horizontal: AlignPoint.left,
            vertical: AlignPoint.bottom
        },
        popupAlign: {
            horizontal: AlignPoint.left,
            vertical: AlignPoint.top
        },
        offset: DEFAULT_OFFSET$1,
        animate: true,
        show: false,
        margin: {
            horizontal: 0,
            vertical: 0
        },
        positionMode: 'absolute'
    };
    /**
     * @hidden
     */
    PopupWithoutContext.contextType = ZIndexContext$1;
    /**
     * @hidden
     */
    PopupWithoutContext.displayName = 'PopupComponent';
    return PopupWithoutContext;
}(React.Component));

var __assign$P = (undefined && undefined.__assign) || function () {
    __assign$P = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$P.apply(this, arguments);
};
/**
 * The PopupPropsContext. It allows to configure the Popup props from a wrapper component.
 *
 * @example
 * ```jsx-no-run
 *  <PopupPropsContext.Provider value={props => ({ ...props, appendTo: document.querySelector('myPopupsContainer') })}>
 *      <DropDownList />
 *      <Editor />
 *  </PopupPropsContext.Provider>
 * ```
 */
var PopupPropsContext$1 = React.createContext(function (props) { return props; });
/**
 * The KendoReact Popup component.
 */
var Popup$1 = React.forwardRef(function (props, ref) {
    var contextPropsCallback = React.useContext(PopupPropsContext$1);
    var popupProps = contextPropsCallback.call(undefined, props);
    return (React.createElement(PopupWithoutContext$1, __assign$P({ ref: ref }, popupProps)));
});
Popup$1.displayName = 'Popup';

var __extends$U = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$O = (undefined && undefined.__assign) || function () {
    __assign$O = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$O.apply(this, arguments);
};
/**
 * @hidden
 */
var ListContainer = /** @class */ (function (_super) {
    __extends$U(ListContainer, _super);
    function ListContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListContainer.prototype.render = function () {
        var _a = this.props, children = _a.children, width = _a.width, dir = _a.dir, itemsCount = _a.itemsCount, popupSettings = _a.popupSettings;
        return (React.createElement(Popup$1, __assign$O({ style: { width: width, direction: dir }, contentKey: itemsCount && itemsCount.join() }, popupSettings), children));
    };
    return ListContainer;
}(React.Component));
var ListContainer$1 = ListContainer;

var __extends$T = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var sizeMap$1 = kendoThemeMaps$1.sizeMap, roundedMap$1 = kendoThemeMaps$1.roundedMap;
/**
 * @hidden
 */
var ListFilter = /** @class */ (function (_super) {
    __extends$T(ListFilter, _super);
    function ListFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.input = null;
        return _this;
    }
    ListFilter.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, size = _b.size, rounded = _b.rounded, fillMode = _b.fillMode, inputRef = _b.inputRef;
        return (React.createElement("div", { className: "k-list-filter" },
            React.createElement("span", { className: classNames$2('k-searchbox k-input', (_a = {},
                    _a["k-input-".concat(sizeMap$1[size] || size)] = size,
                    _a["k-rounded-".concat(roundedMap$1[rounded] || rounded)] = rounded,
                    _a["k-input-".concat(fillMode)] = fillMode,
                    _a)) },
                React.createElement("span", { className: "k-input-icon k-icon k-i-search" }),
                React.createElement("input", { ref: inputRef ? inputRef : function (input) { return _this.input = input; }, value: this.props.value || '', className: "k-input-inner", onChange: this.props.onChange, onKeyDown: this.props.onKeyDown, tabIndex: this.props.tabIndex, onClick: function (e) { return e.stopPropagation(); } }))));
    };
    return ListFilter;
}(React.Component));
var ListFilter$1 = ListFilter;

/**
 * @hidden
 */
var isPresent$1 = function (value) { return value !== null && value !== undefined; };
/**
 * @hidden
 */
var sameCharsOnly = function (word, character) {
    for (var idx = 0; idx < word.length; idx++) {
        if (word.charAt(idx) !== character) {
            return false;
        }
    }
    return true;
};
/**
 * @hidden
 */
var shuffleData = function (data, splitIndex, defaultItem) {
    var result = data;
    if (defaultItem) {
        result = [defaultItem].concat(result);
    }
    return result.slice(splitIndex).concat(result.slice(0, splitIndex));
};
/**
 * @hidden
 */
var matchText = function (text, word, ignoreCase) {
    if (!isPresent$1(text)) {
        return false;
    }
    var temp = String(text);
    if (ignoreCase) {
        temp = temp.toLowerCase();
    }
    return temp.indexOf(word) === 0;
};
/**
 * @hidden
 */
var scrollToItem = function (scrollElem, list, itemIndex, translate, virtualScroll) {
    var viewportHeight = scrollElem.offsetHeight;
    var li = list.children.item(itemIndex);
    var itemOffsetTop = li.offsetTop + (virtualScroll ? translate - scrollElem.scrollTop : 0);
    var itemHeight = li.offsetHeight;
    if (virtualScroll) {
        var diff = 0;
        if (itemOffsetTop + itemHeight > viewportHeight) {
            diff = itemOffsetTop + itemHeight - viewportHeight;
        }
        else if (itemOffsetTop < 0) {
            diff = itemOffsetTop;
        }
        if (diff !== 0) {
            scrollElem.scrollTop += diff;
        }
        else if (scrollElem.scrollTop === 0 && translate !== 0) {
            scrollElem.scrollTop = translate;
        }
    }
    else {
        if (itemOffsetTop + itemHeight > viewportHeight + scrollElem.scrollTop) {
            scrollElem.scrollTop = (itemOffsetTop + itemHeight - viewportHeight);
        }
        else if (itemOffsetTop < scrollElem.scrollTop) {
            scrollElem.scrollTop -= scrollElem.scrollTop - itemOffsetTop;
        }
    }
};
/**
 * @hidden
 */
var itemIndexStartsWith = function (items, text, field) {
    var result = -1;
    if (text) {
        text = text.toLowerCase();
        for (var i = 0; i < items.length; i++) {
            var itemText = (getItemValue(items[i], field) || '') + '';
            if (itemText && itemText.toLowerCase().startsWith(text)) {
                result = i;
                break;
            }
        }
    }
    return result;
};
/**
 * @hidden
 */
var getItemIndexByText = function (data, text, textField, matchCase) {
    if (matchCase === void 0) { matchCase = false; }
    var casing = function (value) { return matchCase ? value : value.toLowerCase(); };
    return data.findIndex(function (item) {
        return textField ? casing(getItemValue(item, textField)) === casing(text) :
            casing(text) === casing(item.toString());
    });
};
/**
 * @hidden
 */
var getItemValue = function (item, field) {
    if (field && isPresent$1(item)) {
        var path = field.split('.');
        var data_1 = item;
        path.forEach(function (p) {
            data_1 = data_1 ? data_1[p] : undefined;
        });
        return data_1;
    }
    return item;
};
/**
 * @hidden
 */
var areSame = function (item1, item2, key) {
    return item1 === item2 ||
        (isPresent$1(item1) === isPresent$1(item2) && getItemValue(item1, key) === getItemValue(item2, key));
};
/**
 * @hidden
 */
var getFocusedItem = function (data, value, textField) {
    if (value) {
        var selectedIndex = getItemIndexByText(data, value, textField, true);
        return selectedIndex !== -1 ? data[selectedIndex] : data[itemIndexStartsWith(data, value, textField)];
    }
    return data[0];
};
/**
 * @hidden
 */
var preventDefaultNonInputs = function (event) {
    if (event.target.nodeName !== 'INPUT') {
        event.preventDefault();
    }
};

var __extends$S = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var preventDefault = function (e) { return e.preventDefault(); };
/**
 * @hidden
 */
var ListDefaultItem = /** @class */ (function (_super) {
    __extends$S(ListDefaultItem, _super);
    function ListDefaultItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListDefaultItem.prototype.render = function () {
        var _a = this.props, selected = _a.selected, defaultItem = _a.defaultItem, textField = _a.textField;
        return (React.createElement("div", { onClick: this.props.onClick, onMouseDown: preventDefault, style: { position: 'unset' }, className: classNames$2('k-list-optionlabel', {
                'k-selected': selected
            }) }, getItemValue(defaultItem, textField) || ''));
    };
    return ListDefaultItem;
}(React.Component));
var ListDefaultItem$1 = ListDefaultItem;

var __extends$R = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:enable:max-line-length
/**
 * @hidden
 */
var ListItem = /** @class */ (function (_super) {
    __extends$R(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) { return _this.props.onClick(_this.props.index, e); };
        return _this;
    }
    ListItem.prototype.render = function () {
        var _a = this.props, selected = _a.selected, group = _a.group, dataItem = _a.dataItem, virtual = _a.virtual, renderer = _a.render;
        var item = (React.createElement("li", { id: this.props.id, role: "option", "aria-selected": selected, className: classNames$2('k-list-item', {
                'k-selected': selected,
                'k-focus': this.props.focused,
                'k-first': Boolean(group)
            }), onClick: this.handleClick, style: { position: virtual ? 'relative' : 'unset' } },
            React.createElement("span", { className: 'k-list-item-text' }, getItemValue(dataItem, this.props.textField).toString()),
            group !== undefined ? React.createElement("div", { className: "k-list-item-group-label" }, group) : null));
        return renderer !== undefined ? renderer.call(undefined, item, this.props) : item;
    };
    return ListItem;
}(React.Component));
var ListItem$1 = ListItem;

var _a$a;
/**
 * @hidden
 */
var nodata = 'dropdowns.nodata';
/**
 * @hidden
 */
var clear = 'dropdowns.clear';
/**
 * @hidden
 */
var messages$3 = (_a$a = {},
    _a$a[clear] = 'clear',
    _a$a[nodata] = 'NO DATA FOUND.',
    _a$a);

var __extends$Q = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var List = /** @class */ (function (_super) {
    __extends$Q(List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    List.prototype.renderItems = function () {
        var _this = this;
        var _a = this.props, textField = _a.textField, valueField = _a.valueField, groupField = _a.groupField, optionsGuid = _a.optionsGuid, _b = _a.skip, skip = _b === void 0 ? 0 : _b, virtual = _a.virtual, focusedIndex = _a.focusedIndex, _c = _a.highlightSelected, highlightSelected = _c === void 0 ? true : _c, value = _a.value, data = _a.data, itemRender = _a.itemRender;
        var isArray = Array.isArray(value);
        return data.map(function (item, index) {
            var realIndex = skip + index;
            var selected = highlightSelected &&
                ((!isArray && areSame(item, value, valueField)) ||
                    (isArray && value.findIndex(function (i) { return areSame(i, item, valueField); }) !== -1));
            var group = undefined;
            var current, previous;
            if (index > 0 && groupField !== undefined) {
                current = getItemValue(item, groupField);
                previous = getItemValue(data[index - 1], groupField);
                if (current && previous && current !== previous) {
                    group = current;
                }
            }
            return (React.createElement(ListItem$1, { id: "option-".concat(optionsGuid, "-").concat(realIndex), virtual: virtual, dataItem: item, selected: selected, focused: focusedIndex === index, index: realIndex, key: realIndex, onClick: _this.props.onClick, textField: textField, group: group, render: itemRender }));
        });
    };
    List.prototype.renderNoValueElement = function (localizationService) {
        var noDataRender = this.props.noDataRender;
        var noDataElement = (React.createElement("div", { className: 'k-nodata' },
            React.createElement("div", null, localizationService.toLanguageString(nodata, messages$3[nodata]))));
        return noDataRender ?
            noDataRender.call(undefined, noDataElement) : noDataElement;
    };
    List.prototype.render = function () {
        var localizationService = provideLocalizationService(this);
        var _a = this.props, id = _a.id, show = _a.show, wrapperCssClass = _a.wrapperCssClass, wrapperStyle = _a.wrapperStyle, listStyle = _a.listStyle, listRef = _a.listRef, wrapperRef = _a.wrapperRef, _b = _a.listClassName, listClassName = _b === void 0 ? 'k-list-ul' : _b;
        var items = this.renderItems();
        return (items.length ? (React.createElement("div", { className: wrapperCssClass, style: wrapperStyle, ref: wrapperRef, onMouseDown: this.props.onMouseDown, onBlur: this.props.onBlur, onScroll: this.props.onScroll, unselectable: "on" },
            React.createElement("ul", { id: id, role: "listbox", "aria-hidden": !show ? true : undefined, className: listClassName, ref: listRef, style: listStyle }, items),
            this.props.scroller && React.createElement("div", { className: "k-height-container" }, this.props.scroller))) : this.renderNoValueElement(localizationService));
    };
    return List;
}(React.Component));
var List$1 = List;
registerForLocalization(List);

var maxHeightIE = 1533915;
/**
 * @hidden
 */
var VirtualScroll$1 = /** @class */ (function () {
    function VirtualScroll() {
        var _this = this;
        this.container = null;
        this.scrollElement = null;
        this.list = null;
        this.containerHeight = 0;
        this.skip = 0;
        this.total = 0;
        this.enabled = false;
        this.pageSize = 0;
        this.itemHeight = 0;
        this.PageChange = null;
        this.prevScrollPos = 0;
        this.listTranslate = 0;
        this.scrollSyncing = false;
        this.scrollerRef = function (element) {
            var vs = _this;
            vs.container = element;
            if (element) {
                element.setAttribute('unselectable', 'on');
                window.setTimeout(vs.calcScrollElementHeight.bind(vs), 0);
            }
        };
        this.calcScrollElementHeight = function () {
            _this.scrollSyncing = true;
            var heightChanged = false;
            _this.itemHeight = _this.list ? _this.list.children[0].offsetHeight : _this.itemHeight;
            _this.containerHeight = Math.min(maxHeightIE, _this.itemHeight * _this.total);
            var newHeight = _this.containerHeight;
            if (_this.scrollElement) {
                heightChanged = _this.scrollElement.style.height !== newHeight + 'px';
                if (heightChanged) {
                    _this.scrollElement.style.height = newHeight + 'px';
                }
            }
            _this.scrollSyncing = false;
            return heightChanged;
        };
        this.scrollHandler = this.scrollHandler.bind(this);
    }
    Object.defineProperty(VirtualScroll.prototype, "translate", {
        get: function () {
            return this.listTranslate;
        },
        enumerable: false,
        configurable: true
    });
    VirtualScroll.prototype.changePage = function (skip, e) {
        var newSkip = Math.min(Math.max(0, skip), this.total - this.pageSize);
        if (newSkip !== this.skip && this.PageChange) {
            this.PageChange({ skip: newSkip, take: this.pageSize }, e);
        }
    };
    VirtualScroll.prototype.translateTo = function (dY) {
        this.listTranslate = dY;
        if (this.list) {
            this.list.style.transform = 'translateY(' + dY + 'px)';
        }
    };
    VirtualScroll.prototype.reset = function () {
        if (this.container) {
            this.calcScrollElementHeight();
            this.container.scrollTop = 0;
            this.translateTo(0);
        }
    };
    VirtualScroll.prototype.scrollToEnd = function () {
        if (this.container && this.list) {
            this.calcScrollElementHeight();
            this.container.scrollTop = this.container.scrollHeight - this.container.offsetHeight;
            this.translateTo(this.container.scrollHeight); //  - this.list.offsetHeight
        }
    };
    VirtualScroll.prototype.localScrollUp = function (e) {
        var height = this.itemHeight;
        var scrollTop = this.container.scrollTop;
        var targetTranslate = this.listTranslate;
        var items;
        var additionalOnTop = scrollTop - targetTranslate;
        if (additionalOnTop > height) {
            return;
        }
        for (items = 0; items < this.skip; items++) {
            if (targetTranslate + height + additionalOnTop <= scrollTop) {
                break;
            }
            targetTranslate -= height;
        }
        targetTranslate = this.validateTranslate(targetTranslate);
        if (this.skip - items <= 0 && targetTranslate >= scrollTop) {
            this.translateTo(0);
            this.changePage(0, e);
            this.container.scrollTop = 0;
            return;
        }
        if (targetTranslate !== this.listTranslate) {
            this.translateTo(targetTranslate);
            this.changePage(this.skip - items, e);
        }
    };
    VirtualScroll.prototype.localScrollDown = function (e) {
        var height = this.itemHeight;
        var scrollTop = this.container.scrollTop;
        var targetTranslate = this.listTranslate;
        var itemsLenght = this.list.children.length;
        var items;
        for (items = 0; items < itemsLenght; items++) {
            if (targetTranslate + height >= scrollTop) {
                break;
            }
            targetTranslate += height;
        }
        targetTranslate = this.validateTranslate(targetTranslate);
        if (items >= itemsLenght && this.skip + items >= this.total) {
            this.translateTo(targetTranslate);
            this.changePage(this.total - 1, e);
        }
        else if (targetTranslate !== this.listTranslate) {
            this.translateTo(targetTranslate);
            this.changePage(this.skip + items, e);
        }
    };
    VirtualScroll.prototype.scrollNonStrict = function (e) {
        var floatItemIndex = this.total * this.prevScrollPos / (this.containerHeight);
        var itemIndex = Math.min(Math.floor(floatItemIndex), this.total - 1);
        var targetTranslate = this.containerHeight * floatItemIndex / this.total;
        targetTranslate = this.validateTranslate(targetTranslate);
        this.translateTo(targetTranslate);
        this.changePage(itemIndex, e);
    };
    VirtualScroll.prototype.scrollHandler = function (e) {
        var scrollTop = this.container ? this.container.scrollTop : 0;
        var prev = this.prevScrollPos;
        this.prevScrollPos = scrollTop;
        if (!this.enabled || !this.list || !this.container || this.scrollSyncing) {
            return;
        }
        if (scrollTop - prev <= 0 && scrollTop > this.listTranslate - this.list.scrollHeight / 10) {
            this.localScrollUp(e);
        }
        else if (scrollTop - prev > 0 && scrollTop < this.listTranslate + this.list.scrollHeight * 2 / 3) {
            this.localScrollDown(e);
        }
        else {
            this.scrollNonStrict(e);
        }
    };
    VirtualScroll.prototype.validateTranslate = function (translate) {
        translate = Math.max(0, translate);
        // translate = Math.min(this.containerHeight - this.list!.offsetHeight, translate);
        translate = Math.min(this.containerHeight, translate);
        return translate;
    };
    return VirtualScroll;
}());
var VirtualScroll$2 = VirtualScroll$1;

/**
 * @hidden
 */
var Navigation$1 = /** @class */ (function () {
    function Navigation() {
    }
    Navigation.prototype.navigate = function (args) {
        var keyCode = args.keyCode;
        if (keyCode === Keys$1.up || keyCode === Keys$1.left) {
            return this.next({ current: args.current, min: args.min, max: args.max, step: -1 });
        }
        else if (keyCode === Keys$1.down || keyCode === Keys$1.right) {
            return this.next({ current: args.current, min: args.min, max: args.max, step: 1 });
        }
        else if (keyCode === Keys$1.home) {
            return 0;
        }
        else if (keyCode === Keys$1.end) {
            return args.max;
        }
    };
    Navigation.prototype.next = function (args) {
        if (!isPresent$1(args.current)) {
            return args.min;
        }
        else {
            return Math.min(args.max, Math.max(args.current + args.step, args.min));
        }
    };
    return Navigation;
}());

var __assign$N = (undefined && undefined.__assign) || function () {
    __assign$N = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$N.apply(this, arguments);
};
/**
 * @hidden
 */
var DropDownBase = /** @class */ (function () {
    function DropDownBase(component) {
        var _this = this;
        this.wrapper = null;
        this.list = null;
        this.vs = new VirtualScroll$2();
        this.navigation = new Navigation$1();
        this.handleItemClick = function (index, event) {
            var state = _this.initState();
            state.syntheticEvent = event;
            event.stopPropagation();
            _this.component.handleItemSelect(index, state);
            _this.togglePopup(state);
            _this.applyState(state);
        };
        this.handleFocus = function (event) {
            if (!_this.component.state.focused) {
                var state = _this.initState();
                state.data.focused = true;
                state.events.push({ type: 'onFocus' });
                state.syntheticEvent = event;
                _this.applyState(state);
            }
        };
        this.filterChanged = function (text, state) {
            var _a = _this.component.props, textField = _a.textField, filterable = _a.filterable;
            if (filterable) {
                state.events.push({
                    type: 'onFilterChange',
                    filter: {
                        field: textField,
                        operator: 'contains',
                        ignoreCase: true,
                        value: text
                    }
                });
            }
        };
        this.togglePopup = function (state) {
            var props = _this.component.props;
            var opened = props.opened !== undefined ? props.opened : _this.component.state.opened;
            if (props.opened === undefined) {
                state.data.opened = !opened;
            }
            if (opened) {
                state.events.push({ type: 'onClose' });
            }
            else {
                state.events.push({ type: 'onOpen' });
                _this.calculatePopupWidth();
            }
        };
        this.pageChange = function (page, syntheticEvent) {
            var state = _this.initState();
            state.syntheticEvent = syntheticEvent;
            _this.triggerOnPageChange(state, page.skip, page.take);
            _this.applyState(state);
        };
        this.scrollToVirtualItem = function (virtual, selectedItemIndex) {
            var vs = _this.vs;
            vs.enabled = false;
            if (virtual.skip === 0) {
                vs.reset();
            }
            else if (virtual.skip + virtual.pageSize === virtual.total) {
                vs.scrollToEnd();
            }
            else {
                var scrollTop = vs.translate;
                if (scrollTop === 0) {
                    vs.calcScrollElementHeight();
                    scrollTop = (vs.itemHeight * virtual.skip);
                    vs.translateTo(scrollTop - vs.itemHeight);
                }
                if (vs.container) {
                    vs.container.scrollTop = scrollTop;
                }
                _this.scrollToItem(selectedItemIndex, true);
            }
            window.setTimeout(function () { return vs.enabled = true; }, 10);
        };
        this.renderScrollElement = function () {
            var vs = _this.vs;
            return vs.enabled && (React.createElement("div", { ref: function (element) { return vs.scrollElement = element; }, key: 'scrollElementKey' }));
        };
        this.listBoxId = guid$1();
        this.guid = guid$1();
        this.component = component;
        this.vs.PageChange = this.pageChange;
    }
    DropDownBase.prototype.didMount = function () {
        var props = this.component.props;
        var popupSettings = props.popupSettings || {};
        var style = props.style || {};
        var popupWidth = popupSettings.width;
        var shouldUpdate = props.opened === true;
        if (popupWidth === undefined) {
            this.calculatePopupWidth();
        }
        if (props.dir === undefined && style.direction === undefined) {
            this.calculateDir();
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            this.component.forceUpdate();
        }
    };
    DropDownBase.prototype.calculateDir = function () {
        var element = this.component.element;
        if (element && element.ownerDocument && element.ownerDocument.defaultView) {
            this.dirCalculated = element.ownerDocument.defaultView.getComputedStyle(element).direction || undefined;
        }
    };
    DropDownBase.prototype.calculatePopupWidth = function () {
        if (this.wrapper) {
            this.popupWidth = this.wrapper.offsetWidth + 'px';
        }
    };
    DropDownBase.prototype.scrollToItem = function (itemIndex, vsEnabled) {
        var list = this.list || this.vs.list;
        if (list && itemIndex >= 0) {
            var vs = this.vs;
            var scrollElement = (vs.container || list.parentNode);
            var virtualScroll = vsEnabled !== undefined ? vsEnabled : vs.enabled;
            scrollToItem(scrollElement, list, itemIndex, vs.translate, virtualScroll);
        }
    };
    DropDownBase.prototype.initState = function () {
        var state = {
            data: {},
            events: [],
            syntheticEvent: undefined
        };
        return state;
    };
    DropDownBase.prototype.applyState = function (state) {
        var _this = this;
        if (Object.keys(state.data).length > 0) {
            this.component.setState(state.data);
        }
        var eventArgs = {
            syntheticEvent: state.syntheticEvent,
            nativeEvent: state.syntheticEvent ? state.syntheticEvent.nativeEvent : undefined,
            target: this.component,
            value: this.component.value
        };
        state.events.forEach(function (eventData) {
            var type = eventData.type;
            delete eventData.type;
            var handler = type && _this.component.props[type];
            if (handler) {
                handler.call(undefined, __assign$N(__assign$N({}, eventArgs), eventData));
            }
        });
    };
    DropDownBase.prototype.triggerOnPageChange = function (state, skip, take) {
        var virtual = this.component.props.virtual;
        if (virtual) {
            var newSkip = Math.min(Math.max(0, skip), Math.max(0, virtual.total - take));
            if (newSkip !== virtual.skip) {
                state.events.push({
                    type: 'onPageChange',
                    page: { skip: newSkip, take: take }
                });
            }
        }
    };
    DropDownBase.prototype.triggerPageChangeCornerItems = function (item, state) {
        var props = this.component.props;
        var _a = props.data, data = _a === void 0 ? [] : _a, dataItemKey = props.dataItemKey, virtual = props.virtual;
        var opened = props.opened !== undefined ? props.opened : this.component.state.opened;
        if (item && virtual && this.vs.enabled) {
            if (virtual.skip > 0 && areSame(item, data[0], dataItemKey)) {
                this.triggerOnPageChange(state, virtual.skip - 1, virtual.pageSize);
            }
            else if (!opened && virtual.skip + virtual.pageSize < virtual.total &&
                areSame(item, data[data.length - 1], dataItemKey)) {
                this.triggerOnPageChange(state, virtual.skip + 1, virtual.pageSize);
            }
        }
    };
    DropDownBase.prototype.getPopupSettings = function () {
        return Object
            .assign({}, DropDownBase.defaultProps.popupSettings, this.component.props.popupSettings);
    };
    DropDownBase.basicPropTypes = {
        opened: propTypes.exports.bool,
        disabled: propTypes.exports.bool,
        dir: propTypes.exports.string,
        tabIndex: propTypes.exports.number,
        accessKey: propTypes.exports.string,
        data: propTypes.exports.array,
        textField: propTypes.exports.string,
        className: propTypes.exports.string,
        label: propTypes.exports.string,
        loading: propTypes.exports.bool,
        popupSettings: propTypes.exports.shape({
            animate: propTypes.exports.oneOfType([propTypes.exports.bool, propTypes.exports.shape({
                    openDuration: propTypes.exports.number,
                    closeDuration: propTypes.exports.number
                })]),
            popupClass: propTypes.exports.string,
            className: propTypes.exports.string,
            appendTo: propTypes.exports.any,
            width: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
            height: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
        }),
        onOpen: propTypes.exports.func,
        onClose: propTypes.exports.func,
        onFocus: propTypes.exports.func,
        onBlur: propTypes.exports.func,
        onChange: propTypes.exports.func,
        itemRender: propTypes.exports.func,
        listNoDataRender: propTypes.exports.func,
        focusedItemIndex: propTypes.exports.func,
        header: propTypes.exports.node,
        footer: propTypes.exports.node
    };
    DropDownBase.propTypes = __assign$N(__assign$N({}, DropDownBase.basicPropTypes), { value: propTypes.exports.any, defaultValue: propTypes.exports.any, filterable: propTypes.exports.bool, filter: propTypes.exports.string, virtual: propTypes.exports.shape({
            pageSize: propTypes.exports.number.isRequired,
            skip: propTypes.exports.number.isRequired,
            total: propTypes.exports.number.isRequired
        }), onFilterChange: propTypes.exports.func, onPageChange: propTypes.exports.func });
    DropDownBase.defaultProps = {
        popupSettings: {
            height: '200px'
        },
        required: false,
        validityStyles: true
    };
    return DropDownBase;
}());
var DropDownBase$1 = DropDownBase;

/**
 * @hidden
 */
var packageMetadata$9 = {
    name: '@progress/kendo-react-dropdowns',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770752,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

/**
 * @hidden
 */
var packageMetadata$8 = {
    name: '@progress/kendo-react-buttons',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770563,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$P = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$M = (undefined && undefined.__assign) || function () {
    __assign$M = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$M.apply(this, arguments);
};
var __rest$e = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @hidden
 */
function iconElement$1(_a) {
    var imageUrl = _a.imageUrl, icon = _a.icon, iconClass = _a.iconClass, imageAlt = _a.imageAlt;
    if (imageUrl) {
        return (React.createElement("img", { role: "presentation", className: 'k-button-icon', alt: imageAlt, src: imageUrl }));
    }
    else if (icon) {
        var iconClasses = classNames$2('k-button-icon k-icon', 'k-i-' + icon);
        return (React.createElement("span", { role: "presentation", className: iconClasses }));
    }
    else if (iconClass) {
        return (React.createElement("span", { role: "presentation", className: classNames$2('k-button-icon', iconClass) }));
    }
    return null;
}
var Button$2 = /** @class */ (function (_super) {
    __extends$P(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this._element = null;
        _this.handleClick = function (event) {
            _this.toggleIfApplicable();
            if (_this.props.onClick) {
                _this.props.onClick.call(undefined, event);
            }
        };
        validatePackage$2(packageMetadata$8);
        _this.state = { selected: _this.props.togglable === true && _this.props.selected === true };
        return _this;
    }
    Object.defineProperty(Button.prototype, "element", {
        /**
         * Gets the DOM element of the Button component.
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "selected", {
        /**
         * Returns `true` when the component is togglable and selected ([see example]({% slug toggleable_button %})).
         * Otherwise, returns `false`.
         */
        get: function () {
            return this._selectedTemp !== undefined ? this._selectedTemp : this.state.selected;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    Button.getDerivedStateFromProps = function (props, state) {
        if (props.togglable && props.selected !== undefined && props.selected !== state.selected) {
            return { selected: props.selected };
        }
        return null;
    };
    /**
     * @hidden
     */
    Button.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, children = _b.children, togglable = _b.togglable, icon = _b.icon, iconClass = _b.iconClass, imageUrl = _b.imageUrl, imageAlt = _b.imageAlt; _b.className; _b.onClick; var _c = _b.size, size = _c === void 0 ? Button.defaultProps.size : _c, _d = _b.shape, shape = _d === void 0 ? Button.defaultProps.shape : _d, _e = _b.rounded, rounded = _e === void 0 ? Button.defaultProps.rounded : _e, _f = _b.fillMode, fillMode = _f === void 0 ? Button.defaultProps.fillMode : _f, _g = _b.themeColor, themeColor = _g === void 0 ? Button.defaultProps.themeColor : _g, htmlAttributes = __rest$e(_b, ["children", "togglable", "icon", "iconClass", "imageUrl", "imageAlt", "className", "onClick", "size", "shape", "rounded", "fillMode", "themeColor"]);
        var hasIcon = (icon !== undefined || iconClass !== undefined || imageUrl !== undefined);
        var hasChildren = children !== undefined;
        var iconEl = iconElement$1({
            icon: icon,
            iconClass: iconClass,
            imageUrl: imageUrl,
            imageAlt: imageAlt
        });
        return (React.createElement("button", __assign$M({ ref: function (button) { return _this._element = button; }, "aria-pressed": togglable ? this.state.selected : undefined }, htmlAttributes, { onClick: this.handleClick, className: classNames$2('k-button', (_a = {},
                _a["k-button-".concat(kendoThemeMaps$1.sizeMap[size] || size)] = size,
                _a["k-button-".concat(shape)] = shape,
                _a["k-button-".concat(fillMode)] = fillMode,
                _a["k-button-".concat(fillMode, "-").concat(themeColor)] = Boolean(fillMode && themeColor),
                _a["k-rounded-".concat(kendoThemeMaps$1.roundedMap[rounded] || rounded)] = rounded,
                _a['k-icon-button'] = !hasChildren && hasIcon,
                _a['k-disabled'] = this.props.disabled,
                _a['k-selected'] = this.state.selected,
                _a['k-rtl'] = this.props.dir === 'rtl',
                _a), this.props.className) }),
            iconEl,
            children && (React.createElement("span", { className: "k-button-text" }, children))));
    };
    Button.prototype.toggleIfApplicable = function () {
        var _this = this;
        if (this.props.togglable && this.props.selected === undefined) {
            var selected = !this.state.selected;
            this._selectedTemp = selected;
            this.setState({ selected: selected }, function () { return _this._selectedTemp = undefined; });
        }
    };
    /**
     * @hidden
     */
    Button.propTypes = {
        children: propTypes.exports.node,
        selected: propTypes.exports.bool,
        togglable: propTypes.exports.bool,
        icon: propTypes.exports.string,
        iconClass: propTypes.exports.string,
        imageUrl: propTypes.exports.string,
        imageAlt: propTypes.exports.string,
        size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
        shape: propTypes.exports.oneOf([null, 'rectangle', 'square']),
        rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
        fillMode: propTypes.exports.oneOf([null, 'flat', 'link', 'outline', 'solid']),
        // eslint-disable-next-line max-len
        themeColor: propTypes.exports.oneOf([null, 'base', 'primary', 'secondary', 'tertiary', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse'])
    };
    /**
     * @hidden
     */
    Button.defaultProps = {
        togglable: false,
        size: 'medium',
        shape: null,
        rounded: 'medium',
        fillMode: 'solid',
        themeColor: 'base'
    };
    return Button;
}(React.Component));

var __extends$O = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$L = (undefined && undefined.__assign) || function () {
    __assign$L = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$L.apply(this, arguments);
};
var VALIDATION_MESSAGE$2 = 'Please select a value from the list!';
var sizeMap = kendoThemeMaps$1.sizeMap, roundedMap = kendoThemeMaps$1.roundedMap;
/**
 * @hidden
 */
var DropDownListWithoutContext = /** @class */ (function (_super) {
    __extends$O(DropDownListWithoutContext, _super);
    function DropDownListWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.state = {};
        _this._element = null;
        _this.base = new DropDownBase$1(_this);
        _this.searchState = { word: '', last: '' };
        _this._select = null;
        _this._skipFocusEvent = false;
        _this._filterInput = null;
        _this._navigated = false;
        /**
         * @hidden
         */
        _this.focus = function () {
            if (_this.base.wrapper) {
                _this.base.wrapper.focus();
            }
        };
        /**
         * @hidden
         */
        _this.handleItemSelect = function (index, state) {
            var _a = _this.props, _b = _a.data, data = _b === void 0 ? [] : _b, virtual = _a.virtual, dataItemKey = _a.dataItemKey, defaultItem = _a.defaultItem;
            var skip = virtual ? virtual.skip : 0;
            var item = (index === -1 && defaultItem !== undefined) ?
                defaultItem : data[index - skip];
            var newSelected = !areSame(item, _this.value, dataItemKey);
            _this.triggerOnChange(item, state);
            if (newSelected) {
                _this.base.triggerPageChangeCornerItems(item, state);
            }
        };
        _this.componentRef = function (element) {
            _this._element = element;
            _this.base.wrapper = element;
        };
        _this.dummySelect = function (value) {
            /* Dummy component to support forms */
            return (React.createElement("select", { name: _this.props.name, ref: function (el) { _this._select = el; }, tabIndex: -1, "aria-hidden": true, title: _this.props.label, style: { opacity: 0, width: 1, border: 0, zIndex: -1, position: 'absolute', left: '50%' } },
                React.createElement("option", { value: _this.props.valueMap ? _this.props.valueMap.call(undefined, value) : value })));
        };
        _this.renderListContainer = function () {
            var _a;
            var _b = _this.props, header = _b.header, footer = _b.footer, dir = _b.dir, _c = _b.data, data = _c === void 0 ? [] : _c, size = _b.size;
            var base = _this.base;
            var popupSettings = base.getPopupSettings();
            var opened = _this.props.opened !== undefined ? _this.props.opened : _this.state.opened;
            var popupWidth = popupSettings.width !== undefined ? popupSettings.width : base.popupWidth;
            var listContainerProps = {
                dir: dir !== undefined ? dir : base.dirCalculated,
                width: popupWidth,
                popupSettings: {
                    popupClass: classNames$2(popupSettings.popupClass, 'k-list-container'),
                    className: popupSettings.className,
                    animate: popupSettings.animate,
                    anchor: _this.element,
                    show: opened,
                    onOpen: _this.onPopupOpened,
                    onClose: _this.onPopupClosed,
                    appendTo: popupSettings.appendTo
                },
                itemsCount: [data.length]
            };
            return (React.createElement(ListContainer$1, __assign$L({}, listContainerProps),
                _this.renderListFilter(),
                header && React.createElement("div", { className: "k-list-header" }, header),
                React.createElement("div", { className: classNames$2('k-list', (_a = {}, _a["k-list-".concat(sizeMap[size] || size)] = size, _a['k-virtual-list'] = _this.base.vs.enabled, _a)) },
                    _this.renderDefaultItem(),
                    _this.renderList()),
                footer && React.createElement("div", { className: "k-list-footer" }, footer)));
        };
        _this.renderList = function () {
            var _a = _this.props, _b = _a.data, data = _b === void 0 ? [] : _b, textField = _a.textField, dataItemKey = _a.dataItemKey, _c = _a.virtual, virtual = _c === void 0 ? { skip: 0 } : _c, listNoDataRender = _a.listNoDataRender, itemRender = _a.itemRender;
            var vs = _this.base.vs;
            var skip = virtual.skip;
            var opened = _this.props.opened !== undefined ? _this.props.opened : _this.state.opened;
            var popupSettings = _this.base.getPopupSettings();
            var translate = "translateY(".concat(vs.translate, "px)");
            return (React.createElement(List$1, { id: _this.base.listBoxId, show: opened, data: data.slice(), focusedIndex: _this.focusedIndex(), value: _this.value, textField: textField, valueField: dataItemKey, optionsGuid: _this.base.guid, listRef: function (list) { return vs.list = _this.base.list = list; }, wrapperStyle: { maxHeight: popupSettings.height }, wrapperCssClass: "k-list-content", listStyle: vs.enabled ? { transform: translate } : undefined, key: "listkey", skip: skip, onClick: _this.handleItemClick, itemRender: itemRender, noDataRender: listNoDataRender, onScroll: function (e) {
                    vs.scrollHandler(e);
                }, wrapperRef: vs.scrollerRef, scroller: _this.base.renderScrollElement() }));
        };
        _this.renderListFilter = function () {
            var filterText = _this.props.filter !== undefined ? _this.props.filter : _this.state.text;
            return _this.props.filterable && (React.createElement(ListFilter$1, { value: filterText, ref: function (filter) { return _this._filterInput = filter && filter.input; }, onChange: _this.handleListFilterChange, onKeyDown: _this.handleKeyDown, size: _this.props.size, rounded: _this.props.rounded, fillMode: _this.props.fillMode }));
        };
        _this.renderDefaultItem = function () {
            var _a = _this.props, textField = _a.textField, defaultItem = _a.defaultItem, dataItemKey = _a.dataItemKey;
            return defaultItem !== undefined && (React.createElement(ListDefaultItem$1, { defaultItem: defaultItem, textField: textField, selected: areSame(_this.value, defaultItem, dataItemKey), key: "defaultitemkey", onClick: _this.handleDefaultItemClick }));
        };
        _this.search = function (event) {
            clearTimeout(_this._typingTimeout);
            if (!_this.props.filterable) {
                _this._typingTimeout = window.setTimeout(function () { return _this.searchState.word = ''; }, _this.props.delay);
                _this.selectNext(event);
            }
        };
        _this.selectNext = function (event) {
            var _a = _this.props, _b = _a.data, data = _b === void 0 ? [] : _b, dataItemKey = _a.dataItemKey;
            var mappedData = data.map(function (item, idx) {
                return { item: item, itemIndex: idx };
            });
            var word = _this.searchState.word;
            var last = _this.searchState.last;
            var isInLoop = sameCharsOnly(word, last);
            var dataLength = mappedData.length;
            var startIndex = Math.max(0, data.findIndex(function (i) { return areSame(i, _this.value, dataItemKey); }));
            var defaultItem;
            if (_this.props.defaultItem) {
                defaultItem = { item: _this.props.defaultItem, itemIndex: -1 };
                dataLength += 1;
                startIndex += 1;
            }
            startIndex += isInLoop ? 1 : 0;
            mappedData = shuffleData(mappedData, startIndex, defaultItem);
            var text, loopMatch, nextMatch, index = 0;
            var _c = _this.props, textField = _c.textField, ignoreCase = _c.ignoreCase;
            for (; index < dataLength; index++) {
                text = getItemValue(mappedData[index].item, textField);
                loopMatch = isInLoop && matchText(text, last, ignoreCase);
                nextMatch = matchText(text, word, ignoreCase);
                if (loopMatch || nextMatch) {
                    index = mappedData[index].itemIndex;
                    break;
                }
            }
            if (index !== dataLength) {
                var state = _this.base.initState();
                state.syntheticEvent = event;
                _this.handleItemSelect(index, state);
                _this.applyState(state);
                _this._valueDuringOnChange = undefined;
            }
        };
        _this.handleKeyDown = function (event) {
            var _a = _this.props, _b = _a.data, data = _b === void 0 ? [] : _b, filterable = _a.filterable, disabled = _a.disabled, _c = _a.leftRightKeysNavigation, leftRightKeysNavigation = _c === void 0 ? true : _c, _d = _a.virtual, virtual = _d === void 0 ? { skip: 0, total: 0, pageSize: 0 } : _d;
            var opened = _this.props.opened !== undefined ? _this.props.opened : _this.state.opened;
            var keyCode = event.keyCode;
            var homeOrEndKeys = keyCode === Keys$1.home || keyCode === Keys$1.end;
            var upOrDownKeys = keyCode === Keys$1.up || keyCode === Keys$1.down;
            var shouldOpen = !opened &&
                ((event.altKey && keyCode === Keys$1.down) || keyCode === Keys$1.enter || keyCode === Keys$1.space);
            var shouldClose = opened && ((event.altKey && keyCode === Keys$1.up) || keyCode === Keys$1.esc);
            var leftOrRightKeys = leftRightKeysNavigation && (keyCode === Keys$1.left || keyCode === Keys$1.right);
            var shouldNavigate = upOrDownKeys || (!filterable && (leftOrRightKeys || homeOrEndKeys));
            var state = _this.base.initState();
            state.syntheticEvent = event;
            if (disabled) {
                return;
            }
            else if (homeOrEndKeys && _this.base.vs.enabled) {
                if (keyCode === Keys$1.home) {
                    if (virtual.skip !== 0) {
                        _this.base.triggerOnPageChange(state, 0, virtual.pageSize);
                        _this._navigated = true;
                    }
                    else {
                        _this.triggerOnChange(data[0], state);
                    }
                }
                else {
                    if (virtual.skip < virtual.total - virtual.pageSize) {
                        _this.base.triggerOnPageChange(state, virtual.total - virtual.pageSize, virtual.pageSize);
                        _this._navigated = true;
                    }
                    else {
                        _this.triggerOnChange(data[data.length - 1], state);
                    }
                }
            }
            else if (opened && keyCode === Keys$1.enter) {
                var focusedIndex = _this.focusedIndex();
                if (focusedIndex !== undefined) {
                    _this.handleItemSelect(focusedIndex, state);
                }
                _this.base.togglePopup(state);
                event.preventDefault();
            }
            else if (shouldOpen || shouldClose) {
                _this.base.togglePopup(state);
                event.preventDefault();
            }
            else if (shouldNavigate) {
                _this.onNavigate(state, keyCode);
                event.preventDefault();
            }
            _this.applyState(state);
        };
        _this.handleItemClick = function (index, event) {
            _this.base.handleItemClick(index, event);
            _this._valueDuringOnChange = undefined;
        };
        _this.handleFocus = function (event) {
            if (_this._skipFocusEvent) {
                return;
            }
            _this.base.handleFocus(event);
        };
        _this.handleBlur = function (event) {
            if (_this._skipFocusEvent || !_this.state.focused) {
                return;
            }
            var opened = _this.props.opened !== undefined ? _this.props.opened : _this.state.opened;
            var state = _this.base.initState();
            state.syntheticEvent = event;
            state.data.focused = false;
            state.events.push({ type: 'onBlur' });
            if (opened) {
                _this.base.togglePopup(state);
            }
            _this.applyState(state);
        };
        _this.handleDefaultItemClick = function (event) {
            var state = _this.base.initState();
            state.syntheticEvent = event;
            _this.base.togglePopup(state);
            _this.triggerOnChange(_this.props.defaultItem, state);
            _this.applyState(state);
        };
        _this.handleWrapperClick = function (event) {
            if (event.isPropagationStopped()) {
                return;
            }
            var state = _this.base.initState();
            state.syntheticEvent = event;
            if (!_this.state.focused) {
                state.data.focused = true;
            }
            _this.base.togglePopup(state);
            _this.applyState(state);
        };
        _this.handleKeyPress = function (event) {
            if (_this.props.filterable || event.which === 0 || event.keyCode === Keys$1.enter) {
                return;
            }
            var character = String.fromCharCode(event.charCode || event.keyCode);
            if (_this.props.ignoreCase) {
                character = character.toLowerCase();
            }
            if (character === ' ') {
                event.preventDefault();
            }
            _this.searchState = {
                word: _this.searchState.word + character,
                last: _this.searchState.last + character
            };
            _this.search(event);
        };
        _this.handleListFilterChange = function (event) {
            var state = _this.base.initState();
            state.syntheticEvent = event;
            if (_this.props.filter === undefined) {
                state.data.text = event.target.value;
            }
            _this.base.filterChanged(event.target.value, state);
            _this.applyState(state);
        };
        _this.onPopupOpened = function () {
            if (_this._filterInput) {
                _this.focusElement(_this._filterInput);
            }
        };
        _this.onPopupClosed = function () {
            if (_this.state.focused) {
                window.setTimeout(function () {
                    if (_this.state.focused && _this.base.wrapper) {
                        _this.focusElement(_this.base.wrapper);
                    }
                });
            }
        };
        _this.setValidity = function () {
            if (_this._select && _this._select.setCustomValidity) {
                _this._select.setCustomValidity(_this.validity.valid
                    ? ''
                    : _this.props.validationMessage || VALIDATION_MESSAGE$2);
            }
        };
        validatePackage$2(packageMetadata$9);
        return _this;
    }
    Object.defineProperty(DropDownListWithoutContext.prototype, "element", {
        /**
         * @hidden
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropDownListWithoutContext.prototype, "value", {
        /**
         * The value of the DropDownList.
         */
        get: function () {
            var value;
            if (this._valueDuringOnChange !== undefined) {
                value = this._valueDuringOnChange;
            }
            else if (this.props.value !== undefined) {
                value = this.props.value;
            }
            else if (this.state.value !== undefined) {
                value = this.state.value;
            }
            else if (this.props.defaultValue !== undefined) {
                value = this.props.defaultValue;
            }
            if (!isPresent$1(value) && this.props.defaultItem !== undefined) {
                value = this.props.defaultItem;
            }
            return value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropDownListWithoutContext.prototype, "index", {
        /**
         * The index of the selected item.
         */
        get: function () {
            var _a = this.props, _b = _a.data, data = _b === void 0 ? [] : _b, dataItemKey = _a.dataItemKey;
            var value = this.value;
            // TO DO: deprecate it!
            return data.findIndex(function (i) { return areSame(i, value, dataItemKey); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropDownListWithoutContext.prototype, "name", {
        /**
         * Gets the `name` property of the DropDownList.
         */
        get: function () {
            return this.props.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropDownListWithoutContext.prototype, "validity", {
        /**
         * Represents the validity state into which the DropDownList is set.
         */
        get: function () {
            var customError = this.props.validationMessage !== undefined;
            var isValid = (!this.required
                || (this.value !== null && this.value !== '' && this.value !== undefined));
            var valid = this.props.valid !== undefined ? this.props.valid : isValid;
            return {
                customError: customError,
                valid: valid,
                valueMissing: this.value === null
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropDownListWithoutContext.prototype, "validityStyles", {
        get: function () {
            return this.props.validityStyles !== undefined
                ? this.props.validityStyles
                : DropDownListWithoutContext.defaultProps.validityStyles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropDownListWithoutContext.prototype, "required", {
        /**
         * @hidden
         */
        get: function () {
            return this.props.required !== undefined
                ? this.props.required
                : DropDownListWithoutContext.defaultProps.required;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    DropDownListWithoutContext.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, _b = _a.data, data = _b === void 0 ? [] : _b, dataItemKey = _a.dataItemKey, virtual = _a.virtual;
        var prevTotal = prevProps.virtual ? prevProps.virtual.total : 0;
        var opened = this.props.opened !== undefined ? this.props.opened : this.state.opened;
        var prevOpened = prevProps.opened !== undefined ? prevProps.opened : prevState.opened;
        var opening = !prevOpened && opened;
        if (!this.base.getPopupSettings().animate) {
            if (opening) {
                this.onPopupOpened();
            }
        }
        if (virtual && virtual.total !== prevTotal) {
            this.base.vs.calcScrollElementHeight();
            this.base.vs.reset();
        }
        else {
            var selectedItem_1 = this.value;
            var prevSelectedItem = prevProps.value !== undefined ? prevProps.value : prevState.value;
            var selectedItemIndex = data.findIndex(function (i) { return areSame(i, selectedItem_1, dataItemKey); });
            var selectedItemChanged = !areSame(prevSelectedItem, selectedItem_1, dataItemKey);
            if (opening && virtual) {
                this.base.scrollToVirtualItem(virtual, selectedItemIndex);
            }
            else if (opening && !virtual) {
                this.base.scrollToItem(selectedItemIndex);
            }
            else if (opened && prevOpened && selectedItem_1 && selectedItemChanged && !this._navigated) {
                this.base.scrollToItem(selectedItemIndex);
            }
            else if (opened && prevOpened && this._navigated) {
                if (this._navigated && virtual && virtual.skip === 0) {
                    this.base.vs.reset();
                }
                else if (this._navigated && virtual && virtual.skip === virtual.total - virtual.pageSize) {
                    this.base.vs.scrollToEnd();
                }
            }
        }
        this._navigated = false;
        this.setValidity();
    };
    /**
     * @hidden
     */
    DropDownListWithoutContext.prototype.componentDidMount = function () {
        this.base.didMount();
        this.setValidity();
    };
    /**
     * @hidden
     */
    DropDownListWithoutContext.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, style = _b.style, className = _b.className, label = _b.label, dir = _b.dir, virtual = _b.virtual, size = _b.size, rounded = _b.rounded, fillMode = _b.fillMode;
        var opened = this.props.opened !== undefined ? this.props.opened : this.state.opened;
        var value = this.value;
        var text = getItemValue(value, this.props.textField);
        var isValid = !this.validityStyles || this.validity.valid;
        var base = this.base;
        var vs = base.vs;
        vs.enabled = virtual !== undefined;
        if (virtual !== undefined) {
            base.vs.skip = virtual.skip;
            base.vs.total = virtual.total;
            base.vs.pageSize = virtual.pageSize;
        }
        var _c = this.props, dataItemKey = _c.dataItemKey, _d = _c.data, data = _d === void 0 ? [] : _d, disabled = _c.disabled, tabIndex = _c.tabIndex, loading = _c.loading, iconClassName = _c.iconClassName, valueRender = _c.valueRender;
        var focused = this.state.focused;
        var selectedIndex = data.findIndex(function (i) { return areSame(i, value, dataItemKey); });
        var valueDefaultRendering = (React.createElement("span", { className: "k-input-inner" },
            React.createElement("span", { className: "k-input-value-text" }, text)));
        var valueElement = valueRender !== undefined ?
            valueRender.call(undefined, valueDefaultRendering, value) : valueDefaultRendering;
        var dropdownlist = (React.createElement("span", { ref: this.componentRef, className: classNames$2('k-dropdownlist k-picker', className, (_a = {},
                _a["k-picker-".concat(sizeMap[size] || size)] = size,
                _a["k-rounded-".concat(roundedMap[rounded] || rounded)] = rounded,
                _a["k-picker-".concat(fillMode)] = fillMode,
                _a['k-focus'] = focused,
                _a['k-disabled'] = disabled,
                _a['k-invalid'] = !isValid,
                _a['k-loading'] = loading,
                _a['k-required'] = this.required,
                _a)), style: !label
                ? style
                : __assign$L(__assign$L({}, style), { width: undefined }), dir: dir, onMouseDown: opened ? preventDefaultNonInputs : undefined, onFocus: this.handleFocus, onBlur: this.handleBlur, tabIndex: getTabIndex(tabIndex, disabled), accessKey: this.props.accessKey, onKeyDown: this.handleKeyDown, onKeyPress: this.handleKeyPress, onClick: disabled ? undefined : this.handleWrapperClick, role: 'combobox', "aria-required": this.required, "aria-disabled": disabled || undefined, "aria-haspopup": 'listbox', "aria-expanded": opened || false, "aria-owns": this.base.listBoxId, "aria-activedescendant": opened ? ('option-' + this.base.guid + '-' + (selectedIndex + (virtual ? virtual.skip : 0))) : undefined, "aria-label": this.props.ariaLabel || this.props.label, "aria-labelledby": this.props.ariaLabelledBy, "aria-describedby": this.props.ariaDescribedBy, id: this.props.id, title: this.props.title },
            valueElement,
            loading && React.createElement("span", { className: "k-icon k-i-loading k-input-loading-icon", key: "loading" }),
            React.createElement(Button$2, { tabIndex: -1, type: "button", "aria-hidden": true, size: size, fillMode: fillMode, iconClass: iconClassName, className: "k-input-button", themeColor: 'base', icon: !iconClassName ? 'caret-alt-down' : undefined, onMouseDown: function (e) { return _this.state.focused && e.preventDefault(); } }),
            this.dummySelect(value),
            this.renderListContainer()));
        return label ? (React.createElement(FloatingLabel, { label: label, editorValue: text, editorValid: isValid, editorDisabled: this.props.disabled, style: { width: style ? style.width : undefined }, children: dropdownlist })) : dropdownlist;
    };
    /**
     * @hidden
     */
    DropDownListWithoutContext.prototype.onNavigate = function (state, keyCode) {
        var _a = this.props, _b = _a.data, data = _b === void 0 ? [] : _b, defaultItem = _a.defaultItem, dataItemKey = _a.dataItemKey, _c = _a.virtual, virtual = _c === void 0 ? { skip: 0, total: 0, pageSize: 0 } : _c;
        var vs = this.base.vs;
        var value = this.value;
        var index = data.findIndex(function (i) { return areSame(i, value, dataItemKey); });
        var newIndex = this.base.navigation.navigate({
            current: virtual.skip + index,
            max: (vs.enabled ? virtual.total : data.length) - 1,
            min: defaultItem !== undefined ? -1 : 0,
            keyCode: keyCode
        });
        if (newIndex !== undefined) {
            this.handleItemSelect(newIndex, state);
        }
        this.applyState(state);
    };
    DropDownListWithoutContext.prototype.focusedIndex = function () {
        var filterText = isPresent$1(this.props.filter) ? this.props.filter : this.state.text;
        var _a = this.props, _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.virtual, virtual = _c === void 0 ? { skip: 0 } : _c, dataItemKey = _a.dataItemKey, textField = _a.textField, focusedItemIndex = _a.focusedItemIndex;
        var value = this.value;
        var selectedIndex = data.findIndex(function (i) { return areSame(i, value, dataItemKey); });
        var hasSelected = !(selectedIndex < 0 && !this.props.defaultItem);
        if (!hasSelected && filterText && virtual.skip === 0) {
            return focusedItemIndex ? focusedItemIndex(data, filterText, textField) :
                data.indexOf(getFocusedItem(data, filterText, textField));
        }
        else {
            return !hasSelected && virtual.skip === 0 ? 0 : undefined;
        }
    };
    DropDownListWithoutContext.prototype.focusElement = function (element) {
        var _this = this;
        this._skipFocusEvent = true;
        element.focus();
        window.setTimeout(function () { return _this._skipFocusEvent = false; }, 30);
    };
    DropDownListWithoutContext.prototype.triggerOnChange = function (item, state) {
        if (areSame(this.value, item, this.props.dataItemKey)) {
            return;
        }
        if (this.props.value === undefined) {
            state.data.value = item;
        }
        this._valueDuringOnChange = item;
        state.events.push({ type: 'onChange' });
    };
    DropDownListWithoutContext.prototype.applyState = function (state) {
        this.base.applyState(state);
        this._valueDuringOnChange = undefined;
    };
    DropDownListWithoutContext.displayName = 'DropDownList';
    /**
     * @hidden
     */
    DropDownListWithoutContext.propTypes = __assign$L({ delay: propTypes.exports.number, ignoreCase: propTypes.exports.bool, iconClassName: propTypes.exports.string, defaultItem: propTypes.exports.any, valueRender: propTypes.exports.func, valueMap: propTypes.exports.func, validationMessage: propTypes.exports.string, required: propTypes.exports.bool, id: propTypes.exports.string, ariaLabelledBy: propTypes.exports.string, ariaDescribedBy: propTypes.exports.string, ariaLabel: propTypes.exports.string, leftRightKeysNavigation: propTypes.exports.bool, title: propTypes.exports.string }, DropDownBase$1.propTypes);
    /**
     * @hidden
     */
    DropDownListWithoutContext.defaultProps = __assign$L(__assign$L({ delay: 500, tabIndex: 0, ignoreCase: true }, DropDownBase$1.defaultProps), { required: false, size: 'medium', rounded: 'medium', fillMode: 'solid' });
    return DropDownListWithoutContext;
}(React.Component));
/**
 * Represents the PropsContext of the `DropDownList` component.
 * Used for global configuration of all `DropDownList` instances.
 *
 * For more information, refer to the [Dropdowns Props Context]({% slug props-context_dropdowns %}) article.
 */
var DropDownListPropsContext = createPropsContext();
/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the component the same as the type */
/**
 * Represents the [KendoReact DropDownList component]({% slug overview_dropdownlist %}).
 *
 * Accepts properties of type [DropDownListProps]({% slug api_dropdowns_dropdownlistprops %}).
 * Obtaining the `ref` returns an object of type [DropDownListHandle]({% slug api_dropdowns_dropdownlisthandle %}).
 *
 * @example
 * ```jsx
 * class App extends React.Component {
 *    dropdownlist = null;
 *    render() {
 *       return (
 *          <div>
 *              <DropDownList
 *                  data={[ "Albania", "Andorra", "Austria", "Belarus" ]}
 *                  ref={component => this.dropdownlist = component}
 *              />
 *              <button onClick={() => alert(this.dropdownlist.value)}>alert value</button>
 *          </div>
 *       );
 *    }
 * }
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var DropDownList = withPropsContext(DropDownListPropsContext, DropDownListWithoutContext);
DropDownList.displayName = 'KendoReactDropDownList';

const caretAltRightIcon = {
    name: 'caret-alt-right',
    content: '<path d="M352 256 160 384V128l192 128z" />',
    viewBox: '0 0 512 512'
};

const caretAltDownIcon = {
    name: 'caret-alt-down',
    content: '<path d="M256 352 128 160h256L256 352z" />',
    viewBox: '0 0 512 512'
};

const moreVerticalIcon = {
    name: 'more-vertical',
    content: '<path d="M240 128c26.4 0 48-21.6 48-48s-21.6-48-48-48-48 21.6-48 48 21.6 48 48 48zm0 64c-26.4 0-48 21.6-48 48s21.6 48 48 48 48-21.6 48-48-21.6-48-48-48zm0 160c-26.4 0-48 21.6-48 48s21.6 48 48 48 48-21.6 48-48-21.6-48-48-48z" />',
    viewBox: '0 0 512 512'
};

const xIcon = {
    name: 'x',
    content: '<path d="M416 141.3 301.3 256 416 370.7 370.7 416 256 301.3 141.3 416 96 370.7 210.7 256 96 141.3 141.3 96 256 210.7 370.7 96l45.3 45.3z" />',
    viewBox: '0 0 512 512'
};

const xCircleIcon = {
    name: 'x-circle',
    content: '<path d="M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm128 306.7L338.7 384 256 301.3 173.3 384 128 338.7l82.7-82.7-82.7-82.7 45.3-45.3 82.7 82.7 82.7-82.7 45.3 45.3-82.7 82.7 82.7 82.7z" />',
    viewBox: '0 0 512 512'
};

const plusIcon = {
    name: 'plus',
    content: '<path d="M288 224V96h-64v128H96v64h128v128h64V288h128v-64H288z" />',
    viewBox: '0 0 512 512'
};

const minusIcon = {
    name: 'minus',
    content: '<path d="M96 224v64h320v-64H96z" />',
    viewBox: '0 0 512 512'
};

const sortAscSmallIcon = {
    name: 'sort-asc-small',
    content: '<path d="M256 192v224h-32V192h-96L240 64l112 128h-96z" />',
    viewBox: '0 0 512 512'
};

const sortDescSmallIcon = {
    name: 'sort-desc-small',
    content: '<path d="M352 288 240 416 128 288h96V64h32v224h96z" />',
    viewBox: '0 0 512 512'
};

const filterIcon = {
    name: 'filter',
    content: '<path d="M64 64v32l160 160v224l64-64V256L448 96V64H64z" />',
    viewBox: '0 0 512 512'
};

const filterClearIcon = {
    name: 'filter-clear',
    content: '<path d="m143.5 64 168.2 168.2L288 256v160l-64 64V256L64 96V64h79.5zm236.1 100.4L448 96V64H279.3l-64-64L192 22l298 298 22-23.3-132.4-132.3z" />',
    viewBox: '0 0 512 512'
};

const searchIcon = {
    name: 'search',
    content: '<path d="M365.3 320h-22.7l-26.7-26.7C338.5 265.7 352 230.4 352 192c0-88.4-71.6-160-160-160S32 103.6 32 192s71.6 160 160 160c38.4 0 73.7-13.5 101.3-36.1l26.7 26.7v22.7L434.7 480l45.3-45.3L365.3 320zM64 192c0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128S64 262.7 64 192z" />',
    viewBox: '0 0 512 512'
};

/**
 * @hidden
 */
var classNames$1 = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    var addLeafKeys = function (arg) { return typeof arg === 'object' ? Object
        .keys(arg)
        .forEach(function (key) {
        result[key] = arg[key];
    }) : result[arg] = true; };
    var addKeys = function (list) { return list
        .filter(function (arg) { return arg !== true && !!arg; })
        .map(function (arg) {
        return Array.isArray(arg) ?
            addKeys(arg) :
            addLeafKeys(arg);
    }); };
    addKeys(args);
    return Object
        .keys(result)
        .map(function (key) { return (result[key] && key) || null; })
        .filter(function (el) { return el !== null; })
        .join(' ');
};

/**
 * @hidden
 */
var noop$1 = function () { };

/**
 * @hidden
 */
function validatePackage$1(packageMetadata) {
    if (typeof licensing !== 'undefined') {
        validatePackage$4(packageMetadata);
    }
    else {
        var message = "License activation failed for ".concat(packageMetadata.name, "\n");
        message += 'The @progress/kendo-licensing script is not loaded.\n';
        message += "See ".concat(packageMetadata.licensingDocsUrl, " for more information.\n");
        console.warn(message);
    }
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$3 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$3;
var TransitionGroup$1 = TransitionGroup;

/**
 * @hidden
 */
var outerHeight = function (element) {
    if (!element || !element.ownerDocument.defaultView) {
        return 0;
    }
    var wnd = element.ownerDocument.defaultView;
    var computedStyles = wnd.getComputedStyle(element);
    var marginTop = parseFloat(computedStyles.marginTop);
    var marginBottom = parseFloat(computedStyles.marginBottom);
    return element.offsetHeight + marginTop + marginBottom;
};
/**
 * @hidden
 */
var outerWidth = function (element) {
    if (!element || !element.ownerDocument.defaultView) {
        return 0;
    }
    var wnd = element.ownerDocument.defaultView;
    var computedStyles = wnd.getComputedStyle(element);
    var marginLeft = parseFloat(computedStyles.marginLeft);
    var marginRight = parseFloat(computedStyles.marginRight);
    return element.offsetWidth + marginLeft + marginRight;
};
/**
 * @hidden
 */
var styles$2 = {
    'animation-container': 'k-animation-container',
    'animation-container-relative': 'k-animation-container-relative',
    'animation-container-fixed': 'k-animation-container-fixed',
    'push-right-enter': 'k-push-right-enter',
    'push-right-appear': 'k-push-right-appear',
    'push-right-enter-active': 'k-push-right-enter-active',
    'push-right-appear-active': 'k-push-right-appear-active',
    'push-right-exit': 'k-push-right-exit',
    'push-right-exit-active': 'k-push-right-exit-active',
    'push-left-enter': 'k-push-left-enter',
    'push-left-appear': 'k-push-left-appear',
    'push-left-enter-active': 'k-push-left-enter-active',
    'push-left-appear-active': 'k-push-left-appear-active',
    'push-left-exit': 'k-push-left-exit',
    'push-left-exit-active': 'k-push-left-exit-active',
    'push-down-enter': 'k-push-down-enter',
    'push-down-appear': 'k-push-down-appear',
    'push-down-enter-active': 'k-push-down-enter-active',
    'push-down-appear-active': 'k-push-down-appear-active',
    'push-down-exit': 'k-push-down-exit',
    'push-down-exit-active': 'k-push-down-exit-active',
    'push-up-enter': 'k-push-up-enter',
    'push-up-appear': 'k-push-up-appear',
    'push-up-enter-active': 'k-push-up-enter-active',
    'push-up-appear-active': 'k-push-up-appear-active',
    'push-up-exit': 'k-push-up-exit',
    'push-up-exit-active': 'k-push-up-exit-active',
    'expand': 'k-expand',
    'expand-vertical-enter': 'k-expand-vertical-enter',
    'expand-vertical-appear': 'k-expand-vertical-appear',
    'expand-vertical-enter-active': 'k-expand-vertical-enter-active',
    'expand-vertical-appear-active': 'k-expand-vertical-appear-active',
    'expand-vertical-exit': 'k-expand-vertical-exit',
    'expand-vertical-exit-active': 'k-expand-vertical-exit-active',
    'expand-horizontal-enter': 'k-expand-horizontal-enter',
    'expand-horizontal-appear': 'k-expand-horizontal-appear',
    'expand-horizontal-enter-active': 'k-expand-horizontal-enter-active',
    'expand-horizontal-appear-active': 'k-expand-horizontal-appear-active',
    'expand-horizontal-exit': 'k-expand-horizontal-exit',
    'expand-horizontal-exit-active': 'k-expand-horizontal-exit-active',
    'child-animation-container': 'k-child-animation-container',
    'fade-enter': 'k-fade-enter',
    'fade-appear': 'k-fade-appear',
    'fade-enter-active': 'k-fade-enter-active',
    'fade-appear-active': 'k-fade-appear-active',
    'fade-exit': 'k-fade-exit',
    'fade-exit-active': 'k-fade-exit-active',
    'zoom-in-enter': 'k-zoom-in-enter',
    'zoom-in-appear': 'k-zoom-in-appear',
    'zoom-in-enter-active': 'k-zoom-in-enter-active',
    'zoom-in-appear-active': 'k-zoom-in-appear-active',
    'zoom-in-exit': 'k-zoom-in-exit',
    'zoom-in-exit-active': 'k-zoom-in-exit-active',
    'zoom-out-enter': 'k-zoom-out-enter',
    'zoom-out-appear': 'k-zoom-out-appear',
    'zoom-out-enter-active': 'k-zoom-out-enter-active',
    'zoom-out-appear-active': 'k-zoom-out-appear-active',
    'zoom-out-exit': 'k-zoom-out-exit',
    'zoom-out-exit-active': 'k-zoom-out-exit-active',
    'slide-in-appear': 'k-slide-in-appear',
    'centered': 'k-centered',
    'slide-in-appear-active': 'k-slide-in-appear-active',
    'slide-down-enter': 'k-slide-down-enter',
    'slide-down-appear': 'k-slide-down-appear',
    'slide-down-enter-active': 'k-slide-down-enter-active',
    'slide-down-appear-active': 'k-slide-down-appear-active',
    'slide-down-exit': 'k-slide-down-exit',
    'slide-down-exit-active': 'k-slide-down-exit-active',
    'slide-up-enter': 'k-slide-up-enter',
    'slide-up-appear': 'k-slide-up-appear',
    'slide-up-enter-active': 'k-slide-up-enter-active',
    'slide-up-appear-active': 'k-slide-up-appear-active',
    'slide-up-exit': 'k-slide-up-exit',
    'slide-up-exit-active': 'k-slide-up-exit-active',
    'slide-right-enter': 'k-slide-right-enter',
    'slide-right-appear': 'k-slide-right-appear',
    'slide-right-enter-active': 'k-slide-right-enter-active',
    'slide-right-appear-active': 'k-slide-right-appear-active',
    'slide-right-exit': 'k-slide-right-exit',
    'slide-right-exit-active': 'k-slide-right-exit-active',
    'slide-left-enter': 'k-slide-left-enter',
    'slide-left-appear': 'k-slide-left-appear',
    'slide-left-enter-active': 'k-slide-left-enter-active',
    'slide-left-appear-active': 'k-slide-left-appear-active',
    'slide-left-exit': 'k-slide-left-exit',
    'slide-left-exit-active': 'k-slide-left-exit-active',
    'reveal-vertical-enter': 'k-reveal-vertical-enter',
    'reveal-vertical-appear': 'k-reveal-vertical-appear',
    'reveal-vertical-enter-active': 'k-reveal-vertical-enter-active',
    'reveal-vertical-appear-active': 'k-reveal-vertical-appear-active',
    'reveal-vertical-exit': 'k-reveal-vertical-exit',
    'reveal-vertical-exit-active': 'k-reveal-vertical-exit-active',
    'reveal-horizontal-enter': 'k-reveal-horizontal-enter',
    'reveal-horizontal-appear': 'k-reveal-horizontal-appear',
    'reveal-horizontal-enter-active': 'k-reveal-horizontal-enter-active',
    'reveal-horizontal-appear-active': 'k-reveal-horizontal-appear-active',
    'reveal-horizontal-exit': 'k-reveal-horizontal-exit',
    'reveal-horizontal-exit-active': 'k-reveal-horizontal-exit-active'
};
/**
 * @hidden
 */
var stylesMap = {
    outerHeight: outerHeight,
    outerWidth: outerWidth,
    styles: styles$2
};
var util = stylesMap;

var __extends$N = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$K = (undefined && undefined.__assign) || function () {
    __assign$K = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$K.apply(this, arguments);
};
var __rest$d = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var styles$1 = util.styles;
var AnimationChild = /** @class */ (function (_super) {
    __extends$N(AnimationChild, _super);
    function AnimationChild() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elementRef = React.createRef();
        return _this;
    }
    Object.defineProperty(AnimationChild.prototype, "element", {
        /**
         * The element that is being animated.
         */
        get: function () {
            return this.elementRef.current;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    AnimationChild.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, style = _a.style, appear = _a.appear, enter = _a.enter, exit = _a.exit, transitionName = _a.transitionName, transitionEnterDuration = _a.transitionEnterDuration, transitionExitDuration = _a.transitionExitDuration, className = _a.className, onEnter = _a.onEnter, onEntering = _a.onEntering, onEntered = _a.onEntered, onExit = _a.onExit, onExiting = _a.onExiting, onExited = _a.onExited, onAfterExited = _a.onAfterExited, mountOnEnter = _a.mountOnEnter, unmountOnExit = _a.unmountOnExit, animationEnteringStyle = _a.animationEnteringStyle, animationEnteredStyle = _a.animationEnteredStyle, animationExitingStyle = _a.animationExitingStyle, animationExitedStyle = _a.animationExitedStyle, other = __rest$d(_a, ["children", "style", "appear", "enter", "exit", "transitionName", "transitionEnterDuration", "transitionExitDuration", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "onAfterExited", "mountOnEnter", "unmountOnExit", "animationEnteringStyle", "animationEnteredStyle", "animationExitingStyle", "animationExitedStyle"]);
        var childAnimationContainerClassNames = classNames$1(className, styles$1['child-animation-container']);
        var defaultStyle = __assign$K({ transitionDelay: '0ms' }, style);
        var animationStyle = {
            entering: __assign$K({ transitionDuration: "".concat(transitionEnterDuration, "ms") }, animationEnteringStyle),
            entered: __assign$K({}, animationEnteredStyle),
            exiting: __assign$K({ transitionDuration: "".concat(transitionExitDuration, "ms") }, animationExitingStyle),
            exited: __assign$K({}, animationExitedStyle)
        };
        var transitionProps = {
            in: this.props.in,
            appear: appear,
            enter: enter,
            exit: exit,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit,
            timeout: {
                enter: transitionEnterDuration,
                exit: transitionExitDuration
            },
            onEnter: (function () {
                if (onEnter) {
                    onEnter.call(undefined, { animatedElement: _this.element, target: _this });
                }
            }),
            onEntering: (function () {
                if (onEntering) {
                    onEntering.call(undefined, { animatedElement: _this.element, target: _this });
                }
            }),
            onEntered: (function () {
                if (onEntered) {
                    onEntered.call(undefined, { animatedElement: _this.element, target: _this });
                }
            }),
            onExit: (function () {
                if (onExit) {
                    onExit.call(undefined, { animatedElement: _this.element, target: _this });
                }
            }),
            onExiting: (function () {
                if (onExiting) {
                    onExiting.call(undefined, { animatedElement: _this.element, target: _this });
                }
            }),
            onExited: (function () {
                if (onAfterExited) {
                    onAfterExited.call(undefined, { animatedElement: _this.element, target: _this });
                }
                if (onExited) {
                    onExited.call(undefined, { animatedElement: _this.element, target: _this });
                }
            }),
            classNames: {
                appear: styles$1["".concat(transitionName, "-appear")] || "".concat(transitionName, "-appear"),
                appearActive: styles$1["".concat(transitionName, "-appear-active")] || "".concat(transitionName, "-appear-active"),
                enter: styles$1["".concat(transitionName, "-enter")] || "".concat(transitionName, "-enter"),
                enterActive: styles$1["".concat(transitionName, "-enter-active")] || "".concat(transitionName, "-enter-active"),
                exit: styles$1["".concat(transitionName, "-exit")] || "".concat(transitionName, "-exit"),
                exitActive: styles$1["".concat(transitionName, "-exit-active")] || "".concat(transitionName, "-exit-active")
            }
        };
        return (React.createElement(CSSTransition$1, __assign$K({}, transitionProps, other, { nodeRef: this.elementRef }), function (status) {
            return (React.createElement("div", { style: __assign$K(__assign$K({}, defaultStyle), animationStyle[status]), className: childAnimationContainerClassNames, ref: _this.elementRef }, children));
        }));
    };
    /**
     * @hidden
     */
    AnimationChild.propTypes = {
        in: propTypes.exports.bool,
        children: propTypes.exports.oneOfType([
            propTypes.exports.arrayOf(propTypes.exports.node),
            propTypes.exports.node
        ]),
        transitionName: propTypes.exports.string.isRequired,
        className: propTypes.exports.string,
        appear: propTypes.exports.bool,
        enter: propTypes.exports.bool,
        exit: propTypes.exports.bool,
        transitionEnterDuration: propTypes.exports.number.isRequired,
        transitionExitDuration: propTypes.exports.number.isRequired,
        mountOnEnter: propTypes.exports.bool,
        unmountOnExit: propTypes.exports.bool,
        animationEnteringStyle: propTypes.exports.object,
        animationEnteredStyle: propTypes.exports.object,
        animationExitingStyle: propTypes.exports.object,
        animationExitedStyle: propTypes.exports.object
    };
    /**
     * @hidden
     */
    AnimationChild.defaultProps = {
        mountOnEnter: true,
        unmountOnExit: false,
        onEnter: noop$1,
        onEntering: noop$1,
        onEntered: noop$1,
        onExit: noop$1,
        onExiting: noop$1,
        onExited: noop$1,
        onAfterExited: noop$1,
        animationEnteringStyle: {},
        animationEnteredStyle: {},
        animationExitingStyle: {},
        animationExitedStyle: {}
    };
    return AnimationChild;
}(React.Component));

/**
 * @hidden
 */
var packageMetadata$7 = {
    name: '@progress/kendo-react-animation',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1675428362,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$M = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$J = (undefined && undefined.__assign) || function () {
    __assign$J = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$J.apply(this, arguments);
};
var __rest$c = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var styles = util.styles;
// tslint:enable:max-line-length
var Animation = /** @class */ (function (_super) {
    __extends$M(Animation, _super);
    function Animation(props) {
        var _this = _super.call(this, props) || this;
        validatePackage$1(packageMetadata$7);
        return _this;
    }
    /**
     * @hidden
     */
    Animation.prototype.render = function () {
        var _a = this.props, id = _a.id, style = _a.style, children = _a.children, component = _a.component, className = _a.className, childFactory = _a.childFactory; _a.stackChildren; var componentChildStyle = _a.componentChildStyle, componentChildClassName = _a.componentChildClassName, other = __rest$c(_a, ["id", "style", "children", "component", "className", "childFactory", "stackChildren", "componentChildStyle", "componentChildClassName"]);
        var transitionProps = {
            id: id,
            style: style,
            component: component,
            childFactory: childFactory,
            className: classNames$1(styles['animation-container'], styles['animation-container-relative'], className)
        };
        var content = React.Children.map(children || null, function (child) { return (React.createElement(AnimationChild, __assign$J({}, other, { style: componentChildStyle, className: componentChildClassName }), child)); });
        return (React.createElement(TransitionGroup$1, __assign$J({}, transitionProps), content));
    };
    /**
     * @hidden
     */
    Animation.propTypes = {
        children: propTypes.exports.oneOfType([
            propTypes.exports.arrayOf(propTypes.exports.node),
            propTypes.exports.node
        ]),
        childFactory: propTypes.exports.any,
        className: propTypes.exports.string,
        component: propTypes.exports.string,
        id: propTypes.exports.string,
        style: propTypes.exports.any,
        transitionName: propTypes.exports.string.isRequired,
        appear: propTypes.exports.bool.isRequired,
        enter: propTypes.exports.bool.isRequired,
        exit: propTypes.exports.bool.isRequired,
        transitionEnterDuration: propTypes.exports.number.isRequired,
        transitionExitDuration: propTypes.exports.number.isRequired
    };
    /**
     * @hidden
     */
    Animation.defaultProps = {
        component: 'div'
    };
    return Animation;
}(React.Component));

var __extends$L = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$I = (undefined && undefined.__assign) || function () {
    __assign$I = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$I.apply(this, arguments);
};
var __rest$b = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var Reveal = /** @class */ (function (_super) {
    __extends$L(Reveal, _super);
    function Reveal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * @hidden
         */
        _this.state = {
            maxHeight: undefined,
            maxWidth: undefined
        };
        _this.componentWillEnter = function (event) {
            var _a = _this.props, onEnter = _a.onEnter, onBeforeEnter = _a.onBeforeEnter;
            if (onBeforeEnter) {
                onBeforeEnter.call(undefined, event);
            }
            _this.updateContainerDimensions(event.animatedElement, function () {
                if (onEnter) {
                    onEnter.call(undefined, event);
                }
            });
        };
        _this.componentIsEntering = function (event) {
            var onEntering = _this.props.onEntering;
            _this.updateContainerDimensions(event.animatedElement, function () {
                if (onEntering) {
                    onEntering.call(undefined, event);
                }
            });
        };
        _this.componentWillExit = function (event) {
            var onExit = _this.props.onExit;
            _this.updateContainerDimensions(event.animatedElement, function () {
                if (onExit) {
                    onExit.call(undefined, event);
                }
            });
        };
        _this.updateContainerDimensions = function (node, done) {
            if (done === void 0) { done = noop$1; }
            var content = node.firstChild;
            if (content) {
                var newHeight = util.outerHeight(content);
                var newWidth = util.outerWidth(content);
                _this.setState({
                    maxHeight: newHeight,
                    maxWidth: newWidth
                }, done);
            }
        };
        return _this;
    }
    /**
     * @hidden
     */
    Reveal.prototype.render = function () {
        var _a = this.props, direction = _a.direction, children = _a.children, childFactory = _a.childFactory, other = __rest$b(_a, ["direction", "children", "childFactory"]);
        var _b = this.state, maxHeight = _b.maxHeight, maxWidth = _b.maxWidth;
        var maxOffset;
        if (direction === 'vertical') {
            maxOffset = { maxHeight: maxHeight ? "".concat(maxHeight, "px") : '' };
        }
        else {
            maxOffset = { maxWidth: maxWidth ? "".concat(maxWidth, "px") : '' };
        }
        var animationEnteringStyle = {
            maxHeight: maxOffset.maxHeight,
            maxWidth: maxOffset.maxWidth
        };
        var factory = function (child) {
            var result = childFactory ? childFactory(child) : child;
            if (!result.props.in) {
                return React.cloneElement(result, __assign$I(__assign$I({}, result.props), { style: __assign$I(__assign$I({}, result.props.style), { maxHeight: maxOffset.maxHeight, maxWidth: maxOffset.maxWidth }) }));
            }
            return result;
        };
        return (React.createElement(Animation, __assign$I({}, other, { childFactory: factory, onEnter: this.componentWillEnter, onEntering: this.componentIsEntering, onExit: this.componentWillExit, animationEnteringStyle: animationEnteringStyle, transitionName: "reveal-".concat(direction) }), children));
    };
    /**
     * @hidden
     */
    Reveal.propTypes = {
        children: propTypes.exports.oneOfType([
            propTypes.exports.arrayOf(propTypes.exports.node),
            propTypes.exports.node
        ]),
        childFactory: propTypes.exports.any,
        className: propTypes.exports.string,
        direction: propTypes.exports.oneOf([
            'horizontal',
            'vertical'
        ]),
        component: propTypes.exports.string,
        id: propTypes.exports.string,
        style: propTypes.exports.any
    };
    /**
     * @hidden
     */
    Reveal.defaultProps = {
        appear: false,
        enter: true,
        exit: true,
        transitionEnterDuration: 300,
        transitionExitDuration: 300,
        direction: 'vertical'
    };
    return Reveal;
}(React.Component));

var __extends$K = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var PagerPageSizes = /** @class */ (function (_super) {
    __extends$K(PagerPageSizes, _super);
    function PagerPageSizes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSizeChange = function (e) {
            if (_this.props.pageChange) {
                _this.props.pageChange({ skip: 0, take: parseInt(e.target.value, 10) }, e);
            }
        };
        return _this;
    }
    PagerPageSizes.prototype.render = function () {
        var _this = this;
        var sizes = this.props.pageSizes.slice();
        if (sizes.filter(function (s) { return s === _this.props.pageSize; }).length === 0) {
            sizes.unshift(this.props.pageSize);
        }
        var itemPerPageMessage = this.props.messagesMap ? this.props.messagesMap(pagerItemPerPage$1) :
            ({ messageKey: pagerItemPerPage$1, defaultMessage: messages$6[pagerItemPerPage$1] });
        var pageSelectionMessage = this.props.messagesMap ? this.props.messagesMap(pagerPageSelection) :
            ({ messageKey: pagerPageSelection, defaultMessage: messages$6[pagerPageSelection] });
        return (React.createElement("span", { className: "k-pager-sizes k-label" },
            React.createElement(DropDownList, { value: this.props.pageSize, data: sizes, onChange: this.pageSizeChange, ariaLabel: provideLocalizationService(this).toLanguageString(pageSelectionMessage.messageKey, pageSelectionMessage.defaultMessage) }),
            provideLocalizationService(this).toLanguageString(itemPerPageMessage.messageKey, itemPerPageMessage.defaultMessage)));
    };
    return PagerPageSizes;
}(React.Component));
registerForLocalization(PagerPageSizes);

/**
 * @hidden
 */
var packageMetadata$6 = {
    name: '@progress/kendo-react-data-tools',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770889,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$J = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$H = (undefined && undefined.__assign) || function () {
    __assign$H = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$H.apply(this, arguments);
};
/**
 * @hidden
 */
var RESPONSIVE_BREAKPOINT_MEDIUM = 600;
/**
 * @hidden
 */
var RESPONSIVE_BREAKPOINT_LARGE = 768;
var Pager = /** @class */ (function (_super) {
    __extends$J(Pager, _super);
    function Pager(props) {
        var _this = _super.call(this, props) || this;
        _this._element = null;
        _this.onPageChange = function (eventData, syntheticEvent) {
            var event = __assign$H({ target: _this, syntheticEvent: syntheticEvent, nativeEvent: syntheticEvent.nativeEvent }, eventData);
            if (_this.props.onPageChange) {
                _this.props.onPageChange.call(undefined, event);
            }
        };
        _this.changePage = function (page, event) {
            if (_this.props.onPageChange && page > 0 && page <= _this.totalPages) {
                _this.props.onPageChange({
                    target: _this,
                    skip: (page - 1) * _this.props.take,
                    take: _this.props.take,
                    syntheticEvent: event,
                    nativeEvent: event.nativeEvent
                });
            }
        };
        _this.onWindowResize = function () {
            var element = _this.element;
            if (!element || !_this.props.responsive) {
                return;
            }
            var width = element.offsetWidth;
            if (width < RESPONSIVE_BREAKPOINT_MEDIUM) {
                element.classList.remove('k-pager-md');
                element.classList.add('k-pager-sm');
            }
            else if (width >= RESPONSIVE_BREAKPOINT_MEDIUM && width < RESPONSIVE_BREAKPOINT_LARGE) {
                element.classList.add('k-pager-md');
                element.classList.remove('k-pager-sm');
            }
            else {
                element.classList.remove('k-pager-md');
                element.classList.remove('k-pager-sm');
            }
        };
        validatePackage$2(packageMetadata$6);
        return _this;
    }
    Object.defineProperty(Pager.prototype, "element", {
        /**
         * Returns the HTML element of the Pager component.
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    Pager.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        this.onWindowResize();
    };
    /**
     * @hidden
     */
    Pager.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
     * @hidden
     */
    Pager.prototype.render = function () {
        var _this = this;
        var _a = this.props, skip = _a.skip, take = _a.take, total = _a.total, pageSizes = _a.pageSizes, messagesMap = _a.messagesMap;
        var localizationService = provideLocalizationService(this);
        var intlService = provideIntlService(this);
        var currentPage = Math.floor(skip / take) + 1;
        var changer = this.props.type === 'numeric' ?
            (React.createElement(PagerNumericButtons, { buttonCount: this.props.buttonCount || 0, totalPages: this.totalPages, currentPage: currentPage, pageChange: this.changePage, messagesMap: this.props.messagesMap })) : (React.createElement(PagerInput, { currentPage: currentPage, totalPages: this.totalPages, pageChange: this.changePage, messagesMap: messagesMap }));
        var firstPageMessage = messagesMap ? messagesMap(pagerFirstPage$1) :
            ({ messageKey: pagerFirstPage$1, defaultMessage: messages$6[pagerFirstPage$1] });
        var previousPageMessage = messagesMap ? messagesMap(pagerPreviousPage$1) :
            ({ messageKey: pagerPreviousPage$1, defaultMessage: messages$6[pagerPreviousPage$1] });
        var nextPageMessage = messagesMap ? messagesMap(pagerNextPage$1) :
            ({ messageKey: pagerNextPage$1, defaultMessage: messages$6[pagerNextPage$1] });
        var lastPageMessage = messagesMap ? messagesMap(pagerLastPage$1) :
            ({ messageKey: pagerLastPage$1, defaultMessage: messages$6[pagerLastPage$1] });
        var infoMessage = messagesMap ? messagesMap(pagerInfo$1) :
            ({ messageKey: pagerInfo$1, defaultMessage: messages$6[pagerInfo$1] });
        var ariaKeyshortcutsMessage = messagesMap ? messagesMap(pagerAriaKeyshortcuts) :
            ({ messageKey: pagerAriaKeyshortcuts, defaultMessage: messages$6[pagerAriaKeyshortcuts] });
        var ariaLabelMessage = messagesMap ? messagesMap(pagerAriaLabel) :
            ({ messageKey: pagerAriaLabel, defaultMessage: messages$6[pagerAriaLabel] });
        var first, prev, next, last;
        if (this.props.previousNext) {
            first = this.renderButton(1, 'k-link k-pager-nav k-pager-first' + (currentPage === 1 ? ' k-disabled' : ''), localizationService.toLanguageString(firstPageMessage.messageKey, firstPageMessage.defaultMessage), 'caret-alt-to-left', (currentPage === 1 ? true : undefined));
            prev = this.renderButton(currentPage - 1, 'k-link k-pager-nav' + (currentPage === 1 ? ' k-disabled' : ''), localizationService.toLanguageString(previousPageMessage.messageKey, previousPageMessage.defaultMessage), 'caret-alt-left', (currentPage === 1 ? true : undefined));
            next = this.renderButton(currentPage + 1, 'k-link k-pager-nav' + (currentPage >= this.totalPages ? ' k-disabled' : ''), localizationService.toLanguageString(nextPageMessage.messageKey, nextPageMessage.defaultMessage), 'caret-alt-right', (currentPage >= this.totalPages ? true : undefined));
            last = this.renderButton(this.totalPages, 'k-link k-pager-nav k-pager-last' + (currentPage >= this.totalPages ? ' k-disabled' : ''), localizationService.toLanguageString(lastPageMessage.messageKey, lastPageMessage.defaultMessage), 'caret-alt-to-right', (currentPage >= this.totalPages ? true : undefined));
        }
        var pagerPageSizes = pageSizes && (React.createElement(PagerPageSizes, { pageChange: this.onPageChange, pageSize: take, pageSizes: pageSizes, messagesMap: messagesMap }));
        var info = this.props.info && (React.createElement("div", { className: "k-pager-info k-label" }, intlService
            .format(localizationService.toLanguageString(infoMessage.messageKey, infoMessage.defaultMessage), [
            Math.min(skip + 1, total),
            Math.min(skip + take, total),
            total
        ])));
        return (React.createElement("div", { className: classNames$2('k-pager k-widget', this.props.className), style: this.props.style, role: "application", "aria-roledescription": "pager", "aria-keyshortcuts": localizationService.toLanguageString(ariaKeyshortcutsMessage.messageKey, ariaKeyshortcutsMessage.defaultMessage), "aria-label": localizationService.toLanguageString(ariaLabelMessage.messageKey, ariaLabelMessage.defaultMessage), ref: function (element) { return _this._element = element; } },
            first,
            prev,
            changer,
            next,
            last,
            pagerPageSizes,
            info));
    };
    Pager.prototype.renderButton = function (page, className, title, icon, isDisabled) {
        var _this = this;
        return (React.createElement("a", { onClick: function (e) {
                e.preventDefault();
                _this.changePage(page, e);
            }, href: "#", className: className, title: title, role: "button", "aria-disabled": isDisabled },
            React.createElement(Icon, { name: icon })));
    };
    Object.defineProperty(Pager.prototype, "totalPages", {
        get: function () {
            return Math.ceil((this.props.total || 0) / this.props.take);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    Pager.propTypes = {
        className: propTypes.exports.string,
        style: propTypes.exports.object,
        total: propTypes.exports.number.isRequired,
        skip: propTypes.exports.number.isRequired,
        take: propTypes.exports.number.isRequired,
        buttonCount: propTypes.exports.number,
        info: propTypes.exports.bool,
        type: propTypes.exports.oneOf(['numeric', 'input']),
        pageSizes: propTypes.exports.arrayOf(propTypes.exports.number),
        previousNext: propTypes.exports.bool,
        onPageChange: propTypes.exports.func,
        messagesMap: propTypes.exports.func
    };
    /**
     * @hidden
     */
    Pager.defaultProps = {
        buttonCount: 10,
        info: true,
        type: 'numeric'
    };
    return Pager;
}(React.Component));
registerForIntl(Pager);
registerForLocalization(Pager);

/**
 * A function that clones the passed date. The parameter could be `null`.
 *
 * @param date - The initial date value.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * cloneDate(new Date(2016, 0, 1)); // returns new Date(2016, 0, 1);
 * cloneDate(null); // returns null
 * ```
 */
var cloneDate = function (date) { return date ? new Date(date.getTime()) : null; };

/**
 * @hidden
 */
var adjustDST = function (date, hour) {
    var newDate = cloneDate(date);
    if (hour === 0 && newDate.getHours() === 23) {
        newDate.setHours(newDate.getHours() + 2);
    }
    return newDate;
};

/**
 * A function that adds and subtracts days from a `Date` object.
 *
 * @param date - The initial date value.
 * @param offset - The number of days to add and subtract from the date.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * addDays(new Date(2016, 0, 1), 5); // 2016-1-6
 * addDays(new Date(2016, 0, 1), -5); // 2015-12-26
 * ```
 */
var addDays = function (date, offset) {
    var newDate = cloneDate(date);
    newDate.setDate(newDate.getDate() + offset);
    return adjustDST(newDate, date.getHours());
};

/**
 * A function which returns a new `Date` instance.
 *
 * @param year - The year value.
 * @param month - The month value.
 * @param day - The day value.
 * @param hours - The hours value.
 * @param minutes - The minutes value.
 * @param seconds - The seconds value.
 * @param milliseconds - milliseconds value.
 * @returns The date instance.
 *
 * @example
 * ```ts-no-run
 * createDate(2016, 0, 15); // 2016-01-15 00:00:00
 * createDate(2016, 0, 15, 22, 22, 20); // 2016-01-15 22:22:20
 * ```
 */
var createDate = function (year, month, day, hours, minutes, seconds, milliseconds) {
    if (hours === void 0) { hours = 0; }
    if (minutes === void 0) { minutes = 0; }
    if (seconds === void 0) { seconds = 0; }
    if (milliseconds === void 0) { milliseconds = 0; }
    var date = new Date(year, month, day, hours, minutes, seconds, milliseconds);
    if (year > -1 && year < 100) {
        date.setFullYear(date.getFullYear() - 1900);
    }
    return adjustDST(date, hours);
};

/**
 * A function which returns the last date of the month.
 *
 * @param date - The initial date.
 * @returns - The last date of the initial date month.
 *
 * @example
 * ```ts-no-run
 * lastDayOfMonth(new Date(2016, 0, 15)); // 2016-01-31
 * ```
 */
var lastDayOfMonth = function (date) {
    var newDate = createDate(date.getFullYear(), date.getMonth() + 1, 1, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return addDays(newDate, -1);
};

var MONTHS_LENGTH = 12;
var normalize$3 = function (date, expectedMonth) { return (date.getMonth() !== expectedMonth ? lastDayOfMonth(addMonths(date, -1)) : date //tslint:disable-line:no-use-before-declare
); };
/**
 * A function that adds and subtracts months from a `Date` object.
 *
 * @param date - The initial date value.
 * @param offset - The number of months to add or subtract from the date.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * addMonths(new Date(2016, 5, 1), 5); // 2016-11-1
 * addMonths(new Date(2016, 5, 1), -5); // 2015-1-1
 * ```
 */
var addMonths = function (date, offset) {
    var newDate = cloneDate(date);
    var diff = (newDate.getMonth() + offset) % MONTHS_LENGTH;
    var expectedMonth = (MONTHS_LENGTH + diff) % MONTHS_LENGTH;
    newDate.setMonth(newDate.getMonth() + offset);
    return normalize$3(adjustDST(newDate, date.getHours()), expectedMonth);
};

/**
 * @hidden
 */
var setYear = function (value, year) {
    var month = value.getMonth();
    var candidate = createDate(year, month, value.getDate(), value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds());
    return candidate.getMonth() === month ? candidate : lastDayOfMonth(addMonths(candidate, -1));
};

/**
 * A function that adds and subtracts years from a `Date` object.
 *
 * @param date - The initial date value.
 * @param offset - The number of years to add or subtract from the date.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * addYears(new Date(2016, 5, 1), 5); // 2011-6-1
 * addYears(new Date(2016, 5, 1), -5); // 2021-6-1
 * ```
 */
var addYears = function (value, offset) {
    return adjustDST(setYear(value, value.getFullYear() + offset), value.getHours());
};

/**
 * A function that adds and subtracts centuries from a `Date` object.
 *
 * @param date - The initial date value.
 * @param offset - The number of centuries to add or subtract from the date.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * addCenturies(new Date(2016, 5, 1), 5); // 2516-6-1
 * addCenturies(new Date(2016, 5, 1), -5); // 1516-6-1
 * ```
 */
var addCenturies = function (value, offset) {
    return addYears(value, 100 * offset);
};

/**
 * A function that adds and subtracts decades from a `Date` object.
 *
 * @param date - The initial date value.
 * @param offset - The number of decades to add or subtract from the date.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * addDecades(new Date(2016, 5, 1), 5); // 2066-6-1
 * addDecades(new Date(2016, 5, 1), -5); // 1966-6-1
 * ```
 */
var addDecades = function (value, offset) {
    return addYears(value, 10 * offset);
};

/**
 * A function that adds and subtracts weeks from a Date object.
 *
 * @param date - The initial date value.
 * @param offset - The number of weeks to add/subtract from the date.
 * @returns - A new `Date` instance.
 *
 * @example
 * ```ts-no-run
 * addWeeks(new Date(2016, 5, 1), 3); // 2016-6-22
 * addWeeks(new Date(2016, 5, 1), -3); // 2015-5-11
 * ```
 */
var addWeeks = function (date, offset) {
    return addDays(date, offset * 7);
};

/**
 * The number of milliseconds in one minute.
 */
/**
 * The number of milliseconds in one standard day.
 */
var MS_PER_DAY = 86400000;

// tslint:disable:max-line-length
/**
 * An enumeration which represents the horizontal direction. The `Forward` option moves forward. The `Backward` option moves backward.
 */
var Direction;
(function (Direction) {
    /**
     * The `Forward` value with an underlying `1` number value.
     */
    Direction[Direction["Forward"] = 1] = "Forward";
    /**
     * The `Backward` value with an underlying `-1` (minus one) number value.
     */
    Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
// tslint:enable:max-line-length

/**
 * @hidden
 *
 * A function which returns the next or previous date for a specific week day. For example, `Day.Monday`.
 *
 * @param date - The date to calculate from.
 * @param weekDay - The `Day` enum specifying the desired week day.
 * @param direction - The `Direction` enum specifying the calculation direction.
 * @returns - A `Date` instance.
 *
 * @example
 * ```ts-no-run
 * dayOfWeek(new Date(2016, 0, 1), Day.Wednesday, Direction.Forward); // 2016-01-06, Wednesday
 * dayOfWeek(new Date(2016, 0, 1), Day.Wednesday, Direction.Backward); // 2015-12-30, Wednesday
 * ```
 */
var dayOfWeek = function (date, weekDay, direction) {
    if (direction === void 0) { direction = Direction.Forward; }
    var newDate = cloneDate(date);
    var newDay = ((weekDay - newDate.getDay()) + (7 * direction)) % 7;
    newDate.setDate(newDate.getDate() + newDay);
    return adjustDST(newDate, date.getHours());
};

/**
 * Enumeration which represents the week days.
 */
var Day;
(function (Day) {
    /**
     * The Sunday value with an underlying `0` number value.
     */
    Day[Day["Sunday"] = 0] = "Sunday";
    /**
     * The Monday value with an underlying `1` number value.
     */
    Day[Day["Monday"] = 1] = "Monday";
    /**
     * The Tuesday value with an underlying `2` number value.
     */
    Day[Day["Tuesday"] = 2] = "Tuesday";
    /**
     * The Wednesday value with an underlying `3` number value.
     */
    Day[Day["Wednesday"] = 3] = "Wednesday";
    /**
     * The Thursday value with an underlying `4` number value.
     */
    Day[Day["Thursday"] = 4] = "Thursday";
    /**
     * The Friday value with an underlying `5` number value.
     */
    Day[Day["Friday"] = 5] = "Friday";
    /**
     * The Saturday value with an underlying `6` number value.
     */
    Day[Day["Saturday"] = 6] = "Saturday";
})(Day || (Day = {}));

/**
 * @hidden
 */
var normalizeYear = function (value, year) { return (setYear(value, year(value.getFullYear()))); };

/**
 * A function that returns a `Date` object of the first decade in a century.
 *
 * @param date - The start date value.
 * @returns - The first year in a century.
 *
 * @example
 * ```ts-no-run
 * firstDecadeOfCentury(new Date(2017, 0, 1)); // 2000-1-1
 * firstDecadeOfCentury(new Date(2007, 10, 22)); // 2000-11-22
 * firstDecadeOfCentury(new Date(2126, 0, 1)); // 2100-1-1
 * ```
 */
var firstDecadeOfCentury = function (value) { return (normalizeYear(value, function (y) { return y - (y % 100); })); };

/**
 * A function that calculates duration in centuries between two `Date` objects.
 *
 * @param start - The start date value.
 * @param end - The end date value.
 * @returns - The duration in months.
 *
 * @example
 * ```ts-no-run
 * durationInCenturies(new Date(2016, 0, 1), new Date(3216, 0, 1)); // 12
 * durationInCenturies(new Date(2016, 6, 1), new Date(2617, 0, 1)); // 6
 * durationInCenturies(new Date(2016, 0, 1), new Date(2016, 0, 1)); // 0
 * ```
 */
var durationInCenturies = function (start, end) { return ((firstDecadeOfCentury(end).getFullYear() - firstDecadeOfCentury(start).getFullYear()) / 100); };

/**
 * A function that returns a `Date` object of the first year in a decade.
 *
 * @param date - The start date value.
 * @returns - The first year in a decade.
 *
 * @example
 * ```ts-no-run
 * firstYearOfDecade(new Date(2017, 0, 1)); // 2010-1-1
 * firstYearOfDecade(new Date(2007, 10, 22)); // 2000-11-22
 * firstYearOfDecade(new Date(2026, 0, 1)); // 2020-1-1
 * ```
 */
var firstYearOfDecade = function (value) { return (normalizeYear(value, function (y) { return y - (y % 10); })); };

/**
 * A function that calculates duration in decades between two `Date` objects.
 *
 * @param start - The start date value.
 * @param end - The end date value.
 * @returns - The duration in months.
 *
 * @example
 * ```ts-no-run
 * durationInDecades(new Date(2016, 0, 1), new Date(2136, 0, 1)); // 12
 * durationInDecades(new Date(2016, 0, 1), new Date(2016, 0, 1)); // 0
 * ```
 */
var durationInDecades = function (start, end) { return ((firstYearOfDecade(end).getFullYear() - firstYearOfDecade(start).getFullYear()) / 10); };

/**
 * A function that calculates duration in months between two `Date` objects.
 *
 * @param start - The start date value.
 * @param end - The end date value.
 * @returns - The duration in months.
 *
 * @example
 * ```ts-no-run
 * durationInMonths(new Date(2016, 0, 1), new Date(2017, 0, 1)); // 12
 * durationInMonths(new Date(2016, 6, 1), new Date(2017, 0, 1)); // 6
 * durationInMonths(new Date(2016, 0, 1), new Date(2016, 0, 1)); // 0
 * ```
 */
var durationInMonths = function (start, end) { return (((end.getFullYear() - start.getFullYear())) * 12 + (end.getMonth() - start.getMonth())); };

/**
 * A function that calculates duration in years between two `Date` objects.
 *
 * @param start - The start date value.
 * @param end - The end date value.
 * @returns - The duration in years.
 *
 * @example
 * ```ts-no-run
 * durationInYears(new Date(2016, 0, 1), new Date(2028, 0, 1)); // 12
 * durationInYears(new Date(2016, 0, 1), new Date(2022, 0, 1)); // 6
 * durationInYears(new Date(2016, 0, 1), new Date(2016, 0, 1)); // 0
 * ```
 */
var durationInYears = function (start, end) { return (end.getFullYear() - start.getFullYear()); };

/**
 * A function which returns the first date of the month.
 *
 * @param date - The initial date.
 * @returns - The first date of the initial date month.
 *
 * @example
 * ```ts-no-run
 * firstDayOfMonth(new Date(2016, 0, 15)); // 2016-01-01
 * ```
 */
var firstDayOfMonth = function (date) {
    return createDate(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

/**
 * @hidden
 */
var setMonth = function (value, month) {
    var day = value.getDate();
    var candidate = createDate(value.getFullYear(), month, day, value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds());
    return candidate.getDate() === day ? candidate : lastDayOfMonth(addMonths(candidate, -1));
};

/**
 * A function that returns a `Date` object of the first month in a year.
 *
 * @param date - The start date value.
 * @returns - The first month in a year.
 *
 * @example
 * ```ts-no-run
 * firstMonthOfYear(new Date(2017, 11, 1)); // 2017-1-1
 * firstMonthOfYear(new Date(2017, 0, 1)); // 2017-1-1
 * ```
 */
var firstMonthOfYear = function (value) { return setMonth(value, 0); };

/**
 * A function which returns the passed date with a midnight time portion.
 *
 * @param date - The initial date.
 * @returns - The date with a midnight time portion.
 *
 * @example
 * ```ts-no-run
 * getDate(new Date(2016, 0, 15, 14, 30, 30)); // 2016-01-15 00:00:00
 * ```
 */
var getDate = function (date) {
    return createDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
};

/**
 * A function that compares two dates. The comparison also includes the time portion.
 *
 * @param candidate - The candidate date.
 * @param expected - The expected date.
 * @returns - A Boolean value indicating whether the values are equal.
 *
 * @example
 * ```ts-no-run
 * isEqual(new Date(2016, 0, 1), new Date(2016, 0, 1)); // true
 * isEqual(new Date(2016, 0, 1), new Date(2016, 0, 2)); // false
 * isEqual(new Date(2016, 0, 1, 10), new Date(2016, 0, 1, 20)); // false
 * ```
 */
var isEqual = function (candidate, expected) {
    if (!candidate && !expected) {
        return true;
    }
    return candidate && expected && candidate.getTime() === expected.getTime();
};

/**
 * A function that compares the date portions of 2 dates.
 *
 * @param candidate - The candidate date.
 * @param expected - The expected date.
 * @returns - A Boolean value whether the values are equal.
 *
 * @example
 * ```ts-no-run
 * isEqualDate(new Date(2016, 0, 1, 10), new Date(2016, 0, 1, 20)); // true
 * isEqualDate(new Date(2016, 0, 1, 10), new Date(2016, 0, 2, 10)); // false
 * ```
 */
var isEqualDate = function (candidate, expected) {
    if (!candidate && !expected) {
        return true;
    }
    return candidate && expected && isEqual(getDate(candidate), getDate(expected));
};

/**
 * A function that returns a `Date` object of the last decade in a century.
 *
 * @param date - The start date value.
 * @returns - The last year in a decade.
 *
 * @example
 * ```ts-no-run
 * lastDecadeOfCentury(new Date(2017, 0, 1)); // 2090-1-1
 * lastDecadeOfCentury(new Date(2007, 10, 22)); // 2090-11-22
 * lastDecadeOfCentury(new Date(2126, 0, 1)); // 2190-1-1
 * ```
 */
var lastDecadeOfCentury = function (value) { return (normalizeYear(value, function (y) { return y - (y % 100) + 90; })); };

/**
 * A function that returns a `Date` object of the last month in a year.
 *
 * @param date - The start date value.
 * @returns - The last month in a year.
 *
 * @example
 * ```ts-no-run
 * lastMonthOfYear(new Date(2017, 5, 3)); // 2017-12-3
 * lastMonthOfYear(new Date(2017, 11, 3)); // 2017-12-3
 * ```
 */
var lastMonthOfYear = function (value) { return setMonth(value, 11); };

/**
 * A function that returns a `Date` object of the last year in a decade.
 *
 * @param date - The start date value.
 * @returns - The last year in a decade.
 *
 * @example
 * ```ts-no-run
 * lastYearOfDecade(new Date(2017, 0, 1)); // 2019-1-1
 * lastYearOfDecade(new Date(2007, 10, 22)); // 2009-11-22
 * lastYearOfDecade(new Date(2026, 0, 1)); // 2029-1-1
 * ```
 */
var lastYearOfDecade = function (value) { return (normalizeYear(value, function (y) { return y - (y % 10) + 9; })); };

/**
 * A function which returns a date by a specific week name. For example, `Day.Monday`.
 *
 * @param date - The date to calculate from.
 * @param weekDay - The `Day` enum specifying the desired week day.
 * @returns - A `Date` instance.
 *
 * @example
 * ```ts-no-run
 * prevDayOfWeek(new Date(2016, 0, 1), Day.Wednesday); // 2015-12-30, Wednesday
 * ```
 */
var prevDayOfWeek = function (date, weekDay) {
    return dayOfWeek(date, weekDay, Direction.Backward);
};

var moveDateToWeekStart = function (date, weekStartDay) {
    if (weekStartDay !== Day.Monday) {
        return addDays(prevDayOfWeek(date, weekStartDay), 4);
    }
    return addDays(date, (4 - (date.getDay() || 7)));
};
var calcWeekInYear = function (date, weekStartDay) {
    var firstWeekInYear = createDate(date.getFullYear(), 0, 1, -6);
    var newDate = moveDateToWeekStart(date, weekStartDay);
    var diffInMS = newDate.getTime() - firstWeekInYear.getTime();
    var days = Math.floor(diffInMS / MS_PER_DAY);
    return 1 + Math.floor(days / 7);
};
/**
 * A function that returns the number of the week within a year, which is calculated in relation to the date.
 *
 * For more information, refer to the [**ISO week date**](https://en.wikipedia.org/wiki/ISO_week_date) article.
 *
 * @param date - The date used for the week number calculation.
 * @param weekStartDay - The first day of the week. By default, the first week day is Monday.
 * @returns - The number of the week within the year.
 *
 * @example
 * ```ts-no-run
 * weekInYear(new Date(2016, 0, 1)); // Week 53, 2015
 * weekInYear(new Date(2016, 0, 5)); // Week 1, 2016
 * weekInYear(new Date(2017, 0, 1)); // Week 52, 2016
 * weekInYear(new Date(2017, 0, 2)); // Week 1, 2017
 * ```
 */
var weekInYear = function (date, weekStartDay) {
    if (weekStartDay === void 0) { weekStartDay = Day.Monday; }
    date = getDate(date);
    var prevWeekDate = addDays(date, -7);
    var nextWeekDate = addDays(date, 7);
    var weekNumber = calcWeekInYear(date, weekStartDay);
    if (weekNumber === 0) {
        return calcWeekInYear(prevWeekDate, weekStartDay) + 1;
    }
    if (weekNumber === 53 && calcWeekInYear(nextWeekDate, weekStartDay) > 1) {
        return 1;
    }
    return weekNumber;
};

/**
 * @hidden
 */
var packageMetadata$5 = {
    name: '@progress/kendo-react-dateinputs',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770683,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __spreadArray$8 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
var update = function (arr, idx, value) { return (__spreadArray$8(__spreadArray$8([], arr.slice(0, idx + 1), true), (arr.slice(idx + 1).map(function (x) { return x + value; })), true)); };
/**
 * @hidden
 */
var RowHeightService$1 = /** @class */ (function () {
    function RowHeightService(total, rowHeight, detailRowHeight) {
        if (total === void 0) { total = 0; }
        this.total = total;
        this.rowHeight = rowHeight;
        this.detailRowHeight = detailRowHeight;
        this.offsets = [];
        this.heights = [];
        var agg = 0;
        for (var idx = 0; idx < total; idx++) {
            this.offsets.push(agg);
            agg += rowHeight;
            this.heights.push(rowHeight);
        }
    }
    RowHeightService.prototype.height = function (rowIndex) {
        return this.heights[rowIndex];
    };
    RowHeightService.prototype.expandDetail = function (rowIndex) {
        if (this.height(rowIndex) === this.rowHeight) {
            this.updateRowHeight(rowIndex, this.detailRowHeight);
        }
    };
    RowHeightService.prototype.collapseDetail = function (rowIndex) {
        if (this.height(rowIndex) > this.rowHeight) {
            this.updateRowHeight(rowIndex, this.detailRowHeight * -1);
        }
    };
    RowHeightService.prototype.index = function (position) {
        for (var i = 0; i < this.offsets.length; i++) {
            if (position === this.offsets[i]) {
                return i;
            }
            if (position < this.offsets[i]) {
                return i - 1;
            }
        }
        return this.total - 1;
    };
    RowHeightService.prototype.offset = function (rowIndex) {
        return this.offsets[rowIndex];
    };
    RowHeightService.prototype.totalHeight = function () {
        return this.heights.reduce(function (prev, curr) { return prev + curr; }, 0);
    };
    RowHeightService.prototype.updateRowHeight = function (rowIndex, value) {
        this.heights[rowIndex] += value;
        this.offsets = update(this.offsets, rowIndex, value);
    };
    return RowHeightService;
}());

var normalize$2 = function (x) { return Math.max(x, 0); };
/**
 * @hidden
 */
var ScrollAction = /** @class */ (function () {
    function ScrollAction(offset) {
        this.offset = offset;
    }
    return ScrollAction;
}());
/**
 * @hidden
 */
var PageAction = /** @class */ (function () {
    function PageAction(skip) {
        this.skip = skip;
    }
    return PageAction;
}());
/**
 * @hidden
 */
var ScrollerService = /** @class */ (function () {
    function ScrollerService(onScrollAction, onPageAction) {
        this.onScrollAction = onScrollAction;
        this.onPageAction = onPageAction;
        this.direction = 'vertical';
        this.firstLoaded = 0;
        this.lastLoaded = 0;
        this.lastScrollTop = 0;
        this.take = 0;
        this.total = 0;
        this.rowHeightService = null;
        this.bottomOffset = 0;
        this.topOffset = 0;
    }
    ScrollerService.prototype.create = function (rowHeightService, skip, take, total, topOffset, bottomOffset, direction) {
        if (topOffset === void 0) { topOffset = 0; }
        if (bottomOffset === void 0) { bottomOffset = 0; }
        if (direction === void 0) { direction = 'vertical'; }
        this.rowHeightService = rowHeightService;
        this.firstLoaded = skip;
        this.lastLoaded = skip + take;
        this.take = take;
        this.total = total;
        this.lastScrollTop = 0;
        this.topOffset = topOffset;
        this.bottomOffset = bottomOffset;
        this.direction = direction;
        var offsetBufferRows = this.rowsForHeight(topOffset);
        var skipWithOffset = normalize$2(skip - offsetBufferRows);
        this.onScrollAction(new ScrollAction(this.rowOffset(skipWithOffset)));
        this.onPageAction(new PageAction(skipWithOffset));
    };
    ScrollerService.prototype.onScroll = function (_a) {
        var scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop, offsetHeight = _a.offsetHeight, offsetWidth = _a.offsetWidth;
        var scrollPosition = this.direction === 'vertical' ? scrollTop : scrollLeft;
        var offsetSize = this.direction === 'vertical' ? offsetHeight : offsetWidth;
        if (this.lastScrollTop === scrollPosition || !this.rowHeightService) {
            return;
        }
        var up = this.lastScrollTop >= scrollPosition;
        this.lastScrollTop = scrollPosition;
        var firstItemIndex = this.rowHeightService.index(normalize$2(scrollPosition - this.topOffset));
        var lastItemIndex = this.rowHeightService.index(normalize$2(scrollPosition + offsetSize - this.bottomOffset));
        if (!up && lastItemIndex >= this.lastLoaded && this.lastLoaded < this.total) {
            this.firstLoaded = firstItemIndex;
            this.onScrollAction(new ScrollAction(this.rowOffset(firstItemIndex)));
            this.lastLoaded = Math.min(this.firstLoaded + this.take, this.total);
            this.onPageAction(new PageAction(this.firstLoaded));
        }
        if (up && firstItemIndex <= this.firstLoaded) {
            var nonVisibleBuffer = Math.floor(this.take * 0.3);
            this.firstLoaded = normalize$2(firstItemIndex - nonVisibleBuffer);
            this.onScrollAction(new ScrollAction(this.rowOffset(this.firstLoaded)));
            this.lastLoaded = Math.min(this.firstLoaded + this.take, this.total);
            this.onPageAction(new PageAction(this.firstLoaded));
        }
    };
    ScrollerService.prototype.rowOffset = function (index) {
        return this.rowHeightService ? this.rowHeightService.offset(index) + this.topOffset : 0;
    };
    ScrollerService.prototype.rowsForHeight = function (height) {
        return this.rowHeightService ? Math.ceil(height / this.rowHeightService.height(0)) : 0;
    };
    return ScrollerService;
}());

var __extends$I = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a$9, _b$1, _c$1;
/**
 * @hidden
 */
var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["Backward"] = 0] = "Backward";
    ScrollDirection[ScrollDirection["Forward"] = 1] = "Forward";
})(ScrollDirection || (ScrollDirection = {}));
var differenceToScroll = function (scrollTop, staticOffset, maxScrollDifference) {
    return Math.min(Math.abs(staticOffset - scrollTop), maxScrollDifference);
};
var FRAME_DURATION$1 = 17;
var scrollModifiers = (_a$9 = {},
    _a$9[ScrollDirection.Forward] = function (step) { return function (value) { return value + step; }; },
    _a$9[ScrollDirection.Backward] = function (step) { return function (value) { return value - step; }; },
    _a$9);
var scrollNormalizers = (_b$1 = {},
    _b$1[ScrollDirection.Forward] = function (end) { return function (value) { return Math.min(value, end); }; },
    _b$1[ScrollDirection.Backward] = function (end) { return function (value) { return Math.max(value, end); }; },
    _b$1);
var scrollValidators = (_c$1 = {},
    _c$1[ScrollDirection.Forward] = function (end) { return function (start) { return start < end; }; },
    _c$1[ScrollDirection.Backward] = function (end) { return function (start) { return start > end; }; },
    _c$1);
/**
 * @hidden
 */
var Virtualization = /** @class */ (function (_super) {
    __extends$I(Virtualization, _super);
    function Virtualization(props) {
        var _this = _super.call(this, props) || this;
        _this.rowHeightService = null;
        _this.scrollContainer = null;
        _this.lastDirection = null;
        _this.lastTotal = 0;
        _this.lastTake = 0;
        _this.animationInProgress = false;
        _this.scrollToIndexTimeout = 0;
        _this.scrollTo = function (value) {
            var scrollProperty = _this.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            if (!_this.scrollContainer) {
                return;
            }
            _this.scrollContainer[scrollProperty] = value;
        };
        _this.scrollToIndex = function (index) {
            if (_this.scrollToIndexTimeout !== undefined) {
                window.cancelAnimationFrame(_this.scrollToIndexTimeout);
            }
            if (!_this.rowHeightService) {
                return;
            }
            _this.scrollToIndexTimeout = window.requestAnimationFrame(function () {
                _this.animationInProgress = false;
                if (_this.rowHeightService) {
                    _this.scrollTo(_this.rowHeightService.offset(index));
                }
            });
        };
        _this.animateToIndex = function (index) {
            if (!_this.rowHeightService || !window) {
                return;
            }
            window.cancelAnimationFrame(_this.cancelAnimation);
            var indexOffset = _this.rowHeightService.offset(index);
            var direction = _this.getContainerScrollDirection(indexOffset);
            var _a = _this.scrollRange(indexOffset, direction), start = _a.start, end = _a.end;
            if (start === end) {
                return;
            }
            var step = _this.scrollStep(start, end);
            var modifyScroll = scrollModifiers[direction](step);
            var normalizeScroll = scrollNormalizers[direction](end);
            var isScrollValid = scrollValidators[direction](modifyScroll(end));
            var animate = function (progress) {
                _this.animationInProgress = true;
                var next = modifyScroll(progress);
                _this.scrollTo(normalizeScroll(next));
                isScrollValid(next)
                    ? _this.cancelAnimation = window.requestAnimationFrame(function () { animate(next); })
                    : _this.animationInProgress = false;
            };
            _this.cancelAnimation = window.requestAnimationFrame(function () { animate(start); });
        };
        _this.scrollToBottom = function () {
            if (!_this.rowHeightService) {
                return;
            }
            _this.scrollTo(_this.rowHeightService.totalHeight() + _this.props.bottomOffset);
        };
        _this.scrollStep = function (start, end) {
            var duration = _this.props.scrollDuration || Virtualization.defaultProps.scrollDuration;
            return Math.abs(end - start) / (duration / FRAME_DURATION$1);
        };
        _this.scrollRange = function (indexOffset, direction) {
            var containerScroll = _this.containerScrollPosition;
            if (parseInt("".concat(indexOffset), 10) === parseInt("".concat(containerScroll), 10)) {
                return { start: indexOffset, end: indexOffset };
            }
            var maxScroll = _this.containerMaxScroll();
            var sign = direction === ScrollDirection.Backward ? 1 : -1;
            var difference = differenceToScroll(containerScroll, indexOffset, _this.props.maxScrollDifference || 0);
            var end = Math.min(indexOffset, maxScroll);
            var start = Math.min(Math.max(end + (sign * difference), 0), maxScroll);
            return { start: start, end: end };
        };
        _this.containerMaxScroll = function () {
            return _this.containerScrollSize - _this.containerOffsetSize;
        };
        _this.getContainerScrollDirection = function (indexOffset) {
            return indexOffset < _this.containerScrollPosition ? ScrollDirection.Backward : ScrollDirection.Forward;
        };
        _this.initServices = function (props) {
            if (props === void 0) { props = _this.props; }
            var dimension = _this.direction === 'vertical' ? props.itemHeight : props.itemWidth;
            if (dimension === undefined) {
                return;
            }
            _this.rowHeightService = new RowHeightService$1(props.total, dimension, 0);
            _this.scrollerService.create(_this.rowHeightService, props.skip, props.take, props.total, props.topOffset, _this.scrollOffsetSize, _this.direction);
        };
        _this.getContainerProperty = function (propertyName) {
            if (!_this.scrollContainer) {
                return 0;
            }
            return _this.scrollContainer[propertyName];
        };
        _this.handleScroll = function (event) {
            if (!_this.scrollContainer || !_this.rowHeightService) {
                return;
            }
            var target = event.target;
            _this.scrollerService.onScroll({
                scrollLeft: target.scrollLeft,
                scrollTop: target.scrollTop,
                offsetHeight: target.offsetHeight,
                offsetWidth: target.offsetWidth
            });
            var index = _this.rowHeightService.index(_this.containerScrollPosition - _this.props.topOffset);
            var onScrollAction = _this.props.onScrollAction;
            var args = {
                index: index,
                target: target,
                scrollAction: _this.scrollAction,
                pageAction: _this.pageAction,
                animationInProgress: _this.animationInProgress
            };
            if (_this.props.onScroll) {
                _this.props.onScroll.call(undefined, event);
            }
            if (onScrollAction) {
                onScrollAction.call(undefined, args);
            }
            _this.scrollAction = undefined;
            _this.pageAction = undefined;
        };
        _this.handleScrollAction = function (action) {
            _this.scrollAction = action;
        };
        _this.handlePageAction = function (action) {
            _this.pageAction = action;
        };
        _this.scrollerService = new ScrollerService(_this.handleScrollAction, _this.handlePageAction);
        return _this;
    }
    Object.defineProperty(Virtualization.prototype, "element", {
        get: function () {
            return this.scrollContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Virtualization.prototype, "containerOffsetSize", {
        get: function () {
            return this.getContainerProperty(this.direction === 'vertical' ? 'offsetHeight' : 'offsetWidth');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Virtualization.prototype, "containerScrollSize", {
        get: function () {
            return this.getContainerProperty(this.direction === 'vertical' ? 'scrollHeight' : 'scrollWidth');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Virtualization.prototype, "containerScrollPosition", {
        get: function () {
            return this.getContainerProperty(this.direction === 'vertical' ? 'scrollTop' : 'scrollLeft');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Virtualization.prototype, "direction", {
        get: function () {
            return this.props.direction !== undefined ? this.props.direction : Virtualization.defaultProps.direction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Virtualization.prototype, "scrollOffsetSize", {
        get: function () {
            return this.props.scrollOffsetSize !== undefined
                ? this.props.scrollOffsetSize : Virtualization.defaultProps.scrollOffsetSize;
        },
        enumerable: false,
        configurable: true
    });
    Virtualization.prototype.activeIndex = function () {
        return this.itemIndex(Math.ceil(this.containerScrollPosition));
    };
    Virtualization.prototype.itemIndex = function (offset) {
        if (!this.rowHeightService) {
            return 0;
        }
        return this.rowHeightService.index(offset);
    };
    Virtualization.prototype.itemOffset = function (index) {
        if (!this.rowHeightService) {
            return 0;
        }
        return this.rowHeightService.offset(index);
    };
    Virtualization.prototype.isIndexVisible = function (index) {
        if (!this.rowHeightService) {
            return false;
        }
        var containerTop = this.containerScrollPosition;
        var containerBottom = containerTop + this.containerOffsetSize;
        var top = this.rowHeightService.offset(index);
        var bottom = top + this.rowHeightService.height(index);
        return top >= containerTop && bottom <= containerBottom;
    };
    Virtualization.prototype.isListScrolled = function (index) {
        if (!this.rowHeightService) {
            return false;
        }
        return this.containerScrollPosition !== this.rowHeightService.offset(index);
    };
    Virtualization.prototype.componentDidMount = function () {
        var onMount = this.props.onMount;
        if (onMount) {
            onMount.call(undefined, this);
        }
    };
    Virtualization.prototype.render = function () {
        var _this = this;
        if (this.lastTotal !== this.props.total
            || this.lastDirection !== this.direction
            || this.lastTake !== this.props.take) {
            this.initServices();
            this.lastTotal = this.props.total;
            this.lastDirection = this.direction;
            this.lastTake = this.props.take;
        }
        var vertexLength = "".concat((this.rowHeightService ? this.rowHeightService.totalHeight() : 0) + this.props.bottomOffset);
        var placeholderStyle = this.direction === 'vertical'
            ? { height: "".concat(vertexLength, "px") }
            : { width: "".concat(vertexLength, "px") };
        var rootClassNames = classNames$2('k-content k-calendar-content k-scrollable', {
            'k-scrollable-horizontal': this.direction === 'horizontal'
        }, this.props.className);
        var scrollableClassNames = classNames$2('k-scrollable-placeholder', {
            'k-scrollable-horizontal-placeholder': this.direction === 'horizontal'
        });
        return (React.createElement("div", { ref: function (el) { _this.scrollContainer = el; }, onScroll: this.handleScroll, className: rootClassNames, tabIndex: this.props.tabIndex, role: this.props.role },
            this.props.children,
            React.createElement("div", { style: placeholderStyle, className: scrollableClassNames })));
    };
    Virtualization.propTypes = {
        bottomOffset: propTypes.exports.number.isRequired,
        className: propTypes.exports.string,
        direction: propTypes.exports.oneOf(['horizontal', 'vertical']),
        forceScroll: propTypes.exports.bool,
        itemHeight: propTypes.exports.number,
        itemWidth: propTypes.exports.number,
        maxScrollDifference: propTypes.exports.number,
        onScroll: propTypes.exports.func,
        onScrollAction: propTypes.exports.func,
        scrollDuration: propTypes.exports.number,
        scrollOffsetSize: propTypes.exports.number,
        skip: propTypes.exports.number.isRequired,
        tabIndex: propTypes.exports.number,
        take: propTypes.exports.number.isRequired,
        topOffset: propTypes.exports.number.isRequired,
        total: propTypes.exports.number.isRequired,
        role: propTypes.exports.string
    };
    Virtualization.defaultProps = {
        direction: 'vertical',
        forceScroll: false,
        scrollOffsetSize: 0,
        maxScrollDifference: 100,
        scrollDuration: 100
    };
    return Virtualization;
}(React.Component));

var __extends$H = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$G = (undefined && undefined.__assign) || function () {
    __assign$G = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$G.apply(this, arguments);
};
var __rest$a = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @hidden
 */
var compareProps = function (x, y) {
    var xProps = Object.getOwnPropertyNames(x);
    var yProps = Object.getOwnPropertyNames(y);
    if (xProps.length !== yProps.length) {
        return false;
    }
    for (var i = 0; i < xProps.length; i++) {
        var propName = xProps[i];
        if (x[propName] !== y[propName]) {
            return false;
        }
    }
    return true;
};
/**
 * The `CalendarCell` component is internally used for rendering the items in the current view. Also be used as a custom `cell` of the [Calendar]({% slug api_dateinputs_calendarprops %}#toc-cell) and the [MultiViewCalendar]({% slug api_dateinputs_multiviewcalendarprops %}#toc-cell).
 *
 * * [Customizing the cells inside the Calendar view]({% slug custom_rendering_calendar %}#toc-cells-inside-the-view)
 * * [Customizing the cells inside the MultiViewCalendar view]({% slug custom_rendering_multiviewcalendar %}#toc-cells-inside-the-view)
 */
var CalendarCell = /** @class */ (function (_super) {
    __extends$H(CalendarCell, _super);
    function CalendarCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:enable:max-line-length
        _this.handleClick = function (event) {
            var _a = _this.props, onClick = _a.onClick, value = _a.value;
            if (onClick) {
                onClick.call(undefined, value, event);
            }
        };
        _this.handleMouseEnter = function () {
            var _a = _this.props, onMouseEnter = _a.onMouseEnter, value = _a.value;
            if (onMouseEnter) {
                onMouseEnter.call(undefined, value);
            }
        };
        _this.handleMouseLeave = function () {
            var _a = _this.props, onMouseLeave = _a.onMouseLeave, value = _a.value;
            if (onMouseLeave) {
                onMouseLeave.call(undefined, value);
            }
        };
        return _this;
    }
    // Manually checking if the component needs an update
    // due to date object being compared by instance
    // and new Date object is created
    // every time and fails the shallow compare of the React.PureComponent.
    /**
     * @hidden
     */
    CalendarCell.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, value = _a.value, props = __rest$a(_a, ["value"]);
        var newValue = nextProps.value, newProps = __rest$a(nextProps, ["value"]);
        var valueEqual = !(value && newValue) || value.getTime() === newValue.getTime();
        return !(valueEqual && compareProps(props, newProps));
    };
    /* eslint-disable max-len */
    /**
     * @return
     * Returns a `<td />` element with a `<span className="k-link" />` inside to apply the styles. The text inside is the [`formattedValue`]({% slug api_dateinputs_calendarcellprops %}#toc-formattedvalue) of the `cell`.
     */
    CalendarCell.prototype.render = function () {
        var _a = this.props, className = _a.className; _a.formattedValue; var isWeekend = _a.isWeekend, isFocused = _a.isFocused; _a.isInRange; var isSelected = _a.isSelected, isRangeStart = _a.isRangeStart, isRangeMid = _a.isRangeMid, isRangeEnd = _a.isRangeEnd, isRangeSplitStart = _a.isRangeSplitStart, isRangeSplitEnd = _a.isRangeSplitEnd, isToday = _a.isToday, isDisabled = _a.isDisabled; _a.view; _a.value; var other = __rest$a(_a, ["className", "formattedValue", "isWeekend", "isFocused", "isInRange", "isSelected", "isRangeStart", "isRangeMid", "isRangeEnd", "isRangeSplitStart", "isRangeSplitEnd", "isToday", "isDisabled", "view", "value"]);
        var isEndActive = this.props.activeRangeEnd === 'end' && isRangeEnd;
        var isStartActive = this.props.activeRangeEnd === 'start' && isRangeStart;
        var rootClassName = classNames$2('k-calendar-td', {
            'k-range-end': isRangeEnd,
            'k-range-mid': isRangeMid,
            'k-range-split-end': isRangeSplitEnd,
            'k-range-split-start': isRangeSplitStart,
            'k-range-start': isRangeStart,
            'k-active': isStartActive || isEndActive,
            'k-state-pending-focus': isFocused,
            'k-selected': isSelected || isRangeStart || isRangeEnd,
            'k-today': isToday,
            'k-weekend': isWeekend,
            'k-disabled': isDisabled
        }, className);
        return (React.createElement("td", __assign$G({}, other, { className: rootClassName, onClick: this.handleClick, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave }),
            React.createElement("span", { className: "k-link" }, this.props.children)));
    };
    return CalendarCell;
}(React.Component));

var __extends$G = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$F = (undefined && undefined.__assign) || function () {
    __assign$F = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$F.apply(this, arguments);
};
var __rest$9 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * The `CalendarWeekCell` component is internally used for rendering the week cells inside the `month` view of the Calendar. Also used as a [custom week cell for the Calendar]({% slug api_dateinputs_calendarprops %}#toc-weekcell) and the [MultiViewCalendar]({% slug api_dateinputs_multiviewcalendarprops %}#toc-weekcell) components.
 *
 * * [Customizing week-column cells in the Calendar]({% slug custom_rendering_calendar %}#toc-cells-inside-the-week-column)
 * * [Customizing week-column cells in the MultiViewCalendar]({% slug custom_rendering_multiviewcalendar %}#toc-cells-inside-the-week-column)
 */
var CalendarWeekCell = /** @class */ (function (_super) {
    __extends$G(CalendarWeekCell, _super);
    function CalendarWeekCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return
     * Returns a `<td />` element with the [`value`]({% slug api_dateinputs_calendarweekcellprops %}#toc-value) as a child.
     */
    CalendarWeekCell.prototype.render = function () {
        var _a = this.props, className = _a.className; _a.firstDate; var other = __rest$9(_a, ["className", "firstDate"]);
        return (React.createElement("td", __assign$F({ className: classNames$2('k-calendar-td', className) }, other), this.props.children));
    };
    return CalendarWeekCell;
}(React.Component));

/**
 * @hidden
 */
var Action;
(function (Action) {
    Action[Action["Left"] = 0] = "Left";
    Action[Action["Right"] = 1] = "Right";
    Action[Action["Up"] = 2] = "Up";
    Action[Action["Down"] = 3] = "Down";
    Action[Action["PrevView"] = 4] = "PrevView";
    Action[Action["NextView"] = 5] = "NextView";
    Action[Action["FirstInView"] = 6] = "FirstInView";
    Action[Action["LastInView"] = 7] = "LastInView";
    Action[Action["LowerView"] = 8] = "LowerView";
    Action[Action["UpperView"] = 9] = "UpperView";
})(Action || (Action = {}));

/**
 * The Enum which defines all possible Calendar view types.
 */
var CalendarViewEnum;
(function (CalendarViewEnum) {
    CalendarViewEnum[CalendarViewEnum["month"] = 0] = "month";
    CalendarViewEnum[CalendarViewEnum["year"] = 1] = "year";
    CalendarViewEnum[CalendarViewEnum["decade"] = 2] = "decade";
    CalendarViewEnum[CalendarViewEnum["century"] = 3] = "century";
})(CalendarViewEnum || (CalendarViewEnum = {}));

/**
 * @hidden
 */
var EMPTY_SELECTIONRANGE = { start: null, end: null };

(undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
var viewInRange = function (candidate, min, max) {
    if (min === undefined || max === undefined) {
        return candidate;
    }
    return min <= candidate && candidate <= max
        ? candidate
        : candidate < min
            ? min
            : max;
};
/**
 * @hidden
 */
var MIDNIGHT_DATE = new Date(1980, 0, 1);
/**
 * @hidden
 */
var MIN_DATE$1 = new Date(1900, 0, 1);
/**
 * @hidden
 */
var MAX_DATE$1 = new Date(2099, 11, 31);
/**
 * @hidden
 */
var setTime = function (origin, candidate) {
    var date = cloneDate(origin);
    date.setHours(candidate.getHours(), candidate.getMinutes(), candidate.getSeconds(), candidate.getMilliseconds());
    return date;
};
/**
 * @hidden
 */
var getToday = function () { return getDate(new Date()); };
/**
 * @hidden
 */
var isInRange$1 = function (candidate, min, max) { return (!candidate || !((min && min > candidate) || (max && max < candidate))); };
/**
 * @hidden
 */
var isInDateRange = function (candidate, min, max) { return (candidate === null
    || !((min && getDate(min) > getDate(candidate))
        || (max && getDate(max) < getDate(candidate)))); };
/**
 * @hidden
 */
var isInSelectionRange = function (value, selectionRange) {
    var _a = selectionRange || EMPTY_SELECTIONRANGE, start = _a.start, end = _a.end;
    if (!start || !end) {
        return false;
    }
    return start < value && value < end;
};
/**
 * @hidden
 */
var range = function (start, end, step) {
    if (step === void 0) { step = 1; }
    var result = [];
    for (var i = start; i < end; i = i + step) {
        result.push(i);
    }
    return result;
};
/**
 * @hidden
 */
var intersects = function (date, min, max) {
    return min.getTime() <= date.getTime() && date.getTime() <= max.getTime();
};
/**
 * @hidden
 */
var shiftWeekNames = function (names, offset) { return (names.slice(offset).concat(names.slice(0, offset))); };
/**
 * @hidden
 */
var dateInRange = function (candidate, min, max) {
    if (!candidate) {
        return candidate;
    }
    if (min && candidate < min) {
        return cloneDate(min);
    }
    if (max && candidate > max) {
        return cloneDate(max);
    }
    return candidate;
};
/**
 * @hidden
 */
var domContainerFactory = function (type) { return function (children, classes, styles) {
    if (classes === void 0) { classes = ''; }
    if (styles === void 0) { styles = {}; }
    var container = document.createElement(type);
    container.className = classes;
    Object.keys(styles).map(function (key) { return container.style[key] = styles[key]; });
    if (typeof children === 'string') {
        container.innerHTML = children || '';
    }
    else {
        (children || []).forEach(function (child) { return child && container.appendChild(child); });
    }
    return container;
}; };

var _a$8;
var EMPTY_DATA$3 = [[]];
var CELLS_LENGTH$3 = 4;
var ROWS_LENGTH$3 = 3;
var ACTIONS$3 = (_a$8 = {},
    _a$8[Action.Left] = function (date) { return addDecades(date, -1); },
    _a$8[Action.Up] = function (date) { return addDecades(date, -5); },
    _a$8[Action.Right] = function (date) { return addDecades(date, 1); },
    _a$8[Action.Down] = function (date) { return addDecades(date, 5); },
    _a$8[Action.PrevView] = function (date) { return addCenturies(date, -1); },
    _a$8[Action.NextView] = function (date) { return addCenturies(date, 1); },
    _a$8[Action.FirstInView] = function (date) { return firstDecadeOfCentury(date); },
    _a$8[Action.LastInView] = function (date) { return lastDecadeOfCentury(date); },
    _a$8);
/**
 * @hidden
 */
var CenturyViewService = /** @class */ (function () {
    function CenturyViewService() {
    }
    CenturyViewService.prototype.addToDate = function (min, skip) {
        return addCenturies(min, skip);
    };
    CenturyViewService.prototype.datesList = function (start, count) {
        return range(0, count).map(function (i) { return addCenturies(start, i); });
    };
    CenturyViewService.prototype.data = function (options) {
        var _this = this;
        var cellUID = options.cellUID, focusedDate = options.focusedDate, isActiveView = options.isActiveView, max = options.max, min = options.min, selectedDate = options.selectedDate, _a = options.selectionRange, selectionRange = _a === void 0 ? EMPTY_SELECTIONRANGE : _a, viewDate = options.viewDate;
        if (!viewDate) {
            return EMPTY_DATA$3;
        }
        var cells = range(0, CELLS_LENGTH$3);
        var firstDate = firstDecadeOfCentury(viewDate);
        var lastDate = lastDecadeOfCentury(viewDate);
        var today = getToday();
        return range(0, ROWS_LENGTH$3).map(function (rowOffset) {
            var baseDate = addDecades(firstDate, rowOffset * CELLS_LENGTH$3);
            return cells.map(function (cellOffset) {
                var cellDate = _this.normalize(addDecades(baseDate, cellOffset), min, max);
                var isRangeStart = _this.isEqual(cellDate, selectionRange.start);
                var isRangeEnd = _this.isEqual(cellDate, selectionRange.end);
                var isInMiddle = !isRangeStart && !isRangeEnd;
                var isRangeMid = isInMiddle && isInSelectionRange(cellDate, selectionRange);
                var isSelected = isActiveView && (!Array.isArray(selectedDate)
                    ? isInRange$1(selectedDate, min, max) && _this.isEqual(cellDate, selectedDate)
                    : _this.isSelectedFromArray(cellDate, selectedDate, min, max));
                return intersects(cellDate, firstDate, lastDate) ? ({
                    formattedValue: _this.value(cellDate),
                    id: "".concat(cellUID).concat(cellDate.getTime()),
                    isFocused: _this.isEqual(cellDate, focusedDate),
                    isSelected: isSelected,
                    isWeekend: false,
                    isInRange: isInRange$1(cellDate, min, max),
                    isRangeStart: isRangeStart,
                    isRangeMid: isRangeMid,
                    isRangeEnd: isRangeEnd,
                    isRangeSplitEnd: isRangeMid && _this.isEqual(cellDate, lastDate),
                    isRangeSplitStart: isRangeMid && _this.isEqual(cellDate, firstDate),
                    isToday: _this.isEqual(cellDate, today),
                    title: _this.cellTitle(cellDate),
                    value: cellDate
                }) : null;
            });
        });
    };
    CenturyViewService.prototype.isSelectedFromArray = function (candidate, dates, min, max) {
        var _this = this;
        var result = false;
        dates.forEach(function (date) {
            if (isInRange$1(candidate, min, max) && _this.isEqual(candidate, date)) {
                result = true;
            }
        });
        return result;
    };
    CenturyViewService.prototype.isEqual = function (candidate, expected) {
        if (!candidate || !expected) {
            return false;
        }
        // TODO: double-check this!
        return firstYearOfDecade(candidate).getFullYear() === firstYearOfDecade(expected).getFullYear();
    };
    CenturyViewService.prototype.isInArray = function (date, dates) {
        if (!dates.length) {
            return false;
        }
        var year = date.getFullYear();
        return dates[0].getFullYear() <= year && year <= (dates[dates.length - 1].getFullYear() + 99);
    };
    CenturyViewService.prototype.isInRange = function (candidate, min, max) {
        var year = firstYearOfDecade(candidate).getFullYear();
        var aboveMin = !min || firstYearOfDecade(min).getFullYear() <= year;
        var belowMax = !max || year <= firstYearOfDecade(max).getFullYear();
        return aboveMin && belowMax;
    };
    CenturyViewService.prototype.isInSameView = function (candidate, value) {
        return durationInCenturies(candidate, value) === 0;
    };
    CenturyViewService.prototype.isRangeStart = function (value) {
        return value.getFullYear() % 1000 === 0;
    };
    CenturyViewService.prototype.move = function (value, action) {
        var modifier = ACTIONS$3[action];
        if (!modifier) {
            return value;
        }
        return modifier(value);
    };
    CenturyViewService.prototype.cellTitle = function (value) {
        return firstYearOfDecade(value).getFullYear().toString();
    };
    CenturyViewService.prototype.navigationTitle = function (value) {
        return value ? firstDecadeOfCentury(value).getFullYear().toString() : '';
    };
    CenturyViewService.prototype.title = function (value) {
        if (!value) {
            return '';
        }
        return "".concat(firstDecadeOfCentury(value).getFullYear(), " - ").concat(lastDecadeOfCentury(value).getFullYear());
    };
    CenturyViewService.prototype.rowLength = function (_) {
        return CELLS_LENGTH$3;
    };
    CenturyViewService.prototype.skip = function (value, min) {
        return durationInCenturies(min, value);
    };
    CenturyViewService.prototype.total = function (min, max) {
        return durationInCenturies(min, max) + 1;
    };
    CenturyViewService.prototype.value = function (current) {
        return current ? firstYearOfDecade(current).getFullYear().toString() : '';
    };
    CenturyViewService.prototype.viewDate = function (date, max, border) {
        if (border === void 0) { border = 1; }
        var renderTwoViews = durationInCenturies(date, max) < border;
        return renderTwoViews ? addCenturies(date, -1) : date;
    };
    CenturyViewService.prototype.normalize = function (cellDate, min, max) {
        if (cellDate < min && this.isEqual(cellDate, min)) {
            return cloneDate(min);
        }
        if (cellDate > max && this.isEqual(cellDate, max)) {
            return cloneDate(max);
        }
        return cellDate;
    };
    return CenturyViewService;
}());

var _a$7;
var EMPTY_DATA$2 = [[]];
var CELLS_LENGTH$2 = 4;
var ROWS_LENGTH$2 = 3;
var ACTIONS$2 = (_a$7 = {},
    _a$7[Action.Left] = function (date) { return addYears(date, -1); },
    _a$7[Action.Up] = function (date) { return addYears(date, -5); },
    _a$7[Action.Right] = function (date) { return addYears(date, 1); },
    _a$7[Action.Down] = function (date) { return addYears(date, 5); },
    _a$7[Action.PrevView] = function (date) { return addDecades(date, -1); },
    _a$7[Action.NextView] = function (date) { return addDecades(date, 1); },
    _a$7[Action.FirstInView] = function (date) { return firstYearOfDecade(date); },
    _a$7[Action.LastInView] = function (date) { return lastYearOfDecade(date); },
    _a$7);
/**
 * @hidden
 */
var DecadeViewService = /** @class */ (function () {
    function DecadeViewService() {
    }
    DecadeViewService.prototype.addToDate = function (min, skip) {
        return addDecades(min, skip);
    };
    DecadeViewService.prototype.datesList = function (start, count) {
        return range(0, count).map(function (i) { return addDecades(start, i); });
    };
    DecadeViewService.prototype.data = function (options) {
        var _this = this;
        var cellUID = options.cellUID, focusedDate = options.focusedDate, isActiveView = options.isActiveView, max = options.max, min = options.min, selectedDate = options.selectedDate, _a = options.selectionRange, selectionRange = _a === void 0 ? EMPTY_SELECTIONRANGE : _a, viewDate = options.viewDate;
        if (!viewDate) {
            return EMPTY_DATA$2;
        }
        var cells = range(0, CELLS_LENGTH$2);
        var firstDate = firstYearOfDecade(viewDate);
        var lastDate = lastYearOfDecade(viewDate);
        var today = getToday();
        return range(0, ROWS_LENGTH$2).map(function (rowOffset) {
            var baseDate = addYears(firstDate, rowOffset * CELLS_LENGTH$2);
            return cells.map(function (cellOffset) {
                var cellDate = _this.normalize(addYears(baseDate, cellOffset), min, max);
                var isRangeStart = _this.isEqual(cellDate, selectionRange.start);
                var isRangeEnd = _this.isEqual(cellDate, selectionRange.end);
                var isInMiddle = !isRangeStart && !isRangeEnd;
                var isRangeMid = isInMiddle && isInSelectionRange(cellDate, selectionRange);
                var isSelected = isActiveView && (!Array.isArray(selectedDate)
                    ? isInRange$1(selectedDate, min, max) && _this.isEqual(cellDate, selectedDate)
                    : _this.isSelectedFromArray(cellDate, selectedDate, min, max));
                return intersects(cellDate, firstDate, lastDate) ? ({
                    formattedValue: _this.value(cellDate),
                    id: "".concat(cellUID).concat(cellDate.getTime()),
                    isFocused: _this.isEqual(cellDate, focusedDate),
                    isSelected: isSelected,
                    isWeekend: false,
                    isInRange: isInRange$1(cellDate, min, max),
                    isRangeStart: isRangeStart,
                    isRangeMid: isRangeMid,
                    isRangeEnd: isRangeEnd,
                    isRangeSplitEnd: isRangeMid && _this.isEqual(cellDate, lastDate),
                    isRangeSplitStart: isRangeMid && _this.isEqual(cellDate, firstDate),
                    isToday: _this.isEqual(cellDate, today),
                    title: _this.cellTitle(cellDate),
                    value: cellDate
                }) : null;
            });
        });
    };
    DecadeViewService.prototype.isSelectedFromArray = function (candidate, dates, min, max) {
        var _this = this;
        var result = false;
        dates.forEach(function (date) {
            if (isInRange$1(candidate, min, max) && _this.isEqual(candidate, date)) {
                result = true;
            }
        });
        return result;
    };
    DecadeViewService.prototype.isEqual = function (candidate, expected) {
        if (!candidate || !expected) {
            return false;
        }
        return candidate.getFullYear() === expected.getFullYear();
    };
    DecadeViewService.prototype.isInArray = function (date, dates) {
        if (!dates.length) {
            return false;
        }
        var year = date.getFullYear();
        return dates[0].getFullYear() <= year && year <= (dates[dates.length - 1].getFullYear() + 9);
    };
    DecadeViewService.prototype.isInRange = function (candidate, min, max) {
        var year = candidate.getFullYear();
        var aboveMin = !min || min.getFullYear() <= year;
        var belowMax = !max || year <= max.getFullYear();
        return aboveMin && belowMax;
    };
    DecadeViewService.prototype.isRangeStart = function (value) {
        return value.getFullYear() % 100 === 0;
    };
    DecadeViewService.prototype.isInSameView = function (candidate, value) {
        return durationInDecades(candidate, value) === 0;
    };
    DecadeViewService.prototype.move = function (value, action) {
        var modifier = ACTIONS$2[action];
        if (!modifier) {
            return value;
        }
        return modifier(value);
    };
    DecadeViewService.prototype.cellTitle = function (value) {
        return value.getFullYear().toString();
    };
    DecadeViewService.prototype.navigationTitle = function (value) {
        return value ? firstYearOfDecade(value).getFullYear().toString() : '';
    };
    DecadeViewService.prototype.title = function (value) {
        if (!value) {
            return '';
        }
        return "".concat(firstYearOfDecade(value).getFullYear(), " - ").concat(lastYearOfDecade(value).getFullYear());
    };
    DecadeViewService.prototype.rowLength = function (_) {
        return CELLS_LENGTH$2;
    };
    DecadeViewService.prototype.skip = function (value, min) {
        return durationInDecades(min, value);
    };
    DecadeViewService.prototype.total = function (min, max) {
        return durationInDecades(min, max) + 1;
    };
    DecadeViewService.prototype.value = function (current) {
        return current ? current.getFullYear().toString() : '';
    };
    DecadeViewService.prototype.viewDate = function (date, max, border) {
        if (border === void 0) { border = 1; }
        var renderTwoViews = durationInDecades(date, max) < border;
        return renderTwoViews ? addDecades(date, -1) : date;
    };
    DecadeViewService.prototype.normalize = function (cellDate, min, max) {
        if (cellDate < min && this.isEqual(cellDate, min)) {
            return cloneDate(min);
        }
        if (cellDate > max && this.isEqual(cellDate, max)) {
            return cloneDate(max);
        }
        return cellDate;
    };
    return DecadeViewService;
}());

var _a$6;
var EMPTY_DATA$1 = [[]];
var CELLS_LENGTH$1 = 7;
var ROWS_LENGTH$1 = 6;
var SATURDAY = 6;
var SUNDAY = 0;
var ACTIONS$1 = (_a$6 = {},
    _a$6[Action.Left] = function (date) { return addDays(date, -1); },
    _a$6[Action.Up] = function (date) { return addWeeks(date, -1); },
    _a$6[Action.Right] = function (date) { return addDays(date, 1); },
    _a$6[Action.Down] = function (date) { return addWeeks(date, 1); },
    _a$6[Action.PrevView] = function (date) { return addMonths(date, -1); },
    _a$6[Action.NextView] = function (date) { return addMonths(date, 1); },
    _a$6[Action.FirstInView] = function (date) { return firstDayOfMonth(date); },
    _a$6[Action.LastInView] = function (date) { return lastDayOfMonth(date); },
    _a$6);
/**
 * @hidden
 */
var MonthViewService = /** @class */ (function () {
    function MonthViewService(intl) {
        this.intl = intl;
    }
    MonthViewService.prototype.addToDate = function (min, skip) {
        return addMonths(min, skip);
    };
    MonthViewService.prototype.datesList = function (start, count) {
        return range(0, count).map(function (i) { return addMonths(start, i); });
    };
    MonthViewService.prototype.data = function (options) {
        var _this = this;
        var cellUID = options.cellUID, focusedDate = options.focusedDate, isActiveView = options.isActiveView, max = options.max, min = options.min, selectedDate = options.selectedDate, _a = options.selectionRange, selectionRange = _a === void 0 ? EMPTY_SELECTIONRANGE : _a, viewDate = options.viewDate;
        if (!viewDate) {
            return EMPTY_DATA$1;
        }
        var firstMonthDate = firstDayOfMonth(viewDate);
        var lastMonthDate = lastDayOfMonth(viewDate);
        var backward = -1;
        var date = dayOfWeek(firstMonthDate, this.intl.firstDay(), backward);
        var cells = range(0, CELLS_LENGTH$1);
        var today = getToday();
        return range(0, ROWS_LENGTH$1).map(function (rowOffset) {
            var baseDate = addDays(date, rowOffset * CELLS_LENGTH$1);
            return cells.map(function (cellOffset) {
                var cellDate = _this.normalize(addDays(baseDate, cellOffset), min, max);
                var otherMonth = cellDate < firstMonthDate || cellDate > lastMonthDate;
                if (otherMonth) {
                    return null;
                }
                var isRangeStart = _this.isEqual(cellDate, selectionRange.start);
                var isRangeEnd = _this.isEqual(cellDate, selectionRange.end);
                var isInMiddle = !isRangeStart && !isRangeEnd;
                var isRangeMid = isInMiddle && isInSelectionRange(cellDate, selectionRange);
                var isSelected = isActiveView && (!Array.isArray(selectedDate)
                    ? isInRange$1(selectedDate, min, max) && _this.isEqual(cellDate, selectedDate)
                    : _this.isSelectedFromArray(cellDate, selectedDate, min, max));
                var cell = {
                    formattedValue: _this.value(cellDate),
                    id: "".concat(cellUID).concat(cellDate.getTime()),
                    isFocused: _this.isEqual(cellDate, focusedDate),
                    isSelected: isSelected,
                    isInRange: isInRange$1(cellDate, min, max),
                    isWeekend: _this.isWeekend(cellDate),
                    isRangeStart: isRangeStart,
                    isRangeMid: isRangeMid,
                    isRangeEnd: isRangeEnd,
                    isRangeSplitStart: isRangeMid && _this.isEqual(cellDate, firstMonthDate),
                    isRangeSplitEnd: isRangeMid && _this.isEqual(cellDate, lastMonthDate),
                    isToday: _this.isEqual(cellDate, today),
                    title: _this.cellTitle(cellDate),
                    value: cellDate
                };
                return cell;
            });
        });
    };
    MonthViewService.prototype.isEqual = function (candidate, expected) {
        if (!candidate || !expected) {
            return false;
        }
        return getDate(candidate).getTime() === getDate(expected).getTime();
    };
    MonthViewService.prototype.isSelectedFromArray = function (candidate, dates, min, max) {
        var _this = this;
        var result = false;
        dates.forEach(function (date) {
            if (isInRange$1(candidate, min, max) && _this.isEqual(candidate, date)) {
                result = true;
            }
        });
        return result;
    };
    MonthViewService.prototype.isInArray = function (date, dates) {
        return !!dates.length && firstDayOfMonth(dates[0]) <= date && date <= lastDayOfMonth(dates[dates.length - 1]);
    };
    MonthViewService.prototype.isInRange = function (candidate, min, max) {
        var value = getDate(candidate);
        var aboveMin = !min || getDate(min) <= value;
        var belowMax = !max || value <= getDate(max);
        return aboveMin && belowMax;
    };
    MonthViewService.prototype.isInSameView = function (candidate, value) {
        return durationInMonths(candidate, value) === 0;
    };
    MonthViewService.prototype.isRangeStart = function (value) {
        return !value.getMonth();
    };
    MonthViewService.prototype.move = function (value, action) {
        var modifier = ACTIONS$1[action];
        if (!modifier) {
            return value;
        }
        return modifier(value);
    };
    MonthViewService.prototype.cellTitle = function (value) {
        return this.intl.formatDate(value, 'D');
    };
    MonthViewService.prototype.navigationTitle = function (value) {
        if (!value) {
            return '';
        }
        return this.isRangeStart(value) ? value.getFullYear().toString() : this.abbrMonthNames()[value.getMonth()];
    };
    MonthViewService.prototype.title = function (current) {
        return "".concat(this.wideMonthNames()[current.getMonth()], " ").concat(current.getFullYear());
    };
    MonthViewService.prototype.rowLength = function (prependCell) {
        return CELLS_LENGTH$1 + (prependCell ? 1 : 0);
    };
    MonthViewService.prototype.skip = function (value, min) {
        return durationInMonths(min, value);
    };
    MonthViewService.prototype.total = function (min, max) {
        return durationInMonths(min, max) + 1;
    };
    MonthViewService.prototype.value = function (current) {
        return current ? current.getDate().toString() : '';
    };
    MonthViewService.prototype.viewDate = function (date, max, border) {
        if (border === void 0) { border = 1; }
        var renderTwoViews = durationInMonths(date, max) < border;
        return renderTwoViews ? addMonths(date, -1) : date;
    };
    MonthViewService.prototype.isWeekend = function (date) {
        var day = date.getDay();
        return day === SATURDAY || day === SUNDAY;
    };
    MonthViewService.prototype.abbrMonthNames = function () {
        return this.intl.dateFormatNames({ nameType: 'abbreviated', type: 'months' });
    };
    MonthViewService.prototype.normalize = function (cellDate, min, max) {
        if (cellDate < min && this.isEqual(cellDate, min)) {
            return getDate(min);
        }
        if (cellDate > max && this.isEqual(cellDate, max)) {
            return getDate(max);
        }
        return cellDate;
    };
    MonthViewService.prototype.wideMonthNames = function () {
        return this.intl.dateFormatNames({ nameType: 'wide', type: 'months', standAlone: true });
    };
    return MonthViewService;
}());

var _a$5;
var EMPTY_DATA = [[]];
var CELLS_LENGTH = 4;
var ROWS_LENGTH = 3;
var upStep = function (month) {
    if (month > 4) {
        return -5;
    }
    if (month < 2) {
        return -2;
    }
    return -7;
};
var downStep = function (month) {
    if (month < 7) {
        return 5;
    }
    if (month < 10) {
        return 7;
    }
    return 2;
};
var ACTIONS = (_a$5 = {},
    _a$5[Action.Left] = function (date) { return addMonths(date, -1); },
    _a$5[Action.Up] = function (date) { return addMonths(date, upStep(date.getMonth())); },
    _a$5[Action.Right] = function (date) { return addMonths(date, 1); },
    _a$5[Action.Down] = function (date) { return addMonths(date, downStep(date.getMonth())); },
    _a$5[Action.PrevView] = function (date) { return addYears(date, -1); },
    _a$5[Action.NextView] = function (date) { return addYears(date, 1); },
    _a$5[Action.FirstInView] = function (date) { return firstMonthOfYear(date); },
    _a$5[Action.LastInView] = function (date) { return lastMonthOfYear(date); },
    _a$5);
/**
 * @hidden
 */
var YearViewService = /** @class */ (function () {
    function YearViewService(intl) {
        this._intl = intl;
    }
    YearViewService.prototype.addToDate = function (min, skip) {
        return addYears(min, skip);
    };
    YearViewService.prototype.datesList = function (start, count) {
        return range(0, count).map(function (i) { return addYears(start, i); });
    };
    YearViewService.prototype.data = function (options) {
        var _this = this;
        var cellUID = options.cellUID, focusedDate = options.focusedDate, isActiveView = options.isActiveView, max = options.max, min = options.min, selectedDate = options.selectedDate, _a = options.selectionRange, selectionRange = _a === void 0 ? EMPTY_SELECTIONRANGE : _a, viewDate = options.viewDate;
        if (!viewDate) {
            return EMPTY_DATA;
        }
        var months = this.abbrMonthNames();
        var firstDate = firstMonthOfYear(viewDate);
        var lastDate = lastMonthOfYear(viewDate);
        var currentYear = firstDate.getFullYear();
        var cells = range(0, CELLS_LENGTH);
        var today = getToday();
        return range(0, ROWS_LENGTH).map(function (rowOffset) {
            var baseDate = addMonths(firstDate, rowOffset * CELLS_LENGTH);
            return cells.map(function (cellOffset) {
                var cellDate = _this.normalize(addMonths(baseDate, cellOffset), min, max);
                var changedYear = currentYear < cellDate.getFullYear();
                if (changedYear) {
                    return null;
                }
                var isRangeStart = _this.isEqual(cellDate, selectionRange.start);
                var isRangeEnd = _this.isEqual(cellDate, selectionRange.end);
                var isInMiddle = !isRangeStart && !isRangeEnd;
                var isRangeMid = isInMiddle && isInSelectionRange(cellDate, selectionRange);
                var isSelected = isActiveView && (!Array.isArray(selectedDate)
                    ? isInRange$1(selectedDate, min, max) && _this.isEqual(cellDate, selectedDate)
                    : _this.isSelectedFromArray(cellDate, selectedDate, min, max));
                return {
                    formattedValue: months[cellDate.getMonth()],
                    id: "".concat(cellUID).concat(cellDate.getTime()),
                    isFocused: _this.isEqual(cellDate, focusedDate),
                    isSelected: isSelected,
                    isInRange: isInRange$1(cellDate, min, max),
                    isWeekend: false,
                    isRangeStart: isRangeStart,
                    isRangeMid: isRangeMid,
                    isRangeEnd: isRangeEnd,
                    isRangeSplitEnd: isRangeMid && _this.isEqual(cellDate, lastDate),
                    isRangeSplitStart: isRangeMid && _this.isEqual(cellDate, firstDate),
                    isToday: _this.isEqual(cellDate, today),
                    title: _this.cellTitle(cellDate),
                    value: cellDate
                };
            });
        });
    };
    YearViewService.prototype.isSelectedFromArray = function (candidate, dates, min, max) {
        var _this = this;
        var result = false;
        dates.forEach(function (date) {
            if (isInRange$1(candidate, min, max) && _this.isEqual(candidate, date)) {
                result = true;
            }
        });
        return result;
    };
    YearViewService.prototype.isEqual = function (candidate, expected) {
        if (!candidate || !expected) {
            return false;
        }
        return candidate.getFullYear() === expected.getFullYear() &&
            candidate.getMonth() === expected.getMonth();
    };
    YearViewService.prototype.isInArray = function (date, dates) {
        if (!dates.length) {
            return false;
        }
        var year = date.getFullYear();
        return dates[0].getFullYear() <= year && year <= dates[dates.length - 1].getFullYear();
    };
    YearViewService.prototype.isInRange = function (candidate, min, max) {
        var candidateValue = createDate(candidate.getFullYear(), candidate.getMonth(), 1);
        var aboveMin = !min || createDate(min.getFullYear(), min.getMonth(), 1) <= candidateValue;
        var belowMax = !max || candidateValue <= createDate(max.getFullYear(), max.getMonth(), 1);
        return aboveMin && belowMax;
    };
    YearViewService.prototype.isInSameView = function (candidate, value) {
        return durationInYears(candidate, value) === 0;
    };
    YearViewService.prototype.isRangeStart = function (value) {
        return value.getFullYear() % 10 === 0;
    };
    YearViewService.prototype.move = function (value, action) {
        var modifier = ACTIONS[action];
        if (!modifier) {
            return value;
        }
        return modifier(value);
    };
    YearViewService.prototype.cellTitle = function (value) {
        return "".concat(value.getFullYear(), " ").concat(this.value(value));
    };
    YearViewService.prototype.navigationTitle = function (value) {
        return this.title(value);
    };
    YearViewService.prototype.title = function (current) {
        return current ? current.getFullYear().toString() : '';
    };
    YearViewService.prototype.rowLength = function (_) {
        return CELLS_LENGTH;
    };
    YearViewService.prototype.skip = function (value, min) {
        return durationInYears(min, value);
    };
    YearViewService.prototype.total = function (min, max) {
        return durationInYears(min, max) + 1;
    };
    YearViewService.prototype.value = function (current) {
        return current ? this.abbrMonthNames()[current.getMonth()] : '';
    };
    YearViewService.prototype.viewDate = function (date, max, border) {
        if (border === void 0) { border = 1; }
        var renderTwoViews = durationInYears(date, max) < border;
        return renderTwoViews ? addYears(date, -1) : date;
    };
    YearViewService.prototype.abbrMonthNames = function () {
        return this._intl.dateFormatNames({ nameType: 'abbreviated', type: 'months' });
    };
    YearViewService.prototype.normalize = function (cellDate, min, max) {
        if (cellDate < min && this.isEqual(cellDate, min)) {
            return cloneDate(min);
        }
        if (cellDate > max && this.isEqual(cellDate, max)) {
            return cloneDate(max);
        }
        return cellDate;
    };
    return YearViewService;
}());

var _a$4;
var services = (_a$4 = {},
    _a$4[CalendarViewEnum.month] = MonthViewService,
    _a$4[CalendarViewEnum.year] = YearViewService,
    _a$4[CalendarViewEnum.decade] = DecadeViewService,
    _a$4[CalendarViewEnum.century] = CenturyViewService,
    _a$4);
var viewOffset = function (view, offset) {
    var candidate = CalendarViewEnum[CalendarViewEnum[view + offset]];
    return candidate !== undefined ? candidate : view;
};
/**
 * @hidden
 */
var BusViewService = /** @class */ (function () {
    function BusViewService(onViewChanged) {
        this.bottom = CalendarViewEnum.month;
        this.top = CalendarViewEnum.century;
        this.onViewChanged = onViewChanged;
    }
    BusViewService.prototype.configure = function (bottom, top) {
        this.bottom = bottom;
        this.top = top;
    };
    BusViewService.prototype.service = function (view, intl) {
        return new services["".concat(view)](intl);
    };
    BusViewService.prototype.moveDown = function (view, event) {
        this.move(view, -1, event);
    };
    BusViewService.prototype.moveUp = function (view, event) {
        this.move(view, 1, event);
    };
    BusViewService.prototype.moveToBottom = function (activeView) {
        if (activeView === this.bottom) {
            return;
        }
        this.onViewChanged({ view: this.bottom });
    };
    BusViewService.prototype.canMoveDown = function (view) {
        return this.bottom < view;
    };
    BusViewService.prototype.canMoveUp = function (view) {
        return view < this.top;
    };
    BusViewService.prototype.clamp = function (view) {
        if (view < this.bottom) {
            return this.bottom;
        }
        if (view > this.top) {
            return this.top;
        }
        return view;
    };
    BusViewService.prototype.move = function (view, offset, event) {
        var candidate = this.clamp(viewOffset(view, offset));
        if (candidate === view) {
            return;
        }
        this.onViewChanged({ view: candidate }, event);
    };
    return BusViewService;
}());

/**
 * @hidden
 */
var DOMService = /** @class */ (function () {
    function DOMService() {
        // heights
        this.calendarHeight = 0;
        this.headerHeight = 0;
        this.monthViewHeight = 0;
        this.yearViewHeight = 0;
        this.decadeViewHeight = 0;
        this.centuryViewHeight = 0;
        this.navigationItemHeight = 0;
        this.scrollableContentHeight = 0;
        this.scrollableYearContentHeight = 0;
        // widths
        this.calendarWidth = 0;
        this.monthViewWidth = 0;
        this.yearViewWidth = 0;
        this.decadeViewWidth = 0;
        this.centuryViewWidth = 0;
        this.scrollableContentWidth = 0;
        this.didCalculate = false;
        this.hostContainer = null;
    }
    DOMService.prototype.ensureHeights = function () {
        if (this.calendarHeight !== undefined) {
            return;
        }
        this.calculateHeights();
    };
    DOMService.prototype.calculateHeights = function (container) {
        var _this = this;
        if (!canUseDOM$2) {
            return;
        }
        var div = domContainerFactory('div');
        var ul = domContainerFactory('ul');
        var li = domContainerFactory('li');
        var td = domContainerFactory('td');
        var th = domContainerFactory('th');
        var tr = domContainerFactory('tr');
        var tbody = domContainerFactory('tbody');
        var thead = domContainerFactory('thead');
        var table = domContainerFactory('table');
        var monthHeader = function () { return (div("\n            <span class=\"k-button k-button-md k-button-rectangle k-button-solid k-button-solid-base k-button-flat k-calendar-title\">\n                <span className=\"k-button-text\">March 2017</span>\n            </span>\n            <span class=\"k-spacer\"></span>\n            <span class=\"k-calendar-nav k-hstack\"><span class=\"k-calendar-nav-today\">TODAY</span></span>\n        ", 'k-calendar-header k-hstack')); };
        var monthWeekHeader = function () { return (table([
            thead([
                tr([th('MO', 'k-calendar-th')], 'k-calendar-tr')
            ], 'k-calendar-thead')
        ], 'k-calendar-table k-calendar-weekdays')); };
        var repeat = function (count, mapper) { return new Array(count).fill('1').map(mapper); };
        var content = function (rows, cells) {
            if (cells === void 0) { cells = 1; }
            return (table([
                tbody([tr([td('1', 'k-calendar-td k-alt')])].concat(repeat(rows, function () { return tr(repeat(cells, function (c) { return td("<span class=\"k-link\">".concat(c, "</span>"), 'k-calendar-td'); }), 'k-calendar-tr'); })), 'k-calendar-tbody')
            ], 'k-calendar-table'));
        };
        var scrollable = function (children) { return div(children, 'k-content k-calendar-content k-scrollable'); };
        var view = function (contentElement, className, renderWeekHeader) { return (div(renderWeekHeader
            ? [
                monthHeader(),
                monthWeekHeader(),
                scrollable([contentElement, contentElement])
            ]
            : [
                monthHeader(),
                scrollable([contentElement, contentElement])
            ], className, { left: '-10000px', position: 'absolute' })); };
        var navigationList = (function () {
            var navElement;
            return function () {
                if (!canUseDOM$2) {
                    return null;
                }
                if (!navElement) {
                    navElement = div([scrollable([ul([li('<span>FEB</span>')])])], 'k-calendar-navigation', { left: '0px', position: 'absolute' });
                }
                return navElement;
            };
        })();
        var viewFactory = function (_a, className, renderWeekHeader) {
            var cells = _a.cells, rows = _a.rows;
            var viewElement;
            return function () {
                if (!canUseDOM$2) {
                    return null;
                }
                if (!viewElement) {
                    viewElement = view(content(rows, cells), className, renderWeekHeader);
                }
                return viewElement;
            };
        };
        var getScrollable = function (element) { return element.querySelector('.k-scrollable'); };
        var horizontal = function (element) {
            var scrollableElement = getScrollable(element);
            scrollableElement.className = "".concat(scrollableElement.className, " k-scrollable-horizontal");
            return element;
        };
        var monthView = viewFactory({ cells: 7, rows: 6 }, 'k-calendar-view k-calendar-monthview k-vstack', true);
        var yearView = viewFactory({ cells: 5, rows: 3 }, 'k-calendar-view k-calendar-yearview', false);
        var decadeView = viewFactory({ cells: 5, rows: 2 }, 'k-calendar-view k-calendar-decadeview', false);
        var horzMonthView = function () { return horizontal(monthView()); };
        var horzYearView = function () { return horizontal(yearView()); };
        var horzDecadeView = function () { return horizontal(decadeView()); };
        var height = function (element) { return (parseFloat(window.getComputedStyle(element).height) || element.offsetHeight); };
        var width = function (element) {
            var styles = window.getComputedStyle(element);
            var computed = parseFloat(styles.width)
                + parseFloat(styles.paddingLeft)
                + parseFloat(styles.paddingRight);
            return computed || element.offsetWidth;
        };
        var getBody = function (element) { return element.querySelector('tbody'); };
        this.didCalculate = true;
        if (container) {
            this.hostContainer = container;
        }
        this.batch(monthView(), function (contentElement) {
            var viewElement = getBody(contentElement);
            _this.calendarHeight = height(contentElement);
            _this.monthViewHeight = height(viewElement);
            _this.headerHeight = height(viewElement.children[0]);
            _this.scrollableContentHeight = height(getScrollable(contentElement));
        });
        this.batch(horzMonthView(), function (contentElement) {
            var viewElement = getBody(contentElement);
            _this.calendarWidth = width(contentElement);
            _this.monthViewWidth = width(viewElement);
            _this.scrollableContentWidth = width(getScrollable(contentElement));
        });
        this.batch(yearView(), function (contentElement) {
            _this.yearViewHeight = height(getBody(contentElement));
            _this.scrollableYearContentHeight = height(getScrollable(contentElement));
        });
        this.batch(horzYearView(), function (contentElement) {
            _this.yearViewWidth = width(getBody(contentElement));
        });
        this.batch(decadeView(), function (contentElement) {
            _this.decadeViewHeight = height(getBody(contentElement));
            _this.centuryViewHeight = _this.decadeViewHeight;
        });
        this.batch(horzDecadeView(), function (contentElement) {
            _this.decadeViewWidth = width(getBody(contentElement));
            _this.centuryViewWidth = _this.decadeViewWidth;
        });
        this.batch(navigationList(), function (contentElement) {
            _this.navigationItemHeight = height(contentElement.querySelector('li'));
        });
    };
    DOMService.prototype.viewHeight = function (viewType) {
        return this.viewDimension(viewType, 'height');
    };
    DOMService.prototype.viewWidth = function (viewType) {
        return this.viewDimension(viewType, 'width');
    };
    DOMService.prototype.viewDimension = function (viewType, dimension) {
        var viewProp = dimension === 'height' ? 'ViewHeight' : 'ViewWidth';
        switch (viewType) {
            case CalendarViewEnum.month:
                return this["month".concat(viewProp)];
            case CalendarViewEnum.year:
                return this["year".concat(viewProp)];
            case CalendarViewEnum.decade:
                return this["decade".concat(viewProp)];
            case CalendarViewEnum.century:
                return this["century".concat(viewProp)];
            default:
                return 1;
        }
    };
    DOMService.prototype.batch = function (contentElement, action) {
        var hostContainer = this.hostContainer || document.body;
        var appendedContent = hostContainer.appendChild(contentElement);
        action(appendedContent);
        hostContainer.removeChild(appendedContent);
    };
    return DOMService;
}());

var KEY_TO_ACTION = {
    '33': Action.PrevView,
    '34': Action.NextView,
    '35': Action.LastInView,
    '36': Action.FirstInView,
    '37': Action.Left,
    '38': Action.Up,
    '39': Action.Right,
    '40': Action.Down,
    'meta+38': Action.UpperView,
    'meta+40': Action.LowerView
};
/**
 * @hidden
 */
var NavigationService = /** @class */ (function () {
    function NavigationService(bus) {
        this.bus = bus;
    }
    NavigationService.prototype.action = function (event) {
        var action = "".concat(event.ctrlKey || event.metaKey ? 'meta+' : '').concat(event.keyCode);
        return KEY_TO_ACTION[action];
    };
    NavigationService.prototype.move = function (value, action, activeView, service, event) {
        if (!service) {
            return value;
        }
        if (action === Action.UpperView && this.bus.canMoveUp(activeView)) {
            this.bus.moveUp(activeView, event);
            return value;
        }
        if (action === Action.LowerView && this.bus.canMoveDown(activeView)) {
            this.bus.moveDown(activeView, event);
            return value;
        }
        return service.move(value, action);
    };
    return NavigationService;
}());

var divideByMagnitude = function (magnitude) { return function (x) { return Math.floor(x / magnitude); }; };
var powerByMagnitude = function (magnitude) { return function (x) { return x * magnitude; }; };
/**
 * @hidden
 */
var ScrollSyncService = /** @class */ (function () {
    function ScrollSyncService(dom) {
        this.dom = dom;
        this.divideByMagnitude = null;
        this.powerByMagnitude = null;
        this.navigator = null;
        this.view = null;
        this.monthScrolled = false;
        this.navScrolled = false;
    }
    ScrollSyncService.prototype.configure = function (activeView) {
        var magnitude = Math.max(this.dom.viewHeight(activeView) / this.dom.navigationItemHeight, 1);
        this.divideByMagnitude = divideByMagnitude(magnitude);
        this.powerByMagnitude = powerByMagnitude(magnitude);
    };
    ScrollSyncService.prototype.sync = function (navigator, view, e) {
        if (!navigator || !view) {
            return;
        }
        this.navigator = navigator;
        this.view = view;
        if (e.target === this.navigator.element) {
            if (this.monthScrolled) {
                this.monthScrolled = false;
                return;
            }
            this.navScrolled = true;
            this.scrollSiblingOf(this.navigator.element);
        }
        if (e.target === this.view.element) {
            if (this.navScrolled) {
                this.navScrolled = false;
                return;
            }
            this.monthScrolled = true;
            this.scrollSiblingOf(this.view.element);
        }
    };
    ScrollSyncService.prototype.scrollSiblingOf = function (scrolledElement) {
        var component = this.siblingComponent(scrolledElement);
        var scrollTop = this.calculateScroll(component, scrolledElement.scrollTop);
        component.scrollTo(scrollTop);
    };
    ScrollSyncService.prototype.siblingComponent = function (scrollableElement) {
        return this.navigator.element === scrollableElement ? this.view : this.navigator;
    };
    ScrollSyncService.prototype.calculateScroll = function (component, scrollTop) {
        var modifier = component === this.navigator ? this.divideByMagnitude : this.powerByMagnitude;
        return modifier ? modifier(scrollTop) : 0;
    };
    return ScrollSyncService;
}());

/**
 * @hidden
 */
var WeekNamesService = /** @class */ (function () {
    function WeekNamesService(intl) {
        this.intl = intl;
    }
    WeekNamesService.prototype.getWeekNames = function (includeWeekNumber) {
        if (includeWeekNumber === void 0) { includeWeekNumber = false; }
        var weekNames = shiftWeekNames(this.intl.dateFormatNames({ nameType: 'short', type: 'days' }), this.intl.firstDay());
        return includeWeekNumber ? [''].concat(weekNames) : weekNames;
    };
    return WeekNamesService;
}());

var __extends$F = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$E = (undefined && undefined.__assign) || function () {
    __assign$E = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$E.apply(this, arguments);
};
// In case we decide to render content for the next month in the empty cells,
// add k-other-month class to all cells and k-weekend for weekend cells.
// tslint:disable-next-line jsx-use-translation-function
var emptyCell = function (idx) { return (React.createElement("td", { key: idx, className: 'k-calendar-td' }, "\u00A0")); };
/**
 * @hidden
 */
var View = /** @class */ (function (_super) {
    __extends$F(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.intl = null;
        _this.weekService = null;
        _this.buildWeekNumber = function (row, idx) {
            var firstDayOfWeek = _this.firstDate(row);
            if (!firstDayOfWeek) {
                return emptyCell("week-cell-".concat(idx));
            }
            var firstDate = _this.firstDate(row);
            var weekCellValue = _this.getWeekNumber(firstDate);
            var uniqueID = "kendo-react-calendar-week-cell-".concat(weekCellValue);
            var cellProps = {
                className: 'k-alt',
                value: weekCellValue,
                firstDate: firstDate
            };
            return _this.props.weekCell
                ? React.createElement(_this.props.weekCell, __assign$E({}, cellProps, { key: uniqueID }), weekCellValue)
                : React.createElement(CalendarWeekCell, __assign$E({}, cellProps, { key: uniqueID }), weekCellValue);
        };
        _this.buildRow = function (row) {
            return row.map(function (cell, idx) {
                if (!cell) {
                    return emptyCell(idx);
                }
                var aria = { 'aria-selected': cell.isSelected };
                var uniqueID = "kendo-react-calendar-cell-".concat(cell.value.getTime());
                var cellProps = __assign$E(__assign$E(__assign$E({}, aria), cell), { isDisabled: !cell.isInRange, view: _this.props.activeView, onClick: _this.handleClick, onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave });
                return _this.props.cell
                    ? (React.createElement(_this.props.cell, __assign$E({}, cellProps, { key: uniqueID }), cell.formattedValue))
                    : (React.createElement(CalendarCell, __assign$E({}, cellProps, { key: uniqueID }), cell.formattedValue));
            });
        };
        _this.firstDate = function (row) {
            var cell = _this.firstWeekDateContext(row);
            return cell ? cell.value : null;
        };
        _this.firstWeekDateContext = function (rowCtx) {
            if (!_this.weekNumber) {
                return null;
            }
            var idx = 0;
            var ctx = rowCtx[idx];
            while (!ctx && idx < rowCtx.length) {
                ctx = rowCtx[++idx];
            }
            return ctx;
        };
        _this.handleClick = function (value, event) {
            var onChange = _this.props.onChange;
            if (onChange && event) {
                var args = {
                    value: cloneDate(value),
                    target: _this,
                    nativeEvent: event && event.nativeEvent,
                    syntheticEvent: event
                };
                onChange.call(undefined, args);
            }
        };
        _this.handleMouseEnter = function (value) {
            var onCellEnter = _this.props.onCellEnter;
            if (onCellEnter) {
                onCellEnter.call(undefined, cloneDate(value));
            }
        };
        _this.handleMouseLeave = function (value) {
            var onCellLeave = _this.props.onCellLeave;
            if (onCellLeave) {
                onCellLeave.call(undefined, cloneDate(value));
            }
        };
        return _this;
    }
    Object.defineProperty(View.prototype, "min", {
        get: function () {
            return this.props.min;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(View.prototype, "max", {
        get: function () {
            return this.props.max;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(View.prototype, "isHorizontal", {
        get: function () {
            return this.props.direction === 'horizontal';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(View.prototype, "isMonthView", {
        get: function () {
            return this.props.activeView === CalendarViewEnum.month;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(View.prototype, "weekNumber", {
        get: function () {
            return Boolean(this.props.showWeekNumbers && this.props.activeView === CalendarViewEnum.month);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(View.prototype, "selectedDate", {
        get: function () {
            return this.props.selectedDate !== undefined ? this.props.selectedDate : View.defaultProps.selectedDate;
        },
        enumerable: false,
        configurable: true
    });
    View.prototype.render = function () {
        var _this = this;
        this.intl = provideIntlService(this);
        this.weekService = new WeekNamesService(this.intl);
        var weekNames = this.weekService.getWeekNames(this.weekNumber);
        var colSpan = this.props.service.rowLength(this.weekNumber);
        var title = this.props.service.title(this.props.viewDate);
        var time = getToday();
        var viewDate = setTime(this.props.viewDate, time);
        var data = this.props.service.data({
            cellUID: this.props.cellUID,
            min: this.min,
            max: this.max,
            focusedDate: this.props.focusedDate,
            isActiveView: !this.props.bus.canMoveDown(this.props.activeView),
            selectedDate: this.selectedDate,
            selectionRange: this.props.selectionRange,
            viewDate: viewDate
        });
        return (React.createElement(React.Fragment, null,
            (this.isMonthView && this.isHorizontal) && (React.createElement("thead", { role: "rowgroup", className: "k-calendar-thead" },
                React.createElement("tr", { role: "row", className: "k-calendar-tr" }, weekNames.map(function (name, idx) { return (React.createElement("th", { key: idx, className: "k-calendar-th" }, name)); })))),
            React.createElement("tbody", { role: "rowgroup", className: "k-calendar-tbody" },
                !this.isHorizontal && (React.createElement("tr", { role: "presentation", className: "k-calendar-tr" },
                    React.createElement("th", { scope: "col", colSpan: colSpan, className: "k-calendar-caption" }, title))),
                data.map(function (row, idx) {
                    return (React.createElement("tr", { role: "row", className: "k-calendar-tr", key: idx },
                        _this.weekNumber && _this.buildWeekNumber(row, idx),
                        _this.buildRow(row)));
                }))));
    };
    View.prototype.getWeekNumber = function (date) {
        if (!this.weekNumber || !this.intl) {
            return null;
        }
        return weekInYear(date, this.intl.firstDay());
    };
    View.propTypes = {
        activeRangeEnd: propTypes.exports.oneOf(['start', 'end', null]),
        activeView: propTypes.exports.number.isRequired,
        cellUID: propTypes.exports.string.isRequired,
        direction: propTypes.exports.oneOf(['horizontal', 'vertical']),
        focusedDate: propTypes.exports.instanceOf(Date).isRequired,
        max: propTypes.exports.instanceOf(Date).isRequired,
        min: propTypes.exports.instanceOf(Date).isRequired,
        onChange: propTypes.exports.func,
        selectedDate: propTypes.exports.oneOfType([propTypes.exports.instanceOf(Date), propTypes.exports.arrayOf(propTypes.exports.instanceOf(Date))]),
        showWeekNumbers: propTypes.exports.bool,
        viewDate: propTypes.exports.instanceOf(Date).isRequired
    };
    View.defaultProps = {
        direction: 'vertical',
        selectedDate: getToday(),
        showWeekNumbers: false
    };
    return View;
}(React.Component));
registerForIntl(View);

var __extends$E = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$D = (undefined && undefined.__assign) || function () {
    __assign$D = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$D.apply(this, arguments);
};
var __rest$8 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * The `CalendarHeaderTitle` component is internally used for rendering the title of the current calendar view. Also used as a custom `headerTitle` for the [Calendar]({% slug api_dateinputs_calendarprops %}#toc-headertitle) and the [MultiViewCalendar]({% slug api_dateinputs_multiviewcalendarprops %}#toc-headertitle) components.
 *
 * * [Customizing the title for the current Calendar view]({% slug custom_rendering_calendar %}#toc-cells-inside-the-view)
 * * [Customizing the title for the current MultiViewCalendar view]({% slug custom_rendering_multiviewcalendar %}#toc-cells-inside-the-view)
 */
var CalendarHeaderTitle = /** @class */ (function (_super) {
    __extends$E(CalendarHeaderTitle, _super);
    function CalendarHeaderTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return
     * Returns a `<span />` element with the [`value`]({% slug api_dateinputs_calendarheadertitleprops %}#toc-value) of the title as a child.
     */
    CalendarHeaderTitle.prototype.render = function () {
        var _a = this.props; _a.view; var props = __rest$8(_a, ["view"]);
        return (React.createElement(Button$2, __assign$D({ type: "button", fillMode: "flat" }, props), this.props.children));
    };
    return CalendarHeaderTitle;
}(React.PureComponent));

/**
 * @hidden
 */
/**
 * @hidden
 */
var MIN_DATE = new Date(1900, 0, 1);
/**
 * @hidden
 */
var MAX_DATE = new Date(2099, 11, 31);
/**
 * @hidden
 */
var MIN_TIME = new Date(1980, 0, 1);
/**
 * @hidden
 */
var MAX_TIME = new Date(1980, 0, 1, 23, 59, 59);

var __extends$D = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$C = (undefined && undefined.__assign) || function () {
    __assign$C = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$C.apply(this, arguments);
};
/**
 * @hidden
 */
var Header$1 = /** @class */ (function (_super) {
    __extends$D(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTitle = function () {
            if (!_this.props.currentDate) {
                return '';
            }
            var take = _this.rangeLength - 1;
            var title = _this.props.service.title(_this.props.currentDate);
            var nextDate = _this.props.service.addToDate(_this.props.currentDate, take);
            if (take < 1 || !_this.props.service.isInRange(nextDate, _this.min, _this.max)) {
                return title;
            }
            return "".concat(title, " - ").concat(_this.props.service.title(nextDate));
        };
        _this.handleTitleClick = function (event) {
            if (!_this.canMoveUp) {
                return;
            }
            _this.props.bus.moveUp(_this.props.activeView, event);
        };
        return _this;
    }
    Object.defineProperty(Header.prototype, "min", {
        get: function () {
            return this.props.min !== undefined
                ? this.props.min
                : Header.defaultProps.min;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "max", {
        get: function () {
            return this.props.max !== undefined
                ? this.props.max
                : Header.defaultProps.max;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "rangeLength", {
        get: function () {
            return this.props.rangeLength !== undefined ? this.props.rangeLength : Header.defaultProps.rangeLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "canMoveUp", {
        get: function () {
            return this.props.bus.canMoveUp(this.props.activeView);
        },
        enumerable: false,
        configurable: true
    });
    Header.prototype.render = function () {
        var title = this.getTitle();
        var titleClassNames = classNames$2('k-calendar-title');
        var headerTitleProps = {
            children: title,
            value: title,
            view: this.props.activeView,
            className: titleClassNames,
            onClick: this.handleTitleClick,
            disabled: !this.canMoveUp
        };
        var headerTitle = this.props.headerTitle
            ? React.createElement(this.props.headerTitle, __assign$C({}, headerTitleProps), title)
            : React.createElement(CalendarHeaderTitle, __assign$C({}, headerTitleProps), title);
        return (React.createElement("div", { className: "k-calendar-header k-hstack" },
            headerTitle,
            React.createElement("span", { className: "k-spacer" }),
            React.createElement("span", { className: "k-calendar-nav k-hstack" }, this.props.commands)));
    };
    Header.propTypes = {
        activeView: propTypes.exports.number.isRequired,
        currentDate: propTypes.exports.instanceOf(Date).isRequired,
        max: propTypes.exports.instanceOf(Date).isRequired,
        min: propTypes.exports.instanceOf(Date).isRequired,
        rangeLength: propTypes.exports.number
    };
    Header.defaultProps = {
        rangeLength: 1,
        min: MIN_DATE,
        max: MAX_DATE
    };
    return Header;
}(React.Component));
registerForLocalization(Header$1);

var _a$3;
/**
 * @hidden
 */
var prevView = 'multiviewcalendar.prevView';
/**
 * @hidden
 */
var nextView = 'multiviewcalendar.nextView';
/**
 * @hidden
 */
var increaseValue$1 = 'dateinput.increment';
/**
 * @hidden
 */
var decreaseValue$1 = 'dateinput.decrement';
/**
 * @hidden
 */
var today = 'calendar.today';
/**
 * @hidden
 */
var toggleCalendar = 'datepicker.toggleCalendar';
/**
 * @hidden
 */
var swapStartEnd = 'daterangepicker.swapStartEnd';
/**
 * @hidden
 */
var start = 'daterangepicker.start';
/**
 * @hidden
 */
var end = 'daterangepicker.end';
/**
 * @hidden
 */
var separator = 'daterangepicker.separator';
/**
 * @hidden
 */
var toggleDateTimeSelector = 'datetimepicker.toggleDateTimeSelector';
/**
 * @hidden
 */
var now = 'timepicker.now';
/**
 * @hidden
 */
var selectNow = 'timepicker.selectNow';
/**
 * @hidden
 */
var timePickerCancel = 'timepicker.cancel';
/**
 * @hidden
 */
var timePickerSet = 'timepicker.set';
/**
 * @hidden
 */
var toggleTimeSelector = 'timepicker.toggleTimeSelector';
/**
 * @hidden
 */
var toggleClock = 'timepicker.toggleClock';
/**
 * @hidden
 */
var date = 'datetimepicker.date';
/**
 * @hidden
 */
var time = 'datetimepicker.time';
/**
 * @hidden
 */
var dateTimePickerCancel = 'datetimepicker.cancel';
/**
 * @hidden
 */
var dateTimePickerSet = 'datetimepicker.set';
/**
 * @hidden
 */
var messages$2 = (_a$3 = {},
    _a$3[today] = 'TODAY',
    _a$3[now] = 'NOW',
    _a$3[timePickerSet] = 'Set',
    _a$3[timePickerCancel] = 'Cancel',
    _a$3[date] = 'Date',
    _a$3[time] = 'Time',
    _a$3[dateTimePickerCancel] = 'Cancel',
    _a$3[dateTimePickerSet] = 'Set',
    _a$3[start] = 'Start',
    _a$3[end] = 'End',
    _a$3[separator] = ' ',
    _a$3[selectNow] = 'Select Now',
    _a$3[toggleTimeSelector] = 'Toggle TimeSelector',
    _a$3[toggleClock] = 'Toggle Clock',
    _a$3[increaseValue$1] = 'Increase value',
    _a$3[decreaseValue$1] = 'Decrease value',
    _a$3[toggleCalendar] = 'Toggle calendar',
    _a$3[prevView] = 'Navigate to previous view',
    _a$3[nextView] = 'Navigate to next view',
    _a$3[swapStartEnd] = 'Swap start and end values',
    _a$3[toggleDateTimeSelector] = 'Toggle date-time selector',
    _a$3);

var __extends$C = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var TodayCommand = /** @class */ (function (_super) {
    __extends$C(TodayCommand, _super);
    function TodayCommand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localization = null;
        _this.handleClick = function (syntheticEvent) {
            if (!_this.todayIsInRange) {
                return;
            }
            if (_this.props.onClick) {
                var event_1 = {
                    syntheticEvent: syntheticEvent,
                    nativeEvent: syntheticEvent.nativeEvent,
                    value: dateInRange(getToday(), _this.min, _this.max),
                    target: _this,
                    isTodayClick: true
                };
                _this.props.onClick.call(undefined, event_1);
            }
        };
        return _this;
    }
    Object.defineProperty(TodayCommand.prototype, "min", {
        get: function () {
            return this.props.min !== undefined
                ? this.props.min
                : TodayCommand.defaultProps.min;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TodayCommand.prototype, "max", {
        get: function () {
            return this.props.max !== undefined
                ? this.props.max
                : TodayCommand.defaultProps.max;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TodayCommand.prototype, "todayIsInRange", {
        get: function () {
            return isInRange$1(getToday(), getDate(this.min), getDate(this.max));
        },
        enumerable: false,
        configurable: true
    });
    TodayCommand.prototype.render = function () {
        this.localization = provideLocalizationService(this);
        var todayMessage = this.localization.toLanguageString(today, messages$2[today]);
        var todayClassNames = classNames$2('k-calendar-nav-today', {
            'k-disabled': this.props.disabled
        });
        return (React.createElement("span", { className: todayClassNames, onClick: this.handleClick, tabIndex: this.props.tabIndex }, todayMessage));
    };
    TodayCommand.propTypes = {
        max: propTypes.exports.instanceOf(Date).isRequired,
        min: propTypes.exports.instanceOf(Date).isRequired,
        onClick: propTypes.exports.func,
        disabled: propTypes.exports.bool
    };
    TodayCommand.defaultProps = {
        min: MIN_DATE,
        max: MAX_DATE
    };
    return TodayCommand;
}(React.Component));
registerForLocalization(TodayCommand);

var __extends$B = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var VIEWS_COUNT = 5;
/**
 * @hidden
 */
var ViewList = /** @class */ (function (_super) {
    __extends$B(ViewList, _super);
    function ViewList(props) {
        var _this = _super.call(this, props) || this;
        _this.virtualization = null;
        _this.calendarView = null;
        _this.table = null;
        _this.intl = null;
        _this.bottomOffset = 0;
        _this.viewOffset = 0;
        _this.viewHeight = 0;
        _this._element = null;
        _this.isActive = false;
        _this.animateToIndex = true;
        _this.shouldScroll = false;
        _this.focusActiveDate = function () {
            if (!_this._element) {
                return;
            }
            var focusedCell = _this._element.querySelector('td.k-focus');
            var nextActiveCell = _this._element.querySelector('.k-state-pending-focus');
            if (focusedCell && focusedCell[0]) {
                focusedCell[0].classList.remove('k-focus');
            }
            if (nextActiveCell) {
                nextActiveCell.classList.add('k-focus');
            }
            _this.isActive = true;
        };
        _this.blurActiveDate = function () {
            if (!_this._element) {
                return;
            }
            var focusedCell = _this._element.querySelector('td.k-focus');
            if (focusedCell) {
                focusedCell.classList.remove('k-focus');
            }
            _this.isActive = false;
        };
        _this.handleVirtualizationMount = function (virtualization) {
            _this.virtualization = virtualization;
            if (_this.virtualization && _this.table) {
                _this.table.style.transform = "translateY(".concat(_this.viewOffset, "px)");
                var viewDate = dateInRange(_this.props.focusedDate, _this.props.min, _this.props.max);
                var indexToScroll = _this.props.service.skip(viewDate, _this.props.min);
                _this.virtualization.scrollToIndex(indexToScroll);
            }
        };
        _this.buildMonthView = function (cols, weekNames) {
            return (React.createElement("table", { key: "calendar-view-list-weekdays", className: "k-calendar-table k-calendar-weekdays" },
                React.createElement("colgroup", null, cols.map(function (_, idx) { return (React.createElement("col", { key: idx })); })),
                React.createElement("thead", { className: "k-calendar-thead" },
                    React.createElement("tr", { className: "k-calendar-tr" }, weekNames.map(function (name, idx) { return (React.createElement("th", { key: idx, className: "k-calendar-th" }, name)); })))));
        };
        _this.buildDates = function (cols, dates) {
            var cellUID = _this.props.cellUID;
            return (React.createElement("table", { className: "k-calendar-table", ref: function (table) { return _this.table = table; }, role: "grid", "aria-activedescendant": cellUID + _this.props.focusedDate.getTime() },
                React.createElement("colgroup", null, cols.map(function (_, idx) { return (React.createElement("col", { key: idx })); })),
                dates.map(function (date) { return (React.createElement(View, { ref: function (el) { if (!_this.calendarView) {
                        _this.calendarView = el;
                    } }, key: date.getTime(), activeView: _this.props.activeView, viewDate: date, min: _this.props.min, max: _this.props.max, cellUID: cellUID, focusedDate: _this.props.focusedDate, cell: _this.props.cell, selectedDate: _this.props.value, showWeekNumbers: _this.weekNumber, onChange: _this.handleDateChange, bus: _this.props.bus, service: _this.props.service, weekCell: _this.props.weekCell })); })));
        };
        _this.calculateHeights = function () {
            if (!_this.props.dom) {
                return;
            }
            var scrollableHeight = _this.props.activeView === CalendarViewEnum.month ?
                _this.props.dom.scrollableContentHeight :
                _this.props.dom.scrollableYearContentHeight;
            _this.bottomOffset = scrollableHeight - _this.props.dom.viewHeight(_this.props.activeView);
            _this.viewOffset = -1 * _this.props.dom.headerHeight;
            _this.viewHeight = _this.props.dom.viewHeight(_this.props.activeView) || 1;
        };
        _this.getTake = function (skip, total) {
            return Math.min(total - skip, _this.take);
        };
        _this.handleScrollAction = function (_a) {
            var index = _a.index, scrollAction = _a.scrollAction, pageAction = _a.pageAction;
            var skip = pageAction ? pageAction.skip : _this.state.skip;
            if (_this.state.index !== index || _this.state.skip !== skip) {
                _this.setState({ index: index, skip: skip });
            }
            if (_this.table && scrollAction) {
                var translate = "translateY(".concat(scrollAction.offset, "px)");
                _this.table.style.transform = translate;
            }
        };
        _this.handleTodayClick = function (event) {
            _this.shouldScroll = true;
            _this.handleDateChange.call(undefined, event, true);
        };
        _this.handleDateChange = function (event, isTodayClick) {
            if (isTodayClick === void 0) { isTodayClick = false; }
            var onChange = _this.props.onChange;
            if (onChange) {
                var args = {
                    syntheticEvent: event.syntheticEvent,
                    nativeEvent: event.nativeEvent,
                    value: cloneDate(event.value),
                    target: _this,
                    isTodayClick: isTodayClick
                };
                onChange.call(undefined, args);
            }
        };
        _this.lastView = _this.props.activeView;
        _this.lastFocus = _this.props.focusedDate;
        _this.state = {
            skip: _this.props.service.skip(_this.props.focusedDate, _this.props.min),
            index: _this.props.service.skip(_this.props.focusedDate, _this.props.min)
        };
        return _this;
    }
    Object.defineProperty(ViewList.prototype, "element", {
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewList.prototype, "weekNames", {
        get: function () {
            this.intl = provideIntlService(this);
            var weekNames = shiftWeekNames(this.intl.dateFormatNames({ nameType: 'short', type: 'days' }), this.intl.firstDay());
            return this.weekNumber ? [''].concat(weekNames) : weekNames;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewList.prototype, "weekNumber", {
        get: function () {
            return Boolean(this.props.showWeekNumbers && this.props.activeView === CalendarViewEnum.month);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewList.prototype, "take", {
        get: function () {
            return this.props.take !== undefined ? this.props.take : ViewList.defaultProps.take;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewList.prototype, "animate", {
        get: function () {
            return Boolean(this.props.smoothScroll && this.animateToIndex);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewList.prototype, "todayIsInRange", {
        get: function () {
            return isInRange$1(getToday(), getDate(this.props.min), getDate(this.props.max));
        },
        enumerable: false,
        configurable: true
    });
    ViewList.prototype.componentDidUpdate = function (_prevProps, _prevState) {
        this.shouldScroll = false;
        if (this.indexToScroll !== undefined && this.virtualization) {
            this.virtualization[this.animate ? 'animateToIndex' : 'scrollToIndex'](this.indexToScroll);
        }
        if (this.isActive) {
            this.focusActiveDate();
        }
        this.lastView = this.props.activeView;
        // this.lastFocus = this.props.focusedDate;
        this.indexToScroll = undefined;
    };
    ViewList.prototype.render = function () {
        var _this = this;
        this.calculateHeights();
        var didViewChange = this.lastView !== this.props.activeView;
        var focusedDate = dateInRange(this.props.focusedDate, this.props.min, this.props.max);
        var skip = !didViewChange ? this.state.skip : this.props.service.skip(focusedDate, this.props.min);
        var total = this.props.service.total(this.props.min, this.props.max);
        var take = this.getTake(skip, total);
        var viewDate = this.props.service.addToDate(this.props.min, skip);
        var activeDate = this.props.service.addToDate(this.props.min, this.state.index);
        var cols = new Array(this.props.service.rowLength(this.weekNumber)).fill('');
        var didViewChanged = this.props.activeView !== this.lastView;
        this.animateToIndex = !didViewChanged;
        if (didViewChanged
            || !isEqualDate(this.lastFocus, focusedDate)
            || this.shouldScroll
            || (!this.props.shouldScroll || this.props.shouldScroll())) {
            this.indexToScroll = this.props.service.skip(focusedDate, this.props.min);
        }
        this.lastFocus = focusedDate;
        var rootClassNames = classNames$2('k-calendar-view k-vstack', {
            'k-calendar-monthview': this.props.activeView === CalendarViewEnum.month,
            'k-calendar-yearview': this.props.activeView === CalendarViewEnum.year,
            'k-calendar-decadeview': this.props.activeView === CalendarViewEnum.decade,
            'k-calendar-centuryview': this.props.activeView === CalendarViewEnum.century
        });
        var dates = this.buildDates(cols, this.props.service.datesList(viewDate, take));
        var viewListBody = (React.createElement(React.Fragment, null,
            React.createElement(Header$1, { key: "calendar-view-list-header", currentDate: activeDate, min: this.props.min, max: this.props.max, activeView: this.props.activeView, bus: this.props.bus, service: this.props.service, headerTitle: this.props.headerTitle, commands: (React.createElement(React.Fragment, null,
                    React.createElement(TodayCommand, { min: this.props.min, max: this.props.max, onClick: this.handleTodayClick, disabled: !this.todayIsInRange, tabIndex: this.props.tabIndex }))) }),
            this.props.activeView === CalendarViewEnum.month && this.buildMonthView(cols, this.weekNames),
            React.createElement(Virtualization, { key: "calendar-view-list-content", skip: skip, take: this.take, total: total, itemHeight: this.viewHeight, topOffset: this.viewOffset, bottomOffset: this.bottomOffset, scrollOffsetSize: this.viewOffset, maxScrollDifference: this.viewHeight, onScroll: this.props.onScroll, onScrollAction: this.handleScrollAction, onMount: this.handleVirtualizationMount, children: dates, tabIndex: this.props.tabIndex })));
        return (React.createElement("div", { ref: function (el) { _this._element = el; }, className: rootClassNames }, this.props.dom.didCalculate ? viewListBody : null));
    };
    ViewList.propTypes = {
        activeView: propTypes.exports.number.isRequired,
        bottomOffset: propTypes.exports.number,
        cellUID: propTypes.exports.string.isRequired,
        focusedDate: propTypes.exports.instanceOf(Date).isRequired,
        max: propTypes.exports.instanceOf(Date).isRequired,
        min: propTypes.exports.instanceOf(Date).isRequired,
        onChange: propTypes.exports.func,
        showWeekNumbers: propTypes.exports.bool,
        smoothScroll: propTypes.exports.bool,
        take: propTypes.exports.number,
        value: propTypes.exports.instanceOf(Date),
        viewHeight: propTypes.exports.number,
        viewOffset: propTypes.exports.number,
        tabIndex: propTypes.exports.number
    };
    ViewList.defaultProps = {
        take: VIEWS_COUNT,
        showWeekNumbers: false,
        smoothScroll: true
    };
    return ViewList;
}(React.Component));
registerForIntl(ViewList);

var __extends$A = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$B = (undefined && undefined.__assign) || function () {
    __assign$B = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$B.apply(this, arguments);
};
var __rest$7 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * The `CalendarNavigationItem` component is internally used for rendering the items in the side navigation of the Calendar. Also used as a custom navigation item for the [Calendar]({% slug api_dateinputs_calendarprops %}#toc-navigationitem) ([see example]({% slug custom_rendering_calendar %}#toc-items-in-the-side-navigation)).
 */
var CalendarNavigationItem = /** @class */ (function (_super) {
    __extends$A(CalendarNavigationItem, _super);
    function CalendarNavigationItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var _a = _this.props, onClick = _a.onClick, value = _a.value;
            if (onClick) {
                onClick.call(undefined, value, event);
            }
        };
        return _this;
    }
    /**
     * @return
     * Returns a `<li />` element with a `<span />` inside. The text inside represents the [`value`]({% slug api_dateinputs_calendarnavigationitemprops %}#toc-value) of the `navigationItem`.
     */
    CalendarNavigationItem.prototype.render = function () {
        var _a = this.props, isRangeStart = _a.isRangeStart; _a.value; _a.text; var other = __rest$7(_a, ["isRangeStart", "value", "text"]);
        return (React.createElement("li", __assign$B({}, other, { onClick: this.handleClick }),
            React.createElement("span", { className: classNames$2({ 'k-calendar-navigation-marker': isRangeStart }) }, this.props.children)));
    };
    return CalendarNavigationItem;
}(React.Component));

var __extends$z = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$A = (undefined && undefined.__assign) || function () {
    __assign$A = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$A.apply(this, arguments);
};
var ITEMS_COUNT = 30;
/**
 * @hidden
 */
var Navigation = /** @class */ (function (_super) {
    __extends$z(Navigation, _super);
    function Navigation(props) {
        var _this = _super.call(this, props) || this;
        _this.virtualization = null;
        _this.list = null;
        _this.itemHeight = 0;
        _this.topOffset = 0;
        _this.maxViewHeight = 0;
        _this.bottomOffset = 0;
        _this.handleVirtualizationMount = function (virtualization) {
            _this.virtualization = virtualization;
            if (_this.virtualization && _this.list) {
                _this.list.style.transform = "translateY(".concat(_this.topOffset, "px)");
                var viewDate = dateInRange(_this.props.focusedDate, _this.props.min, _this.props.max);
                var indexToScroll = _this.props.service.skip(viewDate, _this.props.min);
                _this.virtualization.scrollToIndex(indexToScroll);
            }
        };
        _this.buildNavigationItem = function (date) {
            var text = _this.props.service.navigationTitle(date);
            var isRangeStart = _this.props.service.isRangeStart(date);
            var uniqueID = "kendo-react-calendar-nav-item-".concat(date.getTime());
            var navigationItemProps = {
                text: text,
                value: date,
                isRangeStart: isRangeStart,
                view: _this.props.activeView,
                onClick: _this.handleDateChange
            };
            return _this.props.navigationItem
                ? (React.createElement(_this.props.navigationItem, __assign$A({}, navigationItemProps, { key: uniqueID }), text))
                : (React.createElement(CalendarNavigationItem, __assign$A({}, navigationItemProps, { key: uniqueID }), text));
        };
        _this.calculateHeights = function () {
            var calendarHeight = _this.props.dom.calendarHeight;
            _this.itemHeight = _this.props.dom.navigationItemHeight || 1;
            _this.maxViewHeight = _this.props.dom.monthViewHeight;
            _this.topOffset = (calendarHeight - _this.itemHeight) / 2;
            _this.bottomOffset = calendarHeight - _this.itemHeight;
        };
        _this.handleDateChange = function (value, event) {
            var onChange = _this.props.onChange;
            if (onChange && event) {
                var args = {
                    value: cloneDate(value),
                    target: _this,
                    nativeEvent: event && event.nativeEvent,
                    syntheticEvent: event
                };
                onChange.call(undefined, args);
            }
        };
        _this.handleScrollAction = function (_a) {
            var scrollAction = _a.scrollAction, pageAction = _a.pageAction;
            var skip = pageAction ? pageAction.skip : _this.state.skip;
            if (_this.state.skip !== skip) {
                _this.setState({ skip: skip });
            }
            if (_this.list && scrollAction) {
                var translate = "translateY(".concat(scrollAction.offset, "px)");
                _this.list.style.transform = translate;
            }
        };
        _this.lastView = _this.props.activeView;
        _this.lastFocus = _this.props.focusedDate;
        var skip = _this.props.service.skip(_this.props.focusedDate, _this.props.min);
        var total = _this.props.service.total(_this.props.min, _this.props.max);
        _this.state = {
            skip: (skip - _this.getTake(skip, total) > 0) ? skip : 0
        };
        return _this;
    }
    Object.defineProperty(Navigation.prototype, "take", {
        get: function () {
            return this.props.take !== undefined
                ? this.props.take
                : Navigation.defaultProps.take;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    Navigation.prototype.componentDidUpdate = function (_prevProps, _prevState) {
        if (this.indexToScroll !== undefined && this.virtualization) {
            this.virtualization.scrollToIndex(this.indexToScroll);
        }
        this.lastView = this.props.activeView;
        this.lastFocus = this.props.focusedDate;
        this.indexToScroll = undefined;
    };
    Navigation.prototype.render = function () {
        var _this = this;
        this.calculateHeights();
        var didViewChange = this.lastView !== this.props.activeView;
        var focusedDate = dateInRange(this.props.focusedDate, this.props.min, this.props.max);
        var skip = !didViewChange ? this.state.skip : this.props.service.skip(focusedDate, this.props.min);
        var total = this.props.service.total(this.props.min, this.props.max);
        var take = this.getTake(skip, total);
        var viewDate = this.props.service.addToDate(this.props.min, skip);
        var dates = this.props.service.datesList(viewDate, take);
        if (this.props.activeView !== this.lastView
            || !isEqual(focusedDate, this.lastFocus)) {
            this.indexToScroll = this.props.service.skip(focusedDate, this.props.min);
        }
        var navigationBody = (React.createElement(Virtualization, { skip: skip, take: this.take, total: total, itemHeight: this.itemHeight, topOffset: this.topOffset, bottomOffset: this.bottomOffset, onScroll: this.props.onScroll, maxScrollDifference: this.maxViewHeight, onScrollAction: this.handleScrollAction, onMount: this.handleVirtualizationMount, tabIndex: this.props.tabIndex },
            React.createElement("ul", { ref: function (el) { _this.list = el; }, className: "k-reset" }, dates.map(function (date) { return (_this.buildNavigationItem(date)); }))));
        return (React.createElement("div", { className: "k-calendar-navigation" },
            React.createElement("span", { className: "k-calendar-navigation-highlight" }),
            this.props.dom.didCalculate ? navigationBody : null));
    };
    Navigation.prototype.getTake = function (skip, total) {
        return Math.min(total - skip, this.take);
    };
    Navigation.propTypes = {
        activeView: propTypes.exports.number.isRequired,
        focusedDate: propTypes.exports.instanceOf(Date).isRequired,
        max: propTypes.exports.instanceOf(Date).isRequired,
        min: propTypes.exports.instanceOf(Date).isRequired,
        onChange: propTypes.exports.func,
        take: propTypes.exports.number,
        tabIndex: propTypes.exports.number
    };
    Navigation.defaultProps = {
        take: ITEMS_COUNT
    };
    return Navigation;
}(React.Component));

var __extends$y = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var virtualizationProp = function (x) { return x ? x.virtualization : null; };
var calculateValue = function (min, max, stateValue, propValue) {
    if (min === void 0) { min = CalendarWithoutContext.defaultProps.min; }
    if (max === void 0) { max = CalendarWithoutContext.defaultProps.max; }
    return propValue !== undefined
        ? propValue !== null && isInRange$1(getDate(propValue), min, max)
            ? propValue
            : null
        : stateValue !== null && isInRange$1(getDate(stateValue), min, max)
            ? stateValue
            : null;
};
/** @hidden */
var CalendarWithoutContext = /** @class */ (function (_super) {
    __extends$y(CalendarWithoutContext, _super);
    function CalendarWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollSyncService = null;
        _this.focusedDate = null;
        _this.cellUID = guid$1();
        _this.id = guid$1();
        _this.Navigation = null;
        _this.calendarViewList = null;
        _this._element = null;
        _this.intl = null;
        _this.service = null;
        _this.isActive = false;
        _this.didNavigationChange = false;
        /**
         * @hidden
         */
        _this.focus = function () {
            if (_this._element) {
                _this._element.focus();
            }
        };
        _this.shouldScroll = function () { return _this.didNavigationChange; };
        _this.handleScroll = function (event) {
            if (!_this.scrollSyncService) {
                return;
            }
            _this.scrollSyncService.sync(virtualizationProp(_this.Navigation), virtualizationProp(_this.calendarViewList), event);
        };
        _this.handleNavigationChange = function (event) {
            if (_this.props.disabled) {
                return;
            }
            _this.didNavigationChange = true;
            var focusedDate = cloneDate(event.value);
            _this.setState({ focusedDate: focusedDate });
        };
        _this.handleViewChange = function (_a) {
            var view = _a.view;
            if (_this.scrollSyncService) {
                _this.scrollSyncService.configure(view);
            }
            _this.setState({ activeView: view });
        };
        _this.handleDateChange = function (event) {
            var value = cloneDate(event.value);
            var focusedDate = cloneDate(event.value);
            var canNavigateDown = _this.bus.canMoveDown(_this.state.activeView);
            if (_this.props.disabled) {
                return;
            }
            if (canNavigateDown) {
                if (event.isTodayClick) {
                    _this.bus.moveToBottom(_this.state.activeView);
                }
                else {
                    _this.bus.moveDown(_this.state.activeView, event.syntheticEvent);
                    _this.setState({ focusedDate: focusedDate });
                    return;
                }
            }
            _this.setState({ value: value, focusedDate: focusedDate });
            _this.valueDuringOnChange = value;
            var onChange = _this.props.onChange;
            if (onChange) {
                var args = {
                    syntheticEvent: event.syntheticEvent,
                    nativeEvent: event.nativeEvent,
                    value: value,
                    target: _this
                };
                onChange.call(undefined, args);
            }
            _this.valueDuringOnChange = undefined;
        };
        _this.handleFocus = function (event) {
            _this.isActive = true;
            if (!_this.calendarViewList) {
                return;
            }
            _this.calendarViewList.focusActiveDate();
            var onFocus = _this.props.onFocus;
            if (onFocus) {
                onFocus.call(undefined, event);
            }
        };
        _this.handleBlur = function (event) {
            _this.isActive = false;
            if (!_this.calendarViewList) {
                return;
            }
            _this.calendarViewList.blurActiveDate();
            var onBlur = _this.props.onBlur;
            if (onBlur) {
                onBlur.call(undefined, event);
            }
        };
        _this.handleKeyDown = function (event) {
            var keyCode = event.keyCode;
            if (!_this.focusedDate || !_this.service) {
                return;
            }
            if (keyCode === Keys$1.enter) {
                if (_this.value !== null
                    && isEqualDate(_this.focusedDate, _this.value)) {
                    var viewDate = dateInRange(_this.focusedDate, _this.min, _this.max);
                    virtualizationProp(_this.calendarViewList).scrollToIndex(_this.service.skip(viewDate, _this.min));
                }
                var args = {
                    syntheticEvent: event,
                    nativeEvent: event.nativeEvent,
                    value: _this.focusedDate,
                    target: _this
                };
                _this.handleDateChange(args);
            }
            else {
                var candidate = dateInRange(_this.navigation.move(_this.focusedDate, _this.navigation.action(event), _this.state.activeView, _this.service, event), _this.min, _this.max);
                if (isEqualDate(_this.focusedDate, candidate)) {
                    return;
                }
                _this.setState({ focusedDate: candidate });
            }
            event.preventDefault();
        };
        _this.handleMouseDown = function (event) {
            event.preventDefault();
        };
        _this.handleClick = function (_) {
            if (_this._element) {
                _this._element.focus({ preventScroll: true });
            }
        };
        validatePackage$2(packageMetadata$5);
        var value = calculateValue(_this.min, _this.max, _this.props.defaultValue || CalendarWithoutContext.defaultProps.defaultValue, _this.props.value);
        _this.state = {
            value: value,
            activeView: viewInRange(CalendarViewEnum[props.defaultActiveView], _this.bottomView, _this.topView),
            focusedDate: dateInRange(props.focusedDate
                || value
                || getToday(), _this.min, _this.max)
        };
        _this.dom = new DOMService();
        _this.bus = new BusViewService(_this.handleViewChange);
        _this.navigation = new NavigationService(_this.bus);
        _this.oldValue = value;
        return _this;
    }
    Object.defineProperty(CalendarWithoutContext.prototype, "element", {
        /**
         * Gets the wrapping element of the Calendar.
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarWithoutContext.prototype, "value", {
        /**
         * Gets the value of the Calendar.
         */
        get: function () {
            return this.valueDuringOnChange !== undefined
                ? this.valueDuringOnChange
                : this.props.value !== undefined
                    ? this.props.value
                    : this.state.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarWithoutContext.prototype, "min", {
        get: function () {
            return getDate(this.props.min !== undefined
                ? this.props.min
                : CalendarWithoutContext.defaultProps.min);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarWithoutContext.prototype, "max", {
        get: function () {
            return getDate(this.props.max !== undefined
                ? this.props.max
                : CalendarWithoutContext.defaultProps.max);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarWithoutContext.prototype, "bottomView", {
        get: function () {
            return CalendarViewEnum[this.props.bottomView !== undefined
                ? this.props.bottomView
                : CalendarWithoutContext.defaultProps.bottomView];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarWithoutContext.prototype, "topView", {
        get: function () {
            return CalendarViewEnum[this.props.topView !== undefined
                ? this.props.topView
                : CalendarWithoutContext.defaultProps.topView];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    CalendarWithoutContext.prototype.componentDidMount = function () {
        var _this = this;
        setScrollbarWidth();
        // Async calculation of height to avoid animation cancellation
        Promise.resolve().then(function () {
            if (!_this._element) {
                return;
            }
            _this.dom.calculateHeights(_this._element);
            _this.scrollSyncService = new ScrollSyncService(_this.dom);
            _this.scrollSyncService.configure(_this.state.activeView);
            _this.forceUpdate();
        });
    };
    /**
     * @hidden
     */
    CalendarWithoutContext.prototype.componentDidUpdate = function (_, prevState) {
        setScrollbarWidth();
        if (prevState.activeView !== this.state.activeView && this.scrollSyncService) {
            this.scrollSyncService.configure(this.state.activeView);
        }
        if (this.calendarViewList) {
            (this.isActive ? this.calendarViewList.focusActiveDate : this.calendarViewList.blurActiveDate)();
        }
        this.didNavigationChange = false;
        this.oldValue = this.value;
    };
    /**
     * @hidden
     */
    CalendarWithoutContext.prototype.render = function () {
        var _this = this;
        if (this.props._ref) {
            this.props._ref(this);
        }
        var didValueChange = this.value !== null && this.oldValue !== null
            ? !isEqualDate(this.value, this.oldValue)
            : this.value !== this.oldValue;
        var activeView = viewInRange(this.state.activeView, CalendarViewEnum[this.props.bottomView !== undefined
            ? this.props.bottomView
            : CalendarWithoutContext.defaultProps.bottomView], CalendarViewEnum[this.props.topView !== undefined
            ? this.props.topView
            : CalendarWithoutContext.defaultProps.topView]);
        var value = calculateValue(this.min, this.max, this.value, this.value);
        var sanitizedValue = value ? getDate(value) : null;
        this.focusedDate = getDate(dateInRange(didValueChange && value !== null
            ? value
            : this.state.focusedDate, this.min, this.max));
        this.intl = provideIntlService(this);
        this.bus.configure(this.bottomView, this.topView);
        this.service = this.bus.service(activeView, this.intl);
        var rootClassNames = classNames$2('k-widget k-calendar k-calendar-infinite', {
            'k-disabled': this.props.disabled,
            'k-week-number': this.props.weekNumber
        }, this.props.className);
        var calendarBody = [this.props.navigation && (React.createElement(Navigation, { key: 0, ref: function (el) { _this.Navigation = el; }, activeView: this.state.activeView, focusedDate: this.focusedDate, min: this.min, max: this.max, onScroll: this.handleScroll, onChange: this.handleNavigationChange, service: this.service, dom: this.dom, navigationItem: this.props.navigationItem, tabIndex: this.props.tabIndex })), (React.createElement(ViewList, { key: 1, ref: function (el) { _this.calendarViewList = el; }, activeView: this.state.activeView, focusedDate: this.focusedDate, min: this.min, max: this.max, bus: this.bus, shouldScroll: this.shouldScroll, onScroll: this.handleScroll, service: this.service, cell: this.props.cell, weekCell: this.props.weekCell, dom: this.dom, smoothScroll: this.props.smoothScroll, showWeekNumbers: this.props.weekNumber, onChange: this.handleDateChange, value: sanitizedValue, cellUID: this.cellUID, headerTitle: this.props.headerTitle, tabIndex: this.props.tabIndex }))];
        return (React.createElement("div", { ref: function (el) { _this._element = el; }, className: rootClassNames, id: this.props.id || this.id, "aria-labelledby": this.props.ariaLabelledBy, "aria-describedby": this.props.ariaDescribedBy, "aria-disabled": this.props.disabled, tabIndex: !this.props.disabled ? this.props.tabIndex || 0 : undefined, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseDown, onClick: this.handleClick }, calendarBody));
    };
    /**
     * @hidden
     */
    CalendarWithoutContext.displayName = 'Calendar';
    /**
     * @hidden
     */
    CalendarWithoutContext.propTypes = {
        className: propTypes.exports.string,
        defaultActiveView: propTypes.exports.oneOf(['month', 'year', 'decade', 'century']),
        defaultValue: propTypes.exports.instanceOf(Date),
        disabled: propTypes.exports.bool,
        focusedDate: propTypes.exports.instanceOf(Date),
        id: propTypes.exports.string,
        ariaLabelledBy: propTypes.exports.string,
        ariaDescribedBy: propTypes.exports.string,
        max: propTypes.exports.instanceOf(Date),
        min: propTypes.exports.instanceOf(Date),
        navigation: propTypes.exports.bool,
        smoothScroll: propTypes.exports.bool,
        onBlur: propTypes.exports.func,
        onChange: propTypes.exports.func,
        onFocus: propTypes.exports.func,
        tabIndex: propTypes.exports.number,
        value: propTypes.exports.instanceOf(Date),
        weekNumber: propTypes.exports.bool,
        topView: function (props, propName, componentName) {
            var prop = props[propName];
            var bottomView = props.bottomView;
            if (prop && bottomView && CalendarViewEnum[prop] < CalendarViewEnum[bottomView]) {
                return new Error("Invalid prop + ".concat(propName, " suplied to ").concat(componentName, ".\n                    ").concat(propName, " can not be smaller than bottomView.\n                    "));
            }
            return null;
        },
        bottomView: function (props, propName, componentName) {
            var prop = props[propName];
            var topView = props.topView;
            if (prop && topView && CalendarViewEnum[prop] > CalendarViewEnum[topView]) {
                return new Error("Invalid prop + ".concat(propName, " suplied to ").concat(componentName, ".\n                    ").concat(propName, " can not be bigger than topView.\n                    "));
            }
            return null;
        }
    };
    /**
     * @hidden
     */
    CalendarWithoutContext.defaultProps = {
        disabled: false,
        min: MIN_DATE,
        max: MAX_DATE,
        navigation: true,
        defaultActiveView: 'month',
        defaultValue: null,
        smoothScroll: true,
        topView: 'century',
        bottomView: 'month'
    };
    return CalendarWithoutContext;
}(React.Component));
/**
 * Represents the PropsContext of the `Calendar` component.
 * Used for global configuration of all `Calendar` instances.
 *
 * For more information, refer to the [DateInputs Props Context]({% slug props-context_dateinputs %}) article.
 */
var CalendarPropsContext = createPropsContext();
/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the component the same as the type */
/**
 * Represents the KendoReact Calendar Component.
 *
 * Accepts properties of type [CalendarProps]({% slug api_dateinputs_calendarprops %}).
 * Obtaining the `ref` returns an object of type [CalendarHandle]({% slug api_dateinputs_calendarhandle %}).
 */
var Calendar = withPropsContext(CalendarPropsContext, CalendarWithoutContext);
Calendar.displayName = 'KendoReactCalendar';
registerForIntl(CalendarWithoutContext);

/**
 * @hidden
 */
var Mask = /** @class */ (function () {
    function Mask() {
        this.symbols = '';
        this.partMap = [];
    }
    return Mask;
}());

/**
 * @hidden
 */
var defaultFormat = 'd';
/**
 * @hidden
 */
var defaultFormatPlaceholder = 'wide';
/**
 * @hidden
 */
var approximateStringMatching = function (oldTextOrigin, oldFormat, newTextOrigin, selectionStart) {
    /*
      Remove the right part of the cursor.
      oldFormat = oldFormat.substring(0, caret + oldText.length - newText.length);
    */
    var oldTextSeparator = oldTextOrigin[selectionStart + oldTextOrigin.length - newTextOrigin.length];
    var oldText = oldTextOrigin.substring(0, selectionStart + oldTextOrigin.length - newTextOrigin.length);
    var newText = newTextOrigin.substring(0, selectionStart);
    var diff = [];
    /* Handle the typing of a single character over the same selection. */
    if (oldText === newText && selectionStart > 0) {
        diff.push([oldFormat[selectionStart - 1], newText[selectionStart - 1]]);
        return diff;
    }
    if (oldText.indexOf(newText) === 0 &&
        (newText.length === 0 || oldFormat[newText.length - 1] !== oldFormat[newText.length])) {
        /* Handle Delete/Backspace. */
        var deletedSymbol = '';
        /*
            The whole text is replaced by the same character.
            A nasty patch is required to keep the selection in the first segment.
        */
        if (newText.length === 1) {
            diff.push([oldFormat[0], newText[0]]);
        }
        for (var i = newText.length; i < oldText.length; i++) {
            if (oldFormat[i] !== deletedSymbol && oldFormat[i] !== '_') {
                deletedSymbol = oldFormat[i];
                diff.push([deletedSymbol, '']);
            }
        }
        return diff;
    }
    /*
        Handle the insertion of the text (the new text is longer than the previous one).
        Handle the typing over a literal as well.
    */
    if (newText.indexOf(oldText) === 0 || oldFormat[selectionStart - 1] === '_') {
        var symbol = oldFormat[0];
        for (var i = Math.max(0, oldText.length - 1); i < oldFormat.length; i++) {
            if (oldFormat[i] !== '_') {
                symbol = oldFormat[i];
                break;
            }
        }
        return [[symbol, newText[selectionStart - 1]]];
    }
    /* Handle the entering of a space or a separator for navigating to the next item. */
    if (newText[newText.length - 1] === ' ' || newText[newText.length - 1] === oldTextSeparator) {
        return [[oldFormat[selectionStart - 1], '_']];
    }
    /* Handle typing over a correctly selected part. */
    return [[oldFormat[selectionStart - 1], newText[selectionStart - 1]]];
};
/**
 * @hidden
 */
var dateSymbolMap = function (map, part) { map[part.pattern[0]] = part.type; return map; };
/**
 * @hidden
 */
var isInRange = function (candidate, min, max) { return (candidate === null || !((min && min > candidate) || (max && max < candidate))); };
/** @hidden */
var wrapperClasses = ['k-widget', 'k-dateinput'];

/**
 * @hidden
 */
var KendoDate = /** @class */ (function () {
    function KendoDate(intlProvider, formatPlaceholder, format) {
        this.year = true;
        this.month = true;
        this.date = true;
        this.hours = true;
        this.minutes = true;
        this.seconds = true;
        this.milliseconds = true;
        this.leadingZero = null;
        this.typedMonthPart = '';
        this.knownParts = 'adHhmMsEy';
        this.symbols = {
            'E': 'E',
            'H': 'H',
            'M': 'M',
            'a': 'a',
            'd': 'd',
            'h': 'h',
            'm': 'm',
            's': 's',
            'y': 'y'
        };
        this._value = getDate(new Date());
        this.intlProvider = intlProvider;
        this.formatPlaceholder = formatPlaceholder;
        this.format = format;
        this.monthNames = this.allFormatedMonths();
    }
    Object.defineProperty(KendoDate.prototype, "intl", {
        get: function () {
            return this.intlProvider();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KendoDate.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    KendoDate.prototype.setValue = function (value) {
        if (!value) {
            this._value = getDate(new Date());
            this.modifyExisting(false);
        }
        else if (!isEqual(value, this._value)) {
            this._value = cloneDate(value);
            this.modifyExisting(true);
        }
    };
    KendoDate.prototype.hasValue = function () {
        var _this = this;
        var pred = function (a, p) { return a || p.type !== 'literal' && p.type !== 'dayperiod' && _this.getExisting(p.pattern[0]); };
        return this.intl.splitDateFormat(this.format).reduce(pred, false);
    };
    KendoDate.prototype.getDateObject = function () {
        for (var i = 0; i < this.knownParts.length; i++) {
            if (!this.getExisting(this.knownParts[i])) {
                return null;
            }
        }
        return cloneDate(this.value);
    };
    KendoDate.prototype.getTextAndFormat = function () {
        return this.merge(this.intl.formatDate(this.value, this.format), this.dateFormatString(this.value, this.format));
    };
    KendoDate.prototype.modifyExisting = function (value) {
        var sampleFormat = this.dateFormatString(this.value, this.format).symbols;
        for (var i = 0; i < sampleFormat.length; i++) {
            this.setExisting(sampleFormat[i], value);
        }
    };
    KendoDate.prototype.getExisting = function (symbol) {
        switch (symbol) {
            case 'y': return this.year;
            case 'M':
            case 'L': return this.month;
            case 'd': return this.date;
            case 'E': return this.date && this.month && this.year;
            case 'h':
            case 'H': return this.hours;
            case 'm': return this.minutes;
            case 's': return this.seconds;
            default: return true;
        }
    };
    KendoDate.prototype.setExisting = function (symbol, value) {
        switch (symbol) {
            case 'y':
                // allow 2/29 dates
                this.year = value;
                if (value === false) {
                    this._value.setFullYear(2000);
                }
                break;
            case 'M':
                // make sure you can type 31 in the day part
                this.month = value;
                if (value === false) {
                    this._value.setMonth(0);
                }
                break;
            case 'd':
                this.date = value;
                break;
            case 'h':
            case 'H':
                this.hours = value;
                break;
            case 'm':
                this.minutes = value;
                break;
            case 's':
                this.seconds = value;
                break;
            default: return;
        }
    };
    KendoDate.prototype.modifyPart = function (symbol, offset) {
        var newValue = cloneDate(this.value);
        switch (symbol) {
            case 'y':
                newValue.setFullYear(newValue.getFullYear() + offset);
                break;
            case 'M':
                newValue = addMonths(this.value, offset);
                break;
            case 'd':
            case 'E':
                newValue.setDate(newValue.getDate() + offset);
                break;
            case 'h':
            case 'H':
                newValue.setHours(newValue.getHours() + offset);
                break;
            case 'm':
                newValue.setMinutes(newValue.getMinutes() + offset);
                break;
            case 's':
                newValue.setSeconds(newValue.getSeconds() + offset);
                break;
            case 'a':
                newValue.setHours(newValue.getHours() + (12 * offset));
                break;
        }
        this.setExisting(symbol, true);
        this._value = newValue;
    };
    KendoDate.prototype.parsePart = function (symbol, currentChar) {
        var _a;
        this.resetLeadingZero();
        if (!currentChar) {
            this.setExisting(symbol, false);
            return { value: null };
        }
        var baseDate = this.intl.formatDate(this.value, this.format);
        var dateParts = this.dateFormatString(this.value, this.format);
        var baseFormat = dateParts.symbols;
        var replaced = false;
        var prefix = '';
        var current = '';
        var suffix = '';
        for (var i = 0; i < baseDate.length; i++) {
            if (baseFormat[i] === symbol) {
                current += this.getExisting(symbol) ? baseDate[i] : '0';
                replaced = true;
            }
            else if (!replaced) {
                prefix += baseDate[i];
            }
            else {
                suffix += baseDate[i];
            }
        }
        var parsedDate = null;
        var month = this.matchMonth(currentChar);
        while (current.length > 0 && current.charAt(0) === '0') {
            current = current.slice(1);
        }
        if (current.length >= 4) {
            current = '';
        }
        for (var i = 0; i < 2; i++) {
            var middle = current + currentChar;
            var middleNumber = parseInt(middle, 10);
            parsedDate = this.intl.parseDate(prefix + middle + suffix, this.format);
            if (!parsedDate && !isNaN(middleNumber) && !isNaN(parseInt(currentChar, 10))) {
                if (symbol === 'M' && !month) {
                    var monthNumber = middleNumber - 1;
                    if (monthNumber > -1 && monthNumber < 12) {
                        parsedDate = cloneDate(this.value);
                        parsedDate.setMonth(monthNumber);
                        if (parsedDate.getMonth() !== monthNumber) {
                            parsedDate = lastDayOfMonth(addMonths(parsedDate, -1));
                        }
                    }
                }
                if (symbol === 'y') {
                    parsedDate = createDate(parseInt(middle, 10), this.month ? this.value.getMonth() : 0, this.date ? this.value.getDate() : 1, this.hours ? this.value.getHours() : 0, this.minutes ? this.value.getMinutes() : 0, this.seconds ? this.value.getSeconds() : 0, this.milliseconds ? this.value.getMilliseconds() : 0);
                    if (this.date && parsedDate.getDate() !== this.value.getDate()) {
                        parsedDate = lastDayOfMonth(addMonths(parsedDate, -1));
                    }
                }
            }
            if (parsedDate) {
                this._value = parsedDate;
                this.setExisting(symbol, true);
                return { value: this.value };
            }
            current = '';
        }
        if (month) {
            parsedDate = this.intl.parseDate(prefix + month + suffix, this.format);
            if (parsedDate) {
                this._value = parsedDate;
                this.setExisting(symbol, true);
                return { value: this.value };
            }
        }
        if (currentChar === '0') {
            this.leadingZero = !this.isAbbrMonth(dateParts.partMap, symbol) ? (_a = {}, _a[symbol] = true, _a) : null;
            this.setExisting(symbol, false);
        }
        return { value: null };
    };
    KendoDate.prototype.symbolMap = function (symbol) {
        return this.intl.splitDateFormat(this.format).reduce(dateSymbolMap, {})[symbol];
    };
    KendoDate.prototype.resetLeadingZero = function () {
        var hasLeadingZero = this.leadingZero !== null;
        this.leadingZero = null;
        return hasLeadingZero;
    };
    KendoDate.prototype.isAbbrMonth = function (parts, symbol) {
        var pattern = this.partPattern(parts, symbol);
        return pattern.type === 'month' && pattern.names;
    };
    KendoDate.prototype.partPattern = function (parts, symbol) {
        return parts.filter(function (part) { return part.pattern.indexOf(symbol) !== -1; })[0];
    };
    KendoDate.prototype.matchMonth = function (typedChar) {
        this.typedMonthPart += typedChar.toLowerCase();
        if (this.monthNames.length === 0) {
            return '';
        }
        while (this.typedMonthPart.length > 0) {
            for (var i = 0; i < this.monthNames.length; i++) {
                if (this.monthNames[i].toLowerCase().indexOf(this.typedMonthPart) === 0) {
                    return this.monthNames[i];
                }
            }
            var monthAsNum = parseInt(this.typedMonthPart, 10);
            /* ensure they exact match */
            if (monthAsNum >= 1 && monthAsNum <= 12 && monthAsNum.toString() === this.typedMonthPart) {
                return this.monthNames[monthAsNum - 1];
            }
            this.typedMonthPart = this.typedMonthPart.substring(1, this.typedMonthPart.length);
        }
        return '';
    };
    KendoDate.prototype.allFormatedMonths = function () {
        var dateFormatParts = this.intl.splitDateFormat(this.format);
        for (var i = 0; i < dateFormatParts.length; i++) {
            if (dateFormatParts[i].type === 'month' && dateFormatParts[i].names) {
                return this.intl.dateFormatNames(dateFormatParts[i].names);
            }
        }
        return [];
    };
    KendoDate.prototype.dateFormatString = function (date, format) {
        var dateFormatParts = this.intl.splitDateFormat(format);
        var parts = [];
        var partMap = [];
        for (var i = 0; i < dateFormatParts.length; i++) {
            var partLength = this.intl.formatDate(date, { pattern: dateFormatParts[i].pattern }).length;
            while (partLength > 0) {
                parts.push(this.symbols[dateFormatParts[i].pattern[0]] || '_');
                partMap.push(dateFormatParts[i]);
                partLength--;
            }
        }
        var returnValue = new Mask();
        returnValue.symbols = parts.join('');
        returnValue.partMap = partMap;
        return returnValue;
    };
    KendoDate.prototype.merge = function (text, mask) {
        // Important: right to left.
        var resultText = '';
        var resultFormat = '';
        var format = mask.symbols;
        for (var r = format.length - 1; r >= 0; r--) {
            if (this.knownParts.indexOf(format[r]) === -1 || this.getExisting(format[r])) {
                resultText = text[r] + resultText;
                resultFormat = format[r] + resultFormat;
            }
            else {
                var currentSymbol = format[r];
                while (r >= 0 && currentSymbol === format[r]) {
                    r--;
                }
                r++;
                if (this.leadingZero && this.leadingZero[currentSymbol]) {
                    resultText = '0' + resultText;
                }
                else {
                    resultText = this.dateFieldName(mask.partMap[r]) + resultText;
                }
                while (resultFormat.length < resultText.length) {
                    resultFormat = format[r] + resultFormat;
                }
            }
        }
        return { text: resultText, format: resultFormat };
    };
    KendoDate.prototype.dateFieldName = function (part) {
        var formatPlaceholder = (this.formatPlaceholder || 'wide');
        if (formatPlaceholder[part.type]) {
            return formatPlaceholder[part.type];
        }
        if (formatPlaceholder === 'formatPattern') {
            return part.pattern;
        }
        return this.intl.dateFieldName(Object.assign(part, { nameType: formatPlaceholder }));
    };
    return KendoDate;
}());

/**
 * @hidden
 */
var TIME_PART = {
    dayperiod: 'dayperiod',
    hour: 'hour',
    millisecond: 'millisecond',
    minute: 'minute',
    second: 'second'
};

[
    { type: TIME_PART.hour, getter: function (value) { return value.getHours(); } },
    { type: TIME_PART.minute, getter: function (value) { return value.getMinutes(); } },
    { type: TIME_PART.second, getter: function (value) { return value.getSeconds(); } },
    { type: TIME_PART.millisecond, getter: function (value) { return value.getMilliseconds(); } }
];
var normalizeTimes = function (candidate, min, max) { return ({
    candidateValue: setTime(MIDNIGHT_DATE, candidate),
    maxValue: addDays(setTime(MIDNIGHT_DATE, max), min.getHours() < max.getHours() ? 0 : 1),
    minValue: setTime(MIDNIGHT_DATE, min)
}); };
/**
 * @hidden
 */
var isInTimeRange = function (candidate, min, max) {
    if (!candidate || !min || !max) {
        return true;
    }
    var _a = normalizeTimes(candidate, min, max), candidateValue = _a.candidateValue, minValue = _a.minValue, maxValue = _a.maxValue;
    return minValue <= candidateValue && candidateValue <= maxValue;
};

var __extends$x = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$z = (undefined && undefined.__assign) || function () {
    __assign$z = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$z.apply(this, arguments);
};
var __spreadArray$7 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var VALIDATION_MESSAGE$1 = 'Please enter a valid value!';
// tslint:enable:max-line-length
/** @hidden */
var DateInputWithoutContext = /** @class */ (function (_super) {
    __extends$x(DateInputWithoutContext, _super);
    function DateInputWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        _this.kendoDate = null;
        _this.currentFormat = '';
        _this.paste = false;
        _this._element = null;
        _this._wrapper = null;
        _this._inputId = guid$1();
        _this._lastSelectedSymbol = '';
        /**
         * @hidden
         */
        _this.focus = function () {
            if (_this._element) {
                _this._element.focus();
            }
        };
        /**
         * @hidden
         */
        _this.setValidity = function () {
            if (_this.element && _this.element.setCustomValidity) {
                _this.element.setCustomValidity(_this.validity.valid
                    ? ''
                    : _this.props.validationMessage || DateInputWithoutContext.defaultProps.validationMessage);
            }
        };
        _this.updateOnPaste = function (event) {
            if (!_this.element || !_this.kendoDate) {
                return;
            }
            var value = provideIntlService(_this).parseDate(_this.element.value, _this.props.format) || _this.value;
            var oldValue = _this.value;
            _this.kendoDate.setValue(value);
            _this.triggerChange(event, oldValue);
        };
        /* Handlers */
        _this.spinnersMouseDown = function (event) {
            /* do not steal focus from input when changing value with spinners */
            event.preventDefault();
            /* manually focus the input in case the user clicks the spinners first */
            if (_this.element && document.activeElement !== _this.element) {
                _this.element.focus({ preventScroll: true });
            }
        };
        _this.handlePaste = function () {
            _this.paste = true;
        };
        _this.elementChange = function (event) {
            if (!_this.element || !_this.kendoDate) {
                return;
            }
            if (_this.paste) {
                _this.updateOnPaste(event);
                _this.paste = false;
                return;
            }
            var _a = _this.kendoDate.getTextAndFormat(), text = _a.text, currentFormat = _a.format;
            _this.currentFormat = currentFormat;
            var dateBeforeChange = _this.value;
            var diff = approximateStringMatching(text, _this.currentFormat, _this.element.value, _this.selection.start);
            var navigationOnly = (diff.length === 1 && diff[0][1] === '_');
            if (!navigationOnly) {
                for (var i = 0; i < diff.length; i++) {
                    _this.kendoDate.parsePart(diff[i][0], diff[i][1]);
                }
            }
            if (diff.length && diff[0][0] !== '_') {
                _this.setSelection(_this.selectionBySymbol(diff[0][0]));
            }
            if (navigationOnly) {
                _this.switchDateSegment(1);
            }
            _this.triggerChange(event, dateBeforeChange);
        };
        _this.elementClick = function (_) {
            _this.setSelection(_this.selectionByIndex(_this.selection.start));
        };
        _this.nativeWheel = function (event) {
            if (document.activeElement === _this.element) {
                event.preventDefault();
            }
        };
        _this.wheel = function (event) {
            if (document.activeElement !== _this.element) {
                return;
            }
            if (event.nativeEvent.deltaY < 0) {
                _this.increasePart(event);
            }
            if (event.nativeEvent.deltaY > 0) {
                _this.decreasePart(event);
            }
        };
        _this.increasePart = function (event) {
            _this.modifyDateSegmentValue(1, event);
        };
        _this.decreasePart = function (event) {
            _this.modifyDateSegmentValue(-1, event);
        };
        _this.elementKeyDown = function (event) {
            if (event.altKey) {
                return;
            }
            switch (event.keyCode) {
                case 37:
                    /*
                        * Key: `Left Arrow`
                        * Action: Switches to previous logical* segment.
                        * (*) https://www.w3.org/International/articles/inline-bidi-markup/uba-basics
                        */
                    _this.switchDateSegment(-1);
                    break;
                case (38):
                    /*
                        * Key: `Up Arrow`
                        * Action: Increases the currently selected segment value.
                        */
                    _this.modifyDateSegmentValue(1, event);
                    break;
                case 39:
                    /*
                        * Key: `Right Arrow`
                        * Action: Switches to the next logical segment.
                        */
                    _this.switchDateSegment(1);
                    break;
                case 40:
                    /*
                        * Key: `Down Arrow`
                        * Action: Decreases the currently selected segment value.
                        */
                    _this.modifyDateSegmentValue(-1, event);
                    break;
                default:
                    /*
                        * Key: any
                        * Action: Does not prevent the default behavior.
                        */
                    return;
            }
            event.preventDefault();
        };
        _this.elementOnFocus = function (_) {
            if (_this.wrapper) {
                _this.wrapper.classList.add('k-focus');
            }
            _this.setState({ focused: true });
        };
        _this.elementOnBlur = function (_) {
            if (_this.wrapper) {
                _this.wrapper.classList.remove('k-focus');
            }
            _this.setState({ focused: false });
        };
        validatePackage$2(packageMetadata$5);
        _this.state = {
            focused: false
        };
        return _this;
    }
    /**
     * @hidden
     */
    DateInputWithoutContext.prototype.componentDidMount = function () {
        this.setValidity();
        if (this.wrapper) {
            this.wrapper.addEventListener('wheel', this.nativeWheel, { passive: false });
        }
    };
    /**
     * @hidden
     */
    DateInputWithoutContext.prototype.componentDidUpdate = function (_, prevState) {
        if (this._lastSelectedSymbol && prevState.focused === this.state.focused) {
            this.setSelection(this.selectionBySymbol(this._lastSelectedSymbol));
        }
        else if (this.props.placeholder !== undefined && this.selection.start === this.selection.end) {
            this.setSelection({ start: 0, end: this.currentFormat.length });
        }
        this.setValidity();
    };
    /**
     * @hidden
     */
    DateInputWithoutContext.prototype.componentWillUnmount = function () {
        if (this.wrapper) {
            this.wrapper.removeEventListener('wheel', this.nativeWheel);
        }
    };
    /**
     * @hidden
     */
    DateInputWithoutContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.size, size = _b === void 0 ? DateInputWithoutContext.defaultProps.size : _b, _c = _a.fillMode, fillMode = _c === void 0 ? DateInputWithoutContext.defaultProps.fillMode : _c, _d = _a.rounded, rounded = _d === void 0 ? DateInputWithoutContext.defaultProps.rounded : _d;
        if (this.props._ref) {
            this.props._ref.current = this;
        }
        var localizationService = provideLocalizationService(this);
        var props = __assign$z(__assign$z({}, DateInputWithoutContext.defaultProps), this.props);
        var name = props.name, label = props.label, id = props.id;
        var currentText = this.text;
        var text = currentText === this.props.placeholder ? '' : currentText;
        var placeholder = currentText === this.props.placeholder ? currentText : undefined;
        var inputId = id || this._inputId;
        var isValid = !this.validityStyles || this.validity.valid;
        var wrapperClassesInstance = __spreadArray$7([], wrapperClasses, true);
        if (this.props.className) {
            wrapperClassesInstance.push(this.props.className);
        }
        var dateinput = (React.createElement(AsyncFocusBlur, { onFocus: this.elementOnFocus, onBlur: this.elementOnBlur }, function (_a) {
            var _b;
            var onFocus = _a.onFocus, onBlur = _a.onBlur;
            return (React.createElement("span", { ref: function (span) { _this._wrapper = span; }, style: !label
                    ? { width: _this.props.width }
                    : undefined, dir: _this.props.dir, className: classNames$2('k-dateinput', 'k-input', (_b = {},
                    _b["k-input-".concat(kendoThemeMaps$1.sizeMap[size] || size)] = size,
                    _b["k-input-".concat(fillMode)] = fillMode,
                    _b["k-rounded-".concat(kendoThemeMaps$1.roundedMap[rounded] || rounded)] = rounded,
                    _b['k-invalid'] = !isValid,
                    _b['k-required'] = _this.required,
                    _b['k-disabled'] = _this.props.disabled,
                    _b), _this.props.className), onFocus: onFocus, onBlur: onBlur },
                React.createElement("input", { role: _this.props.ariaRole || 'textbox', tabIndex: _this.props.tabIndex, disabled: _this.props.disabled, title: _this.props.title !== undefined ? _this.props.title : currentText, type: "text", spellCheck: false, autoComplete: "off", autoCorrect: "off", className: "k-input-inner", id: inputId, "aria-label": _this.props.ariaLabel, "aria-labelledby": _this.props.ariaLabelledBy, "aria-describedby": _this.props.ariaDescribedBy, "aria-haspopup": _this.props.ariaHasPopup, "aria-disabled": _this.props.disabled, "aria-expanded": _this.props.ariaExpanded, "aria-controls": _this.props.ariaControls, onWheel: _this.wheel, onClick: _this.elementClick, onInput: _this.elementChange, onPaste: _this.handlePaste, onKeyDown: _this.elementKeyDown, onChange: noop$2, value: text, placeholder: placeholder, name: name, ref: function (input) { return _this._element = input; } }),
                _this.props.children,
                _this.props.spinners && (React.createElement("span", { className: "k-input-spinner k-spin-button", onMouseDown: _this.spinnersMouseDown },
                    React.createElement(Button$2, { tabIndex: -1, type: "button", rounded: null, className: "k-spinner-increase", icon: 'caret-alt-up', "aria-label": localizationService.toLanguageString(increaseValue$1, messages$2[increaseValue$1]), title: localizationService.toLanguageString(increaseValue$1, messages$2[increaseValue$1]), onClick: _this.increasePart }),
                    React.createElement(Button$2, { tabIndex: -1, type: "button", rounded: null, className: "k-spinner-decrease", icon: 'caret-alt-down', "aria-label": localizationService.toLanguageString(decreaseValue$1, messages$2[decreaseValue$1]), title: localizationService.toLanguageString(decreaseValue$1, messages$2[decreaseValue$1]), onClick: _this.decreasePart })))));
        }));
        return label
            ? (React.createElement(FloatingLabel, { label: label, editorId: inputId, editorValue: currentText, editorValid: isValid, editorDisabled: this.props.disabled, children: dateinput, style: { width: this.props.width } }))
            : dateinput;
    };
    Object.defineProperty(DateInputWithoutContext.prototype, "value", {
        /* Public Getters */
        /**
         * Gets the value of the DateInput.
         */
        get: function () {
            if (this.valueDuringOnChange !== undefined) {
                return this.valueDuringOnChange;
            }
            return this.kendoDate && this.kendoDate.getDateObject();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "name", {
        /**
         * Gets the `name` property of the DateInput.
         */
        get: function () {
            return this.props.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "min", {
        get: function () {
            return this.props.min !== undefined
                ? this.props.min
                : DateInputWithoutContext.defaultProps.min;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "max", {
        get: function () {
            return this.props.max !== undefined
                ? this.props.max
                : DateInputWithoutContext.defaultProps.max;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "text", {
        /**
         * @hidden
         */
        get: function () {
            var props = __assign$z(__assign$z({}, DateInput.defaultProps), this.props);
            var _a = props.formatPlaceholder, formatPlaceholder = _a === void 0 ? DateInputWithoutContext.defaultProps.formatPlaceholder : _a, _b = props.format, format = _b === void 0 ? DateInputWithoutContext.defaultProps.format : _b, value = props.value, defaultValue = props.defaultValue;
            if (this.kendoDate === null) {
                this.kendoDate = new KendoDate(this.intl.bind(this), formatPlaceholder, format);
                this.kendoDate.setValue(value || defaultValue || null);
            }
            else {
                this.kendoDate.format = format;
                this.kendoDate.formatPlaceholder = formatPlaceholder;
            }
            if (value !== undefined && this.value !== value) {
                this.kendoDate.setValue(value);
            }
            var _c = this.kendoDate.getTextAndFormat(), currentText = _c.text, currentFormat = _c.format;
            this.currentFormat = currentFormat;
            return props.placeholder !== null && props.placeholder !== undefined
                && !this.state.focused
                && !this.kendoDate.hasValue()
                ? props.placeholder
                : currentText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "validity", {
        /**
         * Represents the validity state into which the DateInput is set.
         */
        get: function () {
            var inRange = isInRange(this.value, this.min, this.max)
                && isInTimeRange(this.value, this.props.minTime, this.props.maxTime);
            var customError = this.props.validationMessage !== undefined;
            var isValid = (!this.required || this.value !== null) && inRange;
            var valid = this.props.valid !== undefined ? this.props.valid : isValid;
            return {
                customError: customError,
                rangeOverflow: (this.value && this.max.getTime() < this.value.getTime()) || false,
                rangeUnderflow: (this.value && this.value.getTime() < this.min.getTime()) || false,
                valid: valid,
                valueMissing: this.value === null
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "element", {
        /**
         * Gets the element of the DateInput.
         *
         * @return - An `HTMLInputElement`.
         *
         * @example
         * ```jsx
         * class App extends React.Component {
         *     constructor(props) {
         *         super(props);
         *     }
         *     element = null;
         *     render() {
         *         return (
         *             <div>
         *                 <DateInput
         *                     ref={(dateInput) =>
         *                         this.element = dateInput ? dateInput.element : null}
         *                 />
         *                 <button onClick={() => console.log(this.element)}>console.log the element</button>
         *             </div>
         *         );
         *     }
         * }
         *
         * ReactDOM.render(
         *     <App />,
         *     document.getElementsByTagName('my-app')[0]
         * );
         * ```
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "validityStyles", {
        /**
         * @hidden
         */
        get: function () {
            return this.props.validityStyles !== undefined
                ? this.props.validityStyles
                : DateInputWithoutContext.defaultProps.validityStyles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "required", {
        /**
         * @hidden
         */
        get: function () {
            return this.props.required !== undefined
                ? this.props.required
                : DateInputWithoutContext.defaultProps.required;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DateInputWithoutContext.prototype, "wrapper", {
        /**
         * @hidden
         */
        get: function () {
            return this._wrapper;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    DateInputWithoutContext.prototype.intl = function () {
        return provideIntlService(this);
    };
    Object.defineProperty(DateInputWithoutContext.prototype, "selection", {
        /*  end handlers */
        get: function () {
            var returnValue = { start: 0, end: 0 };
            if (this.element !== null && this.element.selectionStart !== undefined) {
                returnValue = { start: this.element.selectionStart, end: this.element.selectionEnd };
            }
            return returnValue;
        },
        enumerable: false,
        configurable: true
    });
    DateInputWithoutContext.prototype.setSelection = function (selection) {
        var _this = this;
        this._lastSelectedSymbol = this.currentFormat[selection.start];
        window.requestAnimationFrame(function () {
            if (_this.element && document.activeElement === _this.element) {
                _this.element.setSelectionRange(selection.start, selection.end);
            }
        });
    };
    DateInputWithoutContext.prototype.triggerChange = function (event, oldValue) {
        this.valueDuringOnChange = this.value;
        this.forceUpdate();
        if (this.props.onChange
            && !isEqual(oldValue, this.value)) {
            // isEqual works with null
            this.props.onChange.call(undefined, {
                syntheticEvent: event,
                nativeEvent: event.nativeEvent,
                value: this.value,
                target: this
                // inRange: this.props.min && this.props.max ? isInRange(value, this.props.min, this.props.max) : true
            });
        }
        this.valueDuringOnChange = undefined;
    };
    DateInputWithoutContext.prototype.selectionBySymbol = function (symbol) {
        var start = -1;
        var end = 0;
        for (var i = 0; i < this.currentFormat.length; i++) {
            if (this.currentFormat[i] === symbol) {
                end = i + 1;
                if (start === -1) {
                    start = i;
                }
            }
        }
        if (start < 0) {
            start = 0;
        }
        return { start: start, end: end };
    };
    DateInputWithoutContext.prototype.selectionByIndex = function (index) {
        // console.log(42, index);
        var selection = { start: index, end: index };
        for (var i = index, j = index - 1; i < this.currentFormat.length || j >= 0; i++, j--) {
            if (i < this.currentFormat.length && this.currentFormat[i] !== '_') {
                selection = this.selectionBySymbol(this.currentFormat[i]);
                break;
            }
            if (j >= 0 && this.currentFormat[j] !== '_') {
                selection = this.selectionBySymbol(this.currentFormat[j]);
                break;
            }
        }
        return selection;
    };
    DateInputWithoutContext.prototype.switchDateSegment = function (offset) {
        var _a = this.selection, selectionStart = _a.start, selectionEnd = _a.end;
        if (selectionStart < selectionEnd &&
            this.currentFormat[selectionStart] !== this.currentFormat[selectionEnd - 1]) {
            this.setSelection(this.selectionByIndex(offset > 0 ? selectionStart : selectionEnd - 1));
            return;
        }
        var previousFormatSymbol = this.currentFormat[selectionStart];
        var a = selectionStart + offset;
        while (a > 0 && a < this.currentFormat.length) {
            if (this.currentFormat[a] !== previousFormatSymbol &&
                this.currentFormat[a] !== '_') {
                break;
            }
            a += offset;
        }
        if (this.currentFormat[a] === '_') {
            // no known symbol is found
            return;
        }
        var b = a;
        while (b >= 0 && b < this.currentFormat.length) {
            if (this.currentFormat[b] !== this.currentFormat[a]) {
                break;
            }
            b += offset;
        }
        if (a > b && (b + 1 !== selectionStart || a + 1 !== selectionEnd)) {
            this.setSelection({ start: b + 1, end: a + 1 });
        }
        else if (a < b && (a !== selectionStart || b !== selectionEnd)) {
            this.setSelection({ start: a, end: b });
        }
    };
    DateInputWithoutContext.prototype.modifyDateSegmentValue = function (offset, event) {
        if (!this.kendoDate) {
            return;
        }
        var oldValue = this.value;
        var symbol = this.currentFormat[this.selection.start];
        var currentStepSymbol = this.kendoDate.symbolMap(symbol);
        var step = ((this.props.steps || {})[currentStepSymbol] || 1) * offset;
        this.kendoDate.modifyPart(symbol, step);
        this.triggerChange(event, oldValue);
    };
    /**
     * @hidden
     */
    DateInputWithoutContext.displayName = 'DateInput';
    /**
     * @hidden
     */
    DateInputWithoutContext.propTypes = {
        value: propTypes.exports.instanceOf(Date),
        format: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.shape({
                skeleton: propTypes.exports.string,
                pattern: propTypes.exports.string,
                date: propTypes.exports.oneOf(['short', 'medium', 'long', 'full']),
                time: propTypes.exports.oneOf(['short', 'medium', 'long', 'full']),
                datetime: propTypes.exports.oneOf(['short', 'medium', 'long', 'full']),
                era: propTypes.exports.oneOf(['narrow', 'short', 'long']),
                year: propTypes.exports.oneOf(['numeric', '2-digit']),
                month: propTypes.exports.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
                day: propTypes.exports.oneOf(['numeric', '2-digit']),
                weekday: propTypes.exports.oneOf(['narrow', 'short', 'long']),
                hour: propTypes.exports.oneOf(['numeric', '2-digit']),
                hour12: propTypes.exports.bool,
                minute: propTypes.exports.oneOf(['numeric', '2-digit']),
                second: propTypes.exports.oneOf(['numeric', '2-digit']),
                timeZoneName: propTypes.exports.oneOf(['short', 'long'])
            })
        ]),
        formatPlaceholder: propTypes.exports.oneOfType([
            propTypes.exports.oneOf(['wide', 'narrow', 'short', 'formatPattern']),
            propTypes.exports.shape({
                year: propTypes.exports.string,
                month: propTypes.exports.string,
                day: propTypes.exports.string,
                hour: propTypes.exports.string,
                minute: propTypes.exports.string,
                second: propTypes.exports.string
            })
        ]),
        width: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.number
        ]),
        tabIndex: propTypes.exports.number,
        title: propTypes.exports.string,
        steps: propTypes.exports.shape({
            year: propTypes.exports.number,
            month: propTypes.exports.number,
            day: propTypes.exports.number,
            hour: propTypes.exports.number,
            minute: propTypes.exports.number,
            second: propTypes.exports.number
        }),
        min: propTypes.exports.instanceOf(Date),
        max: propTypes.exports.instanceOf(Date),
        disabled: propTypes.exports.bool,
        spinners: propTypes.exports.bool,
        name: propTypes.exports.string,
        dir: propTypes.exports.string,
        label: propTypes.exports.string,
        id: propTypes.exports.string,
        ariaLabelledBy: propTypes.exports.string,
        ariaDescribedBy: propTypes.exports.string,
        ariaLabel: propTypes.exports.string,
        ariaRole: propTypes.exports.string,
        ariaExpanded: propTypes.exports.oneOfType([
            propTypes.exports.bool
        ]),
        onChange: propTypes.exports.func,
        validationMessage: propTypes.exports.string,
        required: propTypes.exports.bool,
        validate: propTypes.exports.bool,
        valid: propTypes.exports.bool,
        size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
        rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
        fillMode: propTypes.exports.oneOf([null, 'solid', 'flat', 'outline'])
    };
    /**
     * @hidden
     */
    DateInputWithoutContext.defaultProps = {
        format: defaultFormat,
        size: 'medium',
        rounded: 'medium',
        fillMode: 'solid',
        formatPlaceholder: defaultFormatPlaceholder,
        // defaultValue: null as Date | null,
        spinners: false,
        disabled: false,
        max: cloneDate(MAX_DATE$1),
        min: cloneDate(MIN_DATE$1),
        minTime: cloneDate(MIN_TIME),
        maxTime: cloneDate(MAX_TIME),
        required: false,
        validityStyles: true,
        validationMessage: VALIDATION_MESSAGE$1,
        placeholder: null
        // the rest of the properties are undefined by default
    };
    return DateInputWithoutContext;
}(React.Component));
/**
 * Represents the PropsContext of the `DateInput` component.
 * Used for global configuration of all `DateInput` instances.
 *
 * For more information, refer to the [DateInputs Props Context]({% slug props-context_dateinputs %}) article.
 */
var DateInputPropsContext = createPropsContext();
/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the component the same as the type */
/**
 * Represents the KendoReact DateInput Component.
 *
 * Accepts properties of type [DateInputProps]({% slug api_dateinputs_dateinputprops %}).
 * Obtaining the `ref` returns an object of type [DateInputHandle]({% slug api_dateinputs_dateinputhandle %}).
 */
var DateInput = withPropsContext(DateInputPropsContext, DateInputWithoutContext);
DateInput.displayName = 'KendoReactDateInput';
registerForIntl(DateInputWithoutContext);
registerForLocalization(DateInputWithoutContext);

/**
 * Represents the default `toggleButton` component rendered by the [KendoReact Scheduler DatePicker]({% slug overview_datepicker %}).
 */
var ToggleButton = Button$2;

/**
 * @hidden
 * @deprecated
 */
var PickerWrap = React.forwardRef(function (props, ref) {
    var _ref = props._ref;
    var element = React.useRef(null);
    React.useImperativeHandle(ref, function () { return element.current; });
    React.useImperativeHandle(_ref, function () { return element.current; });
    var className = React.useMemo(function () { return classNames$2(props.className, 'k-picker-wrap'); }, [props.className]);
    return (React.createElement("span", { ref: element, id: props.id, style: props.style, className: className, tabIndex: props.tabIndex }, props.children));
});

var __assign$y = (undefined && undefined.__assign) || function () {
    __assign$y = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$y.apply(this, arguments);
};
/**
 * @hidden
 */
var usePickerFloatingLabel = function (dateInput) {
    var _a = React.useState(false), show = _a[0], setShow = _a[1];
    var syncText = function () {
        if (dateInput.current) {
            setShow(Boolean(dateInput.current.text));
        }
    };
    React.useEffect(syncText);
    return {
        editorValue: show
    };
};
/**
 * @hidden
 */
var PickerFloatingLabel = function (props) {
    var floatingLabelProps = usePickerFloatingLabel(props.dateInput);
    return (React.createElement(FloatingLabel, __assign$y({}, props, floatingLabelProps)));
};

var __extends$w = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$x = (undefined && undefined.__assign) || function () {
    __assign$x = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$x.apply(this, arguments);
};
var __rest$6 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @hidden */
var DatePickerWithoutContext = /** @class */ (function (_super) {
    __extends$w(DatePickerWithoutContext, _super);
    function DatePickerWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        _this._popupId = guid$1();
        _this._element = null;
        _this._dateInput = React.createRef();
        _this._calendar = null;
        _this.shouldFocusDateInput = false;
        _this.prevShow = false;
        /**
         * @hidden
         */
        _this.focus = function () {
            if (_this.dateInput) {
                _this.dateInput.focus();
            }
        };
        _this.setCalendarRef = function (calendar) {
            _this._calendar = calendar;
        };
        _this.nextValue = function (nextProps, nextState) {
            return nextProps.value !== undefined
                ? nextProps.value
                : nextState.value;
        };
        _this.nextShow = function (nextProps, nextState) {
            return nextProps.show !== undefined
                ? nextProps.show
                : nextState.show;
        };
        _this.handleInputValueChange = function (event) {
            _this.handleValueChange(event.value, event);
        };
        _this.handleCalendarValueChange = function (event) {
            var value = _this.mergeTime(event.value);
            _this.handleValueChange(value, event);
        };
        _this.handleValueChange = function (value, event) {
            _this.setState({
                value: cloneDate(value || undefined),
                show: false
            });
            _this.valueDuringOnChange = value;
            _this.showDuringOnChange = false;
            _this.shouldFocusDateInput = true;
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange.call(undefined, {
                    syntheticEvent: event.syntheticEvent,
                    nativeEvent: event.nativeEvent,
                    value: _this.value,
                    show: _this.show,
                    target: _this
                });
            }
            _this.valueDuringOnChange = undefined;
            _this.showDuringOnChange = undefined;
        };
        _this.handleFocus = function () {
            _this.setState({ focused: true });
        };
        _this.handleBlur = function () {
            _this.setState({ focused: false });
            _this.setShow(false);
        };
        _this.handleIconClick = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.shouldFocusDateInput = true;
            _this.setShow(!_this.show);
        };
        _this.handleIconMouseDown = function (event) {
            event.preventDefault();
        };
        _this.handleKeyDown = function (event) {
            var altKey = event.altKey, keyCode = event.keyCode;
            if (keyCode === Keys$1.esc) {
                _this.shouldFocusDateInput = true;
                _this.setShow(false);
                return;
            }
            if (altKey && (keyCode === Keys$1.up || keyCode === Keys$1.down)) {
                event.preventDefault();
                event.stopPropagation();
                _this.shouldFocusDateInput = keyCode === Keys$1.up;
                _this.setShow(keyCode === Keys$1.down);
            }
        };
        validatePackage$2(packageMetadata$5);
        _this.state = {
            value: _this.props.defaultValue || DatePickerWithoutContext.defaultProps.defaultValue,
            show: _this.props.defaultShow || DatePickerWithoutContext.defaultProps.defaultShow,
            focused: false
        };
        return _this;
    }
    Object.defineProperty(DatePickerWithoutContext.prototype, "element", {
        /**
         * Gets the wrapping element of the DatePickerWithoutContext.
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "dateInput", {
        /**
         * Gets the DateInput component inside the DatePicker component.
         */
        get: function () {
            return this._dateInput.current;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "calendar", {
        /**
         * Gets the Calendar component inside the DatePicker component.
         */
        get: function () {
            return this._calendar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "value", {
        /**
         * Gets the value of the DatePickerWithoutContext.
         */
        get: function () {
            var value = this.valueDuringOnChange !== undefined
                ? this.valueDuringOnChange
                : this.props.value !== undefined
                    ? this.props.value
                    : this.state.value;
            return (value !== null) ? cloneDate(value) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "show", {
        /**
         * Gets the popup state of the DatePickerWithoutContext.
         */
        get: function () {
            return this.showDuringOnChange !== undefined
                ? this.showDuringOnChange
                : this.props.show !== undefined
                    ? this.props.show
                    : this.state.show;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "name", {
        /**
         * Gets the `name` property of the DatePickerWithoutContext.
         */
        get: function () {
            return this.props.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "min", {
        get: function () {
            return this.props.min !== undefined
                ? this.props.min
                : DatePickerWithoutContext.defaultProps.min;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "max", {
        get: function () {
            return this.props.max !== undefined
                ? this.props.max
                : DatePickerWithoutContext.defaultProps.max;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "dateInputComp", {
        get: function () {
            return this.props.dateInput || DatePickerWithoutContext.defaultProps.dateInput;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "toggleButtonComp", {
        get: function () {
            return this.props.toggleButton || DatePickerWithoutContext.defaultProps.toggleButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "calendarComp", {
        get: function () {
            return this.props.calendar || DatePickerWithoutContext.defaultProps.calendar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "popupComp", {
        get: function () {
            return this.props.popup || DatePickerWithoutContext.defaultProps.popup;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "pickerWrapComp", {
        get: function () {
            return this.props.pickerWrap || DatePickerWithoutContext.defaultProps.pickerWrap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "validity", {
        /**
         * Represents the validity state into which the DatePicker is set.
         */
        get: function () {
            var inRange = isInDateRange(this.value, this.min, this.max);
            var customError = this.props.validationMessage !== undefined;
            var isValid = (!this.required || this.value !== null) && inRange;
            var valid = this.props.valid !== undefined ? this.props.valid : isValid;
            return {
                customError: customError,
                rangeOverflow: (this.value && this.max.getTime() < this.value.getTime()) || false,
                rangeUnderflow: (this.value && this.value.getTime() < this.min.getTime()) || false,
                valid: valid,
                valueMissing: this.value === null
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "validityStyles", {
        /**
         * @hidden
         */
        get: function () {
            return this.props.validityStyles !== undefined
                ? this.props.validityStyles
                : DatePickerWithoutContext.defaultProps.validityStyles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePickerWithoutContext.prototype, "required", {
        /**
         * @hidden
         */
        get: function () {
            return this.props.required !== undefined
                ? this.props.required
                : DatePickerWithoutContext.defaultProps.required;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    DatePickerWithoutContext.prototype.componentDidMount = function () {
        if (this.show) {
            // If defaultShow is true during the initial render, the popup is not aligned.
            this.forceUpdate();
        }
    };
    /**
     * @hidden
     */
    DatePickerWithoutContext.prototype.componentDidUpdate = function () {
        if (this._calendar && this._calendar.element && this.show && !this.prevShow) {
            this._calendar.element.focus({ preventScroll: true });
        }
        if (this.dateInput
            && this.dateInput.element
            && !this.show
            && this.shouldFocusDateInput) {
            this.dateInput.element.focus({ preventScroll: true });
        }
        this.prevShow = this.show;
        this.shouldFocusDateInput = false;
    };
    /**
     * @hidden
     */
    DatePickerWithoutContext.prototype.componentWillUnmount = function () {
        clearTimeout(this.nextTickId);
    };
    /**
     * @hidden
     */
    DatePickerWithoutContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.size, size = _b === void 0 ? DatePickerWithoutContext.defaultProps.size : _b, _c = _a.rounded, rounded = _c === void 0 ? DatePickerWithoutContext.defaultProps.rounded : _c, _d = _a.fillMode, fillMode = _d === void 0 ? DatePickerWithoutContext.defaultProps.fillMode : _d, disabled = _a.disabled, tabIndex = _a.tabIndex, title = _a.title, id = _a.id, format = _a.format, formatPlaceholder = _a.formatPlaceholder, min = _a.min, max = _a.max, weekNumber = _a.weekNumber, focusedDate = _a.focusedDate, className = _a.className, width = _a.width, name = _a.name, validationMessage = _a.validationMessage, required = _a.required, validityStyles = _a.validityStyles, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, ariaLabel = _a.ariaLabel;
        var _e = this.props.popupSettings, popupClass = _e.popupClass, otherPopupSettings = __rest$6(_e, ["popupClass"]);
        var show = this.show;
        var value = this.value;
        var sanitizedValue = value && getDate(value);
        var isValid = !this.validityStyles || this.validity.valid;
        var popupClassNames = classNames$2('k-calendar-container k-group k-reset', popupClass);
        var dateInputProps = {
            disabled: disabled,
            format: format,
            formatPlaceholder: formatPlaceholder,
            id: id,
            ariaLabelledBy: ariaLabelledBy,
            ariaDescribedBy: ariaDescribedBy,
            ariaLabel: ariaLabel,
            max: max,
            min: min,
            name: name,
            onChange: this.handleInputValueChange,
            required: required,
            tabIndex: !show ? tabIndex : -1,
            title: title,
            valid: this.validity.valid,
            validationMessage: validationMessage,
            validityStyles: validityStyles,
            value: value,
            label: undefined,
            placeholder: !this.state.focused ? this.props.placeholder : null,
            ariaExpanded: this.show,
            size: null,
            fillMode: null,
            rounded: null
        };
        var popupProps = __assign$x({ show: show, anchor: this._element, className: popupClassNames, id: this._popupId, anchorAlign: {
                horizontal: 'left',
                vertical: 'bottom'
            }, popupAlign: {
                horizontal: 'left',
                vertical: 'top'
            } }, otherPopupSettings);
        var calendarProps = {
            disabled: disabled,
            value: sanitizedValue,
            min: min,
            max: max,
            weekNumber: weekNumber,
            focusedDate: focusedDate,
            onChange: this.handleCalendarValueChange
        };
        var toggleButtonTitle = provideLocalizationService(this)
            .toLanguageString(toggleCalendar, messages$2[toggleCalendar]);
        var datepicker = (React.createElement(AsyncFocusBlur, { onFocus: this.handleFocus, onBlur: this.handleBlur, onSyncBlur: this.props.onBlur, onSyncFocus: this.props.onFocus }, function (_a) {
            var _b;
            var onFocus = _a.onFocus, onBlur = _a.onBlur;
            return (React.createElement("span", { ref: function (span) { _this._element = span; }, className: classNames$2('k-input', 'k-datepicker', (_b = {},
                    _b["k-input-".concat(kendoThemeMaps$1.sizeMap[size] || size)] = size,
                    _b["k-rounded-".concat(kendoThemeMaps$1.roundedMap[rounded] || rounded)] = rounded,
                    _b["k-input-".concat(fillMode)] = fillMode,
                    _b['k-invalid'] = !isValid,
                    _b['k-required'] = _this.required,
                    _b['k-disabled'] = _this.props.disabled,
                    _b), className), onKeyDown: _this.handleKeyDown, style: { width: width }, onFocus: onFocus, onBlur: onBlur },
                React.createElement(_this.dateInputComp, __assign$x({ _ref: _this._dateInput, ariaRole: 'combobox', ariaExpanded: _this.show, ariaHasPopup: true, ariaControls: _this._popupId }, dateInputProps)),
                React.createElement(_this.toggleButtonComp, { type: "button", icon: "calendar", title: toggleButtonTitle, className: "k-input-button", rounded: null, onClick: _this.handleIconClick, "aria-label": toggleButtonTitle, onMouseDown: _this.handleIconMouseDown }),
                React.createElement(_this.popupComp, __assign$x({}, popupProps),
                    React.createElement(_this.calendarComp, __assign$x({ _ref: _this.setCalendarRef }, calendarProps)))));
        }));
        return this.props.label
            ? (React.createElement(PickerFloatingLabel, { dateInput: this._dateInput, label: this.props.label, editorId: id, editorValid: isValid, editorDisabled: this.props.disabled, children: datepicker, style: { width: this.props.width } }))
            : datepicker;
    };
    DatePickerWithoutContext.prototype.setShow = function (show) {
        if (this.show === show) {
            return;
        }
        this.setState({ show: show });
    };
    DatePickerWithoutContext.prototype.mergeTime = function (value) {
        return this.value && value ? setTime(value, this.value) : value;
    };
    DatePickerWithoutContext.prototype.nextTick = function (f) {
        // XXX: use window.setTimeout due to async focus/blur events in IE, and missing relatedTarget prop.
        // XXX: https://github.com/facebook/react/issues/3751
        // Handles multiple focus events happening at the same time.
        clearTimeout(this.nextTickId);
        this.nextTickId = window.setTimeout(function () { return f(); });
    };
    /**
     * @hidden
     */
    DatePickerWithoutContext.displayName = 'DatePicker';
    /**
     * @hidden
     */
    DatePickerWithoutContext.propTypes = {
        className: propTypes.exports.string,
        defaultShow: propTypes.exports.bool,
        defaultValue: propTypes.exports.instanceOf(Date),
        disabled: propTypes.exports.bool,
        focusedDate: propTypes.exports.instanceOf(Date),
        format: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.shape({
                skeleton: propTypes.exports.string,
                pattern: propTypes.exports.string,
                date: propTypes.exports.oneOf(['short', 'medium', 'long', 'full']),
                time: propTypes.exports.oneOf(['short', 'medium', 'long', 'full']),
                datetime: propTypes.exports.oneOf(['short', 'medium', 'long', 'full']),
                era: propTypes.exports.oneOf(['narrow', 'short', 'long']),
                year: propTypes.exports.oneOf(['numeric', '2-digit']),
                month: propTypes.exports.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
                day: propTypes.exports.oneOf(['numeric', '2-digit']),
                weekday: propTypes.exports.oneOf(['narrow', 'short', 'long']),
                hour: propTypes.exports.oneOf(['numeric', '2-digit']),
                hour12: propTypes.exports.bool,
                minute: propTypes.exports.oneOf(['numeric', '2-digit']),
                second: propTypes.exports.oneOf(['numeric', '2-digit']),
                timeZoneName: propTypes.exports.oneOf(['short', 'long'])
            })
        ]),
        formatPlaceholder: propTypes.exports.oneOfType([
            propTypes.exports.oneOf(['wide', 'narrow', 'short', 'formatPattern']),
            propTypes.exports.shape({
                year: propTypes.exports.string,
                month: propTypes.exports.string,
                day: propTypes.exports.string,
                hour: propTypes.exports.string,
                minute: propTypes.exports.string,
                second: propTypes.exports.string
            })
        ]),
        id: propTypes.exports.string,
        ariaLabelledBy: propTypes.exports.string,
        ariaDescribedBy: propTypes.exports.string,
        ariaLabel: propTypes.exports.string,
        min: propTypes.exports.instanceOf(Date),
        max: propTypes.exports.instanceOf(Date),
        name: propTypes.exports.string,
        popupSettings: propTypes.exports.shape({
            animate: propTypes.exports.bool,
            appendTo: propTypes.exports.any,
            popupClass: propTypes.exports.string
        }),
        show: propTypes.exports.bool,
        tabIndex: propTypes.exports.number,
        title: propTypes.exports.string,
        value: propTypes.exports.instanceOf(Date),
        weekNumber: propTypes.exports.bool,
        width: propTypes.exports.oneOfType([propTypes.exports.number, propTypes.exports.string]),
        validationMessage: propTypes.exports.string,
        required: propTypes.exports.bool,
        validate: propTypes.exports.bool,
        valid: propTypes.exports.bool,
        size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
        rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
        fillMode: propTypes.exports.oneOf([null, 'solid', 'flat', 'outline'])
    };
    /**
     * @hidden
     */
    DatePickerWithoutContext.defaultProps = {
        defaultShow: false,
        defaultValue: null,
        dateInput: DateInput,
        calendar: Calendar,
        toggleButton: ToggleButton,
        popup: Popup$1,
        pickerWrap: PickerWrap,
        disabled: false,
        format: 'd',
        max: MAX_DATE$1,
        min: MIN_DATE$1,
        popupSettings: {},
        tabIndex: 0,
        weekNumber: false,
        required: false,
        validityStyles: true,
        size: 'medium',
        rounded: 'medium',
        fillMode: 'solid'
    };
    return DatePickerWithoutContext;
}(React.Component));
/**
 * Represents the PropsContext of the `DatePicker` component.
 * Used for global configuration of all `DatePicker` instances.
 *
 * For more information, refer to the [DateInputs Props Context]({% slug props-context_dateinputs %}) article.
 */
var DatePickerPropsContext = createPropsContext();
/* eslint-disable @typescript-eslint/no-redeclare */
/**
 * Represents the KendoReact DatePicker Component.
 *
 * Accepts properties of type [DatePickerProps]({% slug api_dateinputs_datepickerprops %}).
 * Obtaining the `ref` returns an object of type [DatePickerHandle]({% slug api_dateinputs_datepickerhandle %}).
 */
var DatePicker = withPropsContext(DatePickerPropsContext, DatePickerWithoutContext);
DatePicker.displayName = 'KendoReactDatePicker';
registerForLocalization(DatePickerWithoutContext);

/**
 * @hidden
 */
var packageMetadata$4 = {
    name: '@progress/kendo-react-inputs',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666770840,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$v = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$w = (undefined && undefined.__assign) || function () {
    __assign$w = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$w.apply(this, arguments);
};
var __rest$5 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @hidden */
var InputWithoutContext = /** @class */ (function (_super) {
    __extends$v(InputWithoutContext, _super);
    function InputWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        _this._input = null;
        _this._inputId = guid$1();
        /**
         * @hidden
         */
        _this.focus = function () {
            if (_this._input) {
                _this._input.focus();
            }
        };
        _this.isInvalid = function (state) {
            var result = false;
            for (var prop in state) {
                if (state.hasOwnProperty(prop)) {
                    result = result || Boolean(state[prop]);
                }
            }
            return result;
        };
        /**
         * @hidden
         */
        _this.setValidity = function () {
            if (_this._input && _this._input.setCustomValidity) {
                _this.validity.valid || !_this.validityStyles
                    ? _this._input.classList.remove('k-invalid')
                    : _this._input.classList.add('k-invalid');
                _this._input.setCustomValidity(_this.validity.valid
                    ? ''
                    : _this.props.validationMessage || '');
            }
        };
        _this.handleChange = function (event) {
            _this.setState({
                value: event.target.value
            });
            _this.valueDuringOnChange = event.target.value;
            if (_this.props.onChange) {
                _this.props.onChange.call(undefined, {
                    syntheticEvent: event,
                    nativeEvent: event.nativeEvent,
                    value: event.target.value,
                    target: _this
                });
            }
            _this.valueDuringOnChange = undefined;
        };
        /**
         * @hidden
         */
        _this.handleAutoFill = function (e) {
            if (e.animationName === 'autoFillStart') {
                var parent_1 = e.target.parentNode;
                if (parent_1 && parent_1.classList.contains('k-empty')) {
                    parent_1.classList.remove('k-empty');
                }
            }
        };
        validatePackage$2(packageMetadata$4);
        _this.state = {
            value: _this.props.defaultValue || InputWithoutContext.defaultProps.defaultValue
        };
        return _this;
    }
    Object.defineProperty(InputWithoutContext.prototype, "element", {
        /**
         * Gets the native input element of the Input component.
         */
        get: function () {
            return this._input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputWithoutContext.prototype, "value", {
        /**
         * Gets the value of the Input.
         */
        get: function () {
            return this.valueDuringOnChange !== undefined
                ? this.valueDuringOnChange
                : this.props.value !== undefined
                    ? this.props.value
                    : this.state.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputWithoutContext.prototype, "name", {
        /**
         * Gets the `name` property of the Input.
         */
        get: function () {
            return this.props.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputWithoutContext.prototype, "validity", {
        /**
         * Represents the validity state into which the Input is set.
         */
        get: function () {
            var result = {
                badInput: this._input ? this._input.validity.badInput : false,
                patternMismatch: this._input
                    ? this._input.validity.patternMismatch
                    : false,
                rangeOverflow: this._input ? this._input.validity.rangeOverflow : false,
                rangeUnderflow: this._input ? this._input.validity.rangeUnderflow : false,
                stepMismatch: this._input ? this._input.validity.stepMismatch : false,
                tooLong: this._input ? this._input.validity.tooLong : false,
                typeMismatch: this._input ? this._input.validity.typeMismatch : false,
                valueMissing: this._input ? this._input.validity.valueMissing : false
            };
            return __assign$w(__assign$w({}, result), { customError: this.props.validationMessage !== undefined, valid: this.props.valid !== undefined
                    ? this.props.valid
                    : this._input
                        ? !this.isInvalid(result)
                        : true });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputWithoutContext.prototype, "validityStyles", {
        /**
         * @hidden
         */
        get: function () {
            return this.props.validityStyles !== undefined
                ? this.props.validityStyles
                : InputWithoutContext.defaultProps.validityStyles;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    InputWithoutContext.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    /**
     * @hidden
     */
    InputWithoutContext.prototype.componentDidUpdate = function () {
        this.setValidity();
    };
    /**
     * @hidden
     */
    InputWithoutContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, label = _a.label, id = _a.id; _a.validationMessage; _a.defaultValue; _a.valid; 
        // Removed to support direct use in Form Field component
        _a.visited; _a.touched; _a.modified; var ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy; _a.validityStyles; var style = _a.style, ariaLabel = _a.ariaLabel, props = __rest$5(_a, ["className", "label", "id", "validationMessage", "defaultValue", "valid", "visited", "touched", "modified", "ariaLabelledBy", "ariaDescribedBy", "validityStyles", "style", "ariaLabel"]);
        var inputId = id || this._inputId;
        var isValid = !this.validityStyles || this.validity.valid;
        var inputClassName = classNames$2(className, 'k-input k-input-md k-rounded-md k-input-solid');
        var textbox = (React.createElement("input", __assign$w({ "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "aria-disabled": this.props.disabled || undefined, "aria-invalid": !isValid || undefined, "aria-label": ariaLabel || undefined }, props, { style: !label
                ? style
                : undefined, value: this.value, id: inputId, className: inputClassName, onChange: this.handleChange, onAnimationStart: this.handleAutoFill, ref: function (el) {
                _this._input = el;
            } })));
        return label ?
            (React.createElement(FloatingLabel, { label: label, editorId: inputId, editorValue: String(this.value), editorValid: isValid, editorDisabled: props.disabled, editorPlaceholder: props.placeholder, children: textbox, style: style, dir: props.dir }))
            : textbox;
    };
    InputWithoutContext.displayName = 'Input';
    /**
     * @hidden
     */
    InputWithoutContext.propTypes = {
        label: propTypes.exports.string,
        validationMessage: propTypes.exports.string,
        required: propTypes.exports.bool,
        validate: propTypes.exports.bool,
        id: propTypes.exports.string,
        ariaLabelledBy: propTypes.exports.string,
        ariaDescribedBy: propTypes.exports.string,
        ariaLabel: propTypes.exports.string
    };
    /**
     * @hidden
     */
    InputWithoutContext.defaultProps = {
        defaultValue: '',
        required: false,
        validityStyles: true
    };
    return InputWithoutContext;
}(React.Component));
/**
 * Represents the PropsContext of the `Input` component.
 * Used for global configuration of all `Input` instances.
 *
 * For more information, refer to the [Inputs Props Context]({% slug props-context_inputs %}) article.
 */
var InputPropsContext = createPropsContext();
/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the component the same as the type */
/**
 * Represents the [KendoReact Input component]({% slug overview_textbox %}).
 *
 * Accepts properties of type [InputProps]({% slug api_inputs_inputprops %}).
 * Obtaining the `ref` returns an object of type [InputHandle]({% slug api_inputs_inputhandle %}).
 */
var Input = withPropsContext(InputPropsContext, InputWithoutContext);
Input.displayName = 'KendoReactInput';

var _a$2;
/**
 * @hidden
 */
var numericIncreaseValue = 'numerictextbox.increment';
/**
 * @hidden
 */
var numericDecreaseValue = 'numerictextbox.decrement';
/**
 * @hidden
 */
var sliderIncreaseValue = 'slider.increment';
/**
 * @hidden
 */
var sliderDecreaseValue = 'slider.decrement';
/**
 * @hidden
 */
var sliderDragTitle = 'slider.dragTitle';
/**
 * @hidden
 */
var colorGradientR = 'colorGradient.r';
/**
 * @hidden
 */
var colorGradientG = 'colorGradient.g';
/**
 * @hidden
 */
var colorGradientB = 'colorGradient.b';
/**
 * @hidden
 */
var colorGradientA = 'colorGradient.a';
/**
 * @hidden
 */
var colorGradientHex = 'colorGradient.hex';
/**
 * @hidden
 */
var colorGradientContrastRatio = 'colorGradient.contrastRatio';
/**
 * @hidden
 */
var colorGradientAALevel = 'colorGradient.colorGradientAALevel';
/**
 * @hidden
 */
var colorGradientAAALevel = 'colorGradient.colorGradientAAALevel';
/**
 * @hidden
 */
var colorGradientPass = 'colorGradient.colorGradientPass';
/**
 * @hidden
 */
var colorGradientFail = 'colorGradient.colorGradientFail';
/**
 * @hidden
 */
var colorGradientHueSliderLabel = 'colorGradient.hueSliderLabel';
/**
 * @hidden
 */
var colorGradientAlphaSliderLabel = 'colorGradient.alphaSliderLabel';
/**
 * @hidden
 */
var colorGradientToggleInputsButton = 'colorGradient.toggleInputsButton';
/**
 * @hidden
 */
var flatColorPickerCancelBtn = 'flatColorPicker.cancelBtn';
/**
 * @hidden
 */
var flatColorPickerApplyBtn = 'flatColorPicker.applyBtn';
/**
 * @hidden
 */
var checkboxValidation = 'checkbox.validation';
/**
 * @hidden
 */
var checkboxOptionalText = 'checkbox.optionalText';
/**
 * @hidden
 */
var radioButtonValidation = 'radioButton.validation';
/**
 * @hidden
 */
var switchValidation = 'switch.validation';
/**
 * @hidden
 */
var colorPickerDropdownButtonAriaLabel = 'colorPicker.dropdownButtonAriaLabel';
/**
 * @hidden
 */
var ratingAriaLabel = 'rating.ariaLabel';
/**
 * @hidden
 */
var signatureClear = 'signature.clear';
/**
 * @hidden
 */
var signatureMaximize = 'signature.maximize';
/**
 * @hidden
 */
var signatureMinimize = 'signature.minimize';
/**
 * @hidden
 */
var messages$1 = (_a$2 = {},
    _a$2[numericIncreaseValue] = 'Increase value',
    _a$2[numericDecreaseValue] = 'Decrease value',
    _a$2[sliderIncreaseValue] = 'Increase',
    _a$2[sliderDecreaseValue] = 'Decrease',
    _a$2[sliderDragTitle] = 'Drag',
    _a$2[colorGradientR] = 'r',
    _a$2[colorGradientG] = 'g',
    _a$2[colorGradientB] = 'b',
    _a$2[colorGradientA] = 'a',
    _a$2[colorGradientHex] = 'hex',
    _a$2[colorGradientContrastRatio] = 'Contrast ratio',
    _a$2[colorGradientAALevel] = 'AA',
    _a$2[colorGradientAAALevel] = 'AAA',
    _a$2[colorGradientPass] = 'Pass',
    _a$2[colorGradientFail] = 'Fail',
    _a$2[colorGradientHueSliderLabel] = 'Hue slider',
    _a$2[colorGradientAlphaSliderLabel] = 'Alpha slider',
    _a$2[colorGradientToggleInputsButton] = 'Toggle colorgradient inputs',
    _a$2[flatColorPickerCancelBtn] = 'Cancel',
    _a$2[flatColorPickerApplyBtn] = 'Apply',
    _a$2[checkboxValidation] = 'Please check this box if you want to proceed!',
    _a$2[checkboxOptionalText] = '(Optional)',
    _a$2[radioButtonValidation] = 'Please select option if you want to proceed!',
    _a$2[switchValidation] = 'Please turn on if you want to proceed!',
    _a$2[colorPickerDropdownButtonAriaLabel] = 'Select',
    _a$2[ratingAriaLabel] = 'Rating',
    _a$2[signatureClear] = 'Clear',
    _a$2[signatureMaximize] = 'Maximize',
    _a$2[signatureMinimize] = 'Minimize',
    _a$2);

var __assign$v = (undefined && undefined.__assign) || function () {
    __assign$v = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$v.apply(this, arguments);
};
var DEFAULT_NUMBER = 1111111.1111111;
var MAX_DECIMAL = 0.31111111111111117;
var MIN_DECIMAL = 1;
var ONE_NUMBER = 1;
var ZERO_NUMBER = 0;
var DIGITS_REGEX = /\d/;
var MAX_PRECISION = 15;
/**
 * @hidden
 */
var getInitialState = function () { return ({
    eventValue: null,
    prevLooseValue: '',
    currentLooseValue: '',
    focused: false,
    selectionStart: undefined,
    selectionEnd: undefined,
    decimalSelect: false,
    valueIsCorrected: false,
    valueIsOutOfRange: false
}); };
/**
 * @hidden
 */
var getStateOrPropsValue = function (value, stateValue) {
    return value !== undefined ? value : stateValue;
};
/**
 * @hidden
 */
var formatValue = function (value, format, intlService) {
    if (value === null && value === undefined) {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    return intlService.formatNumber(value, format);
};
/**
 * @hidden
 */
var fractionLength = function (value) {
    return (String(value).split('.')[1] || '').length;
};
/**
 * @hidden
 */
var maxFractionLength = function (value1, value2) {
    return Math.max(fractionLength(value1), fractionLength(value2));
};
/**
 * @hidden
 */
var limitPrecision = function (precision) { return Math.min(precision, MAX_PRECISION); };
/**
 * @hidden
 */
var toFixedPrecision = function (value, precision) {
    var maxPrecision = limitPrecision(precision);
    return parseFloat(value.toFixed(maxPrecision));
};
/**
 * @hidden
 */
var increaseValue = function (value, newState, step, min, max, format, intlService) {
    var maxPrecision = maxFractionLength(value || 0, step || 0);
    var increasedValue = rangeValue(toFixedPrecision((value || 0) + (step || 0), maxPrecision), min, max);
    newState.eventValue = increasedValue;
    newState.currentLooseValue = formatValue(increasedValue, format, intlService);
    newState.selectionStart = newState.selectionEnd = getLastNumberIndex(newState.currentLooseValue, DIGITS_REGEX);
};
/**
 * @hidden
 */
var decreaseValue = function (value, newState, step, min, max, format, intlService) {
    var maxPrecision = maxFractionLength(value || 0, step || 0);
    var decreasedValue = rangeValue(toFixedPrecision((value || 0) - (step || 0), maxPrecision), min, max);
    newState.eventValue = decreasedValue;
    newState.currentLooseValue = formatValue(decreasedValue, format, intlService);
    newState.selectionStart = newState.selectionEnd = getLastNumberIndex(newState.currentLooseValue, DIGITS_REGEX);
};
/**
 * @hidden
 */
var rangeValue = function (value, min, max) {
    if (value == null) {
        return value;
    }
    if (!(value > 1 || value < 1 || value === 1)) {
        // null, undefined or NaN
        return null;
    }
    if (max !== undefined && min !== undefined && max < min) {
        return null;
    }
    if (max !== undefined && value > max) {
        value = max;
    }
    if (min !== undefined && value < min) {
        value = min;
    }
    return value;
};
/**
 * @hidden
 */
var getMaxCursorPosition = function (nextValue, formatInfo) {
    var formatSuffixIndex = formatInfo.findIndex(function (_a) {
        _a[0]; var currSuffix = _a[1];
        return Boolean(currSuffix) && nextValue.indexOf(currSuffix) === nextValue.length - currSuffix.length;
    });
    if (formatSuffixIndex === -1) {
        return -1;
    }
    var suffix = formatInfo[formatSuffixIndex][1];
    return nextValue.length - suffix.length;
};
/**
 * @hidden
 */
var getMinCursorPosition = function (nextValue, formatInfo) {
    var formatPrefixIndex = formatInfo.findIndex(function (_a) {
        var currPrefix = _a[0]; _a[1];
        return Boolean(currPrefix) && nextValue.indexOf(currPrefix) === 0;
    });
    if (formatPrefixIndex === -1) {
        return -1;
    }
    var prefix = formatInfo[formatPrefixIndex][0];
    return prefix.length;
};
/**
 * @hidden
 */
var rangeSelection = function (nextLooseValue, formatInfo, newState) {
    var maxPosition = getMaxCursorPosition(nextLooseValue, formatInfo);
    if (maxPosition !== -1 && newState.selectionStart > maxPosition) {
        newState.selectionStart = newState.selectionEnd = maxPosition;
        return;
    }
    if (newState.selectionStart > nextLooseValue.length) {
        newState.selectionStart = newState.selectionEnd = nextLooseValue.length;
    }
    var minPosition = getMinCursorPosition(nextLooseValue, formatInfo);
    if (minPosition !== -1 && newState.selectionStart < minPosition) {
        newState.selectionStart = newState.selectionEnd = minPosition;
    }
    if (newState.selectionStart === -1) {
        newState.selectionStart = newState.selectionEnd = 0;
    }
};
/**
 * @hidden
 */
var setSelection = function (newState, newIndex, nextLooseValue, formatInfo) {
    newState.selectionStart = newState.selectionEnd = newIndex;
    rangeSelection(nextLooseValue, formatInfo, newState);
};
/**
 * @hidden
 */
var setInvalid = function (newState, format, formatInfo, intlService) {
    newState.eventValue = intlService.parseNumber(newState.prevLooseValue, format);
    newState.currentLooseValue = newState.prevLooseValue;
    newState.valueIsCorrected = true;
    setSelection(newState, newState.selectionStart, newState.currentLooseValue, formatInfo);
};
/**
 * @hidden
 */
var isMinusSymbolAdded = function (newState, symbols) {
    var newText = String(newState.currentLooseValue);
    var oldText = String(newState.prevLooseValue);
    return (newText.split(symbols.minusSign).length !== oldText.split(symbols.minusSign).length &&
        newText.length === oldText.length + symbols.minusSign.length);
};
/**
 * @hidden
 */
var isMinusSymbolRemoved = function (newState, symbols) {
    var newText = String(newState.currentLooseValue);
    var oldText = String(newState.prevLooseValue);
    return (newText.indexOf(symbols.minusSign) === -1 && oldText.indexOf(symbols.minusSign) !== -1);
};
/**
 * @hidden
 */
var isDecimalDuplicated = function (newState, symbols) {
    var newText = String(newState.currentLooseValue);
    return newText.split(symbols.decimal).length > 2;
};
/**
 * @hidden
 */
var getFormatPrefixSufix = function (format, intlService) {
    var positiveResult = intlService.formatNumber(DEFAULT_NUMBER, format);
    var negativeResult = intlService.formatNumber(-DEFAULT_NUMBER, format);
    var zeroResult = intlService.formatNumber(ZERO_NUMBER, format);
    var oneResult = intlService.formatNumber(ONE_NUMBER, format);
    var positivePrefix = getPrefix(positiveResult);
    var negativePrefix = getPrefix(negativeResult);
    var zeroPrefix = getPrefix(zeroResult);
    var onePrefix = getPrefix(oneResult);
    var positiveSuffix = getSuffix(positiveResult);
    var negativeSuffix = getSuffix(negativeResult);
    var zeroSuffix = getSuffix(zeroResult);
    var oneSuffix = getSuffix(oneResult);
    return {
        positiveInfo: [positivePrefix, positiveSuffix],
        negativeInfo: [negativePrefix, negativeSuffix],
        zeroInfo: [zeroPrefix, zeroSuffix],
        oneInfo: [onePrefix, oneSuffix]
    };
};
/**
 * @hidden
 */
var getFormatSymbols = function (format, intlService) {
    var positiveResult = intlService.formatNumber(DEFAULT_NUMBER, format);
    var negativeResult = intlService.formatNumber(-DEFAULT_NUMBER, format);
    var zeroResult = intlService.formatNumber(ZERO_NUMBER, format);
    var oneResult = intlService.formatNumber(ONE_NUMBER, format);
    var symbols = intlService.numberSymbols();
    var sanitizeRegex = new RegExp("[\\d\\".concat(symbols.decimal).concat(symbols.group, "]"), 'g');
    var resultWithDuplicates = [positiveResult, negativeResult, zeroResult, oneResult]
        .map(function (result) { return result.replace(sanitizeRegex, ''); })
        .join('');
    return resultWithDuplicates
        .split('')
        .filter(function (x, n, s) { return s.indexOf(x) === n; })
        .join('');
};
/**
 * @hidden
 */
var getInitialPosition = function (nextLooseValue, symbols) {
    var decimalIdex = nextLooseValue.indexOf(symbols.decimal);
    if (decimalIdex > -1) {
        return decimalIdex;
    }
    return getLastNumberIndex(nextLooseValue, DIGITS_REGEX);
};
/**
 * @hidden
 */
var reverseString = function (str) {
    return str.split('').reverse().join('');
};
/**
 * @hidden
 */
var getLastNumberIndex = function (currentLooseValue, inputRegex) {
    return currentLooseValue.length - reverseString(currentLooseValue).search(inputRegex);
};
/**
 * @hidden
 */
var getPrefix = function (str) {
    return str.split(str[str.search(DIGITS_REGEX)])[0];
};
/**
 * @hidden
 */
var getSuffix = function (str) {
    var reversedString = reverseString(str);
    return reverseString(reversedString.split(reversedString[reversedString.search(DIGITS_REGEX)])[0]);
};
/**
 * @hidden
 */
var getFirstNumberIndex = function (prevLooseValue, inputRegex) {
    return prevLooseValue.search(inputRegex);
};
/**
 * @hidden
 */
var getDecimalCount = function (value, decimal) {
    var currentDecimalPlace = value.indexOf(decimal);
    return currentDecimalPlace > -1 ? value.length - currentDecimalPlace - 1 : 0;
};
/**
 * @hidden
 */
var changeBasedSelection = function (currentValue, nextValue, selectionPosition, isDelete, sanitizeRegex) {
    var isCurrentLeadingZero = currentValue.replace(sanitizeRegex, '')[0] === '0';
    var isNextLeadingZero = nextValue.replace(sanitizeRegex, '')[0] === '0';
    if (isCurrentLeadingZero && !isNextLeadingZero) {
        return selectionPosition - 1;
    }
    if (isNextLeadingZero && isDelete) {
        return selectionPosition + 1;
    }
    var numberCounter = 0;
    for (var idx = 0; idx < selectionPosition; idx++) {
        if (DIGITS_REGEX.test(currentValue.charAt(idx))) {
            numberCounter++;
        }
    }
    var newSelection = 0;
    while (numberCounter > 0 && nextValue.length > newSelection) {
        if (DIGITS_REGEX.test(nextValue.charAt(newSelection))) {
            numberCounter--;
        }
        newSelection++;
    }
    return newSelection;
};
/**
 * @hidden
 */
var sanitizeNumber = function (state, format, intlService) {
    var newState = __assign$v({}, state);
    var prevLooseValue = newState.prevLooseValue;
    var symbols = intlService.numberSymbols();
    var restrictedSymbols = getFormatSymbols(format, intlService);
    var currentLooseValueAsString = String(newState.currentLooseValue);
    var prevLooseValueAsString = String(prevLooseValue);
    var sanitizeRegex = new RegExp("[^\\d\\".concat(symbols.decimal, "]"), 'g');
    var sanitizeGroupRegex = new RegExp("[^\\d\\".concat(symbols.decimal, "\\").concat(symbols.group, "]"), 'g');
    var allSymbolsRegex = new RegExp("[\\d\\".concat(symbols.decimal, "\\").concat(symbols.group, "]"));
    var sanitizedString = currentLooseValueAsString.replace(sanitizeRegex, '');
    var numberStart = getFirstNumberIndex(currentLooseValueAsString, DIGITS_REGEX);
    var numberEnd = numberStart === -1 ? -1 : getLastNumberIndex(currentLooseValueAsString, DIGITS_REGEX);
    var decimalIndex = currentLooseValueAsString.indexOf(symbols.decimal);
    var sanitizedFormattedString = (currentLooseValueAsString.substring(0, numberStart) +
        currentLooseValueAsString.substring(numberStart, numberEnd).replace(sanitizeGroupRegex, '') +
        currentLooseValueAsString.substring(numberEnd, currentLooseValueAsString.length))
        .split('')
        .filter(function (s) { return restrictedSymbols.indexOf(s) !== -1 || s.search(allSymbolsRegex) !== -1; })
        .join('');
    var formattedMax = intlService.formatNumber(MAX_DECIMAL, format).replace(sanitizeRegex, '');
    var maxDecimalIndex = formattedMax.indexOf(symbols.decimal);
    var maxDecimalCount = maxDecimalIndex > -1 ? formattedMax.length - maxDecimalIndex - 1 : 0;
    var formattedMin = intlService.formatNumber(MIN_DECIMAL, format).replace(sanitizeRegex, '');
    var minDecimalIndex = formattedMin.indexOf(symbols.decimal);
    var minDecimalCount = minDecimalIndex > -1 ? formattedMin.length - minDecimalIndex - 1 : 0;
    var _a = getFormatPrefixSufix(format, intlService), positiveInfo = _a.positiveInfo, negativeInfo = _a.negativeInfo, zeroInfo = _a.zeroInfo, oneInfo = _a.oneInfo;
    var formatInfo = [positiveInfo, negativeInfo, zeroInfo, oneInfo];
    var isFormatContainPrefixSuffix = formatInfo.findIndex(function (info) { return info.findIndex(function (nestedInfo) { return Boolean(nestedInfo); }) !== -1; }) !== 1;
    var isDelete = currentLooseValueAsString.length > 0 && currentLooseValueAsString.length < prevLooseValueAsString.length;
    var isPercentFormat = typeof format === 'string' &&
        format[0] === 'p' &&
        currentLooseValueAsString &&
        currentLooseValueAsString.indexOf(symbols.percentSign) === -1;
    if (!newState.isPaste) {
        // 1. Empty input
        if (currentLooseValueAsString === '') {
            newState.eventValue = null;
            newState.currentLooseValue = '';
            return newState;
        }
        // 2. Check is minus sign
        if (newState.currentLooseValue === symbols.minusSign && intlService.formatNumber(-0, format) !== prevLooseValueAsString) {
            newState.eventValue = -0;
            newState.currentLooseValue = formatValue(newState.eventValue, format, intlService);
            setSelection(newState, getInitialPosition(newState.currentLooseValue, symbols), newState.currentLooseValue, formatInfo);
            return newState;
        }
        // 3. Minus sign toggle
        if (isMinusSymbolAdded(newState, symbols)) {
            var nextValue = intlService.parseNumber(prevLooseValue, format);
            newState.eventValue = -(nextValue !== null ? nextValue : 0);
            newState.currentLooseValue = formatValue(newState.eventValue, format, intlService);
            var currentNumberStart = getFirstNumberIndex(newState.currentLooseValue, DIGITS_REGEX);
            var oldNumberStart = getFirstNumberIndex(prevLooseValueAsString, DIGITS_REGEX);
            setSelection(newState, newState.selectionEnd - 1 + (currentNumberStart - oldNumberStart), newState.currentLooseValue, formatInfo);
            return newState;
        }
        if (isMinusSymbolRemoved(newState, symbols)) {
            newState.eventValue = intlService.parseNumber(newState.currentLooseValue, format);
            setSelection(newState, newState.selectionStart, newState.currentLooseValue, formatInfo);
            return newState;
        }
        // 4. Check is decimal symbol
        if (newState.currentLooseValue === symbols.decimal) {
            newState.eventValue = 0;
            var valueCandidate = formatValue(newState.eventValue, format, intlService);
            if (minDecimalCount === 0 && maxDecimalCount > 0) {
                var currentLastNumberIndex = getLastNumberIndex(valueCandidate, DIGITS_REGEX);
                newState.currentLooseValue = valueCandidate.substring(0, currentLastNumberIndex) +
                    symbols.decimal +
                    valueCandidate.substring(currentLastNumberIndex);
            }
            else {
                newState.currentLooseValue = valueCandidate;
            }
            setSelection(newState, getInitialPosition(newState.currentLooseValue, symbols) + 1, newState.currentLooseValue, formatInfo);
            return newState;
        }
        // 5. Duplicate decimal - it's possible only as trailing
        if (isDecimalDuplicated(newState, symbols)) {
            setInvalid(newState, format, formatInfo, intlService);
            return newState;
        }
        // 6. Percent format
        if (isPercentFormat) {
            newState.eventValue = intlService.parseNumber(currentLooseValueAsString, format) / 100;
            newState.currentLooseValue = formatValue(newState.eventValue, format, intlService);
            return newState;
        }
        // 7. More than 15 numeric symbols
        var numericSymbols = String(newState.currentLooseValue).replace(/[^\d]/g, '');
        if (numericSymbols.length > MAX_PRECISION) {
            setInvalid(newState, format, formatInfo, intlService);
            return newState;
        }
        // 8. Check prefix / suffix for modifications
        if (sanitizedString !== currentLooseValueAsString &&
            currentLooseValueAsString &&
            isFormatContainPrefixSuffix) {
            var formatInfoIndex = formatInfo.findIndex(function (_a) {
                var prefix = _a[0], suffix = _a[1];
                var prefixIndex = currentLooseValueAsString.indexOf(prefix);
                var suffixIndex = currentLooseValueAsString.indexOf(suffix);
                var prefixFound = prefixIndex === 0;
                var suffixFound = suffixIndex === currentLooseValueAsString.length - suffix.length;
                var prefixGap = prefixIndex + prefix.length !== numberStart &&
                    numberStart !== -1 &&
                    currentLooseValueAsString[prefixIndex + prefix.length] !== symbols.decimal;
                var suffixGap = suffixIndex !== numberEnd &&
                    numberEnd !== -1 &&
                    currentLooseValueAsString[suffixIndex - 1] !== symbols.decimal;
                if (prefix && suffix) {
                    if (prefixGap || suffixGap) {
                        return false;
                    }
                    return prefixFound && suffixFound;
                }
                if (prefix) {
                    if (prefixGap) {
                        return false;
                    }
                    return prefixFound;
                }
                if (suffix) {
                    if (suffixGap) {
                        return false;
                    }
                    return suffixFound;
                }
                return false;
            });
            if (formatInfoIndex === -1) {
                setInvalid(newState, format, formatInfo, intlService);
                return newState;
            }
        }
        // 9. Value ending on decimal separator (here as decimal might be typed inside format)
        if (sanitizedString[sanitizedString.length - 1] === symbols.decimal && maxDecimalCount > 0) {
            newState.eventValue = intlService.parseNumber(currentLooseValueAsString, format);
            newState.currentLooseValue = sanitizedFormattedString;
            return newState;
        }
        // 10. prevent deleting decimal and group symbols
        if (newState.currentLooseValue && prevLooseValue) {
            var isSpecialSymbolDeleted = (restrictedSymbols + symbols.decimal + symbols.group)
                .split('')
                .findIndex(function (s) {
                if (currentLooseValueAsString.split('').filter(function (x) { return x === s; }).length <
                    prevLooseValueAsString.split('').filter(function (x) { return x === s; }).length &&
                    currentLooseValueAsString.length + 1 === prevLooseValueAsString.length) {
                    if (s === symbols.decimal &&
                        getDecimalCount(prevLooseValueAsString.replace(sanitizeRegex, ''), symbols.decimal) === 0) {
                        return false;
                    }
                    return true;
                }
                return false;
            }) > -1;
            if (isSpecialSymbolDeleted) {
                newState.eventValue = intlService.parseNumber(state.prevLooseValue, format);
                newState.currentLooseValue = state.prevLooseValue;
                return newState;
            }
        }
        var currentDecimalCount = getDecimalCount(sanitizedString, symbols.decimal);
        var endsOnDecimal = sanitizedString[sanitizedString.length - 1] === '0';
        // 11. Deleting more decimals than allowed
        if (isDelete && endsOnDecimal && currentDecimalCount < minDecimalCount) {
            newState.eventValue = intlService.parseNumber(newState.currentLooseValue, format);
            newState.currentLooseValue = formatValue(newState.eventValue, format, intlService);
            return newState;
        }
        // 12. Ending on zero OR more decimals than allowed
        if (currentDecimalCount > 0) {
            var valueUntillDecimal = currentLooseValueAsString.substring(0, decimalIndex);
            if (endsOnDecimal && (!valueUntillDecimal || prevLooseValueAsString.indexOf(valueUntillDecimal) !== 0)) {
                // ending on zero but typing before decimal separator
                newState.eventValue = intlService.parseNumber(newState.currentLooseValue, format);
                var nextLooseValue = formatValue(newState.eventValue, format, intlService);
                setSelection(newState, changeBasedSelection(currentLooseValueAsString, nextLooseValue, newState.selectionEnd, isDelete, sanitizeRegex), nextLooseValue, formatInfo);
                newState.currentLooseValue = nextLooseValue;
                return newState;
            }
            if (currentDecimalCount > maxDecimalCount) {
                // typing more symbols than format allows
                var looseDecimalPlace = currentLooseValueAsString.indexOf(symbols.decimal);
                var result = currentLooseValueAsString.substring(0, looseDecimalPlace) +
                    currentLooseValueAsString.substring(looseDecimalPlace, looseDecimalPlace + 1 + maxDecimalCount) +
                    currentLooseValueAsString.substring(numberEnd, String(newState.currentLooseValue).length);
                newState.eventValue = intlService.parseNumber(result, format);
                newState.currentLooseValue = result;
                setSelection(newState, newState.selectionStart, result, formatInfo);
                return newState;
            }
            if (minDecimalCount !== maxDecimalCount && currentDecimalCount <= maxDecimalCount && endsOnDecimal) {
                // adding trailing zeroes
                newState.eventValue = intlService.parseNumber(newState.currentLooseValue, format);
                newState.currentLooseValue = sanitizedFormattedString;
                return newState;
            }
            if (currentDecimalCount < minDecimalCount) {
                // deleting more decimals than allowed
                newState.eventValue = intlService.parseNumber(newState.currentLooseValue, format);
                newState.currentLooseValue = formatValue(newState.eventValue, format, intlService);
                return newState;
            }
        }
    }
    // X. All other values should be parsed
    newState.eventValue = intlService.parseNumber(newState.currentLooseValue, format);
    if (isPercentFormat) {
        newState.eventValue = newState.eventValue / 100;
    }
    if (typeof newState.eventValue === 'number') {
        var nextLooseValue = formatValue(newState.eventValue, format, intlService);
        // First digit add
        if (currentLooseValueAsString.length === 1) {
            setSelection(newState, getInitialPosition(nextLooseValue, symbols), nextLooseValue, formatInfo);
        }
        else {
            setSelection(newState, changeBasedSelection(currentLooseValueAsString, nextLooseValue, newState.selectionEnd, isDelete, sanitizeRegex), nextLooseValue, formatInfo);
        }
        newState.currentLooseValue = nextLooseValue;
    }
    else {
        // Case when deleting last number
        newState.currentLooseValue = formatValue(intlService.parseNumber(sanitizedString), format, intlService);
    }
    return newState;
};

var __assign$u = (undefined && undefined.__assign) || function () {
    __assign$u = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$u.apply(this, arguments);
};
var VALIDATION_MESSAGE = 'Please enter a valid value!';
/**
 * Represents the PropsContext of the `NumericTextBox` component.
 * Used for global configuration of all `NumericTextBox` instances.
 *
 * For more information, refer to the [Inputs Props Context]({% slug props-context_inputs %}) article.
 */
var NumericTextBoxPropsContext = createPropsContext();
/**
 * Represents the [KendoReact NumericTextBox component]({% slug overview_numerictextbox %}).
 */
var NumericTextBox = React.forwardRef(function (directProps, target) {
    var _a;
    validatePackage$2(packageMetadata$4);
    var props = usePropsContext(NumericTextBoxPropsContext, directProps);
    var calculatedId = React.useMemo(function () { return guid$1(); }, []);
    var inputId = props.id || calculatedId;
    var intlService = useInternationalization();
    var localizationService = useLocalization();
    var elementRef = React.useRef(null);
    var valueDuringChangeRef = React.useRef();
    var _b = React.useState(false), forceUpdate = _b[0], setForceUpdate = _b[1];
    var stateRef = React.useRef(getInitialState());
    var isPasteRef = React.useRef(false);
    var prevLooseValueRef = React.useRef();
    var stateValueRef = React.useRef(props.defaultValue);
    var looseValue = formatValue(stateRef.current.focused && !props.disabled ?
        stateRef.current.currentLooseValue :
        getStateOrPropsValue(props.value, stateValueRef.current), props.format, intlService);
    prevLooseValueRef.current = looseValue;
    React.useEffect(function () {
        if (elementRef.current && elementRef.current.setCustomValidity) {
            elementRef.current.setCustomValidity(validityGetter().valid
                ? ''
                : props.validationMessage || VALIDATION_MESSAGE);
        }
    });
    var focusElement = React.useCallback(function () {
        if (elementRef.current) {
            elementRef.current.focus();
        }
    }, []);
    var valueGetter = React.useCallback(function () {
        if (valueDuringChangeRef.current !== undefined) {
            return valueDuringChangeRef.current;
        }
        else {
            return getStateOrPropsValue(props.value, stateValueRef.current);
        }
    }, [props.value]);
    var nameGetter = React.useCallback(function () {
        return props.name;
    }, [props.name]);
    var requiredGetter = React.useCallback(function () {
        return props.required;
    }, [props.required]);
    var validityGetter = React.useCallback(function () {
        var customError = props.validationMessage !== undefined;
        var currentValue = valueGetter();
        var valid = props.valid !== undefined ?
            props.valid :
            !stateRef.current.valueIsOutOfRange &&
                (!requiredGetter() || (currentValue !== null && currentValue !== undefined));
        return {
            customError: customError,
            valid: valid,
            valueMissing: currentValue === null || currentValue === undefined
        };
    }, [props.validationMessage, props.valid, valueGetter, requiredGetter]);
    var validityStylesGetter = React.useCallback(function () {
        return props.validityStyles;
    }, [props.validityStyles]);
    var propsGetter = React.useCallback(function () {
        return props;
    }, [props]);
    var getImperativeHandle = React.useCallback(function () {
        var options = {
            element: elementRef.current,
            focus: focusElement
        };
        Object.defineProperty(options, 'name', { get: nameGetter });
        Object.defineProperty(options, 'value', { get: valueGetter });
        Object.defineProperty(options, 'validity', { get: validityGetter });
        Object.defineProperty(options, 'validityStyles', { get: validityStylesGetter });
        Object.defineProperty(options, 'required', { get: requiredGetter });
        Object.defineProperty(options, 'props', { get: propsGetter });
        return options;
    }, [nameGetter, valueGetter, validityGetter, validityStylesGetter, requiredGetter, focusElement, propsGetter]);
    React.useImperativeHandle(target, getImperativeHandle);
    var getCurrentState = React.useCallback(function () {
        return {
            eventValue: getStateOrPropsValue(props.value, stateValueRef.current),
            prevLooseValue: prevLooseValueRef.current,
            currentLooseValue: elementRef.current.value,
            selectionStart: elementRef.current.selectionStart,
            selectionEnd: elementRef.current.selectionEnd,
            decimalSelect: false,
            valueIsCorrected: false,
            valueIsOutOfRange: false,
            isPaste: isPasteRef.current,
            focused: stateRef.current.focused
        };
    }, [props.value]);
    var triggerChange = React.useCallback(function (event, newState) {
        if (props.disabled) {
            return;
        }
        valueDuringChangeRef.current = newState.eventValue;
        stateValueRef.current = newState.eventValue;
        var formattedValue = formatValue(rangeValue(newState.eventValue, props.min, props.max), props.format, intlService);
        var rangedValue = rangeValue(intlService.parseNumber(formattedValue, props.format), props.min, props.max);
        if (rangedValue !== newState.eventValue) {
            newState.valueIsOutOfRange = true;
            newState.eventValue = rangedValue;
            stateValueRef.current = rangedValue;
        }
        var shouldFireEvent = props.value !== newState.eventValue;
        if (shouldFireEvent) {
            dispatchEvent$1(props.onChange, event, getImperativeHandle(), { value: newState.eventValue });
        }
        valueDuringChangeRef.current = undefined;
        stateRef.current = newState;
        setForceUpdate(function (_x) { return !_x; });
    }, [props.value, props.onChange, props.disabled, setForceUpdate, getImperativeHandle]);
    var onChangeHandler = React.useCallback(function (event) {
        var stateCandidate = getCurrentState();
        isPasteRef.current = false;
        triggerChange(event, sanitizeNumber(stateCandidate, props.format, intlService));
    }, [props.format, props.onChange, intlService, triggerChange, getCurrentState]);
    var onKeyDown = React.useCallback(function (event) {
        var newState = getCurrentState();
        var currentValue = intlService.parseNumber(String(newState.currentLooseValue), props.format);
        // Select All
        if (newState.selectionEnd > newState.selectionStart &&
            newState.selectionEnd - newState.selectionStart === String(newState.currentLooseValue).length) {
            isPasteRef.current = true;
            return;
        }
        switch (event.keyCode) {
            case 38:
                // Arrow up
                increaseValue(currentValue, newState, props.step, props.min, props.max, props.format, intlService);
                break;
            case 40:
                // Arrow down
                decreaseValue(currentValue, newState, props.step, props.min, props.max, props.format, intlService);
                break;
            case 13:
                // Enter - range values
                if (props.rangeOnEnter === false) {
                    return;
                }
                var formattedValue = formatValue(rangeValue(currentValue, props.min, props.max), props.format, intlService);
                var rangedValue = rangeValue(intlService.parseNumber(formattedValue, props.format), props.min, props.max);
                newState.eventValue = rangedValue;
                newState.currentLooseValue = formatValue(rangedValue, props.format, intlService);
                newState.selectionStart = newState.selectionEnd = newState.currentLooseValue.length;
                break;
            case 110:
                // Numpad decimal key
                var element = elementRef.current;
                var symbols = intlService.numberSymbols();
                if (element) {
                    newState.currentLooseValue = newState.currentLooseValue.slice(0, newState.selectionStart) +
                        symbols.decimal +
                        newState.currentLooseValue.slice(newState.selectionEnd);
                    newState.selectionStart = newState.selectionEnd = newState.selectionStart + 1;
                    newState = sanitizeNumber(newState, props.format, intlService);
                }
                break;
            default:
                return;
        }
        event.preventDefault();
        triggerChange(event, newState);
    }, [props.format, props.min, props.max, props.step, props.onChange, props.rangeOnEnter, triggerChange, getCurrentState]);
    var onPasteHandler = React.useCallback(function () {
        isPasteRef.current = true;
    }, []);
    var onIncrease = React.useCallback(function (event) {
        if (props.readOnly ||
            props.disabled) {
            return;
        }
        var newState = getCurrentState();
        increaseValue(intlService.parseNumber(String(newState.currentLooseValue), props.format), newState, props.step, props.min, props.max, props.format, intlService);
        triggerChange(event, newState);
    }, [props.format, props.min, props.max, props.step, props.onChange, props.readOnly, props.disabled, triggerChange, getCurrentState]);
    var onDecrease = React.useCallback(function (event) {
        if (props.readOnly ||
            props.disabled) {
            return;
        }
        var newState = getCurrentState();
        decreaseValue(intlService.parseNumber(String(newState.currentLooseValue), props.format), newState, props.step, props.min, props.max, props.format, intlService);
        triggerChange(event, newState);
    }, [props.format, props.min, props.max, props.step, props.onChange, props.readOnly, props.disabled, triggerChange, getCurrentState]);
    var onWheelHandler = React.useCallback(function (event) {
        if (!document ||
            document.activeElement !== elementRef.current ||
            !elementRef.current ||
            props.readOnly ||
            props.disabled) {
            return;
        }
        if (event.nativeEvent.deltaY < 0) {
            onIncrease(event);
        }
        if (event.nativeEvent.deltaY > 0) {
            onDecrease(event);
        }
    }, [onIncrease, onDecrease, props.disabled, props.readOnly]);
    var onFocus = React.useCallback(function (event) {
        stateRef.current.currentLooseValue = prevLooseValueRef.current;
        stateRef.current.focused = true;
        dispatchEvent$1(props.onFocus, event, getImperativeHandle(), {});
        setForceUpdate(function (x) { return !x; });
    }, [props.onFocus, setForceUpdate, getImperativeHandle]);
    var onBlur = React.useCallback(function (event) {
        stateRef.current = getInitialState();
        dispatchEvent$1(props.onBlur, event, getImperativeHandle(), {});
        setForceUpdate(function (x) { return !x; });
    }, [props.onBlur, setForceUpdate, getImperativeHandle]);
    var onMouseDown = React.useCallback(function (e) {
        if (document && elementRef.current) {
            e.preventDefault();
            if (document.activeElement !== elementRef.current) {
                elementRef.current.focus();
            }
        }
    }, []);
    React.useLayoutEffect(function () {
        // The input element's type ('number') does not support selection.
        if (elementRef.current && elementRef.current.type !== 'number' &&
            stateRef.current.selectionStart !== undefined && stateRef.current.selectionEnd !== undefined) {
            elementRef.current.selectionStart = stateRef.current.selectionStart;
            elementRef.current.selectionEnd = stateRef.current.selectionEnd;
            stateRef.current.selectionStart = undefined;
            stateRef.current.selectionEnd = undefined;
        }
    }, [forceUpdate]);
    var isValid = !validityStylesGetter() || validityGetter().valid;
    var numerictextbox = (React.createElement("span", { dir: props.dir, style: !props.label
            ? __assign$u({ width: props.width }, props.style) : props.style, className: classNames$2('k-input', 'k-numerictextbox', (_a = {},
            _a["k-input-".concat(kendoThemeMaps$1.sizeMap[props.size] || props.size)] = props.size,
            _a["k-input-".concat(props.fillMode)] = props.fillMode,
            _a["k-rounded-".concat(kendoThemeMaps$1.roundedMap[props.rounded] || props.rounded)] = props.rounded,
            _a['k-invalid'] = !isValid,
            _a['k-required'] = props.required,
            _a['k-disabled'] = props.disabled,
            _a), props.className), "aria-disabled": props.disabled ? 'true' : undefined },
        React.createElement("input", { value: looseValue === null ? '' : looseValue, tabIndex: getTabIndex(props.tabIndex, props.disabled), accessKey: props.accessKey, disabled: props.disabled, title: props.title, "aria-valuemin": props.min, "aria-valuemax": props.max, "aria-label": props.ariaLabel, "aria-labelledby": props.ariaLabelledBy, "aria-describedby": props.ariaDescribedBy, placeholder: props.placeholder, spellCheck: false, autoComplete: 'off', autoCorrect: 'off', type: props.inputType || 'tel', className: 'k-input-inner', id: inputId, name: props.name, readOnly: props.readOnly, style: props.inputStyle, onChange: onChangeHandler, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onPaste: onPasteHandler, onWheel: onWheelHandler, ref: elementRef }),
        props.children,
        props.spinners &&
            (React.createElement("span", { className: "k-input-spinner k-spin-button", onMouseDown: onMouseDown },
                React.createElement(Button$2, { tabIndex: -1, type: "button", icon: 'caret-alt-up', rounded: null, className: "k-spinner-increase", "aria-label": localizationService.toLanguageString(numericIncreaseValue, messages$1[numericIncreaseValue]), title: localizationService.toLanguageString(numericIncreaseValue, messages$1[numericIncreaseValue]), onClick: onIncrease }),
                React.createElement(Button$2, { tabIndex: -1, type: "button", icon: 'caret-alt-down', rounded: null, className: "k-spinner-decrease", "aria-label": localizationService.toLanguageString(numericDecreaseValue, messages$1[numericDecreaseValue]), title: localizationService.toLanguageString(numericDecreaseValue, messages$1[numericDecreaseValue]), onClick: onDecrease })))));
    return props.label
        ? (React.createElement(FloatingLabel, { label: props.label, editorId: inputId, editorValue: looseValue === null ? '' : looseValue, editorValid: isValid, editorDisabled: props.disabled, editorPlaceholder: props.placeholder, children: numerictextbox, style: { width: props.width }, dir: props.dir }))
        : numerictextbox;
});
NumericTextBox.propTypes = {
    value: propTypes.exports.number,
    defaultValue: propTypes.exports.number,
    step: propTypes.exports.number,
    format: propTypes.exports.oneOfType([
        propTypes.exports.string,
        propTypes.exports.shape({
            style: propTypes.exports.oneOf(['decimal', 'currency', 'percent', 'scientific', 'accounting']),
            currency: propTypes.exports.string,
            currencyDisplay: propTypes.exports.oneOf(['symbol', 'code', 'name']),
            useGrouping: propTypes.exports.bool,
            minimumIntegerDigits: propTypes.exports.number,
            minimumFractionDigits: propTypes.exports.number,
            maximumFractionDigits: propTypes.exports.number
        })
    ]),
    width: propTypes.exports.oneOfType([
        propTypes.exports.string,
        propTypes.exports.number
    ]),
    tabIndex: propTypes.exports.number,
    accessKey: propTypes.exports.string,
    title: propTypes.exports.string,
    placeholder: propTypes.exports.string,
    min: propTypes.exports.number,
    max: propTypes.exports.number,
    spinners: propTypes.exports.bool,
    disabled: propTypes.exports.bool,
    readOnly: propTypes.exports.bool,
    dir: propTypes.exports.string,
    name: propTypes.exports.string,
    label: propTypes.exports.string,
    validationMessage: propTypes.exports.string,
    required: propTypes.exports.bool,
    id: propTypes.exports.string,
    rangeOnEnter: propTypes.exports.bool,
    ariaLabelledBy: propTypes.exports.string,
    ariaDescribedBy: propTypes.exports.string,
    ariaLabel: propTypes.exports.string,
    onChange: propTypes.exports.func,
    onFocus: propTypes.exports.func,
    onBlur: propTypes.exports.func,
    size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
    rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
    fillMode: propTypes.exports.oneOf([null, 'solid', 'flat', 'outline'])
};
NumericTextBox.displayName = 'KendoNumericTextBox';
NumericTextBox.defaultProps = {
    step: 1,
    spinners: true,
    disabled: false,
    required: false,
    validityStyles: true,
    rangeOnEnter: true,
    onChange: function (_) { return; },
    onFocus: function (_) { return; },
    onBlur: function (_) { return; },
    size: 'medium',
    rounded: 'medium',
    fillMode: 'solid'
};

var __assign$t = (undefined && undefined.__assign) || function () {
    __assign$t = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$t.apply(this, arguments);
};
var __rest$4 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Represents the PropsContext of the `Checkbox` component.
 * Used for global configuration of all `Checkbox` instances.
 *
 * For more information, refer to the [Inputs Props Context]({% slug props-context_inputs %}) article.
 */
var CheckboxPropsContext = createPropsContext();
/**
 * Represents the [KendoReact Checkbox component]({% slug overview_checkbox %}).
 *
 * @example
 * ```jsx
 * class App extends React.Component {
 *     render() {
 *         return <Checkbox />;
 *     }
 * }
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var Checkbox = React.forwardRef(function (directProps, target) {
    var _a;
    validatePackage$2(packageMetadata$4);
    var props = usePropsContext(CheckboxPropsContext, directProps);
    var _b = props, ariaDescribedBy = _b.ariaDescribedBy, ariaLabelledBy = _b.ariaLabelledBy, checked = _b.checked, className = _b.className, children = _b.children, defaultChecked = _b.defaultChecked, disabled = _b.disabled, defaultValue = _b.defaultValue, id = _b.id, size = _b.size, rounded = _b.rounded, label = _b.label, labelPlacement = _b.labelPlacement, name = _b.name, labelOptional = _b.labelOptional, onChange = _b.onChange, onFocus = _b.onFocus, onBlur = _b.onBlur, tabIndex = _b.tabIndex, value = _b.value, required = _b.required, valid = _b.valid, validationMessage = _b.validationMessage, validityStyles = _b.validityStyles; 
    // Removed to support direct use in Form Field component
    _b.visited; _b.touched; _b.modified; var others = __rest$4(_b, ["ariaDescribedBy", "ariaLabelledBy", "checked", "className", "children", "defaultChecked", "disabled", "defaultValue", "id", "size", "rounded", "label", "labelPlacement", "name", "labelOptional", "onChange", "onFocus", "onBlur", "tabIndex", "value", "required", "valid", "validationMessage", "validityStyles", "visited", "touched", "modified"]);
    var elementRef = React.useRef(null);
    var focusElement = React.useCallback(function () {
        if (elementRef.current) {
            elementRef.current.focus();
        }
    }, []);
    var getImperativeHandle = React.useCallback(function () { return ({
        element: elementRef.current,
        focus: focusElement,
        get name() { return elementRef.current && elementRef.current.name; }
    }); }, [focusElement]);
    React.useImperativeHandle(target, getImperativeHandle);
    var _c = React.useState(defaultChecked), stateChecked = _c[0], setStateChecked = _c[1];
    var _d = React.useState(defaultValue), stateValue = _d[0], setStateValue = _d[1];
    var valueIsBoolean = (typeof value === 'boolean' || value === null);
    var isCheckedControlled = checked !== undefined;
    var isValueControlled = valueIsBoolean;
    var currentValue = isValueControlled ? value : stateValue;
    var currentChecked = isCheckedControlled ? checked : isValueControlled ? undefined : stateChecked;
    var useValueAsChecked = currentChecked === undefined && currentValue;
    var checkedProp = useValueAsChecked ? currentValue : currentChecked;
    var valueProp = (useValueAsChecked || isValueControlled) ? (value === null ? value : undefined) : value || currentValue;
    var indeterminateProp = checkedProp === null || valueProp === null;
    var calculatedId = React.useMemo(function () { return guid$1(); }, []);
    var localizationService = useLocalization();
    var localizeMessage = function (message) {
        return localizationService.toLanguageString(message, messages$1[message]);
    };
    var defaultValidationMessage = localizeMessage(checkboxValidation);
    var optionalMessage = localizeMessage(checkboxOptionalText);
    var isValid = valid !== undefined ?
        valid :
        !required ?
            true :
            currentChecked ? true : false;
    React.useEffect(function () {
        if (elementRef.current && elementRef.current.setCustomValidity) {
            elementRef.current.setCustomValidity(isValid
                ? ''
                : (validationMessage || defaultValidationMessage));
        }
    }, [isValid, validationMessage, defaultValidationMessage]);
    var setValue = React.useCallback(function (e, val) {
        if (!isValueControlled && !disabled) {
            setStateValue(val);
            if (!isCheckedControlled && !disabled) {
                setStateChecked(val);
            }
        }
        if (onChange && !disabled) {
            dispatchEvent$1(onChange, e, __assign$t(__assign$t({}, getImperativeHandle()), { value: val }), { value: val });
        }
    }, [isCheckedControlled, disabled, onChange, isValueControlled, getImperativeHandle]);
    var handleChange = React.useCallback(function (e) {
        var newValue = e.target.checked;
        setValue(e, newValue);
    }, [setValue, value]);
    var handleKeyDown = React.useCallback(function (e) {
        if (disabled) {
            return;
        }
        var keyCode = e.keyCode;
        var currentVal = e.currentTarget.checked;
        if (keyCode === Keys$1.space) {
            e.preventDefault();
            e.stopPropagation();
            setValue(e, !currentVal);
        }
    }, [disabled, setValue]);
    var handleKeyUp = React.useCallback(function (e) {
        if (disabled) {
            return;
        }
        var keyCode = e.keyCode;
        if (keyCode === Keys$1.space) {
            e.preventDefault();
        }
    }, [disabled]);
    var handleFocus = React.useCallback(function (e) {
        if (onFocus && !disabled) {
            dispatchEvent$1(onFocus, e, getImperativeHandle(), undefined);
        }
    }, [onFocus, disabled, getImperativeHandle]);
    var handleBlur = React.useCallback(function (e) {
        if (onBlur && !disabled) {
            dispatchEvent$1(onBlur, e, getImperativeHandle(), undefined);
        }
    }, [onBlur, disabled, getImperativeHandle]);
    var dir = useDir(elementRef, props.dir);
    var checkboxClasses = classNames$2({ 'k-disabled': disabled }, className);
    var inputProps = __assign$t(__assign$t({ type: 'checkbox', className: classNames$2('k-checkbox', (_a = {},
            _a["k-checkbox-".concat(kendoThemeMaps$1.sizeMap[size] || size)] = size,
            _a["k-rounded-".concat(kendoThemeMaps$1.roundedMap[rounded] || rounded)] = rounded,
            _a['k-indeterminate'] = indeterminateProp,
            _a['k-disabled'] = disabled,
            _a['k-invalid k-invalid'] = !(isValid || validityStyles !== undefined || validityStyles === true),
            _a)), ref: elementRef, name: name, id: id || calculatedId, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, checked: Boolean(checkedProp), disabled: disabled, tabIndex: getTabIndex(tabIndex, disabled), role: 'checkbox', required: required !== undefined ? required : false, 'aria-checked': currentChecked || checkedProp ?
            true :
            indeterminateProp ?
                'mixed' :
                false, 'aria-disabled': disabled || undefined }, others), { onChange: handleChange, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onFocus: handleFocus, onBlur: handleBlur });
    var checkboxInput = (React.createElement(React.Fragment, null, 
    // removing value prop is required due to bug in react where
    // value set to undefined override default submit value
    valueProp === undefined ? (React.createElement("input", __assign$t({}, inputProps))) : (React.createElement("input", __assign$t({}, inputProps, { value: valueIsBoolean ? undefined : valueProp === null ? '' : valueProp })))));
    var checkboxLabel = (React.createElement(React.Fragment, null, label !== undefined ? (React.createElement("label", { className: 'k-checkbox-label', htmlFor: id || calculatedId, style: { userSelect: 'none' } },
        label,
        labelOptional && React.createElement("span", { className: "k-label-optional" }, optionalMessage))) : null));
    return (React.createElement(React.Fragment, null, (labelPlacement === 'before') ? (React.createElement("span", { className: checkboxClasses, dir: 'rtl' },
        checkboxInput,
        checkboxLabel,
        children)) : (React.createElement("span", { className: checkboxClasses, dir: dir },
        checkboxInput,
        checkboxLabel,
        children))));
});
Checkbox.propTypes = {
    checked: propTypes.exports.bool,
    className: propTypes.exports.string,
    defaultChecked: propTypes.exports.bool,
    defaultValue: propTypes.exports.any,
    dir: propTypes.exports.string,
    disabled: propTypes.exports.bool,
    id: propTypes.exports.string,
    size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
    rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
    ariaLabelledBy: propTypes.exports.string,
    ariaDescribedBy: propTypes.exports.string,
    label: propTypes.exports.any,
    labelPlacement: propTypes.exports.string,
    labelOptional: propTypes.exports.bool,
    name: propTypes.exports.string,
    tabIndex: propTypes.exports.number,
    value: propTypes.exports.any,
    validationMessage: propTypes.exports.string,
    required: propTypes.exports.bool,
    validate: propTypes.exports.bool,
    valid: propTypes.exports.bool,
    onChange: propTypes.exports.func,
    onFocus: propTypes.exports.func,
    onBlur: propTypes.exports.func
};
var defaultProps$2 = {
    size: 'medium',
    rounded: 'medium'
};
Checkbox.defaultProps = defaultProps$2;
Checkbox.displayName = 'KendoCheckbox';

var __assign$s = (undefined && undefined.__assign) || function () {
    __assign$s = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$s.apply(this, arguments);
};
var __rest$3 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Represents the [KendoReact TextBox component]({% slug overview_textbox %}).
 */
var TextBox = React.forwardRef(function (props, ref) {
    var _a;
    validatePackage$2(packageMetadata$4);
    var element = React.useRef(null);
    var target = React.useRef(null);
    var valueDuringChangeRef = React.useRef();
    var valueGetter = React.useCallback(function () {
        var _a;
        if (valueDuringChangeRef.current !== undefined) {
            return valueDuringChangeRef.current;
        }
        else {
            return (_a = element.current) === null || _a === void 0 ? void 0 : _a.value;
        }
    }, []);
    React.useImperativeHandle(target, function () {
        var result = {
            element: element.current
        };
        Object.defineProperty(result, 'value', { get: valueGetter });
        return result;
    });
    React.useImperativeHandle(ref, function () { return target.current; });
    var _b = props, size = _b.size, fillMode = _b.fillMode, rounded = _b.rounded, className = _b.className, dir = _b.dir, style = _b.style, _c = _b.prefix, prefix = _c === void 0 ? defaultProps$1.prefix : _c, _d = _b.suffix, suffix = _d === void 0 ? defaultProps$1.suffix : _d; _b.valid; 
    // Destruct to avoid warning when used inside a form field
    _b.modified; _b.touched; _b.visited; var other = __rest$3(_b, ["size", "fillMode", "rounded", "className", "dir", "style", "prefix", "suffix", "valid", "modified", "touched", "visited"]);
    var Prefix = useCustomComponent(prefix)[0];
    var Suffix = useCustomComponent(suffix)[0];
    var _e = React.useState(false), focused = _e[0], setFocused = _e[1];
    var handleFocus = function (_) {
        setFocused(true);
    };
    var handleBlur = function (_) {
        setFocused(false);
    };
    var handleChange = React.useCallback(function (event) {
        valueDuringChangeRef.current = event.target.value;
        if (props.onChange) {
            props.onChange.call(undefined, {
                syntheticEvent: event,
                nativeEvent: event.nativeEvent,
                value: event.target.value,
                target: target.current
            });
        }
        valueDuringChangeRef.current = undefined;
    }, [props.onChange]);
    var _f = useAsyncFocusBlur({
        onFocus: handleFocus,
        onBlur: handleBlur,
        onSyncFocus: props.onFocus,
        onSyncBlur: props.onBlur
    }), onFocus = _f.onFocus, onBlur = _f.onBlur;
    return (React.createElement("span", { style: style, dir: dir, className: classNames$2('k-input', (_a = {},
            _a["k-input-".concat(kendoThemeMaps$1.sizeMap[size] || size)] = size,
            _a["k-input-".concat(fillMode)] = fillMode,
            _a["k-rounded-".concat(kendoThemeMaps$1.roundedMap[rounded] || rounded)] = rounded,
            _a), {
            'k-focus': focused,
            'k-required': props.required,
            'k-disabled': props.disabled,
            'k-invalid': props.valid === false
        }, className), onFocus: onFocus, onBlur: onBlur },
        React.createElement(Prefix, null),
        React.createElement("input", __assign$s({ ref: element, className: "k-input-inner" }, other, { onChange: handleChange })),
        React.createElement(Suffix, null)));
});
var defaultProps$1 = {
    prefix: function (_) { return null; },
    suffix: function (_) { return null; },
    size: 'medium',
    rounded: 'medium',
    fillMode: 'solid'
};
TextBox.propTypes = {
    size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
    rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
    fillMode: propTypes.exports.oneOf([null, 'solid', 'flat', 'outline'])
};
TextBox.displayName = 'KendoReactTextBoxComponent';
TextBox.defaultProps = defaultProps$1;

var __spreadArray$6 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a$1, _b, _c;
/**
 * @hidden
 */
var KEYBOARD_NAV_DATA_LEVEL = 'data-keyboardnavlevel';
/**
 * @hidden
 */
var KEYBOARD_NAV_DATA_SCOPE = 'data-keyboardnavscope';
/**
 * @hidden
 */
var KEYBOARD_NAV_DATA_HEADER = 'data-keyboardnavheader';
/**
 * @hidden
 */
var KEYBOARD_NAV_DATA_BODY = 'data-keyboardnavbody';
/**
 * @hidden
 */
var KEYBOARD_NAV_DATA_ID = 'data-keyboardnavid';
/**
 * @hidden
 */
var KEYBOARD_NAV_FILTER_COL_SUFFIX = '_filter';
var FOCUSABLE_ELEMENTS_BASE = [
    'input:not([disabled]):not([type=hidden])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]'
];
/**
 * @hidden
 */
var FOCUSABLE_ELEMENTS = __spreadArray$6(__spreadArray$6([], FOCUSABLE_ELEMENTS_BASE, true), ['[tabindex]'], false);
/**
 * @hidden
 */
var TABBABLE_ELEMENTS = __spreadArray$6(__spreadArray$6([], FOCUSABLE_ELEMENTS_BASE, true), ['[tabindex]'], false).map(function (selector) { return selector + ':not([tabindex="-1"])'; });
/**
 * @hidden
 */
var tableKeyboardNavigationScopeAttributes = (_a$1 = {},
    _a$1[KEYBOARD_NAV_DATA_SCOPE] = true,
    _a$1);
/**
 * @hidden
 */
var tableKeyboardNavigationHeaderAttributes = (_b = {},
    _b[KEYBOARD_NAV_DATA_HEADER] = true,
    _b);
/**
 * @hidden
 */
var tableKeyboardNavigationBodyAttributes = (_c = {},
    _c[KEYBOARD_NAV_DATA_BODY] = true,
    _c);

/**
 * @hidden
 */
var TableKeyboardNavigationContext = React.createContext(undefined);
TableKeyboardNavigationContext.displayName = 'KendoReactTableKeyboardNavigationContext';

/**
 * @hidden
 */
var useTableKeyboardNavigation = function (elementId, navigatable) {
    var _a;
    var navigationContext = React.useContext(TableKeyboardNavigationContext);
    if (!navigationContext || !elementId || navigatable === false) {
        return {};
    }
    return _a = {
            tabIndex: navigationContext && navigationContext.activeId && navigationContext.activeId === elementId ? 0 : -1
        },
        _a[KEYBOARD_NAV_DATA_LEVEL] = navigationContext.level,
        _a[KEYBOARD_NAV_DATA_ID] = elementId,
        _a;
};

var __assign$r = (undefined && undefined.__assign) || function () {
    __assign$r = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$r.apply(this, arguments);
};
/**
 * @hidden
 */
var HeaderThElement = function (props) {
    var ariaSort = props.ariaSort, colSpan = props.colSpan, rowSpan = props.rowSpan, className = props.className, style = props.style, columnId = props.columnId, onKeyDown = props.onKeyDown, navigatable = props.navigatable, ariaColumnIndex = props.ariaColumnIndex, ariaLabel = props.ariaLabel, role = props.role, ariaSelected = props.ariaSelected;
    var navigationAttributes = useTableKeyboardNavigation(columnId, navigatable);
    return (React.createElement("th", __assign$r({ "aria-sort": ariaSort, "aria-label": ariaLabel, "aria-colindex": ariaColumnIndex, "aria-selected": ariaSelected, 
        // TODO: Enable this with React 18. Currently throws warnings
        // aria-description={ariaDescription}
        colSpan: colSpan, rowSpan: rowSpan, className: className, style: style, onKeyDown: onKeyDown, role: role }, navigationAttributes), props.children));
};
HeaderThElement.displayName = 'KendoReactHeaderThElement';

/**
 * @hidden
 */
var generateNavigatableId = function (navigationId, idPrefix, type) {
    if (type === void 0) { type = 'cell'; }
    return "".concat(idPrefix, "_").concat(navigationId, "_").concat(type);
};
/**
 * @hidden
 */
var getNavigatableLevel = function (element) {
    if (!element) {
        return;
    }
    return parseInt(element.getAttribute(KEYBOARD_NAV_DATA_LEVEL) || '', 10);
};
/**
 * @hidden
 */
var getNavigatableId = function (element) {
    if (!element) {
        return;
    }
    var dataId = element.getAttribute(KEYBOARD_NAV_DATA_ID);
    return dataId ? dataId : undefined;
};
/**
 * @hidden
 */
var isNavigatable = function (element) {
    if (!element) {
        return false;
    }
    var dataId = element.getAttribute(KEYBOARD_NAV_DATA_ID);
    return Boolean(dataId);
};
/**
 * @hidden
 */
var getNavigatableElement = function (scope, options) {
    if (options === void 0) { options = { level: 0 }; }
    return scope.querySelector("[".concat(KEYBOARD_NAV_DATA_LEVEL, "='").concat(options.level, "']"));
};
/**
 * @hidden
 */
var getClosestNavigatableElement = function (target) {
    return (target.parentElement &&
        target.parentElement.closest("[".concat(KEYBOARD_NAV_DATA_LEVEL, "]")));
};
/**
 * @hidden
 */
var getActiveElement = function (scope, activeId) {
    return scope.querySelector("[".concat(KEYBOARD_NAV_DATA_ID, "='").concat(activeId, "']"));
};
/**
 * @hidden
 */
var getClosestScope = function (target) {
    return (target.parentElement &&
        target.parentElement.closest("[".concat(KEYBOARD_NAV_DATA_SCOPE, "]")));
};
/**
 * @hidden
 */
var getHeaderElement = function (scope) {
    return scope.querySelector("[".concat(KEYBOARD_NAV_DATA_HEADER, "]"));
};
/**
 * @hidden
 */
var getBodyElement = function (scope) {
    return scope.querySelector("[".concat(KEYBOARD_NAV_DATA_BODY, "]"));
};
/**
 * @hidden
 */
var getFocusableElements = function (scope, options) {
    if (options === void 0) { options = { focusable: false }; }
    var selectors = options.focusable ? FOCUSABLE_ELEMENTS : TABBABLE_ELEMENTS;
    return Array.from(scope.querySelectorAll(selectors.join(',')));
};
/**
 * @hidden
 */
var getNavigatableElements = function (scope, options) {
    if (options === void 0) { options = { level: 0 }; }
    if (!scope) {
        return [];
    }
    var selector = FOCUSABLE_ELEMENTS.map(function (el) { return el + "[".concat(KEYBOARD_NAV_DATA_LEVEL, "='").concat(options.level, "']"); }).join(',');
    return Array.from(scope.querySelectorAll(selector));
};
/**
 * @hidden
 */
var filterNavigatableElements = function (options) {
    if (options === void 0) { options = { level: 0 }; }
    var selector = FOCUSABLE_ELEMENTS.map(function (sel) { return sel + "[".concat(KEYBOARD_NAV_DATA_LEVEL, "='").concat(options.level, "']"); }).join(',');
    return function (element) { return element.matches(selector); };
};
/**
 * @hidden
 */
var focusElement = function (options) {
    var elementForFocus = options.elementForFocus, event = options.event, contextStateRef = options.contextStateRef, prevElement = options.prevElement;
    if (contextStateRef.current && elementForFocus && elementForFocus.focus) {
        event.preventDefault();
        elementForFocus.focus();
        if (isNavigatable(elementForFocus)) {
            elementForFocus.setAttribute('tabIndex', '0');
            contextStateRef.current.activeId = getNavigatableId(elementForFocus);
        }
        if (prevElement && isNavigatable(prevElement)) {
            prevElement.setAttribute('tabIndex', '-1');
        }
    }
};
/**
 * @hidden
 */
var getIdPrefix = function (navigationStateRef) {
    return navigationStateRef.current ? navigationStateRef.current.idPrefix : '';
};
/**
 * @hidden
 */
var findNextIdByRowIndex = function (initialRowIndex, cellIndex, elementId, matrix, isReverse) {
    if (!elementId) {
        return [];
    }
    var currentRowIndex = initialRowIndex + (isReverse ? -1 : 1);
    while (currentRowIndex >= 0 && currentRowIndex < matrix.length) {
        var currentId = matrix[currentRowIndex][cellIndex];
        if (currentId !== elementId) {
            return [currentId, [currentRowIndex, cellIndex]];
        }
        currentRowIndex = currentRowIndex + (isReverse ? -1 : 1);
    }
    return [];
};
/**
 * @hidden
 */
var findNextIdByCellIndex = function (rowIndex, initialCellIndex, elementId, matrix, isReverse) {
    if (!elementId) {
        return [];
    }
    var currentCellIndex = initialCellIndex + (isReverse ? -1 : 1);
    while (currentCellIndex >= 0 && currentCellIndex < matrix[rowIndex].length) {
        var currentId = matrix[rowIndex][currentCellIndex];
        if (currentId !== elementId) {
            return [currentId, [rowIndex, currentCellIndex]];
        }
        currentCellIndex = currentCellIndex + (isReverse ? -1 : 1);
    }
    return [];
};
/**
 * @hidden
 */
var findId = function (navigationMatrix, cellId) {
    if (!cellId) {
        return;
    }
    for (var rowIndex = 0; rowIndex < navigationMatrix.length; rowIndex++) {
        for (var cellIndex = 0; cellIndex < navigationMatrix[rowIndex].length; cellIndex++) {
            if (navigationMatrix[rowIndex][cellIndex] === cellId) {
                return [rowIndex, cellIndex];
            }
        }
    }
};
/**
 * @hidden
 */
var getNextNavigationIndex = function (navigationStateRef) {
    return navigationStateRef.current ? navigationStateRef.current.navigationMatrix.length : 0;
};
/**
 * @hidden
 */
var getFilterColumnId = function (columnId) {
    return columnId ? "".concat(columnId).concat(KEYBOARD_NAV_FILTER_COL_SUFFIX) : '';
};
/**
 * @hidden
 */
var tableKeyboardNavigationTools = {
    generateNavigatableId: generateNavigatableId,
    getNavigatableId: getNavigatableId,
    getNavigatableLevel: getNavigatableLevel,
    getNavigatableElement: getNavigatableElement,
    getClosestNavigatableElement: getClosestNavigatableElement,
    getActiveElement: getActiveElement,
    getClosestScope: getClosestScope,
    getHeaderElement: getHeaderElement,
    getBodyElement: getBodyElement,
    getFocusableElements: getFocusableElements,
    getNavigatableElements: getNavigatableElements,
    filterNavigatableElements: filterNavigatableElements,
    focusElement: focusElement,
    getIdPrefix: getIdPrefix,
    isNavigatable: isNavigatable,
    findNextIdByRowIndex: findNextIdByRowIndex,
    findNextIdByCellIndex: findNextIdByCellIndex,
    findId: findId,
    getNextNavigationIndex: getNextNavigationIndex,
    getFilterColumnId: getFilterColumnId
};

function nextColumn(columns, current) {
    var currentDepth = columns[current].depth;
    var next = null;
    for (var index = current + 1; index < columns.length; index++) {
        if (columns[index].depth === currentDepth) {
            next = columns[index];
            break;
        }
    }
    return next;
}
var getColumnWidth = function (column) {
    var width = column.width ? parseFloat(column.width.toString()) : 0;
    if (!width && column.children && column.children.length) {
        width = column.children.reduce(function (currentSum, child) { return getColumnWidth(child) + currentSum; }, 0);
    }
    return width;
};
/**
 * @hidden
 */
function mapColumns(columns) {
    var columnsMap = [[]];
    var maxDepth = 0;
    // set colspans, get maxdepth
    for (var q = columns.length - 1; q >= 0; q--) {
        maxDepth = Math.max(maxDepth, columns[q].depth);
        columns[q].colSpan = columns[q].colSpan || 1;
        if (columns[q].parentIndex !== -1) {
            columns[columns[q].parentIndex].colSpan =
                (columns[columns[q].parentIndex].colSpan || 0) + columns[q].colSpan;
        }
    }
    var colIndexByLevel = [];
    var rowSpan = 1;
    // set rowspan, kFirst, index AND create columnsMap
    columns.forEach(function (column, i) {
        columnsMap[column.depth] = columnsMap[column.depth] || [];
        var needKFirst = false;
        if (columnsMap[column.depth].length === 0) {
            if (rowSpan <= 1) {
                rowSpan = 1 + (column.children.length > 0 ? 0 : maxDepth - column.depth);
            }
            else {
                rowSpan--;
                needKFirst = true;
            }
        }
        column.rowSpan = 1 + (column.children.length > 0 ? 0 : maxDepth - column.depth);
        column.kFirst = needKFirst;
        column.index = columnsMap[column.depth].length;
        columnsMap[column.depth].push(i);
        column.ariaColumnIndex = colIndexByLevel[column.depth] ? colIndexByLevel[column.depth] + 1 : 1;
        for (var ci = column.depth; ci < column.depth + column.rowSpan; ci++) {
            colIndexByLevel[ci] = (colIndexByLevel[ci] || 0) + column.colSpan;
        }
    });
    var stickyLeftWidth = new Array(columnsMap.length).fill(0);
    var width = 0;
    // set left AND create stickyLeftWidth
    columns.forEach(function (column) {
        if (column.locked) {
            column.left = stickyLeftWidth[column.depth];
            width = getColumnWidth(column);
            if (column.children.length === 0) {
                for (var i = column.depth; i < stickyLeftWidth.length; i++) {
                    stickyLeftWidth[i] += width;
                }
            }
            else {
                stickyLeftWidth[column.depth] += width;
            }
        }
    });
    var stickyRightWidth = new Array(columnsMap.length).fill(0);
    // set right, rightBorder AND create stickyRightWidth
    for (var i = columns.length - 1; i >= 0; i--) {
        var column = columns[i];
        if (column.locked) {
            column.right = stickyRightWidth[column.depth];
            width = getColumnWidth(column);
            if (column.children.length === 0) {
                for (var j = column.depth; j < stickyRightWidth.length; j++) {
                    stickyRightWidth[j] += width;
                }
            }
            else {
                stickyRightWidth[column.depth] += width;
            }
            var next = nextColumn(columns, i);
            column.rightBorder = !(next && next.locked);
        }
    }
    return columnsMap;
}
/**
 * @hidden
 */
function isRtl(element) {
    return Boolean(element && getComputedStyle(element).direction === 'rtl');
}
/**
 * @hidden
 */
function getIndex(event, parent) {
    if (!parent || !event || !event.originalEvent) {
        return -1;
    }
    var target = parent.ownerDocument ? parent.ownerDocument.elementFromPoint(event.clientX, event.originalEvent.clientY) : null;
    while (target && target.parentElement !== parent) {
        target = target.parentElement;
    }
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
        if (children[i] === target) {
            return i;
        }
    }
    return -1;
}

var __spreadArray$5 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
function tableColumnsVirtualization(args) {
    var enabled = args.enabled, _a = args.columns, columns = _a === void 0 ? [] : _a, tableViewPortWidth = args.tableViewPortWidth, scrollLeft = args.scrollLeft;
    var colSpans = columns.map(function () { return 1; });
    var hiddenColumns = columns.map(function () { return false; });
    if (!enabled) {
        return { colSpans: colSpans, hiddenColumns: hiddenColumns };
    }
    var widths = columns.map(function (c) { return parseFloat((c.width || '').toString()) || 10; });
    var widthOfHiddenColumns = 0;
    for (var i = 0; i < columns.length; i++) {
        if (columns[i].locked) {
            continue;
        }
        var considerNext = (i < widths.length - 1) ? widths[i + 1] : 0;
        if (widthOfHiddenColumns + widths[i] + considerNext < scrollLeft) {
            hiddenColumns[i] = true;
            widthOfHiddenColumns += widths[i];
        }
        else {
            break;
        }
    }
    var totalWidth = widths.reduce(function (acc, current) { return acc + current; }, 0);
    widthOfHiddenColumns = 0;
    for (var i = columns.length - 1; i >= 0; i--) {
        if (columns[i].locked) {
            continue;
        }
        if (widthOfHiddenColumns + 2 * widths[i] < totalWidth - tableViewPortWidth - scrollLeft) {
            hiddenColumns[i] = true;
            widthOfHiddenColumns += widths[i];
        }
        else {
            break;
        }
    }
    var hiddenCols = __spreadArray$5([], hiddenColumns, true);
    var hidden = function (value) { return value; };
    var lastVisible = hiddenCols.lastIndexOf(false);
    var anyHidden = hiddenCols.some(hidden);
    var allHidden = hiddenCols.every(hidden);
    var hiddenSeqLength;
    var updateIndex;
    while (anyHidden && hiddenCols.length && (lastVisible !== -1 || allHidden)) {
        if (lastVisible < hiddenCols.length - 1) {
            hiddenSeqLength = allHidden ? hiddenCols.length : hiddenCols.length - lastVisible - 1;
            updateIndex = hiddenCols.length - hiddenSeqLength;
            if (updateIndex === 0) {
                updateIndex = hiddenSeqLength - 1;
            }
            hiddenColumns[updateIndex] = false;
            colSpans[updateIndex] = hiddenSeqLength;
            hiddenCols.splice(lastVisible + 1, hiddenSeqLength);
        }
        while (hiddenCols.length && !hiddenCols[hiddenCols.length - 1]) {
            hiddenCols.pop();
        }
        lastVisible = hiddenCols.lastIndexOf(false);
        anyHidden = hiddenCols.some(hidden);
        allHidden = hiddenCols.every(hidden);
    }
    return { colSpans: colSpans, hiddenColumns: hiddenColumns };
}

var __extends$u = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var DragClue = /** @class */ (function (_super) {
    __extends$u(DragClue, _super);
    function DragClue(props) {
        var _this = _super.call(this, props) || this;
        _this.elementRef = React.createRef();
        _this.state = {
            visible: false,
            top: 0,
            left: 0,
            innerText: '',
            status: 'k-i-cancel'
        };
        _this.hiddenElementRef = React.createRef();
        return _this;
    }
    Object.defineProperty(DragClue.prototype, "element", {
        get: function () {
            return this.elementRef.current;
        },
        enumerable: false,
        configurable: true
    });
    DragClue.prototype.render = function () {
        var hiddenElement = this.hiddenElementRef.current;
        var dragClue = this.state.visible && canUseDOM$2 && createPortal((React.createElement("div", { ref: this.elementRef, className: "k-header k-drag-clue", style: {
                display: 'block',
                position: 'absolute',
                zIndex: 20000,
                padding: '8px 12px',
                top: this.state.top + 'px',
                left: this.state.left + 'px'
            } },
            React.createElement("span", { className: 'k-icon k-drag-status ' + this.state.status + ' k-icon-with-modifier' },
                React.createElement("span", { className: "k-icon k-icon-modifier" })),
            this.state.innerText)), (hiddenElement && hiddenElement.ownerDocument ?
            hiddenElement.ownerDocument.body :
            document.body));
        return (React.createElement(React.Fragment, null,
            dragClue,
            React.createElement("div", { ref: this.hiddenElementRef, style: { display: 'none' } })));
    };
    return DragClue;
}(React.PureComponent));

var __extends$t = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var DropClue = /** @class */ (function (_super) {
    __extends$t(DropClue, _super);
    function DropClue(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            height: 0,
            visible: false,
            left: 0,
            top: 0
        };
        _this.hiddenElementRef = React.createRef();
        return _this;
    }
    DropClue.prototype.render = function () {
        var hiddenElement = this.hiddenElementRef.current;
        var dropClue = this.state.visible && canUseDOM$2 && createPortal((React.createElement("div", { className: "k-grouping-dropclue", style: {
                zIndex: 10000,
                display: 'block',
                top: this.state.top + 'px',
                left: this.state.left + 'px',
                height: this.state.height + 'px'
            } })), (hiddenElement && hiddenElement.ownerDocument ?
            hiddenElement.ownerDocument.body :
            document.body));
        return (React.createElement(React.Fragment, null,
            dropClue,
            React.createElement("div", { ref: this.hiddenElementRef, style: { display: 'none' } })));
    };
    return DropClue;
}(React.PureComponent));

/**
 * @hidden
 */
var isPresent = function (value) { return value !== null && value !== undefined; };
/**
 * @hidden
 */
var isBlank = function (value) { return value === null || value === undefined; };
/**
 * @hidden
 */
var isArray = function (value) { return Array.isArray(value); };
/**
 * @hidden
 */
var isFunction = function (value) { return typeof value === 'function'; };
/**
 * @hidden
 */
var isString = function (value) { return typeof value === 'string'; };
/**
 * @hidden
 */
var isNullOrEmptyString = function (value) { return isBlank(value) || value.trim().length === 0; };
/**
 * @hidden
 */
var isNotNullOrEmptyString = function (value) { return !isNullOrEmptyString(value); };
/**
 * @hidden
 */
var isNumeric = function (value) { return !isNaN(value - parseFloat(value)); };
/**
 * @hidden
 */
var isDate = function (value) { return value && value.getTime; };

// tslint:enable:max-line-length
/**
 * @hidden
 * Type guard for `CompositeFilterDescriptor`.
 */
var isCompositeFilterDescriptor = function (source) {
    return isPresent(source.filters);
};

/**
 * @hidden
 */
var ifElse = function (predicate, right, left) { return function (value) { return predicate(value) ? right(value) : left(value); }; };
/**
 * @hidden
 * Performs the right-to-left function composition. Functions should have a unary.
 */
var compose = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (data) { return args.reduceRight(function (acc, curr) { return curr(acc); }, data); };
};

/**
 * @hidden
 */
var toUTC = function (date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
};
/**
 * @hidden
 */
var isDateValue = function (x) { return isDate(x.value); };

var operatorMap$1 = function (key) { return ({
    "!=": "neq",
    "<": "lt",
    "<=": "lte",
    "==": "eq",
    ">": "gt",
    ">=": "gte",
    equal: "eq",
    equals: "eq",
    equalto: "eq",
    ge: "gte",
    greater: "gt",
    greaterthan: "gt",
    greaterthanequal: "gte",
    isempty: "isempty",
    isequalto: "eq",
    isgreaterthan: "gt",
    isgreaterthanorequalto: "gte",
    islessthan: "lt",
    islessthanorequalto: "lte",
    isnotempty: "isnotempty",
    isnotequalto: "neq",
    isnull: "isnull",
    le: "lte",
    less: "lt",
    lessthan: "lt",
    lessthanequal: "lte",
    ne: "neq",
    notequal: "neq",
    notequals: "neq",
    notequalto: "neq",
    notsubstringof: "doesnotcontain"
}[key.toLowerCase()] || key); };
var normalizeOperator = function (descriptor) {
    if (descriptor.filters) {
        descriptor.filters = descriptor.filters.map(function (filter) {
            var result = Object.assign({}, filter);
            if (!isCompositeFilterDescriptor(filter) && isString(filter.operator)) {
                result.operator = operatorMap$1(filter.operator);
            }
            if (isCompositeFilterDescriptor(filter)) {
                normalizeOperator(result);
            }
            return result;
        });
    }
};
var normalizeDescriptor = function (descriptor) {
    if (!isCompositeFilterDescriptor(descriptor)) {
        return {
            filters: isArray(descriptor) ? descriptor : [descriptor],
            logic: "and"
        };
    }
    return Object.assign({}, descriptor);
};
// tslint:disable:max-line-length
/**
 * Converts a [FilterDescriptor]({% slug api_kendo-data-query_filterdescriptor %}) into a [CompositeFilterDescriptor]({% slug api_kendo-data-query_compositefilterdescriptor %}). If a `CompositeFilterDescriptor` is passed, no modifications will be made.
 *
 * @param {CompositeFilterDescriptor | FilterDescriptor} descriptor - The descriptor that will be normalized.
 * @returns {CompositeFilterDescriptor} - The normalized descriptor.
 */
// tslint:enable:max-line-length
var normalizeFilters = function (descriptor) {
    if (isPresent(descriptor)) {
        descriptor = normalizeDescriptor(descriptor);
        normalizeOperator(descriptor);
    }
    return descriptor;
};

var getterCache = {};
var FIELD_REGEX = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
// tslint:disable-next-line:no-string-literal
getterCache['undefined'] = function (obj) { return obj; };
/**
 * @hidden
 */
var getter = function (field, safe) {
    var key = field + safe;
    if (getterCache[key]) {
        return getterCache[key];
    }
    var fields = [];
    field.replace(FIELD_REGEX, function (_, index, indexAccessor, field) {
        fields.push(isPresent(index) ? index : (indexAccessor || field));
        return undefined;
    });
    getterCache[key] = function (obj) {
        var result = obj;
        for (var idx = 0; idx < fields.length; idx++) {
            result = result[fields[idx]];
            if (!isPresent(result) && safe) {
                return result;
            }
        }
        return result;
    };
    return getterCache[key];
};

var pairwise = function (key) { return function (value) { return [key, value]; }; };
var empty = function () { return null; };
var isNotEmptyArray = function (value) { return isPresent(value) && isArray(value) && value.length > 0; };
var isNotEmpty = function (accessor) { return function (value) { return isNotEmptyArray(accessor(value)); }; };
var runOrEmpty = function (predicate, fn) { return ifElse(predicate, fn, empty); };
var calcPage = function (_a) {
    var skip = _a.skip, take = _a.take;
    return Math.floor((skip || 0) / take) + 1;
};
var formatDescriptors = function (accessor, formatter) { return function (state) { return (accessor(state).map(formatter).join("~")); }; };
var removeAfter = function (what) { return function (str) { return str.slice(0, str.indexOf(what)); }; };
var replace = function (patterns) {
    return compose.apply(void 0, patterns.map(function (_a) {
        var left = _a[0], right = _a[1];
        return function (s) { return s.replace(new RegExp(left, "g"), right); };
    }));
};
var sanitizeDateLiterals = replace([["\"", ""], [":", "-"]]);
var removeAfterDot = removeAfter(".");
var directionFormatter = function (_a) {
    var field = _a.field, _b = _a.dir, dir = _b === void 0 ? "asc" : _b;
    return field + "-" + dir;
};
var aggregateFormatter = function (_a) {
    var field = _a.field, aggregate = _a.aggregate;
    return field + "-" + aggregate;
};
var take = getter("take");
var aggregates$1 = getter("aggregates");
getter("skip");
var group = getter("group");
var sort = getter("sort", true);
var formatSort = formatDescriptors(sort, directionFormatter);
var formatGroup = formatDescriptors(group, directionFormatter);
var formatAggregates = formatDescriptors(aggregates$1, aggregateFormatter);
var prefixDateValue = function (value) { return "datetime'" + value + "'"; };
var formatDateValue = compose(prefixDateValue, removeAfterDot, sanitizeDateLiterals, JSON.stringify, toUTC);
var formatDate = function (_a) {
    var field = _a.field, value = _a.value, ignoreCase = _a.ignoreCase, operator = _a.operator;
    return ({
        value: formatDateValue(value),
        field: field,
        ignoreCase: ignoreCase,
        operator: operator
    });
};
var normalizeSort = function (state) { return Object.assign({}, state, {
    sort: (sort(state) || []).filter(function (_a) {
        var dir = _a.dir;
        return isNotNullOrEmptyString(dir);
    })
}); };
compose(pairwise('page'), calcPage);
compose(pairwise('pageSize'), take);
compose(pairwise('group'), formatGroup);
var transformSort = compose(pairwise('sort'), formatSort);
compose(pairwise('aggregate'), formatAggregates);
compose(runOrEmpty(isNotEmpty(sort), transformSort), normalizeSort);
var filterFormatter = function (_a) {
    var field = _a.field, operator = _a.operator, value = _a.value;
    return field + "~" + operator + "~" + value;
};
ifElse(isDateValue, compose(filterFormatter, formatDate), filterFormatter);

// tslint:enable:max-line-length
var set = function (field, target, value) {
    target[field] = value;
    return target;
};
var convert = function (mapper) { return function (values) { return Object.keys(values).reduce(mapper.bind(null, values), {}); }; };
var translateAggregate = convert(function (source, acc, field) { return set(field.toLowerCase(), acc, source[field]); });
var translateAggregates = convert(function (source, acc, field) { return set(field, acc, translateAggregate(source[field])); });
var valueOrDefault = function (value, defaultValue) { return isPresent(value) ? value : defaultValue; };
var normalizeGroup = function (group) { return ({
    aggregates: group.Aggregates || group.aggregates,
    field: group.Member || group.member || group.field,
    hasSubgroups: group.HasSubgroups || group.hasSubgroups || false,
    items: group.Items || group.items,
    value: valueOrDefault(group.Key, valueOrDefault(group.key, group.value))
}); };
var translateGroup = compose(function (_a) {
    var field = _a.field, hasSubgroups = _a.hasSubgroups, value = _a.value, aggregates = _a.aggregates, items = _a.items;
    return ({
        aggregates: translateAggregates(aggregates),
        field: field,
        items: hasSubgroups ? items.map(translateGroup) : items,
        value: value
    });
}, normalizeGroup);

var valueToString = function (value) {
    value = isPresent(value) && value.getTime ? value.getTime() : value;
    return value + "";
};
/**
 * @hidden
 */
var groupCombinator = function (field) {
    var prop = getter(field, true);
    var position = 0;
    return function (agg, value) {
        agg[field] = agg[field] || {};
        var groupValue = prop(value);
        var key = valueToString(groupValue);
        var values = agg[field][key] || { __position: position++, aggregates: {}, items: [], value: groupValue };
        values.items.push(value);
        agg[field][key] = values;
        return agg;
    };
};
/**
 * @hidden
 */
var expandAggregates = function (result) {
    if (result === void 0) { result = {}; }
    Object.keys(result).forEach(function (field) {
        var aggregates = result[field];
        Object.keys(aggregates).forEach(function (aggregate) {
            aggregates[aggregate] = aggregates[aggregate].result();
        });
    });
    return result;
};
var aggregatesFuncs = function (name) { return ({
    average: function () {
        var value = 0;
        var count = 0;
        return {
            calc: function (curr) {
                if (isNumeric(curr)) {
                    value += curr;
                    count++;
                }
                else {
                    value = curr;
                }
            },
            result: function () { return isNumeric(value) ? value / count : value; }
        };
    },
    count: function () {
        var state = 0;
        return {
            calc: function () { return state++; },
            result: function () { return state; }
        };
    },
    max: function () {
        var state = Number.NEGATIVE_INFINITY;
        return {
            calc: function (value) {
                state = isNumeric(state) || isDate(state) ? state : value;
                if (state < value && (isNumeric(value) || isDate(value))) {
                    state = value;
                }
            },
            result: function () { return state; }
        };
    },
    min: function () {
        var state = Number.POSITIVE_INFINITY;
        return {
            calc: function (value) {
                state = isNumeric(state) || isDate(state) ? state : value;
                if (state > value && (isNumeric(value) || isDate(value))) {
                    state = value;
                }
            },
            result: function () { return state; }
        };
    },
    sum: function () {
        var state = 0;
        return {
            calc: function (value) {
                value = isPresent(value) ? value : 0;
                state += value;
            },
            result: function () { return state; }
        };
    }
}[name]()); };
/**
 * @hidden
 */
var aggregatesCombinator = function (descriptors) {
    var functions = descriptors.map(function (descriptor) {
        var fieldAccessor = getter(descriptor.field, true);
        var aggregateName = (descriptor.aggregate || "").toLowerCase();
        var aggregateAccessor = getter(aggregateName, true);
        return function (state, value) {
            var fieldAggregates = state[descriptor.field] || {};
            var aggregateFunction = aggregateAccessor(fieldAggregates)
                || aggregatesFuncs(aggregateName);
            aggregateFunction.calc(fieldAccessor(value));
            fieldAggregates[descriptor.aggregate] = aggregateFunction;
            state[descriptor.field] = fieldAggregates;
            return state;
        };
    });
    return function (state, value) { return functions.reduce(function (agg, calc) { return calc(agg, value); }, state); };
};
/**
 * @hidden
 * Returns a reducer that will apply the specified transformation to the value.
 */
var map = function (transform) { return (function (reduce) { return (function (acc, curr, index) { return reduce(acc, transform(curr, index)); }); }); };
/**
 * @hidden
 */
var isTransformerResult = function (source) {
    return isPresent(source.__value);
};
/**
 * @hidden
 * Transforms the data by applying the supplied transformer.
 */
var exec = function (transform, initialValue, data) {
    var result = initialValue;
    for (var idx = 0, length_1 = data.length; idx < length_1; idx++) {
        result = transform(result, data[idx], idx);
        if (isTransformerResult(result)) {
            result = result.__value;
            break;
        }
    }
    return result;
};

var identity$1 = map(function (x) { return x; });
// tslint:disable:max-line-length
/**
 * Applies the specified [AggregateDescriptors]({% slug api_kendo-data-query_aggregatedescriptor %}) to the data. Returns an [AggregateResult]({% slug api_kendo-data-query_aggregateresult %}) instance.
 *
 * @example
 * ```ts
 * const data = [
 *    { unitPrice: 23, unitsInStock: 21 },
 *    { unitPrice: 10, unitsInStock: 12 },
 *    { unitPrice: 20, unitsInStock: 33 }
 * ];
 *
 * const result = aggregateBy(data, [
 *   { aggregate: "sum", field: "unitPrice" },
 *   { aggregate: "sum", field: "unitsInStock" }
 * ]);
 *
 * //output:
 * // {
 * //     "unitPrice": { "sum": 53 },
 * //     "unitsInStock": { "sum": 66 }
 * // }
 * ```
 * @param {T[]} data - The data on which the calculation will be executed.
 * @param {AggregateDescriptor[]} descriptors - The aggregate operations that will be executed.
 * @param {any} transformers - For internal use.
 * @returns {AggregateResult} - The aggregated result.
 * For more information, refer to the [aggregateresult]({% slug api_kendo-data-query_aggregateresult %}) configuration.
 */
// tslint:enable:max-line-length
var aggregateBy = function (data, descriptors, transformers) {
    if (descriptors === void 0) { descriptors = []; }
    if (transformers === void 0) { transformers = identity$1; }
    var initialValue = {};
    if (!descriptors.length) {
        return initialValue;
    }
    var result = exec(transformers(aggregatesCombinator(descriptors)), initialValue, data);
    return expandAggregates(result);
};

var logic = {
    "or": {
        concat: function (acc, fn) { return function (a) { return acc(a) || fn(a); }; },
        identity: function () { return false; }
    },
    "and": {
        concat: function (acc, fn) { return function (a) { return acc(a) && fn(a); }; },
        identity: function () { return true; }
    }
};
var operatorsMap = {
    contains: function (a, b) { return (a || "").indexOf(b) >= 0; },
    doesnotcontain: function (a, b) { return (a || "").indexOf(b) === -1; },
    doesnotendwith: function (a, b) { return (a || "").indexOf(b, (a || "").length - (b || "").length) < 0; },
    doesnotstartwith: function (a, b) { return (a || "").lastIndexOf(b, 0) === -1; },
    endswith: function (a, b) { return (a || "").indexOf(b, (a || "").length - (b || "").length) >= 0; },
    eq: function (a, b) { return a === b; },
    gt: function (a, b) { return a > b; },
    gte: function (a, b) { return a >= b; },
    isempty: function (a) { return a === ''; },
    isnotempty: function (a) { return a !== ''; },
    isnotnull: function (a) { return isPresent(a); },
    isnull: function (a) { return isBlank(a); },
    lt: function (a, b) { return a < b; },
    lte: function (a, b) { return a <= b; },
    neq: function (a, b) { return a != b; },
    startswith: function (a, b) { return (a || "").lastIndexOf(b, 0) === 0; }
};
var dateRegExp = /^\/Date\((.*?)\)\/$/;
var convertValue = function (value, ignoreCase) {
    if (value != null && isString(value)) {
        var date = dateRegExp.exec(value);
        if (date) {
            return new Date(+date[1]).getTime();
        }
        else if (ignoreCase) {
            return value.toLowerCase();
        }
    }
    else if (value != null && isDate(value)) {
        return value.getTime();
    }
    return value;
};
var typedGetter = function (prop, value, ignoreCase) {
    if (!isPresent(value)) {
        return prop;
    }
    var acc = prop;
    if (isString(value)) {
        var date = dateRegExp.exec(value);
        if (date) {
            value = new Date(+date[1]);
        }
        else {
            acc = function (a) {
                var x = prop(a);
                if (typeof x === 'string' && ignoreCase) {
                    return x.toLowerCase();
                }
                else {
                    return isNumeric(x) ? x + "" : x;
                }
            };
        }
    }
    if (isDate(value)) {
        return function (a) {
            var x = acc(a);
            return isDate(x) ? x.getTime() : x;
        };
    }
    return acc;
};
var transformFilter = function (_a) {
    var field = _a.field, ignoreCase = _a.ignoreCase, value = _a.value, operator = _a.operator;
    field = !isPresent(field) ? function (a) { return a; } : field;
    ignoreCase = isPresent(ignoreCase) ? ignoreCase : true;
    var itemProp = typedGetter(isFunction(field) ? field : getter(field, true), value, ignoreCase);
    value = convertValue(value, ignoreCase);
    var op = isFunction(operator) ? operator : operatorsMap[operator];
    return function (a) { return op(itemProp(a), value, ignoreCase); };
};
/**
 * @hidden
 */
var transformCompositeFilter = function (filter) {
    var combiner = logic[filter.logic];
    return filter.filters
        .filter(isPresent)
        .map(function (x) { return isCompositeFilterDescriptor(x) ? transformCompositeFilter(x) : transformFilter(x); })
        .reduce(combiner.concat, combiner.identity);
};

// tslint:disable:max-line-length
/**
 * Creates a [Predicate]({% slug api_kendo-data-query_predicate %}) function for the specified [CompositeFilterDescriptor]({% slug api_kendo-data-query_compositefilterdescriptor %}).
 *
 * @param {CompositeFilterDescriptor} descriptor - The descriptor for which the predicate is created.
 * @returns {Predicate} - The created function instance.
 *
 * @example
 * ```ts
 * import { compileFilter } from '@progress/kendo-data-query';
 *
 * const data = [{ name: "Pork" }, { name: "Pepper" }, { name: "Beef" } ];
 * const predicate = compileFilter({ logic: "and", filters: [{ field: "name", operator: "startswith", value: "P" }] });
 * const result = data.filter(predicate);
 *
 * ```
 */
// tslint:enable:max-line-length
var compileFilter = function (descriptor) {
    if (!descriptor || descriptor.filters.length === 0) {
        return function () { return true; };
    }
    return transformCompositeFilter(descriptor);
};
// tslint:disable:max-line-length
/**
 * Filters the provided array according to the specified [CompositeFilterDescriptor]({% slug api_kendo-data-query_compositefilterdescriptor %}).
 *
 * @param {T[]} data - The data that will be filtered.
 * @param {(CompositeFilterDescriptor | FilterDescriptor)} descriptor - The filter criteria that will be applied.
 * @returns {T[]} - The filtered data.
 *
 * @example
 * ```ts
 * import { filterBy } from '@progress/kendo-data-query';
 *
 * const data = [
 *  { name: "Pork", category: "Food", subcategory: "Meat" },
 *  { name: "Pepper", category: "Food", subcategory: "Vegetables" },
 *  { name: "Beef", category: "Food", subcategory: "Meat" }
 * ];
 *
 * const result = filterBy(data, {
 *     logic: 'and',
 *     filters: [
 *           { field: "name", operator: "startswith", value: "p", ignoreCase: true },
 *           { field: "subcategory", operator: "eq", value: "Meat" },
 *     ]
 * });
 *
 * // output:
 * // [{ "name": "Pork", "category": "Food", "subcategory": "Meat" }]
 * ```
 */
// tslint:enable:max-line-length
var filterBy = function (data, descriptor) {
    if (!isPresent(descriptor) || (isCompositeFilterDescriptor(descriptor) && descriptor.filters.length === 0)) {
        return data;
    }
    return data.filter(compileFilter(normalizeFilters(descriptor)));
};

/**
 * @hidden
 */
var normalizeGroups = function (descriptors) {
    descriptors = isArray(descriptors) ? descriptors : [descriptors];
    return descriptors.map(function (x) { return Object.assign({ dir: "asc" }, x); });
};
var identity = map(function (x) { return x; });
/**
 * Groups the provided data according to the specified descriptors.
 *
 * @param {Array} data - The data that will be grouped.
 * @param {GroupDescriptor[]} descriptors - The descriptors.
 * @param {any} transformers - For internal use.
 * @param {Array} originalData - For internal use.
 * @returns {(Array<GroupResult<T>> | T[])} - The grouped data.
 *
 * @example
 * ```ts
 *
 * import { groupBy } from '@progress/kendo-data-query';
 *
 * const data = [
 *     { name: "Pork", category: "Food", subcategory: "Meat" },
 *     { name: "Pepper", category: "Food", subcategory: "Vegetables" },
 *     { name: "Beef", category: "Food", subcategory: "Meat" }
 * ];
 *
 * const result = groupBy(data, [{ field: "subcategory" }]);
 * ```
 */
var groupBy = function (data, descriptors, transformers, originalData) {
    if (descriptors === void 0) { descriptors = []; }
    if (transformers === void 0) { transformers = identity; }
    if (originalData === void 0) { originalData = data; }
    descriptors = normalizeGroups(descriptors);
    if (!descriptors.length) {
        return data;
    }
    var descriptor = descriptors[0];
    var initialValue = {};
    var view = exec(transformers(groupCombinator(descriptor.field)), initialValue, data);
    var result = [];
    Object.keys(view).forEach(function (field) {
        Object.keys(view[field]).forEach(function (value) {
            var group = view[field][value];
            var aggregateResult = {};
            var filteredData = originalData;
            if (isPresent(descriptor.aggregates)) {
                filteredData = filterBy(originalData, {
                    field: descriptor.field,
                    ignoreCase: false,
                    operator: 'eq',
                    value: group.value
                });
                aggregateResult = aggregateBy(filteredData, descriptor.aggregates);
            }
            result[group.__position] = {
                aggregates: aggregateResult,
                field: field,
                items: descriptors.length > 1 ?
                    groupBy(group.items, descriptors.slice(1), identity, filteredData)
                    : group.items,
                value: group.value
            };
        });
    });
    return result;
};

/**
 * Represents the list of supported [`FilterDescriptor`]({% slug api_kendo-data-query_filterdescriptor %}) operators.
 * Allows restricting `FilterDescriptor.operator` definition to available values only.
 */
var FilterOperator;
(function (FilterOperator) {
    /**
     * The `contains` operator.
     */
    FilterOperator["Contains"] = "contains";
    /**
     * The `doesnotcontain` operator.
     */
    FilterOperator["DoesNotContain"] = "doesnotcontain";
    /**
     * The `doesnotendwith` operator.
     */
    FilterOperator["DoesNotEndWith"] = "doesnotendwith";
    /**
     * The `doesnotstartwith` operator.
     */
    FilterOperator["DoesNotStartWith"] = "doesnotstartwith";
    /**
     * The `endswith` operator.
     */
    FilterOperator["EndsWith"] = "endswith";
    /**
     * The `eq` operator.
     */
    FilterOperator["EqualTo"] = "eq";
    /**
     * The `gt` operator.
     */
    FilterOperator["GreaterThan"] = "gt";
    /**
     * The `gte` operator.
     */
    FilterOperator["GreaterThanOrEqual"] = "gte";
    /**
     * The `isempty` operator.
     */
    FilterOperator["IsEmpty"] = "isempty";
    /**
     * The `isnotempty` operator.
     */
    FilterOperator["IsNotEmpty"] = "isnotempty";
    /**
     * The `isnotnull` operator.
     */
    FilterOperator["IsNotNull"] = "isnotnull";
    /**
     * The `isnull` operator.
     */
    FilterOperator["IsNull"] = "isnull";
    /**
     * The `lt` operator.
     */
    FilterOperator["LessThan"] = "lt";
    /**
     * The `lte` operator.
     */
    FilterOperator["LessThanOrEqual"] = "lte";
    /**
     * The `neq` operator.
     */
    FilterOperator["NotEqualTo"] = "neq";
    /**
     * The `startswith` operator.
     */
    FilterOperator["StartsWith"] = "startswith";
})(FilterOperator || (FilterOperator = {}));

var GROUP_ID_FIELD = 'groupId';
var GROUP_SUBITEMS_COLLECTION = 'items';
/**
 * @hidden
 */
var setGroupId = function (group, depth, parentValue) {
    if (group.items) {
        group[GROUP_ID_FIELD] = "".concat(parentValue).concat(parentValue && '_').concat(group.value).concat(group.field);
        if (depth > 1) {
            group.items.forEach(function (item) { return setGroupId(item, depth - 1, group[GROUP_ID_FIELD]); });
        }
    }
};
/**
 * Add unique ids to the group items inside data.
 *
 * @param {{data: any[], group: GroupDescriptor[]}} options - The options to be processed.
 */
var setGroupIds = function (options) {
    var group = options.group;
    if (group && group.length && options.data) {
        return options.data.forEach(function (item) { return setGroupId(item, group.length, ''); });
    }
};
/**
 * Apply the `expanded` prop to the group items in data based on the provided collection of group ids.
 *
 * @param {{data: any[], collapsedIds: string[]}} options - The options to be processed.
 * @returns {string[]} - Collection of all group ids from the data.
 */
var setExpandedState = function (options) {
    // TODO: no need to traverse whole tree, only group levels
    return mapTree(options.data, GROUP_SUBITEMS_COLLECTION, function (item) {
        return extendDataItem(item, GROUP_SUBITEMS_COLLECTION, {
            expanded: !options.collapsedIds.some(function (groupId) { return groupId === item[GROUP_ID_FIELD]; })
        });
    });
};

var __spreadArray$4 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
var onConstructor = function (options) {
    var navigatable = options.navigatable, contextStateRef = options.contextStateRef, navigationStateRef = options.navigationStateRef, idPrefix = options.idPrefix;
    // v.2: check if nested navigation
    if (navigatable) {
        contextStateRef.current = {
            activeId: '',
            level: 0
        };
        navigationStateRef.current = {
            activeElementIsFocused: false,
            prevNavigationIndexes: undefined,
            idPrefix: idPrefix || guid$1(),
            navigationMatrix: [],
            lastHeaderIndex: -1
        };
    }
};
/**
 * @hidden
 */
var onComponentDidMount = function (options) {
    var scope = options.scope, contextStateRef = options.contextStateRef, navigationStateRef = options.navigationStateRef;
    if (contextStateRef.current && navigationStateRef.current && scope) {
        generateMatrix(options);
        var firstId = navigationStateRef.current.navigationMatrix[0][0];
        var firstIdElement = tableKeyboardNavigationTools.getActiveElement(scope, firstId);
        if (firstId && firstIdElement) {
            contextStateRef.current.activeId = firstId;
            firstIdElement.setAttribute('tabIndex', '0');
        }
    }
};
/**
 * @hidden
 */
var onGetSnapshotBeforeUpdate = function (options) {
    var contextStateRef = options.contextStateRef, navigationStateRef = options.navigationStateRef, currentDocument = options.document;
    if (contextStateRef.current && navigationStateRef.current && currentDocument) {
        var activeElement = currentDocument.activeElement;
        var activeId = tableKeyboardNavigationTools.getNavigatableId(activeElement);
        if (activeId && activeId === contextStateRef.current.activeId) {
            navigationStateRef.current.activeElementIsFocused = true;
        }
    }
};
/**
 * @hidden
 */
var onComponentDidUpdate = function (options) {
    var scope = options.scope, contextStateRef = options.contextStateRef, navigationStateRef = options.navigationStateRef;
    generateMatrix(options);
    // check if nested navigation
    if (contextStateRef.current && navigationStateRef.current && scope) {
        var activeElement = tableKeyboardNavigationTools.getActiveElement(scope, contextStateRef.current.activeId);
        if (!activeElement) {
            var firstId = navigationStateRef.current.navigationMatrix[0][0];
            var firstIdElement = tableKeyboardNavigationTools.getActiveElement(scope, firstId);
            if (firstId && firstIdElement) {
                contextStateRef.current.activeId = firstId;
                firstIdElement.setAttribute('tabIndex', '0');
                if (navigationStateRef.current.activeElementIsFocused) {
                    firstIdElement.focus();
                }
            }
        }
        navigationStateRef.current.activeElementIsFocused = false;
    }
};
/**
 * @hidden
 */
var onFocus = function (event, options) {
    var contextStateRef = options.contextStateRef;
    if (event.isDefaultPrevented()) {
        return;
    }
    if (!contextStateRef.current) {
        return;
    }
    var focusedElement = event.target;
    var activeId = tableKeyboardNavigationTools.getNavigatableId(focusedElement);
    if (activeId && activeId !== contextStateRef.current.activeId) {
        var scope = tableKeyboardNavigationTools.getClosestScope(focusedElement);
        if (!scope) {
            return;
        }
        var prevElement = tableKeyboardNavigationTools.getActiveElement(scope, contextStateRef.current.activeId);
        if (prevElement) {
            prevElement.setAttribute('tabIndex', '-1');
        }
        focusedElement.setAttribute('tabIndex', '0');
        contextStateRef.current.activeId = activeId;
    }
};
/**
 * @hidden
 */
var onKeyDown = function (event, options) {
    var contextStateRef = options.contextStateRef, navigationStateRef = options.navigationStateRef, onNavigationAction = options.onNavigationAction;
    if (event.isDefaultPrevented()) {
        return;
    }
    if (!contextStateRef.current || !navigationStateRef.current) {
        return;
    }
    if (event.keyCode === Keys$1.esc) {
        // activate navigation
        var elementForFocus = tableKeyboardNavigationTools.getClosestNavigatableElement(event.target);
        tableKeyboardNavigationTools.focusElement({ elementForFocus: elementForFocus, event: event, contextStateRef: contextStateRef });
        return;
    }
    var element = event.target;
    var elementId = tableKeyboardNavigationTools.getNavigatableId(element);
    var dataLevel = tableKeyboardNavigationTools.getNavigatableLevel(element);
    var scope = tableKeyboardNavigationTools.getClosestScope(element);
    var matrix = navigationStateRef.current.navigationMatrix;
    if (dataLevel !== undefined && scope) {
        if (event.keyCode === Keys$1.enter) {
            // activate nested navigation or focus focusable element
            var navigatableElement = tableKeyboardNavigationTools.getNavigatableElement(element, { level: dataLevel + 1 });
            if (navigatableElement) {
                tableKeyboardNavigationTools.focusElement({
                    elementForFocus: navigatableElement,
                    event: event,
                    contextStateRef: contextStateRef,
                    prevElement: element
                });
                return;
            }
            else {
                var elementForFocus = tableKeyboardNavigationTools.getFocusableElements(element)[0];
                tableKeyboardNavigationTools.focusElement({ elementForFocus: elementForFocus, event: event, contextStateRef: contextStateRef, prevElement: element });
                return;
            }
        }
        if (event.keyCode === Keys$1.up ||
            event.keyCode === Keys$1.down ||
            event.keyCode === Keys$1.left ||
            event.keyCode === Keys$1.right) {
            var isReverse = event.keyCode === Keys$1.up || event.keyCode === Keys$1.left;
            var isVertical = event.keyCode === Keys$1.up || event.keyCode === Keys$1.down;
            var currentIdIndexes = void 0;
            if (navigationStateRef.current && navigationStateRef.current.prevNavigationIndexes) {
                var _a = navigationStateRef.current.prevNavigationIndexes, rowIndex = _a[0], cellIndex = _a[1];
                if (matrix[rowIndex][cellIndex] === elementId) {
                    currentIdIndexes = navigationStateRef.current.prevNavigationIndexes;
                }
                else {
                    currentIdIndexes = findId(matrix, elementId);
                }
            }
            else {
                currentIdIndexes = findId(matrix, elementId);
            }
            if (currentIdIndexes) {
                var rowIndex = currentIdIndexes[0], cellIndex = currentIdIndexes[1];
                var _b = isVertical ?
                    findNextIdByRowIndex(rowIndex, cellIndex, elementId, matrix, isReverse) :
                    findNextIdByCellIndex(rowIndex, cellIndex, elementId, matrix, isReverse), idForFocus = _b[0], currentIndexes = _b[1];
                if (idForFocus) {
                    var elementForFocus = tableKeyboardNavigationTools.getActiveElement(scope, idForFocus);
                    // emit event
                    tableKeyboardNavigationTools.focusElement({ elementForFocus: elementForFocus, event: event, contextStateRef: contextStateRef, prevElement: element });
                    navigationStateRef.current.prevNavigationIndexes = currentIndexes;
                    if (onNavigationAction) {
                        onNavigationAction({ focusElement: elementForFocus, event: event });
                    }
                }
            }
        }
    }
};
/**
 * @hidden
 */
var generateMatrix = function (options) {
    var navigationStateRef = options.navigationStateRef, scope = options.scope;
    if (!navigationStateRef.current || !scope) {
        return;
    }
    var matrix = [];
    var thead = getHeaderElement(scope);
    var tbody = getBodyElement(scope);
    if (!thead || !tbody) {
        return;
    }
    var headerRows = Array.from(thead.children);
    var bodyRows = Array.from(tbody.children);
    __spreadArray$4(__spreadArray$4([], headerRows, true), bodyRows, true).forEach(function (row, rowIndex) {
        Array.from(row.children).forEach(function (cell) {
            var cellId = getNavigatableId(cell);
            if (!cellId) {
                return;
            } // cell is not navigatable
            var rowSpan = cell.rowSpan || 1;
            var cellSpan = cell.colSpan || 1;
            var cellIndex;
            for (var depth = rowIndex, maxDepth = rowIndex + rowSpan; depth < maxDepth; depth++) {
                if (!matrix[depth]) {
                    matrix[depth] = [];
                }
                if (cellIndex === undefined) {
                    var freeSlotIndex = matrix[depth].findIndex(function (mi) { return !mi; });
                    cellIndex = freeSlotIndex > -1 ? freeSlotIndex : matrix[depth].length;
                }
                matrix[depth][cellIndex] = cellId || '';
            }
            for (var depth = cellIndex + 1, maxDepth = cellIndex + cellSpan; depth < maxDepth; depth++) {
                matrix[rowIndex][depth] = cellId || '';
            }
        });
    });
    navigationStateRef.current.navigationMatrix = matrix.filter(function (row) { return !!row; });
    navigationStateRef.current.lastHeaderIndex = headerRows.length - 1;
};
/**
 * @hidden
 */
var tableKeyboardNavigation = {
    onConstructor: onConstructor,
    onComponentDidMount: onComponentDidMount,
    onGetSnapshotBeforeUpdate: onGetSnapshotBeforeUpdate,
    onComponentDidUpdate: onComponentDidUpdate,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    generateMatrix: generateMatrix
};

/** @hidden */
var TABLE_ROW_INDEX_ATTRIBUTE = 'data-grid-row-index';
/** @hidden */
var TABLE_COL_INDEX_ATTRIBUTE = 'data-grid-col-index';
/** @hidden */
var TABLE_PREVENT_SELECTION_ELEMENT = 'data-prevent-selection';

var __assign$q = (undefined && undefined.__assign) || function () {
    __assign$q = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$q.apply(this, arguments);
};
(undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** @hidden */
var closestTagName = function (target, tagName) {
    var currentTarget = target;
    while (currentTarget) {
        if (currentTarget.tagName === tagName) {
            return currentTarget;
        }
        else if (currentTarget.tagName === 'TABLE') {
            return null;
        }
        currentTarget = currentTarget.parentElement;
    }
    return null;
};
/** @hidden */
var getRowIndex = function (element) {
    if (!element) {
        return;
    }
    var rowIndex = element.getAttribute(TABLE_ROW_INDEX_ATTRIBUTE);
    return rowIndex ? parseInt(rowIndex, 10) : undefined;
};
/** @hidden */
var getColumnIndex = function (element) {
    if (!element) {
        return;
    }
    var colIndex = element.getAttribute(TABLE_COL_INDEX_ATTRIBUTE);
    return colIndex ? parseInt(colIndex, 10) : undefined;
};
/** @hidden */
var HAS_RELATIVE_STACKING_CONTEXT = hasRelativeStackingContext$1();
/** @hidden */
var relativeContextElement = function (element) {
    if (!element || !HAS_RELATIVE_STACKING_CONTEXT) {
        return null;
    }
    var node = element.parentElement;
    while (node) {
        if (window.getComputedStyle(node).transform !== 'none') {
            return node;
        }
        node = node.parentElement;
    }
};
/** @hidden */
var getOffset = function (offsetParent) {
    if (offsetParent && offsetParent.ownerDocument) {
        if (offsetParent !== offsetParent.ownerDocument.body) {
            var rect = offsetParent.getBoundingClientRect();
            return {
                left: rect.left - offsetParent.scrollLeft,
                top: rect.top - offsetParent.scrollTop
            };
        }
    }
    return { left: 0, top: 0 };
};
/** @hidden */
var getSelectionOptions = function (selectable) {
    var enabled = selectable ?
        (typeof selectable.enabled === 'boolean' ? selectable.enabled : true) :
        false;
    var drag = selectable ? Boolean(selectable.drag) : false;
    var mode = selectable && selectable.mode ? selectable.mode : 'multiple';
    var cell = Boolean(selectable && selectable.cell);
    return { enabled: enabled, drag: drag, mode: mode, cell: cell };
};

var __assign$p = (undefined && undefined.__assign) || function () {
    __assign$p = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$p.apply(this, arguments);
};
/** @hidden */
var TableSelection = function (props) {
    var onRelease = props.onRelease, childRef = props.childRef;
    var _a = getSelectionOptions(props.selectable), selectionEnabled = _a.enabled, selectionDrag = _a.drag, selectionMode = _a.mode, selectionCell = _a.cell;
    var draggableRef = React.useRef(null);
    var overlayElementRef = React.useRef(null);
    var dragStartRef = React.useRef({ clientX: 0, clientY: 0 });
    var _b = React.useState(null), overlaySettings = _b[0], setOverlaySettings = _b[1];
    var offsetParentRef = React.useRef();
    var isDraggedRef = React.useRef(false);
    var isPreventedRef = React.useRef(false);
    var onPressHandler = React.useCallback(function (eventData) {
        var event = eventData.event;
        isPreventedRef.current = event.originalEvent.target.hasAttribute(TABLE_PREVENT_SELECTION_ELEMENT);
        if (isPreventedRef.current || !draggableRef.current) {
            return;
        }
        offsetParentRef.current = relativeContextElement(draggableRef.current.element);
        dragStartRef.current = {
            clientY: event.clientY,
            clientX: event.clientX
        };
    }, []);
    var onDragHandler = React.useCallback(function (eventData) {
        var event = eventData.event;
        var _a = dragStartRef.current, clientX = _a.clientX, clientY = _a.clientY;
        if (isPreventedRef.current) {
            return;
        }
        if (!selectionDrag || selectionMode === 'single') {
            return;
        }
        if (Math.abs(clientY - event.clientY) > 5 || Math.abs(clientX - event.clientX) > 5) {
            isDraggedRef.current = true;
        }
        if (isDraggedRef.current) {
            var offset = getOffset(offsetParentRef.current);
            setOverlaySettings({
                top: Math.min(clientY, event.clientY) - offset.top,
                left: Math.min(clientX, event.clientX) - offset.left,
                width: Math.abs(event.clientX - clientX),
                height: Math.abs(event.clientY - clientY)
            });
        }
    }, [setOverlaySettings, selectionDrag, selectionMode]);
    var onReleaseHandler = React.useCallback(function (eventData) {
        var event = eventData.event;
        var _a = dragStartRef.current, clientX = _a.clientX, clientY = _a.clientY;
        if (isPreventedRef.current || !draggableRef.current) {
            return;
        }
        var currentDocument = draggableRef.current.element && draggableRef.current.element.ownerDocument;
        if (!currentDocument) {
            return;
        }
        if (!isDraggedRef.current) {
            var startElement = currentDocument.elementFromPoint(clientX, clientY);
            if (!startElement) {
                return;
            }
            var tdElement = closestTagName(startElement, 'TD');
            var trElement = closestTagName(startElement, 'TR');
            var colIndex = getColumnIndex(tdElement);
            var rowIndex = getRowIndex(trElement);
            if (tdElement && trElement && rowIndex !== undefined && colIndex !== undefined) {
                onRelease({
                    nativeEvent: event.originalEvent,
                    startRowIndex: rowIndex,
                    startColIndex: colIndex,
                    endRowIndex: rowIndex,
                    endColIndex: colIndex,
                    altKey: event.altKey,
                    shiftKey: event.shiftKey,
                    ctrlKey: event.ctrlKey,
                    metaKey: event.metaKey,
                    mode: selectionMode,
                    cell: selectionCell,
                    isDrag: false
                });
            }
        }
        else {
            var top_1 = Math.min(clientY, event.clientY);
            var left = Math.min(clientX, event.clientX);
            var bottom = Math.max(clientY, event.clientY);
            var right = Math.max(clientX, event.clientX);
            var overlayElement = overlayElementRef.current;
            if (!overlayElement) {
                return;
            }
            overlayElement.style.visibility = 'hidden';
            var startElement = currentDocument.elementFromPoint(left, top_1);
            var endElement = currentDocument.elementFromPoint(right, bottom);
            overlayElement.style.visibility = '';
            if (!startElement || !endElement) {
                return;
            }
            var startTdElement = closestTagName(startElement, 'TD');
            var startTrElement = closestTagName(startTdElement, 'TR');
            var endTdElement = closestTagName(endElement, 'TD');
            var endTrElement = closestTagName(endTdElement, 'TR');
            var startColIndex = getColumnIndex(startTdElement);
            var startRowIndex = getRowIndex(startTrElement);
            var endColIndex = getColumnIndex(endTdElement);
            var endRowIndex = getRowIndex(endTrElement);
            if (startColIndex !== undefined &&
                startRowIndex !== undefined &&
                endColIndex !== undefined &&
                endRowIndex !== undefined) {
                onRelease({
                    nativeEvent: event.originalEvent,
                    startRowIndex: startRowIndex,
                    startColIndex: startColIndex,
                    endRowIndex: endRowIndex,
                    endColIndex: endColIndex,
                    altKey: event.altKey,
                    shiftKey: event.shiftKey,
                    ctrlKey: event.ctrlKey,
                    metaKey: event.metaKey,
                    mode: selectionMode,
                    cell: selectionCell,
                    isDrag: true
                });
            }
        }
        setOverlaySettings(null);
        isDraggedRef.current = false;
        dragStartRef.current = { clientX: 0, clientY: 0 };
    }, [setOverlaySettings, selectionMode, selectionCell, onRelease]);
    if (!selectionEnabled) {
        return (React.cloneElement(React.Children.only(props.children), { ref: childRef }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Draggable, { onPress: onPressHandler, onDrag: onDragHandler, onRelease: onReleaseHandler, ref: draggableRef, childRef: childRef }, props.children),
        overlaySettings &&
            React.createElement("div", { ref: overlayElementRef, style: __assign$p(__assign$p({}, overlaySettings), { position: 'fixed' }), className: 'k-marquee k-marquee-color' })));
};

/**
 * @hidden
 */
var GridColumn = function (_) { return null; };
/**
 * @hidden
 */
GridColumn.displayName = 'KendoReactGridColumn';
/**
 * @hidden
 */
GridColumn.defaultProps = {
    filterable: true,
    editable: true,
    sortable: true,
    resizable: true,
    reorderable: true,
    groupable: true
};
/**
 * @hidden
 */
GridColumn.propTypes = {
    field: propTypes.exports.string,
    title: propTypes.exports.string,
    editable: propTypes.exports.bool,
    sortable: propTypes.exports.oneOfType([
        propTypes.exports.bool,
        propTypes.exports.shape({
            allowUnsort: propTypes.exports.bool.isRequired
        })
    ]),
    cell: propTypes.exports.any,
    filterCell: propTypes.exports.any,
    filterTitle: propTypes.exports.string,
    filterable: propTypes.exports.bool,
    filter: propTypes.exports.oneOf(['text', 'numeric', 'boolean', 'date']),
    editor: propTypes.exports.oneOf(['text', 'numeric', 'boolean', 'date']),
    width: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    minResizableWidth: propTypes.exports.number,
    headerCell: propTypes.exports.any,
    footerCell: propTypes.exports.any,
    headerSelectionValue: propTypes.exports.bool,
    format: propTypes.exports.string,
    headerClassName: propTypes.exports.string,
    className: propTypes.exports.string,
    reorderable: propTypes.exports.bool,
    resizable: propTypes.exports.bool,
    orderIndex: propTypes.exports.number,
    groupable: propTypes.exports.bool,
    columnMenu: propTypes.exports.any,
    locked: propTypes.exports.bool
};

var __assign$o = (undefined && undefined.__assign) || function () {
    __assign$o = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$o.apply(this, arguments);
};
var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @hidden
 */
function getNestedValue(fieldName, dataItem) {
    var path = (fieldName || '').split('.');
    var data = dataItem;
    path.forEach(function (p) {
        data = data ? data[p] : undefined;
    });
    return data;
}
/**
 * @hidden
 */
function flatData(output, input, footer, dataIndex, groupDefined, field, level) {
    if (level === void 0) { level = 0; }
    var maxLevel = level;
    for (var i = 0; i < input.length; i++) {
        if (!groupDefined || input[i].value === undefined || input[i].items === undefined) {
            output[output.length] = {
                dataIndex: dataIndex.index,
                dataItem: input[i],
                rowType: 'data',
                level: level,
                expanded: field === undefined || getNestedValue(field, input[i])
            };
            dataIndex.index++;
            continue;
        }
        maxLevel = Math.max(maxLevel, level + 1);
        var expanded = field === undefined ||
            getNestedValue(field, input[i]) === undefined ||
            getNestedValue(field, input[i]);
        // header
        output[output.length] = {
            dataIndex: -1,
            dataItem: input[i],
            level: level,
            rowType: 'groupHeader',
            expanded: expanded
        };
        // children
        if (expanded) {
            maxLevel = Math.max(flatData(output, input[i].items, footer, dataIndex, groupDefined, field, level + 1), maxLevel);
        }
        // footer
        if (footer === 'always' || (expanded && footer === 'visible')) {
            output[output.length] = {
                dataIndex: -1,
                dataItem: input[i],
                rowType: 'groupFooter',
                level: level,
                expanded: expanded
            };
        }
    }
    return maxLevel;
}
/**
 * @hidden
 */
function readColumns(elements, oldColumns, idInfo, depth) {
    if (depth === void 0) { depth = 0; }
    var columns = [];
    if (!elements) {
        return [];
    }
    if (elements && elements.length === undefined) {
        elements = [elements];
    }
    elements.forEach(function (columnProps, index) {
        columnProps = columnProps.props ? columnProps.props : columnProps;
        var oldColumn = oldColumns[index] || null;
        var children = readColumns(columnProps.children, oldColumn && oldColumn.children || [], idInfo, depth + 1);
        columns.push(Object.assign({ depth: depth }, GridColumn.defaultProps, (children.length) ? { cell: function () { return null; }, filterCell: function () { return null; } } : {}, oldColumn ? { width: oldColumn.width, orderIndex: oldColumn.orderIndex } : {}, columnProps, {
            id: columnProps.id ? columnProps.id : tableKeyboardNavigationTools.generateNavigatableId("".concat(idInfo.prevId++), idInfo.idPrefix, 'column'),
            declarationIndex: columns.length,
            children: children,
            rowSpan: 0,
            colSpan: 0,
            isAccessible: true
        }));
    });
    var comparator = function (a, b) {
        return a.orderIndex === b.orderIndex ?
            a.declarationIndex - b.declarationIndex :
            ((a.orderIndex || 0) - (b.orderIndex || 0));
    };
    columns.sort(comparator);
    if (depth === 0) {
        var ret_1 = [];
        var flat_1 = function (cols, pIndex) {
            return cols.forEach(function (c) {
                c.parentIndex = pIndex;
                flat_1(c.children, ret_1.push(c) - 1);
            });
        };
        flat_1(columns, -1);
        return ret_1;
    }
    return columns;
}
/**
 * @hidden
 */
function autoGenerateColumns(data, group, expandField, idInfo) {
    var propData = [];
    if (Array.isArray(data)) {
        propData = data;
    }
    else if (data) {
        propData = data.data;
    }
    var columns = [];
    if (propData.length > 0) {
        var itemForColumnsGen = propData[0];
        if (group) {
            for (var i = 0; i < group.length; i++) {
                itemForColumnsGen = itemForColumnsGen.items && itemForColumnsGen.items[0];
            }
        }
        var fields = Object.getOwnPropertyNames(itemForColumnsGen);
        fields.forEach(function (field) {
            if (field !== expandField) {
                columns.push(Object.assign({
                    id: tableKeyboardNavigationTools.generateNavigatableId("".concat(idInfo.prevId++), idInfo.idPrefix, 'column'),
                    declarationIndex: -1,
                    parentIndex: -1,
                    depth: 0,
                    colSpan: 0,
                    rowSpan: 0,
                    index: 0,
                    left: 0,
                    right: 0,
                    rightBorder: false,
                    children: [],
                    ariaColumnIndex: 0,
                    isAccessible: true
                }, GridColumn.defaultProps, { field: field }));
            }
        });
    }
    return columns;
}
var hasParentFooterCell = function (columns, column) {
    var parent = columns[column.parentIndex];
    while (parent) {
        if (parent.footerCell) {
            return true;
        }
        parent = columns[parent.parentIndex];
    }
    return false;
};
/**
 * @hidden
 */
var footerColumns = function (columns) {
    return columns.filter(function (column) {
        if (hasParentFooterCell(columns, column)) {
            return false;
        }
        return Boolean(column.footerCell) || !(column.children && column.children.length > 0);
    });
};
/**
 * @hidden
 */
var sanitizeColumns = function (columns) {
    columns.sort(function (a, b) {
        return a.declarationIndex - b.declarationIndex;
    });
    return columns.map(function (column) {
        column.declarationIndex; column.parentIndex; column.depth; column.colSpan; column.rowSpan; column.index; column.kFirst; var children = column.children, props = __rest$2(column, ["declarationIndex", "parentIndex", "depth", "colSpan", "rowSpan", "index", "kFirst", "children"]);
        return children.length ? __assign$o({ children: sanitizeColumns(children) }, props) : props;
    });
};
/**
 * @hidden
 */
var firefox$1 = typeof window !== 'undefined' &&
    /Firefox/.test(window.navigator.userAgent);
/**
 * @hidden
 */
var firefoxMaxHeight = 17895697;

var __assign$n = (undefined && undefined.__assign) || function () {
    __assign$n = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$n.apply(this, arguments);
};
/**
 * @hidden
 */
var GridSelectionCell = function (props) {
    var handleOnChange = React.useCallback(function (syntheticEvent) {
        if (props.selectionChange) {
            props.selectionChange({ syntheticEvent: syntheticEvent });
        }
    }, [props.selectionChange]);
    var inputId = React.useMemo(function () { return guid$2(); }, []);
    var selectedValue = getNestedValue(props.field, props.dataItem);
    var navigationAttributes = useTableKeyboardNavigation(props.id);
    var defaultRendering = props.rowType !== 'groupHeader' ? (React.createElement("td", __assign$n({ colSpan: props.colSpan, style: props.style, className: props.className, "aria-colindex": props.ariaColumnIndex, role: 'gridcell' }, navigationAttributes),
        React.createElement("input", { checked: typeof selectedValue === 'boolean' && selectedValue, id: inputId, type: "checkbox", className: "k-checkbox k-checkbox-md k-rounded-md", onChange: handleOnChange }),
        React.createElement("label", { className: "k-checkbox-label", htmlFor: inputId }))) : null;
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
};

var _a;
/**
 * @hidden
 */
var noRecords = 'grid.noRecords';
/**
 * @hidden
 */
var pagerInfo = 'grid.pagerInfo';
/**
 * @hidden
 */
var pagerFirstPage = 'grid.pagerFirstPage';
/**
 * @hidden
 */
var pagerPreviousPage = 'grid.pagerPreviousPage';
/**
 * @hidden
 */
var pagerNextPage = 'grid.pagerNextPage';
/**
 * @hidden
 */
var pagerLastPage = 'grid.pagerLastPage';
/**
 * @hidden
 */
var pagerItemPerPage = 'grid.pagerItemsPerPage';
/**
 * @hidden
 */
var pagerPage = 'grid.pagerPage';
/**
 * @hidden
 */
var pagerOf = 'grid.pagerOf';
/**
 * @hidden
 */
var pagerTotalPages = 'grid.pagerTotalPages';
/**
 * @hidden
 */
var groupPanelEmpty = 'grid.groupPanelEmpty';
/**
 * @hidden
 */
var groupColumn = 'grid.groupColumn';
/**
 * @hidden
 */
var ungroupColumn = 'grid.ungroupColumn';
/**
 * @hidden
 */
var filterClearButton = 'grid.filterClearButton';
/**
 * @hidden
 */
var filterSubmitButton = 'grid.filterSubmitButton';
/**
 * @hidden
 */
var filterTitle = 'grid.filterTitle';
/**
 * @hidden
 */
var sortAscending = 'grid.sortAscending';
/**
 * @hidden
 */
var sortDescending = 'grid.sortDescending';
/**
 * @hidden
 */
var searchPlaceholder = 'grid.searchPlaceholder';
/**
 * @hidden
 */
var filterCheckAll = 'grid.filterCheckAll';
/**
 * @hidden
 */
var filterChooseOperator = 'grid.filterChooseOperator';
/**
 * @hidden
 */
var filterSelectedItems = 'grid.filterSelectedItems';
/**
 * @hidden
 */
var sortAriaLabel = 'grid.sortAriaLabel';
/**
 * @hidden
 */
var filterAriaLabel = 'grid.filterAriaLabel';
/**
 * @hidden
 */
var groupPanelAriaLabel = 'grid.groupPanelAriaLabel';
/**
 * @hidden
 */
var groupExpand = 'grid.groupExpand';
/**
 * @hidden
 */
var groupCollapse = 'grid.groupCollapse';
/**
 * @hidden
 */
var detailExpand = 'grid.detailExpand';
/**
 * @hidden
 */
var detailCollapse = 'grid.detailCollapse';
/**
 * @hidden
 */
var messages = (_a = {},
    _a[detailExpand] = 'Expand detail row',
    _a[detailCollapse] = 'Collapse detail row',
    _a[groupExpand] = 'Expand group',
    _a[groupCollapse] = 'Collapse Group',
    _a[noRecords] = 'No records available',
    _a[groupPanelEmpty] = 'Drag a column header and drop it here to group by that column',
    _a[filterClearButton] = 'Clear',
    _a[filterSubmitButton] = 'Filter',
    _a[filterTitle] = 'Filter',
    _a[sortAscending] = 'Sort Ascending',
    _a[sortDescending] = 'Sort Descending',
    _a[sortAriaLabel] = 'Sortable',
    _a[groupColumn] = 'Group Column',
    _a[ungroupColumn] = 'Ungroup Column',
    _a[pagerItemPerPage] = 'items per page',
    _a[pagerInfo] = '{0} - {1} of {2} items',
    _a[pagerFirstPage] = 'Go to the first page',
    _a[pagerPreviousPage] = 'Go to the previous page',
    _a[pagerNextPage] = 'Go to the next page',
    _a[pagerLastPage] = 'Go to the last page',
    _a[pagerPage] = 'Page',
    _a[pagerOf] = 'of',
    _a[pagerTotalPages] = '{0}',
    _a[searchPlaceholder] = 'Search',
    _a[filterCheckAll] = 'Check All',
    _a[filterChooseOperator] = 'Choose Operator',
    _a[filterSelectedItems] = 'selected items',
    _a[filterAriaLabel] = 'Filter',
    _a[groupPanelAriaLabel] = 'Group panel',
    _a['grid.filterEqOperator'] = 'Is equal to',
    _a['grid.filterNotEqOperator'] = 'Is not equal to',
    _a['grid.filterIsNullOperator'] = 'Is null',
    _a['grid.filterIsNotNullOperator'] = 'Is not null',
    _a['grid.filterIsEmptyOperator'] = 'Is empty',
    _a['grid.filterIsNotEmptyOperator'] = 'Is not empty',
    _a['grid.filterStartsWithOperator'] = 'Starts with',
    _a['grid.filterContainsOperator'] = 'Contains',
    _a['grid.filterNotContainsOperator'] = 'Does not contain',
    _a['grid.filterEndsWithOperator'] = 'Ends with',
    _a['grid.filterGteOperator'] = 'Is greater than or equal to',
    _a['grid.filterGtOperator'] = 'Is greater than',
    _a['grid.filterLteOperator'] = 'Is less than or equal to',
    _a['grid.filterLtOperator'] = 'Is less than',
    _a['grid.filterIsTrue'] = 'Is true',
    _a['grid.filterIsFalse'] = 'Is false',
    _a['grid.filterBooleanAll'] = '(All)',
    _a['grid.filterAfterOrEqualOperator'] = 'Is after or equal to',
    _a['grid.filterAfterOperator'] = 'Is after',
    _a['grid.filterBeforeOperator'] = 'Is before',
    _a['grid.filterBeforeOrEqualOperator'] = 'Is before or equal to',
    _a['grid.filterAndLogic'] = 'And',
    _a['grid.filterOrLogic'] = 'Or',
    _a);
/**
 * @hidden
 */
function pagerMessagesMap(pagerMessageKey) {
    var messageKey = pagerMessageKey.replace(/^pager\.([a-z])/, function (_match, group) { return 'grid.pager' + group.toUpperCase(); });
    return ({ messageKey: messageKey, defaultMessage: messages[messageKey] });
}

var __assign$m = (undefined && undefined.__assign) || function () {
    __assign$m = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$m.apply(this, arguments);
};
/**
 * @hidden
 */
var GridHierarchyCell = function (props) {
    var defaultRendering = null;
    var expanded = getNestedValue(props.field, props.dataItem);
    var navigationAttributes = useTableKeyboardNavigation(props.id);
    var localization = useLocalization();
    var onKeyDownHandler = React.useCallback(function (event) {
        if (event.isDefaultPrevented()) {
            return;
        }
        if (event.keyCode === Keys$2.enter && props.onChange) {
            event.preventDefault();
            props.onChange({
                dataItem: props.dataItem,
                dataIndex: props.dataIndex,
                syntheticEvent: event,
                field: props.field,
                value: !expanded
            });
        }
    }, [props.dataItem, props.dataIndex, props.field, props.onChange, expanded]);
    if (props.rowType === 'groupFooter') {
        defaultRendering =
            React.createElement("td", __assign$m({ className: "k-table-td k-hierarchy-cell", role: 'gridcell' }, navigationAttributes));
    }
    else if (props.rowType !== 'groupHeader') {
        var baseMessage = expanded ? detailCollapse : detailExpand;
        var message = localization.toLanguageString(baseMessage, messages[baseMessage]);
        defaultRendering = (React.createElement("td", __assign$m({ className: "k-table-td k-hierarchy-cell", onKeyDown: onKeyDownHandler, "aria-expanded": expanded ? 'true' : 'false', role: 'gridcell', "aria-colindex": props.ariaColumnIndex }, navigationAttributes),
            React.createElement("a", { onClick: function (e) {
                    e.preventDefault();
                    if (props.onChange) {
                        props.onChange({
                            dataItem: props.dataItem,
                            dataIndex: props.dataIndex,
                            syntheticEvent: e,
                            field: props.field,
                            value: !expanded
                        });
                    }
                }, "aria-label": message, href: "#", tabIndex: -1 },
                React.createElement(IconWrap, { name: expanded ? 'minus' : 'plus', icon: expanded ? minusIcon : plusIcon }))));
    }
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
};

/** The attribute required by the Grid selection on Grid `tr` elements. */
var GRID_ROW_INDEX_ATTRIBUTE = TABLE_ROW_INDEX_ATTRIBUTE;
/** The attribute required by the Grid selection on Grid `td` elements. */
var GRID_COL_INDEX_ATTRIBUTE = TABLE_COL_INDEX_ATTRIBUTE;

var __assign$l = (undefined && undefined.__assign) || function () {
    __assign$l = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$l.apply(this, arguments);
};
/**
 * @hidden
 */
var GridEditCell = function (props) {
    var _a, _b, _c, _d, _e;
    var data = getNestedValue(props.field, props.dataItem);
    var defaultRendering = null;
    var editCellClasses = classNames$3('k-table-td', 'k-grid-edit-cell', (_a = {},
        _a['k-selected'] = props.isSelected,
        _a), props.className);
    var inputId = React.useMemo(function () { return guid$2(); }, []);
    var navigationAttributes = useTableKeyboardNavigation(props.id);
    var handleOnChange = React.useCallback(function (syntheticEvent) {
        if (props.onChange) {
            var value = syntheticEvent.target.type === 'checkbox' ?
                syntheticEvent.target.checked :
                syntheticEvent.target.value;
            props.onChange({
                dataItem: props.dataItem,
                dataIndex: props.dataIndex,
                field: props.field,
                syntheticEvent: syntheticEvent,
                value: value
            });
        }
    }, [props.onChange, props.dataItem, props.dataIndex, props.field]);
    var onContextMenu = React.useCallback(function (event) {
        if (props.onContextMenu) {
            props.onContextMenu.call(undefined, event, props.dataItem, props.field);
        }
    }, [props.onContextMenu, props.dataItem, props.field]);
    var inputChange = React.useCallback(function (e) {
        if (props.onChange) {
            props.onChange({
                dataItem: props.dataItem,
                dataIndex: props.dataIndex,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value
            });
        }
    }, [props.onChange, props.dataItem, props.dataIndex, props.field]);
    switch (props.editor) {
        case 'numeric':
            defaultRendering = (React.createElement("td", __assign$l({ onContextMenu: onContextMenu, colSpan: props.colSpan, style: props.style, className: editCellClasses, "aria-colindex": props.ariaColumnIndex, "aria-selected": props.isSelected }, (_b = {}, _b[GRID_COL_INDEX_ATTRIBUTE] = props.columnIndex, _b), { role: 'gridcell' }, navigationAttributes),
                React.createElement(NumericTextBox, { width: "100%", value: (data === undefined) ? null : data, onChange: inputChange })));
            break;
        case 'date':
            defaultRendering = (React.createElement("td", __assign$l({ onContextMenu: onContextMenu, colSpan: props.colSpan, style: props.style, className: editCellClasses, "aria-colindex": props.ariaColumnIndex, "aria-selected": props.isSelected }, (_c = {}, _c[GRID_COL_INDEX_ATTRIBUTE] = props.columnIndex, _c), { role: 'gridcell' }, navigationAttributes),
                React.createElement(DatePicker, { width: "100%", value: data, onChange: inputChange })));
            break;
        case 'boolean':
            defaultRendering = (React.createElement("td", __assign$l({ onContextMenu: onContextMenu, colSpan: props.colSpan, style: props.style, className: editCellClasses, "aria-colindex": props.ariaColumnIndex, "aria-selected": props.isSelected }, (_d = {}, _d[GRID_COL_INDEX_ATTRIBUTE] = props.columnIndex, _d), { role: 'gridcell' }, navigationAttributes),
                React.createElement("input", { checked: data || false, id: inputId, type: "checkbox", className: "k-checkbox k-checkbox-md k-rounded-md", onChange: handleOnChange }),
                React.createElement("label", { className: "k-checkbox-label", htmlFor: inputId })));
            break;
        default:
            defaultRendering = (React.createElement("td", __assign$l({ onContextMenu: onContextMenu, colSpan: props.colSpan, style: props.style, className: editCellClasses, "aria-colindex": props.ariaColumnIndex, "aria-selected": props.isSelected }, (_e = {}, _e[GRID_COL_INDEX_ATTRIBUTE] = props.columnIndex, _e), { role: 'gridcell' }, navigationAttributes),
                React.createElement("input", { style: { width: '100%' }, className: "k-input", value: data || '', onChange: handleOnChange })));
    }
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
};

var __extends$s = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$k = (undefined && undefined.__assign) || function () {
    __assign$k = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$k.apply(this, arguments);
};
/**
 * @hidden
 */
var Header = /** @class */ (function (_super) {
    __extends$s(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerWrap = null;
        _this.table = null;
        _this.syncScroll = false;
        _this.scrollbarWidth = getScrollbarWidth();
        _this.onScroll = function (_event) {
            if (_this.syncScroll) {
                _this.syncScroll = false;
                return;
            }
            if (!_this.headerWrap) {
                return;
            }
            var scrollLeft = _this.headerWrap.scrollLeft;
            var scrollableDataElement = _this.props.scrollableDataElement();
            if (scrollableDataElement && scrollableDataElement.scrollLeft !== scrollLeft) {
                scrollableDataElement.scrollLeft = scrollLeft;
            }
        };
        return _this;
    }
    Object.defineProperty(Header.prototype, "element", {
        get: function () {
            return this.props.elemRef.current;
        },
        enumerable: false,
        configurable: true
    });
    Header.prototype.componentDidMount = function () {
        var rtl = isRtl(this.element);
        if (this.props.columnResize) {
            this.props.columnResize.setIsRtl(rtl);
        }
        this.forceUpdate();
    };
    /**
     *
     * @param scrollLeft - Scrolls to the left (in pixels).
     */
    Header.prototype.setScrollLeft = function (scrollLeft) {
        if (this.headerWrap && this.headerWrap.scrollLeft !== scrollLeft) {
            this.syncScroll = true;
            this.headerWrap.scrollLeft = scrollLeft;
        }
    };
    /**
     *
     * @param width - Scrolls the width (in pixels).
     */
    Header.prototype.setWidth = function (width) {
        if (this.table) {
            this.table.style.width = width + 'px';
        }
    };
    Header.prototype.render = function () {
        var _a;
        var _this = this;
        if (!this.props.staticHeaders) {
            return (React.createElement("thead", __assign$k({ role: "presentation", className: classNames$3('k-table-thead', { 'k-grid-draggable-header': this.props.draggable }) }, tableKeyboardNavigationHeaderAttributes),
                this.props.headerRow,
                this.props.filterRow));
        }
        return (React.createElement("div", { ref: this.props.elemRef, className: classNames$3('k-grid-header', { 'k-grid-draggable-header': this.props.draggable }), role: "presentation" },
            React.createElement("div", { ref: function (div) { _this.headerWrap = div; }, className: "k-grid-header-wrap", style: this.scrollbarWidth ? {} : { borderWidth: 0 }, onScroll: this.onScroll, role: "presentation" },
                React.createElement("table", { ref: function (table) { _this.table = table; }, className: classNames$3('k-table k-grid-header-table', (_a = {
                            'k-table-md': !this.props.size
                        },
                        _a["k-table-".concat(kendoThemeMaps$2.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                        _a), this.props.className), role: "presentation" },
                    React.createElement("colgroup", { ref: function (e) { _this.props.columnResize.colGroupHeader = e; } }, this.props.cols),
                    React.createElement("thead", __assign$k({ className: 'k-table-thead', role: "rowgroup" }, tableKeyboardNavigationHeaderAttributes),
                        this.props.headerRow,
                        this.props.filterRow)))));
    };
    return Header;
}(React.Component));

var __spreadArray$3 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
var normalize$1 = function () {
    var settings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        settings[_i] = arguments[_i];
    }
    return Object.assign.apply(Object, __spreadArray$3([{ allowUnsort: true, mode: 'single' }], settings, false));
};

var __extends$r = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var ColumnResizer = /** @class */ (function (_super) {
    __extends$r(ColumnResizer, _super);
    function ColumnResizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.draggable = null;
        _this.isDragged = false;
        /**
         * @hidden
         */
        _this.onDrag = function (data) {
            _this.isDragged = true;
            var element = _this.draggable && _this.draggable.element;
            if (element) {
                _this.props.resize(data.event, element, false);
            }
        };
        /**
         * @hidden
         */
        _this.onRelease = function (data) {
            if (!_this.isDragged) {
                return;
            }
            var element = _this.draggable && _this.draggable.element;
            if (element) {
                _this.props.resize(data.event, element, true);
            }
            _this.isDragged = false;
        };
        /**
         * @hidden
         */
        _this.onDoubleClick = function (event) {
            if (_this.isDragged) {
                return;
            }
            var element = _this.draggable && _this.draggable.element;
            if (element) {
                _this.props.autofit(event, element);
            }
        };
        return _this;
    }
    ColumnResizer.prototype.render = function () {
        var _this = this;
        return (React.createElement(Draggable$1, { onPress: function (e) { e.event.originalEvent.stopPropagation(); }, onDrag: this.onDrag, onRelease: this.onRelease, ref: function (component) { _this.draggable = component; } },
            React.createElement("span", { className: "k-column-resizer", style: { touchAction: 'none' }, draggable: false, onDoubleClick: this.onDoubleClick })));
    };
    return ColumnResizer;
}(React.Component));

var __extends$q = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var ColumnDraggable = /** @class */ (function (_super) {
    __extends$q(ColumnDraggable, _super);
    function ColumnDraggable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.draggable = null;
        /**
         * @hidden
         */
        _this.onPress = function (data) {
            var element = _this.draggable && _this.draggable.element;
            if (element && _this.props.pressHandler) {
                _this.props.pressHandler(data.event, element);
            }
        };
        /**
         * @hidden
         */
        _this.onDrag = function (data) {
            var element = _this.draggable && _this.draggable.element;
            if (element && _this.props.dragHandler) {
                _this.props.dragHandler(data.event, element);
            }
        };
        /**
         * @hidden
         */
        _this.onRelease = function (data) {
            var element = _this.draggable && _this.draggable.element;
            if (element && _this.props.releaseHandler) {
                _this.props.releaseHandler(data.event);
            }
        };
        return _this;
    }
    ColumnDraggable.prototype.render = function () {
        var _this = this;
        return (React.createElement(Draggable$1, { onPress: this.onPress, onDrag: this.onDrag, onRelease: this.onRelease, hint: this.props.dragClue, autoScroll: { boundaryElementRef: this.props.headerRef, direction: { horizontal: true, vertical: false } }, scrollContainer: this.props.containerRef || undefined, ref: function (component) { _this.draggable = component; } },
            React.createElement("tr", { className: 'k-table-row', style: { touchAction: 'none' }, role: "row", "aria-rowindex": this.props.ariaRowIndex }, this.props.children)));
    };
    return ColumnDraggable;
}(React.PureComponent));

var __extends$p = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$j = (undefined && undefined.__assign) || function () {
    __assign$j = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$j.apply(this, arguments);
};
var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * The GridColumnMenuWrapper component.
 */
var GridColumnMenuWrapper = /** @class */ (function (_super) {
    __extends$p(GridColumnMenuWrapper, _super);
    function GridColumnMenuWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @hidden */
        _this.state = {
            show: false
        };
        /** @hidden */
        _this._anchor = null;
        /** @hidden */
        _this._content = null;
        /** @hidden */
        _this.blurTimeout = undefined;
        /** @hidden */
        _this.willBlur = false;
        /** @hidden */
        _this.blur = function () {
            if (_this.willBlur) {
                _this.willBlur = false;
                return;
            }
            clearTimeout(_this.blurTimeout);
            _this.blurTimeout = window.setTimeout(function () { _this.closeMenu(); });
        };
        /** @hidden */
        _this.focus = function () {
            clearTimeout(_this.blurTimeout);
        };
        /** @hidden */
        _this.anchorClick = function (event) {
            event.preventDefault();
            _this.setState({
                show: !_this.state.show
            }, function () { return _this.state.show && _this._content && _this._content.focus(); });
        };
        /** @hidden */
        _this.closeMenu = function () {
            _this.setState({ show: false });
        };
        /** @hidden */
        _this.onAnchorMouseDown = function (event) {
            _this.willBlur = _this.state.show && event.currentTarget === _this._anchor;
        };
        return _this;
    }
    GridColumnMenuWrapper.prototype.render = function () {
        var _this = this;
        var _a = this.props, ColumnMenu = _a.columnMenu, others = __rest$1(_a, ["columnMenu"]);
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { className: 'k-grid-header-menu k-grid-column-menu', ref: function (e) { return _this._anchor = e; }, onClick: this.anchorClick, onMouseDown: this.onAnchorMouseDown, href: "#" },
                React.createElement(IconWrap, { name: 'more-vertical', icon: moreVerticalIcon })),
            React.createElement(Popup$1, { anchor: this._anchor, show: this.state.show },
                React.createElement("div", { ref: function (e) { return _this._content = e; }, className: 'k-grid-columnmenu-popup', tabIndex: 0, onBlur: this.blur, onFocus: this.focus, style: { outline: 'none' } }, ColumnMenu && (React.createElement(ColumnMenu, __assign$j({}, others, { onCloseMenu: this.closeMenu })))))));
    };
    return GridColumnMenuWrapper;
}(React.Component));

var __extends$o = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$i = (undefined && undefined.__assign) || function () {
    __assign$i = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$i.apply(this, arguments);
};
/**
 * @example
 * ```jsx
 * class App extends React.PureComponent {
 *    state = {
 *        details: false,
 *        data: [
 *               { foo: 'A1', bar: 'B1', b1: 1, b2:2 },
 *               { foo: 'A2', bar: 'B2', b1: 3, b2:4 },
 *               { foo: 'A3', bar: 'B2', b1: 5, b2:6 }
 *           ]
 *    };
 *
 *    CustomHeaderCell = (props) =>
 *        <span>
 *            {props.title || props.field + ' '}
 *            <button onClick={() => this.setState({ barDetails: !this.state.barDetails })}>
 *                {this.state.barDetails ? 'collapse' : 'expand'}
 *            </button>
 *            {props.children}
 *        </span>
 *
 *    render() {
 *        return (
 *            <Grid
 *                style={{ height: '420px' }}
 *                data={this.state.data}
 *                reorderable={true}
 *            >
 *                <GridColumn field="foo" />
 *                <GridColumn field="bar" headerCell={this.CustomHeaderCell}>
 *                    {this.state.barDetails && [
 *                        <GridColumn field="b1" />,
 *                        <GridColumn field="b2" />
 *                    ]}
 *                </GridColumn>
 *            </Grid>
 *        );
 *    }
 * }
 *
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var GridHeaderCell = /** @class */ (function (_super) {
    __extends$o(GridHeaderCell, _super);
    function GridHeaderCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridHeaderCell.prototype.render = function () {
        var columnMenuWrapperProps = this.props.columnMenuWrapperProps;
        var clickProps = this.props.onClick ? {
            onClick: this.props.onClick
        } : {};
        var defaultRendering = (React.createElement("span", { className: 'k-cell-inner' },
            React.createElement("span", __assign$i({ className: classNames$3('k-link', {
                    '!k-cursor-default': !this.props.columnMenuWrapperProps.sortable
                }) }, clickProps),
                React.createElement("span", { className: 'k-column-title' }, this.props.title || this.props.field || '\u00A0'),
                this.props.children),
            columnMenuWrapperProps.columnMenu && React.createElement(GridColumnMenuWrapper, __assign$i({}, columnMenuWrapperProps))));
        if (this.props.render) {
            return this.props.render.call(undefined, defaultRendering, this.props);
        }
        return defaultRendering;
    };
    return GridHeaderCell;
}(React.Component));

var __extends$n = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$h = (undefined && undefined.__assign) || function () {
    __assign$h = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$h.apply(this, arguments);
};
/**
 * @hidden
 */
var sortSeqMap$1 = {
    true: { 'asc': 'desc', 'desc': '', '': 'asc' },
    false: { 'asc': 'desc', 'desc': 'asc', '': 'asc' }
};
/**
 * @hidden
 */
var ariaSortMap = {
    'none': 'none',
    'asc': 'ascending',
    'desc': 'descending'
};
/**
 * @hidden
 */
var HeaderRow = /** @class */ (function (_super) {
    __extends$n(HeaderRow, _super);
    function HeaderRow(props) {
        var _this = _super.call(this, props) || this;
        _this.serviceIndex = 0;
        _this.index = -1;
        _this.cellKeyDown = function (event, column) {
            if (event.isDefaultPrevented()) {
                return;
            }
            if (event.keyCode === Keys$2.enter) {
                _this.cellClick(event, column);
            }
        };
        _this.cells = function (rowIndexes) { return rowIndexes.map(function (columnIndex) {
            var column = _this.props.columns[columnIndex];
            var sortable = _this.props.sortable && column.sortable;
            var sortIndex = _this.props.sort ? _this.props.sort.findIndex(function (s) { return s.field === column.field; }) : -1;
            var sortDir = sortIndex >= 0 ? ((_this.props.sort)[sortIndex].dir || 'none') : 'none';
            var columnMenu = (column.columnMenu === null) ? null : (column.columnMenu || _this.props.columnMenu);
            var className = classNames$3({
                'k-first': column.kFirst,
                'k-filterable': Boolean(columnMenu),
                'k-table-th': true,
                'k-header': true,
                'k-grid-header-sticky': column.locked,
                'k-sorted': _this.props.sort && _this.props.sort.some(function (descriptor) { return descriptor.field === column.field; })
            }, column.headerClassName);
            var style = column.left !== undefined
                ? !_this.props.isRtl
                    ? { left: column.left, right: column.right }
                    : { left: column.right, right: column.left }
                : {};
            var sortLabel = provideLocalizationService(_this).toLanguageString(sortAriaLabel, messages[sortAriaLabel]);
            var ariaAttrs = column.isAccessible ? {
                ariaSort: ariaSortMap[sortDir],
                role: 'columnheader',
                ariaColumnIndex: column.ariaColumnIndex,
                ariaSelected: false,
                ariaDescription: sortable ? sortLabel : ''
            } : {
                'role': 'presentation'
            };
            var key = (column.declarationIndex >= 0) ? ++_this.index : --_this.serviceIndex;
            var HeaderCell = column.headerCell ? column.headerCell : GridHeaderCell;
            var headerCell = (React.createElement(HeaderCell, { field: column.field, onClick: sortable && (function (e) { return _this.cellClick(e, column); }) || undefined, selectionChange: _this.props.selectionChange, title: column.title, selectionValue: column.headerSelectionValue, render: _this.props.cellRender, children: _this.sortIcon(sortIndex), columnMenuWrapperProps: {
                    column: {
                        field: column.field,
                        filter: column.filter
                    },
                    sortable: sortable && _this.props.sortable,
                    sort: _this.props.sort,
                    onSortChange: _this.props.sortChange,
                    filter: _this.props.filter,
                    filterable: _this.props.filterable && column.filterable,
                    filterOperators: _this.props.filterOperators,
                    onFilterChange: _this.props.filterChange,
                    group: _this.props.group,
                    groupable: _this.props.groupable,
                    onGroupChange: _this.props.groupChange,
                    columnMenu: columnMenu
                } }));
            return (React.createElement(HeaderThElement, __assign$h({}, ariaAttrs, { key: key, colSpan: column.colSpan, rowSpan: column.rowSpan, className: className, style: style, columnId: column.id, navigatable: column.navigatable, onKeyDown: sortable && (function (e) { return _this.cellKeyDown(e, column); }) || undefined, role: "columnheader" }),
                headerCell,
                _this.props.columnResize && _this.props.columnResize.resizable && column.resizable &&
                    React.createElement(ColumnResizer, { key: 2, resize: function (e, element, end) {
                            return _this.props.columnResize &&
                                _this.props.columnResize.dragHandler(e, column, element, end);
                        }, autofit: function (e) {
                            return _this.props.columnResize &&
                                _this.props.columnResize.dblClickHandler(e, [column.id]);
                        } })));
        }); };
        _this.cellClick = _this.cellClick.bind(_this);
        return _this;
    }
    HeaderRow.prototype.cellClick = function (e, column) {
        e.preventDefault();
        if (!this.props.sortChange) {
            return;
        }
        var _a = normalize$1(this.props.sortable || false, column.sortable || false), allowUnsort = _a.allowUnsort, mode = _a.mode;
        var oldDescriptor = (this.props.sort || []).filter(function (d) { return d.field === column.field; })[0];
        var dir = sortSeqMap$1[allowUnsort][oldDescriptor && oldDescriptor.dir || ''];
        var newDescriptor = (mode === 'single') ?
            [] : (this.props.sort || []).filter(function (d) { return d.field !== column.field; });
        if (dir !== '' && column.field) {
            newDescriptor.push({ field: column.field, dir: dir });
        }
        this.props.sortChange(newDescriptor, e);
    };
    HeaderRow.prototype.sortIcon = function (sortIndex) {
        if (!this.props.sort) {
            return null;
        }
        return sortIndex >= 0 && [
            React.createElement("span", { key: 1, className: 'k-sort-icon' },
                React.createElement(IconWrap, { name: 'sort-' + this.props.sort[sortIndex].dir + '-small', icon: this.props.sort[sortIndex].dir === 'asc' ? sortAscSmallIcon : sortDescSmallIcon })),
            this.props.sort.length > 1 &&
                React.createElement("span", { key: 2, className: 'k-sort-icon' },
                    React.createElement("span", { className: "k-sort-order" }, sortIndex + 1))
        ];
    };
    HeaderRow.prototype.render = function () {
        var _this = this;
        this.serviceIndex = 0;
        this.index = -1;
        return this.props.columnsMap.map(function (rowIndexes, i) {
            return _this.props.pressHandler && (React.createElement(ColumnDraggable, { key: i, pressHandler: _this.props.pressHandler, dragHandler: _this.props.dragHandler, releaseHandler: _this.props.releaseHandler, ariaRowIndex: i + 1, dragClue: _this.props.dragClue, headerRef: _this.props.headerRef, containerRef: _this.props.containerRef }, _this.cells(rowIndexes))) || React.createElement("tr", { className: 'k-table-row', role: "row", "aria-rowindex": i + 1 }, _this.cells(rowIndexes));
        });
    };
    return HeaderRow;
}(React.Component));
registerForLocalization(HeaderRow);

/**
 * @hidden
 */
var filterLogicList = [
    { text: 'grid.filterAndLogic', operator: 'and' },
    { text: 'grid.filterOrLogic', operator: 'or' }
];
/**
 * @hidden
 */
var operators = {
    'text': [
        { text: 'grid.filterContainsOperator', operator: 'contains' },
        { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
        { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
        { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
        { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
    ],
    'numeric': [
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterGteOperator', operator: 'gte' },
        { text: 'grid.filterGtOperator', operator: 'gt' },
        { text: 'grid.filterLteOperator', operator: 'lte' },
        { text: 'grid.filterLtOperator', operator: 'lt' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
    ],
    'date': [
        { text: 'grid.filterEqOperator', operator: 'eq' },
        { text: 'grid.filterNotEqOperator', operator: 'neq' },
        { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
        { text: 'grid.filterAfterOperator', operator: 'gt' },
        { text: 'grid.filterBeforeOperator', operator: 'lt' },
        { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
        { text: 'grid.filterIsNullOperator', operator: 'isnull' },
        { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
    ],
    'boolean': [
        { text: 'grid.filterEqOperator', operator: 'eq' }
    ]
};
/**
 * @hidden
 */
var IsUnaryFilter = function (operator) {
    return operator === 'isnull' || operator === 'isnotnull' || operator === 'isempty' || operator === 'isnotempty';
};
/**
 * @hidden
 */
var operatorMap = function (iterable, service) { return iterable.map(function (operator) { return ({
    text: service.toLanguageString(operator.text, messages[operator.text]),
    operator: operator.operator
}); }); };
/**
 * @hidden
 */
var defaultBooleanOperator = 'eq';
/**
 * @hidden
 */
var booleanFilterValues = [
    { text: 'grid.filterBooleanAll', operator: '' },
    { text: 'grid.filterIsTrue', operator: true },
    { text: 'grid.filterIsFalse', operator: false }
];
/**
 * @hidden
 */
var defaultHideSecondFilter = {
    text: false,
    numeric: false,
    date: false,
    boolean: true
};
/**
 * @hidden
 */
var cellInputChange = function (value, e, props) {
    var defaultOperator = getDefaultOperator(props.operators);
    var operator = props.operator;
    switch (props.filterType) {
        case 'numeric':
            if (!operator || IsUnaryFilter(operator)) {
                // change the operator to default
                operator = defaultOperator;
            }
            if (value === null && operator === defaultOperator) {
                // clear only the default operator
                operator = '';
            }
            break;
        case 'date':
            if (!operator || IsUnaryFilter(operator)) {
                operator = defaultOperator;
            }
            if (value === null && operator === defaultOperator) {
                operator = '';
            }
            break;
        case 'text':
            if (!operator || IsUnaryFilter(operator)) {
                operator = defaultOperator;
            }
            if (!value && operator === defaultOperator) {
                operator = '';
            }
            break;
        default: return;
    }
    props.onChange({ value: value, operator: operator, syntheticEvent: e });
};
/**
 * @hidden
 */
var getDefaultOperator = function (filterOperators, filterType) {
    if (filterType) {
        return filterOperators[filterType][0].operator;
    }
    else {
        return filterOperators[0].operator;
    }
};
/**
 * @hidden
 */
var getFilterType = function (filterType) {
    return filterType || 'text';
};
/**
 * @hidden
 */
var cellBoolDropdownChange = function (event, onChange) {
    var item = event.target.value;
    onChange({
        value: item.operator,
        operator: item.operator === '' ? '' : defaultBooleanOperator,
        syntheticEvent: event.syntheticEvent
    });
};
/**
 * @hidden
 */
var cellOperatorChange = function (event, currentValue, onChange) {
    var value = currentValue;
    var item = event.target.value;
    if (!event.target.state.opened) {
        return;
    }
    if (IsUnaryFilter(item.operator)) {
        // clear the value to avoid confusion on what is filtered
        value = null;
    }
    if (currentValue === null && !IsUnaryFilter(item.operator)) {
        value = undefined;
    }
    onChange({ value: value, operator: item.operator, syntheticEvent: event.syntheticEvent });
};

var __extends$m = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var GridFilterCell = /** @class */ (function (_super) {
    __extends$m(GridFilterCell, _super);
    function GridFilterCell(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOperatorEditor = function (localization) {
            if (_this.props.filterType === 'boolean') {
                return;
            }
            var value = _this.props.operators.find(function (item) { return item.operator === _this.props.operator; }) || null;
            return (React.createElement(DropDownList, { size: _this.props.size, value: value, onChange: _this.operatorChange, className: "k-dropdown-operator", iconClassName: "k-i-filter k-icon", svgIcon: filterIcon, data: _this.props.operators, textField: "text", title: localization.toLanguageString(filterChooseOperator, messages[filterChooseOperator]), popupSettings: {
                    width: ''
                } }));
        };
        _this.inputChange = _this.inputChange.bind(_this);
        _this.clear = _this.clear.bind(_this);
        _this.operatorChange = _this.operatorChange.bind(_this);
        _this.boolDropdownChange = _this.boolDropdownChange.bind(_this);
        return _this;
    }
    /**
     * @hidden
     */
    GridFilterCell.prototype.render = function () {
        var _a;
        var localizationService = provideLocalizationService(this);
        var defaultRendering = (React.createElement("div", { className: "k-filtercell" },
            React.createElement("div", { className: "k-filtercell-wrapper" },
                this.filterComponent(this.props.filterType, this.props.value, this.props.booleanValues),
                React.createElement("div", { className: "k-filtercell-operator" },
                    this.renderOperatorEditor(localizationService),
                    "\u00A0",
                    React.createElement(Button$2, { size: this.props.size, icon: 'filter-clear', svgIcon: filterClearIcon, className: classNames$3((_a = {},
                            _a['k-clear-button-visible'] = Boolean(!(this.props.value === null || this.props.value === '') || this.props.operator),
                            _a)), title: localizationService.toLanguageString(filterClearButton, messages[filterClearButton]), type: "button", onClick: this.clear, disabled: !(!(this.props.value === null || this.props.value === '') || this.props.operator) })))));
        if (this.props.render) {
            return this.props.render.call(undefined, defaultRendering, this.props);
        }
        return defaultRendering;
    };
    GridFilterCell.prototype.inputChange = function (value, e) {
        cellInputChange(value, e, this.props);
    };
    GridFilterCell.prototype.operatorChange = function (event) {
        cellOperatorChange(event, this.props.value, this.props.onChange);
    };
    GridFilterCell.prototype.boolDropdownChange = function (event) {
        cellBoolDropdownChange(event, this.props.onChange);
    };
    GridFilterCell.prototype.clear = function (e) {
        e.preventDefault();
        this.props.onChange({ value: '', operator: '', syntheticEvent: e });
    };
    GridFilterCell.prototype.filterComponent = function (filterType, value, booleanValues) {
        var _this = this;
        switch (filterType) {
            case 'numeric':
                return (React.createElement(NumericTextBox, { size: this.props.size, value: value, onChange: function (e) { _this.inputChange(e.value, e.syntheticEvent); }, title: this.props.title, ariaLabel: this.props.ariaLabel }));
            case 'date':
                return (React.createElement(DatePicker, { size: this.props.size, value: value, onChange: function (e) { _this.inputChange(e.value, e.syntheticEvent); }, title: this.props.title, ariaLabel: this.props.ariaLabel }));
            case 'boolean':
                var noFilterSet_1 = function (filter) { return filter === null || filter === undefined; };
                return (React.createElement(DropDownList, { size: this.props.size, onChange: this.boolDropdownChange, value: booleanValues.find(function (item) { return item.operator === (noFilterSet_1(value) ? '' : value); }), data: booleanValues, textField: "text", title: this.props.title, ariaLabel: this.props.ariaLabel }));
            default: return (React.createElement(TextBox, { size: this.props.size, value: value || '', onChange: function (e) { _this.inputChange(e.target.value, e.syntheticEvent); }, title: this.props.title, "aria-label": this.props.ariaLabel }));
        }
    };
    return GridFilterCell;
}(React.Component));
registerForLocalization(GridFilterCell);

var __extends$l = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$g = (undefined && undefined.__assign) || function () {
    __assign$g = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$g.apply(this, arguments);
};
/**
 * @hidden
 */
var FILTER_ROW_CLASS = 'k-table-row k-filter-row';
/**
 *
 * @hidden
 */
var FilterRow = /** @class */ (function (_super) {
    __extends$l(FilterRow, _super);
    function FilterRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterRow.prototype.headerCellClassName = function (field, locked) {
        var result = "".concat(locked ? 'k-grid-header-sticky' : '');
        if (this.props.sort &&
            this.props.sort.filter(function (descriptor) { return descriptor.field === field; }).length > 0) {
            result += ' k-sorted';
        }
        return result;
    };
    FilterRow.prototype.setFilter = function (value, operator, field, e) {
        if (!this.props.filterChange) {
            return;
        }
        var filters = [];
        if (value !== '' && value !== null || operator !== '') {
            filters.push({
                field: field,
                operator: operator,
                value: value
            });
        }
        if (this.props.filter && this.props.filter.filters) {
            var oldFilters = this.props.filter.filters || [];
            oldFilters.forEach(function (filter) {
                var descriptor = filter;
                if (descriptor && descriptor.field !== field) {
                    filters.push(descriptor);
                }
            });
        }
        var logic = this.props.filter && this.props.filter.logic ? this.props.filter.logic : 'and';
        this.props.filterChange(filters.length > 0 ? { logic: logic, filters: filters } : null, e);
    };
    FilterRow.prototype.render = function () {
        var _this = this;
        var intl = provideLocalizationService(this);
        var oldFilters = this.props.filter && this.props.filter.filters || [];
        var activeFilter = function (field) {
            if (field === undefined) {
                return;
            }
            var currentFilters = oldFilters.filter(function (filter) { return filter.field === field; });
            return currentFilters.length ? currentFilters[0] : undefined;
        };
        var serviceIndex = 0, index = -1;
        var filterCells = this.props.columns.filter(function (c) { return c.children.length === 0; })
            .map(function (column) {
            var filterType = getFilterType(column.filter);
            var currentActiveFilter = activeFilter(column.field);
            var ariaLabel = column.filterable ? intl.toLanguageString(filterAriaLabel, messages[filterAriaLabel]) : undefined;
            var value = currentActiveFilter && currentActiveFilter.value;
            if (value === undefined) {
                value = filterType === 'text' ? '' : null;
            }
            var filterCellProps = column.filterable && {
                render: _this.props.cellRender,
                field: column.field,
                title: column.filterTitle,
                value: value,
                operator: currentActiveFilter && currentActiveFilter.operator,
                operators: operatorMap(_this.props.filterOperators[filterType] || [], intl),
                booleanValues: operatorMap(booleanFilterValues, intl),
                filterType: filterType,
                ariaLabel: ariaLabel,
                onChange: function (e) { _this.setFilter(e.value, e.operator, column.field, e.syntheticEvent); }
            };
            var key = (column.declarationIndex >= 0) ? ++index : --serviceIndex;
            var ariaAttrs = {
                ariaLabel: ariaLabel,
                ariaColumnIndex: column.ariaColumnIndex
            };
            var style = column.left !== undefined
                ? !_this.props.isRtl
                    ? { left: column.left, right: column.right }
                    : { left: column.right, right: column.left }
                : {};
            return (React.createElement(HeaderThElement, __assign$g({ key: key, columnId: tableKeyboardNavigationTools.getFilterColumnId(column.id), navigatable: column.navigatable, style: style, className: classNames$3('k-table-th', _this.headerCellClassName(column.field, column.locked) || undefined), role: "columnheader" }, ariaAttrs), filterCellProps && (column.filterCell ?
                React.createElement(column.filterCell, __assign$g({}, filterCellProps)) :
                React.createElement(GridFilterCell, __assign$g({ size: _this.props.size }, filterCellProps)))));
        });
        return React.createElement("tr", { className: FILTER_ROW_CLASS, "aria-rowindex": this.props.ariaRowIndex, role: "row" }, filterCells);
    };
    return FilterRow;
}(React.Component));
registerForLocalization(FilterRow);

var __extends$k = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var GroupingIndicator = /** @class */ (function (_super) {
    __extends$k(GroupingIndicator, _super);
    function GroupingIndicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.draggable = null;
        /**
         * @hidden
         */
        _this.onPress = function (data) {
            var element = _this.draggable && _this.draggable.element;
            if (element && _this.props.onPress) {
                _this.props.onPress(data.event, element);
            }
        };
        /**
         * @hidden
         */
        _this.onDrag = function (data) {
            var element = _this.draggable && _this.draggable.element;
            if (element && _this.props.onDrag) {
                _this.props.onDrag(data.event, element);
            }
        };
        /**
         * @hidden
         */
        _this.onRelease = function (data) {
            var element = _this.draggable && _this.draggable.element;
            if (element && _this.props.onRelease) {
                _this.props.onRelease(data.event);
            }
        };
        _this.sortChange = function (event) {
            event.preventDefault();
            if (_this.props.onSortChange) {
                var sort = (_this.props.dir === 'asc') ? 'desc' : 'asc';
                _this.props.onSortChange(event, sort);
            }
        };
        _this.groupRemove = function (event) {
            event.preventDefault();
            if (_this.props.onRemove) {
                _this.props.onRemove(event);
            }
        };
        return _this;
    }
    GroupingIndicator.prototype.render = function () {
        var _this = this;
        var localizationService = provideLocalizationService(this);
        var dir = this.props.dir;
        return (React.createElement(Draggable$1, { onPress: this.onPress, onDrag: this.onDrag, onRelease: this.onRelease, ref: function (component) { _this.draggable = component; } },
            React.createElement("div", { className: "k-chip k-chip-md k-chip-solid k-chip-solid-base k-rounded-md", role: "button", style: { touchAction: 'none' } },
                React.createElement("span", { onClick: this.sortChange },
                    React.createElement(IconWrap, { name: 'sort-' + dir + '-small', icon: dir === 'asc' ? sortAscSmallIcon : sortDescSmallIcon })),
                React.createElement("span", { className: 'k-chip-content' }, this.props.title),
                React.createElement("span", { className: "k-chip-actions" },
                    React.createElement("span", { className: "k-chip-action k-chip-remove-action", onClick: this.groupRemove, "aria-label": localizationService.toLanguageString(ungroupColumn, messages[ungroupColumn]) },
                        React.createElement(IconWrap, { name: 'x-circle', icon: xCircleIcon }))))));
    };
    return GroupingIndicator;
}(React.Component));
registerForLocalization(GroupingIndicator);

var __extends$j = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var GroupPanel = /** @class */ (function (_super) {
    __extends$j(GroupPanel, _super);
    function GroupPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onGroupRemove = function (event, index) {
            var newGroups = _this.props.group.slice();
            newGroups.splice(index, 1);
            _this.props.groupChange(newGroups, event);
        };
        _this.onGroupSortChange = function (event, index, groupDesc, dir) {
            var group = Object.assign({}, groupDesc, { dir: dir });
            var newGroups = _this.props.group.slice();
            newGroups.splice(index, 1, group);
            _this.props.groupChange(newGroups, event);
        };
        return _this;
    }
    GroupPanel.prototype.render = function () {
        var _this = this;
        var groupsProp = this.props.group || [];
        var groups = groupsProp.map(function (groupDesc, index) { return (React.createElement(GroupingIndicator, { key: index, dir: groupDesc.dir || 'asc', title: _this.props.resolveTitle(groupDesc.field), onRemove: function (event) {
                _this.onGroupRemove(event, index);
            }, onSortChange: function (event, dir) {
                _this.onGroupSortChange(event, index, groupDesc, dir);
            }, onPress: _this.props.pressHandler, onDrag: _this.props.dragHandler, onRelease: _this.props.releaseHandler })); });
        return (React.createElement("div", { ref: this.props.refCallback, className: "k-grouping-header", role: "toolbar", "aria-label": provideLocalizationService(this).toLanguageString(groupPanelAriaLabel, messages[groupPanelAriaLabel]) },
            React.createElement("div", { className: "k-chip-list k-chip-list-md", role: "none" }, groups),
            React.createElement("div", { className: "k-grouping-drop-container" },
                !groups.length && provideLocalizationService(this).toLanguageString(groupPanelEmpty, messages[groupPanelEmpty]),
                "\u00A0")));
    };
    return GroupPanel;
}(React.Component));
registerForLocalization(GroupPanel);

var __extends$i = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var Footer = /** @class */ (function (_super) {
    __extends$i(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.footerWrap = null;
        _this.table = null;
        _this.scrollbarWidth = getScrollbarWidth();
        return _this;
    }
    Footer.prototype.componentDidMount = function () {
        this.setState({});
    };
    /**
     *
     * @param scrollLeft - Scrolls to the left (in pixels).
     */
    Footer.prototype.setScrollLeft = function (scrollLeft) {
        if (this.footerWrap) {
            this.footerWrap.scrollLeft = scrollLeft;
        }
    };
    /**
     *
     * @param width - Scrolls the width (in pixels).
     */
    Footer.prototype.setWidth = function (width) {
        if (this.table) {
            this.table.style.width = width + 'px';
        }
    };
    Footer.prototype.render = function () {
        var _a;
        var _this = this;
        if (!this.props.staticHeaders) {
            return (React.createElement("tfoot", { className: "k-table-tfoot" }, this.props.row));
        }
        return (React.createElement("div", { className: "k-grid-footer", role: "presentation" },
            React.createElement("div", { ref: function (div) { _this.footerWrap = div; }, className: "k-grid-footer-wrap", style: this.scrollbarWidth ? {} : { borderWidth: 0 }, role: "presentation" },
                React.createElement("table", { ref: function (table) { _this.table = table; }, className: classNames$3('k-table k-grid-footer-table', (_a = {
                            'k-table-md': !this.props.size
                        },
                        _a["k-table-".concat(kendoThemeMaps$2.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                        _a), this.props.className), role: "presentation" },
                    React.createElement("colgroup", { ref: function (e) { _this.props.columnResize.colGroupFooter = e; }, role: "presentation" }, this.props.cols),
                    React.createElement("tfoot", { className: "k-table-tfoot", role: "presentation" }, this.props.row)))));
    };
    return Footer;
}(React.Component));

/**
 * @hidden
 */
var VirtualScroll = /** @class */ (function () {
    function VirtualScroll(cached) {
        var _this = this;
        this.table = null;
        this.containerHeight = 0;
        this.topCacheCount = 0; // 4;
        this.attendedSkip = 0; // -4;
        this.propsSkip = 0;
        this.total = 0;
        this.scrollableVirtual = false;
        this.realSkip = 0;
        this.pageSize = 0;
        this.PageChange = null;
        this.tableBodyRef = React.createRef();
        this.fixedScroll = false;
        this.askedSkip = undefined;
        this.containerRef = React.createRef();
        this.tableTransform = '';
        this.prevScrollPos = 0;
        this.tableTranslate = 0;
        this.scrollSyncing = false;
        this.reactVersion = Number.parseFloat(React.version);
        this.topItems = function (heights, skipTopBuffer) {
            if (!_this.container || skipTopBuffer) {
                return { topItemsCount: 0, topItemsHeight: 0 };
            }
            var screenHeight = _this.container.clientHeight;
            var itemsOnScreen = Math.ceil(screenHeight / heights[0].line);
            var topItemsCount = Math.ceil((heights.length - itemsOnScreen) / 2);
            var topItemsHeight = 0;
            for (var i = 0; i < topItemsCount; i++) {
                topItemsHeight += heights[i].line + heights[i].acc;
            }
            return {
                topItemsCount: topItemsCount,
                topItemsHeight: topItemsHeight,
                itemsNeededOnScreen: itemsOnScreen + itemsOnScreen / 2
            };
        };
        this.horizontalScrollbarHeight = function () {
            if (!_this.container) {
                return 0;
            }
            return _this.container.offsetHeight - _this.container.clientHeight;
        };
        if (cached) {
            this.topCacheCount = 4;
            this.attendedSkip = -this.topCacheCount;
        }
        this.scrollHandler = this.scrollHandler.bind(this);
    }
    Object.defineProperty(VirtualScroll.prototype, "container", {
        get: function () {
            return this.containerRef.current;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VirtualScroll.prototype, "rowHeights", {
        /**
         * @return - The row heights in an array.
         */
        get: function () {
            var result = [];
            var allRows = this.tableBodyRef.current && this.tableBodyRef.current.children || [];
            var accumulate = 0;
            for (var i = 0; i < allRows.length; i++) {
                if (allRows[i].className.indexOf('k-grouping-row') > -1) {
                    accumulate += allRows[i].scrollHeight;
                    continue;
                }
                if (allRows[i].className.indexOf('k-detail-row') > -1) {
                    result[result.length - 1].line += allRows[i].scrollHeight;
                }
                else {
                    result.push({
                        line: allRows[i].scrollHeight,
                        acc: accumulate
                    });
                    accumulate = 0;
                }
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    VirtualScroll.prototype.changePage = function (skip, e) {
        this.attendedSkip = skip - this.topCacheCount;
        if (this.PageChange) {
            this.PageChange({
                skip: Math.max(0, skip - this.topCacheCount),
                take: this.pageSize
            }, e);
        }
    };
    VirtualScroll.prototype.translate = function (dY, forceSet) {
        this.tableTranslate = dY;
        if (this.scrollableVirtual && this.table) {
            if (this.reactVersion <= 17 || forceSet) {
                this.table.style.transform = 'translateY(' + dY + 'px)';
            }
            else {
                this.tableTransform = 'translateY(' + dY + 'px)';
            }
        }
    };
    VirtualScroll.prototype.reset = function () {
        this.scrollSyncing = true;
        if (this.fixedScroll) {
            return;
        }
        if (this.container) {
            this.container.scrollTop = 0;
        }
        this.translate(0, true);
    };
    VirtualScroll.prototype.localScrollUp = function (e) {
        if (!this.container) {
            return;
        }
        var heights = this.rowHeights;
        var scrollTop = this.container.scrollTop;
        var targetTranslate = this.tableTranslate;
        var rowsCount = 0;
        var _a = this.topItems(heights, Boolean(this.topCacheCount)), topItemsCount = _a.topItemsCount, topItemsHeight = _a.topItemsHeight, itemsNeededOnScreen = _a.itemsNeededOnScreen;
        var additionalOnTop = scrollTop - targetTranslate;
        if ((additionalOnTop > topItemsHeight) || heights.length <= itemsNeededOnScreen) {
            return;
        }
        while ((rowsCount < this.topCacheCount + this.attendedSkip - this.realSkip + topItemsCount)
            && this.propsSkip - rowsCount > 0 &&
            !(targetTranslate + (heights[heights.length - 1 - rowsCount].line + heights[heights.length - 1 - rowsCount].acc) + additionalOnTop <= scrollTop)) {
            targetTranslate -= heights[heights.length - 1 - rowsCount].line +
                heights[heights.length - 1 - rowsCount].acc;
            rowsCount++;
        }
        if (rowsCount === 0 && this.topCacheCount === 0 && this.attendedSkip > 0) {
            // allows local scrolling up, when top caching is disabled
            // for variable heights 'topCacheCount' should be atleast 1 to avoid flickering
            targetTranslate = Math.max(targetTranslate - heights[0].line, 0);
            rowsCount = 1;
        }
        if (this.propsSkip - rowsCount <= 0 && targetTranslate > scrollTop) {
            this.translate(0);
            this.changePage(0, e);
            this.container.scrollTop = 0;
            return;
        }
        if (targetTranslate > scrollTop) {
            targetTranslate = scrollTop;
            // need to handle these cases
            // if the item height is not available:
            //    floor the translate to beginning of the item in absolute value
        }
        if (targetTranslate !== this.tableTranslate) {
            this.translate(Math.max(0, targetTranslate - topItemsHeight));
            var nextSkip = Math.max(0, this.propsSkip - rowsCount - topItemsCount);
            this.changePage(nextSkip, e);
        }
    };
    VirtualScroll.prototype.localScrollDown = function (e) {
        if (!this.container) {
            return;
        }
        var heights = this.rowHeights;
        var scrollTop = this.container.scrollTop;
        var targetTranslate = this.tableTranslate;
        var rowsCount = 0;
        var _a = this.topItems(heights, Boolean(this.topCacheCount)), topItemsCount = _a.topItemsCount, topItemsHeight = _a.topItemsHeight, itemsNeededOnScreen = _a.itemsNeededOnScreen;
        while (rowsCount < heights.length - this.topCacheCount &&
            !(targetTranslate + heights[rowsCount].line + heights[rowsCount].acc > scrollTop)) {
            targetTranslate += heights[rowsCount].line + heights[rowsCount].acc;
            rowsCount++;
        }
        if ((topItemsCount > this.propsSkip + rowsCount) || heights.length <= itemsNeededOnScreen) {
            return;
        }
        if (rowsCount >= heights.length - this.topCacheCount && this.propsSkip + rowsCount >= this.total) {
            this.translate(targetTranslate - topItemsHeight);
            this.changePage(this.total - 1 - topItemsCount, e);
        }
        else if (targetTranslate !== this.tableTranslate && this.propsSkip + rowsCount - topItemsCount !== this.propsSkip) {
            this.translate(targetTranslate - topItemsHeight);
            this.changePage(this.propsSkip + rowsCount - topItemsCount, e);
        }
    };
    VirtualScroll.prototype.scrollNonStrict = function (e) {
        var floatRowIndex = this.total * this.prevScrollPos / (this.containerHeight);
        var rowIndex = Math.floor(floatRowIndex);
        if (rowIndex >= this.total) {
            rowIndex = this.total - 1;
        }
        var rowpercentage = Math.min(floatRowIndex - rowIndex, 1);
        var microAdjust = 0;
        var rowIndexOffset = rowIndex - this.propsSkip;
        var heights = this.rowHeights;
        if (rowIndexOffset >= 0 && rowIndexOffset <= 1) {
            microAdjust = -((heights[0].line + heights[0].acc) * rowpercentage);
        }
        else if (rowIndexOffset === -1) {
            microAdjust = -((heights[heights.length - 1].line + heights[heights.length - 1].acc) * rowpercentage);
        }
        var _a = this.topItems(heights, Boolean(this.topCacheCount)), topItemsCount = _a.topItemsCount, topItemsHeight = _a.topItemsHeight;
        this.translate(Math.max(0, microAdjust - topItemsHeight - this.horizontalScrollbarHeight() + this.containerHeight * floatRowIndex / this.total));
        this.changePage(rowIndex - topItemsCount, e);
    };
    VirtualScroll.prototype.scrollHandler = function (e) {
        if (!this.scrollableVirtual) {
            return;
        }
        if (this.scrollSyncing || !this.container || !this.table) {
            this.scrollSyncing = false;
            return;
        }
        var scrollTop = this.container.scrollTop;
        var prev = this.prevScrollPos;
        this.prevScrollPos = scrollTop;
        if (this.askedSkip !== undefined) {
            this.translate(this.containerHeight * this.askedSkip / this.total);
            this.changePage(this.askedSkip, e);
            this.prevScrollPos = scrollTop;
            this.askedSkip = undefined;
            return;
        }
        if (scrollTop - prev < 0 && scrollTop > this.tableTranslate - this.table.scrollHeight / 10) {
            this.localScrollUp(e);
        }
        else if (scrollTop - prev > 0 && scrollTop < this.tableTranslate + this.table.scrollHeight * 2 / 3) {
            this.localScrollDown(e);
        }
        else {
            this.scrollNonStrict(e);
        }
        this.prevScrollPos = scrollTop;
    };
    return VirtualScroll;
}());

/**
 * @hidden
 */
var RowHeightService = /** @class */ (function () {
    function RowHeightService(total, rowHeight, detailRowHeight, data) {
        if (total === void 0) { total = 0; }
        this.total = total;
        this.offsets = [];
        this.heights = [];
        var agg = 0;
        for (var idx = 0; idx < total; idx++) {
            this.offsets.push(agg);
            var currHeight = (data && data[idx].expanded && data[idx].rowType === 'data') ? detailRowHeight : rowHeight;
            agg += currHeight;
            this.heights.push(currHeight);
        }
    }
    RowHeightService.prototype.height = function (rowIndex) {
        return this.heights[rowIndex];
    };
    RowHeightService.prototype.index = function (position) {
        if (position < 0) {
            return undefined;
        }
        var result = this.offsets.reduce(function (prev, current, idx) {
            if (prev !== undefined) {
                return prev;
            }
            else if (current === position) {
                return idx;
            }
            else if (current > position) {
                return idx - 1;
            }
            return undefined;
        }, undefined);
        return result === undefined ? this.total - 1 : result;
    };
    RowHeightService.prototype.offset = function (rowIndex) {
        return this.offsets[rowIndex];
    };
    RowHeightService.prototype.totalHeight = function () {
        var lastOffset = this.offsets[this.offsets.length - 1];
        var lastHeight = this.heights[this.heights.length - 1];
        return lastOffset + lastHeight;
        // return this.heights.reduce((prev, curr) => prev + curr, 0);
    };
    return RowHeightService;
}());
/**
 * @hidden
 */
var VirtualScrollFixed = /** @class */ (function () {
    function VirtualScrollFixed(_cached) {
        this.table = null;
        this.containerHeight = 0;
        this.topCacheCount = 0;
        this.attendedSkip = 0;
        this.propsSkip = 0;
        this.total = 0;
        this.scrollableVirtual = false;
        this.realSkip = 0;
        this.pageSize = 0;
        this.PageChange = null;
        this.tableBodyRef = React.createRef();
        this.fixedScroll = false;
        this.askedSkip = undefined;
        this.containerRef = React.createRef();
        this.tableTransform = '';
        this.scrollSyncing = false;
        this.lastLoaded = 0;
        this.firstLoaded = 0;
        this.lastScrollTop = 0;
        this.reactVersion = Number.parseFloat(React.version);
        this.firstLoaded = this.pageSize;
        this.lastLoaded = this.realSkip + this.pageSize;
        this.scrollHandler = this.scrollHandler.bind(this);
    }
    Object.defineProperty(VirtualScrollFixed.prototype, "container", {
        get: function () {
            return this.containerRef.current;
        },
        enumerable: false,
        configurable: true
    });
    VirtualScrollFixed.prototype.translate = function (dY, forceSet) {
        if (this.scrollableVirtual && this.table) {
            if (this.reactVersion <= 17 || forceSet) {
                this.table.style.transform = 'translateY(' + dY + 'px)';
            }
            else {
                this.tableTransform = 'translateY(' + dY + 'px)';
            }
        }
    };
    VirtualScrollFixed.prototype.changePage = function (skip, e) {
        if (this.PageChange) {
            this.PageChange({ skip: Math.max(0, skip), take: this.pageSize }, e);
        }
    };
    VirtualScrollFixed.prototype.reset = function () {
        this.scrollSyncing = true;
        if (this.fixedScroll) {
            return;
        }
        if (this.container) {
            this.container.scrollTop = 0;
        }
        this.translate(0, true);
    };
    VirtualScrollFixed.prototype.scrollHandler = function (e) {
        if (!this.scrollableVirtual || !this.container || !this.table ||
            !this.rowHeightService || !this.containerRef.current) {
            return;
        }
        if (this.scrollSyncing) {
            this.scrollSyncing = false;
            return;
        }
        var scrollTop = this.container.scrollTop;
        var up = this.lastScrollTop >= scrollTop;
        var down = !up;
        this.lastScrollTop = scrollTop;
        var firstItemIndex = this.rowHeightService.index(scrollTop);
        var firstItemOffset = this.rowHeightService.offset(firstItemIndex);
        var offsetHeight = this.containerRef.current.offsetHeight;
        var lastItemIndex = this.rowHeightService.index(scrollTop + offsetHeight);
        if (down && lastItemIndex >= this.lastLoaded && this.lastLoaded < this.total) {
            var overflow = (firstItemIndex + this.pageSize) - this.total;
            if (overflow > 0) {
                firstItemIndex = firstItemIndex - overflow;
                firstItemOffset = this.rowHeightService.offset(firstItemIndex);
            }
            this.firstLoaded = firstItemIndex;
            this.translate(firstItemOffset);
            var nextTake = this.firstLoaded + this.pageSize;
            this.lastLoaded = Math.min(nextTake, this.total);
            this.changePage(this.firstLoaded, e);
        }
        else if (up && firstItemIndex < this.firstLoaded) {
            var nonVisibleBuffer = Math.floor(this.pageSize * 0.3);
            this.firstLoaded = Math.max(firstItemIndex - nonVisibleBuffer, 0);
            this.translate(this.rowHeightService.offset(this.firstLoaded));
            this.lastLoaded = Math.min(this.firstLoaded + this.pageSize, this.total);
            this.changePage(this.firstLoaded, e);
        }
    };
    return VirtualScrollFixed;
}());

// offsetWidth() is slowly transition to reporting double instead of integet in all browsers
// during this process (which is a bit back-and-forth) we need to make sure we are working across all browsers and versions
var OFFSET_ROUND = 1;
/**
 * @hidden
 */
var ColumnResize = /** @class */ (function () {
    function ColumnResize(triggerResize) {
        var _this = this;
        // Typings. `col` and `colgroup` do not differ, both represnt a `HTMLTableColElement`.
        // Implemented as `any`.
        this.columns = [];
        /**
         * The settings for resizing the Grid.
         */
        this.resizable = false;
        this.isRtl = false;
        this.setIsRtl = function (isRtl) {
            _this.isRtl = isRtl;
        };
        this.dragHandler = function (event, column, dragCue, end) {
            var e = event.originalEvent;
            if (!end) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
            var tdElement = dragCue.parentElement;
            if (!tdElement || !tdElement.parentElement) {
                return;
            }
            var oldWidth = tdElement.clientWidth;
            var newWidth = oldWidth;
            if (_this.isRtl) {
                newWidth += (dragCue.getBoundingClientRect().right - (dragCue.offsetWidth / 2)) - event.clientX;
            }
            else {
                newWidth += event.clientX - dragCue.getBoundingClientRect().left - (dragCue.offsetWidth / 2);
            }
            if (!end && Math.abs(newWidth - oldWidth) < 1) {
                return;
            }
            _this.fixateInitialWidths(tdElement.parentElement.clientWidth);
            _this.setWidths(column, Math.floor(newWidth) / oldWidth);
            var index = _this.columns.filter(function (c) { return !c.children.length; }).findIndex(function (c) { return c.id === column.id; });
            _this.onResize(index, oldWidth, newWidth, e, end, column.id);
        };
        this.dblClickHandler = function (event, columnIds) {
            var columns = _this.columns.filter(function (c) { return columnIds.indexOf(c.id) > -1; });
            if (!_this.colGroupMain || !columns.length) {
                return;
            }
            var leafsForAdjust = {};
            var stack = columns;
            while (stack.length > 0) {
                var currentCol = stack.pop();
                if (!currentCol) {
                    break;
                }
                if (currentCol.children.length) {
                    stack.push.apply(stack, currentCol.children);
                }
                else {
                    leafsForAdjust[currentCol.id] = currentCol;
                }
            }
            var leafs = _this.columns.filter(function (c) { return !c.children.length; });
            var indexesForAdjust = [];
            leafs.forEach(function (currentColumn, index) {
                if (leafsForAdjust[currentColumn.id]) {
                    indexesForAdjust.push(index);
                }
            });
            var tables = [_this.colGroupMain.parentElement];
            var colgroups = [_this.colGroupMain];
            if (_this.colGroupHeader) {
                tables.push(_this.colGroupHeader.parentElement);
                colgroups.push(_this.colGroupHeader);
            }
            if (_this.colGroupFooter) {
                tables.push(_this.colGroupFooter.parentElement);
                colgroups.push(_this.colGroupFooter);
            }
            tables.forEach(function (table) { return table.classList.add('k-autofitting'); });
            var maxWidths = [];
            colgroups.forEach(function (colgroup) {
                indexesForAdjust.forEach(function (columnIndex) {
                    if (colgroup.children[columnIndex]) {
                        colgroup.children[columnIndex].width = '';
                        maxWidths[columnIndex] = Math.max(maxWidths[columnIndex] || 0, colgroup.children[columnIndex].offsetWidth + OFFSET_ROUND);
                    }
                });
            });
            colgroups.forEach(function (colgroup) {
                indexesForAdjust.forEach(function (columnIndex) {
                    if (colgroup.children[columnIndex]) {
                        colgroup.children[columnIndex].width = maxWidths[columnIndex] + 'px';
                        leafs[columnIndex].width = maxWidths[columnIndex];
                    }
                });
            });
            tables.forEach(function (table) { return table.classList.remove('k-autofitting'); });
            _this.onResize(indexesForAdjust[0], 0, 0, event, true, columnIds[0]);
        };
        this.updateColElements = function (affectedColumns) {
            var leafColumns = _this.columns.filter(function (c) { return !c.children.length; });
            var difference = 1e-10;
            var _loop_1 = function (i) {
                var currentColumn = affectedColumns[i];
                var colIndex = leafColumns.findIndex(function (c) { return c.id === currentColumn.id; });
                var currentColumnFloatWidth = parseFloat((currentColumn.width || 0).toString());
                var currentColumnFloorWidth = Math.floor(currentColumnFloatWidth);
                difference += currentColumnFloatWidth - currentColumnFloorWidth;
                var currentWidth = currentColumnFloorWidth + Math.floor(difference);
                difference -= Math.floor(difference);
                if (_this.colGroupMain && _this.colGroupMain.children[colIndex]) {
                    _this.colGroupMain.children[colIndex].width = currentWidth + 'px';
                }
                if (_this.colGroupHeader && _this.colGroupHeader.children[colIndex]) {
                    // static headers
                    _this.colGroupHeader.children[colIndex].width = currentWidth + 'px';
                }
                if (_this.colGroupFooter && _this.colGroupFooter.children[colIndex]) {
                    // static footers
                    _this.colGroupFooter.children[colIndex].width = currentWidth + 'px';
                }
            };
            for (var i = 0; i < affectedColumns.length; i++) {
                _loop_1(i);
            }
        };
        this.onResize = triggerResize;
    }
    ColumnResize.prototype.fixateInitialWidths = function (width) {
        var columns = this.columns.filter(function (c) { return !c.children.length; });
        var remainingCount = 0;
        var cols = this.colGroupMain ? this.colGroupMain.children : [];
        for (var i = 0; i < cols.length; i++) {
            if (cols[i].width) {
                width -= parseFloat(cols[i].width);
            }
            else {
                remainingCount++;
            }
        }
        if (remainingCount === 0) {
            return;
        }
        var perCol = Math.floor(width / remainingCount);
        for (var i = 0; i < cols.length; i++) {
            var col = cols[i];
            if (!col.width) {
                col.width = perCol;
                columns[i].width = perCol.toString();
                if (this.colGroupHeader) {
                    this.colGroupHeader.children[i].width = perCol;
                }
                if (this.colGroupFooter) {
                    this.colGroupFooter.children[i].width = perCol;
                }
            }
        }
    };
    ColumnResize.prototype.setWidths = function (column, coef) {
        var indexInOriginal = this.columns.findIndex(function (c) { return c.id === column.id; });
        var toAdjust = [];
        var more = column.children.length;
        for (var i = indexInOriginal + 1; more > 0 && i < this.columns.length; i++, more--) {
            var cc = this.columns[i];
            if (!cc.children.length) {
                toAdjust.push(cc);
            }
            else {
                more += cc.children.length;
            }
        }
        if (toAdjust.length === 0) {
            toAdjust.push(column);
        }
        toAdjust.forEach(function (colToAdjust) {
            var targetWidth = colToAdjust.width ? parseFloat(colToAdjust.width.toString()) * coef : 0;
            var min = colToAdjust.minResizableWidth === undefined ? 10 : colToAdjust.minResizableWidth;
            if (targetWidth < min) {
                targetWidth = min;
            }
            colToAdjust.width = targetWidth;
        });
        this.updateColElements(toAdjust);
        return toAdjust;
    };
    return ColumnResize;
}());

/**
 * @hidden
 */
var CommonDragLogic = /** @class */ (function () {
    function CommonDragLogic(columnReorder, groupReorder, columnToGroup) {
        var _this = this;
        this.refDragElementClue = React.createRef();
        this.refDropElementClue = React.createRef();
        this.columns = [];
        this.reorderable = false;
        this.groupable = false;
        this.startColumn = -1;
        this.startGroup = -1;
        this.currentColumn = -1;
        this.currentGroup = -1;
        this.groupPanelDivElement = null;
        this.refGroupPanelDiv = function (e) {
            _this.groupPanelDivElement = (e && e.children) ? e.children[0] : e;
        };
        this.pressHandler = function (event, element) {
            var startColumn = _this.getColumnIndex(event, element);
            _this.startGroup = _this.getGroupIndex(event);
            if (startColumn >= 0) {
                var col = _this.columns[startColumn];
                if (col.reorderable && _this.reorderable || col.groupable && _this.groupable) {
                    _this.startColumn = startColumn;
                }
            }
        };
        this.dragHandler = function (event, element) {
            if (!event.isTouch) {
                event.originalEvent.preventDefault();
            }
            event.originalEvent.stopPropagation();
            if (_this.startColumn === -1 && _this.startGroup === -1) {
                return;
            }
            _this.currentColumn = _this.getColumnIndex(event, element);
            var groupPanelChildren = _this.groupPanelDivElement && _this.groupPanelDivElement.children;
            _this.currentGroup = _this.isTargetGroupingContainer(event)
                ? groupPanelChildren && groupPanelChildren.length
                    ? groupPanelChildren.length
                    : 0
                : _this.getGroupIndex(event);
            var invalidIndex = !_this.isValid();
            if (invalidIndex) {
                _this.currentColumn = -1;
                _this.currentGroup = -1;
            }
            var targetElement = (_this.currentColumn >= 0) ?
                element.children[_this.columns[_this.currentColumn].index] :
                _this.isTargetGroupingContainer(event)
                    ? event.originalEvent.target
                    : _this.groupPanelDivElement && _this.groupPanelDivElement.children[_this.currentGroup];
            _this.updateDragElementClue(event, element, targetElement, invalidIndex);
            _this.updateDropElementClue(event, element, targetElement, invalidIndex);
        };
        this.releaseHandler = function (event) {
            var prevColumnIndex = _this.startColumn;
            var nextColumnIndex = _this.currentColumn;
            var prevGroupIndex = _this.startGroup;
            var nextGroupIndex = _this.currentGroup;
            event.originalEvent.preventDefault();
            if (_this.dropElementClue) {
                _this.dropElementClue.setState({ visible: false });
            }
            if (_this.dragElementClue) {
                _this.dragElementClue.setState({ visible: false });
            }
            var isValid = _this.isValid();
            _this.startColumn = _this.startGroup = _this.currentColumn = _this.currentGroup = -1;
            if (!isValid) {
                return;
            }
            if (prevColumnIndex >= 0 && nextColumnIndex >= 0) {
                _this.columnReorder(prevColumnIndex, nextColumnIndex, event.originalEvent);
            }
            else if (prevGroupIndex >= 0 && nextGroupIndex >= 0) {
                _this.groupReorder(prevGroupIndex, nextGroupIndex, event.originalEvent);
            }
            else if (prevColumnIndex >= 0 && nextGroupIndex >= 0) {
                _this.columnToGroup(prevColumnIndex, nextGroupIndex, event.originalEvent);
            }
        };
        this.columnReorder = columnReorder;
        this.groupReorder = groupReorder;
        this.columnToGroup = columnToGroup;
    }
    Object.defineProperty(CommonDragLogic.prototype, "dragClueRef", {
        get: function () {
            return this.refDragElementClue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonDragLogic.prototype, "dropClueRef", {
        get: function () {
            return this.refDropElementClue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonDragLogic.prototype, "dragElementClue", {
        get: function () {
            return this.refDragElementClue.current;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonDragLogic.prototype, "dropElementClue", {
        get: function () {
            return this.refDropElementClue.current;
        },
        enumerable: false,
        configurable: true
    });
    CommonDragLogic.prototype.getColumnIndex = function (event, parent) {
        if (!parent || (parent.parentElement === this.groupPanelDivElement)) {
            return -1;
        }
        var index = getIndex(event, parent);
        if (index === -1) {
            return -1;
        }
        var _loop_1 = function (i) {
            if (parent.parentNode.children[i] === parent) {
                return { value: this_1.columns.findIndex(function (c) { return ((c.index === index) && (c.depth === i)); }) };
            }
        };
        var this_1 = this;
        for (var i = 0; i < parent.parentNode.children.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return -1;
    };
    CommonDragLogic.prototype.isTargetGroupingContainer = function (event) {
        var target = event.originalEvent.target;
        return target.className.indexOf('k-grouping-drop-container') !== -1;
    };
    CommonDragLogic.prototype.getGroupIndex = function (event) {
        return getIndex(event, this.groupPanelDivElement);
    };
    CommonDragLogic.prototype.isValid = function () {
        if (this.startGroup >= 0) {
            // group can be moved into group only
            return this.currentGroup >= 0 && this.currentGroup !== this.startGroup;
        }
        if (this.startColumn === -1) {
            return false;
        }
        if (this.currentGroup >= 0) {
            // column to group is possible
            return this.columns[this.startColumn].groupable === true && this.groupable === true;
        }
        // reorder is possible
        return this.reorderable === true &&
            this.currentColumn >= 0 &&
            this.currentColumn !== this.startColumn &&
            this.columns[this.startColumn].reorderable === true &&
            this.columns[this.currentColumn].parentIndex === this.columns[this.startColumn].parentIndex;
    };
    CommonDragLogic.prototype.updateDragElementClue = function (event, element, targetElement, invalidIndex) {
        if (!this.dragElementClue) {
            return;
        }
        var innerText = this.startColumn >= 0 ?
            element.children[this.columns[this.startColumn].index].innerText :
            element.innerText;
        this.dragElementClue.setState({
            visible: true,
            top: (event.pageY + 10),
            left: event.pageX,
            innerText: innerText,
            status: (invalidIndex || !targetElement) ? 'k-i-cancel' : 'k-i-plus'
        });
    };
    CommonDragLogic.prototype.updateDropElementClue = function (event, element, targetElement, invalidIndex) {
        if (!this.dropElementClue) {
            return;
        }
        if (invalidIndex || !targetElement) {
            this.dropElementClue.setState({ visible: false });
            return;
        }
        var rect = targetElement.getBoundingClientRect();
        var groupElement = targetElement.closest('.k-grouping-header');
        var rectParent = (groupElement || targetElement).getBoundingClientRect();
        var left = rect.left + event.pageX - event.clientX - 6;
        if (!this.isTargetGroupingContainer(event) && (this.currentColumn > this.startColumn
            || this.currentGroup > this.startGroup && this.startGroup !== -1)) {
            left += rect.width;
        }
        var top = rectParent.top + event.pageY - event.clientY;
        this.dropElementClue.setState({
            visible: true,
            top: top,
            left: left,
            height: (this.currentColumn >= 0) ? element.clientHeight : rectParent.height
        });
    };
    return CommonDragLogic;
}());

var __assign$f = (undefined && undefined.__assign) || function () {
    __assign$f = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};
var GridCell = function (props) {
    var _a;
    var defaultRendering = null;
    var intl = useInternationalization();
    var navigationAttributes = useTableKeyboardNavigation(props.id);
    var onContextMenu = React.useCallback(function (event) {
        if (props.onContextMenu) {
            props.onContextMenu.call(undefined, event, props.dataItem, props.field);
        }
    }, [props.onContextMenu, props.dataItem, props.field]);
    if (props.rowType === 'groupFooter') {
        defaultRendering = React.createElement("td", { onContextMenu: onContextMenu, className: props.className });
    }
    else if (props.field !== undefined && props.rowType !== 'groupHeader') {
        var data = getNestedValue(props.field, props.dataItem);
        var dataAsString = '';
        if (data !== undefined && data !== null) {
            dataAsString = props.format ?
                intl.format(props.format, data) :
                data.toString();
        }
        var className = classNames$3('k-table-td', props.className, { 'k-selected': props.isSelected });
        defaultRendering = (React.createElement("td", __assign$f({ onContextMenu: onContextMenu, colSpan: props.colSpan, style: props.style, className: className, role: 'gridcell', "aria-colindex": props.ariaColumnIndex, "aria-selected": props.isSelected }, (_a = {}, _a[GRID_COL_INDEX_ATTRIBUTE] = props.columnIndex, _a), navigationAttributes), dataAsString));
    }
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
};

var __assign$e = (undefined && undefined.__assign) || function () {
    __assign$e = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$e.apply(this, arguments);
};
/**
 * @hidden
 */
var GridGroupCell = function (props) {
    var defaultRendering = null;
    var columnIndex = props.columnIndex, level = props.level, columnsCount = props.columnsCount, rowType = props.rowType, dataItem = props.dataItem, field = props.field, onChange = props.onChange, expanded = props.expanded, render = props.render, dataIndex = props.dataIndex, ariaColumnIndex = props.ariaColumnIndex;
    var definedField = field || '';
    var navigationAttributes = useTableKeyboardNavigation(props.id);
    var localization = useLocalization();
    var onKeyDownHandler = React.useCallback(function (event) {
        if (event.isDefaultPrevented()) {
            return;
        }
        if (event.keyCode === Keys$2.enter && onChange) {
            event.preventDefault();
            onChange({
                dataItem: dataItem,
                dataIndex: dataIndex,
                syntheticEvent: event,
                field: undefined,
                value: !expanded
            });
        }
    }, [expanded, onChange, dataItem, dataIndex]);
    var onContextMenu = React.useCallback(function (event) {
        if (props.onContextMenu) {
            props.onContextMenu.call(undefined, event, props.dataItem, props.field);
        }
    }, [props.onContextMenu, props.dataItem, props.field]);
    var renderCellCollapse = function (colspan, styles) {
        var baseMessage = expanded ? groupCollapse : groupExpand;
        var message = localization.toLanguageString(baseMessage, messages[baseMessage]);
        return (React.createElement("td", __assign$e({ className: 'k-table-td', style: __assign$e(__assign$e({}, props.style), styles), colSpan: colspan, key: 'g-colspan', role: 'gridcell', "aria-selected": false, "aria-expanded": expanded, "aria-colindex": ariaColumnIndex, onKeyDown: onKeyDownHandler, onContextMenu: onContextMenu }, navigationAttributes),
            React.createElement("p", { className: "k-reset" },
                React.createElement("a", { onClick: function (e) {
                        e.preventDefault();
                        if (onChange) {
                            onChange({
                                dataItem: dataItem,
                                dataIndex: dataIndex,
                                syntheticEvent: e,
                                field: undefined,
                                value: !expanded
                            });
                        }
                    }, href: "#", tabIndex: -1, "aria-label": message },
                    React.createElement(IconWrap, { name: expanded ? 'caret-alt-down' : 'caret-alt-right', icon: expanded ? caretAltDownIcon : caretAltRightIcon })),
                ((dataItem[definedField] instanceof Date) && dataItem[definedField].toString) ?
                    dataItem[definedField].toString() :
                    dataItem[definedField])));
    };
    if (columnIndex === undefined || level === undefined || columnIndex < level ||
        columnsCount === undefined || rowType !== 'groupHeader' || dataItem[definedField] === undefined) {
        defaultRendering = (React.createElement("td", { style: props.style, key: 'g' + columnIndex, className: classNames$3('k-table-td', 'k-group-cell', { 'k-grid-content-sticky': props.locked }), role: "gridcell", onContextMenu: onContextMenu }));
    }
    else if (columnIndex <= level && !props.locked) {
        defaultRendering = renderCellCollapse(columnsCount - columnIndex, {});
    }
    else if (columnIndex <= level && props.locked) {
        defaultRendering = (React.createElement(React.Fragment, null,
            renderCellCollapse(0, { position: 'sticky', zIndex: 2 }),
            React.createElement("td", { className: 'k-table-td', role: 'gridcell', colSpan: (columnsCount - columnIndex), style: { borderLeftWidth: 0, borderRightWidth: 0 }, onContextMenu: onContextMenu })));
    }
    return render ?
        render.call(undefined, defaultRendering, props) :
        defaultRendering;
};

var __extends$h = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$d = (undefined && undefined.__assign) || function () {
    __assign$d = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$d.apply(this, arguments);
};
/**
 * The component for each of the items in the `data` property which the Grid renders.
 */
var GridRow = /** @class */ (function (_super) {
    __extends$h(GridRow, _super);
    function GridRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridRow.prototype.render = function () {
        var _a;
        var className = classNames$3('k-table-row', {
            'k-grouping-row': this.props.rowType === 'groupHeader',
            'k-group-footer': this.props.rowType === 'groupFooter',
            'k-master-row': this.props.rowType !== 'groupHeader' &&
                this.props.rowType !== 'groupFooter',
            'k-table-alt-row k-alt': this.props.rowType !== 'groupHeader' &&
                this.props.rowType !== 'groupFooter' &&
                this.props.isAltRow,
            'k-selected': this.props.isSelected,
            'k-grid-edit-row': this.props.isInEdit
        });
        var defaultRendering = (React.createElement("tr", __assign$d({ id: this.props.id, onClick: this.props.onClick, onDoubleClick: this.props.onDoubleClick, className: className, style: {
                height: this.props.rowHeight ? this.props.rowHeight + 'px' : '',
                visibility: this.props.isHidden ? 'hidden' : ''
            }, role: "row", "aria-rowindex": this.props.ariaRowIndex }, (_a = {}, _a[GRID_ROW_INDEX_ATTRIBUTE] = this.props.rowType === 'data' ? this.props.dataIndex : undefined, _a)), this.props.children));
        return this.props.render ?
            this.props.render.call(undefined, defaultRendering, this.props) :
            defaultRendering;
    };
    return GridRow;
}(React.Component));

var __extends$g = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$c = (undefined && undefined.__assign) || function () {
    __assign$c = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};
/**
 * @hidden
 */
var GridHeaderSelectionCell = /** @class */ (function (_super) {
    __extends$g(GridHeaderSelectionCell, _super);
    function GridHeaderSelectionCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inputId = guid$2();
        return _this;
    }
    GridHeaderSelectionCell.prototype.render = function () {
        var _this = this;
        var columnMenuWrapperProps = this.props.columnMenuWrapperProps;
        var defaultRendering = [
            (React.createElement("input", { key: 0, checked: this.props.selectionValue, id: this._inputId, type: "checkbox", className: "k-checkbox k-checkbox-md k-rounded-md", onChange: function (e) {
                    return _this.props.selectionChange({
                        field: _this.props.field,
                        syntheticEvent: e
                    });
                } })),
            (React.createElement("label", { key: 1, className: "k-checkbox-label", htmlFor: this._inputId })),
            columnMenuWrapperProps.columnMenu && React.createElement(GridColumnMenuWrapper, __assign$c({}, columnMenuWrapperProps))
        ];
        return this.props.render ?
            this.props.render.call(undefined, defaultRendering, this.props) :
            defaultRendering;
    };
    return GridHeaderSelectionCell;
}(React.Component));

var __extends$f = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable max-len */
/**
 * Represents the GridNoRecords component. The component is rendered when the `data` property of the Grid is empty or `null`.
 *
 * @example
 * ```jsx
 * class App extends React.Component {
 *     render() {
 *         return (
 *             <Grid data={[]}>
 *                 <GridNoRecords>
 *                     There is no data available
 *                 </GridNoRecords>
 *                 <GridColumn field="id" />
 *                 <GridColumn field="name" />
 *             </Grid>
 *         );
 *     }
 * }
 * ReactDOM.render(
 *     <App />,
 *     document.querySelector('my-app')
 * );
 * ```
 */
// tslint:enable:max-line-length
var GridNoRecords = /** @class */ (function (_super) {
    __extends$f(GridNoRecords, _super);
    function GridNoRecords() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridNoRecords.prototype.render = function () {
        return this.props.children || provideLocalizationService(this).toLanguageString(noRecords, messages[noRecords]);
    };
    /**
     * @hidden
     */
    GridNoRecords.displayName = 'KendoReactGridNoRecords';
    return GridNoRecords;
}(React.Component));
registerForLocalization(GridNoRecords);

var __extends$e = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$b = (undefined && undefined.__assign) || function () {
    __assign$b = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$b.apply(this, arguments);
};
/**
 * @hidden
 */
var FooterRow = /** @class */ (function (_super) {
    __extends$e(FooterRow, _super);
    function FooterRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._element = null;
        _this.renderCell = function (column, index) {
            var tdProps = {
                colSpan: column.colSpan !== 1 ? column.colSpan : undefined,
                style: column.left !== undefined
                    ? !_this.props.isRtl
                        ? { left: column.left, right: column.right }
                        : { left: column.right, right: column.left }
                    : {},
                className: classNames$3('k-table-td', column.locked && column.left !== undefined ? 'k-grid-footer-sticky' : '')
            };
            var cellProps = __assign$b({ field: column.field, ariaColumnIndex: column.ariaColumnIndex }, tdProps);
            return (column.footerCell && React.createElement(column.footerCell, __assign$b({}, cellProps, { key: index }))) || (React.createElement("td", __assign$b({ key: index }, tdProps, { role: 'columnfooter', "aria-selected": false, "aria-colindex": column.ariaColumnIndex })));
        };
        return _this;
    }
    Object.defineProperty(FooterRow.prototype, "element", {
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    FooterRow.prototype.render = function () {
        return React.createElement("tr", { className: 'k-table-row', role: "row", "aria-rowindex": this.props.ariaRowIndex }, footerColumns(this.props.columns).map(this.renderCell));
    };
    return FooterRow;
}(React.Component));

/**
 * @hidden
 */
var normalizeSettings = function (_a) {
    var _b = _a.buttonCount, buttonCount = _b === void 0 ? 10 : _b, _c = _a.info, info = _c === void 0 ? true : _c, _d = _a.type, type = _d === void 0 ? 'numeric' : _d, _e = _a.pageSizes, pageSizes = _e === void 0 ? undefined : _e, _f = _a.previousNext, previousNext = _f === void 0 ? true : _f, _g = _a.responsive, responsive = _g === void 0 ? true : _g, _h = _a.pageSizeValue, pageSizeValue = _h === void 0 ? undefined : _h;
    return ({
        buttonCount: buttonCount,
        info: info,
        pageSizes: pageSizes === true ? [5, 10, 20] : (pageSizes || undefined),
        previousNext: previousNext,
        responsive: responsive,
        type: type,
        pageSizeValue: pageSizeValue
    });
};
/**
 * @hidden
 */
var normalize = function (settings) {
    return normalizeSettings(settings === true ? {} : settings);
};

/**
 * @hidden
 */
var packageMetadata$3 = {
    name: '@progress/kendo-react-grid',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1678868063,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __assign$a = (undefined && undefined.__assign) || function () {
    __assign$a = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$a.apply(this, arguments);
};
/** @hidden */
var GridDetailCell = function (props) {
    var colSpan = props.colSpan, ariaColIndex = props.ariaColIndex, dataItem = props.dataItem, dataIndex = props.dataIndex, id = props.id;
    var navigationAttributes = useTableKeyboardNavigation(id);
    var onContextMenu = React.useCallback(function (event) {
        if (props.onContextMenu) {
            props.onContextMenu.call(undefined, event, props.dataItem);
        }
    }, [props.onContextMenu, props.dataItem]);
    return (React.createElement("td", __assign$a({ onContextMenu: onContextMenu, className: "k-table-td k-detail-cell", colSpan: colSpan, "aria-colindex": ariaColIndex, role: 'gridcell' }, navigationAttributes),
        React.createElement(props.detail, { dataItem: dataItem, dataIndex: dataIndex })));
};

var __assign$9 = (undefined && undefined.__assign) || function () {
    __assign$9 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$9.apply(this, arguments);
};
/** @hidden */
var GridDetailHierarchyCell = function (props) {
    var navigationAttributes = useTableKeyboardNavigation(props.id);
    return (React.createElement("td", __assign$9({ className: "k-table-td k-hierarchy-cell" }, navigationAttributes, { role: 'gridcell' })));
};

var __extends$d = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$8 = (undefined && undefined.__assign) || function () {
    __assign$8 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$8.apply(this, arguments);
};
var __spreadArray$2 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Represents the [KendoReact Grid component]({% slug overview_grid %}).
 *
 * @example
 * ```jsx
 * class App extends React.Component {
 *    constructor(props) {
 *        super(props);
 *        this.state = {
 *            data: [
 *                { 'foo': 'A1', 'bar': 'B1' },
 *                { 'foo': 'A2', 'bar': 'B2' },
 *                { 'foo': 'A3', 'bar': 'B2' }
 *            ]
 *        };
 *    }
 *    render() {
 *        return (
 *            <Grid
 *                data={this.state.data}
 *                reorderable={true}
 *            >
 *                <GridColumn field="foo" />
 *                <GridColumn field="bar" />
 *            </Grid>
 *        );
 *    }
 * }
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var Grid = /** @class */ (function (_super) {
    __extends$d(Grid, _super);
    function Grid(props) {
        var _this = _super.call(this, props) || this;
        _this._columns = [];
        _this._columnsMap = [[]];
        _this._columnsMutations = 0;
        _this.contextStateRef = { current: undefined };
        _this.navigationStateRef = { current: undefined };
        _this._data = [];
        _this._slicedData = undefined;
        _this.wrapperScrollTop = 0;
        _this.headerRef = React.createRef();
        _this.headerElementRef = React.createRef();
        _this._element = null;
        _this.tableElement = null;
        _this.containerRef = React.createRef();
        _this.tableBodyRef = React.createRef();
        _this._footer = null;
        _this.forceUpdateTimeout = undefined;
        _this.isRtl = false;
        _this._gridId = guid$2();
        /**
         * Method to allow the scroll to be set to a specific row index.
         *
         * @param options - Object, containing the rowIndex to which is going to be scrolled.
         */
        _this.scrollIntoView = function (options) {
            if (!_this.vs.container || _this.props.scrollable === 'none') {
                return;
            }
            var rowIndex = options.rowIndex;
            if (_this.props.scrollable === 'virtual') {
                _this.vs.askedSkip = rowIndex;
                _this.vs.container.scroll(0, Math.round(_this.vs.askedSkip / _this.vs.total * _this.vs.container.scrollHeight));
            }
            else if (_this.element) {
                var selectedRow = rowIndex < 1
                    ? _this.element.querySelector("tbody > tr:nth-child(".concat(1, ")"))
                    : _this.element.querySelector("tbody > tr:nth-child(".concat(rowIndex, ")"));
                if (selectedRow) {
                    selectedRow.scrollIntoView(true);
                }
            }
        };
        /**
         * Method to fit columns according to their content.
         *
         * @param columnIds - Array of column ids to be fitted.
         */
        _this.fitColumns = function (columnIds) {
            _this.columnResize.dblClickHandler(null, columnIds);
        };
        _this.onContextMenu = function (event, dataItem, field) {
            if (_this.props.onContextMenu) {
                var ev = {
                    target: _this,
                    syntheticEvent: event,
                    nativeEvent: event.nativeEvent,
                    dataItem: dataItem,
                    field: field
                };
                _this.props.onContextMenu.call(undefined, ev);
            }
        };
        _this.getVirtualScroll = function (props) {
            var rowHeight = props.rowHeight, detailRowHeight = props.detailRowHeight, detail = props.detail, expandField = props.expandField, groupable = props.groupable;
            var hasAllData = _this.isAllData();
            var hasRowHeight = rowHeight !== undefined && rowHeight > 0;
            var hasDetailRowHeight = detailRowHeight !== undefined && detailRowHeight > 0;
            var isGroupable = groupable === true || (typeof groupable === 'object' && groupable.enabled !== false);
            var hasDetails = Boolean(detail && expandField);
            if (!hasRowHeight ||
                (isGroupable && !hasAllData) ||
                (hasDetails && (!hasDetailRowHeight || !hasAllData))) {
                return VirtualScroll;
            }
            return VirtualScrollFixed;
        };
        _this.isAllData = function () {
            var _a = _this.props, data = _a.data, total = _a.total;
            if (Array.isArray(data)) {
                return data.length === total;
            }
            else if (data) {
                return total === data.total;
            }
            return false;
        };
        _this.initializeVirtualization = function (total, groupable) {
            _this.reInitVirtualization(_this.props.scrollable === 'virtual', _this.props.total, _this.props.filter, _this.props.group, _this.props.sort, groupable || _this.props.rowHeight === undefined || _this.props.rowHeight === 0);
            _this.vs.fixedScroll = _this.props.fixedScroll || false;
            _this.vs.PageChange = _this.pageChange;
            _this.vs.realSkip = _this.props.skip || 0;
            _this.vs.pageSize = (_this.props.take !== undefined ? _this.props.take : _this.props.pageSize) || 0;
            _this.vs.scrollableVirtual = (_this.props.scrollable === 'virtual');
            _this.vs.total = total;
            _this.vs.propsSkip = (_this.props.skip || 0) + (_this.props.scrollable === 'virtual' ?
                _this.vs.topCacheCount + (_this.vs.attendedSkip - (_this.props.skip || 0)) : 0);
            if (_this.props.rowHeight !== undefined && _this.props.rowHeight > 0 && !groupable) {
                var containerHeight = _this.props.rowHeight * total;
                _this.vs.containerHeight = firefox$1 ? Math.min(firefoxMaxHeight, containerHeight) : containerHeight;
            }
            else {
                _this.vs.containerHeight = 1533915;
            }
            _this.vs.containerRef = _this.containerRef;
            _this.vs.tableBodyRef = _this.tableBodyRef;
            _this.vs.table = _this.tableElement;
            _this._slicedData = undefined;
            if (_this.vs instanceof VirtualScrollFixed) {
                var _a = _this.props, _b = _a.rowHeight, rowHeight = _b === void 0 ? 0 : _b, detail = _a.detail, expandField = _a.expandField;
                var _c = _this.props.detailRowHeight, detailRowHeight = _c === void 0 ? 0 : _c;
                detailRowHeight = Boolean(detail && expandField) ? detailRowHeight : rowHeight;
                if (_this.isAllData()) {
                    _this.vs.total = _this._data.length;
                    _this._slicedData = _this._data.slice(_this.vs.realSkip, _this.vs.realSkip + _this.vs.pageSize);
                    _this.vs.rowHeightService = _this.rowHeightService(_this.vs, _this._data.length, rowHeight, detailRowHeight, _this._data);
                }
                else {
                    _this.vs.rowHeightService = new RowHeightService(total, rowHeight, detailRowHeight);
                }
                var containerHeight = _this.vs.rowHeightService.totalHeight();
                _this.vs.containerHeight = firefox$1 ? Math.min(firefoxMaxHeight, containerHeight) : containerHeight;
            }
        };
        _this.scrollHandler = function (event) {
            if (event.target !== event.currentTarget) {
                return;
            }
            clearTimeout(_this.forceUpdateTimeout);
            _this.vs.table = _this.tableElement;
            var scrollLeft = event.currentTarget.scrollLeft;
            var scrollTop = event.currentTarget.scrollTop;
            if (_this.props.columnVirtualization && (!_this.vs.scrollableVirtual || scrollTop === _this.wrapperScrollTop)) {
                _this.forceUpdateTimeout = window.setTimeout(function () { _this.forceUpdate(); }, 0);
            }
            if (_this._header) {
                _this._header.setScrollLeft(scrollLeft);
            }
            if (_this._footer) {
                _this._footer.setScrollLeft(scrollLeft);
            }
            if (_this.vs && scrollTop !== _this.wrapperScrollTop) {
                _this.vs.scrollHandler(event);
            }
            dispatchEvent$2(_this.props.onScroll, event, _this, undefined);
            _this.wrapperScrollTop = scrollTop;
        };
        _this.onKeyDown = function (event) {
            tableKeyboardNavigation.onKeyDown(event, {
                contextStateRef: _this.contextStateRef,
                navigationStateRef: _this.navigationStateRef,
                onNavigationAction: _this.onNavigationAction
            });
            if (_this.props.onKeyDown) {
                var _a = getSelectionOptions(_this.props.selectable), mode = _a.mode, cell = _a.cell;
                var ev = __assign$8({ dataItems: _this.getLeafDataItems(), mode: mode, cell: cell, componentId: _this._gridId, selectedField: _this.props.selectedField }, _this.getArguments(event));
                _this.props.onKeyDown.call(undefined, ev);
            }
        };
        _this.onFocus = function (event) {
            tableKeyboardNavigation.onFocus(event, {
                contextStateRef: _this.contextStateRef
            });
        };
        _this.onNavigationAction = function (options) {
            if (_this.props.onNavigationAction) {
                var ev = __assign$8({ focusElement: options.focusElement }, _this.getArguments(options.event));
                _this.props.onNavigationAction.call(undefined, ev);
            }
        };
        _this.rowClick = function (e, item) {
            if (_this.props.onRowClick && e.target.nodeName === 'TD') {
                _this.props.onRowClick.call(undefined, __assign$8({ dataItem: item.dataItem }, _this.getArguments(e)));
            }
        };
        _this.rowDblClick = function (e, item) {
            if (_this.props.onRowDoubleClick && e.target.nodeName === 'TD') {
                _this.props.onRowDoubleClick.call(undefined, __assign$8({ dataItem: item.dataItem }, _this.getArguments(e)));
            }
        };
        _this.itemChange = function (event) {
            var itemChange = _this.props.onItemChange;
            if (event.field === _this.props.expandField || _this.props.group && event.field === undefined) {
                var expandChange = _this.props.onExpandChange;
                if (expandChange) {
                    expandChange.call(undefined, __assign$8(__assign$8({}, _this.getArguments(event.syntheticEvent)), { dataItem: event.dataItem, dataIndex: event.dataIndex, value: event.value }));
                }
                return;
            }
            if (itemChange) {
                itemChange.call(undefined, __assign$8(__assign$8({}, _this.getArguments(event.syntheticEvent)), { dataItem: event.dataItem, field: event.field, value: event.value }));
            }
        };
        _this.onHeaderSelectionChange = function (event) {
            if (_this.props.onHeaderSelectionChange) {
                _this.props.onHeaderSelectionChange.call(undefined, {
                    field: event.field,
                    nativeEvent: event.syntheticEvent && event.syntheticEvent.nativeEvent,
                    syntheticEvent: event.syntheticEvent,
                    target: _this,
                    dataItems: _this.getLeafDataItems(),
                    selectedField: _this.props.selectedField
                });
            }
        };
        _this.selectionRelease = function (event) {
            if (_this.props.onSelectionChange) {
                var selectionEvent = __assign$8({ syntheticEvent: undefined, target: _this, selectedField: _this.props.selectedField || '', componentId: _this._gridId, dataItems: _this.getLeafDataItems(), dataItem: null }, event);
                _this.props.onSelectionChange.call(undefined, selectionEvent);
            }
        };
        _this.pageChange = function (page, syntheticEvent, targetEvent) {
            _this.raiseDataEvent(_this.props.onPageChange, { page: page }, { skip: page.skip, take: page.take }, syntheticEvent, targetEvent);
        };
        _this.pagerPageChange = function (event) {
            _this.pageChange({ skip: event.skip, take: event.take }, event.syntheticEvent, event.targetEvent);
        };
        _this.sortChange = function (sort, syntheticEvent) {
            _this.raiseDataEvent(_this.props.onSortChange, { sort: sort }, __assign$8({ sort: sort }, (_this.props.scrollable === 'virtual' ? { skip: 0 } : {})), syntheticEvent);
        };
        _this.filterChange = function (filter, syntheticEvent) {
            _this.raiseDataEvent(_this.props.onFilterChange, { filter: filter }, { filter: filter || undefined, skip: 0 }, syntheticEvent);
        };
        _this.groupChange = function (groups, event) {
            var syntheticEvent = event.nativeEvent ?
                event : { nativeEvent: event.nativeEvent || event.originalEvent };
            _this.raiseDataEvent(_this.props.onGroupChange, { group: groups }, { group: groups, skip: 0 }, syntheticEvent);
        };
        _this.onResize = function (index, newWidth, oldWidth, nativeEvent, end, targetId) {
            _this.resetTableWidth();
            _this._columnsMutations++;
            if (_this.props.onColumnResize) {
                _this.props.onColumnResize.call(undefined, {
                    columns: _this.columns,
                    nativeEvent: nativeEvent,
                    targetColumnId: targetId,
                    index: index,
                    newWidth: newWidth,
                    oldWidth: oldWidth,
                    end: end,
                    target: _this
                });
            }
        };
        _this.reInitVirtualization = memoizeOne(function (_vScrolling, _total, _filter, _group, _sort, useCached) {
            _this.vs.reset();
            var VS = _this.getVirtualScroll(_this.props);
            _this.vs = new VS(useCached);
        });
        _this.flatData = memoizeOne(function (propsData, groupingFooter, skip, group, expandField, _filter, _sort) {
            var flattedData = [];
            var resolvedGroupsCount = flatData(flattedData, propsData, groupingFooter, { index: skip }, group !== undefined, expandField);
            return { flattedData: flattedData, resolvedGroupsCount: resolvedGroupsCount };
        });
        _this.rowHeightService = memoizeOne(function (_vs, total, rowHeight, detailRowHeight, data) {
            return new RowHeightService(total, rowHeight, detailRowHeight, data);
        });
        _this.childrenToArray = memoizeOne(function (children) {
            return React.Children.toArray(children);
        });
        _this.readColumns = memoizeOne(function (children, idPrefix, _mutationsCount) {
            var columnElements = children.filter(function (child) { return child && child.type && child.type.displayName === 'KendoReactGridColumn'; });
            return readColumns(columnElements, _this.columns, { prevId: 0, idPrefix: idPrefix });
        });
        _this.mapColumns = memoizeOne(function (columns) {
            return mapColumns(columns);
        });
        _this.configureColumns = memoizeOne(function (columns, groupCount, idPrefix) {
            if (_this.props.selectedField) {
                columns.filter(function (c) { return c.field === _this.props.selectedField; }).forEach(function (c) {
                    c.width = c.width || '50px';
                    c.cell = c.cell || GridSelectionCell;
                    c.headerCell = c.headerCell || GridHeaderSelectionCell;
                });
            }
            var defaultServiceProps = {
                id: '',
                resizable: true,
                width: '32px',
                title: ' ',
                declarationIndex: -1,
                orderIndex: -1,
                children: [],
                parentIndex: -1,
                depth: 0,
                colSpan: 0,
                rowSpan: 0,
                left: 0,
                right: 0,
                index: 0,
                rightBorder: false,
                ariaColumnIndex: 0,
                isAccessible: true
            };
            var columnIndexOffset = 0;
            if (_this.props.expandField && (_this.props.onExpandChange) && _this.props.detail) {
                columns.unshift(__assign$8(__assign$8({}, defaultServiceProps), { cell: GridHierarchyCell, field: _this.props.expandField, headerClassName: 'k-hierarchy-cell k-header', id: tableKeyboardNavigationTools.generateNavigatableId("".concat(_this._columns.length), idPrefix, 'column') }));
                columnIndexOffset++;
            }
            for (var i = 0; i < groupCount; i++) {
                columns.unshift(__assign$8(__assign$8({}, defaultServiceProps), { isAccessible: false, cell: GridGroupCell, field: 'value', locked: _this.props.lockGroups }));
                columnIndexOffset++;
            }
            columns.slice(columnIndexOffset).forEach(function (c) { return c.parentIndex >= 0 && (c.parentIndex += columnIndexOffset); });
        });
        _this.getHeaderRow = memoizeOne(function (sort, sortable, group, groupable, filter, filterable, filterOperators, headerCellRender, columnMenu, columns, columnsMap) {
            return (React.createElement(HeaderRow, { sort: sort, sortable: sortable, sortChange: _this.sortChange, group: group || [], groupable: groupable, groupChange: _this.groupChange, filter: filter, filterable: filterable, filterOperators: filterOperators, filterChange: _this.filterChange, columnMenu: columnMenu, selectionChange: _this.onHeaderSelectionChange, columns: columns, columnResize: _this.columnResize, pressHandler: _this.dragLogic.pressHandler, dragHandler: _this.dragLogic.dragHandler, releaseHandler: _this.dragLogic.releaseHandler, columnsMap: columnsMap, cellRender: headerCellRender, isRtl: _this.isRtl, dragClue: _this.dragLogic.dragClueRef, headerRef: _this.headerElementRef, containerRef: _this.containerRef }));
        });
        _this.resolveTitle = function (field) {
            var column = _this._columns.find(function (c) { return c.field === field; });
            var title = column && (column.title || column.field);
            return title === undefined ? field : title;
        };
        _this.getLeafDataItems = function () {
            return _this._data.filter(function (item) { return item.rowType === 'data'; }).map(function (item) { return item.dataItem; });
        };
        validatePackage$3(packageMetadata$3);
        var groupable = _this.props.groupable === true ||
            (typeof _this.props.groupable === 'object') && _this.props.groupable.enabled !== false;
        var VS = _this.getVirtualScroll(props);
        _this.vs = new VS(groupable || props.rowHeight === undefined || props.rowHeight === 0);
        _this.dragLogic = new CommonDragLogic(_this.columnReorder.bind(_this), _this.groupReorder.bind(_this), _this.columnToGroup.bind(_this));
        _this.columnResize = new ColumnResize(_this.onResize);
        tableKeyboardNavigation.onConstructor({
            navigatable: Boolean(props.navigatable),
            contextStateRef: _this.contextStateRef,
            navigationStateRef: _this.navigationStateRef,
            idPrefix: _this._gridId
        });
        return _this;
    }
    Object.defineProperty(Grid.prototype, "columns", {
        /* eslint-disable max-len */
        /**
         * A getter of the current columns. Gets the current column width or current columns, or any other [`GridColumnProps`]({% slug api_grid_gridcolumnprops %}) for each defined column. Can be used on each Grid instance. To obtain the instance of the rendered Grid, use the `ref` callback. The following example demonstrates how to reorder the columns by dragging their handlers and check the properties afterwards. You can check the result in the browser console.
         *
         * @example
         * ```jsx
         * class App extends React.Component {
         *     constructor(props) {
         *         super(props);
         *         this.state = {
         *             data: [
         *                 { 'foo': 'A1', 'bar': 'B1' },
         *                 { 'foo': 'A2', 'bar': 'B2' },
         *                 { 'foo': 'A3', 'bar': 'B2' }
         *             ]
         *         };
         *         this.grid = null;
         *     }
         *     render() {
         *         return (
         *             <div>
         *                 <Grid
         *                     data={this.state.data}
         *                     reorderable={true}
         *                     ref={(g) => { this.grid = g; }}
         *                 >
         *                     <GridColumn field="foo" />
         *                     <GridColumn field="bar" />
         *                 </Grid>
         *                 <button onClick={() => console.log(JSON.stringify(this.grid.columns))}>
         *                     log current properties into browser console.
         *                 </button>
         *             </div>
         *         );
         *     }
         * }
         * ReactDOM.render(<App />, document.querySelector('my-app'));
         * ```
         */
        // tslint:enable:max-line-length
        get: function () {
            var shuffledColumns = this._columns.filter(function (q) { return q.declarationIndex >= 0 && q.parentIndex === -1; });
            return sanitizeColumns(shuffledColumns);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "element", {
        /**
         * Returns the HTML element of the Grid component.
         */
        get: function () {
            return this._element;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "document", {
        get: function () {
            if (!canUseDOM$3) {
                return;
            }
            // useful only for user actions
            return (this.element && this.element.ownerDocument) || document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Grid.prototype, "_header", {
        get: function () {
            return this.headerRef.current;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @hidden
     */
    Grid.prototype.componentDidMount = function () {
        this.resetTableWidth();
        setScrollbarWidth$1();
        var rtl = isRtl(this.element);
        this.isRtl = rtl;
        tableKeyboardNavigation.onComponentDidMount({
            scope: this.element || undefined,
            contextStateRef: this.contextStateRef,
            navigationStateRef: this.navigationStateRef
        });
        if (this.isRtl) {
            this.forceUpdate();
        }
    };
    /**
     * @hidden
     */
    Grid.prototype.getSnapshotBeforeUpdate = function () {
        tableKeyboardNavigation.onGetSnapshotBeforeUpdate({
            document: this.document,
            contextStateRef: this.contextStateRef,
            navigationStateRef: this.navigationStateRef
        });
        return null;
    };
    /**
     * @hidden
     */
    Grid.prototype.componentDidUpdate = function () {
        setScrollbarWidth$1();
        if (this.vs.tableTransform && this.vs.table) {
            this.vs.table.style.transform = this.vs.tableTransform;
            this.vs.tableTransform = '';
        }
        tableKeyboardNavigation.onComponentDidUpdate({
            scope: this.element || undefined,
            contextStateRef: this.contextStateRef,
            navigationStateRef: this.navigationStateRef
        });
    };
    /**
     * @hidden
     */
    Grid.prototype.componentWillUnmount = function () {
        clearTimeout(this.forceUpdateTimeout);
    };
    /**
     * @hidden
     */
    Grid.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var total = this.props.total || 0;
        var idPrefix = tableKeyboardNavigationTools.getIdPrefix(this.navigationStateRef);
        var propsData = [];
        if (Array.isArray(this.props.data)) {
            propsData = this.props.data;
            total = total || this.props.data.length;
        }
        else if (this.props.data) {
            propsData = this.props.data.data;
            total = total || this.props.data.total;
        }
        var groupingFooter = (typeof this.props.groupable === 'object') && this.props.groupable.footer || 'none';
        var _d = this.flatData(propsData, groupingFooter, this.props.skip || 0, this.props.group, this.props.expandField, this.props.filter, this.props.sort), resolvedGroupsCount = _d.resolvedGroupsCount, flattedData = _d.flattedData;
        this._data = flattedData;
        var groupable = this.props.groupable === true ||
            (typeof this.props.groupable === 'object') && this.props.groupable.enabled !== false;
        this.columnResize.resizable = this.props.resizable || false;
        this.dragLogic.reorderable = this.props.reorderable || false;
        this.dragLogic.groupable = groupable;
        var tableUserSelect = this.props.selectable && this.props.selectable.drag ? 'none' : undefined;
        this.initializeVirtualization(total, groupable);
        var children = this.childrenToArray(this.props.children);
        this.initColumns(children, resolvedGroupsCount);
        var toolbar = children.filter(function (child) { return child && child.type &&
            child.type.displayName === 'KendoReactGridToolbar'; });
        var noRecords = children.filter(function (child) { return child && child.type &&
            child.type.displayName === 'KendoReactGridNoRecords'; });
        var leafColumns = this._columns.filter(function (c) { return c.children.length === 0; });
        var groupingPanel = groupable && (React.createElement(GroupPanel, { group: this.props.group || [], groupChange: this.groupChange, pressHandler: this.dragLogic.pressHandler, dragHandler: this.dragLogic.dragHandler, releaseHandler: this.dragLogic.releaseHandler, refCallback: this.dragLogic.refGroupPanelDiv, resolveTitle: this.resolveTitle }));
        var _e = this.props, sort = _e.sort, sortable = _e.sortable, group = _e.group, filter = _e.filter, filterable = _e.filterable, _f = _e.filterOperators, filterOperators = _f === void 0 ? operators : _f, headerCellRender = _e.headerCellRender, columnMenu = _e.columnMenu;
        var header = (React.createElement(Header, { size: this.props.size, columnResize: this.columnResize, staticHeaders: this.props.scrollable !== 'none', scrollableDataElement: function () { return _this.vs.container; }, draggable: this.props.reorderable || groupable, ref: this.headerRef, elemRef: this.headerElementRef, headerRow: this.getHeaderRow(sort, sortable, group, groupable, filter, filterable, filterOperators, headerCellRender, columnMenu, this._columns, this._columnsMap), filterRow: this.props.filterable && React.createElement(FilterRow, { size: this.props.size, columns: this._columns, filter: this.props.filter, filterOperators: this.props.filterOperators || operators, filterChange: this.filterChange, sort: this.props.sort, cellRender: this.props.filterCellRender, isRtl: this.isRtl, ariaRowIndex: this._columnsMap.length + 1 }) || undefined, cols: leafColumns.map(function (column, index) { return (React.createElement("col", { key: index.toString(), width: column.width !== undefined ?
                    Math.floor(parseFloat(column.width.toString())) + 'px' : undefined })); }) }));
        var scrollLeft = this.vs && this.vs.container && this.vs.container.scrollLeft || 0;
        var tableWidth = parseFloat(((this.props.style || {}).width || '').toString());
        var _g = tableColumnsVirtualization({
            enabled: this.props.columnVirtualization,
            columns: leafColumns,
            tableViewPortWidth: tableWidth,
            scrollLeft: scrollLeft
        }), colSpans = _g.colSpans, isColHidden = _g.hiddenColumns;
        var dataRow = function (item, rowId, rowDataIndex) {
            var isInEdit = false;
            var selectedValue = _this.props.selectedField ? getNestedValue(_this.props.selectedField, item.dataItem) : undefined;
            return {
                row: leafColumns.map(function (column, columnIndex) {
                    if (isColHidden[columnIndex]) {
                        return null;
                    }
                    var columnKey = column.id ? column.id : columnIndex;
                    var className = "".concat(column.className ? column.className + ' ' : '')
                        + "".concat(column.locked ? 'k-grid-content-sticky' : '');
                    var style = column.left !== undefined
                        ? !_this.isRtl
                            ? { left: column.left, right: column.right }
                            : { left: column.right, right: column.left }
                        : {};
                    var currentColumnIsInEdit = false;
                    if (column.editable && _this.props.editField) {
                        var inEdit = getNestedValue(_this.props.editField, item.dataItem);
                        if (inEdit === true || inEdit === column.field) {
                            isInEdit = true;
                            currentColumnIsInEdit = true;
                        }
                    }
                    var Cell = column.cell || (currentColumnIsInEdit && GridEditCell) || GridCell;
                    return (React.createElement(Cell, { onContextMenu: _this.onContextMenu, key: columnKey, locked: _this.props.lockGroups, id: tableKeyboardNavigationTools.generateNavigatableId("".concat(rowId, "-").concat(String(columnIndex)), idPrefix), colSpan: colSpans[columnIndex], dataItem: item.dataItem, field: column.field, editor: column.editor, format: column.format, className: className, render: _this.props.cellRender, onChange: _this.itemChange, selectionChange: (_this.props.onSelectionChange) ?
                            (function (e) { _this.selectionChange({ event: e, dataItem: item.dataItem, dataIndex: rowDataIndex, columnIndex: columnIndex }); }) :
                            undefined, columnIndex: columnIndex, columnsCount: leafColumns.length, rowType: item.rowType, level: item.level, expanded: item.expanded, dataIndex: item.dataIndex, style: style, ariaColumnIndex: column.ariaColumnIndex, isSelected: Array.isArray(selectedValue) && selectedValue.indexOf(columnIndex) > -1 }));
                }),
                isInEdit: isInEdit,
                isSelected: typeof selectedValue === 'boolean' && selectedValue
            };
        };
        var hiddenRows = 0;
        if (this.props.scrollable === 'virtual') {
            for (var i = 0; i < this.vs.topCacheCount + this.vs.attendedSkip - (this.props.skip || 0); i++) {
                var item = this._data.shift();
                if (item) {
                    this._data.push(item);
                    hiddenRows++;
                    if (item.rowType === 'groupHeader') {
                        i--;
                    }
                }
                else {
                    break;
                }
            }
        }
        var hidden = function (index) {
            return (index >= _this._data.length - hiddenRows);
        };
        var absoluteDataIndex = this.vs.realSkip || 0;
        var body = [];
        var rowIndexStart = this._columnsMap.length + (this.props.filterable ? 1 : 0) + 1;
        var currentAriaRowIndex = 0;
        if (this._data.length) {
            var dataIndex_1 = -1;
            var detailRowCount_1 = 0;
            (this._slicedData || this._data).forEach(function (item, rowIndex) {
                if (item.rowType === 'data') {
                    absoluteDataIndex++;
                    dataIndex_1++;
                }
                var isAlt = absoluteDataIndex % 2 === 0;
                var dataItemKey = _this.props.dataItemKey && getter$1(_this.props.dataItemKey)(item.dataItem);
                var absoluteIndex = rowIndex + (_this.vs.realSkip || 0);
                var rowId = dataItemKey ? dataItemKey : 'ai' + absoluteIndex;
                var detailRowId = rowId + '_1';
                var gridRow = dataRow(item, rowId, dataIndex_1);
                currentAriaRowIndex = absoluteIndex + rowIndexStart + detailRowCount_1;
                body.push((React.createElement(GridRow, { key: rowId, dataItem: item.dataItem, isAltRow: isAlt, isInEdit: gridRow.isInEdit, rowType: item.rowType, isHidden: hidden(rowIndex), onClick: function (e) { return _this.rowClick(e, item); }, onDoubleClick: function (e) { return _this.rowDblClick(e, item); }, selectedField: _this.props.selectedField, rowHeight: _this.props.rowHeight, render: _this.props.rowRender, ariaRowIndex: currentAriaRowIndex, dataIndex: dataIndex_1, isSelected: gridRow.isSelected }, gridRow.row)));
                if (_this.props.detail && item.rowType === 'data' && item.expanded) {
                    var detailColspan = (leafColumns.length
                        - (_this.props.expandField ? 1 : 0)
                        - (_this.props.group ? _this.props.group.length : 0)) || 1;
                    detailRowCount_1++;
                    currentAriaRowIndex = absoluteIndex + rowIndexStart + detailRowCount_1;
                    body.push((React.createElement("tr", { key: detailRowId, className: classNames$3('k-table-row', isAlt ? 'k-detail-row k-table-alt-row k-alt' : 'k-detail-row'), style: { visibility: hidden(rowIndex) ? 'hidden' : '', height: _this.props.detailRowHeight }, role: "row", "aria-rowindex": currentAriaRowIndex },
                        _this.props.group && _this.props.group.map(function (gr, idx) {
                            var _a;
                            var columnStyle = (_a = gridRow === null || gridRow === void 0 ? void 0 : gridRow.row[idx]) === null || _a === void 0 ? void 0 : _a.props.style;
                            var style = columnStyle
                                ? !_this.isRtl
                                    ? { left: columnStyle.left, right: columnStyle.right }
                                    : { left: columnStyle.right, right: columnStyle.left }
                                : {};
                            return (React.createElement(GridGroupCell, { id: '', dataIndex: item.dataIndex, field: gr.field, dataItem: item.dataItem, key: idx, style: style, ariaColumnIndex: 1 + idx, isSelected: false, locked: _this.props.lockGroups }));
                        }),
                        _this.props.expandField &&
                            React.createElement(GridDetailHierarchyCell, { id: tableKeyboardNavigationTools.generateNavigatableId("".concat(detailRowId, "-dhcell"), idPrefix) }),
                        React.createElement(GridDetailCell, { onContextMenu: _this.onContextMenu, dataItem: item.dataItem, dataIndex: item.dataIndex, colSpan: detailColspan, ariaColIndex: 2 + (_this.props.group ? _this.props.group.length : 0), detail: _this.props.detail, id: tableKeyboardNavigationTools.generateNavigatableId("".concat(detailRowId, "-dcell"), idPrefix) }))));
                }
            });
        }
        else {
            body.push((React.createElement("tr", { key: "no-records", className: "k-table-row k-grid-norecords", role: 'row', "aria-rowindex": rowIndexStart },
                React.createElement("td", { className: 'k-table-td', colSpan: leafColumns.length, role: 'gridcell' }, noRecords.length ? noRecords : React.createElement(GridNoRecords, null)))));
        }
        var pagerProps = __assign$8({ size: this.props.size, onPageChange: this.pagerPageChange, total: total, skip: this.vs.propsSkip || 0, take: (this.props.take !== undefined ? this.props.take : this.props.pageSize) || 10, messagesMap: pagerMessagesMap }, (normalize(this.props.pageable || {})));
        var pager = this.props.pager ? React.createElement(this.props.pager, __assign$8({}, pagerProps)) : React.createElement(Pager, __assign$8({ className: "k-grid-pager" }, pagerProps));
        var sorted = function (field) {
            return _this.props.sort && _this.props.sort.filter(function (descriptor) { return descriptor.field === field; }).length > 0;
        };
        var footer = this._columns.some(function (c) { return Boolean(c.footerCell); }) ? (React.createElement(Footer, { size: this.props.size, columnResize: this.columnResize, staticHeaders: this.props.scrollable !== 'none', ref: function (f) { return _this._footer = f; }, row: React.createElement(FooterRow, { columns: this._columns, isRtl: this.isRtl, ariaRowIndex: currentAriaRowIndex + 1 }), cols: leafColumns.map(function (column, index) { return (React.createElement("col", { key: index.toString(), width: column.width !== undefined ?
                    Math.floor(parseFloat(column.width.toString())) + 'px' : undefined })); }) })) : null;
        var colGroups = (React.createElement("colgroup", { ref: function (c) {
                _this.columnResize.colGroupMain = c;
            } }, leafColumns.map(function (column, index) { return (React.createElement("col", { key: index.toString(), className: sorted(column.field) ? 'k-sorted' : undefined, width: column.width !== undefined ?
                Math.floor(parseFloat(column.width.toString())) + 'px' : undefined })); })));
        var enableDragClues = this.dragLogic.reorderable || this.dragLogic.groupable;
        var tableDisplay = this.props.columnVirtualization ? 'block' : 'table';
        if (this.props.scrollable === 'none') {
            return (React.createElement(TableKeyboardNavigationContext.Provider, { value: this.contextStateRef.current },
                React.createElement("div", __assign$8({ id: this.props.id, style: this.props.style, className: classNames$3('k-grid', (_a = {
                            'k-grid-md': !this.props.size
                        },
                        _a["k-grid-".concat(kendoThemeMaps$2.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                        _a), this.props.className), ref: function (el) { _this._element = el; }, "aria-label": this.props.ariaLabel, onKeyDown: this.onKeyDown, onFocus: this.onFocus }, tableKeyboardNavigationScopeAttributes),
                    toolbar,
                    groupingPanel,
                    React.createElement(TableSelection, { selectable: this.props.selectable, onRelease: this.selectionRelease, childRef: function (table) {
                            _this.tableElement = table;
                        } },
                        React.createElement("table", { style: { userSelect: tableUserSelect, display: tableDisplay } },
                            colGroups,
                            header,
                            React.createElement("tbody", __assign$8({ role: 'rowgroup', className: 'k-table-tbody' }, tableKeyboardNavigationBodyAttributes), body),
                            footer)),
                    this.props.pageable && pager,
                    enableDragClues && (React.createElement(React.Fragment, null,
                        React.createElement(DropClue, { ref: this.dragLogic.refDropElementClue }),
                        React.createElement(DragClue, { ref: this.dragLogic.refDragElementClue }))))));
        }
        var wrapperStyle = this.props.style || {};
        if (this.props.scrollable === 'virtual') {
            // Set the default height for vs if not existing.
            if (!wrapperStyle.height) {
                wrapperStyle = Object.assign({}, wrapperStyle, { height: '450px' });
            }
        }
        return (React.createElement(TableKeyboardNavigationContext.Provider, { value: this.contextStateRef.current },
            React.createElement("div", __assign$8({ id: this.props.id, style: wrapperStyle, className: classNames$3('k-grid', (_b = {
                        'k-grid-md': !this.props.size
                    },
                    _b["k-grid-".concat(kendoThemeMaps$2.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                    _b['k-grid-virtual'] = this.props.scrollable === 'virtual',
                    _b), this.props.className), ref: function (el) {
                    _this._element = el;
                }, role: "grid", "aria-colcount": leafColumns.length, "aria-rowcount": total, "aria-label": this.props.ariaLabel, onKeyDown: this.onKeyDown, onFocus: this.onFocus }, tableKeyboardNavigationScopeAttributes),
                toolbar,
                groupingPanel,
                header,
                React.createElement("div", { className: "k-grid-container", role: "presentation" },
                    React.createElement("div", { ref: this.containerRef, className: "k-grid-content k-virtual-content", onScroll: this.scrollHandler, role: "presentation" },
                        React.createElement("div", { className: 'k-grid-table-wrap', role: "presentation" },
                            React.createElement(TableSelection, { selectable: this.props.selectable, onRelease: this.selectionRelease, childRef: function (table) {
                                    _this.tableElement = table;
                                } },
                                React.createElement("table", { className: classNames$3('k-table k-grid-table', (_c = {
                                            'k-table-md': !this.props.size
                                        },
                                        _c["k-table-".concat(kendoThemeMaps$2.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                                        _c)), role: "presentation", style: { userSelect: tableUserSelect, display: tableDisplay } },
                                    colGroups,
                                    React.createElement("tbody", __assign$8({ className: 'k-table-tbody', ref: this.tableBodyRef, role: 'rowgroup' }, tableKeyboardNavigationBodyAttributes), body)))),
                        React.createElement("div", { className: "k-height-container", role: "presentation" },
                            React.createElement("div", { style: this.props.scrollable === 'virtual' ?
                                    { 'height': (this.vs.containerHeight) + 'px' } : {} })))),
                footer,
                this.props.pageable && pager,
                enableDragClues && (React.createElement(React.Fragment, null,
                    React.createElement(DropClue, { ref: this.dragLogic.refDropElementClue }),
                    React.createElement(DragClue, { ref: this.dragLogic.refDragElementClue }))))));
    };
    Grid.prototype.selectionChange = function (options) {
        if (this.props.onSelectionChange) {
            var event_1 = options.event, dataItem = options.dataItem, dataIndex = options.dataIndex, columnIndex = options.columnIndex;
            var _a = getSelectionOptions(this.props.selectable), mode = _a.mode, cell = _a.cell;
            var selectionEvent = __assign$8(__assign$8({}, this.getArguments(event_1.syntheticEvent)), { dataItem: dataItem, startColIndex: columnIndex, endColIndex: columnIndex, startRowIndex: dataIndex, endRowIndex: dataIndex, dataItems: this.getLeafDataItems(), altKey: false, ctrlKey: false, shiftKey: false, metaKey: false, mode: mode, cell: cell, isDrag: false, componentId: this._gridId, selectedField: this.props.selectedField || '' });
            this.props.onSelectionChange.call(undefined, selectionEvent);
        }
    };
    Grid.prototype.raiseDataEvent = function (handler, data, moreData, syntheticEvent, targetEvent) {
        var dataStateChange = this.props.onDataStateChange;
        if (handler) {
            var ev = __assign$8(__assign$8(__assign$8({}, this.getArguments(syntheticEvent)), data), { targetEvent: targetEvent });
            handler.call(undefined, ev);
        }
        else if (dataStateChange) {
            dataStateChange.call(undefined, __assign$8(__assign$8({}, this.getArguments(syntheticEvent)), { targetEvent: targetEvent || {}, dataState: __assign$8(__assign$8({}, this.getDataState()), moreData) }));
        }
    };
    Grid.prototype.columnReorder = function (prev, next, nativeEvent) {
        var _a;
        var _this = this;
        var column = this._columns[prev];
        var depth = column.depth;
        var end = function (index) {
            do {
                index++;
            } while (index < _this._columns.length && _this._columns[index].depth > depth);
            return index;
        };
        var spliced = this._columns.splice(prev, end(prev) - prev);
        (_a = this._columns).splice.apply(_a, __spreadArray$2([prev < next ? end(next - spliced.length) : next, 0], spliced, false));
        this._columns.filter(function (q) { return q.declarationIndex >= 0; }).forEach(function (c, i) { return c.orderIndex = i; });
        this._columnsMutations++;
        var eventColumnProps = this.columns;
        this.forceUpdate();
        if (this.props.onColumnReorder) {
            var reorderEvent = {
                target: this,
                columns: eventColumnProps,
                columnId: column.id,
                nativeEvent: nativeEvent
            };
            this.props.onColumnReorder.call(undefined, reorderEvent);
        }
    };
    Grid.prototype.groupReorder = function (prevIndex, nextIndex, nativeEvent) {
        if (this.props.group === undefined) {
            return;
        }
        var group = this.props.group.slice();
        group.splice.apply(group, __spreadArray$2([nextIndex, 0], group.splice(prevIndex, 1), false));
        this.groupChange(group, nativeEvent);
    };
    Grid.prototype.columnToGroup = function (columnIndex, groupIndex, nativeEvent) {
        var field = this._columns[columnIndex].field;
        if (!field) {
            return;
        }
        var group = (this.props.group || []).slice();
        group.splice(groupIndex, 0, { field: field });
        this.groupChange(group, nativeEvent);
    };
    Grid.prototype.resetTableWidth = function () {
        var totalWidth = 0;
        if (!this.columnResize.colGroupMain) {
            return;
        }
        var colElements = this.columnResize.colGroupMain.children;
        for (var i = 0; i < colElements.length; i++) {
            var width = colElements[i].width;
            if (!width) {
                return;
            }
            totalWidth += parseFloat(width.toString());
        }
        totalWidth = Math.round(totalWidth);
        if (this._header) {
            this._header.setWidth(totalWidth);
        }
        if (this._footer) {
            this._footer.setWidth(totalWidth);
        }
        if (this.tableElement) {
            this.tableElement.style.width = totalWidth + 'px';
        }
    };
    Grid.prototype.initColumns = function (children, groupCount) {
        var idPrefix = tableKeyboardNavigationTools.getIdPrefix(this.navigationStateRef);
        this._columns = this.readColumns(children, idPrefix, this._columnsMutations);
        if (this._columns.length === 0) {
            this._columns = autoGenerateColumns(this.props.data, this.props.group, this.props.expandField, { prevId: 0, idPrefix: idPrefix });
        }
        this.configureColumns(this._columns, groupCount, idPrefix);
        this._columnsMap = this.mapColumns(this._columns);
        this.columnResize.columns = this._columns;
        this.dragLogic.columns = this._columns;
    };
    Grid.prototype.getDataState = function () {
        return {
            filter: this.props.filter,
            sort: this.props.sort,
            skip: this.props.skip,
            take: (this.props.take !== undefined ? this.props.take : this.props.pageSize),
            group: this.props.group
        };
    };
    Grid.prototype.getArguments = function (syntheticEvent) {
        return {
            nativeEvent: syntheticEvent && syntheticEvent.nativeEvent,
            syntheticEvent: syntheticEvent,
            target: this
        };
    };
    /**
     * @hidden
     */
    Grid.displayName = 'KendoReactGrid';
    /**
     * @hidden
     */
    Grid.defaultProps = {
    // never use this
    };
    /**
     * @hidden
     */
    Grid.propTypes = {
        data: propTypes.exports.oneOfType([
            propTypes.exports.array,
            propTypes.exports.shape({
                data: propTypes.exports.array,
                total: propTypes.exports.number
            })
        ]),
        sortable: propTypes.exports.oneOfType([
            propTypes.exports.bool,
            propTypes.exports.shape({
                mode: propTypes.exports.oneOf(['single', 'multiple']),
                allowUnsort: propTypes.exports.bool
            })
        ]),
        onSortChange: propTypes.exports.func,
        sort: propTypes.exports.array,
        filterable: propTypes.exports.bool,
        filter: propTypes.exports.any,
        onFilterChange: propTypes.exports.func,
        pageable: propTypes.exports.oneOfType([
            propTypes.exports.bool,
            propTypes.exports.shape({
                buttonCount: propTypes.exports.number,
                info: propTypes.exports.bool,
                type: propTypes.exports.oneOf(['numeric', 'input']),
                pageSizes: propTypes.exports.oneOfType([
                    propTypes.exports.bool,
                    propTypes.exports.arrayOf(propTypes.exports.oneOfType([
                        propTypes.exports.string,
                        propTypes.exports.number
                    ]))
                ]),
                previousNext: propTypes.exports.bool
            })
        ]),
        pageSize: propTypes.exports.number,
        onPageChange: propTypes.exports.func,
        total: propTypes.exports.number,
        skip: propTypes.exports.number,
        take: propTypes.exports.number,
        fixedScroll: propTypes.exports.bool,
        onExpandChange: propTypes.exports.func,
        expandField: propTypes.exports.string,
        selectedField: propTypes.exports.string,
        onSelectionChange: propTypes.exports.func,
        onHeaderSelectionChange: propTypes.exports.func,
        resizable: propTypes.exports.bool,
        reorderable: propTypes.exports.bool,
        group: propTypes.exports.any,
        groupable: propTypes.exports.oneOfType([
            propTypes.exports.bool,
            propTypes.exports.shape({
                enabled: propTypes.exports.bool,
                footer: propTypes.exports.oneOf(['always', 'visible', 'none'])
            })
        ]),
        onGroupChange: propTypes.exports.func,
        onRowClick: propTypes.exports.func,
        onRowDoubleClick: propTypes.exports.func,
        onItemChange: propTypes.exports.func,
        editField: propTypes.exports.string,
        scrollable: propTypes.exports.oneOf(['none', 'scrollable', 'virtual']),
        rowHeight: propTypes.exports.number,
        detailRowHeight: propTypes.exports.number,
        detail: propTypes.exports.any,
        style: propTypes.exports.object,
        onDataStateChange: propTypes.exports.func,
        onColumnResize: propTypes.exports.func,
        onColumnReorder: propTypes.exports.func,
        dataItemKey: propTypes.exports.string,
        navigatable: propTypes.exports.bool,
        size: propTypes.exports.oneOf(['small', 'medium'])
    };
    /** @hidden */
    Grid.contextType = TableKeyboardNavigationContext;
    return Grid;
}(React.Component));

var __extends$c = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * The GridColumnMenuItemGroup that will be used inside the Grid ColumnMenu.
 */
var GridColumnMenuItemGroup = /** @class */ (function (_super) {
    __extends$c(GridColumnMenuItemGroup, _super);
    function GridColumnMenuItemGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridColumnMenuItemGroup.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement("div", { id: this.props.id, className: classNames$3('k-columnmenu-item-wrapper', this.props.className), style: this.props.style }, children));
    };
    return GridColumnMenuItemGroup;
}(React.Component));

var __extends$b = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * The GridColumnMenuItem component that is used inside the Grid ColumnMenu.
 */
var GridColumnMenuItem = /** @class */ (function (_super) {
    __extends$b(GridColumnMenuItem, _super);
    function GridColumnMenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        return _this;
    }
    /**
     * @hidden
     */
    GridColumnMenuItem.prototype.render = function () {
        var _a = this.props, title = _a.title, iconClass = _a.iconClass, svgIcon = _a.svgIcon, selected = _a.selected;
        return (React.createElement("div", { onClick: this.onClick, className: "k-columnmenu-item ".concat(selected ? 'k-selected' : '') },
            (iconClass || svgIcon) && React.createElement(IconWrap, { name: iconClass ? toIconName(iconClass) : iconClass, icon: svgIcon }),
            title));
    };
    return GridColumnMenuItem;
}(React.Component));

var __extends$a = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var ASC_DIR = 'asc';
/**
 * @hidden
 */
var DESC_DIR = 'desc';
/**
 * @hidden
 */
var sortSeqMap = {
    true: {
        'asc': { 'asc': '', 'desc': 'desc' },
        'desc': { 'asc': 'asc', 'desc': '' },
        '': { 'asc': 'asc', 'desc': 'desc' }
    },
    false: {
        'asc': { 'asc': 'asc', 'desc': 'desc' },
        'desc': { 'asc': 'asc', 'desc': 'desc' },
        '': { 'asc': 'asc', 'desc': 'desc' }
    }
};
/**
 * @hidden
 */
var sortIndex = function (field, sort) {
    if (!sort) {
        return -1;
    }
    return sort.findIndex(function (s) { return s.field === field; });
};
/**
 * @hidden
 */
var sortedAsc = function (sortedIndex, sort) {
    return !!(sort && sortedIndex > -1 && sort[sortedIndex].dir === ASC_DIR);
};
/**
 * @hidden
 */
var sortedDesc = function (sortedIndex, sort) {
    return !!(sort && sortedIndex > -1 && sort[sortedIndex].dir === DESC_DIR);
};
/**
 * @example
 * ```jsx-no-run
 * class ColumnMenu extends React.Component {
 *     render() {
 *         return (
 *         <div>
 *             <GridColumnMenuSort {...this.props} />
 *         </div>);
 *     }
 * }
 *
 * class App extends React.PureComponent {
 *     constructor(props) {
 *         super(props);
 *
 *         this.state = this.createAppState({
 *             take: 10,
 *             skip: 0
 *         });
 *     }
 *
 *     createAppState(dataState) {
 *         return {
 *             result: process(products.slice(0), dataState),
 *             dataState: dataState
 *         };
 *     }
 *
 *     dataStateChange = (event) => {
 *         this.setState(this.createAppState(event.dataState));
 *     }
 *
 *     render() {
 *         return (
 *             <div>
 *                 <Grid
 *                     data={this.state.result}
 *                     {...this.state.dataState}
 *                     onDataStateChange={this.dataStateChange}
 *                     sortable={true}
 *                     pageable={true}
 *                 >
 *                     <Column field="ProductID" title="Product ID" columnMenu={ColumnMenu}/>
 *                     <Column field="ProductName" />
 *                 </Grid>
 *                 <br />
 *             </div>
 *         );
 *     }
 * }
 *
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var GridColumnMenuSort = /** @class */ (function (_super) {
    __extends$a(GridColumnMenuSort, _super);
    function GridColumnMenuSort() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * @hidden
         */
        _this.onAscClick = function (event) {
            _this.onSort(event, ASC_DIR);
            if (_this.props.onCloseMenu) {
                _this.props.onCloseMenu();
            }
        };
        /**
         * @hidden
         */
        _this.onDescClick = function (event) {
            _this.onSort(event, DESC_DIR);
            if (_this.props.onCloseMenu) {
                _this.props.onCloseMenu();
            }
        };
        /**
         * @hidden
         */
        _this.onSort = function (event, selectedDir) {
            event.preventDefault();
            if (!_this.props.onSortChange) {
                return;
            }
            var _a = _this.props, column = _a.column, sortable = _a.sortable, sort = _a.sort;
            var _b = normalize$1(sortable || false, false), allowUnsort = _b.allowUnsort, mode = _b.mode;
            var oldDescriptor = (sort || []).filter(function (d) { return d.field === column.field; })[0];
            var dir = sortSeqMap[allowUnsort][oldDescriptor && oldDescriptor.dir || ''][selectedDir];
            var newDescriptor = (mode === 'single') ?
                [] : (_this.props.sort || []).filter(function (d) { return d.field !== column.field; });
            if (dir !== '' && column.field) {
                newDescriptor.push({ field: column.field, dir: dir });
            }
            _this.props.onSortChange(newDescriptor, event);
        };
        return _this;
    }
    /**
     * @hidden
     */
    GridColumnMenuSort.prototype.render = function () {
        var _a = this.props, sort = _a.sort, column = _a.column;
        var currentSortIndex = sortIndex(column.field, sort);
        var localizationService = provideLocalizationService(this);
        return (React.createElement(GridColumnMenuItemGroup, null,
            React.createElement(GridColumnMenuItem, { title: localizationService.toLanguageString(sortAscending, messages[sortAscending]), iconClass: 'k-i-sort-asc-sm', svgIcon: sortAscSmallIcon, selected: sortedAsc(currentSortIndex, sort), onClick: this.onAscClick }),
            React.createElement(GridColumnMenuItem, { title: localizationService.toLanguageString(sortDescending, messages[sortDescending]), iconClass: 'k-i-sort-desc-sm', svgIcon: sortDescSmallIcon, selected: sortedDesc(currentSortIndex, sort), onClick: this.onDescClick })));
    };
    /* eslint-disable max-len */
    /**
     * Can be used to check if sorting is applied to a specific field ([see example]({% slug column_menu_grid %}#toc-styling-the-column-menu-icon)). Useful for creating active sort indicators.
     */
    // tslint:enable:max-line-length
    GridColumnMenuSort.active = function (field, sort) {
        var currentSortIndex = sortIndex(field, sort);
        return sortedDesc(currentSortIndex, sort) || sortedAsc(currentSortIndex, sort);
    };
    return GridColumnMenuSort;
}(React.Component));
registerForIntl(GridColumnMenuSort);
registerForLocalization(GridColumnMenuSort);

var __extends$9 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * The GridColumnMenuItemContent that will be used inside the Grid ColumnMenu.
 */
var GridColumnMenuItemContent = /** @class */ (function (_super) {
    __extends$9(GridColumnMenuItemContent, _super);
    function GridColumnMenuItemContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridColumnMenuItemContent.prototype.render = function () {
        return (React.createElement("div", { id: this.props.id, className: classNames$3('k-columnmenu-item-content', this.props.className), style: this.props.style },
            React.createElement(Reveal, { style: { position: 'relative', display: 'block' } }, this.props.show ? this.props.children : null)));
    };
    return GridColumnMenuItemContent;
}(React.Component));

var __extends$8 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @hidden
 */
var GridColumnMenuFilterCell = /** @class */ (function (_super) {
    __extends$8(GridColumnMenuFilterCell, _super);
    function GridColumnMenuFilterCell(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOperatorEditor = function () {
            if (_this.props.filterType === 'boolean') {
                return;
            }
            var value = _this.props.operators.find(function (item) { return item.operator === _this.props.operator; }) || null;
            return (React.createElement(DropDownList, { value: value, onChange: _this.operatorChange, data: _this.props.operators, textField: "text" }));
        };
        _this.inputChange = _this.inputChange.bind(_this);
        _this.operatorChange = _this.operatorChange.bind(_this);
        _this.boolDropdownChange = _this.boolDropdownChange.bind(_this);
        return _this;
    }
    /**
     * @hidden
     */
    GridColumnMenuFilterCell.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.renderOperatorEditor(),
            this.filterComponent(this.props.filterType, this.props.value, this.props.booleanValues)));
    };
    GridColumnMenuFilterCell.prototype.inputChange = function (value, e) {
        cellInputChange(value, e, this.props);
    };
    GridColumnMenuFilterCell.prototype.operatorChange = function (event) {
        cellOperatorChange(event, this.props.value, this.props.onChange);
    };
    GridColumnMenuFilterCell.prototype.boolDropdownChange = function (event) {
        cellBoolDropdownChange(event, this.props.onChange);
    };
    GridColumnMenuFilterCell.prototype.filterComponent = function (filterType, value, booleanValues) {
        var _this = this;
        switch (filterType) {
            case 'numeric':
                return (React.createElement(NumericTextBox, { value: value, onChange: function (e) { _this.inputChange(e.value, e.syntheticEvent); }, rangeOnEnter: false }));
            case 'date':
                return (React.createElement(DatePicker, { value: value, onChange: function (e) { _this.inputChange(e.value, e.syntheticEvent); } }));
            case 'boolean':
                var noFilterSet_1 = function (filter) { return filter === null || filter === undefined; };
                return (React.createElement(DropDownList, { onChange: this.boolDropdownChange, value: booleanValues.find(function (item) { return item.operator === (noFilterSet_1(value) ? '' : value); }), data: booleanValues, textField: "text" }));
            default: return (React.createElement(Input, { value: value || '', onChange: function (e) { _this.inputChange(e.target.value, e.syntheticEvent); } }));
        }
    };
    return GridColumnMenuFilterCell;
}(React.Component));

var __extends$7 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$7 = (undefined && undefined.__assign) || function () {
    __assign$7 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$7.apply(this, arguments);
};
/**
 * @hidden
 */
var GridColumnMenuFilterUI = /** @class */ (function (_super) {
    __extends$7(GridColumnMenuFilterUI, _super);
    function GridColumnMenuFilterUI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridColumnMenuFilterUI.prototype.render = function () {
        var _a = this.props, firstFilterProps = _a.firstFilterProps, hideSecondFilter = _a.hideSecondFilter, secondFilterProps = _a.secondFilterProps, logicData = _a.logicData, logicValue = _a.logicValue, onLogicChange = _a.onLogicChange;
        return (React.createElement(React.Fragment, null,
            React.createElement(GridColumnMenuFilterCell, __assign$7({}, firstFilterProps)),
            !hideSecondFilter && (React.createElement(React.Fragment, null,
                React.createElement(DropDownList, { data: logicData, value: logicValue, onChange: onLogicChange, className: 'k-filter-and', textField: "text" }),
                React.createElement(GridColumnMenuFilterCell, __assign$7({}, secondFilterProps))))));
    };
    return GridColumnMenuFilterUI;
}(React.Component));

var __extends$6 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$6 = (undefined && undefined.__assign) || function () {
    __assign$6 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};
var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
var rootFilterOrDefault = function (rootFilter) {
    return (rootFilter || { filters: [], logic: 'and' });
};
/**
 * @hidden
 */
var filterGroupByField = function (field, filter) {
    var rootFilter = rootFilterOrDefault(filter);
    var compositeFilters = rootFilter.filters
        .filter(function (f) {
        if (isCompositeFilterDescriptor(f)) {
            return f.filters &&
                f.filters.length &&
                f.filters.length <= 2 &&
                !f.filters.find(function (nf) { return isCompositeFilterDescriptor(nf) || nf.field !== field; });
        }
        return false;
    });
    return compositeFilters[0] || null;
};
/**
 * @example
 * ```jsx-no-run
 * class TextColumnMenu extends React.Component {
 *     render() {
 *         return (
 *         <div>
 *             <GridColumnMenuSort {...this.props} />
 *             <GridColumnMenuFilter {...this.props} />
 *         </div>);
 *     }
 * }
 *
 * class App extends React.PureComponent {
 *     constructor(props) {
 *         super(props);
 *
 *         this.state = this.createAppState({
 *             take: 10,
 *             skip: 0
 *         });
 *     }
 *
 *     createAppState(dataState) {
 *         return {
 *             result: process(products.slice(0), dataState),
 *             dataState: dataState
 *         };
 *     }
 *
 *     dataStateChange = (event) => {
 *         this.setState(this.createAppState(event.dataState));
 *     }
 *
 *     render() {
 *         return (
 *             <div>
 *                 <Grid
 *                     data={this.state.result}
 *                     {...this.state.dataState}
 *                     onDataStateChange={this.dataStateChange}
 *                     sortable={true}
 *                     pageable={true}
 *                 >
 *                     <Column field="ProductID" title="Product ID" />
 *                     <Column field="ProductName" columnMenu={TextColumnMenu} />
 *                 </Grid>
 *                 <br />
 *             </div>
 *         );
 *     }
 * }
 *
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var GridColumnMenuFilter = /** @class */ (function (_super) {
    __extends$6(GridColumnMenuFilter, _super);
    function GridColumnMenuFilter(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.removeGroup = function (group, rootFilter) {
            var filters = __spreadArray$1([], rootFilter.filters, true);
            var groupIndex = filters
                .findIndex(function (f) { return f === group; });
            if (groupIndex > -1) {
                filters.splice(groupIndex, 1);
            }
            return __assign$6(__assign$6({}, rootFilter), { filters: filters });
        };
        /**
         * @hidden
         */
        _this.insertGroup = function (group, rootFilter) {
            return __assign$6(__assign$6({}, rootFilter), { filters: __spreadArray$1([
                    group
                ], rootFilter.filters, true) });
        };
        /**
         * @hidden
         */
        _this.isControlled = function () { return _this.props.expanded !== undefined; };
        /**
         * @hidden
         */
        _this.onFilterExpand = function () {
            var isControlled = _this.isControlled();
            var nextValue = !(isControlled ? _this.props.expanded : _this.state.expanded);
            if (_this.props.onExpandChange) {
                _this.props.onExpandChange(nextValue);
            }
            if (!isControlled) {
                _this.setState({
                    expanded: nextValue
                });
            }
        };
        /**
         * @hidden
         */
        _this.firstFilterChange = function (event) {
            _this.filterChange(0, event);
        };
        /**
         * @hidden
         */
        _this.secondFilterChange = function (event) {
            _this.filterChange(1, event);
        };
        /**
         * @hidden
         */
        _this.filterChange = function (filterIndex, e) {
            var filters = _this.state.filterGroup.filters.map(function (f, i) {
                if (i === filterIndex) {
                    return __assign$6(__assign$6({}, f), { value: e.value, operator: e.operator });
                }
                return f;
            });
            _this.setState({
                filterGroup: __assign$6(__assign$6({}, _this.state.filterGroup), { filters: filters })
            });
        };
        /**
         * @hidden
         */
        _this.logicChange = function (event) {
            _this.setState({
                filterGroup: __assign$6(__assign$6({}, _this.state.filterGroup), { logic: event.target.value.operator })
            });
        };
        /**
         * @hidden
         */
        _this.clear = function (event) {
            event.preventDefault();
            if (!_this.props.onFilterChange) {
                return;
            }
            var field = _this.props.column.field;
            var rootFilter = rootFilterOrDefault(_this.props.filter);
            var filterGroup = filterGroupByField(field, _this.props.filter);
            var rootFilters = rootFilter.filters.filter(function (f) { return f !== filterGroup; });
            if (!rootFilters.length) {
                _this.props.onFilterChange(null, event);
            }
            else {
                _this.props.onFilterChange(__assign$6(__assign$6({}, rootFilter), { filters: rootFilters }), event);
            }
            if (_this.props.onCloseMenu) {
                _this.props.onCloseMenu();
            }
        };
        /**
         * @hidden
         */
        _this.currentFilterGroup = function () {
            return __assign$6(__assign$6({}, _this.state.filterGroup), { filters: _this.state
                    .filterGroup
                    .filters
                    .filter(function (nf) {
                    return (nf.value !== undefined && nf.value !== null && nf.value !== '') ||
                        (nf.value === null && nf.operator);
                }) });
        };
        /**
         * @hidden
         */
        _this.submit = function (event) {
            event.preventDefault();
            if (!_this.props.onFilterChange) {
                return;
            }
            var field = _this.props.column.field;
            var rootFilter = rootFilterOrDefault(_this.props.filter);
            var filterGroup = filterGroupByField(field, _this.props.filter);
            var currentFilterGroup = _this.currentFilterGroup();
            var updatedFilter = null;
            if (filterGroup && currentFilterGroup.filters.length > 0) {
                var rootFilters = rootFilter.filters.map(function (f) {
                    if (f === filterGroup) {
                        return currentFilterGroup;
                    }
                    return f;
                });
                updatedFilter = __assign$6(__assign$6({}, rootFilter), { filters: rootFilters });
            }
            else if (currentFilterGroup.filters.length === 0) {
                var rootFilters = rootFilter
                    .filters
                    .filter(function (f) { return f !== filterGroup; });
                if (rootFilters.length) {
                    updatedFilter = __assign$6(__assign$6({}, rootFilter), { filters: rootFilters });
                }
            }
            else {
                updatedFilter = __assign$6(__assign$6({}, rootFilter), { filters: __spreadArray$1(__spreadArray$1([], rootFilter.filters, true), [currentFilterGroup], false) });
            }
            _this.props.onFilterChange(updatedFilter, event);
            if (_this.props.onCloseMenu) {
                _this.props.onCloseMenu();
            }
        };
        var filterGroup;
        if (props.column && props.column.field) {
            var filterType = getFilterType(props.column.filter);
            var defaultOperator = getDefaultOperator(props.filterOperators, filterType);
            filterGroup = filterGroupByField(props.column.field, props.filter);
            filterGroup = filterGroup ? __assign$6(__assign$6({}, filterGroup), { filters: filterGroup.filters.map(function (f) {
                    return __assign$6({}, f);
                }) }) : {
                logic: 'and',
                filters: [
                    { field: props.column.field, operator: defaultOperator, value: IsUnaryFilter(defaultOperator) ? null : undefined },
                    { field: props.column.field, operator: defaultOperator, value: IsUnaryFilter(defaultOperator) ? null : undefined }
                ]
            };
            if (filterGroup.filters.filter(function (x) { return x.field === props.column.field; }).length === 1) {
                filterGroup.filters.splice(1, 0, { field: props.column.field, operator: defaultOperator });
            }
        }
        _this.state = {
            expanded: props.expanded || false,
            filterGroup: filterGroup
        };
        return _this;
    }
    /**
     * @hidden
     */
    GridColumnMenuFilter.prototype.render = function () {
        var _a = this.props, column = _a.column, filterUI = _a.filterUI, hideSecondFilter = _a.hideSecondFilter, filterOperators = _a.filterOperators;
        if (!column || !column.field) {
            return React.createElement("div", null);
        }
        var filterType = getFilterType(column.filter);
        var currentHideSecondFilter = hideSecondFilter !== undefined ?
            hideSecondFilter : defaultHideSecondFilter[filterType];
        var localizationService = provideLocalizationService(this);
        var filters = this.state.filterGroup.filters;
        var currentOperators = operatorMap(filterOperators[filterType], localizationService);
        var booleanValues = operatorMap(booleanFilterValues, localizationService);
        var firstFilterCellProps = {
            field: column.field,
            value: filters[0].value,
            operator: filters[0].operator,
            operators: currentOperators,
            booleanValues: booleanValues,
            onChange: this.firstFilterChange,
            filterType: filterType
        };
        var secondFilterCellProps = {
            field: column.field,
            value: filters[1].value,
            operator: filters[1].operator,
            operators: currentOperators,
            booleanValues: booleanValues,
            onChange: this.secondFilterChange,
            filterType: filterType
        };
        var filterLogic = this.state.filterGroup.logic;
        var logicData = operatorMap(filterLogicList, localizationService);
        var logicProps = {
            value: logicData.find(function (item) { return item.operator === (filterLogic === null ? '' : filterLogic); }),
            onChange: this.logicChange,
            data: logicData
        };
        var FilterUI = filterUI;
        var filterUIProps = {
            firstFilterProps: firstFilterCellProps,
            secondFilterProps: secondFilterCellProps,
            logicData: logicProps.data,
            logicValue: logicProps.value,
            onLogicChange: logicProps.onChange,
            hideSecondFilter: currentHideSecondFilter
        };
        var isFilterValid = this.currentFilterGroup().filters.length !== 0 ||
            IsUnaryFilter(filters[0].operator) ||
            IsUnaryFilter(filters[1].operator);
        var expandState = this.isControlled() ? this.props.expanded : this.state.expanded;
        return (React.createElement(GridColumnMenuItemGroup, null,
            React.createElement(GridColumnMenuItem, { title: localizationService.toLanguageString(filterTitle, messages[filterTitle]), iconClass: 'k-i-filter', svgIcon: filterIcon, onClick: this.onFilterExpand }),
            React.createElement(GridColumnMenuItemContent, { show: !!expandState },
                React.createElement("div", { className: 'kendo-grid-filter-menu-container' },
                    React.createElement("form", { className: 'k-filter-menu k-group k-reset k-state-border-up', onSubmit: this.submit, onReset: this.clear, onKeyDown: function (e) { return e.stopPropagation(); } },
                        React.createElement("div", { className: 'k-filter-menu-container' },
                            FilterUI ?
                                React.createElement(FilterUI, __assign$6({}, filterUIProps)) :
                                React.createElement(GridColumnMenuFilterUI, __assign$6({}, filterUIProps)),
                            React.createElement("div", { className: 'k-actions k-actions-stretched' },
                                React.createElement(Button$2, { type: 'reset' }, localizationService.toLanguageString(filterClearButton, messages[filterClearButton])),
                                React.createElement(Button$2, { themeColor: "primary", disabled: !isFilterValid }, localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])))))))));
    };
    /* eslint-disable max-len */
    /**
     * Can be used to check if filtering is applied to a specific field ([see example]({% slug column_menu_grid %}#toc-styling-the-column-menu-icon)). Useful for creating active filter indicators.
     */
    // tslint:enable:max-line-length
    GridColumnMenuFilter.active = function (field, filter) {
        return !!filterGroupByField(field, filter);
    };
    return GridColumnMenuFilter;
}(React.Component));
registerForLocalization(GridColumnMenuFilter);

var __extends$5 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$5 = (undefined && undefined.__assign) || function () {
    __assign$5 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @hidden
 */
var isArrayEqual = function (firstArray, secondArray) {
    if (firstArray.length !== secondArray.length) {
        return false;
    }
    return firstArray.every(function (ex, i) { return ex === secondArray[i]; });
};
var GridColumnMenuCheckboxFilter = /** @class */ (function (_super) {
    __extends$5(GridColumnMenuCheckboxFilter, _super);
    function GridColumnMenuCheckboxFilter(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.defaultFilter = function () {
            if (_this.props.filter) {
                return clone(_this.props.filter);
            }
            return { filters: [], logic: 'and' };
        };
        /**
         * @hidden
         */
        _this.isControlled = function () { return _this.props.expanded !== undefined; };
        /**
         * @hidden
         */
        _this.parseData = function (originalData, isUnique) {
            var field = _this.props.column.field || '';
            var data = originalData.map(function (item) { return getNestedValue(field, item); });
            if (isUnique) {
                return data.filter(function (item, index) { return data.indexOf(item) === index; });
            }
            return data;
        };
        /**
         * @hidden
         */
        _this.getFilterIndex = function () {
            var field = _this.props.column.field;
            var currentFilter = _this.defaultFilter();
            var compositeFilterIndex = currentFilter.filters.findIndex(function (filter) {
                return filter.filters && filter.filters.length > 0 && filter.filters[0].field === field;
            });
            return compositeFilterIndex;
        };
        /**
         * @hidden
         */
        _this.onFilterExpand = function () {
            var isControlled = _this.isControlled();
            var nextValue = !(isControlled ? _this.props.expanded : _this.state.expanded);
            if (_this.props.onExpandChange) {
                _this.props.onExpandChange(nextValue);
            }
            if (!isControlled) {
                _this.setState({
                    expanded: nextValue
                });
            }
        };
        /**
         * @hidden
         */
        _this.handleSearchChange = function (e) {
            var filterOperator = _this.props.searchBoxFilterOperator ? _this.props.searchBoxFilterOperator : 'startswith';
            var filterExpression = {
                logic: 'and',
                filters: [
                    { field: _this.props.column.field, operator: filterOperator, value: e.target.value, ignoreCase: true }
                ]
            };
            _this.setState({
                value: e.target.value,
                data: _this.parseData(filterBy(_this.props.data || [], filterExpression), _this.props.uniqueData)
            });
        };
        /**
         * @hidden
         */
        _this.handleClear = function () {
            var filterOperator = _this.props.searchBoxFilterOperator ? _this.props.searchBoxFilterOperator : 'startswith';
            var filterExpression = {
                logic: 'and',
                filters: [
                    { field: _this.props.column.field, operator: filterOperator, value: '', ignoreCase: true }
                ]
            };
            _this.setState({
                value: '',
                data: _this.parseData(filterBy(_this.props.data || [], filterExpression), _this.props.uniqueData)
            });
        };
        /**
         * @hidden
         */
        _this.clear = function (e) {
            e.preventDefault();
            if (!_this.props.onFilterChange) {
                return;
            }
            var updatedFilter = _this.state.currentFilter || null;
            if (updatedFilter !== null && updatedFilter.filters.length > 0) {
                if (_this.compositeFilterIndex >= 0) {
                    updatedFilter.filters.splice(_this.compositeFilterIndex, 1);
                }
                _this.props.onFilterChange(updatedFilter, e);
            }
            else {
                _this.props.onFilterChange(null, e);
            }
            if (_this.props.onCloseMenu) {
                _this.props.onCloseMenu();
            }
        };
        /**
         * @hidden
         */
        _this.submit = function (e) {
            e.preventDefault();
            if (!_this.props.onFilterChange) {
                return;
            }
            var updatedFilter = _this.state.currentFilter || null;
            _this.props.onFilterChange(updatedFilter, e);
            if (_this.props.onCloseMenu) {
                _this.props.onCloseMenu();
            }
        };
        /**
         * @hidden
         */
        _this.handleCheckBoxChange = function (e, value) {
            var field = _this.props.column.field || '';
            var newFilter = __assign$5({}, _this.state.currentFilter);
            var filters = __spreadArray([], _this.state.currentFilter.filters, true) || [];
            var fieldFilters = [];
            if (_this.compositeFilterIndex !== -1 && newFilter.filters[_this.compositeFilterIndex].filters && value !== 'all') {
                fieldFilters = newFilter.filters[_this.compositeFilterIndex].filters;
            }
            if (e.value && value === 'all') {
                _this.state.data.forEach(function (item) {
                    fieldFilters.push({ field: field, operator: 'eq', value: item });
                });
            }
            else if (e.value) {
                fieldFilters.push({ field: field, operator: 'eq', value: value });
            }
            else if (_this.state.currentFilter) {
                var index = fieldFilters.findIndex(function (filter) { return filter.value === value; });
                fieldFilters.splice(index, 1);
            }
            newFilter.logic = 'and';
            if (_this.compositeFilterIndex !== -1) {
                filters[_this.compositeFilterIndex] = {
                    logic: 'or',
                    filters: fieldFilters
                };
            }
            else {
                filters.push({
                    logic: 'or',
                    filters: fieldFilters
                });
            }
            if (!e.value && value === 'all' || fieldFilters.length === 0) {
                filters.splice(_this.compositeFilterIndex, 1);
            }
            newFilter.filters = filters;
            _this.setState({ currentFilter: newFilter });
        };
        /**
         * @hidden
         */
        _this.isAllSelected = function () {
            var isAllChecked = false;
            if (_this.state.currentFilter) {
                var filters_1 = __spreadArray([], _this.state.currentFilter.filters, true);
                if (_this.compositeFilterIndex === -1) {
                    return false;
                }
                isAllChecked = _this.state.data.every(function (item) {
                    if (_this.compositeFilterIndex !== -1 && filters_1[_this.compositeFilterIndex].filters) {
                        var index = filters_1[_this.compositeFilterIndex].filters.findIndex(function (filter) { return filter.value === item; });
                        return index >= 0;
                    }
                    return false;
                });
                return isAllChecked;
            }
            return isAllChecked;
        };
        _this.compositeFilterIndex = _this.getFilterIndex();
        _this.state = {
            expanded: props.expanded || false,
            value: '',
            data: _this.parseData(_this.props.data, _this.props.uniqueData) || [],
            dataFromProps: _this.parseData(_this.props.data, false) || [],
            currentFilter: _this.defaultFilter()
        };
        return _this;
    }
    /**
     * @hidden
     */
    GridColumnMenuCheckboxFilter.prototype.componentDidUpdate = function () {
        var field = this.props.column.field || '';
        var data = this.props.data.map(function (item) { return getNestedValue(field, item); });
        if (!isArrayEqual(data, this.state.dataFromProps)) {
            this.setState({
                data: data,
                dataFromProps: data
            });
        }
    };
    /**
     * @hidden
     */
    GridColumnMenuCheckboxFilter.prototype.render = function () {
        var _this = this;
        var column = this.props.column;
        if (!column || !column.field) {
            return React.createElement("div", null);
        }
        var localizationService = provideLocalizationService(this);
        var expandState = this.isControlled() ? this.props.expanded : this.state.expanded;
        var filterValues = [];
        if (this.state.currentFilter) {
            var currentFilter = __spreadArray([], this.state.currentFilter.filters, true);
            this.compositeFilterIndex = currentFilter.findIndex(function (filter) {
                if (filter.filters && filter.filters.length > 0) {
                    return filter.filters[0].field === column.field;
                }
                return false;
            });
            if (this.compositeFilterIndex !== -1 && currentFilter[this.compositeFilterIndex].filters.length > 0) {
                currentFilter[this.compositeFilterIndex].filters.forEach(function (filterItem) {
                    if (filterItem.field === _this.props.column.field) {
                        filterValues.push(filterItem.value);
                    }
                });
            }
        }
        var searchBox = this.props.searchBox ?
            React.createElement(this.props.searchBox, { value: this.state.value, onChange: this.handleSearchChange }) :
            (React.createElement("div", { className: "k-searchbox k-textbox k-input k-input-md k-input-solid" },
                React.createElement(IconWrap, { className: "k-input-icon", name: 'search', icon: searchIcon }),
                React.createElement(Input, { className: "k-input-inner", type: "text", placeholder: localizationService.toLanguageString(searchPlaceholder, messages[searchPlaceholder]), value: this.state.value, onChange: function (e) { return _this.handleSearchChange(e.nativeEvent); } }),
                React.createElement(Button$2, { type: "button", rounded: null, className: "k-input-button", onClick: this.handleClear, icon: "x", svgIcon: xIcon })));
        var uniqueFilterValues = filterValues.filter(function (item, index) { return filterValues.indexOf(item) === index; });
        return (React.createElement(GridColumnMenuItemGroup, null,
            React.createElement(GridColumnMenuItem, { title: localizationService.toLanguageString(filterTitle, messages[filterTitle]), iconClass: "k-i-filter", svgIcon: filterIcon, onClick: this.onFilterExpand }),
            React.createElement(GridColumnMenuItemContent, { show: !!expandState },
                React.createElement("div", { className: "kendo-grid-filter-menu-container" },
                    React.createElement("form", { className: "k-filter-menu k-group k-reset k-state-border-up", onSubmit: this.submit, onReset: this.clear },
                        React.createElement("div", { className: "k-filter-menu-container" },
                            searchBox,
                            React.createElement("ul", { className: "k-reset k-multicheck-wrap" },
                                React.createElement("li", { className: "k-item k-check-all-wrap" },
                                    React.createElement(Checkbox, { label: localizationService.toLanguageString(filterCheckAll, messages[filterCheckAll]), onChange: function (e) { return _this.handleCheckBoxChange(e, 'all'); }, checked: this.isAllSelected() })),
                                this.state.data.map(function (item, index) {
                                    return (React.createElement("li", { className: "k-item", key: index },
                                        React.createElement(Checkbox, { label: String(item), onChange: function (e) { return _this.handleCheckBoxChange(e, item); }, checked: uniqueFilterValues.includes(item) })));
                                })),
                            React.createElement("div", { className: "k-filter-selected-items" }, uniqueFilterValues.length + ' ' + localizationService.toLanguageString(filterSelectedItems, messages[filterSelectedItems])),
                            React.createElement("div", { className: "k-actions k-hstack k-justify-content-stretch" },
                                React.createElement(Button$2, { className: "k-button", type: 'reset' }, localizationService.toLanguageString(filterClearButton, messages[filterClearButton])),
                                React.createElement(Button$2, { themeColor: "primary", type: 'submit' }, localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])))))))));
    };
    /**
     * @hidden
     */
    GridColumnMenuCheckboxFilter.defaultProps = {
        uniqueData: true
    };
    return GridColumnMenuCheckboxFilter;
}(React.Component));
registerForLocalization(GridColumnMenuCheckboxFilter);

var __extends$4 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Represents the GridToolbar component.
 *
 * @example
 * ```jsx
 * class App extends React.Component {
 *    state = {
 *       data: [
 *            {'Column1':'A1', 'Column2':'A2'},
 *            {'Column1':'B1', 'Column2':'B2'},
 *            {'Column1':'C1', 'Column2':'C2'}
 *        ]
 *    }
 *
 *    customClick = () => {
 *        alert("Custom handler in custom toolbar");
 *    }
 *    render() {
 *        return (
 *           <Grid data={this.state.data}>
 *                <GridToolbar>
 *                    <button
 *                        title="Click"
 *                        className="k-button k-primary"
 *                        onClick={this.customClick}
 *                    >Click
 *                    </button>
 *                </GridToolbar>
 *            </Grid>
 *        );
 *    }
 * }
 * ReactDOM.render(
 *    <App />,
 *    document.querySelector('my-app')
 * );
 * ```
 */
var GridToolbar = /** @class */ (function (_super) {
    __extends$4(GridToolbar, _super);
    function GridToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    GridToolbar.prototype.render = function () {
        var _a;
        return (React.createElement("div", { className: classNames$3('k-toolbar k-grid-toolbar', (_a = {
                    'k-toolbar-md': !this.props.size
                },
                _a["k-toolbar-".concat(kendoThemeMaps$2.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                _a), this.props.className) }, this.props.children));
    };
    /**
     * @hidden
     */
    GridToolbar.displayName = 'KendoReactGridToolbar';
    return GridToolbar;
}(React.Component));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@charset \"UTF-8\";\n.k-theme-test-class,\n.k-common-test-class {\n  opacity: 0;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nscript {\n  display: none !important;\n}\n\n.k-hidden {\n  display: none !important;\n}\n\n.k-rtl {\n  direction: rtl;\n}\n\n.k-sr-only {\n  position: absolute;\n  left: -1px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n.k-hbox,\n.k-hstack {\n  display: flex;\n  flex-flow: row nowrap;\n}\n\n.k-vbox,\n.k-vstack {\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.k-flex,\n.k-spacer {\n  flex: 1 0 0%;\n}\n\n.k-flex-layout {\n  display: flex;\n}\n\n.k-grid-layout {\n  display: grid;\n}\n\n.k-separator {\n  width: auto;\n  height: 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: inherit;\n  display: block;\n  flex-grow: 0 !important;\n  flex-shrink: 0 !important;\n  align-self: stretch;\n}\n\n.k-separator-horizontal,\n.k-vstack > .k-separator {\n  width: auto;\n  height: 0;\n  border-width: 1px 0 0;\n}\n\n.k-separator-vertical,\n.k-hstack > .k-separator {\n  width: 0;\n  height: auto;\n  border-width: 0 0 0 1px;\n}\n\nhr.k-separator {\n  margin: 0;\n  padding: 0;\n}\n\n.k-reset {\n  margin: 0;\n  padding: 0;\n  border-width: 0;\n  outline: 0;\n  text-decoration: none;\n  font: inherit;\n  list-style: none;\n}\n\nkendo-sortable {\n  display: block;\n}\n\n.k-link,\n.k-link:hover {\n  color: inherit;\n  text-decoration: none;\n  outline: 0;\n  cursor: pointer;\n}\n\n.k-content {\n  outline: 0;\n}\n\n.k-centered {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.k-no-click {\n  pointer-events: none;\n}\n\n.k-pdf-export-shadow {\n  position: absolute;\n  overflow: hidden;\n  left: -15000px;\n  width: 14400px;\n}\n\n.kendo-pdf-hide-pseudo-elements::before,\n.kendo-pdf-hide-pseudo-elements::after {\n  display: none !important;\n}\n\n.k-text-selection ::selection {\n  background-color: #ff6358;\n  color: white;\n}\n\n.k-block,\n.k-panel {\n  border-radius: 4px;\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n  padding: 4px 8px;\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n}\n.k-block > .k-header,\n.k-panel > .k-header {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n  margin: -4px -8px 4px;\n  padding: 8px 8px;\n}\n\n.k-content {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n\n.k-disabled,\n.k-widget[disabled],\n.k-disabled {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n.k-disabled .k-link,\n.k-widget[disabled] .k-link,\n.k-disabled .k-link {\n  cursor: default;\n  outline: 0;\n}\n.k-disabled [disabled],\n.k-disabled .k-disabled,\n.k-widget[disabled] [disabled],\n.k-widget[disabled] .k-disabled,\n.k-disabled [disabled],\n.k-disabled .k-disabled {\n  opacity: 1;\n  filter: grayscale(0);\n}\n\n.k-hr {\n  margin: 1em auto;\n  padding: 0;\n  height: 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.08);\n  display: block;\n  float: none;\n  clear: both;\n}\n\n.k-d-flex-row > .k-hr {\n  margin: 0;\n  width: 0;\n  height: auto;\n  border-width: 0 0 0 1px;\n  flex: 0 0 auto;\n}\n\n.k-d-flex-col > .k-hr {\n  margin: 0;\n  flex: 0 0 auto;\n}\n\n.k-dirty {\n  margin: 0;\n  padding: 0;\n  width: 0;\n  height: 0;\n  border-width: 3px;\n  border-style: solid;\n  border-color: #f31700 #f31700 transparent transparent;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n[dir=rtl] .k-dirty,\n.k-rtl .k-dirty {\n  border-color: transparent transparent #f31700 #f31700;\n  right: auto;\n  left: 0;\n}\n\n.k-placeholder-line {\n  width: 100%;\n  height: 10px;\n  background-color: rgba(0, 0, 0, 0.1);\n  display: inline-block;\n}\n\n.k-drop-hint {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n  align-items: center;\n  position: absolute;\n  z-index: 1000;\n  transform: translate(-50%, -50%);\n}\n\n.k-drop-hint-start,\n.k-drop-hint-end {\n  flex-shrink: 0;\n  border-width: 4px;\n  border-style: solid;\n  border-color: transparent;\n}\n\n.k-drop-hint-line {\n  flex-grow: 1;\n  background-color: #ff6358;\n}\n\n.k-drop-hint-h .k-drop-hint-start {\n  border-left-width: 6.9282032304px;\n  border-left-color: #ff6358;\n  border-right-width: 0;\n}\n.k-drop-hint-h .k-drop-hint-line {\n  width: 20px;\n  height: 1px;\n}\n.k-drop-hint-h .k-drop-hint-end {\n  border-right-width: 6.9282032304px;\n  border-right-color: #ff6358;\n  border-left-width: 0;\n}\n\n.k-drop-hint-v {\n  flex-direction: column;\n}\n.k-drop-hint-v .k-drop-hint-start {\n  border-top-width: 6.9282032304px;\n  border-top-color: #ff6358;\n  border-bottom-width: 0;\n}\n.k-drop-hint-v .k-drop-hint-line {\n  width: 1px;\n  height: 20px;\n}\n.k-drop-hint-v .k-drop-hint-end {\n  border-bottom-width: 6.9282032304px;\n  border-bottom-color: #ff6358;\n  border-top-width: 0;\n}\n\n.k-animation-container {\n  position: absolute;\n  overflow: hidden;\n  z-index: 100;\n}\n.k-animation-container-fixed {\n  position: fixed;\n}\n.k-animation-container-relative {\n  position: relative;\n  display: inline-block;\n}\n\n.k-push-right-enter, .k-push-right-appear {\n  transform: translate(-100%, 0);\n}\n.k-push-right-enter-active, .k-push-right-appear-active {\n  transform: translate(0, 0);\n  transition: transform 300ms ease-in-out;\n}\n.k-push-right-exit {\n  transform: translate(0, 0);\n}\n.k-push-right-exit-active {\n  transform: translate(100%, 0);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-push-left-enter, .k-push-left-appear {\n  transform: translate(100%, 0);\n}\n.k-push-left-enter-active, .k-push-left-appear-active {\n  transform: translate(0, 0);\n  transition: transform 300ms ease-in-out;\n}\n.k-push-left-exit {\n  transform: translate(0, 0);\n}\n.k-push-left-exit-active {\n  transform: translate(-100%, 0);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-push-down-enter, .k-push-down-appear {\n  transform: translate(0, -100%);\n}\n.k-push-down-enter-active, .k-push-down-appear-active {\n  transform: translate(0, 0);\n  transition: transform 300ms ease-in-out;\n}\n.k-push-down-exit {\n  transform: translate(0, 0);\n}\n.k-push-down-exit-active {\n  transform: translate(0, 100%);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-push-up-enter, .k-push-up-appear {\n  transform: translate(0, 100%);\n}\n.k-push-up-enter-active, .k-push-up-appear-active {\n  transform: translate(0, 0);\n  transition: transform 300ms ease-in-out;\n}\n.k-push-up-exit {\n  transform: translate(0, 0);\n}\n.k-push-up-exit-active {\n  transform: translate(0, -100%);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-expand-vertical-enter, .k-expand-vertical-appear {\n  transform: scaleY(0);\n}\n.k-expand-vertical-enter-active, .k-expand-vertical-appear-active {\n  transform: scaleY(1);\n  transition: transform 300ms ease-in-out;\n}\n.k-expand-vertical-exit {\n  transform: scaleY(1);\n}\n.k-expand-vertical-exit-active {\n  transform: scaleY(0);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-expand-horizontal-enter, .k-expand-horizontal-appear {\n  transform: scaleX(0);\n}\n.k-expand-horizontal-enter-active, .k-expand-horizontal-appear-active {\n  transform: scaleX(1);\n  transition: transform 300ms ease-in-out;\n}\n.k-expand-horizontal-exit {\n  transform: scaleX(1);\n}\n.k-expand-horizontal-exit-active {\n  transform: scaleX(0);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-fade-enter, .k-fade-appear {\n  opacity: 0;\n}\n.k-fade-enter-active, .k-fade-appear-active {\n  opacity: 1;\n  transition: opacity 500ms ease-in-out;\n}\n.k-fade-exit {\n  opacity: 1;\n}\n.k-fade-exit-active {\n  opacity: 0;\n  transition: opacity 500ms ease-in-out;\n}\n.k-fade-exit-active + .k-fade-exit-active, .k-fade-enter-active + .k-fade-enter-active {\n  display: none;\n}\n\n.k-zoom-in-enter, .k-zoom-in-appear {\n  opacity: 0;\n  transform: scale(0);\n}\n.k-zoom-in-enter-active, .k-zoom-in-appear-active {\n  opacity: 1;\n  transform: scale(1);\n  transition: transform, opacity 300ms ease-in-out;\n}\n.k-zoom-in-exit {\n  opacity: 1;\n  transform: scale(1);\n}\n.k-zoom-in-exit-active {\n  opacity: 0;\n  transform: scale(2);\n  transition: transform, opacity 300ms ease-in-out;\n}\n\n.k-zoom-out-enter, .k-zoom-out-appear {\n  opacity: 0;\n  transform: scale(2);\n}\n.k-zoom-out-enter-active, .k-zoom-out-appear-active {\n  opacity: 1;\n  transform: scale(1);\n  transition: transform, opacity 300ms ease-in-out;\n}\n.k-zoom-out-exit {\n  opacity: 1;\n  transform: scale(1);\n}\n.k-zoom-out-exit-active {\n  opacity: 0;\n  transform: scale(0);\n  transition: transform, opacity 300ms ease-in-out;\n}\n\n.k-slide-in-appear {\n  opacity: 0.1;\n  transform: translate(0, -3em);\n}\n.k-slide-in-appear .k-centered {\n  transform: translate(-50%, -60%);\n}\n.k-slide-in-appear-active {\n  opacity: 1;\n  transform: translate(0, 0);\n  transition: transform 0.3s cubic-bezier(0.2, 0.6, 0.4, 1), opacity 0.3s cubic-bezier(0.2, 1, 0.2, 1);\n}\n.k-slide-in-appear-active .k-centered {\n  transform: translate(-50%, -50%);\n}\n\n.k-slide-down-enter, .k-slide-down-appear {\n  transform: translateY(-100%);\n}\n.k-slide-down-enter-active, .k-slide-down-appear-active {\n  transform: translateY(0);\n  transition: transform 300ms ease-in-out;\n}\n.k-slide-down-exit {\n  transform: translateY(0);\n}\n.k-slide-down-exit-active {\n  transform: translateY(-100%);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-slide-up-enter, .k-slide-up-appear {\n  transform: translateY(100%);\n}\n.k-slide-up-enter-active, .k-slide-up-appear-active {\n  transform: translateY(0);\n  transition: transform 300ms ease-in-out;\n}\n.k-slide-up-exit {\n  transform: translateY(0);\n}\n.k-slide-up-exit-active {\n  transform: translateY(100%);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-slide-right-enter, .k-slide-right-appear {\n  transform: translateX(-100%);\n}\n.k-slide-right-enter-active, .k-slide-right-appear-active {\n  transform: translateX(0);\n  transition: transform 300ms ease-in-out;\n}\n.k-slide-right-exit {\n  transform: translateX(0);\n}\n.k-slide-right-exit-active {\n  transform: translateX(-100%);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-slide-left-enter, .k-slide-left-appear {\n  transform: translateX(100%);\n}\n.k-slide-left-enter-active, .k-slide-left-appear-active {\n  transform: translateX(0);\n  transition: transform 300ms ease-in-out;\n}\n.k-slide-left-exit {\n  transform: translateX(0);\n}\n.k-slide-left-exit-active {\n  transform: translateX(100%);\n  transition: transform 300ms ease-in-out;\n}\n\n.k-reveal-vertical-enter, .k-reveal-vertical-appear {\n  max-height: 0;\n}\n.k-reveal-vertical-enter-active, .k-reveal-vertical-appear-active {\n  transition: max-height 300ms ease-in-out;\n}\n.k-reveal-vertical-exit-active {\n  max-height: 0 !important;\n  transition: max-height 300ms ease-in-out;\n}\n\n.k-reveal-horizontal-enter, .k-reveal-horizontal-appear {\n  max-width: 0;\n}\n.k-reveal-horizontal-enter-active, .k-reveal-horizontal-appear-active {\n  transition: max-width 300ms ease-in-out;\n}\n.k-reveal-horizontal-exit-active {\n  max-width: 0 !important;\n  transition: max-width 300ms ease-in-out;\n}\n\n.k-fx-end .k-fx-next,\n.k-fx-end .k-fx-current {\n  transition: all 350ms ease-out;\n}\n\n.k-fx {\n  position: relative;\n}\n.k-fx .k-fx-current {\n  z-index: 0;\n}\n.k-fx .k-fx-next {\n  z-index: 1;\n}\n\n.k-fx-hidden,\n.k-fx-hidden * {\n  visibility: hidden !important;\n}\n\n.k-fx-reverse .k-fx-current {\n  z-index: 1;\n}\n.k-fx-reverse .k-fx-next {\n  z-index: 0;\n}\n\n.k-fx-zoom.k-fx-start .k-fx-next {\n  transform: scale(0) !important;\n}\n.k-fx-zoom.k-fx-end .k-fx-next {\n  transform: scale(1) !important;\n}\n.k-fx-zoom.k-fx-reverse.k-fx-start .k-fx-next, .k-fx-zoom.k-fx-reverse.k-fx-end .k-fx-next {\n  transform: scale(1) !important;\n}\n.k-fx-zoom.k-fx-reverse.k-fx-start .k-fx-current {\n  transform: scale(1) !important;\n}\n.k-fx-zoom.k-fx-reverse.k-fx-end .k-fx-current {\n  transform: scale(0) !important;\n}\n\n.k-fx-fade.k-fx-start .k-fx-next {\n  will-change: opacity;\n  opacity: 0;\n}\n.k-fx-fade.k-fx-end .k-fx-next {\n  opacity: 1;\n}\n.k-fx-fade.k-fx-reverse.k-fx-start .k-fx-current {\n  will-change: opacity;\n  opacity: 1;\n}\n.k-fx-fade.k-fx-reverse.k-fx-end .k-fx-current {\n  opacity: 0;\n}\n\n.k-fx-slide.k-fx-end .k-fx-next .k-content, .k-fx-slide.k-fx-end .k-fx-next .k-header, .k-fx-slide.k-fx-end .k-fx-next .k-footer, .k-fx-slide.k-fx-end .k-fx-current .k-content, .k-fx-slide.k-fx-end .k-fx-current .k-header, .k-fx-slide.k-fx-end .k-fx-current .k-footer, .k-fx-slide.k-fx-end .k-fx-next .km-content, .k-fx-slide.k-fx-end .k-fx-next .km-header, .k-fx-slide.k-fx-end .k-fx-next .km-footer, .k-fx-slide.k-fx-end .k-fx-current .km-content, .k-fx-slide.k-fx-end .k-fx-current .km-header, .k-fx-slide.k-fx-end .k-fx-current .km-footer {\n  transition: all 350ms ease-out;\n}\n.k-fx-slide.k-fx-start .k-fx-next .k-content, .k-fx-slide.k-fx-start .k-fx-next .km-content {\n  will-change: transform;\n  transform: translateX(100%);\n}\n.k-fx-slide.k-fx-start .k-fx-next .k-header, .k-fx-slide.k-fx-start .k-fx-next .k-footer, .k-fx-slide.k-fx-start .k-fx-next .km-header, .k-fx-slide.k-fx-start .k-fx-next .km-footer {\n  will-change: opacity;\n  opacity: 0;\n}\n.k-fx-slide.k-fx-end .k-fx-current .k-content, .k-fx-slide.k-fx-end .k-fx-current .km-content {\n  transform: translateX(-100%);\n}\n.k-fx-slide.k-fx-end .k-fx-next .k-header, .k-fx-slide.k-fx-end .k-fx-next .k-footer, .k-fx-slide.k-fx-end .k-fx-next .km-header, .k-fx-slide.k-fx-end .k-fx-next .km-footer {\n  opacity: 1;\n}\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-content, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-content {\n  will-change: transform;\n  transform: translateX(0);\n}\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-content, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-content {\n  transform: translateX(100%);\n}\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-content, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-content {\n  transform: translateX(-100%);\n}\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-content, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-content {\n  transform: translateX(0);\n}\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-header, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .k-footer, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-header, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-current .km-footer {\n  will-change: opacity;\n  opacity: 1;\n}\n.k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-header, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .k-footer, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-header, .k-fx-slide.k-fx-reverse.k-fx-start .k-fx-next .km-footer {\n  opacity: 1;\n}\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-header, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .k-footer, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-header, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-current .km-footer {\n  opacity: 0;\n}\n.k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-header, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .k-footer, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-header, .k-fx-slide.k-fx-reverse.k-fx-end .k-fx-next .km-footer {\n  opacity: 1;\n}\n.k-fx-slide.k-fx-right.k-fx-start .k-fx-next .k-content, .k-fx-slide.k-fx-right.k-fx-start .k-fx-next .km-content {\n  transform: translateX(-100%);\n}\n.k-fx-slide.k-fx-right.k-fx-end .k-fx-current .k-content, .k-fx-slide.k-fx-right.k-fx-end .k-fx-current .km-content {\n  transform: translateX(100%);\n}\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current .k-content, .k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current .km-content {\n  transform: translateX(0);\n}\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current .k-content, .k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current .km-content {\n  transform: translateX(-100%);\n}\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next .k-content, .k-fx-slide.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next .km-content {\n  transform: translateX(100%);\n}\n.k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next .k-content, .k-fx-slide.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next .km-content {\n  transform: translateX(0%);\n}\n\n.k-fx-tile.k-fx-start .k-fx-next {\n  will-change: transform;\n  transform: translateX(100%);\n}\n.k-fx-tile.k-fx-end .k-fx-current {\n  transform: translateX(-100%);\n}\n.k-fx-tile.k-fx-reverse.k-fx-start .k-fx-current {\n  will-change: transform;\n  transform: translateX(0);\n}\n.k-fx-tile.k-fx-reverse.k-fx-end .k-fx-current {\n  transform: translateX(100%);\n}\n.k-fx-tile.k-fx-reverse.k-fx-start .k-fx-next {\n  transform: translateX(-100%);\n}\n.k-fx-tile.k-fx-reverse.k-fx-end .k-fx-next {\n  transform: translateX(0);\n}\n.k-fx-tile.k-fx-right.k-fx-start .k-fx-next {\n  transform: translateX(-100%);\n}\n.k-fx-tile.k-fx-right.k-fx-end .k-fx-current {\n  transform: translateX(100%);\n}\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-start .k-fx-current {\n  transform: translateX(0);\n}\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-end .k-fx-current {\n  transform: translateX(-100%);\n}\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-start .k-fx-next {\n  transform: translateX(100%);\n}\n.k-fx-tile.k-fx-right.k-fx-reverse.k-fx-end .k-fx-next {\n  transform: translateX(0%);\n}\n\n.k-fx.k-fx-overlay.k-fx-start .k-fx-next, .k-fx.k-fx-overlay.k-fx-left.k-fx-start .k-fx-next {\n  will-change: transform;\n  transform: translateX(100%);\n}\n.k-fx.k-fx-overlay.k-fx-right.k-fx-start .k-fx-next {\n  transform: translateX(-100%);\n}\n.k-fx.k-fx-overlay.k-fx-up.k-fx-start .k-fx-next {\n  transform: translateY(100%);\n}\n.k-fx.k-fx-overlay.k-fx-down.k-fx-start .k-fx-next {\n  transform: translateY(-100%);\n}\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-start .k-fx-next {\n  transform: none;\n}\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-start .k-fx-current {\n  will-change: transform;\n  transform: none;\n}\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-end .k-fx-current, .k-fx.k-fx-overlay.k-fx-reverse.k-fx-left.k-fx-end .k-fx-current {\n  transform: translateX(100%);\n}\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-right.k-fx-end .k-fx-current {\n  transform: translateX(-100%);\n}\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-up.k-fx-end .k-fx-current {\n  transform: translateY(100%);\n}\n.k-fx.k-fx-overlay.k-fx-reverse.k-fx-down.k-fx-end .k-fx-current {\n  transform: translateY(-100%);\n}\n\n.k-drag-clue {\n  border-radius: 4px;\n  padding: 4px 8px;\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-family: inherit;\n  line-height: 1.4285714286;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  white-space: nowrap;\n  overflow: hidden;\n  position: absolute;\n  z-index: 20000;\n  cursor: move;\n}\n\n.k-drag-status,\n.k-drag-clue .k-drag-status {\n  margin: 0;\n  margin-right: 0.4ex;\n}\n\n.k-drag-clue {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n\n.k-reorder-cue {\n  position: absolute;\n}\n.k-reorder-cue::before, .k-reorder-cue::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border: 3px solid transparent;\n  position: absolute;\n  transform: translateX(-50%);\n}\n.k-reorder-cue::before {\n  border-bottom-width: 0;\n  border-top-color: currentColor;\n  top: -4px;\n}\n.k-reorder-cue::after {\n  border-top-width: 0;\n  border-bottom-color: currentColor;\n  bottom: -4px;\n}\n\n.k-loading-mask,\n.k-loading-image,\n.k-loading-color {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.k-loading-mask *,\n.k-loading-mask *::before,\n.k-loading-mask *::after, .k-loading-mask::before, .k-loading-mask::after,\n.k-loading-image *,\n.k-loading-image *::before,\n.k-loading-image *::after,\n.k-loading-image::before,\n.k-loading-image::after,\n.k-loading-color *,\n.k-loading-color *::before,\n.k-loading-color *::after,\n.k-loading-color::before,\n.k-loading-color::after {\n  box-sizing: border-box;\n}\n\n.k-loading-mask {\n  z-index: 100;\n}\n.k-loading-mask.k-opaque .k-loading-color {\n  opacity: 1;\n}\n\n.k-loading-text {\n  text-indent: -4000px;\n  text-align: center;\n  position: absolute;\n  color: currentColor;\n}\n\n.k-loading-image {\n  z-index: 2;\n  color: currentColor;\n}\n\n.k-loading-color {\n  background-color: #ffffff;\n  opacity: 0.3;\n}\n\n.k-i-loading {\n  position: relative;\n  background-color: transparent;\n  box-sizing: border-box;\n  color: currentColor;\n}\n.k-i-loading::before, .k-i-loading::after {\n  box-sizing: border-box;\n}\n\n.k-i-loading::before,\n.k-i-loading::after,\n.k-loading-image::before,\n.k-loading-image::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: inline-block;\n  content: \"\";\n  box-sizing: inherit;\n  border-radius: 50%;\n  border-width: 0.05em;\n  border-style: solid;\n  border-color: currentColor;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  background-color: transparent;\n}\n\n.k-icon.k-i-loading::before,\n.k-icon.k-i-loading::after {\n  content: \"\";\n}\n\n.k-i-loading::before,\n.k-loading-image::before {\n  margin-top: -0.5em;\n  margin-left: -0.5em;\n  width: 1em;\n  height: 1em;\n  animation: k-loading-animation 0.7s linear infinite;\n}\n\n.k-i-loading::after,\n.k-loading-image::after {\n  margin-top: -0.25em;\n  margin-left: -0.25em;\n  width: 0.5em;\n  height: 0.5em;\n  animation: k-loading-animation reverse 1.4s linear infinite;\n}\n\n.k-loading-image::before,\n.k-loading-image::after {\n  content: \"\";\n  border-width: 1px;\n  border-width: clamp(0.015em, 1px, 1px);\n  font-size: 4em;\n}\n\n@keyframes loading {\n  0% {\n    stroke-dasharray: 0 251;\n    stroke-dashoffset: 502;\n  }\n  50% {\n    stroke-dasharray: 250 1;\n  }\n  100% {\n    stroke-dasharray: 0 251;\n    stroke-dashoffset: 0;\n  }\n}\n@keyframes k-loading-animation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.k-resize-handle,\n.k-resize-hint {\n  position: absolute;\n  border-color: inherit;\n  z-index: 200;\n}\n\n.k-resize-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.k-resize-handle::before {\n  content: \"\";\n  border: 0 solid;\n  border-color: inherit;\n}\n\n.k-resize-n {\n  width: 100%;\n  height: 6px;\n  flex-direction: row;\n  left: 0;\n  top: -3px;\n  cursor: n-resize;\n}\n\n.k-resize-s {\n  width: 100%;\n  height: 6px;\n  flex-direction: row;\n  left: 0;\n  bottom: -3px;\n  cursor: s-resize;\n}\n\n.k-resize-w {\n  width: 6px;\n  height: 100%;\n  flex-direction: column;\n  top: 0;\n  left: -3px;\n  cursor: w-resize;\n}\n\n.k-resize-e {\n  width: 6px;\n  height: 100%;\n  flex-direction: column;\n  top: 0;\n  right: -3px;\n  cursor: e-resize;\n}\n\n.k-resize-sw,\n.k-resize-se,\n.k-resize-nw,\n.k-resize-ne {\n  width: 5px;\n  height: 5px;\n}\n\n.k-resize-sw {\n  cursor: sw-resize;\n  bottom: 0;\n  left: 0;\n}\n\n.k-resize-se {\n  cursor: se-resize;\n  bottom: 0;\n  right: 0;\n}\n\n.k-resize-nw {\n  cursor: nw-resize;\n  top: 0;\n  left: 0;\n}\n\n.k-resize-ne {\n  cursor: ne-resize;\n  top: 0;\n  right: 0;\n}\n\n.k-vertical-resize {\n  cursor: row-resize;\n}\n\n.k-horizontal-resize {\n  cursor: col-resize;\n}\n\n.k-resize-hint {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.k-resize-hint .k-resize-hint-handle {\n  width: auto;\n  height: 20px;\n  align-self: stretch;\n}\n.k-resize-hint .k-resize-hint-marker {\n  width: 2px;\n  height: auto;\n  flex: 1 1 auto;\n}\n\n.k-resize-hint-vertical {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.k-resize-hint-vertical .k-resize-hint-handle {\n  width: 20px;\n  height: auto;\n  align-self: stretch;\n}\n.k-resize-hint-vertical .k-resize-hint-marker {\n  width: auto;\n  height: 2px;\n  flex: 1 1 auto;\n}\n\n.k-scrollbar {\n  position: absolute;\n  overflow: scroll;\n}\n\n.k-scrollbar-vertical {\n  top: 0;\n  right: 0;\n  width: 17px;\n  height: 100%;\n  overflow-x: hidden;\n}\n\n.k-touch-scrollbar {\n  display: none;\n  position: absolute;\n  z-index: 200000;\n  height: 8px;\n  width: 8px;\n  border: 1px solid #8a8a8a;\n  background-color: #858585;\n}\n\n.k-marquee {\n  position: absolute;\n  z-index: 100000;\n}\n\n.k-marquee-color,\n.k-marquee-text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.k-marquee-color {\n  color: white;\n  background-color: #ff6358;\n  border-color: rgba(0, 0, 0, 0.08);\n  opacity: 0.6;\n}\n\n.k-marquee-text {\n  color: white;\n}\n\n@font-face {\n  font-family: \"WebComponentsIcons\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(data:font/ttf;base64,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) format(\"truetype\");\n}\n.k-icon-wrap {\n  flex: none;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  gap: 0;\n  align-items: center;\n  align-self: flex-start;\n  vertical-align: middle;\n  position: relative;\n}\n.k-icon-wrap::before {\n  content: \"​\";\n  width: 0;\n  overflow: hidden;\n  flex: none;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.k-icon {\n  width: 1em;\n  height: 1em;\n  outline: 0;\n  font-size: 16px;\n  font-family: \"WebComponentsIcons\";\n  font-style: normal;\n  font-variant: normal;\n  font-weight: normal;\n  line-height: 1;\n  speak: none;\n  text-transform: none;\n  text-decoration: none;\n  flex-shrink: 0;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  position: relative;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n.k-icon:hover, .k-icon:focus {\n  text-decoration: none;\n}\n\n.k-svg-icon {\n  width: 1em;\n  height: 1em;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  position: relative;\n}\n.k-svg-icon > svg {\n  fill: currentColor;\n  flex: 1 0 auto;\n}\n.k-svg-icon.k-flip-h, .k-svg-icon.k-flip-v, .k-svg-icon.k-flip-h.k-flip-v {\n  transform: none;\n}\n.k-svg-icon.k-flip-h > svg {\n  transform: scaleX(-1);\n}\n.k-svg-icon.k-flip-v > svg {\n  transform: scaleY(-1);\n}\n.k-svg-icon.k-flip-h.k-flip-v > svg {\n  transform: scale(-1, -1);\n}\n\n.k-icon-with-modifier {\n  position: relative;\n  margin: 0.25em;\n}\n\n.k-icon-modifier {\n  position: absolute;\n  font-size: 0.5em;\n  bottom: 0;\n  right: 0;\n  margin: 0 -0.5em -0.5em 0;\n}\n\n.k-i-none::before {\n  content: \"\";\n  display: none;\n}\n\n.k-icon-action {\n  padding: 4px;\n  cursor: pointer;\n}\n\n.k-icon-xs {\n  font-size: 8px;\n}\n\n.k-icon-sm {\n  font-size: 12px;\n}\n\n.k-icon-md {\n  font-size: 32px;\n}\n\n.k-icon-lg {\n  font-size: 48px;\n}\n\n.k-icon-xl {\n  font-size: 64px;\n}\n\n.k-i-caret-tr::before {\n  content: \"\\e000\";\n}\n\n.k-i-arrow-45-up-right::before {\n  content: \"\\e000\";\n}\n\n.k-i-collapse-ne::before {\n  content: \"\\e000\";\n}\n\n.k-i-resize-ne::before {\n  content: \"\\e000\";\n}\n\n.k-i-caret-br::before {\n  content: \"\\e001\";\n}\n\n.k-i-arrow-45-down-right::before {\n  content: \"\\e001\";\n}\n\n.k-i-collapse-se::before {\n  content: \"\\e001\";\n}\n\n.k-i-resize-se::before {\n  content: \"\\e001\";\n}\n\n.k-i-caret-bl::before {\n  content: \"\\e002\";\n}\n\n.k-i-arrow-45-down-left::before {\n  content: \"\\e002\";\n}\n\n.k-i-collapse-sw::before {\n  content: \"\\e002\";\n}\n\n.k-i-resize-sw::before {\n  content: \"\\e002\";\n}\n\n.k-i-caret-tl::before {\n  content: \"\\e003\";\n}\n\n.k-i-arrow-45-up-left::before {\n  content: \"\\e003\";\n}\n\n.k-i-collapse-nw::before {\n  content: \"\\e003\";\n}\n\n.k-i-resize-nw::before {\n  content: \"\\e003\";\n}\n\n.k-i-caret-alt-up::before {\n  content: \"\\e004\";\n}\n\n.k-i-arrow-60-up::before {\n  content: \"\\e004\";\n}\n\n.k-i-arrow-n::before {\n  content: \"\\e004\";\n}\n\n.k-i-kpi-trend-increase::before {\n  content: \"\\e004\";\n}\n\n.k-i-expand-n::before {\n  content: \"\\e004\";\n}\n\n.k-i-sarrow-n::before {\n  content: \"\\e004\";\n}\n\n.k-i-caret-alt-right::before {\n  content: \"\\e005\";\n}\n\n.k-i-arrow-60-right::before {\n  content: \"\\e005\";\n}\n\n.k-i-arrow-e::before {\n  content: \"\\e005\";\n}\n\n.k-i-expand::before {\n  content: \"\\e005\";\n}\n\n.k-i-expand-e::before {\n  content: \"\\e005\";\n}\n\n.k-i-sarrow-e::before {\n  content: \"\\e005\";\n}\n\n.k-i-caret-alt-down::before {\n  content: \"\\e006\";\n}\n\n.k-i-arrow-60-down::before {\n  content: \"\\e006\";\n}\n\n.k-i-arrow-s::before {\n  content: \"\\e006\";\n}\n\n.k-i-kpi-trend-decrease::before {\n  content: \"\\e006\";\n}\n\n.k-i-expand-s::before {\n  content: \"\\e006\";\n}\n\n.k-i-collapse::before {\n  content: \"\\e006\";\n}\n\n.k-i-sarrow-s::before {\n  content: \"\\e006\";\n}\n\n.k-i-caret-alt-left::before {\n  content: \"\\e007\";\n}\n\n.k-i-arrow-60-left::before {\n  content: \"\\e007\";\n}\n\n.k-i-arrow-w::before {\n  content: \"\\e007\";\n}\n\n.k-i-expand-w::before {\n  content: \"\\e007\";\n}\n\n.k-i-sarrow-w::before {\n  content: \"\\e007\";\n}\n\n.k-i-caret-alt-to-top::before {\n  content: \"\\e008\";\n}\n\n.k-i-arrow-end-up::before {\n  content: \"\\e008\";\n}\n\n.k-i-seek-n::before {\n  content: \"\\e008\";\n}\n\n.k-i-caret-alt-to-right::before {\n  content: \"\\e009\";\n}\n\n.k-i-arrow-end-right::before {\n  content: \"\\e009\";\n}\n\n.k-i-seek-e::before {\n  content: \"\\e009\";\n}\n\n.k-i-caret-alt-to-bottom::before {\n  content: \"\\e00a\";\n}\n\n.k-i-arrow-end-down::before {\n  content: \"\\e00a\";\n}\n\n.k-i-seek-s::before {\n  content: \"\\e00a\";\n}\n\n.k-i-caret-alt-to-left::before {\n  content: \"\\e00b\";\n}\n\n.k-i-arrow-end-left::before {\n  content: \"\\e00b\";\n}\n\n.k-i-seek-w::before {\n  content: \"\\e00b\";\n}\n\n.k-i-caret-double-alt-up::before {\n  content: \"\\e00c\";\n}\n\n.k-i-arrow-double-60-up::before {\n  content: \"\\e00c\";\n}\n\n.k-i-arrow-seek-up::before {\n  content: \"\\e00c\";\n}\n\n.k-i-caret-double-alt-right::before {\n  content: \"\\e00d\";\n}\n\n.k-i-arrow-double-60-right::before {\n  content: \"\\e00d\";\n}\n\n.k-i-arrow-seek-right::before {\n  content: \"\\e00d\";\n}\n\n.k-i-forward-sm::before {\n  content: \"\\e00d\";\n}\n\n.k-i-caret-double-alt-down::before {\n  content: \"\\e00e\";\n}\n\n.k-i-arrow-double-60-down::before {\n  content: \"\\e00e\";\n}\n\n.k-i-arrow-seek-down::before {\n  content: \"\\e00e\";\n}\n\n.k-i-caret-double-alt-left::before {\n  content: \"\\e00f\";\n}\n\n.k-i-arrow-double-60-left::before {\n  content: \"\\e00f\";\n}\n\n.k-i-arrow-seek-left::before {\n  content: \"\\e00f\";\n}\n\n.k-i-rewind-sm::before {\n  content: \"\\e00f\";\n}\n\n.k-i-caret-alt-expand::before {\n  content: \"\\e010\";\n}\n\n.k-i-arrows-kpi::before {\n  content: \"\\e010\";\n}\n\n.k-i-kpi::before {\n  content: \"\\e010\";\n}\n\n.k-i-caret-alt-sort::before {\n  content: \"\\e010\";\n}\n\n.k-i-arrows-no-change::before {\n  content: \"\\e011\";\n}\n\n.k-i-arrow-overflow-down::before {\n  content: \"\\e012\";\n}\n\n.k-i-chevron-up::before {\n  content: \"\\e013\";\n}\n\n.k-i-chevron-double-up::before {\n  content: \"\\e05e\";\n}\n\n.k-i-arrow-chevron-up::before {\n  content: \"\\e013\";\n}\n\n.k-i-arrowhead-n::before {\n  content: \"\\e013\";\n}\n\n.k-i-chevron-right::before {\n  content: \"\\e014\";\n}\n\n.k-i-chevron-double-right::before {\n  content: \"\\e05f\";\n}\n\n.k-i-arrow-chevron-right::before {\n  content: \"\\e014\";\n}\n\n.k-i-arrowhead-e::before {\n  content: \"\\e014\";\n}\n\n.k-i-chevron-down::before {\n  content: \"\\e015\";\n}\n\n.k-i-chevron-double-down::before {\n  content: \"\\e060\";\n}\n\n.k-i-arrow-chevron-down::before {\n  content: \"\\e015\";\n}\n\n.k-i-arrowhead-s::before {\n  content: \"\\e015\";\n}\n\n.k-i-chevron-left::before {\n  content: \"\\e016\";\n}\n\n.k-i-chevron-double-left::before {\n  content: \"\\e061\";\n}\n\n.k-i-arrow-chevron-left::before {\n  content: \"\\e016\";\n}\n\n.k-i-arrowhead-w::before {\n  content: \"\\e016\";\n}\n\n.k-i-arrow-up::before {\n  content: \"\\e017\";\n}\n\n.k-i-arrow-right::before {\n  content: \"\\e018\";\n}\n\n.k-i-arrow-down::before {\n  content: \"\\e019\";\n}\n\n.k-i-arrow-left::before {\n  content: \"\\e01a\";\n}\n\n.k-i-level-down::before {\n  content: \"\\e01b\";\n}\n\n.k-i-arrow-drill::before {\n  content: \"\\e01b\";\n}\n\n.k-i-level-up::before {\n  content: \"\\e01c\";\n}\n\n.k-i-arrow-parent::before {\n  content: \"\\e01c\";\n}\n\n.k-i-level-to-top::before {\n  content: \"\\e01d\";\n}\n\n.k-i-arrow-root::before {\n  content: \"\\e01d\";\n}\n\n.k-i-level-root::before {\n  content: \"\\e01d\";\n}\n\n.k-i-col-resize::before {\n  content: \"\\e01e\";\n}\n\n.k-i-arrows-resizing::before {\n  content: \"\\e01e\";\n}\n\n.k-i-arrows-axes::before {\n  content: \"\\e01f\";\n}\n\n.k-i-arrows-dimensions::before {\n  content: \"\\e01f\";\n}\n\n.k-i-dimension::before {\n  content: \"\\e01f\";\n}\n\n.k-i-arrows-swap::before {\n  content: \"\\e020\";\n}\n\n.k-i-drag-and-drop::before {\n  content: \"\\e021\";\n}\n\n.k-i-categorize::before {\n  content: \"\\e022\";\n}\n\n.k-i-grid::before {\n  content: \"\\e023\";\n}\n\n.k-i-grid-layout::before {\n  content: \"\\e024\";\n}\n\n.k-i-group::before {\n  content: \"\\e025\";\n}\n\n.k-i-ungroup::before {\n  content: \"\\e026\";\n}\n\n.k-i-handler-drag::before {\n  content: \"\\e027\";\n}\n\n.k-i-layout::before {\n  content: \"\\e028\";\n}\n\n.k-i-layout-1-by-4::before {\n  content: \"\\e029\";\n}\n\n.k-i-layout-2-by-2::before {\n  content: \"\\e02a\";\n}\n\n.k-i-page-layout::before {\n  content: \"\\e02a\";\n}\n\n.k-i-layout-side-by-side::before {\n  content: \"\\e02b\";\n}\n\n.k-i-layout-stacked::before {\n  content: \"\\e02c\";\n}\n\n.k-i-columns::before {\n  content: \"\\e02d\";\n}\n\n.k-i-rows::before {\n  content: \"\\e02e\";\n}\n\n.k-i-reorder::before {\n  content: \"\\e02f\";\n}\n\n.k-i-menu::before {\n  content: \"\\e030\";\n}\n\n.k-i-hamburger::before {\n  content: \"\\e030\";\n}\n\n.k-i-more-vertical::before {\n  content: \"\\e031\";\n}\n\n.k-i-more-v::before {\n  content: \"\\e031\";\n}\n\n.k-i-vbars::before {\n  content: \"\\e031\";\n}\n\n.k-i-more-horizontal::before {\n  content: \"\\e032\";\n}\n\n.k-i-more-h::before {\n  content: \"\\e032\";\n}\n\n.k-i-hbars::before {\n  content: \"\\e032\";\n}\n\n.k-i-overlap::before {\n  content: \"\\e033\";\n}\n\n.k-i-home::before {\n  content: \"\\e034\";\n}\n\n.k-i-root::before {\n  content: \"\\e034\";\n}\n\n.k-i-height::before {\n  content: \"\\e035\";\n}\n\n.k-i-width::before {\n  content: \"\\e036\";\n}\n\n.k-i-max-height::before {\n  content: \"\\e037\";\n}\n\n.k-i-max-width::before {\n  content: \"\\e038\";\n}\n\n.k-i-min-height::before {\n  content: \"\\e039\";\n}\n\n.k-i-min-width::before {\n  content: \"\\e03a\";\n}\n\n.k-i-margin::before {\n  content: \"\\e03b\";\n}\n\n.k-i-margin-top::before {\n  content: \"\\e03c\";\n}\n\n.k-i-margin-right::before {\n  content: \"\\e03d\";\n}\n\n.k-i-margin-bottom::before {\n  content: \"\\e03e\";\n}\n\n.k-i-margin-left::before {\n  content: \"\\e03f\";\n}\n\n.k-i-padding::before {\n  content: \"\\e040\";\n}\n\n.k-i-padding-top::before {\n  content: \"\\e041\";\n}\n\n.k-i-padding-right::before {\n  content: \"\\e042\";\n}\n\n.k-i-padding-bottom::before {\n  content: \"\\e043\";\n}\n\n.k-i-padding-left::before {\n  content: \"\\e044\";\n}\n\n.k-i-border-style::before {\n  content: \"\\e045\";\n}\n\n.k-i-border-style-top::before {\n  content: \"\\e046\";\n}\n\n.k-i-border-style-right::before {\n  content: \"\\e047\";\n}\n\n.k-i-border-style-bottom::before {\n  content: \"\\e048\";\n}\n\n.k-i-border-style-left::before {\n  content: \"\\e049\";\n}\n\n.k-i-border-radius::before {\n  content: \"\\e04a\";\n}\n\n.k-i-border-radius-top-right::before {\n  content: \"\\e04b\";\n}\n\n.k-i-border-radius-bottom-right::before {\n  content: \"\\e04c\";\n}\n\n.k-i-border-radius-bottom-left::before {\n  content: \"\\e04d\";\n}\n\n.k-i-border-radius-top-left::before {\n  content: \"\\e04e\";\n}\n\n.k-i-outline-width::before {\n  content: \"\\e04f\";\n}\n\n.k-i-outline-offset::before {\n  content: \"\\e050\";\n}\n\n.k-i-box-sizing::before {\n  content: \"\\e051\";\n}\n\n.k-i-position-top::before {\n  content: \"\\e052\";\n}\n\n.k-i-position-right::before {\n  content: \"\\e053\";\n}\n\n.k-i-position-bottom::before {\n  content: \"\\e054\";\n}\n\n.k-i-position-left::before {\n  content: \"\\e055\";\n}\n\n.k-i-display-block::before {\n  content: \"\\e056\";\n}\n\n.k-i-display-inline-block::before {\n  content: \"\\e057\";\n}\n\n.k-i-display-flex::before {\n  content: \"\\e058\";\n}\n\n.k-i-display-inline-flex::before {\n  content: \"\\e059\";\n}\n\n.k-i-gap-column::before {\n  content: \"\\e05a\";\n}\n\n.k-i-gap-row::before {\n  content: \"\\e05b\";\n}\n\n.k-i-handle-resize-alt::before {\n  content: \"\\e05c\";\n}\n\n.k-i-handle-resize::before {\n  content: \"\\e05d\";\n}\n\n.k-i-undo::before {\n  content: \"\\e100\";\n}\n\n.k-i-undo-large::before {\n  content: \"\\e100\";\n}\n\n.k-i-redo::before {\n  content: \"\\e101\";\n}\n\n.k-i-redo-large::before {\n  content: \"\\e101\";\n}\n\n.k-i-arrow-rotate-ccw::before {\n  content: \"\\e102\";\n}\n\n.k-i-reset::before {\n  content: \"\\e102\";\n}\n\n.k-i-arrow-rotate-cw::before {\n  content: \"\\e103\";\n}\n\n.k-i-reload::before {\n  content: \"\\e103\";\n}\n\n.k-i-refresh::before {\n  content: \"\\e103\";\n}\n\n.k-i-recurrence::before {\n  content: \"\\e103\";\n}\n\n.k-i-arrows-repeat::before {\n  content: \"\\e103\";\n}\n\n.k-i-arrows-no-repeat::before {\n  content: \"\\e104\";\n}\n\n.k-i-non-recurrence::before {\n  content: \"\\e104\";\n}\n\n.k-i-refresh-clear::before {\n  content: \"\\e104\";\n}\n\n.k-i-arrow-rotate-ccw-small::before {\n  content: \"\\e105\";\n}\n\n.k-i-reset-sm::before {\n  content: \"\\e105\";\n}\n\n.k-i-arrow-rotate-cw-small::before {\n  content: \"\\e106\";\n}\n\n.k-i-reload-sm::before {\n  content: \"\\e106\";\n}\n\n.k-i-refresh-sm::before {\n  content: \"\\e106\";\n}\n\n.k-i-recurrence-sm::before {\n  content: \"\\e106\";\n}\n\n.k-i-arrows-repeat-sm::before {\n  content: \"\\e106\";\n}\n\n.k-i-clock::before {\n  content: \"\\e107\";\n}\n\n.k-i-calendar::before {\n  content: \"\\e108\";\n}\n\n.k-i-save::before {\n  content: \"\\e109\";\n}\n\n.k-i-floppy::before {\n  content: \"\\e109\";\n}\n\n.k-i-print::before {\n  content: \"\\e10a\";\n}\n\n.k-i-printer::before {\n  content: \"\\e10a\";\n}\n\n.k-i-pencil::before {\n  content: \"\\e10b\";\n}\n\n.k-i-edit::before {\n  content: \"\\e10b\";\n}\n\n.k-i-trash::before {\n  content: \"\\e10c\";\n}\n\n.k-i-delete::before {\n  content: \"\\e10c\";\n}\n\n.k-i-paperclip::before {\n  content: \"\\e10d\";\n}\n\n.k-i-attachment::before {\n  content: \"\\e10d\";\n}\n\n.k-i-clip::before {\n  content: \"\\e10d\";\n}\n\n.k-i-paperclip-alt::before {\n  content: \"\\e10e\";\n}\n\n.k-i-attachment-45::before {\n  content: \"\\e10e\";\n}\n\n.k-i-clip-45::before {\n  content: \"\\e10e\";\n}\n\n.k-i-link::before {\n  content: \"\\e10f\";\n}\n\n.k-i-link-horizontal::before {\n  content: \"\\e10f\";\n}\n\n.k-i-hyperlink::before {\n  content: \"\\e10f\";\n}\n\n.k-i-link-h::before {\n  content: \"\\e10f\";\n}\n\n.k-i-unlink::before {\n  content: \"\\e110\";\n}\n\n.k-i-unlink-horizontal::before {\n  content: \"\\e110\";\n}\n\n.k-i-hyperlink-remove::before {\n  content: \"\\e110\";\n}\n\n.k-i-unlink-h::before {\n  content: \"\\e110\";\n}\n\n.k-i-link-vertical::before {\n  content: \"\\e111\";\n}\n\n.k-i-link-v::before {\n  content: \"\\e111\";\n}\n\n.k-i-unlink-vertical::before {\n  content: \"\\e112\";\n}\n\n.k-i-unlink-v::before {\n  content: \"\\e112\";\n}\n\n.k-i-lock::before {\n  content: \"\\e113\";\n}\n\n.k-i-unlock::before {\n  content: \"\\e114\";\n}\n\n.k-i-cancel::before {\n  content: \"\\e115\";\n}\n\n.k-i-cancel-outline::before {\n  content: \"\\e116\";\n}\n\n.k-i-deny::before {\n  content: \"\\e116\";\n}\n\n.k-i-cancel-circle::before {\n  content: \"\\e117\";\n}\n\n.k-i-check::before {\n  content: \"\\e118\";\n}\n\n.k-i-checkmark::before {\n  content: \"\\e118\";\n}\n\n.k-i-tick::before {\n  content: \"\\e118\";\n}\n\n.k-i-check-outline::before {\n  content: \"\\e119\";\n}\n\n.k-i-checkmark-outline::before {\n  content: \"\\e119\";\n}\n\n.k-i-success::before {\n  content: \"\\e119\";\n}\n\n.k-i-check-circle::before {\n  content: \"\\e11a\";\n}\n\n.k-i-checkmark-circle::before {\n  content: \"\\e11a\";\n}\n\n.k-i-x::before {\n  content: \"\\e11b\";\n}\n\n.k-i-close::before {\n  content: \"\\e11b\";\n}\n\n.k-i-clear::before {\n  content: \"\\e11b\";\n}\n\n.k-i-times::before {\n  content: \"\\e11b\";\n}\n\n.k-i-group-delete::before {\n  content: \"\\e11b\";\n}\n\n.k-i-x-outline::before {\n  content: \"\\e11c\";\n}\n\n.k-i-close-outline::before {\n  content: \"\\e11c\";\n}\n\n.k-i-clear-outline::before {\n  content: \"\\e11c\";\n}\n\n.k-i-times-outline::before {\n  content: \"\\e11c\";\n}\n\n.k-i-error::before {\n  content: \"\\e11c\";\n}\n\n.k-i-x-circle::before {\n  content: \"\\e11d\";\n}\n\n.k-i-close-circle::before {\n  content: \"\\e11d\";\n}\n\n.k-i-clear-circle::before {\n  content: \"\\e11d\";\n}\n\n.k-i-times-circle::before {\n  content: \"\\e11d\";\n}\n\n.k-i-plus::before {\n  content: \"\\e11e\";\n}\n\n.k-i-add::before {\n  content: \"\\e11e\";\n}\n\n.k-i-plus-outline::before {\n  content: \"\\e11f\";\n}\n\n.k-i-add-outline::before {\n  content: \"\\e11f\";\n}\n\n.k-i-plus-circle::before {\n  content: \"\\e120\";\n}\n\n.k-i-add-circle::before {\n  content: \"\\e120\";\n}\n\n.k-i-minus::before {\n  content: \"\\e121\";\n}\n\n.k-i-kpi-trend-equal::before {\n  content: \"\\e121\";\n}\n\n.k-i-minus-outline::before {\n  content: \"\\e122\";\n}\n\n.k-i-minus-circle::before {\n  content: \"\\e123\";\n}\n\n.k-i-sort-asc::before {\n  content: \"\\e124\";\n}\n\n.k-i-sort-desc::before {\n  content: \"\\e125\";\n}\n\n.k-i-sort-clear::before {\n  content: \"\\e126\";\n}\n\n.k-i-unsort::before {\n  content: \"\\e126\";\n}\n\n.k-i-sort-asc-small::before {\n  content: \"\\e127\";\n}\n\n.k-i-sort-asc-sm::before {\n  content: \"\\e127\";\n}\n\n.k-i-sort-desc-small::before {\n  content: \"\\e128\";\n}\n\n.k-i-sort-desc-sm::before {\n  content: \"\\e128\";\n}\n\n.k-i-filter::before {\n  content: \"\\e129\";\n}\n\n.k-i-filter-clear::before {\n  content: \"\\e12a\";\n}\n\n.k-i-filter-small::before {\n  content: \"\\e12b\";\n}\n\n.k-i-filter-sm::before {\n  content: \"\\e12b\";\n}\n\n.k-i-filter-sort-asc-small::before {\n  content: \"\\e12c\";\n}\n\n.k-i-filter-sort-asc-sm::before {\n  content: \"\\e12c\";\n}\n\n.k-i-filter-sort-desc-small::before {\n  content: \"\\e12d\";\n}\n\n.k-i-filter-sort-desc-sm::before {\n  content: \"\\e12d\";\n}\n\n.k-i-filter-add-expression::before {\n  content: \"\\e12e\";\n}\n\n.k-i-filter-add-group::before {\n  content: \"\\e12f\";\n}\n\n.k-i-login::before {\n  content: \"\\e130\";\n}\n\n.k-i-sign-in::before {\n  content: \"\\e130\";\n}\n\n.k-i-logout::before {\n  content: \"\\e131\";\n}\n\n.k-i-sign-out::before {\n  content: \"\\e131\";\n}\n\n.k-i-download::before {\n  content: \"\\e132\";\n}\n\n.k-i-upload::before {\n  content: \"\\e133\";\n}\n\n.k-i-hyperlink-open::before {\n  content: \"\\e134\";\n}\n\n.k-i-hyperlink-open-sm::before {\n  content: \"\\e135\";\n}\n\n.k-i-launch::before {\n  content: \"\\e136\";\n}\n\n.k-i-window::before {\n  content: \"\\e137\";\n}\n\n.k-i-window-maximize::before {\n  content: \"\\e137\";\n}\n\n.k-i-maximize::before {\n  content: \"\\e137\";\n}\n\n.k-i-window-restore::before {\n  content: \"\\e138\";\n}\n\n.k-i-windows::before {\n  content: \"\\e138\";\n}\n\n.k-i-tiles::before {\n  content: \"\\e138\";\n}\n\n.k-i-restore::before {\n  content: \"\\e138\";\n}\n\n.k-i-window-minimize::before {\n  content: \"\\e139\";\n}\n\n.k-i-minimize::before {\n  content: \"\\e139\";\n}\n\n.k-i-gear::before {\n  content: \"\\e13a\";\n}\n\n.k-i-cog::before {\n  content: \"\\e13a\";\n}\n\n.k-i-custom::before {\n  content: \"\\e13a\";\n}\n\n.k-i-gears::before {\n  content: \"\\e13b\";\n}\n\n.k-i-cogs::before {\n  content: \"\\e13b\";\n}\n\n.k-i-wrench::before {\n  content: \"\\e13c\";\n}\n\n.k-i-settings::before {\n  content: \"\\e13c\";\n}\n\n.k-i-eye::before {\n  content: \"\\e13d\";\n}\n\n.k-i-preview::before {\n  content: \"\\e13d\";\n}\n\n.k-i-search::before {\n  content: \"\\e13e\";\n}\n\n.k-i-zoom::before {\n  content: \"\\e13e\";\n}\n\n.k-i-zoom-in::before {\n  content: \"\\e13f\";\n}\n\n.k-i-zoom-out::before {\n  content: \"\\e140\";\n}\n\n.k-i-arrows-move::before {\n  content: \"\\e141\";\n}\n\n.k-i-pan::before {\n  content: \"\\e141\";\n}\n\n.k-i-move::before {\n  content: \"\\e141\";\n}\n\n.k-i-calculator::before {\n  content: \"\\e142\";\n}\n\n.k-i-cart::before {\n  content: \"\\e143\";\n}\n\n.k-i-shopping-cart::before {\n  content: \"\\e143\";\n}\n\n.k-i-connector::before {\n  content: \"\\e144\";\n}\n\n.k-i-plus-sm::before {\n  content: \"\\e145\";\n}\n\n.k-i-splus::before {\n  content: \"\\e145\";\n}\n\n.k-i-minus-sm::before {\n  content: \"\\e146\";\n}\n\n.k-i-sminus::before {\n  content: \"\\e146\";\n}\n\n.k-i-kpi-status-deny::before {\n  content: \"\\e147\";\n}\n\n.k-i-kpi-status-hold::before {\n  content: \"\\e148\";\n}\n\n.k-i-kpi-status-open::before {\n  content: \"\\e149\";\n}\n\n.k-i-equal::before {\n  content: \"\\e14a\";\n}\n\n.k-i-not-equal::before {\n  content: \"\\e14b\";\n}\n\n.k-i-less-or-equal::before {\n  content: \"\\e14c\";\n}\n\n.k-i-greater-or-equal::before {\n  content: \"\\e14d\";\n}\n\n.k-i-divide::before {\n  content: \"\\e14e\";\n}\n\n.k-i-accessibility::before {\n  content: \"\\e14f\";\n}\n\n.k-i-barcode-outline::before {\n  content: \"\\e150\";\n}\n\n.k-i-barcode::before {\n  content: \"\\e151\";\n}\n\n.k-i-barcode-scanner::before {\n  content: \"\\e152\";\n}\n\n.k-i-qr-code-outline::before {\n  content: \"\\e153\";\n}\n\n.k-i-qr-code::before {\n  content: \"\\e154\";\n}\n\n.k-i-qr-code-scanner::before {\n  content: \"\\e155\";\n}\n\n.k-i-barcode-qr-code-scanner::before {\n  content: \"\\e156\";\n}\n\n.k-i-signature::before {\n  content: \"\\e157\";\n}\n\n.k-i-hand::before {\n  content: \"\\e158\";\n}\n\n.k-i-pointer::before {\n  content: \"\\e159\";\n}\n\n.k-i-cursor::before {\n  content: \"\\e159\";\n}\n\n.k-i-stick::before {\n  content: \"\\e15a\";\n}\n\n.k-i-unstick::before {\n  content: \"\\e15b\";\n}\n\n.k-i-set-column-position::before {\n  content: \"\\e15c\";\n}\n\n.k-i-clock-arrow-rotate::before {\n  content: \"\\e15d\";\n}\n\n.k-i-play::before {\n  content: \"\\e200\";\n}\n\n.k-i-pause::before {\n  content: \"\\e201\";\n}\n\n.k-i-stop::before {\n  content: \"\\e202\";\n}\n\n.k-i-rewind::before {\n  content: \"\\e203\";\n}\n\n.k-i-forward::before {\n  content: \"\\e204\";\n}\n\n.k-i-volume-down::before {\n  content: \"\\e205\";\n}\n\n.k-i-volume-low::before {\n  content: \"\\e205\";\n}\n\n.k-i-volume-up::before {\n  content: \"\\e206\";\n}\n\n.k-i-volume-high::before {\n  content: \"\\e206\";\n}\n\n.k-i-volume-mute::before {\n  content: \"\\e207\";\n}\n\n.k-i-volume-off::before {\n  content: \"\\e207\";\n}\n\n.k-i-hd::before {\n  content: \"\\e208\";\n}\n\n.k-i-closed-captions::before {\n  content: \"\\e209\";\n}\n\n.k-i-subtitles::before {\n  content: \"\\e209\";\n}\n\n.k-i-playlist::before {\n  content: \"\\e20a\";\n}\n\n.k-i-music-notes::before {\n  content: \"\\e20b\";\n}\n\n.k-i-audio::before {\n  content: \"\\e20b\";\n}\n\n.k-i-play-sm::before {\n  content: \"\\e20c\";\n}\n\n.k-i-pause-sm::before {\n  content: \"\\e20d\";\n}\n\n.k-i-stop-sm::before {\n  content: \"\\e20e\";\n}\n\n.k-i-heart-outline::before {\n  content: \"\\e300\";\n}\n\n.k-i-fav-outline::before {\n  content: \"\\e300\";\n}\n\n.k-i-favorite-outline::before {\n  content: \"\\e300\";\n}\n\n.k-i-heart::before {\n  content: \"\\e301\";\n}\n\n.k-i-fav::before {\n  content: \"\\e301\";\n}\n\n.k-i-favorite::before {\n  content: \"\\e301\";\n}\n\n.k-i-star-outline::before {\n  content: \"\\e302\";\n}\n\n.k-i-bookmark-outline::before {\n  content: \"\\e302\";\n}\n\n.k-i-star::before {\n  content: \"\\e303\";\n}\n\n.k-i-bookmark::before {\n  content: \"\\e303\";\n}\n\n.k-i-checkbox::before {\n  content: \"\\e304\";\n}\n\n.k-i-shape-rect::before {\n  content: \"\\e304\";\n}\n\n.k-i-checkbox-checked::before {\n  content: \"\\e305\";\n}\n\n.k-i-checkbox-indeterminate::before {\n  content: \"\\e306\";\n}\n\n.k-i-tri-state-indeterminate::before {\n  content: \"\\e306\";\n}\n\n.k-i-checkbox-null::before {\n  content: \"\\e307\";\n}\n\n.k-i-tri-state-null::before {\n  content: \"\\e307\";\n}\n\n.k-i-circle::before {\n  content: \"\\e308\";\n}\n\n.k-i-radiobutton::before {\n  content: \"\\e309\";\n}\n\n.k-i-shape-circle::before {\n  content: \"\\e309\";\n}\n\n.k-i-radiobutton-checked::before {\n  content: \"\\e30a\";\n}\n\n.k-i-bell::before {\n  content: \"\\e400\";\n}\n\n.k-i-notification::before {\n  content: \"\\e400\";\n}\n\n.k-i-info-circle::before {\n  content: \"\\e401\";\n}\n\n.k-i-information::before {\n  content: \"\\e401\";\n}\n\n.k-i-info::before {\n  content: \"\\e401\";\n}\n\n.k-i-note::before {\n  content: \"\\e401\";\n}\n\n.k-i-question-circle::before {\n  content: \"\\e402\";\n}\n\n.k-i-question::before {\n  content: \"\\e402\";\n}\n\n.k-i-help::before {\n  content: \"\\e402\";\n}\n\n.k-i-exclamation-circle::before {\n  content: \"\\e403\";\n}\n\n.k-i-warning::before {\n  content: \"\\e403\";\n}\n\n.k-i-exception::before {\n  content: \"\\e403\";\n}\n\n.k-i-camera::before {\n  content: \"\\e500\";\n}\n\n.k-i-photo-camera::before {\n  content: \"\\e500\";\n}\n\n.k-i-image::before {\n  content: \"\\e501\";\n}\n\n.k-i-photo::before {\n  content: \"\\e501\";\n}\n\n.k-i-image-export::before {\n  content: \"\\e502\";\n}\n\n.k-i-photo-export::before {\n  content: \"\\e502\";\n}\n\n.k-i-zoom-actual-size::before {\n  content: \"\\e503\";\n}\n\n.k-i-zoom-best-fit::before {\n  content: \"\\e504\";\n}\n\n.k-i-image-resize::before {\n  content: \"\\e505\";\n}\n\n.k-i-crop::before {\n  content: \"\\e506\";\n}\n\n.k-i-mirror::before {\n  content: \"\\e507\";\n}\n\n.k-i-flip-horizontal::before {\n  content: \"\\e508\";\n}\n\n.k-i-flip-h::before {\n  content: \"\\e508\";\n}\n\n.k-i-flip-vertical::before {\n  content: \"\\e509\";\n}\n\n.k-i-flip-v::before {\n  content: \"\\e509\";\n}\n\n.k-i-rotate::before {\n  content: \"\\e50a\";\n}\n\n.k-i-rotate-right::before {\n  content: \"\\e50b\";\n}\n\n.k-i-rotate-cw::before {\n  content: \"\\e50b\";\n}\n\n.k-i-rotate-left::before {\n  content: \"\\e50c\";\n}\n\n.k-i-rotate-ccw::before {\n  content: \"\\e50c\";\n}\n\n.k-i-brush::before {\n  content: \"\\e50d\";\n}\n\n.k-i-palette::before {\n  content: \"\\e50e\";\n}\n\n.k-i-droplet::before {\n  content: \"\\e50f\";\n}\n\n.k-i-paint::before {\n  content: \"\\e50f\";\n}\n\n.k-i-background::before {\n  content: \"\\e50f\";\n}\n\n.k-i-shape-line::before {\n  content: \"\\e510\";\n}\n\n.k-i-line::before {\n  content: \"\\e510\";\n}\n\n.k-i-brightness-contrast::before {\n  content: \"\\e511\";\n}\n\n.k-i-sliders::before {\n  content: \"\\e512\";\n}\n\n.k-i-saturation::before {\n  content: \"\\e512\";\n}\n\n.k-i-invert-colors::before {\n  content: \"\\e513\";\n}\n\n.k-i-transparency::before {\n  content: \"\\e514\";\n}\n\n.k-i-opacity::before {\n  content: \"\\e514\";\n}\n\n.k-i-grayscale::before {\n  content: \"\\e515\";\n}\n\n.k-i-blur::before {\n  content: \"\\e516\";\n}\n\n.k-i-sharpen::before {\n  content: \"\\e517\";\n}\n\n.k-i-shapes::before {\n  content: \"\\e518\";\n}\n\n.k-i-shape::before {\n  content: \"\\e518\";\n}\n\n.k-i-round-corners::before {\n  content: \"\\e519\";\n}\n\n.k-i-bring-to-front::before {\n  content: \"\\e51a\";\n}\n\n.k-i-front-element::before {\n  content: \"\\e51a\";\n}\n\n.k-i-bring-to-back::before {\n  content: \"\\e51b\";\n}\n\n.k-i-back-element::before {\n  content: \"\\e51b\";\n}\n\n.k-i-bring-forward::before {\n  content: \"\\e51c\";\n}\n\n.k-i-forward-element::before {\n  content: \"\\e51c\";\n}\n\n.k-i-bring-backward::before {\n  content: \"\\e51d\";\n}\n\n.k-i-backward-element::before {\n  content: \"\\e51d\";\n}\n\n.k-i-align-self-start::before {\n  content: \"\\e51e\";\n}\n\n.k-i-align-left-element::before {\n  content: \"\\e51e\";\n}\n\n.k-i-align-self-center::before {\n  content: \"\\e51f\";\n}\n\n.k-i-align-center-element::before {\n  content: \"\\e51f\";\n}\n\n.k-i-align-self-end::before {\n  content: \"\\e520\";\n}\n\n.k-i-align-right-element::before {\n  content: \"\\e520\";\n}\n\n.k-i-align-self-start-alt::before {\n  content: \"\\e521\";\n}\n\n.k-i-align-top-element::before {\n  content: \"\\e521\";\n}\n\n.k-i-align-self-center-alt::before {\n  content: \"\\e522\";\n}\n\n.k-i-align-middle-element::before {\n  content: \"\\e522\";\n}\n\n.k-i-align-self-end-alt::before {\n  content: \"\\e523\";\n}\n\n.k-i-align-bottom-element::before {\n  content: \"\\e523\";\n}\n\n.k-i-thumbnails-up::before {\n  content: \"\\e524\";\n}\n\n.k-i-thumbnails-right::before {\n  content: \"\\e525\";\n}\n\n.k-i-thumbnails-down::before {\n  content: \"\\e526\";\n}\n\n.k-i-thumbnails-left::before {\n  content: \"\\e527\";\n}\n\n.k-i-fullscreen::before {\n  content: \"\\e528\";\n}\n\n.k-i-full-screen::before {\n  content: \"\\e528\";\n}\n\n.k-i-fullscreen-enter::before {\n  content: \"\\e528\";\n}\n\n.k-i-fullscreen-exit::before {\n  content: \"\\e529\";\n}\n\n.k-i-full-screen-exit::before {\n  content: \"\\e529\";\n}\n\n.k-i-droplet-slash::before {\n  content: \"\\e52a\";\n}\n\n.k-i-reset-color::before {\n  content: \"\\e52a\";\n}\n\n.k-i-paint-remove::before {\n  content: \"\\e52a\";\n}\n\n.k-i-background-remove::before {\n  content: \"\\e52a\";\n}\n\n.k-i-photos::before {\n  content: \"\\e52b\";\n}\n\n.k-i-images::before {\n  content: \"\\e52b\";\n}\n\n.k-i-gallery::before {\n  content: \"\\e52b\";\n}\n\n.k-i-align-to-grid::before {\n  content: \"\\e52c\";\n}\n\n.k-i-size-to-grid::before {\n  content: \"\\e52d\";\n}\n\n.k-i-make-same-size::before {\n  content: \"\\e52e\";\n}\n\n.k-i-make-same-width::before {\n  content: \"\\e52f\";\n}\n\n.k-i-make-same-height::before {\n  content: \"\\e530\";\n}\n\n.k-i-make-horizontal-spacing-equal::before {\n  content: \"\\e531\";\n}\n\n.k-i-increase-horizontal-spacing::before {\n  content: \"\\e532\";\n}\n\n.k-i-decrease-horizontal-spacing::before {\n  content: \"\\e533\";\n}\n\n.k-i-remove-horizontal-spacing::before {\n  content: \"\\e534\";\n}\n\n.k-i-make-vertical-spacing-equal::before {\n  content: \"\\e535\";\n}\n\n.k-i-increase-vertical-spacing::before {\n  content: \"\\e536\";\n}\n\n.k-i-decrease-vertical-spacing::before {\n  content: \"\\e537\";\n}\n\n.k-i-remove-vertical-spacing::before {\n  content: \"\\e538\";\n}\n\n.k-i-eyedropper::before {\n  content: \"\\e539\";\n}\n\n.k-i-snap-grid::before {\n  content: \"\\e53a\";\n}\n\n.k-i-snap-to-gridlines::before {\n  content: \"\\e53b\";\n}\n\n.k-i-snap-to-snaplines::before {\n  content: \"\\e53c\";\n}\n\n.k-i-dimentions::before {\n  content: \"\\e53d\";\n}\n\n.k-i-align-self-stretch::before {\n  content: \"\\e53e\";\n}\n\n.k-i-align-stretch-element-horizontal::before {\n  content: \"\\e53e\";\n}\n\n.k-i-align-self-stretch-alt::before {\n  content: \"\\e53f\";\n}\n\n.k-i-align-stretch-element-vertical::before {\n  content: \"\\e53f\";\n}\n\n.k-i-align-items-start::before {\n  content: \"\\e540\";\n}\n\n.k-i-align-left-elements::before {\n  content: \"\\e540\";\n}\n\n.k-i-align-items-center::before {\n  content: \"\\e541\";\n}\n\n.k-i-align-center-elements::before {\n  content: \"\\e541\";\n}\n\n.k-i-align-items-end::before {\n  content: \"\\e542\";\n}\n\n.k-i-align-right-elements::before {\n  content: \"\\e542\";\n}\n\n.k-i-align-items-stretch::before {\n  content: \"\\e543\";\n}\n\n.k-i-align-stretch-elements-horizontal::before {\n  content: \"\\e543\";\n}\n\n.k-i-align-items-baseline::before {\n  content: \"\\e544\";\n}\n\n.k-i-align-baseline-horizontal::before {\n  content: \"\\e544\";\n}\n\n.k-i-align-items-start-alt::before {\n  content: \"\\e545\";\n}\n\n.k-i-align-top-elements::before {\n  content: \"\\e545\";\n}\n\n.k-i-align-items-center-alt::before {\n  content: \"\\e546\";\n}\n\n.k-i-align-middle-elements::before {\n  content: \"\\e546\";\n}\n\n.k-i-align-items-end-alt::before {\n  content: \"\\e547\";\n}\n\n.k-i-align-bottom-elements::before {\n  content: \"\\e547\";\n}\n\n.k-i-align-items-stretch-alt::before {\n  content: \"\\e548\";\n}\n\n.k-i-align-stretch-elements-vertical::before {\n  content: \"\\e548\";\n}\n\n.k-i-align-items-baseline-alt::before {\n  content: \"\\e549\";\n}\n\n.k-i-align-baseline-vertical::before {\n  content: \"\\e549\";\n}\n\n.k-i-justify-content-start::before {\n  content: \"\\e54a\";\n}\n\n.k-i-justify-start-horizontal::before {\n  content: \"\\e54a\";\n}\n\n.k-i-justify-content-center::before {\n  content: \"\\e54b\";\n}\n\n.k-i-justify-center-horizontal::before {\n  content: \"\\e54b\";\n}\n\n.k-i-justify-content-end::before {\n  content: \"\\e54c\";\n}\n\n.k-i-justify-end-horizontal::before {\n  content: \"\\e54c\";\n}\n\n.k-i-justify-content-between::before {\n  content: \"\\e54d\";\n}\n\n.k-i-justify-between-horizontal::before {\n  content: \"\\e54d\";\n}\n\n.k-i-justify-content-around::before {\n  content: \"\\e54e\";\n}\n\n.k-i-justify-around-horizontal::before {\n  content: \"\\e54e\";\n}\n\n.k-i-justify-content-start-alt::before {\n  content: \"\\e54f\";\n}\n\n.k-i-justify-start-vertical::before {\n  content: \"\\e54f\";\n}\n\n.k-i-justify-content-center-alt::before {\n  content: \"\\e550\";\n}\n\n.k-i-justify-center-vertical::before {\n  content: \"\\e550\";\n}\n\n.k-i-justify-content-end-alt::before {\n  content: \"\\e551\";\n}\n\n.k-i-justify-end-vertical::before {\n  content: \"\\e551\";\n}\n\n.k-i-justify-content-between-alt::before {\n  content: \"\\e552\";\n}\n\n.k-i-justify-between-vertical::before {\n  content: \"\\e552\";\n}\n\n.k-i-justify-content-around-alt::before {\n  content: \"\\e553\";\n}\n\n.k-i-justify-around-vertical::before {\n  content: \"\\e553\";\n}\n\n.k-i-color-canvas::before {\n  content: \"\\e554\";\n}\n\n.k-i-file-wrench::before {\n  content: \"\\e600\";\n}\n\n.k-i-page-properties::before {\n  content: \"\\e600\";\n}\n\n.k-i-bold::before {\n  content: \"\\e601\";\n}\n\n.k-i-italic::before {\n  content: \"\\e602\";\n}\n\n.k-i-underline::before {\n  content: \"\\e603\";\n}\n\n.k-i-font-family::before {\n  content: \"\\e604\";\n}\n\n.k-i-foreground-color::before {\n  content: \"\\e605\";\n}\n\n.k-i-text::before {\n  content: \"\\e605\";\n}\n\n.k-i-convert-lowercase::before {\n  content: \"\\e606\";\n}\n\n.k-i-convert-uppercase::before {\n  content: \"\\e607\";\n}\n\n.k-i-strikethrough::before {\n  content: \"\\e608\";\n}\n\n.k-i-strike-through::before {\n  content: \"\\e608\";\n}\n\n.k-i-subscript::before {\n  content: \"\\e609\";\n}\n\n.k-i-sub-script::before {\n  content: \"\\e609\";\n}\n\n.k-i-supscript::before {\n  content: \"\\e60a\";\n}\n\n.k-i-sup-script::before {\n  content: \"\\e60a\";\n}\n\n.k-i-superscript::before {\n  content: \"\\e60a\";\n}\n\n.k-i-div::before {\n  content: \"\\e60b\";\n}\n\n.k-i-all::before {\n  content: \"\\e60c\";\n}\n\n.k-i-h1::before {\n  content: \"\\e60d\";\n}\n\n.k-i-h2::before {\n  content: \"\\e60e\";\n}\n\n.k-i-h3::before {\n  content: \"\\e60f\";\n}\n\n.k-i-h4::before {\n  content: \"\\e610\";\n}\n\n.k-i-h5::before {\n  content: \"\\e611\";\n}\n\n.k-i-h6::before {\n  content: \"\\e612\";\n}\n\n.k-i-list-ordered::before {\n  content: \"\\e613\";\n}\n\n.k-i-list-numbered::before {\n  content: \"\\e613\";\n}\n\n.k-i-insert-ordered-list::before {\n  content: \"\\e613\";\n}\n\n.k-i-list-unordered::before {\n  content: \"\\e614\";\n}\n\n.k-i-list-bulleted::before {\n  content: \"\\e614\";\n}\n\n.k-i-insert-unordered-list::before {\n  content: \"\\e614\";\n}\n\n.k-i-indent::before {\n  content: \"\\e615\";\n}\n\n.k-i-indent-increase::before {\n  content: \"\\e615\";\n}\n\n.k-i-outdent::before {\n  content: \"\\e616\";\n}\n\n.k-i-indent-decrease::before {\n  content: \"\\e616\";\n}\n\n.k-i-insert-top::before {\n  content: \"\\e617\";\n}\n\n.k-i-insert-up::before {\n  content: \"\\e617\";\n}\n\n.k-i-insert-n::before {\n  content: \"\\e617\";\n}\n\n.k-i-insert-middle::before {\n  content: \"\\e618\";\n}\n\n.k-i-insert-m::before {\n  content: \"\\e618\";\n}\n\n.k-i-insert-bottom::before {\n  content: \"\\e619\";\n}\n\n.k-i-insert-down::before {\n  content: \"\\e619\";\n}\n\n.k-i-insert-s::before {\n  content: \"\\e619\";\n}\n\n.k-i-align-top::before {\n  content: \"\\e61a\";\n}\n\n.k-i-align-middle::before {\n  content: \"\\e61b\";\n}\n\n.k-i-align-bottom::before {\n  content: \"\\e61c\";\n}\n\n.k-i-align-left::before {\n  content: \"\\e61d\";\n}\n\n.k-i-justify-left::before {\n  content: \"\\e61d\";\n}\n\n.k-i-align-center::before {\n  content: \"\\e61e\";\n}\n\n.k-i-justify-center::before {\n  content: \"\\e61e\";\n}\n\n.k-i-align-right::before {\n  content: \"\\e61f\";\n}\n\n.k-i-justify-left::before {\n  content: \"\\e61f\";\n}\n\n.k-i-align-justify::before {\n  content: \"\\e620\";\n}\n\n.k-i-justify-full::before {\n  content: \"\\e620\";\n}\n\n.k-i-align-remove::before {\n  content: \"\\e621\";\n}\n\n.k-i-justify-clear::before {\n  content: \"\\e621\";\n}\n\n.k-i-text-wrap::before {\n  content: \"\\e622\";\n}\n\n.k-i-horizontal-rule::before {\n  content: \"\\e623\";\n}\n\n.k-i-rule-horizontal::before {\n  content: \"\\e623\";\n}\n\n.k-i-hr::before {\n  content: \"\\e623\";\n}\n\n.k-i-table-align-top-left::before {\n  content: \"\\e624\";\n}\n\n.k-i-table-align-top-center::before {\n  content: \"\\e625\";\n}\n\n.k-i-table-align-top-right::before {\n  content: \"\\e626\";\n}\n\n.k-i-table-align-middle-left::before {\n  content: \"\\e627\";\n}\n\n.k-i-table-align-middle-center::before {\n  content: \"\\e628\";\n}\n\n.k-i-table-align-middle-right::before {\n  content: \"\\e629\";\n}\n\n.k-i-table-align-bottom-left::before {\n  content: \"\\e62a\";\n}\n\n.k-i-table-align-bottom-center::before {\n  content: \"\\e62b\";\n}\n\n.k-i-table-align-bottom-right::before {\n  content: \"\\e62c\";\n}\n\n.k-i-table-align-remove::before {\n  content: \"\\e62d\";\n}\n\n.k-i-borders-all::before {\n  content: \"\\e62e\";\n}\n\n.k-i-all-borders::before {\n  content: \"\\e62e\";\n}\n\n.k-i-borders-outside::before {\n  content: \"\\e62f\";\n}\n\n.k-i-outside-borders::before {\n  content: \"\\e62f\";\n}\n\n.k-i-borders-inside::before {\n  content: \"\\e630\";\n}\n\n.k-i-inside-borders::before {\n  content: \"\\e630\";\n}\n\n.k-i-borders-inside-horizontal::before {\n  content: \"\\e631\";\n}\n\n.k-i-border-inside-h::before {\n  content: \"\\e631\";\n}\n\n.k-i-inside-horizontal-borders::before {\n  content: \"\\e631\";\n}\n\n.k-i-borders-inside-vertical::before {\n  content: \"\\e632\";\n}\n\n.k-i-borders-inside-v::before {\n  content: \"\\e632\";\n}\n\n.k-i-inside-vertical-borders::before {\n  content: \"\\e632\";\n}\n\n.k-i-border-top::before {\n  content: \"\\e633\";\n}\n\n.k-i-top-border::before {\n  content: \"\\e633\";\n}\n\n.k-i-border-bottom::before {\n  content: \"\\e634\";\n}\n\n.k-i-bottom-border::before {\n  content: \"\\e634\";\n}\n\n.k-i-border-left::before {\n  content: \"\\e635\";\n}\n\n.k-i-left-border::before {\n  content: \"\\e635\";\n}\n\n.k-i-border-right::before {\n  content: \"\\e636\";\n}\n\n.k-i-right-border::before {\n  content: \"\\e636\";\n}\n\n.k-i-borders-none::before {\n  content: \"\\e637\";\n}\n\n.k-i-border-no::before {\n  content: \"\\e637\";\n}\n\n.k-i-no-borders::before {\n  content: \"\\e637\";\n}\n\n.k-i-borders-show-hide::before {\n  content: \"\\e638\";\n}\n\n.k-i-form::before {\n  content: \"\\e639\";\n}\n\n.k-i-border::before {\n  content: \"\\e639\";\n}\n\n.k-i-form-element::before {\n  content: \"\\e63a\";\n}\n\n.k-i-code-snippet::before {\n  content: \"\\e63b\";\n}\n\n.k-i-select-all::before {\n  content: \"\\e63c\";\n}\n\n.k-i-button::before {\n  content: \"\\e63d\";\n}\n\n.k-i-select-box::before {\n  content: \"\\e63e\";\n}\n\n.k-i-calendar-date::before {\n  content: \"\\e63f\";\n}\n\n.k-i-group-box::before {\n  content: \"\\e640\";\n}\n\n.k-i-textarea::before {\n  content: \"\\e641\";\n}\n\n.k-i-textbox::before {\n  content: \"\\e642\";\n}\n\n.k-i-textbox-hidden::before {\n  content: \"\\e643\";\n}\n\n.k-i-password::before {\n  content: \"\\e644\";\n}\n\n.k-i-paragraph-add::before {\n  content: \"\\e645\";\n}\n\n.k-i-edit-tools::before {\n  content: \"\\e646\";\n}\n\n.k-i-template-manager::before {\n  content: \"\\e647\";\n}\n\n.k-i-change-manually::before {\n  content: \"\\e648\";\n}\n\n.k-i-track-changes::before {\n  content: \"\\e649\";\n}\n\n.k-i-track-changes-enable::before {\n  content: \"\\e64a\";\n}\n\n.k-i-track-changes-accept::before {\n  content: \"\\e64b\";\n}\n\n.k-i-track-changes-accept-all::before {\n  content: \"\\e64c\";\n}\n\n.k-i-track-changes-reject::before {\n  content: \"\\e64d\";\n}\n\n.k-i-track-changes-reject-all::before {\n  content: \"\\e64e\";\n}\n\n.k-i-document-manager::before {\n  content: \"\\e64f\";\n}\n\n.k-i-custom-icon::before {\n  content: \"\\e650\";\n}\n\n.k-i-book::before {\n  content: \"\\e651\";\n}\n\n.k-i-dictionary-add::before {\n  content: \"\\e651\";\n}\n\n.k-i-image-add::before {\n  content: \"\\e652\";\n}\n\n.k-i-image-light-dialog::before {\n  content: \"\\e652\";\n}\n\n.k-i-image-insert::before {\n  content: \"\\e652\";\n}\n\n.k-i-insert-image::before {\n  content: \"\\e652\";\n}\n\n.k-i-image-edit::before {\n  content: \"\\e653\";\n}\n\n.k-i-image-map-editor::before {\n  content: \"\\e654\";\n}\n\n.k-i-comment::before {\n  content: \"\\e655\";\n}\n\n.k-i-comment-remove::before {\n  content: \"\\e656\";\n}\n\n.k-i-comments-remove::before {\n  content: \"\\e657\";\n}\n\n.k-i-comments-remove-all::before {\n  content: \"\\e657\";\n}\n\n.k-i-silverlight::before {\n  content: \"\\e658\";\n}\n\n.k-i-media-manager::before {\n  content: \"\\e659\";\n}\n\n.k-i-video-external::before {\n  content: \"\\e65a\";\n}\n\n.k-i-flash-manager::before {\n  content: \"\\e65b\";\n}\n\n.k-i-binoculars::before {\n  content: \"\\e65c\";\n}\n\n.k-i-find-and-replace::before {\n  content: \"\\e65c\";\n}\n\n.k-i-find::before {\n  content: \"\\e65c\";\n}\n\n.k-i-copy::before {\n  content: \"\\e65d\";\n}\n\n.k-i-files::before {\n  content: \"\\e65d\";\n}\n\n.k-i-cut::before {\n  content: \"\\e65e\";\n}\n\n.k-i-clipboard::before {\n  content: \"\\e65f\";\n}\n\n.k-i-paste::before {\n  content: \"\\e65f\";\n}\n\n.k-i-clipboard-code::before {\n  content: \"\\e660\";\n}\n\n.k-i-paste-as-html::before {\n  content: \"\\e660\";\n}\n\n.k-i-clipboard-word::before {\n  content: \"\\e661\";\n}\n\n.k-i-paste-from-word::before {\n  content: \"\\e661\";\n}\n\n.k-i-clipboard-word-alt::before {\n  content: \"\\e662\";\n}\n\n.k-i-paste-from-word-strip-file::before {\n  content: \"\\e662\";\n}\n\n.k-i-clipboard-html::before {\n  content: \"\\e663\";\n}\n\n.k-i-paste-html::before {\n  content: \"\\e663\";\n}\n\n.k-i-clipboard-markdown::before {\n  content: \"\\e664\";\n}\n\n.k-i-paste-markdown::before {\n  content: \"\\e664\";\n}\n\n.k-i-clipboard-text::before {\n  content: \"\\e665\";\n}\n\n.k-i-paste-plain-text::before {\n  content: \"\\e665\";\n}\n\n.k-i-apply-format::before {\n  content: \"\\e666\";\n}\n\n.k-i-clear-css::before {\n  content: \"\\e667\";\n}\n\n.k-i-clearformat::before {\n  content: \"\\e667\";\n}\n\n.k-i-copy-format::before {\n  content: \"\\e668\";\n}\n\n.k-i-strip-all-formatting::before {\n  content: \"\\e669\";\n}\n\n.k-i-strip-css-format::before {\n  content: \"\\e66a\";\n}\n\n.k-i-strip-font-elements::before {\n  content: \"\\e66b\";\n}\n\n.k-i-strip-span-elements::before {\n  content: \"\\e66c\";\n}\n\n.k-i-strip-word-formatting::before {\n  content: \"\\e66d\";\n}\n\n.k-i-format-code-block::before {\n  content: \"\\e66e\";\n}\n\n.k-i-building-blocks::before {\n  content: \"\\e66f\";\n}\n\n.k-i-style-builder::before {\n  content: \"\\e66f\";\n}\n\n.k-i-puzzle-piece::before {\n  content: \"\\e670\";\n}\n\n.k-i-module-manager::before {\n  content: \"\\e670\";\n}\n\n.k-i-puzzle::before {\n  content: \"\\e670\";\n}\n\n.k-i-link-add::before {\n  content: \"\\e671\";\n}\n\n.k-i-hyperlink-light-dialog::before {\n  content: \"\\e671\";\n}\n\n.k-i-hyperlink-insert::before {\n  content: \"\\e671\";\n}\n\n.k-i-globe-link::before {\n  content: \"\\e672\";\n}\n\n.k-i-hyperlink-globe::before {\n  content: \"\\e672\";\n}\n\n.k-i-globe-unlink::before {\n  content: \"\\e673\";\n}\n\n.k-i-hyperlink-globe-remove::before {\n  content: \"\\e673\";\n}\n\n.k-i-envelop-link::before {\n  content: \"\\e674\";\n}\n\n.k-i-hyperlink-email::before {\n  content: \"\\e674\";\n}\n\n.k-i-anchor::before {\n  content: \"\\e675\";\n}\n\n.k-i-table-add::before {\n  content: \"\\e676\";\n}\n\n.k-i-table-light-dialog::before {\n  content: \"\\e676\";\n}\n\n.k-i-table-insert::before {\n  content: \"\\e676\";\n}\n\n.k-i-create-table::before {\n  content: \"\\e676\";\n}\n\n.k-i-table::before {\n  content: \"\\e677\";\n}\n\n.k-i-table-properties::before {\n  content: \"\\e678\";\n}\n\n.k-i-table-cell::before {\n  content: \"\\e679\";\n}\n\n.k-i-table-cell-properties::before {\n  content: \"\\e67a\";\n}\n\n.k-i-table-column-insert-left::before {\n  content: \"\\e67b\";\n}\n\n.k-i-add-column-left::before {\n  content: \"\\e67b\";\n}\n\n.k-i-table-column-insert-right::before {\n  content: \"\\e67c\";\n}\n\n.k-i-add-column-right::before {\n  content: \"\\e67c\";\n}\n\n.k-i-table-row-insert-above::before {\n  content: \"\\e67d\";\n}\n\n.k-i-add-row-above::before {\n  content: \"\\e67d\";\n}\n\n.k-i-table-row-insert-below::before {\n  content: \"\\e67e\";\n}\n\n.k-i-add-row-below::before {\n  content: \"\\e67e\";\n}\n\n.k-i-table-column-delete::before {\n  content: \"\\e67f\";\n}\n\n.k-i-delete-column::before {\n  content: \"\\e67f\";\n}\n\n.k-i-table-row-delete::before {\n  content: \"\\e680\";\n}\n\n.k-i-delete-row::before {\n  content: \"\\e680\";\n}\n\n.k-i-table-cell-delete::before {\n  content: \"\\e681\";\n}\n\n.k-i-table-delete::before {\n  content: \"\\e682\";\n}\n\n.k-i-cells-merge::before {\n  content: \"\\e683\";\n}\n\n.k-i-merge-cells::before {\n  content: \"\\e683\";\n}\n\n.k-i-cells-merge-horizontally::before {\n  content: \"\\e684\";\n}\n\n.k-i-cells-merge-h::before {\n  content: \"\\e684\";\n}\n\n.k-i-merge-horizontally::before {\n  content: \"\\e684\";\n}\n\n.k-i-cells-merge-vertically::before {\n  content: \"\\e685\";\n}\n\n.k-i-cells-merge-v::before {\n  content: \"\\e685\";\n}\n\n.k-i-merge-vertically::before {\n  content: \"\\e685\";\n}\n\n.k-i-cell-split-horizontally::before {\n  content: \"\\e686\";\n}\n\n.k-i-cells-split-h::before {\n  content: \"\\e686\";\n}\n\n.k-i-cell-split-vertically::before {\n  content: \"\\e687\";\n}\n\n.k-i-cells-split-v::before {\n  content: \"\\e687\";\n}\n\n.k-i-table-unmerge::before {\n  content: \"\\e688\";\n}\n\n.k-i-normal-layout::before {\n  content: \"\\e688\";\n}\n\n.k-i-pane-freeze::before {\n  content: \"\\e689\";\n}\n\n.k-i-freeze-pane::before {\n  content: \"\\e689\";\n}\n\n.k-i-row-freeze::before {\n  content: \"\\e68a\";\n}\n\n.k-i-freeze-row::before {\n  content: \"\\e68a\";\n}\n\n.k-i-column-freeze::before {\n  content: \"\\e68b\";\n}\n\n.k-i-col-freeze::before {\n  content: \"\\e68b\";\n}\n\n.k-i-freeze-col::before {\n  content: \"\\e68b\";\n}\n\n.k-i-toolbar-float::before {\n  content: \"\\e68c\";\n}\n\n.k-i-spell-checker::before {\n  content: \"\\e68d\";\n}\n\n.k-i-validation-xhtml::before {\n  content: \"\\e68e\";\n}\n\n.k-i-validation-data::before {\n  content: \"\\e68f\";\n}\n\n.k-i-toggle-full-screen-mode::before {\n  content: \"\\e690\";\n}\n\n.k-i-formula-fx::before {\n  content: \"\\e691\";\n}\n\n.k-i-fx::before {\n  content: \"\\e691\";\n}\n\n.k-i-sum::before {\n  content: \"\\e692\";\n}\n\n.k-i-symbol::before {\n  content: \"\\e693\";\n}\n\n.k-i-dollar::before {\n  content: \"\\e694\";\n}\n\n.k-i-currency::before {\n  content: \"\\e694\";\n}\n\n.k-i-percent::before {\n  content: \"\\e695\";\n}\n\n.k-i-custom-format::before {\n  content: \"\\e696\";\n}\n\n.k-i-format-number::before {\n  content: \"\\e696\";\n}\n\n.k-i-decimal-increase::before {\n  content: \"\\e697\";\n}\n\n.k-i-increace-decimal::before {\n  content: \"\\e697\";\n}\n\n.k-i-decimal-decrease::before {\n  content: \"\\e698\";\n}\n\n.k-i-decrease-decimal::before {\n  content: \"\\e698\";\n}\n\n.k-i-font-size::before {\n  content: \"\\e699\";\n}\n\n.k-i-image-absolute-position::before {\n  content: \"\\e69a\";\n}\n\n.k-i-table-wizard::before {\n  content: \"\\e69b\";\n}\n\n.k-i-crosstab::before {\n  content: \"\\e69c\";\n}\n\n.k-i-crosstab-wizard::before {\n  content: \"\\e69d\";\n}\n\n.k-i-table-body::before {\n  content: \"\\e69e\";\n}\n\n.k-i-table-column-groups::before {\n  content: \"\\e69f\";\n}\n\n.k-i-table-corner::before {\n  content: \"\\e6a0\";\n}\n\n.k-i-table-row-groups::before {\n  content: \"\\e6a1\";\n}\n\n.k-i-globe-outline::before {\n  content: \"\\e700\";\n}\n\n.k-i-globe::before {\n  content: \"\\e701\";\n}\n\n.k-i-map-marker::before {\n  content: \"\\e702\";\n}\n\n.k-i-marker-pin::before {\n  content: \"\\e702\";\n}\n\n.k-i-map-marker-target::before {\n  content: \"\\e703\";\n}\n\n.k-i-marker-pin-target::before {\n  content: \"\\e703\";\n}\n\n.k-i-pin::before {\n  content: \"\\e704\";\n}\n\n.k-i-unpin::before {\n  content: \"\\e705\";\n}\n\n.k-i-share::before {\n  content: \"\\e800\";\n}\n\n.k-i-user::before {\n  content: \"\\e801\";\n}\n\n.k-i-inbox::before {\n  content: \"\\e802\";\n}\n\n.k-i-blogger::before {\n  content: \"\\e803\";\n}\n\n.k-i-blogger-box::before {\n  content: \"\\e804\";\n}\n\n.k-i-delicious::before {\n  content: \"\\e805\";\n}\n\n.k-i-delicious-box::before {\n  content: \"\\e806\";\n}\n\n.k-i-digg::before {\n  content: \"\\e807\";\n}\n\n.k-i-digg-box::before {\n  content: \"\\e808\";\n}\n\n.k-i-envelop::before {\n  content: \"\\e809\";\n}\n\n.k-i-email::before {\n  content: \"\\e809\";\n}\n\n.k-i-letter::before {\n  content: \"\\e809\";\n}\n\n.k-i-envelop-box::before {\n  content: \"\\e80a\";\n}\n\n.k-i-email-box::before {\n  content: \"\\e80a\";\n}\n\n.k-i-letter-box::before {\n  content: \"\\e80a\";\n}\n\n.k-i-facebook::before {\n  content: \"\\e80b\";\n}\n\n.k-i-facebook-box::before {\n  content: \"\\e80c\";\n}\n\n.k-i-google::before {\n  content: \"\\e80d\";\n}\n\n.k-i-google-box::before {\n  content: \"\\e80e\";\n}\n\n.k-i-google-plus::before {\n  content: \"\\e80f\";\n}\n\n.k-i-google-plus-box::before {\n  content: \"\\e810\";\n}\n\n.k-i-linkedin::before {\n  content: \"\\e811\";\n}\n\n.k-i-linkedin-box::before {\n  content: \"\\e812\";\n}\n\n.k-i-myspace::before {\n  content: \"\\e813\";\n}\n\n.k-i-myspace-box::before {\n  content: \"\\e814\";\n}\n\n.k-i-pinterest::before {\n  content: \"\\e815\";\n}\n\n.k-i-pinterest-box::before {\n  content: \"\\e816\";\n}\n\n.k-i-reddit::before {\n  content: \"\\e817\";\n}\n\n.k-i-reddit-box::before {\n  content: \"\\e818\";\n}\n\n.k-i-stumble-upon::before {\n  content: \"\\e819\";\n}\n\n.k-i-stumble-upon-box::before {\n  content: \"\\e81a\";\n}\n\n.k-i-tell-a-friend::before {\n  content: \"\\e81b\";\n}\n\n.k-i-tell-a-friend-box::before {\n  content: \"\\e81c\";\n}\n\n.k-i-tumblr::before {\n  content: \"\\e81d\";\n}\n\n.k-i-tumblr-box::before {\n  content: \"\\e81e\";\n}\n\n.k-i-twitter::before {\n  content: \"\\e81f\";\n}\n\n.k-i-twitter-box::before {\n  content: \"\\e820\";\n}\n\n.k-i-yammer::before {\n  content: \"\\e821\";\n}\n\n.k-i-yammer-box::before {\n  content: \"\\e822\";\n}\n\n.k-i-behance::before {\n  content: \"\\e823\";\n}\n\n.k-i-behance-box::before {\n  content: \"\\e824\";\n}\n\n.k-i-dribbble::before {\n  content: \"\\e825\";\n}\n\n.k-i-dribbble-box::before {\n  content: \"\\e826\";\n}\n\n.k-i-rss::before {\n  content: \"\\e827\";\n}\n\n.k-i-rss-box::before {\n  content: \"\\e828\";\n}\n\n.k-i-vimeo::before {\n  content: \"\\e829\";\n}\n\n.k-i-vimeo-box::before {\n  content: \"\\e82a\";\n}\n\n.k-i-youtube::before {\n  content: \"\\e82b\";\n}\n\n.k-i-youtube-box::before {\n  content: \"\\e82c\";\n}\n\n.k-i-folder::before {\n  content: \"\\e900\";\n}\n\n.k-i-folder-open::before {\n  content: \"\\e901\";\n}\n\n.k-i-folder-add::before {\n  content: \"\\e902\";\n}\n\n.k-i-folder-up::before {\n  content: \"\\e903\";\n}\n\n.k-i-folder-more::before {\n  content: \"\\e904\";\n}\n\n.k-i-fields-more::before {\n  content: \"\\e904\";\n}\n\n.k-i-aggregate-fields::before {\n  content: \"\\e905\";\n}\n\n.k-i-file::before {\n  content: \"\\e906\";\n}\n\n.k-i-file-vertical::before {\n  content: \"\\e906\";\n}\n\n.k-i-page-portrait::before {\n  content: \"\\e906\";\n}\n\n.k-i-file-v::before {\n  content: \"\\e906\";\n}\n\n.k-i-file-add::before {\n  content: \"\\e907\";\n}\n\n.k-i-insert-file::before {\n  content: \"\\e907\";\n}\n\n.k-i-file-txt::before {\n  content: \"\\e908\";\n}\n\n.k-i-txt::before {\n  content: \"\\e908\";\n}\n\n.k-i-file-csv::before {\n  content: \"\\e909\";\n}\n\n.k-i-csv::before {\n  content: \"\\e909\";\n}\n\n.k-i-file-excel::before {\n  content: \"\\e90a\";\n}\n\n.k-i-file-xls::before {\n  content: \"\\e90a\";\n}\n\n.k-i-excel::before {\n  content: \"\\e90a\";\n}\n\n.k-i-xls::before {\n  content: \"\\e90a\";\n}\n\n.k-i-xlsa::before {\n  content: \"\\e90a\";\n}\n\n.k-i-file-word::before {\n  content: \"\\e90b\";\n}\n\n.k-i-file-doc::before {\n  content: \"\\e90b\";\n}\n\n.k-i-word::before {\n  content: \"\\e90b\";\n}\n\n.k-i-doc::before {\n  content: \"\\e90b\";\n}\n\n.k-i-file-mdb::before {\n  content: \"\\e90c\";\n}\n\n.k-i-mdb::before {\n  content: \"\\e90c\";\n}\n\n.k-i-file-ppt::before {\n  content: \"\\e90d\";\n}\n\n.k-i-ppt::before {\n  content: \"\\e90d\";\n}\n\n.k-i-file-pdf::before {\n  content: \"\\e90e\";\n}\n\n.k-i-pdf::before {\n  content: \"\\e90e\";\n}\n\n.k-i-pdfa::before {\n  content: \"\\e90e\";\n}\n\n.k-i-file-psd::before {\n  content: \"\\e90f\";\n}\n\n.k-i-psd::before {\n  content: \"\\e90f\";\n}\n\n.k-i-file-flash::before {\n  content: \"\\e910\";\n}\n\n.k-i-flash::before {\n  content: \"\\e910\";\n}\n\n.k-i-file-config::before {\n  content: \"\\e911\";\n}\n\n.k-i-config::before {\n  content: \"\\e911\";\n}\n\n.k-i-file-ascx::before {\n  content: \"\\e912\";\n}\n\n.k-i-ascx::before {\n  content: \"\\e912\";\n}\n\n.k-i-file-bac::before {\n  content: \"\\e913\";\n}\n\n.k-i-bac::before {\n  content: \"\\e913\";\n}\n\n.k-i-file-zip::before {\n  content: \"\\e914\";\n}\n\n.k-i-zip::before {\n  content: \"\\e914\";\n}\n\n.k-i-film::before {\n  content: \"\\e915\";\n}\n\n.k-i-css3::before {\n  content: \"\\e916\";\n}\n\n.k-i-html5::before {\n  content: \"\\e917\";\n}\n\n.k-i-code::before {\n  content: \"\\e918\";\n}\n\n.k-i-html::before {\n  content: \"\\e918\";\n}\n\n.k-i-source-code::before {\n  content: \"\\e918\";\n}\n\n.k-i-view-source::before {\n  content: \"\\e918\";\n}\n\n.k-i-css::before {\n  content: \"\\e919\";\n}\n\n.k-i-js::before {\n  content: \"\\e91a\";\n}\n\n.k-i-exe::before {\n  content: \"\\e91b\";\n}\n\n.k-i-csproj::before {\n  content: \"\\e91c\";\n}\n\n.k-i-vbproj::before {\n  content: \"\\e91d\";\n}\n\n.k-i-cs::before {\n  content: \"\\e91e\";\n}\n\n.k-i-vb::before {\n  content: \"\\e91f\";\n}\n\n.k-i-sln::before {\n  content: \"\\e920\";\n}\n\n.k-i-cloud::before {\n  content: \"\\e921\";\n}\n\n.k-i-file-horizontal::before {\n  content: \"\\e922\";\n}\n\n.k-i-page-landscape::before {\n  content: \"\\e922\";\n}\n\n.k-i-file-h::before {\n  content: \"\\e922\";\n}\n\n.k-i-subreport::before {\n  content: \"\\e923\";\n}\n\n.k-i-data::before {\n  content: \"\\e924\";\n}\n\n.k-i-report-header-section::before {\n  content: \"\\e925\";\n}\n\n.k-i-report-footer-section::before {\n  content: \"\\e926\";\n}\n\n.k-i-group-header-section::before {\n  content: \"\\e927\";\n}\n\n.k-i-group-footer-section::before {\n  content: \"\\e928\";\n}\n\n.k-i-page-header-section::before {\n  content: \"\\e929\";\n}\n\n.k-i-page-footer-section::before {\n  content: \"\\e92a\";\n}\n\n.k-i-detail-section::before {\n  content: \"\\e92b\";\n}\n\n.k-i-toc-section::before {\n  content: \"\\e92c\";\n}\n\n.k-i-group-section::before {\n  content: \"\\e92d\";\n}\n\n.k-i-parameters::before {\n  content: \"\\e92e\";\n}\n\n.k-i-data-csv::before {\n  content: \"\\e92f\";\n}\n\n.k-i-data-json::before {\n  content: \"\\e930\";\n}\n\n.k-i-data-sql::before {\n  content: \"\\e931\";\n}\n\n.k-i-data-web::before {\n  content: \"\\e932\";\n}\n\n.k-i-group-collection::before {\n  content: \"\\e933\";\n}\n\n.k-i-parameter-boolean::before {\n  content: \"\\e934\";\n}\n\n.k-i-parameter-date-time::before {\n  content: \"\\e935\";\n}\n\n.k-i-parameter-float::before {\n  content: \"\\e936\";\n}\n\n.k-i-parameter-integer::before {\n  content: \"\\e937\";\n}\n\n.k-i-parameter-string::before {\n  content: \"\\e938\";\n}\n\n.k-i-toc-section-level::before {\n  content: \"\\e939\";\n}\n\n.k-i-inherited::before {\n  content: \"\\e93a\";\n}\n\n.k-i-file-video::before {\n  content: \"\\e93b\";\n}\n\n.k-i-file-audio::before {\n  content: \"\\e93c\";\n}\n\n.k-i-file-image::before {\n  content: \"\\e93d\";\n}\n\n.k-i-file-presentation::before {\n  content: \"\\e93e\";\n}\n\n.k-i-file-data::before {\n  content: \"\\e93f\";\n}\n\n.k-i-report-element::before {\n  content: \"\\e94a\";\n}\n\n.k-i-file-disc-image::before {\n  content: \"\\e940\";\n}\n\n.k-i-file-programming::before {\n  content: \"\\e941\";\n}\n\n.k-i-parameters-byte-array::before {\n  content: \"\\e942\";\n}\n\n.k-i-parameters-unknown::before {\n  content: \"\\e943\";\n}\n\n.k-i-file-error::before {\n  content: \"\\e944\";\n}\n\n.k-i-file-validation::before {\n  content: \"\\e944\";\n}\n\n.k-i-files-error::before {\n  content: \"\\e945\";\n}\n\n.k-i-files-validation::before {\n  content: \"\\e945\";\n}\n\n.k-i-data-rest::before {\n  content: \"\\e946\";\n}\n\n.k-i-file-typescript::before {\n  content: \"\\e947\";\n}\n\n.k-i-data-ods::before {\n  content: \"\\e948\";\n}\n\n.k-i-file-report::before {\n  content: \"\\e949\";\n}\n\n.k-i-table-position-start::before {\n  content: \"\\e6a2\";\n}\n\n.k-i-table-position-left::before {\n  content: \"\\e6a2\";\n}\n\n.k-i-table-position-center::before {\n  content: \"\\e6a3\";\n}\n\n.k-i-table-position-end::before {\n  content: \"\\e6a4\";\n}\n\n.k-i-table-position-right::before {\n  content: \"\\e6a4\";\n}\n\n.k-i-list-roman-upper::before {\n  content: \"\\e6a5\";\n}\n\n.k-i-list-roman-lower::before {\n  content: \"\\e6a6\";\n}\n\n.k-i-import::before {\n  content: \"\\e6a7\";\n}\n\n.k-i-export::before {\n  content: \"\\e6a8\";\n}\n\n.k-i-match-full-word::before {\n  content: \"\\e6a9\";\n}\n\n.k-i-regular-expression::before {\n  content: \"\\e6ab\";\n}\n\n.k-i-replace-single::before {\n  content: \"\\e6ac\";\n}\n\n.k-i-replace-all::before {\n  content: \"\\e6ad\";\n}\n\n.k-i-letter-space::before {\n  content: \"\\e6ae\";\n}\n\n.k-i-line-height::before {\n  content: \"\\e6af\";\n}\n\n.k-i-blockquote::before {\n  content: \"\\e6b0\";\n}\n\n.k-i-list-latin-big::before {\n  content: \"\\e6b1\";\n}\n\n.k-i-list-latin-small::before {\n  content: \"\\e6b2\";\n}\n\n.k-i-list-unordered-square::before {\n  content: \"\\e6b3\";\n}\n\n.k-i-list-unordered-outline::before {\n  content: \"\\e6b4\";\n}\n\n.k-i-graph::before {\n  content: \"\\ea00\";\n}\n\n.k-i-chart-column-clustered::before {\n  content: \"\\ea01\";\n}\n\n.k-i-chart-column-stacked::before {\n  content: \"\\ea02\";\n}\n\n.k-i-chart-column-stacked100::before {\n  content: \"\\ea03\";\n}\n\n.k-i-chart-column-range::before {\n  content: \"\\ea04\";\n}\n\n.k-i-chart-bar-clustered::before {\n  content: \"\\ea05\";\n}\n\n.k-i-chart-bar-stacked::before {\n  content: \"\\ea06\";\n}\n\n.k-i-chart-bar-stacked100::before {\n  content: \"\\ea07\";\n}\n\n.k-i-chart-bar-range::before {\n  content: \"\\ea08\";\n}\n\n.k-i-chart-area-clustered::before {\n  content: \"\\ea09\";\n}\n\n.k-i-chart-area-stacked::before {\n  content: \"\\ea0a\";\n}\n\n.k-i-chart-area-stacked100::before {\n  content: \"\\ea0b\";\n}\n\n.k-i-chart-area-range::before {\n  content: \"\\ea0c\";\n}\n\n.k-i-chart-line::before {\n  content: \"\\ea0d\";\n}\n\n.k-i-chart-line-stacked::before {\n  content: \"\\ea0e\";\n}\n\n.k-i-chart-line-stacked100::before {\n  content: \"\\ea0f\";\n}\n\n.k-i-chart-line-markers::before {\n  content: \"\\ea10\";\n}\n\n.k-i-chart-line-stacked-markers::before {\n  content: \"\\ea11\";\n}\n\n.k-i-chart-line-stacked100-markers::before {\n  content: \"\\ea12\";\n}\n\n.k-i-chart-pie::before {\n  content: \"\\ea13\";\n}\n\n.k-i-chart-doughnut::before {\n  content: \"\\ea14\";\n}\n\n.k-i-chart-scatter::before {\n  content: \"\\ea15\";\n}\n\n.k-i-chart-scatter-smooth-lines-markers::before {\n  content: \"\\ea16\";\n}\n\n.k-i-chart-scatter-smooth-lines::before {\n  content: \"\\ea17\";\n}\n\n.k-i-chart-scatter-straight-lines-markers::before {\n  content: \"\\ea18\";\n}\n\n.k-i-chart-scatter-straight-lines::before {\n  content: \"\\ea19\";\n}\n\n.k-i-chart-bubble::before {\n  content: \"\\ea1a\";\n}\n\n.k-i-chart-candlestick::before {\n  content: \"\\ea1b\";\n}\n\n.k-i-chart-ohlc::before {\n  content: \"\\ea1c\";\n}\n\n.k-i-chart-radar::before {\n  content: \"\\ea1d\";\n}\n\n.k-i-chart-radar-markers::before {\n  content: \"\\ea1e\";\n}\n\n.k-i-chart-radar-filled::before {\n  content: \"\\ea1f\";\n}\n\n.k-i-chart-rose::before {\n  content: \"\\ea20\";\n}\n\n.k-i-chart-choropleth::before {\n  content: \"\\ea21\";\n}\n\n.k-rtl .k-i-indent-increase,\n.k-rtl .k-i-indent-decrease,\n.k-rtl .k-i-expand,\n.k-rtl .k-i-collapse,\n[dir=rtl] .k-i-expand,\n[dir=rtl] .k-i-collapse {\n  transform: scaleX(-1);\n}\n\n.k-sprite {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  overflow: hidden;\n  background-repeat: no-repeat;\n  font-size: 0;\n  line-height: 0;\n  text-align: center;\n  -ms-high-contrast-adjust: none;\n}\n\n.k-image {\n  display: inline-block;\n}\n\n.k-listgroup {\n  border-radius: 4px;\n  margin: 0;\n  padding: 0;\n  border-width: 1px;\n  border-style: solid;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n.k-listgroup > ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n}\n.k-listgroup .k-listgroup-item + .k-listgroup-item {\n  border-top-width: 1px;\n}\n\n.k-listgroup-flush {\n  border-radius: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.k-listgroup-item {\n  padding: 8px 8px;\n  border-width: 0;\n  border-style: solid;\n  border-color: inherit;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 0 0 auto;\n  position: relative;\n}\n.k-listgroup-item > .k-link {\n  margin: -8px -8px;\n  padding: 8px 8px;\n  color: inherit;\n  text-decoration: none;\n  outline: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1 1 auto;\n  position: relative;\n}\n.k-listgroup-item > .k-link > .k-select {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.k-listgroup-item-segmented {\n  align-items: stretch;\n}\n.k-listgroup-item-segmented > .k-link {\n  margin-right: 0;\n}\n.k-listgroup-item-segmented > .k-select {\n  margin: -8px -8px -8px 0;\n  padding: 8px;\n  border-width: 0 0 0 1px;\n  border-style: solid;\n  border-color: inherit;\n  cursor: pointer;\n}\n\n.k-listgroup-form-row {\n  margin: -8px -8px;\n  padding: 8px 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1 1 auto;\n  position: relative;\n}\n.k-listgroup-form-row .k-listgroup-form-field-label {\n  width: 40%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.k-listgroup-form-row .k-listgroup-form-field-wrapper {\n  width: 50%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  text-align: end;\n  position: relative;\n}\n.k-listgroup-form-row .k-listgroup-form-field-wrapper select,\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=text],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=password],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=date],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=time],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=datetime-local],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper input[type=number],\n.k-listgroup-form-row .k-listgroup-form-field-wrapper textarea {\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1 1 100%;\n}\n.k-listgroup-form-row .k-listgroup-form-field-wrapper textarea {\n  min-height: 4em;\n  resize: vertical;\n}\n\n.k-listgroup-item.k-listgroup-form-row {\n  margin: 0;\n}\n\n[dir=rtl] .k-listgroup-item > .k-link > .k-select {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .k-listgroup-item > .k-link > .k-select .k-icon {\n  transform: scaleX(-1);\n}\n[dir=rtl] .k-listgroup-item-segmented > .k-link {\n  margin-right: -8px;\n  margin-left: 0;\n}\n[dir=rtl] .k-listgroup-item-segmented > .k-select {\n  margin-right: 0;\n  margin-left: -8px;\n  border-right-width: 1px;\n  border-left-width: 0;\n}\n[dir=rtl] .k-listgroup-item-segmented > .k-select .k-icon {\n  transform: scaleX(-1);\n}\n\n.k-noflexbox .k-listgroup,\n.k-noflexbox .k-listgroup > ul .k-listgroup-item,\n.k-noflexbox .k-listgroup-item > .k-link {\n  display: block;\n}\n\n.k-listgroup {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n\n.k-checkbox {\n  margin: 0;\n  padding: 0;\n  line-height: initial;\n  border-width: 1px;\n  border-style: solid;\n  outline: 0;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: inline-block;\n  flex: none;\n  vertical-align: middle;\n  position: relative;\n  cursor: pointer;\n  -webkit-appearance: none;\n}\n\n.k-checkbox:checked,\n.k-checkbox.k-checked {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='white' stroke-linecap='square' stroke-linejoin='square' stroke-width='2' d='M3,8 l3,3 l7-7'/%3e%3c/svg%3e\");\n}\n\n.k-checkbox:indeterminate,\n.k-checkbox.k-indeterminate {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ff6358' stroke-linecap='square' stroke-linejoin='square' stroke-width='2' d='M4,8 h8'/%3e%3c/svg%3e\");\n}\n\n.k-checkbox:disabled,\n.k-checkbox.k-disabled {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n\n.k-checkbox-wrap {\n  flex: none;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  gap: 0;\n  align-items: center;\n  align-self: flex-start;\n  vertical-align: middle;\n  position: relative;\n}\n.k-checkbox-wrap::before {\n  content: \"​\";\n  width: 0px;\n  overflow: hidden;\n  flex: none;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.k-checkbox-label {\n  margin: 0;\n  padding: 0;\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 4px;\n  vertical-align: middle;\n  position: relative;\n  cursor: pointer;\n}\n.k-checkbox-label .k-ripple {\n  visibility: hidden !important;\n}\n\n.k-checkbox + .k-label,\n.k-checkbox-wrap + .k-label,\n.k-checkbox + .k-checkbox-label,\n.k-checkbox-wrap + .k-checkbox-label {\n  display: inline;\n  margin-inline-start: 4px;\n}\n\n.k-checkbox-label:empty {\n  display: none !important;\n}\n\n.k-checkbox-label.k-no-text {\n  min-width: 1px;\n}\n\n.k-checkbox-list {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 0;\n  list-style: none;\n}\n\n.k-checkbox-item,\n.k-checkbox-list-item {\n  padding: 4px 0px;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  gap: 4px;\n}\n.k-checkbox-item .k-checkbox-label,\n.k-checkbox-list-item .k-checkbox-label {\n  margin: 0;\n}\n\n.k-checkbox-list-horizontal,\n.k-checkbox-list.k-list-horizontal {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 16px;\n}\n\n.k-ripple-container .k-checkbox::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 100%;\n  z-index: -1;\n  transition: opacity 100ms linear, transform 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate(-50%, -50%) scale(0);\n  transform-origin: center center;\n}\n.k-ripple-container .k-checkbox:focus,\n.k-ripple-container .k-checkbox.k-focus {\n  box-shadow: none !important;\n}\n.k-ripple-container .k-checkbox:disabled::after,\n.k-ripple-container .k-checkbox.k-disabled::after {\n  display: none;\n}\n\n.k-checkbox-sm {\n  width: 12px;\n  height: 12px;\n}\n.k-checkbox-sm::before {\n  font-size: 10px;\n}\n\n.k-ripple-container .k-checkbox-sm::after {\n  width: 36px;\n  height: 36px;\n}\n\n.k-checkbox-md {\n  width: 16px;\n  height: 16px;\n}\n.k-checkbox-md::before {\n  font-size: 14px;\n}\n\n.k-ripple-container .k-checkbox-md::after {\n  width: 48px;\n  height: 48px;\n}\n\n.k-checkbox-lg {\n  width: 20px;\n  height: 20px;\n}\n.k-checkbox-lg::before {\n  font-size: 18px;\n}\n\n.k-ripple-container .k-checkbox-lg::after {\n  width: 60px;\n  height: 60px;\n}\n\n.k-checkbox {\n  border-color: rgba(0, 0, 0, 0.08);\n  background-color: #ffffff;\n}\n\n.k-checkbox:focus,\n.k-checkbox.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.06);\n}\n\n.k-checkbox:indeterminate,\n.k-checkbox.k-indeterminate {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #ff6358;\n  background-color: #ffffff;\n}\n\n.k-checkbox:checked,\n.k-checkbox.k-checked {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n\n.k-checkbox:checked:focus,\n.k-checkbox.k-checked.k-focus {\n  box-shadow: 0 0 0 2px rgba(255, 99, 88, 0.3);\n}\n\n.k-checkbox.k-invalid {\n  border-color: #f31700;\n}\n\n.k-checkbox.k-invalid + .k-checkbox-label {\n  color: #f31700;\n}\n\n.k-checkbox-wrap .k-ripple-blob {\n  color: #ff6358;\n  opacity: 0.25;\n}\n\n.k-ripple-container .k-checkbox::after {\n  background: #ff6358;\n  opacity: 0.25;\n}\n\n.k-radio {\n  border-radius: 50%;\n  margin: 0;\n  padding: 0;\n  line-height: initial;\n  border-width: 1px;\n  border-style: solid;\n  outline: 0;\n  box-sizing: border-box;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: inline-block;\n  flex: none;\n  vertical-align: middle;\n  position: relative;\n  cursor: pointer;\n  -webkit-appearance: none;\n}\n\n.k-radio:checked,\n.k-radio.k-checked {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3e%3ccircle cx='50%25' cy='50%25' r='4' fill='white'/%3e%3c/svg%3e\");\n}\n\n.k-radio:disabled,\n.k-radio.k-disabled {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n\n.k-radio-wrap {\n  flex: none;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  gap: 0;\n  align-items: center;\n  align-self: start;\n  vertical-align: middle;\n  position: relative;\n}\n.k-radio-wrap::before {\n  content: \"​\";\n  width: 0px;\n  overflow: hidden;\n  flex: none;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.k-radio-label {\n  margin: 0;\n  padding: 0;\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 4px;\n  vertical-align: middle;\n  position: relative;\n  cursor: pointer;\n}\n.k-radio-label .k-ripple {\n  visibility: hidden !important;\n}\n\n.k-radio + .k-label,\n.k-radio-wrap + .k-label,\n.k-radio + .k-radio-label,\n.k-radio-wrap + .k-radio-label {\n  display: inline;\n  margin-inline-start: 4px;\n}\n\n.k-radio-label:empty {\n  display: none !important;\n}\n\n.k-radio-label.k-no-text {\n  min-width: 1px;\n}\n\n.k-radio-list {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 0;\n  list-style: none;\n}\n\n.k-radio-item,\n.k-radio-list-item {\n  padding: 4px 0px;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  gap: 4px;\n}\n.k-radio-item .k-radio-label,\n.k-radio-list-item .k-radio-label {\n  margin: 0;\n}\n\n.k-radio-list-horizontal,\n.k-radio-list.k-list-horizontal {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 16px;\n}\n\n.k-ripple-container .k-radio::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 100%;\n  z-index: -1;\n  transition: opacity 100ms linear, transform 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate(-50%, -50%) scale(0);\n  transform-origin: center center;\n}\n.k-ripple-container .k-radio:focus,\n.k-ripple-container .k-radio.k-focus {\n  box-shadow: none !important;\n}\n.k-ripple-container .k-radio:disabled::after,\n.k-ripple-container .k-radio.k-disabled::after {\n  display: none;\n}\n.k-ripple-container .k-radio:disabled::after,\n.k-ripple-container .k-radio.k-disabled::after {\n  display: none;\n}\n\n.k-radio-sm {\n  width: 12px;\n  height: 12px;\n}\n.k-radio-sm::before {\n  font-size: 10px;\n}\n\n.k-ripple-container .k-radio-sm::after {\n  width: 36px;\n  height: 36px;\n}\n\n.k-radio-md {\n  width: 16px;\n  height: 16px;\n}\n.k-radio-md::before {\n  font-size: 14px;\n}\n\n.k-ripple-container .k-radio-md::after {\n  width: 48px;\n  height: 48px;\n}\n\n.k-radio-lg {\n  width: 20px;\n  height: 20px;\n}\n.k-radio-lg::before {\n  font-size: 18px;\n}\n\n.k-ripple-container .k-radio-lg::after {\n  width: 60px;\n  height: 60px;\n}\n\n.k-radio {\n  border-color: rgba(0, 0, 0, 0.08);\n  background-color: #ffffff;\n}\n\n.k-radio:focus,\n.k-radio.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.06);\n}\n\n.k-radio.k-invalid,\n.k-radio.ng-invalid.ng-touched,\n.k-radio.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n\n.k-radio.k-invalid + .k-radio-label,\n.k-radio.ng-invalid.ng-touched + .k-radio-label,\n.k-radio.ng-invalid.ng-dirty + .k-radio-label {\n  color: #f31700;\n}\n\n.k-radio:checked,\n.k-radio.k-checked {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n\n.k-radio:checked:focus,\n.k-radio.k-checked.k-focus {\n  box-shadow: 0 0 0 2px rgba(255, 99, 88, 0.3);\n}\n\n.k-ripple-container .k-radio::after {\n  background: #ff6358;\n  opacity: 0.25;\n}\n\n.k-border {\n  border-width: 1px !important;\n}\n\n.k-border-0 {\n  border-width: 0 !important;\n}\n\n.k-border-top {\n  border-top-width: 1px !important;\n}\n\n.k-border-top-0 {\n  border-top-width: 0 !important;\n}\n\n.k-border-right {\n  border-right-width: 1px !important;\n}\n\n.k-border-right-0 {\n  border-right-width: 0 !important;\n}\n\n.k-border-bottom {\n  border-bottom-width: 1px !important;\n}\n\n.k-border-bottom-0 {\n  border-bottom-width: 0 !important;\n}\n\n.k-border-left {\n  border-left-width: 1px !important;\n}\n\n.k-border-left-0 {\n  border-left-width: 0 !important;\n}\n\n.k-border-x {\n  border-left-width: 1px !important;\n  border-right-width: 1px !important;\n}\n\n.k-border-x-0 {\n  border-left-width: 0 !important;\n  border-right-width: 0 !important;\n}\n\n.k-border-y {\n  border-top-width: 1px !important;\n  border-bottom-width: 1px !important;\n}\n\n.k-border-y-0 {\n  border-top-width: 0 !important;\n  border-bottom-width: 0 !important;\n}\n\n.k-border-solid {\n  border-style: solid !important;\n}\n\n.k-border-dashed {\n  border-style: dashed !important;\n}\n\n.k-border-dotted {\n  border-style: dotted !important;\n}\n\n.k-border-double {\n  border-style: double !important;\n}\n\n.k-border-none {\n  border-style: none !important;\n}\n\n.k-border-primary {\n  border-color: #ff6358 !important;\n}\n\n.k-border-secondary {\n  border-color: #666666 !important;\n}\n\n.k-border-tertiary {\n  border-color: #03a9f4 !important;\n}\n\n.k-border-info {\n  border-color: #0058e9 !important;\n}\n\n.k-border-success {\n  border-color: #37b400 !important;\n}\n\n.k-border-warning {\n  border-color: #ffc000 !important;\n}\n\n.k-border-error {\n  border-color: #f31700 !important;\n}\n\n.k-border-dark {\n  border-color: #424242 !important;\n}\n\n.k-border-light {\n  border-color: #ebebeb !important;\n}\n\n.k-border-inverse {\n  border-color: #424242 !important;\n}\n\n.k-rounded {\n  border-radius: 4px;\n}\n\n.\\!k-rounded {\n  border-radius: 4px !important;\n}\n\n.k-rounded-0 {\n  border-radius: 0;\n}\n\n.\\!k-rounded-0 {\n  border-radius: 0 !important;\n}\n\n.k-rounded-sm {\n  border-radius: 2px;\n}\n\n.\\!k-rounded-sm {\n  border-radius: 2px !important;\n}\n\n.k-rounded-md {\n  border-radius: 4px;\n}\n\n.\\!k-rounded-md {\n  border-radius: 4px !important;\n}\n\n.k-rounded-lg {\n  border-radius: 6px;\n}\n\n.\\!k-rounded-lg {\n  border-radius: 6px !important;\n}\n\n.k-rounded-full {\n  border-radius: 9999px;\n}\n\n.\\!k-rounded-full {\n  border-radius: 9999px !important;\n}\n\n.k-rounded-top {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.\\!k-rounded-top {\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n}\n\n.k-rounded-top-0 {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.\\!k-rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.k-rounded-top-sm {\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n}\n\n.\\!k-rounded-top-sm {\n  border-top-left-radius: 2px !important;\n  border-top-right-radius: 2px !important;\n}\n\n.k-rounded-top-md {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.\\!k-rounded-top-md {\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n}\n\n.k-rounded-top-lg {\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.\\!k-rounded-top-lg {\n  border-top-left-radius: 6px !important;\n  border-top-right-radius: 6px !important;\n}\n\n.k-rounded-top-full {\n  border-top-left-radius: 9999px;\n  border-top-right-radius: 9999px;\n}\n\n.\\!k-rounded-top-full {\n  border-top-left-radius: 9999px !important;\n  border-top-right-radius: 9999px !important;\n}\n\n.k-rounded-right {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.\\!k-rounded-right {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.k-rounded-right-0 {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.\\!k-rounded-right-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.k-rounded-right-sm {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.\\!k-rounded-right-sm {\n  border-top-right-radius: 2px !important;\n  border-bottom-right-radius: 2px !important;\n}\n\n.k-rounded-right-md {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.\\!k-rounded-right-md {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.k-rounded-right-lg {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.\\!k-rounded-right-lg {\n  border-top-right-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n}\n\n.k-rounded-right-full {\n  border-top-right-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n}\n\n.\\!k-rounded-right-full {\n  border-top-right-radius: 9999px !important;\n  border-bottom-right-radius: 9999px !important;\n}\n\n.k-rounded-bottom {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.\\!k-rounded-bottom {\n  border-bottom-left-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.k-rounded-bottom-0 {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.\\!k-rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.k-rounded-bottom-sm {\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.\\!k-rounded-bottom-sm {\n  border-bottom-left-radius: 2px !important;\n  border-bottom-right-radius: 2px !important;\n}\n\n.k-rounded-bottom-md {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.\\!k-rounded-bottom-md {\n  border-bottom-left-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.k-rounded-bottom-lg {\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.\\!k-rounded-bottom-lg {\n  border-bottom-left-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n}\n\n.k-rounded-bottom-full {\n  border-bottom-left-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n}\n\n.\\!k-rounded-bottom-full {\n  border-bottom-left-radius: 9999px !important;\n  border-bottom-right-radius: 9999px !important;\n}\n\n.k-rounded-left {\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.\\!k-rounded-left {\n  border-bottom-left-radius: 4px !important;\n  border-top-left-radius: 4px !important;\n}\n\n.k-rounded-left-0 {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.\\!k-rounded-left-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.k-rounded-left-sm {\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n}\n\n.\\!k-rounded-left-sm {\n  border-bottom-left-radius: 2px !important;\n  border-top-left-radius: 2px !important;\n}\n\n.k-rounded-left-md {\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.\\!k-rounded-left-md {\n  border-bottom-left-radius: 4px !important;\n  border-top-left-radius: 4px !important;\n}\n\n.k-rounded-left-lg {\n  border-bottom-left-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.\\!k-rounded-left-lg {\n  border-bottom-left-radius: 6px !important;\n  border-top-left-radius: 6px !important;\n}\n\n.k-rounded-left-full {\n  border-bottom-left-radius: 9999px;\n  border-top-left-radius: 9999px;\n}\n\n.\\!k-rounded-left-full {\n  border-bottom-left-radius: 9999px !important;\n  border-top-left-radius: 9999px !important;\n}\n\n.k-rounded-top-left {\n  border-top-left-radius: 4px;\n}\n\n.\\!k-rounded-top-left {\n  border-top-left-radius: 4px !important;\n}\n\n.k-rounded-top-left-0 {\n  border-top-left-radius: 0;\n}\n\n.\\!k-rounded-top-left-0 {\n  border-top-left-radius: 0 !important;\n}\n\n.k-rounded-top-left-sm {\n  border-top-left-radius: 2px;\n}\n\n.\\!k-rounded-top-left-sm {\n  border-top-left-radius: 2px !important;\n}\n\n.k-rounded-top-left-md {\n  border-top-left-radius: 4px;\n}\n\n.\\!k-rounded-top-left-md {\n  border-top-left-radius: 4px !important;\n}\n\n.k-rounded-top-left-lg {\n  border-top-left-radius: 6px;\n}\n\n.\\!k-rounded-top-left-lg {\n  border-top-left-radius: 6px !important;\n}\n\n.k-rounded-top-left-full {\n  border-top-left-radius: 9999px;\n}\n\n.\\!k-rounded-top-left-full {\n  border-top-left-radius: 9999px !important;\n}\n\n.k-rounded-top-right {\n  border-top-right-radius: 4px;\n}\n\n.\\!k-rounded-top-right {\n  border-top-right-radius: 4px !important;\n}\n\n.k-rounded-top-right-0 {\n  border-top-right-radius: 0;\n}\n\n.\\!k-rounded-top-right-0 {\n  border-top-right-radius: 0 !important;\n}\n\n.k-rounded-top-right-sm {\n  border-top-right-radius: 2px;\n}\n\n.\\!k-rounded-top-right-sm {\n  border-top-right-radius: 2px !important;\n}\n\n.k-rounded-top-right-md {\n  border-top-right-radius: 4px;\n}\n\n.\\!k-rounded-top-right-md {\n  border-top-right-radius: 4px !important;\n}\n\n.k-rounded-top-right-lg {\n  border-top-right-radius: 6px;\n}\n\n.\\!k-rounded-top-right-lg {\n  border-top-right-radius: 6px !important;\n}\n\n.k-rounded-top-right-full {\n  border-top-right-radius: 9999px;\n}\n\n.\\!k-rounded-top-right-full {\n  border-top-right-radius: 9999px !important;\n}\n\n.k-rounded-bottom-left {\n  border-bottom-left-radius: 4px;\n}\n\n.\\!k-rounded-bottom-left {\n  border-bottom-left-radius: 4px !important;\n}\n\n.k-rounded-bottom-left-0 {\n  border-bottom-left-radius: 0;\n}\n\n.\\!k-rounded-bottom-left-0 {\n  border-bottom-left-radius: 0 !important;\n}\n\n.k-rounded-bottom-left-sm {\n  border-bottom-left-radius: 2px;\n}\n\n.\\!k-rounded-bottom-left-sm {\n  border-bottom-left-radius: 2px !important;\n}\n\n.k-rounded-bottom-left-md {\n  border-bottom-left-radius: 4px;\n}\n\n.\\!k-rounded-bottom-left-md {\n  border-bottom-left-radius: 4px !important;\n}\n\n.k-rounded-bottom-left-lg {\n  border-bottom-left-radius: 6px;\n}\n\n.\\!k-rounded-bottom-left-lg {\n  border-bottom-left-radius: 6px !important;\n}\n\n.k-rounded-bottom-left-full {\n  border-bottom-left-radius: 9999px;\n}\n\n.\\!k-rounded-bottom-left-full {\n  border-bottom-left-radius: 9999px !important;\n}\n\n.k-rounded-bottom-right {\n  border-bottom-right-radius: 4px;\n}\n\n.\\!k-rounded-bottom-right {\n  border-bottom-right-radius: 4px !important;\n}\n\n.k-rounded-bottom-right-0 {\n  border-bottom-right-radius: 0;\n}\n\n.\\!k-rounded-bottom-right-0 {\n  border-bottom-right-radius: 0 !important;\n}\n\n.k-rounded-bottom-right-sm {\n  border-bottom-right-radius: 2px;\n}\n\n.\\!k-rounded-bottom-right-sm {\n  border-bottom-right-radius: 2px !important;\n}\n\n.k-rounded-bottom-right-md {\n  border-bottom-right-radius: 4px;\n}\n\n.\\!k-rounded-bottom-right-md {\n  border-bottom-right-radius: 4px !important;\n}\n\n.k-rounded-bottom-right-lg {\n  border-bottom-right-radius: 6px;\n}\n\n.\\!k-rounded-bottom-right-lg {\n  border-bottom-right-radius: 6px !important;\n}\n\n.k-rounded-bottom-right-full {\n  border-bottom-right-radius: 9999px;\n}\n\n.\\!k-rounded-bottom-right-full {\n  border-bottom-right-radius: 9999px !important;\n}\n\n.k-switch {\n  box-sizing: border-box;\n  outline: 0;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  line-height: 1;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-switch *,\n.k-switch *::before,\n.k-switch *::after {\n  box-sizing: border-box;\n}\n.k-switch [type=checkbox] {\n  display: none;\n}\n.k-switch[aria-readonly=true] {\n  pointer-events: none;\n}\n\n.k-switch.k-readonly {\n  pointer-events: none;\n}\n\n.k-switch-track {\n  border-width: 1px;\n  border-style: solid;\n  outline: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  flex: 1 0 auto;\n  position: relative;\n  transition: background-color 200ms ease-in-out;\n}\n\n.k-switch-thumb-wrap {\n  width: 0;\n  height: 0;\n  overflow: visible;\n  position: absolute;\n  transition: left 200ms ease-in-out;\n  top: 50%;\n}\n\n.k-switch-thumb {\n  border-width: 1px;\n  border-style: solid;\n  display: block;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.k-switch-label-on,\n.k-switch-label-off {\n  text-transform: uppercase;\n  display: inline;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  overflow: hidden;\n}\n\n.k-switch-sm {\n  width: 52px;\n  height: 26px;\n  font-size: 10px;\n}\n.k-switch-sm .k-switch-track {\n  width: 52px;\n  height: 26px;\n}\n.k-switch-sm .k-switch-label-on {\n  left: 4px;\n}\n.k-switch-sm .k-switch-label-off {\n  right: 4px;\n}\n.k-switch-sm .k-switch-thumb {\n  width: 26px;\n  height: 26px;\n}\n.k-switch-sm.k-switch-on .k-switch-thumb-wrap {\n  left: calc( 100% - 13px - 0px );\n}\n.k-switch-sm.k-switch-off .k-switch-thumb-wrap {\n  left: calc( 13px + 0px );\n}\n\n.k-switch-sm[dir=rtl] .k-switch-label-on,\n[dir=rtl] .k-switch-sm .k-switch-label-on,\n.k-rtl .k-switch-sm .k-switch-label-on {\n  left: auto;\n  right: 4px;\n}\n.k-switch-sm[dir=rtl] .k-switch-label-off,\n[dir=rtl] .k-switch-sm .k-switch-label-off,\n.k-rtl .k-switch-sm .k-switch-label-off {\n  right: auto;\n  left: 4px;\n}\n.k-switch-sm[dir=rtl].k-switch-on .k-switch-thumb-wrap,\n[dir=rtl] .k-switch-sm.k-switch-on .k-switch-thumb-wrap,\n.k-rtl .k-switch-sm.k-switch-on .k-switch-thumb-wrap {\n  left: calc( 13px + 0px );\n}\n.k-switch-sm[dir=rtl].k-switch-off .k-switch-thumb-wrap,\n[dir=rtl] .k-switch-sm.k-switch-off .k-switch-thumb-wrap,\n.k-rtl .k-switch-sm.k-switch-off .k-switch-thumb-wrap {\n  left: calc( 100% - 13px - 0px );\n}\n\n.k-switch-md {\n  width: 60px;\n  height: 30px;\n  font-size: 10px;\n}\n.k-switch-md .k-switch-track {\n  width: 60px;\n  height: 30px;\n}\n.k-switch-md .k-switch-label-on {\n  left: 6px;\n}\n.k-switch-md .k-switch-label-off {\n  right: 6px;\n}\n.k-switch-md .k-switch-thumb {\n  width: 30px;\n  height: 30px;\n}\n.k-switch-md.k-switch-on .k-switch-thumb-wrap {\n  left: calc( 100% - 15px - 0px );\n}\n.k-switch-md.k-switch-off .k-switch-thumb-wrap {\n  left: calc( 15px + 0px );\n}\n\n.k-switch-md[dir=rtl] .k-switch-label-on,\n[dir=rtl] .k-switch-md .k-switch-label-on,\n.k-rtl .k-switch-md .k-switch-label-on {\n  left: auto;\n  right: 6px;\n}\n.k-switch-md[dir=rtl] .k-switch-label-off,\n[dir=rtl] .k-switch-md .k-switch-label-off,\n.k-rtl .k-switch-md .k-switch-label-off {\n  right: auto;\n  left: 6px;\n}\n.k-switch-md[dir=rtl].k-switch-on .k-switch-thumb-wrap,\n[dir=rtl] .k-switch-md.k-switch-on .k-switch-thumb-wrap,\n.k-rtl .k-switch-md.k-switch-on .k-switch-thumb-wrap {\n  left: calc( 15px + 0px );\n}\n.k-switch-md[dir=rtl].k-switch-off .k-switch-thumb-wrap,\n[dir=rtl] .k-switch-md.k-switch-off .k-switch-thumb-wrap,\n.k-rtl .k-switch-md.k-switch-off .k-switch-thumb-wrap {\n  left: calc( 100% - 15px - 0px );\n}\n\n.k-switch-lg {\n  width: 68px;\n  height: 34px;\n  font-size: 10px;\n}\n.k-switch-lg .k-switch-track {\n  width: 68px;\n  height: 34px;\n}\n.k-switch-lg .k-switch-label-on {\n  left: 8px;\n}\n.k-switch-lg .k-switch-label-off {\n  right: 8px;\n}\n.k-switch-lg .k-switch-thumb {\n  width: 34px;\n  height: 34px;\n}\n.k-switch-lg.k-switch-on .k-switch-thumb-wrap {\n  left: calc( 100% - 17px - 0px );\n}\n.k-switch-lg.k-switch-off .k-switch-thumb-wrap {\n  left: calc( 17px + 0px );\n}\n\n.k-switch-lg[dir=rtl] .k-switch-label-on,\n[dir=rtl] .k-switch-lg .k-switch-label-on,\n.k-rtl .k-switch-lg .k-switch-label-on {\n  left: auto;\n  right: 8px;\n}\n.k-switch-lg[dir=rtl] .k-switch-label-off,\n[dir=rtl] .k-switch-lg .k-switch-label-off,\n.k-rtl .k-switch-lg .k-switch-label-off {\n  right: auto;\n  left: 8px;\n}\n.k-switch-lg[dir=rtl].k-switch-on .k-switch-thumb-wrap,\n[dir=rtl] .k-switch-lg.k-switch-on .k-switch-thumb-wrap,\n.k-rtl .k-switch-lg.k-switch-on .k-switch-thumb-wrap {\n  left: calc( 17px + 0px );\n}\n.k-switch-lg[dir=rtl].k-switch-off .k-switch-thumb-wrap,\n[dir=rtl] .k-switch-lg.k-switch-off .k-switch-thumb-wrap,\n.k-rtl .k-switch-lg.k-switch-off .k-switch-thumb-wrap {\n  left: calc( 100% - 17px - 0px );\n}\n\n.k-switch[dir=rtl] .k-switch-thumb,\n[dir=rtl] .k-switch .k-switch-thumb,\n.k-switch.k-rtl .k-switch-thumb,\n.k-rtl .k-switch .k-switch-thumb {\n  transform: translate(50%, -50%);\n}\n\n.k-switch-off .k-switch-track {\n  border-color: #ebebeb;\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-switch-off .k-switch-thumb {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n.k-switch-off:focus .k-switch-track, .k-switch-off.k-focus .k-switch-track {\n  outline: 2px solid rgba(0, 0, 0, 0.08);\n}\n.k-switch-off .k-switch-label-on {\n  color: transparent;\n}\n\n.k-switch-on .k-switch-track {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n.k-switch-on .k-switch-thumb {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n.k-switch-on:focus .k-switch-track, .k-switch-on.k-focus .k-switch-track {\n  outline: 2px solid rgba(255, 99, 88, 0.25);\n}\n.k-switch-on .k-switch-label-off {\n  color: transparent;\n}\n\n.k-static,\n.k-pos-static {\n  position: static !important;\n}\n\n.\\!k-static,\n.\\!k-pos-static {\n  position: static !important;\n}\n\n.k-relative,\n.k-pos-relative {\n  position: relative !important;\n}\n\n.\\!k-relative,\n.\\!k-pos-relative {\n  position: relative !important;\n}\n\n.k-absolute,\n.k-pos-absolute {\n  position: absolute !important;\n}\n\n.\\!k-absolute,\n.\\!k-pos-absolute {\n  position: absolute !important;\n}\n\n.k-fixed,\n.k-pos-fixed {\n  position: fixed !important;\n}\n\n.\\!k-fixed,\n.\\!k-pos-fixed {\n  position: fixed !important;\n}\n\n.k-sticky,\n.k-pos-sticky {\n  position: sticky !important;\n}\n\n.\\!k-sticky,\n.\\!k-pos-sticky {\n  position: sticky !important;\n}\n\n.k-top,\n.k-pos-top {\n  top: 0;\n}\n\n.k-right,\n.k-pos-right {\n  right: 0;\n}\n\n.k-bottom,\n.k-pos-bottom {\n  bottom: 0;\n}\n\n.k-left,\n.k-pos-left {\n  left: 0;\n}\n\n.k-top-start,\n.k-pos-top-start {\n  top: 0;\n  left: 0;\n}\n.k-rtl .k-top-start, .k-top-start[dir=rtl], [dir=rtl] .k-top-start,\n.k-rtl .k-pos-top-start,\n.k-pos-top-start[dir=rtl],\n[dir=rtl] .k-pos-top-start {\n  left: auto;\n  right: 0;\n}\n\n.k-top-center,\n.k-pos-top-center {\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.k-top-end,\n.k-pos-top-end {\n  top: 0;\n  right: 0;\n}\n.k-rtl .k-top-end, .k-top-end[dir=rtl], [dir=rtl] .k-top-end,\n.k-rtl .k-pos-top-end,\n.k-pos-top-end[dir=rtl],\n[dir=rtl] .k-pos-top-end {\n  right: auto;\n  left: 0;\n}\n\n.k-middle-start,\n.k-pos-middle-start {\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\n.k-rtl .k-middle-start, .k-middle-start[dir=rtl], [dir=rtl] .k-middle-start,\n.k-rtl .k-pos-middle-start,\n.k-pos-middle-start[dir=rtl],\n[dir=rtl] .k-pos-middle-start {\n  left: auto;\n  right: 0;\n}\n\n.k-middle-center,\n.k-pos-middle-center {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.k-middle-end,\n.k-pos-middle-end {\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n.k-rtl .k-middle-end, .k-middle-end[dir=rtl], [dir=rtl] .k-middle-end,\n.k-rtl .k-pos-middle-end,\n.k-pos-middle-end[dir=rtl],\n[dir=rtl] .k-pos-middle-end {\n  right: auto;\n  left: 0;\n}\n\n.k-bottom-start,\n.k-pos-bottom-start {\n  bottom: 0;\n  left: 0;\n}\n.k-rtl .k-bottom-start, .k-bottom-start[dir=rtl], [dir=rtl] .k-bottom-start,\n.k-rtl .k-pos-bottom-start,\n.k-pos-bottom-start[dir=rtl],\n[dir=rtl] .k-pos-bottom-start {\n  left: auto;\n  right: 0;\n}\n\n.k-bottom-center,\n.k-pos-bottom-center {\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.k-bottom-end,\n.k-pos-bottom-end {\n  bottom: 0;\n  right: 0;\n}\n.k-rtl .k-bottom-end, .k-bottom-end[dir=rtl], [dir=rtl] .k-bottom-end,\n.k-rtl .k-pos-bottom-end,\n.k-pos-bottom-end[dir=rtl],\n[dir=rtl] .k-pos-bottom-end {\n  right: auto;\n  left: 0;\n}\n\n.k-badge {\n  padding: 0;\n  border-width: 1px;\n  border-style: solid;\n  border-color: transparent;\n  box-sizing: border-box;\n  color: inherit;\n  background-color: transparent;\n  font: inherit;\n  text-align: center;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.k-badge *,\n.k-badge *::before,\n.k-badge *::after {\n  box-sizing: border-box;\n}\n\n.k-badge > * {\n  color: inherit;\n}\n\na.k-badge,\n.k-badge > a {\n  text-decoration: none;\n}\n\na.k-badge:hover,\n.k-badge > a:hover {\n  text-decoration: underline;\n}\n\n.k-badge-icon {\n  max-width: 1em;\n  max-height: 1em;\n  font-size: inherit;\n}\n\n.k-badge-icon.k-svg-icon svg {\n  fill: currentColor;\n}\n\n.k-badge-sm {\n  padding: 2px 2px;\n  font-size: 10px;\n  line-height: 1;\n  min-width: calc( 1em + 4px + 2px );\n}\n.k-badge-sm:empty {\n  padding: 2px;\n  min-width: auto;\n}\n\n.k-badge-md {\n  padding: 4px 4px;\n  font-size: 10px;\n  line-height: 1;\n  min-width: calc( 1em + 8px + 2px );\n}\n.k-badge-md:empty {\n  padding: 4px;\n  min-width: auto;\n}\n\n.k-badge-lg {\n  padding: 6px 6px;\n  font-size: 10px;\n  line-height: 1;\n  min-width: calc( 1em + 12px + 2px );\n}\n.k-badge-lg:empty {\n  padding: 6px;\n  min-width: auto;\n}\n\nkendo-badge-container {\n  display: inline-block;\n}\n\n.k-badge-container {\n  position: relative;\n  overflow: visible;\n}\n\n.k-badge-inside {\n  position: absolute;\n  z-index: 9999;\n}\n.k-badge-edge {\n  position: absolute;\n  z-index: 9999;\n}\n.k-badge-edge.k-top-start {\n  transform: translate(-50%, -50%);\n}\n.k-badge-edge.k-top-end {\n  transform: translate(50%, -50%);\n}\n.k-badge-edge.k-bottom-start {\n  transform: translate(-50%, 50%);\n}\n.k-badge-edge.k-bottom-end {\n  transform: translate(50%, 50%);\n}\n\n.k-rtl .k-badge-edge.k-top-start,\n[dir=rtl].k-badge-edge.k-top-start,\n[dir=rtl] .k-badge-edge.k-top-start {\n  transform: translate(50%, -50%);\n}\n.k-rtl .k-badge-edge.k-top-end,\n[dir=rtl].k-badge-edge.k-top-end,\n[dir=rtl] .k-badge-edge.k-top-end {\n  transform: translate(-50%, -50%);\n}\n.k-rtl .k-badge-edge.k-bottom-start,\n[dir=rtl].k-badge-edge.k-bottom-start,\n[dir=rtl] .k-badge-edge.k-bottom-start {\n  transform: translate(50%, 50%);\n}\n.k-rtl .k-badge-edge.k-bottom-end,\n[dir=rtl].k-badge-edge.k-bottom-end,\n[dir=rtl] .k-badge-edge.k-bottom-end {\n  transform: translate(-50%, 50%);\n}\n\n.k-badge-outside {\n  position: absolute;\n  z-index: 9999;\n}\n.k-badge-outside.k-top-start {\n  transform: translate(-100%, -100%);\n}\n.k-badge-outside.k-top-end {\n  transform: translate(100%, -100%);\n}\n.k-badge-outside.k-bottom-start {\n  transform: translate(-100%, 100%);\n}\n.k-badge-outside.k-bottom-end {\n  transform: translate(100%, 100%);\n}\n\n.k-rtl .k-badge-outside.k-top-start,\n[dir=rtl].k-badge-outside.k-top-start,\n[dir=rtl] .k-badge-outside.k-top-start {\n  transform: translate(100%, -100%);\n}\n.k-rtl .k-badge-outside.k-top-end,\n[dir=rtl].k-badge-outside.k-top-end,\n[dir=rtl] .k-badge-outside.k-top-end {\n  transform: translate(-100%, -100%);\n}\n.k-rtl .k-badge-outside.k-bottom-start,\n[dir=rtl].k-badge-outside.k-bottom-start,\n[dir=rtl] .k-badge-outside.k-bottom-start {\n  transform: translate(100%, 100%);\n}\n.k-rtl .k-badge-outside.k-bottom-end,\n[dir=rtl].k-badge-outside.k-bottom-end,\n[dir=rtl] .k-badge-outside.k-bottom-end {\n  transform: translate(-100%, 100%);\n}\n\n.k-badge-border-cutout {\n  box-shadow: 0 0 0 2px #ffffff;\n}\n\n.k-badge-solid-primary {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n\n.k-badge-solid-secondary {\n  border-color: #666666;\n  color: white;\n  background-color: #666666;\n}\n\n.k-badge-solid-tertiary {\n  border-color: #03a9f4;\n  color: white;\n  background-color: #03a9f4;\n}\n\n.k-badge-solid-info {\n  border-color: #0058e9;\n  color: white;\n  background-color: #0058e9;\n}\n\n.k-badge-solid-success {\n  border-color: #37b400;\n  color: white;\n  background-color: #37b400;\n}\n\n.k-badge-solid-warning {\n  border-color: #ffc000;\n  color: black;\n  background-color: #ffc000;\n}\n\n.k-badge-solid-error {\n  border-color: #f31700;\n  color: white;\n  background-color: #f31700;\n}\n\n.k-badge-solid-dark {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n\n.k-badge-solid-light {\n  border-color: #ebebeb;\n  color: black;\n  background-color: #ebebeb;\n}\n\n.k-badge-solid-inverse {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n\n.k-badge-outline {\n  border-color: currentColor;\n  background-color: #ffffff;\n}\n\n.k-badge-outline-primary {\n  color: #ff6358;\n}\n\n.k-badge-outline-secondary {\n  color: #666666;\n}\n\n.k-badge-outline-tertiary {\n  color: #03a9f4;\n}\n\n.k-badge-outline-info {\n  color: #0058e9;\n}\n\n.k-badge-outline-success {\n  color: #37b400;\n}\n\n.k-badge-outline-warning {\n  color: #ffc000;\n}\n\n.k-badge-outline-error {\n  color: #f31700;\n}\n\n.k-badge-outline-dark {\n  color: #424242;\n}\n\n.k-badge-outline-light {\n  color: #ebebeb;\n}\n\n.k-badge-outline-inverse {\n  color: #424242;\n}\n\n.k-button {\n  box-sizing: border-box;\n  border-width: 1px;\n  border-style: solid;\n  color: inherit;\n  background: none;\n  font-family: inherit;\n  text-align: center;\n  text-decoration: none;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  vertical-align: middle;\n  user-select: none;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  position: relative;\n  transition: color 0.2s ease-in-out;\n}\n.k-button *,\n.k-button *::before,\n.k-button *::after {\n  box-sizing: border-box;\n}\n.k-button:disabled, .k-button.k-disabled {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n.k-button::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n  outline: 0;\n}\n.k-button:hover, .k-button:focus {\n  text-decoration: none;\n  outline: 0;\n}\n\n.k-icon-button {\n  gap: 0;\n}\n.k-icon-button .k-icon {\n  display: inline-flex;\n}\n\n.k-button-icon {\n  color: inherit;\n  align-self: center;\n  position: relative;\n}\n\n.k-button-sm {\n  padding: 2px 8px;\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n\n.k-button-sm.k-icon-button {\n  padding: 2px;\n}\n.k-button-sm.k-icon-button > .k-button-icon {\n  min-width: calc( 14px * 1.4285714286 );\n  min-height: calc( 14px * 1.4285714286 );\n}\n\n.k-button-md {\n  padding: 4px 8px;\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n\n.k-button-md.k-icon-button {\n  padding: 4px;\n}\n.k-button-md.k-icon-button > .k-button-icon {\n  min-width: calc( 14px * 1.4285714286 );\n  min-height: calc( 14px * 1.4285714286 );\n}\n\n.k-button-lg {\n  padding: 8px 12px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.k-button-lg.k-icon-button {\n  padding: 8px;\n}\n.k-button-lg.k-icon-button > .k-button-icon {\n  min-width: calc( 16px * 1.5 );\n  min-height: calc( 16px * 1.5 );\n}\n\n.k-button-square {\n  aspect-ratio: 1;\n}\n\n.k-button-group {\n  margin: 0;\n  padding: 0;\n  border-width: 0;\n  box-sizing: border-box;\n  list-style: none;\n  outline: 0;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  vertical-align: middle;\n  position: relative;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-button-group > .k-button + .k-button {\n  margin-inline-start: -1px;\n}\n.k-button-group > .k-button:hover,\n.k-button-group > .k-button.k-hover,\n.k-button-group > .k-button:focus,\n.k-button-group > .k-button.k-focus,\n.k-button-group > .k-button:active,\n.k-button-group > .k-button.k-active,\n.k-button-group > .k-button.k-selected {\n  z-index: 2;\n}\n.k-button-group .k-button:not(:first-child):not(:last-child) {\n  border-start-end-radius: 0;\n  border-end-end-radius: 0;\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n}\n.k-button-group > .k-button:first-child:not(:only-child) {\n  border-start-end-radius: 0;\n  border-end-end-radius: 0;\n}\n.k-button-group > .k-button:last-child:not(:only-child) {\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n}\n.k-button-group:disabled, .k-button-group[disabled], .k-button-group.k-disabled {\n  opacity: 1;\n  filter: none;\n}\n\n.k-button-group-stretched {\n  width: 100%;\n}\n.k-button-group-stretched > * {\n  flex: 1 0 0%;\n  overflow: hidden;\n}\n\n.k-button-flat {\n  border-color: transparent !important;\n  color: inherit;\n  background: none !important;\n  box-shadow: none !important;\n}\n.k-button-flat::before {\n  display: block !important;\n}\n.k-button-flat::after {\n  box-shadow: inset 0 0 0 2px currentColor;\n  display: block !important;\n}\n.k-button-flat:focus::after, .k-button-flat.k-focus::after {\n  opacity: 0.12;\n}\n\n.k-button-outline {\n  border-color: currentColor;\n  color: inherit;\n  background: none;\n}\n\n.k-button-link {\n  border-color: transparent;\n  color: inherit;\n  text-decoration: none;\n  background: none;\n}\n.k-button-link:hover, .k-button-link.k-hover {\n  text-decoration: underline;\n}\n\n.k-button-clear {\n  border-color: transparent !important;\n  color: inherit;\n  background: none !important;\n  box-shadow: none !important;\n}\n\n.k-ie .k-button-group .k-button {\n  border-radius: 0;\n}\n\n.k-button-overlay, .k-button::before {\n  border-radius: inherit;\n  content: \"\";\n  background: currentColor;\n  opacity: 0;\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  left: -1px;\n  right: -1px;\n  top: -1px;\n  bottom: -1px;\n  z-index: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.k-button:hover::before, .k-button.k-hover::before {\n  opacity: 0.04;\n}\n.k-button.k-no-focus:not(:hover)::before, .k-button.k-no-focus:not(.k-hover)::before {\n  opacity: 0;\n}\n.k-button:active::before, .k-button.k-active::before {\n  opacity: 0.16;\n}\n.k-button.k-selected::before {\n  opacity: 0.2;\n}\n\n.k-button::after {\n  border-radius: inherit;\n  content: \"\";\n  opacity: 0;\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  left: -1px;\n  right: -1px;\n  top: -1px;\n  bottom: -1px;\n  z-index: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.k-button-solid-base {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #f5f5f5;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-base:hover, .k-button-solid-base.k-hover {\n  background-color: #ebebeb;\n}\n.k-button-solid-base:focus, .k-button-solid-base.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-button-solid-base:active, .k-button-solid-base.k-active {\n  background-color: #d8d8d8;\n}\n.k-button-solid-base.k-selected {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n.k-button-solid-primary {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-primary:hover, .k-button-solid-primary.k-hover {\n  border-color: #f55f54;\n  background-color: #f55f54;\n}\n.k-button-solid-primary:focus, .k-button-solid-primary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(255, 99, 88, 0.3);\n}\n.k-button-solid-primary:active, .k-button-solid-primary.k-active {\n  border-color: #e0574d;\n  background-color: #e0574d;\n}\n.k-button-solid-primary.k-selected {\n  border-color: #e0574d;\n  background-color: #e0574d;\n}\n.k-button-solid-secondary {\n  border-color: #666666;\n  color: white;\n  background-color: #666666;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-secondary:hover, .k-button-solid-secondary.k-hover {\n  border-color: #626262;\n  background-color: #626262;\n}\n.k-button-solid-secondary:focus, .k-button-solid-secondary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(102, 102, 102, 0.3);\n}\n.k-button-solid-secondary:active, .k-button-solid-secondary.k-active {\n  border-color: #5a5a5a;\n  background-color: #5a5a5a;\n}\n.k-button-solid-secondary.k-selected {\n  border-color: #5a5a5a;\n  background-color: #5a5a5a;\n}\n.k-button-solid-tertiary {\n  border-color: #03a9f4;\n  color: white;\n  background-color: #03a9f4;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-tertiary:hover, .k-button-solid-tertiary.k-hover {\n  border-color: #03a2ea;\n  background-color: #03a2ea;\n}\n.k-button-solid-tertiary:focus, .k-button-solid-tertiary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(3, 169, 244, 0.3);\n}\n.k-button-solid-tertiary:active, .k-button-solid-tertiary.k-active {\n  border-color: #0395d7;\n  background-color: #0395d7;\n}\n.k-button-solid-tertiary.k-selected {\n  border-color: #0395d7;\n  background-color: #0395d7;\n}\n.k-button-solid-info {\n  border-color: #0058e9;\n  color: white;\n  background-color: #0058e9;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-info:hover, .k-button-solid-info.k-hover {\n  border-color: #0054e0;\n  background-color: #0054e0;\n}\n.k-button-solid-info:focus, .k-button-solid-info.k-focus {\n  box-shadow: 0 0 0px 2px rgba(0, 88, 233, 0.3);\n}\n.k-button-solid-info:active, .k-button-solid-info.k-active {\n  border-color: #004dcd;\n  background-color: #004dcd;\n}\n.k-button-solid-info.k-selected {\n  border-color: #004dcd;\n  background-color: #004dcd;\n}\n.k-button-solid-success {\n  border-color: #37b400;\n  color: white;\n  background-color: #37b400;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-success:hover, .k-button-solid-success.k-hover {\n  border-color: #35ad00;\n  background-color: #35ad00;\n}\n.k-button-solid-success:focus, .k-button-solid-success.k-focus {\n  box-shadow: 0 0 0px 2px rgba(55, 180, 0, 0.3);\n}\n.k-button-solid-success:active, .k-button-solid-success.k-active {\n  border-color: #309e00;\n  background-color: #309e00;\n}\n.k-button-solid-success.k-selected {\n  border-color: #309e00;\n  background-color: #309e00;\n}\n.k-button-solid-warning {\n  border-color: #ffc000;\n  color: black;\n  background-color: #ffc000;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-warning:hover, .k-button-solid-warning.k-hover {\n  border-color: #f5b800;\n  background-color: #f5b800;\n}\n.k-button-solid-warning:focus, .k-button-solid-warning.k-focus {\n  box-shadow: 0 0 0px 2px rgba(255, 192, 0, 0.3);\n}\n.k-button-solid-warning:active, .k-button-solid-warning.k-active {\n  border-color: #e0a900;\n  background-color: #e0a900;\n}\n.k-button-solid-warning.k-selected {\n  border-color: #e0a900;\n  background-color: #e0a900;\n}\n.k-button-solid-error {\n  border-color: #f31700;\n  color: white;\n  background-color: #f31700;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-error:hover, .k-button-solid-error.k-hover {\n  border-color: #e91600;\n  background-color: #e91600;\n}\n.k-button-solid-error:focus, .k-button-solid-error.k-focus {\n  box-shadow: 0 0 0px 2px rgba(243, 23, 0, 0.3);\n}\n.k-button-solid-error:active, .k-button-solid-error.k-active {\n  border-color: #d61400;\n  background-color: #d61400;\n}\n.k-button-solid-error.k-selected {\n  border-color: #d61400;\n  background-color: #d61400;\n}\n.k-button-solid-dark {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-dark:hover, .k-button-solid-dark.k-hover {\n  border-color: #3f3f3f;\n  background-color: #3f3f3f;\n}\n.k-button-solid-dark:focus, .k-button-solid-dark.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-solid-dark:active, .k-button-solid-dark.k-active {\n  border-color: #3a3a3a;\n  background-color: #3a3a3a;\n}\n.k-button-solid-dark.k-selected {\n  border-color: #3a3a3a;\n  background-color: #3a3a3a;\n}\n.k-button-solid-light {\n  border-color: #ebebeb;\n  color: black;\n  background-color: #ebebeb;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-light:hover, .k-button-solid-light.k-hover {\n  border-color: #e2e2e2;\n  background-color: #e2e2e2;\n}\n.k-button-solid-light:focus, .k-button-solid-light.k-focus {\n  box-shadow: 0 0 0px 2px rgba(235, 235, 235, 0.3);\n}\n.k-button-solid-light:active, .k-button-solid-light.k-active {\n  border-color: #cfcfcf;\n  background-color: #cfcfcf;\n}\n.k-button-solid-light.k-selected {\n  border-color: #cfcfcf;\n  background-color: #cfcfcf;\n}\n.k-button-solid-inverse {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-button-solid-inverse:hover, .k-button-solid-inverse.k-hover {\n  border-color: #3f3f3f;\n  background-color: #3f3f3f;\n}\n.k-button-solid-inverse:focus, .k-button-solid-inverse.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-solid-inverse:active, .k-button-solid-inverse.k-active {\n  border-color: #3a3a3a;\n  background-color: #3a3a3a;\n}\n.k-button-solid-inverse.k-selected {\n  border-color: #3a3a3a;\n  background-color: #3a3a3a;\n}\n.k-button-outline-primary {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #ff6358;\n  background-color: transparent;\n}\n.k-button-outline-primary:hover, .k-button-outline-primary.k-hover {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n.k-button-outline-primary:focus, .k-button-outline-primary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(255, 99, 88, 0.3);\n}\n.k-button-outline-primary:active, .k-button-outline-primary.k-active {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n.k-button-outline-primary.k-selected {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n.k-button-outline-secondary {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #666666;\n  background-color: transparent;\n}\n.k-button-outline-secondary:hover, .k-button-outline-secondary.k-hover {\n  border-color: #666666;\n  color: white;\n  background-color: #666666;\n}\n.k-button-outline-secondary:focus, .k-button-outline-secondary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(102, 102, 102, 0.3);\n}\n.k-button-outline-secondary:active, .k-button-outline-secondary.k-active {\n  border-color: #666666;\n  color: white;\n  background-color: #666666;\n}\n.k-button-outline-secondary.k-selected {\n  border-color: #666666;\n  color: white;\n  background-color: #666666;\n}\n.k-button-outline-tertiary {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #03a9f4;\n  background-color: transparent;\n}\n.k-button-outline-tertiary:hover, .k-button-outline-tertiary.k-hover {\n  border-color: #03a9f4;\n  color: white;\n  background-color: #03a9f4;\n}\n.k-button-outline-tertiary:focus, .k-button-outline-tertiary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(3, 169, 244, 0.3);\n}\n.k-button-outline-tertiary:active, .k-button-outline-tertiary.k-active {\n  border-color: #03a9f4;\n  color: white;\n  background-color: #03a9f4;\n}\n.k-button-outline-tertiary.k-selected {\n  border-color: #03a9f4;\n  color: white;\n  background-color: #03a9f4;\n}\n.k-button-outline-info {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #0058e9;\n  background-color: transparent;\n}\n.k-button-outline-info:hover, .k-button-outline-info.k-hover {\n  border-color: #0058e9;\n  color: white;\n  background-color: #0058e9;\n}\n.k-button-outline-info:focus, .k-button-outline-info.k-focus {\n  box-shadow: 0 0 0px 2px rgba(0, 88, 233, 0.3);\n}\n.k-button-outline-info:active, .k-button-outline-info.k-active {\n  border-color: #0058e9;\n  color: white;\n  background-color: #0058e9;\n}\n.k-button-outline-info.k-selected {\n  border-color: #0058e9;\n  color: white;\n  background-color: #0058e9;\n}\n.k-button-outline-success {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #37b400;\n  background-color: transparent;\n}\n.k-button-outline-success:hover, .k-button-outline-success.k-hover {\n  border-color: #37b400;\n  color: white;\n  background-color: #37b400;\n}\n.k-button-outline-success:focus, .k-button-outline-success.k-focus {\n  box-shadow: 0 0 0px 2px rgba(55, 180, 0, 0.3);\n}\n.k-button-outline-success:active, .k-button-outline-success.k-active {\n  border-color: #37b400;\n  color: white;\n  background-color: #37b400;\n}\n.k-button-outline-success.k-selected {\n  border-color: #37b400;\n  color: white;\n  background-color: #37b400;\n}\n.k-button-outline-warning {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #ffc000;\n  background-color: transparent;\n}\n.k-button-outline-warning:hover, .k-button-outline-warning.k-hover {\n  border-color: #ffc000;\n  color: black;\n  background-color: #ffc000;\n}\n.k-button-outline-warning:focus, .k-button-outline-warning.k-focus {\n  box-shadow: 0 0 0px 2px rgba(255, 192, 0, 0.3);\n}\n.k-button-outline-warning:active, .k-button-outline-warning.k-active {\n  border-color: #ffc000;\n  color: black;\n  background-color: #ffc000;\n}\n.k-button-outline-warning.k-selected {\n  border-color: #ffc000;\n  color: black;\n  background-color: #ffc000;\n}\n.k-button-outline-error {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #f31700;\n  background-color: transparent;\n}\n.k-button-outline-error:hover, .k-button-outline-error.k-hover {\n  border-color: #f31700;\n  color: white;\n  background-color: #f31700;\n}\n.k-button-outline-error:focus, .k-button-outline-error.k-focus {\n  box-shadow: 0 0 0px 2px rgba(243, 23, 0, 0.3);\n}\n.k-button-outline-error:active, .k-button-outline-error.k-active {\n  border-color: #f31700;\n  color: white;\n  background-color: #f31700;\n}\n.k-button-outline-error.k-selected {\n  border-color: #f31700;\n  color: white;\n  background-color: #f31700;\n}\n.k-button-outline-dark {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #424242;\n  background-color: transparent;\n}\n.k-button-outline-dark:hover, .k-button-outline-dark.k-hover {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-dark:focus, .k-button-outline-dark.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-outline-dark:active, .k-button-outline-dark.k-active {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-dark.k-selected {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-light {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #ebebeb;\n  background-color: transparent;\n}\n.k-button-outline-light:hover, .k-button-outline-light.k-hover {\n  border-color: #ebebeb;\n  color: black;\n  background-color: #ebebeb;\n}\n.k-button-outline-light:focus, .k-button-outline-light.k-focus {\n  box-shadow: 0 0 0px 2px rgba(235, 235, 235, 0.3);\n}\n.k-button-outline-light:active, .k-button-outline-light.k-active {\n  border-color: #ebebeb;\n  color: black;\n  background-color: #ebebeb;\n}\n.k-button-outline-light.k-selected {\n  border-color: #ebebeb;\n  color: black;\n  background-color: #ebebeb;\n}\n.k-button-outline-inverse {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #424242;\n  background-color: transparent;\n}\n.k-button-outline-inverse:hover, .k-button-outline-inverse.k-hover {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-inverse:focus, .k-button-outline-inverse.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-outline-inverse:active, .k-button-outline-inverse.k-active {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-inverse.k-selected {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-base {\n  box-shadow: none;\n  border-color: currentColor;\n  color: #424242;\n  background-color: transparent;\n}\n.k-button-outline-base:hover, .k-button-outline-base.k-hover {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-base:focus, .k-button-outline-base.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-outline-base:active, .k-button-outline-base.k-active {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-outline-base.k-selected {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-button-flat-primary {\n  color: #ff6358;\n}\n.k-button-flat-secondary {\n  color: #666666;\n}\n.k-button-flat-tertiary {\n  color: #03a9f4;\n}\n.k-button-flat-info {\n  color: #0058e9;\n}\n.k-button-flat-success {\n  color: #37b400;\n}\n.k-button-flat-warning {\n  color: #ffc000;\n}\n.k-button-flat-error {\n  color: #f31700;\n}\n.k-button-flat-dark {\n  color: #424242;\n}\n.k-button-flat-light {\n  color: #ebebeb;\n}\n.k-button-flat-inverse {\n  color: #424242;\n}\n.k-button-flat-base {\n  color: inherit;\n}\n.k-button-link-primary {\n  color: #ff6358;\n}\n.k-button-link-primary:hover, .k-button-link-primary.k-hover {\n  color: #d6534a;\n}\n.k-button-link-primary:focus, .k-button-link-primary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(255, 99, 88, 0.3);\n}\n.k-button-link-primary:active, .k-button-link-primary.k-active {\n  color: #d6534a;\n}\n.k-button-link-primary.k-selected {\n  color: #d6534a;\n}\n.k-button-link-secondary {\n  color: #666666;\n}\n.k-button-link-secondary:hover, .k-button-link-secondary.k-hover {\n  color: #565656;\n}\n.k-button-link-secondary:focus, .k-button-link-secondary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(102, 102, 102, 0.3);\n}\n.k-button-link-secondary:active, .k-button-link-secondary.k-active {\n  color: #565656;\n}\n.k-button-link-secondary.k-selected {\n  color: #565656;\n}\n.k-button-link-tertiary {\n  color: #03a9f4;\n}\n.k-button-link-tertiary:hover, .k-button-link-tertiary.k-hover {\n  color: #038ecd;\n}\n.k-button-link-tertiary:focus, .k-button-link-tertiary.k-focus {\n  box-shadow: 0 0 0px 2px rgba(3, 169, 244, 0.3);\n}\n.k-button-link-tertiary:active, .k-button-link-tertiary.k-active {\n  color: #038ecd;\n}\n.k-button-link-tertiary.k-selected {\n  color: #038ecd;\n}\n.k-button-link-info {\n  color: #0058e9;\n}\n.k-button-link-info:hover, .k-button-link-info.k-hover {\n  color: #004ac4;\n}\n.k-button-link-info:focus, .k-button-link-info.k-focus {\n  box-shadow: 0 0 0px 2px rgba(0, 88, 233, 0.3);\n}\n.k-button-link-info:active, .k-button-link-info.k-active {\n  color: #004ac4;\n}\n.k-button-link-info.k-selected {\n  color: #004ac4;\n}\n.k-button-link-success {\n  color: #37b400;\n}\n.k-button-link-success:hover, .k-button-link-success.k-hover {\n  color: #2e9700;\n}\n.k-button-link-success:focus, .k-button-link-success.k-focus {\n  box-shadow: 0 0 0px 2px rgba(55, 180, 0, 0.3);\n}\n.k-button-link-success:active, .k-button-link-success.k-active {\n  color: #2e9700;\n}\n.k-button-link-success.k-selected {\n  color: #2e9700;\n}\n.k-button-link-warning {\n  color: #ffc000;\n}\n.k-button-link-warning:hover, .k-button-link-warning.k-hover {\n  color: #d6a100;\n}\n.k-button-link-warning:focus, .k-button-link-warning.k-focus {\n  box-shadow: 0 0 0px 2px rgba(255, 192, 0, 0.3);\n}\n.k-button-link-warning:active, .k-button-link-warning.k-active {\n  color: #d6a100;\n}\n.k-button-link-warning.k-selected {\n  color: #d6a100;\n}\n.k-button-link-error {\n  color: #f31700;\n}\n.k-button-link-error:hover, .k-button-link-error.k-hover {\n  color: #cc1300;\n}\n.k-button-link-error:focus, .k-button-link-error.k-focus {\n  box-shadow: 0 0 0px 2px rgba(243, 23, 0, 0.3);\n}\n.k-button-link-error:active, .k-button-link-error.k-active {\n  color: #cc1300;\n}\n.k-button-link-error.k-selected {\n  color: #cc1300;\n}\n.k-button-link-dark {\n  color: #424242;\n}\n.k-button-link-dark:hover, .k-button-link-dark.k-hover {\n  color: #373737;\n}\n.k-button-link-dark:focus, .k-button-link-dark.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-link-dark:active, .k-button-link-dark.k-active {\n  color: #373737;\n}\n.k-button-link-dark.k-selected {\n  color: #373737;\n}\n.k-button-link-light {\n  color: #ebebeb;\n}\n.k-button-link-light:hover, .k-button-link-light.k-hover {\n  color: #c5c5c5;\n}\n.k-button-link-light:focus, .k-button-link-light.k-focus {\n  box-shadow: 0 0 0px 2px rgba(235, 235, 235, 0.3);\n}\n.k-button-link-light:active, .k-button-link-light.k-active {\n  color: #c5c5c5;\n}\n.k-button-link-light.k-selected {\n  color: #c5c5c5;\n}\n.k-button-link-inverse {\n  color: #424242;\n}\n.k-button-link-inverse:hover, .k-button-link-inverse.k-hover {\n  color: #373737;\n}\n.k-button-link-inverse:focus, .k-button-link-inverse.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-link-inverse:active, .k-button-link-inverse.k-active {\n  color: #373737;\n}\n.k-button-link-inverse.k-selected {\n  color: #373737;\n}\n.k-button-link-base {\n  color: #424242;\n}\n.k-button-link-base:hover, .k-button-link-base.k-hover {\n  color: #373737;\n}\n.k-button-link-base:focus, .k-button-link-base.k-focus {\n  box-shadow: 0 0 0px 2px rgba(66, 66, 66, 0.3);\n}\n.k-button-link-base:active, .k-button-link-base.k-active {\n  color: #373737;\n}\n.k-button-link-base.k-selected {\n  color: #373737;\n}\n.k-button-clear-primary {\n  color: #ff6358;\n}\n.k-button-clear-primary:focus::after, .k-button-clear-primary.k-focus::after, .k-button-clear-primary:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-secondary {\n  color: #666666;\n}\n.k-button-clear-secondary:focus::after, .k-button-clear-secondary.k-focus::after, .k-button-clear-secondary:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-tertiary {\n  color: #03a9f4;\n}\n.k-button-clear-tertiary:focus::after, .k-button-clear-tertiary.k-focus::after, .k-button-clear-tertiary:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-info {\n  color: #0058e9;\n}\n.k-button-clear-info:focus::after, .k-button-clear-info.k-focus::after, .k-button-clear-info:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-success {\n  color: #37b400;\n}\n.k-button-clear-success:focus::after, .k-button-clear-success.k-focus::after, .k-button-clear-success:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-warning {\n  color: #ffc000;\n}\n.k-button-clear-warning:focus::after, .k-button-clear-warning.k-focus::after, .k-button-clear-warning:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-error {\n  color: #f31700;\n}\n.k-button-clear-error:focus::after, .k-button-clear-error.k-focus::after, .k-button-clear-error:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-dark {\n  color: #424242;\n}\n.k-button-clear-dark:focus::after, .k-button-clear-dark.k-focus::after, .k-button-clear-dark:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-light {\n  color: #ebebeb;\n}\n.k-button-clear-light:focus::after, .k-button-clear-light.k-focus::after, .k-button-clear-light:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-inverse {\n  color: #424242;\n}\n.k-button-clear-inverse:focus::after, .k-button-clear-inverse.k-focus::after, .k-button-clear-inverse:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-button-clear-base {\n  color: #424242;\n}\n.k-button-clear-base:focus::after, .k-button-clear-base.k-focus::after, .k-button-clear-base:active::after {\n  background-color: currentColor;\n  opacity: 0.1;\n  display: block;\n}\n.k-popup {\n  margin: 0;\n  padding: 0;\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.k-popup .k-item {\n  outline: none;\n}\n\n.k-animation-container {\n  border-radius: 0 0 4px 4px;\n}\n\n.k-animation-container-shown {\n  overflow: visible;\n}\n\n.k-popup > .k-colorpalette {\n  padding: 8px 8px;\n}\n\n.k-popup.k-popup-transparent {\n  border-width: 0;\n  background-color: transparent;\n}\n\n.k-popup.k-popup-flush {\n  padding: 0;\n}\n\n.k-popup > .k-widget,\n.k-popup > .k-coloreditor {\n  border-width: 0;\n}\n\n.k-shadow {\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);\n}\n\n.k-popup {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);\n}\n\n.k-animation-container {\n  border-radius: 0 0 4px 4px;\n}\n\n.k-list-container {\n  display: flex;\n  flex-flow: column nowrap;\n}\n.k-list-container > .k-list {\n  flex: 1;\n  height: 100%;\n}\n\n.k-list {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-flow: column nowrap;\n  outline: none;\n  position: relative;\n  overflow: hidden;\n}\n.k-list *,\n.k-list *::before,\n.k-list *::after {\n  box-sizing: border-box;\n}\n\n.k-popup > .k-list {\n  height: 100%;\n  border-width: 0;\n}\n\n.k-list-group-sticky-header {\n  border-width: 0;\n  border-width: 0 0 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  flex: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.k-list-content {\n  border-color: inherit;\n  flex: 1 1 auto;\n  overflow: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n}\n\n.k-list-ul {\n  margin: 0;\n  padding: 0;\n  border-width: 0;\n  border-color: inherit;\n  height: auto;\n  list-style: none;\n}\n\n.k-list-item, .k-list-optionlabel {\n  border: 0;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  gap: 4px;\n  position: relative;\n  transition-property: color, background-color, outline-color, box-shadow;\n  transition-duration: 200ms;\n  transition-timing-function: ease;\n}\n.k-list-item.k-first::before, .k-first.k-list-optionlabel::before {\n  content: \"\";\n  border-width: 1px 0 0;\n  border-style: solid;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.k-list-item-text::before,\n.k-list-optionlabel::before {\n  content: \"​\";\n  width: 0px;\n  overflow: hidden;\n}\n\n.k-list-group-item {\n  border-width: 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  cursor: default;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  gap: 4px;\n  position: relative;\n}\n\n.k-list-item-group-label {\n  padding: 0 0.5em;\n  font-size: 0.75em;\n  position: absolute;\n  top: 0;\n  inset-inline-end: 0;\n}\n.k-ie .k-list-item-group-label {\n  right: 0;\n}\n.k-ie .k-rtl .k-list-item-group-label, .k-ie [dir=rtl] .k-list-item-group-label {\n  right: auto;\n  left: 0;\n}\n\n.k-virtual-content,\n.k-virtual-list .k-list-content {\n  overflow-y: scroll;\n}\n\n.k-virtual-list .k-list-item, .k-virtual-list .k-list-optionlabel,\n.k-virtual-list .k-list-group-item,\n.k-virtual-content .k-list-item,\n.k-virtual-content .k-list-optionlabel,\n.k-virtual-content .k-list-group-item {\n  position: absolute;\n  width: 100%;\n}\n\n.k-virtual-list .k-list-item-text,\n.k-virtual-list .k-list-header-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.k-virtual-list .k-list-optionlabel {\n  position: relative;\n}\n\n.k-list-filter {\n  display: block;\n  position: relative;\n  padding: 8px;\n  box-sizing: border-box;\n  flex: none;\n}\n\n.k-list-sm {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-list-sm .k-list-group-sticky-header {\n  padding: 2px 8px;\n}\n.k-list-sm .k-list-item, .k-list-sm .k-list-optionlabel {\n  padding: 2px 8px;\n}\n.k-list-sm .k-list-group-item {\n  padding: 2px 8px;\n}\n\n.k-list-md {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-list-md .k-list-group-sticky-header {\n  padding: 4px 8px;\n}\n.k-list-md .k-list-item, .k-list-md .k-list-optionlabel {\n  padding: 4px 8px;\n}\n.k-list-md .k-list-group-item {\n  padding: 4px 8px;\n}\n\n.k-list-lg {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.k-list-lg .k-list-group-sticky-header {\n  padding: 6px 8px;\n}\n.k-list-lg .k-list-item, .k-list-lg .k-list-optionlabel {\n  padding: 8px 12px;\n}\n.k-list-lg .k-list-group-item {\n  padding: 6px 8px;\n}\n\n.k-no-data, .k-nodata {\n  min-height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: lighter;\n  text-align: center;\n  white-space: normal;\n}\n\n.k-list {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n\n.k-list-group-sticky-header {\n  border-color: inherit;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.06);\n}\n\n.k-list-item:hover, .k-list-optionlabel:hover, .k-list-item.k-hover, .k-hover.k-list-optionlabel {\n  color: #424242;\n  background-color: #f0f0f0;\n}\n.k-list-item:focus, .k-list-optionlabel:focus, .k-list-item.k-focus, .k-focus.k-list-optionlabel {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n.k-list-item.k-selected, .k-selected.k-list-optionlabel {\n  color: white;\n  background-color: #ff6358;\n}\n.k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel {\n  color: white;\n  background-color: #eb5b51;\n}\n\n.k-list-group-item {\n  border-color: inherit;\n}\n\n.k-list-item-group-label {\n  color: #ffffff;\n  background-color: #424242;\n}\n\n.k-no-data, .k-nodata {\n  color: #666666;\n}\n\n.k-menu-bar, .k-menu {\n  border-width: 0px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  position: relative;\n  cursor: default;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-menu-bar *, .k-menu *,\n.k-menu-bar *::before,\n.k-menu *::before,\n.k-menu-bar *::after,\n.k-menu *::after {\n  box-sizing: border-box;\n}\n\n.k-menu-item {\n  border-width: 0;\n  outline: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  flex: none;\n  position: relative;\n  user-select: none;\n}\n\n.k-menu-item-content {\n  display: block;\n  height: auto;\n  overflow: visible;\n}\n.k-menu-item-content .k-actions, .k-menu-item-content .k-form-buttons, .k-menu-item-content .k-edit-buttons,\n.k-menu-item-content .k-action-buttons,\n.k-menu-item-content .k-columnmenu-actions {\n  margin-top: 0;\n}\n\n.k-menu-link {\n  padding: 6px 12px;\n  outline: 0;\n  color: inherit;\n  display: flex;\n  flex-flow: row nowrap;\n  flex: 1 1 auto;\n  gap: 4px;\n  align-items: center;\n  position: relative;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.k-menu-link-text {\n  display: flex;\n  flex-flow: row nowrap;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.k-menu-expand-arrow {\n  margin-inline-end: -4px;\n  display: inline-flex;\n  flex-flow: row wrap;\n  align-items: center;\n  flex: none;\n  position: relative;\n}\n\n.k-menu-horizontal {\n  flex-direction: row;\n}\n.k-menu-horizontal > .k-menu-item + .k-menu-item {\n  margin-left: 0px;\n}\n.k-menu-horizontal > .k-separator {\n  margin: 0 4px;\n  width: 0;\n  height: auto;\n  border-width: 0 0 0 1px;\n  border-style: solid;\n}\n\n.k-menu-vertical {\n  flex-direction: column;\n}\n.k-menu-vertical > .k-menu-item + .k-menu-item {\n  margin-top: 0px;\n}\n.k-menu-vertical > .k-menu-item > .k-menu-link {\n  padding: 4px 8px;\n  padding-right: calc( 16px + 16px );\n}\n.k-menu-vertical > .k-menu-item > .k-menu-link > .k-menu-expand-arrow {\n  margin-inline-start: 8px;\n  margin-inline-end: calc(-1 * (calc( 16px + 16px ) - 4px));\n}\n.k-menu-vertical > .k-separator {\n  margin: 4px 0;\n  height: 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.08);\n  display: block;\n}\n\n.k-menu-popup {\n  box-sizing: border-box;\n  border-width: 1px;\n  border-style: solid;\n  overflow: auto;\n  max-height: 80vh;\n}\n.k-menu-popup *,\n.k-menu-popup *::before,\n.k-menu-popup *::after {\n  box-sizing: border-box;\n}\n\n.k-menu-group {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-flow: column nowrap;\n  position: absolute;\n}\n.k-menu-group .k-menu-item + .k-menu-item {\n  margin-top: 0px;\n}\n.k-menu-group .k-separator {\n  margin: 4px 0;\n  height: 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.08);\n  display: block;\n}\n\n.k-menu-popup .k-menu-group {\n  position: relative;\n}\n\n.k-menu-group-sm {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-menu-group-sm .k-menu-item {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-menu-group-sm .k-menu-link {\n  padding: 2px 8px;\n  padding-inline-end: calc( 16px + 16px );\n}\n.k-menu-group-sm .k-menu-expand-arrow {\n  margin-inline-start: 8px;\n  margin-inline-end: calc(-1 * (calc( 16px + 16px ) - 4px));\n}\n\n.k-menu-group-md {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-menu-group-md .k-menu-item {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-menu-group-md .k-menu-link {\n  padding: 4px 8px;\n  padding-inline-end: calc( 16px + 16px );\n}\n.k-menu-group-md .k-menu-expand-arrow {\n  margin-inline-start: 8px;\n  margin-inline-end: calc(-1 * (calc( 16px + 16px ) - 4px));\n}\n\n.k-menu-group-lg {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-menu-group-lg .k-menu-item {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-menu-group-lg .k-menu-link {\n  padding: 6px 8px;\n  padding-inline-end: calc( 16px + 16px );\n}\n.k-menu-group-lg .k-menu-expand-arrow {\n  margin-inline-start: 8px;\n  margin-inline-end: calc(-1 * (calc( 16px + 16px ) - 4px));\n}\n\n.k-popups-wrapper {\n  position: relative;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.k-context-menu {\n  margin: 0;\n  border-width: 1px;\n  border-style: solid;\n}\n.k-animation-container .k-context-menu.k-menu-horizontal {\n  display: flex !important;\n  flex-wrap: nowrap;\n}\n\n.k-context-menu-popup {\n  z-index: 12000;\n}\n.k-context-menu-popup .k-context-menu {\n  border-width: 0;\n}\n\n.k-popup .k-context-menu,\n.k-context-menu-popup .k-context-menu {\n  border-width: 0;\n}\n\n.k-menu-scroll-wrapper {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  position: relative;\n}\n.k-menu-scroll-wrapper .k-menu {\n  overflow: hidden;\n  flex-wrap: nowrap;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button {\n  border-radius: 0;\n  padding: 0;\n  border-width: 0;\n  border-color: inherit;\n  color: inherit;\n  background: inherit;\n  position: absolute;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-left {\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 16px;\n  border-right-width: 1px;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-right {\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 16px;\n  border-left-width: 1px;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-up {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 16px;\n  border-bottom-width: 1px;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button.k-scroll-down {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 16px;\n  border-top-width: 1px;\n}\n\n.k-rtl .k-menu-horizontal > .k-menu-item + .k-menu-item,\n[dir=rtl] .k-menu-horizontal > .k-menu-item + .k-menu-item {\n  margin-right: 0px;\n  margin-left: 0;\n}\n.k-rtl .k-menu-vertical > .k-menu-item > .k-menu-link,\n[dir=rtl] .k-menu-vertical > .k-menu-item > .k-menu-link {\n  padding-right: 8px;\n  padding-left: calc( 16px + 16px );\n}\n.k-rtl .k-menu-group .k-menu-link,\n[dir=rtl] .k-menu-group .k-menu-link {\n  padding-right: 8px;\n  padding-left: calc( 16px + 16px );\n}\n\n.k-menu:not(.k-context-menu) {\n  color: #424242;\n  background-color: transparent;\n}\n.k-menu:not(.k-context-menu) > .k-item {\n  color: #ff6358;\n}\n.k-menu:not(.k-context-menu) > .k-item:hover, .k-menu:not(.k-context-menu) > .k-item.k-hover {\n  color: #d6534a;\n}\n.k-menu:not(.k-context-menu) > .k-item:active, .k-menu:not(.k-context-menu) > .k-item.k-active {\n  color: #424242;\n}\n.k-menu:not(.k-context-menu) > .k-item:focus, .k-menu:not(.k-context-menu) > .k-item.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n\n.k-menu-group,\n.k-menu.k-context-menu {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-menu-group .k-item > .k-link:hover, .k-menu-group .k-item > .k-link.k-hover,\n.k-menu.k-context-menu .k-item > .k-link:hover,\n.k-menu.k-context-menu .k-item > .k-link.k-hover {\n  color: #424242;\n  background-color: #f0f0f0;\n}\n.k-menu-group .k-item > .k-link:active, .k-menu-group .k-item > .k-link.k-active, .k-menu-group .k-item > .k-link.k-selected,\n.k-menu.k-context-menu .k-item > .k-link:active,\n.k-menu.k-context-menu .k-item > .k-link.k-active,\n.k-menu.k-context-menu .k-item > .k-link.k-selected {\n  color: white;\n  background-color: #ff6358;\n}\n.k-menu-group .k-item:focus > .k-link,\n.k-menu-group .k-item.k-focus > .k-link,\n.k-menu.k-context-menu .k-item:focus > .k-link,\n.k-menu.k-context-menu .k-item.k-focus > .k-link {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n\n.k-menu-scroll-wrapper .k-menu-scroll-button {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #ff6358;\n  background-color: #ffffff;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button:hover {\n  color: #d6534a;\n}\n.k-menu-scroll-wrapper .k-menu-scroll-button:hover::before {\n  opacity: 0;\n}\n\n.k-toolbar {\n  margin: 0;\n  padding: 8px 8px;\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  list-style: none;\n  display: flex;\n  flex-flow: row wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n  overflow: hidden;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-toolbar::before {\n  content: \"\";\n  height: calc( 1.4285714286em + 8px + 2px );\n  margin-inline-start: -8px;\n}\n.k-toolbar.k-toolbar-resizable {\n  flex-wrap: nowrap;\n}\n.k-toolbar > * {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-content: center;\n  vertical-align: middle;\n}\n.k-toolbar > * > label {\n  margin-inline-end: 8px;\n  align-self: center;\n}\n.k-toolbar .k-input,\n.k-toolbar .k-picker {\n  width: 10em;\n}\n.k-toolbar .k-color-picker {\n  width: min-content;\n}\n.k-toolbar .k-overflow-anchor {\n  border-radius: 0;\n  margin: 0;\n  padding: 8px;\n  width: auto;\n  height: 100%;\n  aspect-ratio: 1;\n  border-width: 0;\n  border-color: inherit;\n  box-sizing: border-box;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.k-toolbar .k-overflow-anchor::before {\n  display: block;\n}\n.k-toolbar .k-separator,\n.k-toolbar .k-toolbar-separator {\n  width: 0;\n  height: calc( 1.4285714286 * 1em );\n  border-width: 0 0 0 1px;\n  border-style: solid;\n  align-self: center;\n}\n.k-toolbar .k-toolbar-spacer {\n  height: calc( 1.4285714286 * 1em );\n  flex: 1 0 0%;\n}\n.k-toolbar .k-toolbar-template {\n  align-self: center;\n  align-items: center;\n}\n.k-toolbar .k-toolbar-item:focus,\n.k-toolbar .k-toolbar-item.k-focus {\n  text-decoration: none;\n  outline: 0;\n}\n\n.k-toolbar-group {\n  display: flex;\n  flex-direction: inherit;\n  flex-wrap: nowrap;\n  gap: inherit;\n}\n\nkendo-toolbar-renderer {\n  display: inline-block;\n  border-color: inherit;\n}\n\n.k-overflow-container {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-overflow-container > .k-item {\n  border-color: inherit;\n}\n.k-overflow-container .k-separator {\n  margin: 4px 0;\n}\n.k-overflow-container .k-overflow-tool-group {\n  display: block;\n}\n.k-overflow-container .k-overflow-button {\n  padding: 4px 8px;\n  width: 100%;\n  height: auto;\n  border-width: 0;\n  border-radius: 0;\n  aspect-ratio: auto;\n  color: inherit;\n  background-color: transparent;\n  background-image: none;\n  font: inherit;\n  cursor: pointer;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  gap: 4px;\n  justify-content: flex-start;\n  position: relative;\n}\n.k-overflow-container .k-button-group {\n  box-shadow: none;\n  display: flex;\n  flex-flow: column nowrap;\n}\n.k-overflow-container .k-button-group .k-button {\n  margin: 0;\n}\n.k-overflow-container .k-split-button {\n  display: flex;\n  flex-direction: column;\n}\n.k-overflow-container .k-overflow-hidden {\n  display: none;\n}\n\n.k-toolbar.k-rtl .k-overflow-anchor, .k-rtl .k-toolbar .k-overflow-anchor, .k-toolbar[dir=rtl] .k-overflow-anchor, [dir=rtl] .k-toolbar .k-overflow-anchor {\n  margin: 0;\n  right: auto;\n  left: 0;\n}\n\n.k-floating-toolbar,\n.editorToolbarWindow.k-window-content {\n  padding: 8px 8px !important;\n  border-width: 1px;\n  border-style: solid;\n  display: flex;\n  flex-flow: row nowrap;\n  gap: 8px;\n  align-items: center;\n}\n.k-floating-toolbar .k-toolbar,\n.editorToolbarWindow.k-window-content .k-toolbar {\n  padding: 0;\n  border-width: 0;\n  flex-shrink: 1;\n  color: inherit;\n  background: none;\n}\n\n.k-editortoolbar-dragHandle {\n  cursor: move;\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  flex-shrink: 0;\n}\n\n.k-toolbar {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n.k-toolbar .k-separator {\n  border-color: inherit;\n}\n.k-toolbar .k-toolbar-item:focus,\n.k-toolbar .k-toolbar-item.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-overflow-container .k-button:hover, .k-overflow-container .k-button.k-hover {\n  color: #424242;\n  background: #f0f0f0;\n}\n.k-overflow-container .k-button:focus, .k-overflow-container .k-button.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n.k-overflow-container .k-button:active, .k-overflow-container .k-button.k-active {\n  color: #424242;\n  background: #f0f0f0;\n}\n.k-overflow-container .k-button.k-selected {\n  color: white;\n  background: #ff6358;\n}\n.k-overflow-container .k-button:disabled, .k-overflow-container .k-button.k-disabled {\n  color: inherit;\n}\n\n.k-floating-toolbar,\n.editorToolbarWindow.k-window-content {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n\n.k-pane-wrapper {\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  display: block;\n  position: relative;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-pane-wrapper .k-pane {\n  width: 100%;\n  height: 100%;\n  user-select: none;\n  box-sizing: border-box;\n  font-family: sans-serif;\n  overflow-x: hidden;\n}\n.k-pane-wrapper .k-view {\n  top: 0;\n  left: 0;\n  position: relative;\n  border: 0;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  align-items: stretch;\n  align-content: stretch;\n  vertical-align: top;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-pane-wrapper .k-content {\n  min-height: 1px;\n  flex: 1;\n  align-items: stretch;\n  display: block;\n  width: auto;\n  overflow: hidden;\n  position: relative;\n}\n\n.k-pane-wrapper > div.k-pane {\n  box-shadow: none;\n  font-weight: normal;\n}\n.k-pane-wrapper .k-popup-edit-form .k-content,\n.k-pane-wrapper .k-grid-edit-form .k-content,\n.k-pane-wrapper .k-grid-header-menu .k-content,\n.k-pane-wrapper .k-grid-filter-menu .k-content {\n  overflow-y: auto;\n}\n.k-pane-wrapper .k-popup-edit-form .k-content > .k-scroll-container,\n.k-pane-wrapper .k-grid-edit-form .k-content > .k-scroll-container,\n.k-pane-wrapper .k-grid-header-menu .k-content > .k-scroll-container,\n.k-pane-wrapper .k-grid-filter-menu .k-content > .k-scroll-container {\n  position: absolute;\n  width: 100%;\n  min-height: 100%;\n  box-sizing: border-box;\n}\n.k-pane-wrapper .k-grid-edit-form .k-popup-edit-form,\n.k-pane-wrapper .k-grid-edit-form .k-edit-form-container {\n  width: auto;\n  min-width: auto;\n}\n\n.k-grid.k-grid-mobile {\n  border-width: 0;\n}\n\n.k-grid-mobile .k-resize-handle-inner::before {\n  content: \"\\e01e\";\n  position: absolute;\n  font: 16px/1 \"WebComponentsIcons\";\n  top: calc(50% - 1px);\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 0.2em;\n}\n.k-grid-mobile .k-header a {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -webkit-user-drag: none;\n  -moz-user-drag: none;\n}\n\n.k-pane-wrapper .k-scheduler-edit-form .k-recur-view {\n  padding: 0;\n  flex-direction: column;\n  align-items: stretch;\n}\n.k-pane-wrapper .k-scheduler-edit-form .k-recur-view > .k-listgroup-form-row {\n  margin: 0;\n}\n.k-pane-wrapper .k-scheduler-edit-form .k-recur-items-wrap {\n  width: 100%;\n  margin: -1px 0;\n}\n.k-pane-wrapper .k-scheduler-edit-form .k-scheduler-recur-end-wrap {\n  white-space: nowrap;\n}\n\n.k-scheduler.k-scheduler-mobile {\n  border-width: 0;\n}\n\n.k-scheduler-mobile th {\n  font-weight: normal;\n}\n.k-scheduler-mobile .k-event:hover .k-resize-handle {\n  visibility: hidden;\n}\n.k-scheduler-mobile .k-scheduler-toolbar {\n  padding: 8px 8px;\n}\n.k-scheduler-mobile .k-scheduler-toolbar > * {\n  margin: 0;\n}\n.k-scheduler-mobile .k-scheduler-toolbar::before {\n  display: none;\n}\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation {\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin: 0;\n}\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation .k-nav-current {\n  line-height: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  justify-content: space-evenly;\n  gap: 0;\n}\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-navigation .k-y-date-format {\n  font-size: 12px;\n}\n.k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-views-wrapper .k-views-dropdown {\n  display: inline-block;\n}\n.k-scheduler-mobile .k-scheduler-footer {\n  padding: 8px 8px;\n  display: flex;\n  justify-content: space-between;\n}\n.k-scheduler-mobile .k-scheduler-footer > * {\n  margin: 0;\n}\n.k-scheduler-mobile .k-scheduler-footer::before {\n  display: none;\n}\n.k-scheduler-mobile .k-scheduler-monthview .k-hidden {\n  height: 40px;\n}\n.k-scheduler-mobile .k-scheduler-monthview .k-scheduler-table td {\n  height: 40px;\n  vertical-align: top;\n  text-align: center;\n}\n.k-scheduler-mobile .k-scheduler-monthview .k-events-container {\n  position: absolute;\n  text-align: center;\n  height: 6px;\n  line-height: 6px;\n}\n.k-scheduler-mobile .k-scheduler-monthview .k-event {\n  position: static;\n  padding: 4px;\n  border-radius: 50%;\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  min-height: 0;\n  margin: 1px;\n}\n.k-scheduler-mobile .k-scheduler-dayview .k-mobile-header.k-mobile-horizontal-header .k-scheduler-times table tr:first-child {\n  display: none;\n}\n.k-scheduler-mobile .k-scheduler-dayview .k-mobile-header .k-scheduler-header .k-scheduler-date-group {\n  display: none;\n}\n.k-scheduler-mobile .k-scheduler-header-wrap > div {\n  overflow: visible;\n}\n.k-scheduler-mobile .k-scheduler-agendaview .k-mobile-header {\n  display: none;\n}\n.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table {\n  table-layout: auto;\n}\n.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table .k-scheduler-groupcolumn {\n  width: 1%;\n}\n.k-scheduler-mobile .k-scheduler-agendaview .k-scheduler-table td {\n  white-space: normal;\n}\n.k-scheduler-mobile .k-mobile-header .k-scheduler-table td,\n.k-scheduler-mobile .k-mobile-header .k-scheduler-table th {\n  height: 1.5em;\n}\n.k-scheduler-mobile .k-time-text,\n.k-scheduler-mobile .k-time-period {\n  display: block;\n  line-height: 1;\n}\n.k-scheduler-mobile .k-time-period {\n  font-size: 0.7em;\n}\n.k-scheduler-mobile .k-scheduler-table td,\n.k-scheduler-mobile .k-scheduler-table th {\n  height: 2em;\n  vertical-align: middle;\n}\n.k-scheduler-mobile .k-scheduler-datecolumn-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.k-scheduler-mobile .k-task {\n  display: flex;\n  align-items: center;\n}\n.k-scheduler-mobile .k-task .k-scheduler-mark {\n  border-radius: 50%;\n}\n.k-scheduler-mobile .k-task .k-i-reload,\n.k-scheduler-mobile .k-task .k-i-arrow-rotate-cw {\n  font-size: 1em;\n  margin-right: 0.5em;\n}\n.k-scheduler-mobile .k-task .k-scheduler-task-text {\n  flex: 1 1 0%;\n}\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-group-cell,\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-groupcolumn,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-group-cell,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-groupcolumn {\n  vertical-align: top;\n}\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-group-cell .k-scheduler-group-text,\n.k-scheduler-mobile .k-scheduler-times .k-scheduler-groupcolumn .k-scheduler-group-text,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-group-cell .k-scheduler-group-text,\n.k-scheduler-mobile .k-scheduler-agenda .k-scheduler-groupcolumn .k-scheduler-group-text {\n  writing-mode: vertical-lr;\n  transform: rotate(180deg);\n  white-space: nowrap;\n}\n.k-scheduler-mobile .k-scrollbar-h tr + tr .k-scheduler-times {\n  border-bottom-width: 0;\n}\n\n.k-pane-wrapper .k-appbar {\n  padding: 4px;\n}\n.k-pane-wrapper .k-list-title,\n.k-pane-wrapper .k-filter-help-text {\n  padding: 8px 8px;\n  display: block;\n}\n.k-pane-wrapper .k-listgroup-title {\n  padding: 8px 8px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.k-pane-wrapper .k-listgroup .k-listgroup-item {\n  border-color: inherit;\n}\n.k-pane-wrapper .k-listgroup + .k-listgroup {\n  margin-top: 16px;\n}\n.k-pane-wrapper .k-column-menu {\n  padding: 8px;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 8px;\n}\n.k-pane-wrapper .k-column-menu .k-filter-item .k-filterable * {\n  pointer-events: none;\n}\n.k-pane-wrapper .k-column-menu .k-list-title,\n.k-pane-wrapper .k-column-menu .k-listgroup-title {\n  padding: 0;\n}\n.k-pane-wrapper .k-column-menu .k-listgroup {\n  margin-inline: -8px;\n}\n.k-pane-wrapper .k-filter-menu {\n  padding: 8px;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 8px;\n}\n.k-pane-wrapper .k-filter-menu .k-list-title {\n  padding: 0;\n}\n.k-pane-wrapper .k-filter-menu .k-list-filter {\n  padding: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: inherit;\n}\n.k-pane-wrapper .k-filter-menu .k-filter-tools {\n  display: flex;\n  flex-flow: row nowrap;\n  gap: inherit;\n}\n.k-pane-wrapper .k-filter-menu .k-listgroup {\n  margin-inline: -8px;\n}\n.k-pane-wrapper .k-popup-edit-form .k-recur-editor-wrap {\n  display: flex;\n}\n.k-pane-wrapper .k-popup-edit-form .k-mobiletimezoneeditor {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n  flex: 1 1 auto;\n}\n.k-pane-wrapper .k-multicheck-wrap.k-listgroup {\n  overflow-y: auto;\n}\n.k-pane-wrapper .k-pager-wrap.k-pager-sm,\n.k-pane-wrapper .k-pager.k-pager-sm {\n  justify-content: center;\n}\n.k-pane-wrapper .k-pager-wrap.k-pager-sm .k-pager-refresh,\n.k-pane-wrapper .k-pager.k-pager-sm .k-pager-refresh {\n  display: none;\n}\n.k-rtl .k-pane-wrapper .k-header-cancel .k-i-arrow-chevron-left,\n.k-rtl .k-pane-wrapper .k-listgroup-item .k-select .k-i-arrow-chevron-right, .k-pane-wrapper[dir=rtl] .k-header-cancel .k-i-arrow-chevron-left,\n.k-pane-wrapper[dir=rtl] .k-listgroup-item .k-select .k-i-arrow-chevron-right, [dir=rtl] .k-pane-wrapper .k-header-cancel .k-i-arrow-chevron-left,\n[dir=rtl] .k-pane-wrapper .k-listgroup-item .k-select .k-i-arrow-chevron-right {\n  transform: scaleX(-1);\n}\n.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar > ul > li, .k-pane-wrapper[dir=rtl] .k-scheduler-mobile .k-scheduler-toolbar > ul > li, [dir=rtl] .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar > ul > li {\n  border: 0;\n}\n.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar .k-nav-prev,\n.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar .k-nav-next, .k-pane-wrapper[dir=rtl] .k-scheduler-mobile .k-scheduler-toolbar .k-nav-prev,\n.k-pane-wrapper[dir=rtl] .k-scheduler-mobile .k-scheduler-toolbar .k-nav-next, [dir=rtl] .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar .k-nav-prev,\n[dir=rtl] .k-pane-wrapper .k-scheduler-mobile .k-scheduler-toolbar .k-nav-next {\n  transform: scaleX(-1);\n}\n.k-rtl .k-pane-wrapper .k-scheduler-mobile .k-task .k-i-reload, .k-pane-wrapper[dir=rtl] .k-scheduler-mobile .k-task .k-i-reload, [dir=rtl] .k-pane-wrapper .k-scheduler-mobile .k-task .k-i-reload {\n  margin-left: 0.5em;\n  margin-right: 0;\n}\n\n.k-pane-wrapper,\n.k-view {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n\n.k-pane-wrapper .k-pane > .k-view > .k-content {\n  background-position: 50% 50%;\n  background-color: #fafafa;\n}\n.k-pane-wrapper .k-pane .k-grid-mobile .k-column-active + th.k-header {\n  border-left-color: #424242;\n}\n.k-pane-wrapper .k-pane .k-grid-mobile .k-resize-handle-inner::before {\n  background-color: #fafafa;\n}\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-nav-current {\n  color: #ff6358;\n}\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendadate {\n  color: inherit;\n}\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-time-period,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-mobile-scheduler-agendaweekday {\n  color: #666666;\n}\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-times,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-wrap,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-datecolumn,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-groupcolumn,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-group-cell,\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-header-all-day {\n  background-color: #fafafa;\n}\n.k-pane-wrapper .k-pane .k-scheduler-mobile .k-scheduler-toolbar .k-scheduler-tools > li {\n  display: inline-block;\n  background-color: inherit;\n}\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-item,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-link,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-item,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-link,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-item,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-link,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-item,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-link {\n  color: #424242;\n}\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-clear,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-select-all,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-grid-edit-form .k-scheduler-resetSeries,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-clear,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-select-all,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-grid-header-menu .k-scheduler-resetSeries,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-clear,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-select-all,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-grid-filter-menu .k-scheduler-resetSeries,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-clear,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-select-all,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-delete,\n.k-pane-wrapper .k-pane .k-scheduler-edit-form .k-scheduler-resetSeries {\n  color: #ff6358;\n}\n.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-selected {\n  color: #ff6358;\n  background: none;\n}\n.k-pane-wrapper .k-pane .k-column-menu .k-listgroup-item.k-selected .k-link {\n  color: inherit;\n}\n\n.k-progressbar {\n  border-radius: 4px;\n  --kendo-progressbar-progress: 0;\n  border-width: 0px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 12px;\n  line-height: 1;\n  display: inline-grid;\n  vertical-align: middle;\n  position: relative;\n  overflow: hidden;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-progressbar *,\n.k-progressbar *::before,\n.k-progressbar *::after {\n  box-sizing: border-box;\n}\n.k-progressbar > .k-selected {\n  border-width: 0;\n  border-style: solid;\n  display: flex;\n  overflow: hidden;\n  grid-column: 1/-1;\n  grid-row: 1/-1;\n}\n.k-progressbar > ul {\n  border-width: inherit;\n  border-style: inherit;\n  white-space: nowrap;\n  display: flex;\n  align-items: stretch;\n  flex: 1;\n  grid-column: 1/-1;\n  grid-row: 1/-1;\n}\n.k-progressbar .k-item {\n  display: block;\n  border-width: 0;\n  border-style: solid;\n  border-color: transparent;\n}\n\n.k-progress-status-wrap {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  grid-column: 1/-1;\n  grid-row: 1/-1;\n}\n.k-progress-status-wrap.k-progress-start {\n  justify-content: flex-start;\n}\n.k-progress-status-wrap.k-progress-center {\n  justify-content: center;\n}\n.k-progress-status-wrap.k-progress-end {\n  justify-content: flex-end;\n}\n\n.k-progress-status {\n  padding: 0 0.5em;\n  padding-block-start: 0;\n  padding-block-end: 0;\n  padding-inline-start: 0.5em;\n  padding-inline-end: 0.5em;\n  min-width: 10px;\n  text-align: center;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.k-progressbar-horizontal {\n  width: 100%;\n  height: 22px;\n  grid-template-columns: 1fr;\n  grid-template-rows: 100%;\n}\n.k-progressbar-horizontal .k-progress-status-wrap {\n  flex-direction: row;\n}\n.k-progressbar-horizontal > .k-selected {\n  width: 0;\n  width: calc(var(--kendo-progressbar-progress, 0) * 1%);\n  flex-direction: row;\n}\n.k-progressbar-horizontal > .k-selected > .k-progress-status-wrap {\n  width: calc(100% * 100 / var(--kendo-progressbar-progress, 1));\n}\n.k-progressbar-horizontal > ul {\n  flex-direction: row;\n}\n.k-progressbar-horizontal .k-item + .k-item {\n  border-left-width: 1px;\n  border-inline-start-width: 1px;\n  border-inline-end-width: 0;\n}\n.k-progressbar-horizontal.k-progressbar-reverse > .k-selected {\n  flex-direction: row-reverse;\n  justify-self: flex-end;\n}\n\n.k-progressbar-vertical {\n  width: 22px;\n  height: 27em;\n  grid-template-columns: 100%;\n  grid-template-rows: 1fr;\n}\n.k-progressbar-vertical .k-progress-status-wrap {\n  flex-direction: column-reverse;\n}\n.k-progressbar-vertical .k-progress-status {\n  writing-mode: vertical-lr;\n}\n.k-progressbar-vertical > .k-selected {\n  height: 0;\n  height: calc(var(--kendo-progressbar-progress, 0) * 1%);\n  flex-direction: column-reverse;\n  align-self: flex-end;\n  align-items: flex-end;\n}\n.k-progressbar-vertical > .k-selected > .k-progress-status-wrap {\n  height: calc(100% * 100 / var(--kendo-progressbar-progress, 1));\n}\n.k-progressbar-vertical > ul {\n  flex-direction: column;\n}\n.k-progressbar-vertical .k-item + .k-item {\n  border-top-width: 1px;\n  border-block-start-width: 1px;\n  border-block-end-width: 0;\n}\n.k-progressbar-vertical.k-progressbar-reverse {\n  flex-direction: column;\n}\n.k-progressbar-vertical.k-progressbar-reverse > .k-selected {\n  flex-direction: column;\n  align-self: flex-start;\n}\n\n.k-progressbar-indeterminate .k-progress-status-wrap,\n.k-progressbar-indeterminate .k-selected,\n.k-progressbar-indeterminate .k-item {\n  display: none;\n}\n\n.telerik-blazor.k-progressbar-horizontal > .k-selected,\n.telerik-blazor.k-progressbar-horizontal > .k-selected > .k-progress-status-wrap {\n  transition: width 0.1s ease-in-out;\n}\n\n.k-rtl .k-progressbar,\n.k-progressbar[dir=rtl] {\n  direction: rtl;\n}\n\n.k-progressbar {\n  display: -ms-inline-grid;\n}\n.k-progressbar > .k-progress-status-wrap,\n.k-progressbar > .k-selected {\n  -ms-grid-column: 1;\n  -ms-grid-row: 1;\n}\n\n.k-progressbar-horizontal {\n  -ms-grid-columns: 1fr;\n  -ms-grid-rows: 22px;\n}\n.k-progressbar-horizontal.k-progressbar-reverse > .k-selected {\n  -ms-grid-column-align: end;\n}\n\n.k-progressbar-vertical {\n  -ms-grid-columns: 22px;\n  -ms-grid-rows: 1fr;\n}\n.k-progressbar-vertical > .k-selected {\n  -ms-grid-row-align: end;\n}\n.k-progressbar-vertical.k-progressbar-reverse > .k-selected {\n  -ms-grid-row-align: start;\n}\n\n.k-circular-progressbar {\n  display: inline-block;\n  text-align: left;\n  position: relative;\n}\n\n.k-circular-progressbar-surface {\n  height: 100%;\n}\n.k-circular-progressbar-surface > div {\n  width: 100%;\n  height: 100%;\n}\n.k-circular-progressbar-surface svg {\n  width: 100%;\n  height: 100%;\n}\n\n.k-circular-progressbar-scale {\n  fill: none;\n}\n\n.k-circular-progressbar-arc {\n  transform-box: fill-box;\n  transform-origin: center center;\n  transform: rotate(-90deg);\n  stroke-linecap: round;\n  fill: none;\n}\n\n.k-circular-progressbar-label {\n  position: absolute;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n}\n\n@keyframes progressbar-indeterminate-animation {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 22px 0;\n  }\n}\n.k-progressbar {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ebebeb;\n}\n.k-progressbar .k-selected {\n  border-color: #eb5b51;\n  color: white;\n  background-color: #ff6358;\n}\n.k-progressbar .k-item {\n  border-color: #ffffff;\n}\n\n.k-progressbar-indeterminate {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ebebeb;\n  background-image: linear-gradient(45deg, #d8d8d8 25%, transparent 25%, transparent 50%, #d8d8d8 50%, #d8d8d8 75%, transparent 75%, transparent);\n  background-size: 22px 22px;\n  animation: progressbar-indeterminate-animation 1s linear infinite;\n}\n\n.k-circular-progressbar-scale {\n  stroke: #ebebeb;\n}\n\n.k-circular-progressbar-arc {\n  stroke: #ff6358;\n  transition: stroke 0.5s ease;\n}\n\n.k-actions, .k-form-buttons, .k-edit-buttons,\n.k-action-buttons,\n.k-columnmenu-actions {\n  padding: 8px 8px;\n  box-sizing: border-box;\n  border-width: 0px 0 0 0;\n  border-style: solid;\n  border-color: inherit;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 8px;\n  overflow: hidden;\n  clear: both;\n}\n.k-actions *, .k-form-buttons *, .k-edit-buttons *,\n.k-action-buttons *,\n.k-columnmenu-actions *,\n.k-actions *::before,\n.k-form-buttons *::before,\n.k-edit-buttons *::before,\n.k-action-buttons *::before,\n.k-columnmenu-actions *::before,\n.k-actions *::after,\n.k-form-buttons *::after,\n.k-edit-buttons *::after,\n.k-action-buttons *::after,\n.k-columnmenu-actions *::after {\n  box-sizing: border-box;\n}\n\n.k-popup .k-actions, .k-popup .k-form-buttons, .k-popup .k-edit-buttons,\n.k-popup .k-action-buttons,\n.k-popup .k-columnmenu-actions {\n  margin-top: 16px;\n}\n\n.k-ie .k-actions .k-button ~ .k-button, .k-ie .k-form-buttons .k-button ~ .k-button, .k-ie .k-edit-buttons .k-button ~ .k-button,\n.k-ie .k-action-buttons .k-button ~ .k-button,\n.k-ie .k-columnmenu-actions .k-button ~ .k-button {\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n.k-rtl .k-ie .k-actions .k-button ~ .k-button, .k-rtl .k-ie .k-form-buttons .k-button ~ .k-button, .k-rtl .k-ie .k-edit-buttons .k-button ~ .k-button,\n.k-rtl .k-ie .k-action-buttons .k-button ~ .k-button,\n.k-rtl .k-ie .k-columnmenu-actions .k-button ~ .k-button, [dir=rtl] .k-ie .k-actions .k-button ~ .k-button, [dir=rtl] .k-ie .k-form-buttons .k-button ~ .k-button, [dir=rtl] .k-ie .k-edit-buttons .k-button ~ .k-button,\n[dir=rtl] .k-ie .k-action-buttons .k-button ~ .k-button,\n[dir=rtl] .k-ie .k-columnmenu-actions .k-button ~ .k-button {\n  margin-left: 0;\n  margin-right: 8px;\n}\n\n.k-actions-start {\n  justify-content: flex-start;\n}\n\n.k-actions-center {\n  justify-content: center;\n}\n\n.k-actions-end {\n  justify-content: flex-end;\n}\n\n.k-actions-stretched > * {\n  flex: 1 0 0%;\n}\n\n.k-actions-horizontal {\n  width: 100%;\n  flex-flow: row nowrap;\n}\n\n.k-actions-vertical {\n  flex-flow: column nowrap;\n}\n\n.k-input,\n.k-picker {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  border-width: 1px;\n  border-style: solid;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  font-weight: normal;\n  text-align: start;\n  box-shadow: none;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  vertical-align: middle;\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-appearance: none;\n}\n.k-input *,\n.k-input *::before,\n.k-input *::after,\n.k-picker *,\n.k-picker *::before,\n.k-picker *::after {\n  box-sizing: border-box;\n}\n.k-input .k-input,\n.k-input .k-picker,\n.k-picker .k-input,\n.k-picker .k-picker {\n  border-width: 0 !important;\n  color: inherit;\n  background: none;\n  font: inherit;\n  outline: 0;\n  box-shadow: none;\n}\n.k-input > *,\n.k-picker > * {\n  margin: 0;\n}\n.k-input::placeholder,\n.k-picker::placeholder {\n  color: #666666;\n  opacity: 1;\n  user-select: none;\n}\n.k-input:-ms-input-placeholder,\n.k-picker:-ms-input-placeholder {\n  color: #666666;\n}\n\ninput.k-input,\ntextarea.k-textarea {\n  padding: 4px 8px;\n}\ninput.k-input:disabled, input.k-input[disabled],\ntextarea.k-textarea:disabled,\ntextarea.k-textarea[disabled] {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n[disabled] input.k-input:disabled, .k-disabled input.k-input:disabled, [disabled] input.k-input[disabled], .k-disabled input.k-input[disabled],\n[disabled] textarea.k-textarea:disabled,\n.k-disabled textarea.k-textarea:disabled,\n[disabled] textarea.k-textarea[disabled],\n.k-disabled textarea.k-textarea[disabled] {\n  opacity: 1;\n  filter: grayscale(0);\n}\n\n.k-picker {\n  cursor: pointer;\n}\n\nselect.k-picker {\n  padding: 4px 8px;\n  appearance: auto;\n}\nselect.k-picker:disabled, select.k-picker[disabled] {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n[disabled] select.k-picker:disabled, .k-disabled select.k-picker:disabled, [disabled] select.k-picker[disabled], .k-disabled select.k-picker[disabled] {\n  opacity: 1;\n  filter: grayscale(0);\n}\n\n.k-input-inner {\n  padding: 4px 8px;\n  width: 100%;\n  border: 0;\n  outline: 0;\n  color: inherit;\n  background: none;\n  font: inherit;\n  flex: 1;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-appearance: none;\n}\n.k-input-inner::-ms-clear {\n  display: none;\n}\n.k-input-inner::placeholder {\n  color: #666666;\n  opacity: 1;\n  user-select: none;\n}\n.k-input-inner:-ms-input-placeholder {\n  color: #666666;\n}\n.k-input-inner:invalid {\n  box-shadow: none;\n}\n\nspan.k-input-inner {\n  white-space: nowrap;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n}\n\ntextarea.k-input-inner {\n  margin: 0;\n}\n\n.k-input-value-icon {\n  flex: none;\n}\n\n.k-input-value-text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.k-input-value-text::before {\n  content: \"​\";\n  width: 0px;\n  overflow: hidden;\n  flex: none;\n  display: inline-block;\n  vertical-align: top;\n}\n\n.k-input-values {\n  width: 100%;\n  padding: 2px 2px;\n  cursor: text;\n}\n\n.k-input-values > .k-searchbar,\n.k-input-values > .k-input-inner {\n  margin: -2px -2px;\n}\n\n.k-icon-picker .k-input-inner {\n  padding: 4px;\n  justify-content: center;\n}\n\n.k-input-prefix,\n.k-input-suffix {\n  border-color: inherit;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  flex: none;\n}\n.k-input-prefix > *,\n.k-input-suffix > * {\n  flex-shrink: 0;\n}\n\n.k-input-separator {\n  margin: 0;\n  width: 0;\n  height: 16px;\n  border-width: 0 0 0 1px;\n  border-style: solid;\n  border-color: inherit;\n  align-self: center;\n}\n\n.k-input-icon,\n.k-input-validation-icon,\n.k-input-loading-icon,\n.k-input-prefix > .k-icon,\n.k-input-suffix > .k-icon {\n  flex: none;\n  align-self: center;\n  display: inline-flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.k-clear-value {\n  outline: 0;\n  flex: none;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  opacity: 0.5;\n}\n\n.k-clear-value:hover,\n.k-clear-value.k-hover {\n  opacity: 1;\n}\n\n.k-clear-value:focus-visible {\n  outline: 1px dotted;\n  outline-offset: -1px;\n}\n\n.k-input-button {\n  width: calc( 1.4285714286em + 8px );\n  border-width: 0;\n  border-inline-start-width: 1px;\n  flex: none;\n  aspect-ratio: auto;\n  box-shadow: none;\n}\n.k-input-button > .k-button-icon {\n  min-width: auto !important;\n}\n.k-input-button:focus {\n  box-shadow: none;\n}\n\n.k-picker .k-input-button {\n  color: inherit;\n  background: none;\n  border-color: transparent;\n}\n\n.k-input-spinner {\n  width: calc( 1.4285714286em + 8px );\n  flex: none;\n  display: flex;\n  flex-flow: column nowrap;\n}\n.k-input-spinner .k-spinner-increase,\n.k-input-spinner .k-spinner-decrease {\n  border-width: 0;\n  border-inline-start-width: 1px;\n  flex: 1 1 50%;\n  box-shadow: none;\n  position: relative;\n  aspect-ratio: auto;\n}\n.k-input-spinner .k-spinner-increase > .k-button-icon,\n.k-input-spinner .k-spinner-decrease > .k-button-icon {\n  margin: -1em 0;\n  min-width: auto !important;\n  min-height: auto !important;\n}\n.k-input-spinner .k-spinner-increase .k-icon {\n  bottom: auto;\n}\n.k-input-spinner .k-spinner-decrease .k-icon {\n  top: auto;\n}\n\n.k-searchbar {\n  flex: 1 1 auto;\n  display: flex;\n  flex-flow: row nowrap;\n}\n\n.k-picker-wrap,\n.k-dropdown-wrap,\n.k-dateinput-wrap,\n.k-multiselect-wrap,\n.k-numeric-wrap {\n  width: 100%;\n  border-width: 0;\n  border-color: inherit;\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  display: flex;\n  flex-flow: row nowrap;\n  overflow: hidden;\n  position: relative;\n}\n\n.k-input-flat,\n.k-picker-flat {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n  border-width: 1px 0;\n  border-top-color: transparent !important;\n  background-image: none !important;\n}\n\n.k-input-outline {\n  background: none !important;\n}\n\n.k-input-sm,\n.k-picker-sm {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-input-sm .k-input-values,\n.k-picker-sm .k-input-values {\n  width: 100%;\n  padding: 1px;\n  gap: 1px;\n  cursor: text;\n}\n.k-input-sm .k-input-values > .k-searchbar,\n.k-input-sm .k-input-values > .k-input-inner,\n.k-picker-sm .k-input-values > .k-searchbar,\n.k-picker-sm .k-input-values > .k-input-inner {\n  margin: -1px;\n}\n.k-input-sm .k-input-inner,\n.k-picker-sm .k-input-inner {\n  padding: 2px 8px;\n}\n.k-input-sm .k-input-button,\n.k-input-sm .k-spinner-increase,\n.k-input-sm .k-spinner-decrease,\n.k-picker-sm .k-input-button,\n.k-picker-sm .k-spinner-increase,\n.k-picker-sm .k-spinner-decrease {\n  padding: 2px 2px;\n}\n.k-input-sm .k-input-icon,\n.k-input-sm .k-input-validation-icon,\n.k-input-sm .k-input-loading-icon,\n.k-input-sm .k-clear-value,\n.k-input-sm .k-input-prefix > .k-icon,\n.k-input-sm .k-input-suffix > .k-icon,\n.k-picker-sm .k-input-icon,\n.k-picker-sm .k-input-validation-icon,\n.k-picker-sm .k-input-loading-icon,\n.k-picker-sm .k-clear-value,\n.k-picker-sm .k-input-prefix > .k-icon,\n.k-picker-sm .k-input-suffix > .k-icon {\n  width: calc( 16px + 4px );\n  height: calc( 16px + 4px );\n}\n.k-input-sm.k-icon-picker .k-input-inner,\n.k-picker-sm.k-icon-picker .k-input-inner {\n  width: calc( 1.4285714286em );\n  height: calc( 1.4285714286em );\n  padding: 2px;\n  box-sizing: content-box;\n}\n\n.k-dropdown-operator.k-picker-sm .k-input-button {\n  padding: 2px;\n}\n\n.k-input-md,\n.k-picker-md {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-input-md .k-input-values,\n.k-picker-md .k-input-values {\n  width: 100%;\n  padding: 2px;\n  gap: 2px;\n  cursor: text;\n}\n.k-input-md .k-input-values > .k-searchbar,\n.k-input-md .k-input-values > .k-input-inner,\n.k-picker-md .k-input-values > .k-searchbar,\n.k-picker-md .k-input-values > .k-input-inner {\n  margin: -2px;\n}\n.k-input-md .k-input-inner,\n.k-picker-md .k-input-inner {\n  padding: 4px 8px;\n}\n.k-input-md .k-input-button,\n.k-input-md .k-spinner-increase,\n.k-input-md .k-spinner-decrease,\n.k-picker-md .k-input-button,\n.k-picker-md .k-spinner-increase,\n.k-picker-md .k-spinner-decrease {\n  padding: 4px 4px;\n}\n.k-input-md .k-input-icon,\n.k-input-md .k-input-validation-icon,\n.k-input-md .k-input-loading-icon,\n.k-input-md .k-clear-value,\n.k-input-md .k-input-prefix > .k-icon,\n.k-input-md .k-input-suffix > .k-icon,\n.k-picker-md .k-input-icon,\n.k-picker-md .k-input-validation-icon,\n.k-picker-md .k-input-loading-icon,\n.k-picker-md .k-clear-value,\n.k-picker-md .k-input-prefix > .k-icon,\n.k-picker-md .k-input-suffix > .k-icon {\n  width: calc( 16px + 8px );\n  height: calc( 16px + 8px );\n}\n.k-input-md.k-icon-picker .k-input-inner,\n.k-picker-md.k-icon-picker .k-input-inner {\n  width: calc( 1.4285714286em );\n  height: calc( 1.4285714286em );\n  padding: 4px;\n  box-sizing: content-box;\n}\n\n.k-dropdown-operator.k-picker-md .k-input-button {\n  padding: 4px;\n}\n\n.k-input-lg,\n.k-picker-lg {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.k-input-lg .k-input-values,\n.k-picker-lg .k-input-values {\n  width: 100%;\n  padding: 4px;\n  gap: 4px;\n  cursor: text;\n}\n.k-input-lg .k-input-values > .k-searchbar,\n.k-input-lg .k-input-values > .k-input-inner,\n.k-picker-lg .k-input-values > .k-searchbar,\n.k-picker-lg .k-input-values > .k-input-inner {\n  margin: -4px;\n}\n.k-input-lg .k-input-inner,\n.k-picker-lg .k-input-inner {\n  padding: 8px 12px;\n}\n.k-input-lg .k-input-button,\n.k-input-lg .k-spinner-increase,\n.k-input-lg .k-spinner-decrease,\n.k-picker-lg .k-input-button,\n.k-picker-lg .k-spinner-increase,\n.k-picker-lg .k-spinner-decrease {\n  padding: 8px 8px;\n}\n.k-input-lg .k-input-icon,\n.k-input-lg .k-input-validation-icon,\n.k-input-lg .k-input-loading-icon,\n.k-input-lg .k-clear-value,\n.k-input-lg .k-input-prefix > .k-icon,\n.k-input-lg .k-input-suffix > .k-icon,\n.k-picker-lg .k-input-icon,\n.k-picker-lg .k-input-validation-icon,\n.k-picker-lg .k-input-loading-icon,\n.k-picker-lg .k-clear-value,\n.k-picker-lg .k-input-prefix > .k-icon,\n.k-picker-lg .k-input-suffix > .k-icon {\n  width: calc( 16px + 16px );\n  height: calc( 16px + 16px );\n}\n.k-input-lg.k-icon-picker .k-input-inner,\n.k-picker-lg.k-icon-picker .k-input-inner {\n  width: calc( 1.5em );\n  height: calc( 1.5em );\n  padding: 8px;\n  box-sizing: content-box;\n}\n\n.k-dropdown-operator.k-picker-lg .k-input-button {\n  padding: 8px;\n}\n\n.k-input > kendo-popup,\n.k-picker > kendo-popup {\n  position: fixed;\n}\n\n@keyframes autoFillStart {}\n@keyframes autoFillEnd {}\n.k-autofill:-webkit-autofill {\n  animation-name: autoFillStart;\n}\n\n.k-autofill:not(:-webkit-autofill) {\n  animation-name: autoFillEnd;\n}\n\n.k-input:-webkit-autofill {\n  animation-name: autoFillStart;\n}\n\n.k-input:not(:-webkit-autofill) {\n  animation-name: autoFillEnd;\n}\n\n.k-input-solid {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-input-solid:hover, .k-input-solid.k-hover {\n  border-color: rgba(0, 0, 0, 0.16);\n}\n.k-input-solid:focus, .k-input-solid.k-focus {\n  border-color: rgba(0, 0, 0, 0.16);\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-input-solid:focus-within {\n  border-color: rgba(0, 0, 0, 0.16);\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-input-solid.k-invalid, .k-input-solid.ng-invalid.ng-touched, .k-input-solid.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n.k-input-solid.k-invalid .k-input-validation-icon, .k-input-solid.ng-invalid.ng-touched .k-input-validation-icon, .k-input-solid.ng-invalid.ng-dirty .k-input-validation-icon {\n  color: #f31700;\n}\n.k-picker-solid {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #f5f5f5;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.02));\n}\n.k-picker-solid:hover, .k-picker-solid.k-hover {\n  background-color: #ebebeb;\n}\n.k-picker-solid:focus, .k-picker-solid.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-picker-solid:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-picker-solid.k-invalid, .k-picker-solid.ng-invalid.ng-touched, .k-picker-solid.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n.k-picker-solid.k-invalid .k-input-validation-icon, .k-picker-solid.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-solid.ng-invalid.ng-dirty .k-input-validation-icon {\n  color: #f31700;\n}\n.k-input-outline {\n  border-color: rgba(66, 66, 66, 0.5);\n  color: #424242;\n}\n.k-input-outline > .k-input-button {\n  border-color: inherit;\n}\n.k-input-outline > .k-input-spinner {\n  border-color: inherit;\n}\n.k-input-outline > .k-input-spinner > .k-spinner-increase, .k-input-outline > .k-input-spinner > .k-spinner-decrease {\n  border-color: inherit;\n}\n.k-input-outline:hover, .k-input-outline.k-hover {\n  border-color: rgba(66, 66, 66, 0.8);\n}\n.k-input-outline:focus, .k-input-outline.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-input-outline:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-input-outline.k-invalid, .k-input-outline.ng-invalid.ng-touched, .k-input-outline.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n.k-input-outline.k-invalid .k-input-validation-icon, .k-input-outline.ng-invalid.ng-touched .k-input-validation-icon, .k-input-outline.ng-invalid.ng-dirty .k-input-validation-icon {\n  color: #f31700;\n}\n.k-picker-outline {\n  border-color: rgba(66, 66, 66, 0.5);\n  color: #424242;\n}\n.k-picker-outline:hover, .k-picker-outline.k-hover {\n  border-color: #424242;\n  color: white;\n  background-color: #424242;\n}\n.k-picker-outline:focus, .k-picker-outline.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-picker-outline:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-picker-outline.k-invalid, .k-picker-outline.ng-invalid.ng-touched, .k-picker-outline.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n.k-picker-outline.k-invalid .k-input-validation-icon, .k-picker-outline.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-outline.ng-invalid.ng-dirty .k-input-validation-icon {\n  color: #f31700;\n}\n.k-input-flat {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n}\n.k-input-flat:hover, .k-input-flat.k-hover {\n  border-color: rgba(0, 0, 0, 0.16);\n}\n.k-input-flat:focus, .k-input-flat.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-input-flat:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-input-flat.k-invalid, .k-input-flat.ng-invalid.ng-touched, .k-input-flat.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n.k-input-flat.k-invalid .k-input-validation-icon, .k-input-flat.ng-invalid.ng-touched .k-input-validation-icon, .k-input-flat.ng-invalid.ng-dirty .k-input-validation-icon {\n  color: #f31700;\n}\n.k-picker-flat {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n}\n.k-picker-flat:hover, .k-picker-flat.k-hover {\n  border-color: rgba(0, 0, 0, 0.16);\n  background-color: rgba(66, 66, 66, 0.04);\n}\n.k-picker-flat:focus, .k-picker-flat.k-focus {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-picker-flat:focus-within {\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-picker-flat.k-invalid, .k-picker-flat.ng-invalid.ng-touched, .k-picker-flat.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n.k-picker-flat.k-invalid .k-input-validation-icon, .k-picker-flat.ng-invalid.ng-touched .k-input-validation-icon, .k-picker-flat.ng-invalid.ng-dirty .k-input-validation-icon {\n  color: #f31700;\n}\n.k-floating-label-container {\n  padding-top: calc( 1.4285714286 * 14px );\n  box-sizing: border-box;\n  display: inline-flex;\n  vertical-align: middle;\n  position: relative;\n  flex-direction: column;\n  justify-content: stretch;\n}\n.k-floating-label-container *,\n.k-floating-label-container *::before,\n.k-floating-label-container *::after {\n  box-sizing: border-box;\n}\n.k-floating-label-container > .k-label {\n  max-width: 90%;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: absolute;\n  top: calc( calc( 1.4285714286 * 14px ) + 1px + 4px );\n  left: calc( 8px + 1px );\n  overflow: hidden;\n  cursor: text;\n  transform-origin: left center;\n  transition: transform 0.2s ease-out, color 0.2s ease-out, top 0.2s ease-out, left 0.2s ease-out;\n}\n.k-floating-label-container > .k-widget {\n  flex: 1 1 auto;\n  width: auto;\n}\n.k-floating-label-container.k-empty > .k-label {\n  top: calc( calc( 1.4285714286 * 14px ) + 1px + 4px );\n  left: calc( 8px + 1px );\n  transform: scale(1);\n  pointer-events: none;\n}\n.k-floating-label-container > .k-label, .k-floating-label-container.k-focus > .k-label {\n  top: 0;\n  left: 0;\n  transform: scale(1);\n}\n.k-floating-label-container:focus-within > .k-label {\n  top: 0;\n  left: 0;\n  transform: scale(1);\n}\n.k-floating-label-container.k-empty:not(.k-focus):not(:focus-within) ::placeholder {\n  color: transparent;\n}\n[dir=rtl] .k-floating-label-container > .k-label, .k-rtl .k-floating-label-container > .k-label, .k-floating-label-container[dir=rtl] > .k-label {\n  transform-origin: right center;\n  transition: transform 0.2s ease-out, color 0.2s ease-out, top 0.2s ease-out, right 0.2s ease-out;\n}\n[dir=rtl] .k-floating-label-container.k-empty > .k-label, .k-rtl .k-floating-label-container.k-empty > .k-label, .k-floating-label-container[dir=rtl].k-empty > .k-label {\n  left: auto;\n  right: calc( 8px + 1px );\n}\n[dir=rtl] .k-floating-label-container > .k-label, [dir=rtl] .k-floating-label-container.k-focus > .k-label, .k-rtl .k-floating-label-container > .k-label, .k-rtl .k-floating-label-container.k-focus > .k-label, .k-floating-label-container[dir=rtl] > .k-label, .k-floating-label-container[dir=rtl].k-focus > .k-label {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .k-floating-label-container:focus-within > .k-label, .k-rtl .k-floating-label-container:focus-within > .k-label, .k-floating-label-container[dir=rtl]:focus-within > .k-label {\n  left: auto;\n  right: 0;\n}\n\n.k-tooltip {\n  border-radius: 4px;\n  margin: 0;\n  padding: 4px 8px;\n  border-width: 0px;\n  border-style: solid;\n  box-sizing: border-box;\n  background-repeat: repeat-x;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.25;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n  position: absolute;\n  z-index: 12000;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-tooltip *,\n.k-tooltip *::before,\n.k-tooltip *::after {\n  box-sizing: border-box;\n}\n\n.k-tooltip-icon {\n  margin-inline-end: 4px;\n  flex-shrink: 0;\n}\n\n.k-tooltip-title {\n  margin-bottom: 0.25em;\n  font-size: 17.5px;\n  line-height: 1;\n}\n\n.k-tooltip-content {\n  align-self: stretch;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.k-tooltip-button {\n  margin-inline-start: 4px;\n  flex-shrink: 0;\n}\n.k-tooltip-button .k-icon {\n  color: inherit;\n  vertical-align: top;\n}\n\n.k-callout {\n  width: 12px;\n  height: 12px;\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent;\n  position: absolute;\n  pointer-events: none;\n}\n\n.k-callout-n {\n  margin-left: -6px;\n  border-bottom-color: currentColor;\n  top: -12px;\n  left: 50%;\n  pointer-events: none;\n}\n\n.k-callout-e {\n  margin-top: -6px;\n  border-left-color: currentColor;\n  top: 50%;\n  right: -12px;\n  pointer-events: none;\n}\n\n.k-callout-s {\n  margin-left: -6px;\n  border-top-color: currentColor;\n  bottom: -12px;\n  left: 50%;\n  pointer-events: none;\n}\n\n.k-callout-w {\n  margin-top: -6px;\n  border-right-color: currentColor;\n  top: 50%;\n  left: -12px;\n  pointer-events: none;\n}\n\n.k-tooltip-wrapper .k-tooltip {\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);\n}\n\n.k-tooltip {\n  border-color: rgba(0, 0, 0, 0.75);\n  color: white;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n.k-tooltip .k-callout {\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.k-tooltip-primary {\n  border-color: #ff6358;\n  color: white;\n  background-color: #ff6358;\n}\n.k-tooltip-primary .k-callout {\n  color: #ff6358;\n}\n\n.k-tooltip-info {\n  border-color: #0058e9;\n  color: white;\n  background-color: #0058e9;\n}\n.k-tooltip-info .k-callout {\n  color: #0058e9;\n}\n\n.k-tooltip-success {\n  border-color: #37b400;\n  color: white;\n  background-color: #37b400;\n}\n.k-tooltip-success .k-callout {\n  color: #37b400;\n}\n\n.k-tooltip-warning {\n  border-color: #ffc000;\n  color: black;\n  background-color: #ffc000;\n}\n.k-tooltip-warning .k-callout {\n  color: #ffc000;\n}\n\n.k-tooltip-error {\n  border-color: #f31700;\n  color: white;\n  background-color: #f31700;\n}\n.k-tooltip-error .k-callout {\n  color: #f31700;\n}\n\n.k-validator-tooltip {\n  margin-top: calc( 6px + 0px );\n  width: auto;\n  white-space: normal;\n  display: flex;\n  align-items: center;\n  z-index: 9999;\n}\n\n.k-grid .k-validator-tooltip {\n  max-width: 300px;\n}\n\n.k-calendar {\n  inline-size: var(--INTERNAL--kendo-calendar-width, min-content);\n  block-size: var(--INTERNAL--kendo-calendar-height, min-content);\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  position: relative;\n  overflow: hidden;\n  display: inline-flex;\n  flex-flow: column nowrap;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-calendar > .k-calendar {\n  border: 0;\n}\n\n.k-calendar-table {\n  margin: 0 auto;\n  border-width: 0;\n  border-color: inherit;\n  border-spacing: 0;\n  border-collapse: separate;\n  table-layout: fixed;\n  text-align: center;\n  outline: 0;\n  display: table;\n  position: relative;\n  z-index: 1;\n}\n\n.k-calendar-caption,\n.k-calendar-caption.k-calendar-th,\n.k-calendar .k-meta-header,\n.k-calendar .k-month-header {\n  padding: 4px 8px;\n  height: 32px;\n  box-sizing: border-box;\n  text-transform: none;\n  text-align: left;\n  font-weight: bold;\n  cursor: default;\n}\n\n.k-calendar-th,\n.k-calendar-td {\n  border-width: 0;\n  padding: 0;\n  text-align: center;\n  border-style: solid;\n  border-color: inherit;\n  font-weight: normal;\n  cursor: default;\n}\n\n.k-calendar-th {\n  width: 32px;\n  height: 32px;\n  font-size: 12px;\n  line-height: 2;\n  text-transform: uppercase;\n}\n\n.k-calendar-td {\n  border-radius: 4px;\n  inline-size: var(--INTERNAL--kendo-calendar-cell-size, min-content);\n  block-size: var(--INTERNAL--kendo-calendar-cell-size, min-content);\n  border-color: transparent;\n}\n\n.k-calendar .k-calendar-cell-inner, .k-calendar .k-link {\n  border-radius: 4px;\n  padding: 0.25em 0.25em;\n  padding-inline: var(--INTERNAL--kendo-calendar-cell-padding-x, 0.25em);\n  padding-block: var(--INTERNAL--kendo-calendar-cell-padding-y, 0.25em);\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  white-space: normal;\n  position: relative;\n  overflow: hidden;\n}\n\n.k-calendar .k-header {\n  padding: 4px 4px;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  display: flex;\n  flex-flow: row nowrap;\n  gap: 4px;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.k-calendar-header {\n  padding: 4px 4px;\n  min-width: 256px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 0 auto;\n}\n.k-calendar-header .k-title,\n.k-calendar-header .k-calendar-title {\n  font-weight: bold;\n}\n.k-calendar-header .k-today,\n.k-calendar-header .k-nav-today,\n.k-calendar-header .k-calendar-nav-today {\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n}\n.k-calendar-header .k-calendar-nav {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 4px;\n}\n\n.k-calendar-footer,\n.k-calendar .k-footer {\n  padding: 8px 16px;\n  text-align: center;\n  clear: both;\n}\n\n.k-calendar-view {\n  margin: auto;\n  padding: 0 4px;\n  width: 256px;\n  inline-size: var(--INTERNAL--kendo-calendar-view-width, 256px);\n  min-height: 224px;\n  box-sizing: content-box;\n  gap: 16px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.k-month-calendar .k-calendar-td,\n.k-calendar-monthview .k-calendar-td {\n  width: 32px;\n  height: 32px;\n  inline-size: var(--INTERNAL--kendo-calendar-cell-size, 32px);\n  block-size: var(--INTERNAL--kendo-calendar-cell-size, 32px);\n}\n\n.k-year-calendar .k-calendar-td,\n.k-calendar-yearview .k-calendar-td {\n  width: 64px;\n  height: 64px;\n  inline-size: var(--INTERNAL--kendo-calendar-cell-size, 64px);\n  block-size: var(--INTERNAL--kendo-calendar-cell-size, 64px);\n}\n\n.k-decade-calendar .k-calendar-td,\n.k-calendar-decadeview .k-calendar-td {\n  width: 64px;\n  height: 64px;\n  inline-size: var(--INTERNAL--kendo-calendar-cell-size, 64px);\n  block-size: var(--INTERNAL--kendo-calendar-cell-size, 64px);\n}\n\n.k-century-calendar .k-calendar-td,\n.k-calendar-centuryview .k-calendar-td {\n  width: 64px;\n  height: 64px;\n  inline-size: var(--INTERNAL--kendo-calendar-cell-size, 64px);\n  block-size: var(--INTERNAL--kendo-calendar-cell-size, 64px);\n}\n.k-century-calendar .k-calendar-cell-inner, .k-century-calendar .k-link,\n.k-calendar-centuryview .k-calendar-cell-inner,\n.k-calendar-centuryview .k-link {\n  text-align: left;\n}\n\n.k-popup .k-calendar {\n  height: 100%;\n}\n\n.k-calendar-container,\n.k-datetime-container {\n  padding: 0;\n}\n.k-calendar-container .k-calendar,\n.k-datetime-container .k-calendar {\n  border-width: 0;\n}\n\n.k-calendar .k-content.k-scrollable,\n.k-calendar .k-calendar-content.k-scrollable {\n  box-sizing: content-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: block;\n  padding-right: 100px;\n  padding-left: 100px;\n  margin-left: -100px;\n  margin-right: calc( -100px - var(--kendo-scrollbar-width, 17px) );\n}\n\n.k-calendar .k-scrollable-placeholder {\n  position: absolute;\n  z-index: -1;\n  width: 1px;\n  top: 0;\n  right: 0;\n}\n\n.k-calendar-sm {\n  --INTERNAL--kendo-calendar-view-width: 224px;\n  --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-sm-cell-padding-x, 2px );\n  --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-sm-cell-padding-y, 2px );\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-calendar-sm.k-month-calendar,\n.k-calendar-sm .k-calendar-monthview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-month-cell-size, 28px );\n}\n.k-calendar-sm.k-year-calendar,\n.k-calendar-sm .k-calendar-yearview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-year-cell-size, 56px );\n}\n.k-calendar-sm.k-decade-calendar,\n.k-calendar-sm .k-calendar-decadeview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-decade-cell-size, 56px );\n}\n.k-calendar-sm.k-century-calendar,\n.k-calendar-sm .k-calendar-centuryview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-sm-century-cell-size, 56px );\n}\n\n.k-calendar-md {\n  --INTERNAL--kendo-calendar-view-width: 256px;\n  --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-md-cell-padding-x, 4px );\n  --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-md-cell-padding-y, 4px );\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-calendar-md.k-month-calendar,\n.k-calendar-md .k-calendar-monthview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-month-cell-size, 32px );\n}\n.k-calendar-md.k-year-calendar,\n.k-calendar-md .k-calendar-yearview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-year-cell-size, 64px );\n}\n.k-calendar-md.k-decade-calendar,\n.k-calendar-md .k-calendar-decadeview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-decade-cell-size, 64px );\n}\n.k-calendar-md.k-century-calendar,\n.k-calendar-md .k-calendar-centuryview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-md-century-cell-size, 64px );\n}\n\n.k-calendar-lg {\n  --INTERNAL--kendo-calendar-view-width: 320px;\n  --INTERNAL--kendo-calendar-cell-padding-x: var( --kendo-calendar-lg-cell-padding-x, 8px );\n  --INTERNAL--kendo-calendar-cell-padding-y: var( --kendo-calendar-lg-cell-padding-y, 8px );\n  font-size: 16px;\n  line-height: 1.5;\n}\n.k-calendar-lg.k-month-calendar,\n.k-calendar-lg .k-calendar-monthview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-month-cell-size, 40px );\n}\n.k-calendar-lg.k-year-calendar,\n.k-calendar-lg .k-calendar-yearview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-year-cell-size, 80px );\n}\n.k-calendar-lg.k-decade-calendar,\n.k-calendar-lg .k-calendar-decadeview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-decade-cell-size, 80px );\n}\n.k-calendar-lg.k-century-calendar,\n.k-calendar-lg .k-calendar-centuryview {\n  --INTERNAL--kendo-calendar-cell-size: var( --kendo-calendar-lg-century-cell-size, 80px );\n}\n\n.k-calendar-infinite {\n  box-sizing: content-box;\n  display: inline-flex;\n  flex-flow: row nowrap;\n}\n.k-calendar-infinite .k-calendar-view {\n  padding: 0px 16px;\n  height: 288px;\n  flex: 0 0 auto;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 0;\n  overflow: hidden;\n}\n.k-calendar-infinite .k-calendar-view .k-content.k-scrollable {\n  position: relative;\n}\n.k-calendar-infinite .k-calendar-view::after {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  content: \"​\";\n  height: 0;\n  line-height: 0;\n  z-index: 1;\n  width: 150%;\n  left: -25%;\n  box-shadow: 0 0 32px 16px #ffffff;\n}\n.k-calendar-infinite .k-calendar-header {\n  margin-left: -16px;\n  margin-right: -16px;\n  padding: 8px 16px;\n  width: auto;\n  min-width: 0;\n}\n.k-calendar-infinite .k-calendar-weekdays {\n  flex: 0 0 auto;\n}\n\n.k-calendar-navigation {\n  width: 5em;\n  text-align: center;\n  flex: 0 0 auto;\n  display: block;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n.k-calendar-navigation::before, .k-calendar-navigation::after {\n  display: block;\n  position: absolute;\n  content: \"​\";\n  height: 0;\n  line-height: 0;\n  z-index: 1;\n  width: 200%;\n  left: -50%;\n  box-shadow: 0 0 6em 3em #fafafa;\n}\n.k-calendar-navigation::before {\n  top: 0;\n}\n.k-calendar-navigation::after {\n  bottom: 0;\n}\n.k-calendar-navigation .k-content,\n.k-calendar-navigation .k-calendar-content {\n  background: transparent;\n  height: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.k-calendar-navigation .k-content ul,\n.k-calendar-navigation .k-calendar-content ul {\n  width: 5em;\n}\n.k-calendar-navigation .k-content li,\n.k-calendar-navigation .k-calendar-content li {\n  height: 2em;\n  line-height: 2em;\n  cursor: pointer;\n  padding: 0 1em;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n.k-calendar-navigation .k-calendar-navigation-marker {\n  font-weight: bold;\n}\n.k-calendar-navigation .k-calendar-navigation-highlight {\n  width: 100%;\n  border-width: 1px 0;\n  border-style: solid;\n  height: 2em;\n  box-sizing: border-box;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.k-calendar-range {\n  width: auto;\n}\n.k-calendar-range .k-calendar-view {\n  width: auto;\n  white-space: nowrap;\n}\n.k-calendar-range .k-calendar-view::after {\n  display: none;\n}\n.k-calendar-range .k-calendar-view:focus {\n  outline: 0;\n}\n.k-calendar-range .k-range-start {\n  border-color: inherit;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.k-calendar-range .k-range-end {\n  border-color: inherit;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.k-calendar-range .k-range-mid {\n  border-color: inherit;\n  border-radius: 0;\n}\n\n.k-rtl .k-calendar .k-nav-prev,\n.k-rtl .k-calendar .k-nav-next,\n.k-rtl .k-calendar .k-prev-view,\n.k-rtl .k-calendar .k-next-view,\n.k-rtl .k-calendar .k-calendar-nav-prev,\n.k-rtl .k-calendar .k-calendar-nav-next,\n.k-calendar[dir=rtl] .k-nav-prev,\n.k-calendar[dir=rtl] .k-nav-next,\n.k-calendar[dir=rtl] .k-prev-view,\n.k-calendar[dir=rtl] .k-next-view,\n.k-calendar[dir=rtl] .k-calendar-nav-prev,\n.k-calendar[dir=rtl] .k-calendar-nav-next {\n  transform: scaleX(-1);\n}\n.k-rtl .k-calendar .k-content.k-scrollable,\n.k-rtl .k-calendar .k-calendar-content.k-scrollable,\n.k-calendar[dir=rtl] .k-content.k-scrollable,\n.k-calendar[dir=rtl] .k-calendar-content.k-scrollable {\n  padding-right: 100px;\n  padding-left: 100px;\n  margin-left: calc( -100px - var(--kendo-scrollbar-width, 17px) );\n  margin-right: -100px;\n}\n.k-rtl .k-calendar tbody th,\n.k-rtl .k-calendar .k-calendar-tbody .k-calendar-th,\n.k-calendar[dir=rtl] tbody th,\n.k-calendar[dir=rtl] .k-calendar-tbody .k-calendar-th {\n  text-align: right;\n}\n\n.k-calendar {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-calendar .k-header {\n  border-color: inherit;\n  color: #424242;\n  background-color: #fafafa;\n  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.1);\n}\n.k-calendar .k-nav-today,\n.k-calendar .k-calendar-nav-today {\n  color: #ff6358;\n}\n.k-calendar .k-nav-today:hover, .k-calendar .k-nav-today.k-hover, .k-calendar .k-nav-today:focus, .k-calendar .k-nav-today.k-focus,\n.k-calendar .k-calendar-nav-today:hover,\n.k-calendar .k-calendar-nav-today.k-hover,\n.k-calendar .k-calendar-nav-today:focus,\n.k-calendar .k-calendar-nav-today.k-focus {\n  color: #d6534a;\n}\n.k-calendar .k-calendar-th,\n.k-calendar .k-calendar-caption,\n.k-calendar .k-meta-header,\n.k-calendar .k-month-header {\n  color: #666666;\n}\n.k-calendar .k-calendar-view .k-today {\n  color: #ff6358;\n}\n.k-calendar .k-other-month {\n  color: #666666;\n}\n.k-calendar .k-alt {\n  background-color: transparent;\n  color: #666666;\n}\n.k-calendar .k-out-of-range {\n  pointer-events: none;\n}\n.k-calendar .k-calendar-td:hover .k-calendar-cell-inner, .k-calendar .k-calendar-td:hover .k-link,\n.k-calendar .k-calendar-td.k-hover .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-hover .k-link {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #f0f0f0;\n}\n.k-calendar .k-calendar-td.k-selected .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected .k-link {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: white;\n  background-color: #ff6358;\n}\n.k-calendar .k-calendar-td.k-selected:hover .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected:hover .k-link,\n.k-calendar .k-calendar-td.k-selected.k-hover .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-selected.k-hover .k-link {\n  color: white;\n  background-color: #f55f54;\n}\n.k-calendar .k-calendar-td:focus .k-calendar-cell-inner, .k-calendar .k-calendar-td:focus .k-link,\n.k-calendar .k-calendar-td.k-focus .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-focus .k-link {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-calendar .k-calendar-td.k-selected:focus .k-calendar-cell-inner, .k-calendar .k-calendar-td.k-selected:focus .k-link,\n.k-calendar .k-calendar-td.k-selected.k-focus .k-calendar-cell-inner,\n.k-calendar .k-calendar-td.k-selected.k-focus .k-link {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);\n}\n.k-calendar .k-calendar-navigation {\n  color: #424242;\n  background-color: #fafafa;\n  box-shadow: inset -1px 0 rgba(0, 0, 0, 0.08);\n}\n.k-calendar .k-calendar-navigation li:hover,\n.k-calendar .k-calendar-navigation li.k-hover {\n  color: #d6534a;\n}\n.k-calendar .k-calendar-navigation-highlight {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-calendar[dir=rtl] .k-calendar-navigation, .k-rtl .k-calendar .k-calendar-navigation {\n  box-shadow: inset 1px 0 rgba(0, 0, 0, 0.08);\n}\n.k-calendar.k-invalid, .k-calendar.k-invalid:hover, .k-calendar.ng-invalid.ng-touched, .k-calendar.ng-invalid.ng-dirty {\n  border-color: #f31700;\n}\n\n.k-scheduler .k-calendar .k-other-month {\n  color: #666666;\n  background-color: transparent;\n}\n\n.k-calendar .k-range-start,\n.k-calendar .k-range-end,\n.k-calendar .k-range-mid {\n  background-color: rgba(255, 99, 88, 0.25);\n}\n.k-calendar .k-range-start.k-range-end {\n  background-image: none;\n  background-color: transparent;\n}\n.k-calendar .k-range-start .k-calendar-cell-inner, .k-calendar .k-range-start .k-link,\n.k-calendar .k-range-end .k-calendar-cell-inner,\n.k-calendar .k-range-end .k-link {\n  background-color: #ff6358;\n}\n.k-calendar .k-range-start.k-active .k-calendar-cell-inner, .k-calendar .k-range-start.k-active .k-link,\n.k-calendar .k-range-end.k-active .k-calendar-cell-inner,\n.k-calendar .k-range-end.k-active .k-link {\n  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, 0.2);\n}\n.k-calendar .k-range-split-start,\n.k-calendar .k-range-split-end {\n  position: relative;\n}\n.k-calendar .k-range-split-start::after,\n.k-calendar .k-range-split-end::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n}\n.k-calendar .k-range-split-start::after {\n  left: -5px;\n  right: auto;\n  background-image: linear-gradient(to left, rgba(255, 99, 88, 0.25), transparent 100%);\n}\n.k-calendar .k-range-split-end::after {\n  right: -5px;\n  left: auto;\n  background-image: linear-gradient(to right, rgba(255, 99, 88, 0.25), transparent 100%);\n}\n\n.k-timeselector {\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-flow: column nowrap;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-popup > .k-timeselector {\n  border-width: 0;\n}\n\n.k-time-header,\n.k-time-selector-header {\n  padding: 8px 8px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 0 auto;\n}\n.k-time-header .k-title,\n.k-time-header .k-time-selector-header-title,\n.k-time-selector-header .k-title,\n.k-time-selector-header .k-time-selector-header-title {\n  padding: 4px 8px;\n  font-weight: bold;\n  display: inline-block;\n}\n.k-time-header .k-time-now,\n.k-time-selector-header .k-time-now {\n  border-width: 0;\n  line-height: inherit;\n  cursor: pointer;\n}\n\n.k-actions.k-time-fast-selection, .k-time-fast-selection.k-form-buttons, .k-time-fast-selection.k-edit-buttons,\n.k-time-fast-selection.k-action-buttons,\n.k-time-fast-selection.k-columnmenu-actions {\n  margin-top: 0;\n}\n\n.k-time-list-container {\n  display: flex;\n  position: relative;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.k-time-highlight,\n.k-time-list-highlight {\n  width: 100%;\n  height: calc( 20px + 8px );\n  border-width: 1px 0px;\n  border-style: solid;\n  box-sizing: border-box;\n  position: absolute;\n  top: calc( 50% + 9px);\n  left: 0;\n  right: 0;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.k-time-list-wrapper {\n  min-width: 4em;\n  height: 240px;\n  box-sizing: content-box;\n  display: inline-flex;\n  flex-flow: column nowrap;\n  align-items: stretch;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  flex: 1 1 auto;\n}\n.k-time-list-wrapper .k-title {\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: bold;\n  text-align: center;\n  text-transform: capitalize;\n  display: block;\n}\n.k-time-list-wrapper.k-focus::before, .k-time-list-wrapper.k-focus::after {\n  display: block;\n  content: \"​\";\n  position: absolute;\n  width: 100%;\n  left: 0;\n  pointer-events: none;\n  height: calc( 50% - calc( 20px + 8px )/2 );\n  box-sizing: border-box;\n  border-width: 0;\n  border-style: solid;\n}\n.k-time-list-wrapper.k-focus::before {\n  top: 18px;\n}\n.k-time-list-wrapper.k-focus::after {\n  bottom: 0;\n}\n\n.k-time-list {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  flex: 1;\n  position: relative;\n  z-index: 1;\n  outline: 0;\n  overflow: hidden;\n}\n.k-time-list::before, .k-time-list::after {\n  display: block;\n  position: absolute;\n  content: \"​\";\n  height: 0;\n  line-height: 0;\n  z-index: 1;\n  width: 200%;\n  left: -50%;\n}\n.k-time-list::before {\n  top: 0;\n}\n.k-time-list::after {\n  bottom: 0;\n}\n\n.k-time-container,\n.k-time-list-content {\n  position: relative;\n  flex: 1 1 auto;\n  display: block;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  padding-right: 100px;\n  padding-left: 100px;\n  margin-left: -100px;\n  margin-right: calc( -100px - var(--kendo-scrollbar-width, 17px) );\n}\n.k-time-container > ul,\n.k-time-list-content > ul {\n  height: auto;\n  width: 4em;\n  margin: auto;\n}\n.k-time-container .k-scrollable-placeholder,\n.k-time-list-content .k-scrollable-placeholder {\n  position: absolute;\n  width: 1px;\n  top: 0;\n  right: 0;\n}\n\n.k-time-list-item,\n.k-time-list .k-item {\n  padding: 4px 8px;\n}\n\n.k-time-separator {\n  width: 0;\n  height: calc( 20px + 8px );\n  align-self: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 11;\n  top: calc( 9px );\n}\n\n.k-timeselector-sm {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-timeselector-sm .k-time-highlight,\n.k-timeselector-sm .k-time-list-highlight {\n  height: calc( 20px + 4px );\n}\n.k-timeselector-sm .k-time-separator {\n  height: calc( 20px + 4px );\n}\n.k-timeselector-sm .k-time-list-item,\n.k-timeselector-sm .k-time-list .k-item {\n  padding: 2px 8px;\n}\n\n.k-timeselector-md {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n.k-timeselector-md .k-time-highlight,\n.k-timeselector-md .k-time-list-highlight {\n  height: calc( 20px + 8px );\n}\n.k-timeselector-md .k-time-separator {\n  height: calc( 20px + 8px );\n}\n.k-timeselector-md .k-time-list-item,\n.k-timeselector-md .k-time-list .k-item {\n  padding: 4px 8px;\n}\n\n.k-timeselector-lg {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.k-timeselector-lg .k-time-highlight,\n.k-timeselector-lg .k-time-list-highlight {\n  height: calc( 24px + 16px );\n}\n.k-timeselector-lg .k-time-separator {\n  height: calc( 24px + 16px );\n}\n.k-timeselector-lg .k-time-list-item,\n.k-timeselector-lg .k-time-list .k-item {\n  padding: 8px 12px;\n}\n\n.k-rtl .k-time-container,\n.k-rtl .k-time-list-content,\n[dir=rtl] .k-time-container,\n[dir=rtl] .k-time-list-content {\n  padding-right: 100px;\n  padding-left: 100px;\n  margin-left: calc( -100px - var(--kendo-scrollbar-width, 17px) );\n  margin-right: -100px;\n}\n\n.k-timeselector {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n\n.k-time-header .k-time-now,\n.k-time-selector-header .k-time-now {\n  color: #ff6358;\n}\n.k-time-header .k-time-now:hover,\n.k-time-selector-header .k-time-now:hover {\n  color: #d6534a;\n}\n\n.k-time-list-wrapper .k-title {\n  color: #666666;\n}\n.k-time-list-wrapper.k-focus .k-title {\n  color: #424242;\n}\n.k-time-list-wrapper.k-focus::before, .k-time-list-wrapper.k-focus::after {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.k-time-list::before, .k-time-list::after {\n  box-shadow: 0 0 3em 1.5em #ffffff;\n}\n.k-time-list .k-item:hover {\n  color: #ff6358;\n}\n\n.k-time-container {\n  background: transparent;\n}\n\n.k-time-highlight {\n  border-color: rgba(0, 0, 0, 0.08);\n  background-color: #ffffff;\n}\n\n.k-datetime-selector {\n  display: flex;\n  transition: transform 0.2s;\n}\n\n.k-datetime-wrap {\n  width: calc( 256px + 32px);\n  overflow: hidden;\n}\n.k-datetime-wrap .k-datetime-buttongroup {\n  padding: 8px 8px;\n}\n.k-datetime-wrap .k-calendar,\n.k-datetime-wrap .k-timeselector {\n  width: 100%;\n  border-width: 0;\n}\n\n.k-datetime-calendar-wrap,\n.k-datetime-time-wrap {\n  text-align: center;\n  flex: 0 0 calc( 256px + 32px);\n}\n\n.k-date-tab .k-datetime-selector {\n  transform: translateX(0);\n}\n\n.k-time-tab .k-datetime-selector {\n  transform: translateX(-100%);\n}\n\n.k-datetimepicker[dir=rtl] .k-time-tab .k-datetime-selector, .k-rtl .k-datetimepicker .k-time-tab .k-datetime-selector {\n  transform: translateX(100%);\n}\n\n.k-dropdown-operator {\n  width: min-content;\n  flex: none;\n  aspect-ratio: 1;\n}\n.k-dropdown-operator .k-input-button {\n  border-width: 0;\n}\n.k-dropdown-operator .k-input-button .k-button-icon {\n  width: auto;\n  aspect-ratio: 1;\n}\n.k-dropdown-operator .k-input-inner {\n  display: none;\n}\n\n.k-overlay {\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10001;\n}\n\n.k-overlay {\n  background-color: #000000;\n}\n\n.k-overlay-primary {\n  background-color: #ff6358;\n}\n\n.k-overlay-secondary {\n  background-color: #666666;\n}\n\n.k-overlay-tertiary {\n  background-color: #03a9f4;\n}\n\n.k-overlay-info {\n  background-color: #0058e9;\n}\n\n.k-overlay-success {\n  background-color: #37b400;\n}\n\n.k-overlay-warning {\n  background-color: #ffc000;\n}\n\n.k-overlay-error {\n  background-color: #f31700;\n}\n\n.k-overlay-dark {\n  background-color: #424242;\n}\n\n.k-overlay-light {\n  background-color: #ebebeb;\n}\n\n.k-overlay-inverse {\n  background-color: #424242;\n}\n\n.k-form,\n.k-form-inline {\n  font-size: 14px;\n  line-height: 1.4285714286;\n}\n\n.k-fieldset {\n  margin: 30px;\n  border-width: 1px 0 0;\n  border-style: solid;\n  padding: 25px 0 0;\n}\n.k-fieldset > legend {\n  margin-left: 0;\n  padding: 0 8px 0 0;\n  text-transform: uppercase;\n}\n\nkendo-label > .k-label {\n  margin: 0;\n}\n\n.k-label-optional {\n  margin-left: 6px;\n  font-size: 12px;\n  font-style: italic;\n  align-self: center;\n}\n\n.k-label-empty::before {\n  content: \"\";\n  display: inline-block;\n}\n\n.k-input-label {\n  margin-right: 10px;\n  z-index: 1;\n}\n.k-input-label:dir(rtl), .k-rtl .k-input-label, .k-input-label.k-rtl, [dir=rtl] .k-input-label, .k-input-label[dir=rtl] {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n.k-form {\n  border: 0;\n}\n.k-form .k-label,\n.k-form kendo-label,\n.k-form .k-form-label {\n  margin-bottom: 0px;\n  display: flex;\n  flex-flow: row nowrap;\n}\n.k-form .k-label + .k-radio {\n  margin-left: 0;\n}\n.k-form .k-form-fieldset {\n  margin: 2em 0 0;\n  padding: 0px;\n  border: 0;\n}\n.k-form .k-form-fieldset > *:not(.k-hidden):first-child, .k-form .k-form-fieldset > *.k-hidden + :not(.k-hidden) {\n  margin-top: 0;\n}\n.k-form .k-form-legend {\n  margin: 0 0 1em;\n  padding: 0px;\n  border-width: 0 0 2px;\n  border-style: solid;\n  width: 100%;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.k-form .k-form-group {\n  padding: 0;\n}\n.k-form .k-form-field {\n  margin-top: 1em;\n}\n.k-form > *:not(.k-hidden):first-child, .k-form > *.k-hidden + :not(.k-hidden) {\n  margin-top: 0;\n}\n.k-form .k-form-field,\n.k-form .k-form-field-wrap {\n  display: block;\n}\n.k-form .k-form-field-disabled .k-label,\n.k-form .k-form-field-disabled .k-form-label {\n  outline: none;\n  cursor: default;\n  opacity: 0.6;\n  filter: grayscale(0.1);\n  pointer-events: none;\n  box-shadow: none;\n}\n.k-form .k-alert-error {\n  font-size: 12px;\n  margin-top: 8px;\n}\n.k-form .k-field-info {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 1;\n  margin: 0 8px;\n}\n.k-form .k-multiselect,\n.k-form .k-floating-label-container,\n.k-form .k-daterangepicker .k-dateinput,\n.k-form .k-signature {\n  display: inline-flex;\n  width: 100%;\n}\n\n.k-form-buttons {\n  margin-top: 2em;\n  padding: 0;\n  overflow: visible;\n}\n\n.k-form-hint,\n.k-form-error {\n  margin-top: 4px;\n  display: flex;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.k-text-start,\n.k-buttons-start {\n  justify-content: flex-start;\n}\n\n.k-text-end,\n.k-buttons-end {\n  justify-content: flex-end;\n}\n\n.k-form-separator {\n  margin: 1em 0 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  display: block;\n  flex: 0 0 auto;\n}\n\n.k-form-horizontal .k-form-field {\n  display: flex;\n}\n.k-form-horizontal .k-form-field > .k-label,\n.k-form-horizontal .k-form-field > kendo-label,\n.k-form-horizontal .k-form-field > .k-form-label {\n  margin-right: 10px;\n  padding-top: 5px;\n  width: 25%;\n  text-align: end;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n.k-form-horizontal .k-form-field .k-label-optional {\n  margin: 0;\n  align-self: inherit;\n}\n.k-form-horizontal .k-form-field-wrap {\n  max-width: calc( ( 100% - 25% ) - 10px );\n  flex: 1 1 auto;\n}\n\n.k-form [dir=rtl] .k-label-optional, .k-rtl .k-form .k-label-optional {\n  margin-left: 0;\n  margin-right: 6px;\n}\n\n.k-form-horizontal [dir=rtl].k-form-field > .k-label,\n.k-form-horizontal [dir=rtl].k-form-field > kendo-label,\n.k-form-horizontal [dir=rtl].k-form-field > .k-form-label,\n.k-form-horizontal [dir=rtl] .k-form-field > .k-label,\n.k-form-horizontal [dir=rtl] .k-form-field > kendo-label,\n.k-form-horizontal [dir=rtl] .k-form-field > .k-form-label, .k-rtl .k-form-horizontal.k-form-field > .k-label,\n.k-rtl .k-form-horizontal.k-form-field > kendo-label,\n.k-rtl .k-form-horizontal.k-form-field > .k-form-label,\n.k-rtl .k-form-horizontal .k-form-field > .k-label,\n.k-rtl .k-form-horizontal .k-form-field > kendo-label,\n.k-rtl .k-form-horizontal .k-form-field > .k-form-label {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n.k-form-inline {\n  padding: 16px;\n}\n.k-form-inline fieldset {\n  border-width: 1px 0 0;\n  border-style: solid;\n  margin: 32px 0;\n  padding: 0;\n}\n.k-form-inline fieldset:first-child:first-of-type {\n  margin-top: 0;\n}\n.k-form-inline fieldset:last-child:last-of-type {\n  margin-bottom: 0;\n}\n.k-form-inline legend {\n  font-size: 12px;\n  text-align: left;\n  font-weight: 600;\n  line-height: 1;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  padding: 0 8px 0 0;\n  width: auto;\n}\n.k-form-inline .k-form-field {\n  display: flex;\n  align-items: flex-start;\n  text-align: left;\n  margin-bottom: 12px;\n}\n.k-form-inline .k-form-field > span:not(.k-widget) {\n  width: 25%;\n  text-align: right;\n  line-height: 1.4285714286;\n  padding: calc( 4px + 1px ) 0;\n  padding-right: 12px;\n  align-self: center;\n}\n.k-form-inline .k-form-field > input {\n  align-self: center;\n}\n.k-form-inline .k-form-field > input:not(.k-checkbox):not(.k-radio) {\n  flex: 1 1 auto;\n}\n.k-form-inline .k-form-field .k-alert-error {\n  font-size: 12px;\n  margin-top: 8px;\n}\n.k-form-inline .k-form-field .k-field-info {\n  display: block;\n  font-size: 10px;\n  line-height: 1;\n  margin: 0;\n}\n.k-form-inline .k-form-field:last-child {\n  margin-bottom: 0;\n}\n\n.k-edit-form-container {\n  width: 400px;\n  min-width: 400px;\n  border-color: inherit;\n  position: relative;\n}\n\n.k-popup-edit-form > .k-actions, .k-popup-edit-form > .k-edit-buttons,\n.k-popup-edit-form > .k-action-buttons,\n.k-popup-edit-form > .k-columnmenu-actions, .k-popup-edit-form > .k-form-buttons,\n.k-edit-form-container .k-actions,\n.k-edit-form-container .k-edit-buttons,\n.k-edit-form-container .k-action-buttons,\n.k-edit-form-container .k-columnmenu-actions,\n.k-edit-form-container .k-form-buttons {\n  margin: 1em -16px -16px;\n}\n\n.k-edit-label {\n  margin: 0 0 1em 0;\n  padding: calc( 4px + 1px ) 0;\n  width: 30%;\n  line-height: 1.4285714286;\n  text-align: right;\n  float: left;\n  clear: both;\n}\n\n.k-edit-field {\n  margin: 0 0 1em 0;\n  width: 65%;\n  float: right;\n  clear: right;\n  position: relative;\n}\n.k-edit-field.k-no-editor {\n  padding: calc( 4px + 1px ) 0;\n}\n\n.k-edit-field > .k-widget {\n  width: 100%;\n  box-sizing: border-box;\n}\n.k-edit-field input[type=radio]:not(.k-radio),\n.k-edit-field input[type=checkbox]:not(.k-checkbox) {\n  margin-right: 0.4ex;\n}\n.k-edit-field .k-radio-label,\n.k-edit-field .k-checkbox-label {\n  margin-right: 1em;\n}\n.k-edit-field > .k-reset > li + li {\n  margin-top: 0.5em;\n}\n.k-edit-field .k-reset .k-widget {\n  margin: 0 0.4ex 0 1ex;\n}\n\n.k-form,\n.k-form-inline {\n  color: #424242;\n}\n.k-form fieldset legend,\n.k-form-inline fieldset legend {\n  color: #373737;\n}\n.k-form .k-form-legend,\n.k-form-inline .k-form-legend {\n  border-color: rgba(0, 0, 0, 0.08);\n}\n.k-form .k-field-info,\n.k-form-inline .k-field-info {\n  color: #666666;\n}\n.k-form .k-alert-error,\n.k-form-inline .k-alert-error {\n  color: #f31700;\n}\n\n.k-form-error,\n.k-text-error,\n.k-form-field-error .k-label {\n  color: #f31700;\n}\n\n.k-form-separator {\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-window {\n  border-radius: 0px;\n  padding: 0;\n  border-width: 0px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.25;\n  display: inline-flex;\n  flex-direction: column;\n  position: absolute;\n  z-index: 10002;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.k-window.k-window-maximized {\n  max-width: 100vw;\n  max-height: 100vh;\n  box-shadow: none;\n}\n\n.k-window-sm {\n  width: 300px;\n}\n\n.k-window-md {\n  width: 800px;\n}\n\n.k-window-lg {\n  width: 1200px;\n}\n\n.k-window-titlebar {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  padding: 12px 16px;\n  border-width: 0 0 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  align-items: center;\n}\n.k-window-minimized .k-window-titlebar {\n  border-width: 0;\n}\n\n.k-window-title {\n  padding: 0.5em 0;\n  margin: -0.5em 0;\n  font-size: 16px;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  cursor: default;\n  flex: 1;\n  display: flex;\n  flex-flow: row nowrap;\n}\n.k-window-title::before {\n  content: \"​\";\n}\n\n.k-window-actions {\n  margin: -5em 0;\n  margin-inline-end: calc( 12px - 16px );\n  line-height: 1;\n  display: flex;\n  flex-flow: row nowrap;\n  flex-shrink: 0;\n  align-items: center;\n  vertical-align: top;\n}\n\n.k-window-action {\n  flex-shrink: 0;\n}\n\n.k-window-content,\n.k-prompt-container {\n  padding: 16px 16px;\n  border-width: 0;\n  border-color: inherit;\n  color: inherit;\n  background: none;\n  outline: 0;\n  overflow: auto;\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.k-window-content + .k-prompt-container {\n  margin-top: -8px;\n}\n\n.k-window-content:first-child {\n  padding-top: clamp( 16px, 12px, 12px );\n}\n\n.k-window-content:last-child {\n  padding-bottom: clamp( 16px, 12px, 12px );\n}\n\n.k-window-iframecontent {\n  padding: 0;\n  overflow: visible;\n}\n.k-window-iframecontent .k-content-frame {\n  vertical-align: top;\n  border: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.k-window-buttons,\n.k-window-buttongroup {\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  padding: 8px 8px;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: inherit;\n  flex: 0 0 auto;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  overflow: hidden;\n}\n\n.k-prompt-container > .k-textarea {\n  width: 100%;\n}\n\n.k-window .k-resize-n {\n  top: 0;\n}\n.k-window .k-resize-e {\n  right: 0;\n}\n.k-window .k-resize-s {\n  bottom: 0;\n}\n.k-window .k-resize-w {\n  left: 0;\n}\n\n.k-window {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.06);\n}\n\n.k-window:focus, .k-window.k-focus {\n  box-shadow: 1px 1px 7px 1px rgba(0, 0, 0, 0.3);\n}\n\n.k-window-titlebar {\n  border-color: inherit;\n  color: #424242;\n  background-color: #fafafa;\n}\n\n.k-dialog-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  outline: 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10001;\n}\n.k-dialog-wrapper .k-dialog {\n  position: relative;\n}\n\n.k-dialog {\n  padding: 0;\n  position: fixed;\n  box-sizing: border-box;\n}\n.k-dialog.k-dialog-centered {\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n}\n.k-dialog .k-multiselect {\n  width: 100%;\n}\n\n.k-dialog-buttongroup {\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  padding: 8px 8px;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: inherit;\n  flex: 0 0 auto;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  gap: 8px;\n  overflow: hidden;\n}\n\n.k-ie .k-dialog-buttongroup .k-button ~ .k-button {\n  margin-left: 8px;\n}\n.k-rtl .k-ie .k-dialog-buttongroup .k-button ~ .k-button, [dir=rtl] .k-ie .k-dialog-buttongroup .k-button ~ .k-button {\n  margin-left: 0;\n  margin-right: 8px;\n}\n\n.k-dialog-titlebar {\n  border-color: inherit;\n  color: white;\n  background-color: #ff6358;\n}\n\n.k-pager-wrap,\n.k-pager {\n  padding: 8px 8px;\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  cursor: default;\n  flex: 0 0 auto;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-pager-wrap *,\n.k-pager-wrap *::before,\n.k-pager-wrap *::after,\n.k-pager *,\n.k-pager *::before,\n.k-pager *::after {\n  box-sizing: border-box;\n}\n.k-pager-wrap .k-link,\n.k-pager .k-link {\n  text-decoration: none;\n  outline: 0;\n  font: inherit;\n  background-color: inherit;\n}\n.k-pager-wrap .k-link:focus, .k-pager-wrap .k-link.k-focus,\n.k-pager .k-link:focus,\n.k-pager .k-link.k-focus {\n  z-index: 3;\n}\n.k-rtl .k-pager-wrap .k-i-caret-alt-to-left,\n.k-rtl .k-pager-wrap .k-i-caret-alt-to-right,\n.k-rtl .k-pager-wrap .k-i-caret-alt-left,\n.k-rtl .k-pager-wrap .k-i-caret-alt-right,\n.k-rtl .k-pager-wrap .k-i-arrow-end-left,\n.k-rtl .k-pager-wrap .k-i-arrow-60-left,\n.k-rtl .k-pager-wrap .k-i-arrow-60-right,\n.k-rtl .k-pager-wrap .k-i-arrow-end-right,\n.k-rtl .k-pager-wrap .k-i-seek-w,\n.k-rtl .k-pager-wrap .k-i-arrow-w,\n.k-rtl .k-pager-wrap .k-i-arrow-e,\n.k-rtl .k-pager-wrap .k-i-seek-e, .k-pager-wrap[dir=rtl] .k-i-caret-alt-to-left,\n.k-pager-wrap[dir=rtl] .k-i-caret-alt-to-right,\n.k-pager-wrap[dir=rtl] .k-i-caret-alt-left,\n.k-pager-wrap[dir=rtl] .k-i-caret-alt-right,\n.k-pager-wrap[dir=rtl] .k-i-arrow-end-left,\n.k-pager-wrap[dir=rtl] .k-i-arrow-60-left,\n.k-pager-wrap[dir=rtl] .k-i-arrow-60-right,\n.k-pager-wrap[dir=rtl] .k-i-arrow-end-right,\n.k-pager-wrap[dir=rtl] .k-i-seek-w,\n.k-pager-wrap[dir=rtl] .k-i-arrow-w,\n.k-pager-wrap[dir=rtl] .k-i-arrow-e,\n.k-pager-wrap[dir=rtl] .k-i-seek-e, [dir=rtl] .k-pager-wrap .k-i-caret-alt-to-left,\n[dir=rtl] .k-pager-wrap .k-i-caret-alt-to-right,\n[dir=rtl] .k-pager-wrap .k-i-caret-alt-left,\n[dir=rtl] .k-pager-wrap .k-i-caret-alt-right,\n[dir=rtl] .k-pager-wrap .k-i-arrow-end-left,\n[dir=rtl] .k-pager-wrap .k-i-arrow-60-left,\n[dir=rtl] .k-pager-wrap .k-i-arrow-60-right,\n[dir=rtl] .k-pager-wrap .k-i-arrow-end-right,\n[dir=rtl] .k-pager-wrap .k-i-seek-w,\n[dir=rtl] .k-pager-wrap .k-i-arrow-w,\n[dir=rtl] .k-pager-wrap .k-i-arrow-e,\n[dir=rtl] .k-pager-wrap .k-i-seek-e,\n.k-rtl .k-pager .k-i-caret-alt-to-left,\n.k-rtl .k-pager .k-i-caret-alt-to-right,\n.k-rtl .k-pager .k-i-caret-alt-left,\n.k-rtl .k-pager .k-i-caret-alt-right,\n.k-rtl .k-pager .k-i-arrow-end-left,\n.k-rtl .k-pager .k-i-arrow-60-left,\n.k-rtl .k-pager .k-i-arrow-60-right,\n.k-rtl .k-pager .k-i-arrow-end-right,\n.k-rtl .k-pager .k-i-seek-w,\n.k-rtl .k-pager .k-i-arrow-w,\n.k-rtl .k-pager .k-i-arrow-e,\n.k-rtl .k-pager .k-i-seek-e,\n.k-pager[dir=rtl] .k-i-caret-alt-to-left,\n.k-pager[dir=rtl] .k-i-caret-alt-to-right,\n.k-pager[dir=rtl] .k-i-caret-alt-left,\n.k-pager[dir=rtl] .k-i-caret-alt-right,\n.k-pager[dir=rtl] .k-i-arrow-end-left,\n.k-pager[dir=rtl] .k-i-arrow-60-left,\n.k-pager[dir=rtl] .k-i-arrow-60-right,\n.k-pager[dir=rtl] .k-i-arrow-end-right,\n.k-pager[dir=rtl] .k-i-seek-w,\n.k-pager[dir=rtl] .k-i-arrow-w,\n.k-pager[dir=rtl] .k-i-arrow-e,\n.k-pager[dir=rtl] .k-i-seek-e,\n[dir=rtl] .k-pager .k-i-caret-alt-to-left,\n[dir=rtl] .k-pager .k-i-caret-alt-to-right,\n[dir=rtl] .k-pager .k-i-caret-alt-left,\n[dir=rtl] .k-pager .k-i-caret-alt-right,\n[dir=rtl] .k-pager .k-i-arrow-end-left,\n[dir=rtl] .k-pager .k-i-arrow-60-left,\n[dir=rtl] .k-pager .k-i-arrow-60-right,\n[dir=rtl] .k-pager .k-i-arrow-end-right,\n[dir=rtl] .k-pager .k-i-seek-w,\n[dir=rtl] .k-pager .k-i-arrow-w,\n[dir=rtl] .k-pager .k-i-arrow-e,\n[dir=rtl] .k-pager .k-i-seek-e {\n  transform: scaleX(-1);\n}\n\n.k-pager-info, .k-pager-sizes, .k-pager-input {\n  margin-left: 1em;\n  margin-right: 1em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.k-pager-refresh, .k-pager-numbers .k-link, .k-pager-nav {\n  min-width: calc( 1.4285714286em + 8px + 2px );\n  height: calc( 1.4285714286em + 8px + 2px );\n  color: inherit;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.k-pager-refresh:hover, .k-pager-numbers .k-link:hover, .k-pager-nav:hover {\n  z-index: 2;\n}\n.k-disabled.k-pager-refresh, .k-pager-numbers .k-disabled.k-link, .k-disabled.k-pager-nav {\n  color: inherit;\n}\n\n.k-pager-nav {\n  padding: 4px 4px;\n  border-width: 0px;\n  border-style: solid;\n}\n\n.k-pager-numbers-wrap {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n}\n.k-pager-numbers-wrap select.k-dropdown-list, .k-pager-numbers-wrap select.k-dropdown,\n.k-pager-numbers-wrap select.k-dropdownlist {\n  cursor: pointer;\n  display: none;\n}\n\n.k-pager-numbers {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n}\n.k-pager-numbers li {\n  display: inline-flex;\n}\n.k-pager-numbers .k-link {\n  padding: 4px 4px;\n  border-width: 0px;\n  border-style: solid;\n}\n.k-pager-numbers .k-selected {\n  cursor: inherit;\n  z-index: 2;\n}\n\n.k-pager-input .k-textbox {\n  margin: 0 1ex;\n  width: 5em;\n}\n\n.k-pager-sizes .k-dropdown-list, .k-pager-sizes .k-dropdown,\n.k-pager-sizes .k-dropdownlist,\n.k-pager-sizes > select {\n  margin-right: 1ex;\n  width: 5em;\n}\n.k-pager-sizes .k-input-inner,\n.k-pager-sizes .k-input-value-text {\n  text-overflow: clip;\n}\n.k-rtl .k-pager-sizes .k-dropdown-list, .k-rtl .k-pager-sizes .k-dropdown,\n.k-rtl .k-pager-sizes .k-dropdownlist,\n.k-rtl .k-pager-sizes > select, [dir=rtl] .k-pager-sizes .k-dropdown-list, [dir=rtl] .k-pager-sizes .k-dropdown,\n[dir=rtl] .k-pager-sizes .k-dropdownlist,\n[dir=rtl] .k-pager-sizes > select {\n  margin-left: 1ex;\n  margin-right: 0;\n}\n\n.k-pager-info {\n  text-align: right;\n  justify-content: flex-end;\n  flex: 1 1 0%;\n  order: 9;\n}\n\n.k-pager-refresh {\n  margin-left: auto;\n  order: 10;\n}\n.k-rtl .k-pager-refresh, [dir=rtl] .k-pager-refresh {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.k-pager-sm {\n  overflow: visible;\n}\n.k-pager-sm .k-pager-numbers-wrap select.k-dropdown-list, .k-pager-sm .k-pager-numbers-wrap select.k-dropdown,\n.k-pager-sm .k-pager-numbers-wrap select.k-dropdownlist {\n  width: 5em;\n  display: flex;\n}\n.k-pager-sm .k-pager-numbers-wrap {\n  margin-left: 1em;\n  margin-right: 1em;\n  height: calc( 1.4285714286em + 8px + 2px );\n  border-color: inherit;\n}\n.k-rtl .k-pager-sm .k-pager-numbers-wrap, .k-pager-sm[dir=rtl] .k-pager-numbers-wrap, [dir=rtl] .k-pager-sm .k-pager-numbers-wrap {\n  margin-left: 1em;\n  margin-right: 1em;\n}\n\n.k-pager-md .k-pager-info,\n.k-pager-sm .k-pager-info,\n.k-pager-sm .k-pager-sizes,\n.k-pager-sm .k-pager-numbers {\n  display: none;\n}\n\n.k-pager-wrap,\n.k-pager {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n.k-pager-wrap:focus, .k-pager-wrap.k-focus,\n.k-pager:focus,\n.k-pager.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.13);\n}\n\n.k-pager-refresh:hover, .k-pager-nav.k-link:hover, .k-hover.k-pager-refresh, .k-hover.k-pager-nav.k-link {\n  color: #424242;\n  background-color: #f0f0f0;\n}\n.k-selected.k-pager-refresh, .k-selected.k-pager-nav.k-link {\n  color: white;\n  background-color: #ff6358;\n}\n.k-pager-refresh:focus, .k-pager-nav.k-link:focus, .k-focus.k-pager-refresh, .k-focus.k-pager-nav.k-link {\n  background-color: transparent;\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n\n.k-pager-numbers .k-link {\n  color: #ff6358;\n}\n.k-pager-numbers .k-link:hover, .k-pager-numbers .k-link.k-hover {\n  color: #ff6358;\n  background-color: rgba(255, 99, 88, 0.08);\n}\n.k-pager-numbers .k-link:focus, .k-pager-numbers .k-link.k-focus {\n  background-color: transparent;\n  box-shadow: inset 0 0 0 2px rgba(255, 99, 88, 0.12);\n}\n.k-pager-numbers .k-link.k-selected {\n  color: #ff6358;\n  background-color: rgba(255, 99, 88, 0.2);\n}\n\n.k-pager-md .k-pager-numbers .k-current-page .k-link,\n.k-pager-sm .k-pager-numbers .k-current-page .k-link {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #f5f5f5;\n}\n.k-pager-md .k-pager-numbers .k-current-page .k-link:hover, .k-pager-md .k-pager-numbers .k-current-page .k-link.k-hover,\n.k-pager-sm .k-pager-numbers .k-current-page .k-link:hover,\n.k-pager-sm .k-pager-numbers .k-current-page .k-link.k-hover {\n  background-color: #ebebeb;\n}\n.k-pager-md .k-pager-numbers.k-expanded,\n.k-pager-sm .k-pager-numbers.k-expanded {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 4px 5px 0 rgba(0, 0, 0, 0.04);\n}\n.k-pager-md .k-pager-numbers.k-expanded .k-link:hover, .k-pager-md .k-pager-numbers.k-expanded .k-link.k-hover,\n.k-pager-sm .k-pager-numbers.k-expanded .k-link:hover,\n.k-pager-sm .k-pager-numbers.k-expanded .k-link.k-hover {\n  color: #424242;\n  background-color: #f0f0f0;\n}\n.k-pager-md .k-pager-numbers.k-expanded .k-link.k-selected,\n.k-pager-sm .k-pager-numbers.k-expanded .k-link.k-selected {\n  color: white;\n  background-color: #ff6358;\n}\n\n.k-skeleton {\n  display: block;\n}\n\n.k-skeleton-text {\n  border-radius: 4px;\n  transform: scale(1, 0.6);\n}\n.k-skeleton-text:empty::before {\n  content: \"​\";\n}\n\n.k-skeleton-rect {\n  border-radius: 0;\n}\n\n.k-skeleton-circle {\n  border-radius: 9999px;\n}\n\n@keyframes k-skeleton-wave {\n  0% {\n    transform: translateX(-100%);\n  }\n  60% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n.k-skeleton-wave .k-skeleton, .k-skeleton-wave.k-skeleton {\n  position: relative;\n  overflow: hidden;\n}\n.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave.k-skeleton::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transform: translateX(-100%);\n  animation: k-skeleton-wave 1.6s linear 0.5s infinite;\n}\n\n@keyframes k-skeleton-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.k-skeleton-pulse .k-skeleton, .k-skeleton-pulse.k-skeleton {\n  animation: k-skeleton-pulse 1.5s ease-in-out 0.5s infinite;\n}\n\n.k-skeleton {\n  background-color: rgba(66, 66, 66, 0.2);\n}\n\n.k-skeleton-wave .k-skeleton::after, .k-skeleton-wave.k-skeleton::after {\n  background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.04), transparent);\n}\n\n.k-float-left {\n  float: left !important;\n}\n\n.k-float-right {\n  float: right !important;\n}\n\n.k-float-none {\n  float: none !important;\n}\n\n.k-clear-left {\n  clear: left !important;\n}\n\n.k-clear-right {\n  clear: right !important;\n}\n\n.k-clear-both {\n  clear: both !important;\n}\n\n.k-clear-none {\n  clear: none !important;\n}\n\n.k-floatwrap::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.k-spacer {\n  flex: 1 0 auto;\n}\n\n.k-spacer-sized {\n  flex-grow: 0;\n}\n\n.k-grid {\n  border-width: 1px;\n  border-style: solid;\n  box-sizing: border-box;\n  outline: 0;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.4285714286;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.k-grid.k-grid-display-block {\n  display: block;\n}\n.k-grid .k-grid-container {\n  display: flex;\n  flex: 1 1 auto;\n  overflow: hidden;\n  position: relative;\n}\n.k-grid .k-grid-aria-root {\n  border-color: inherit;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n.k-grid table {\n  margin: 0;\n  width: 100%;\n  max-width: none;\n  border-width: 0;\n  border-color: inherit;\n  border-collapse: separate;\n  border-spacing: 0;\n  empty-cells: show;\n  outline: 0;\n}\n.k-grid thead,\n.k-grid tbody,\n.k-grid tfoot {\n  text-align: left;\n  border-color: inherit;\n}\n.k-grid tr {\n  border-color: inherit;\n}\n.k-grid th,\n.k-grid td {\n  padding: 8px 12px;\n  border-style: solid;\n  border-color: inherit;\n  outline: 0;\n  font-weight: inherit;\n  text-align: inherit;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.k-grid th:first-child,\n.k-grid td:first-child {\n  border-left-width: 0;\n}\n.k-grid th:focus,\n.k-grid td:focus {\n  outline: none;\n}\n.k-grid th .k-placeholder-line,\n.k-grid td .k-placeholder-line {\n  width: 80%;\n}\n.k-grid th {\n  padding: 8px 12px;\n  border-width: 0 0 1px 1px;\n  white-space: nowrap;\n}\n.k-grid td {\n  border-width: 0 0 0px 1px;\n  vertical-align: middle;\n}\n.k-grid a {\n  color: inherit;\n  text-decoration: none;\n}\n.k-grid a:hover {\n  text-decoration: none;\n}\n.k-grid table,\n.k-grid .k-grid-header-wrap {\n  box-sizing: content-box;\n}\n.k-grid .k-group-col,\n.k-grid .k-hierarchy-col {\n  padding: 0;\n  width: 32px;\n}\n.k-grid .k-grouping-row p {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.k-grid .k-grouping-row td {\n  overflow: visible;\n}\n.k-grid .k-grouping-row + tr td {\n  border-top-width: 1px;\n}\n.k-grid .k-grouping-row .k-group-cell,\n.k-grid .k-grouping-row + tr .k-group-cell {\n  border-top-width: 0;\n  text-overflow: clip;\n}\n.k-grid .k-grouping-row .k-icon {\n  margin-left: calc( 8px - 12px );\n  margin-right: 8px;\n  text-decoration: none;\n}\n.k-grid .k-group-footer td {\n  border-style: solid;\n  border-width: 1px 0;\n}\n.k-grid .k-group-footer .k-group-cell + td {\n  border-left-width: 1px;\n}\n.k-grid .k-hierarchy-cell,\n.k-grid .k-drag-cell {\n  text-align: center;\n  padding: 0;\n  overflow: visible;\n}\n.k-grid .k-hierarchy-cell > .k-icon,\n.k-grid .k-drag-cell > .k-icon {\n  padding: 8px 0;\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  outline: 0;\n}\n.k-grid .k-hierarchy-cell + .k-grid-content-sticky {\n  border-left-width: 1px;\n}\n.k-grid .k-detail-row .k-detail-cell {\n  border-left-width: 0;\n}\n.k-grid[dir=rtl] thead,\n.k-grid[dir=rtl] tbody,\n.k-grid[dir=rtl] tfoot, .k-rtl .k-grid thead,\n.k-rtl .k-grid tbody,\n.k-rtl .k-grid tfoot {\n  text-align: right;\n}\n.k-grid[dir=rtl] th, .k-rtl .k-grid th {\n  white-space: nowrap;\n}\n.k-grid[dir=rtl] .k-grid-header-wrap,\n.k-grid[dir=rtl] .k-grid-footer-wrap, .k-rtl .k-grid .k-grid-header-wrap,\n.k-rtl .k-grid .k-grid-footer-wrap {\n  border-width: 0 0 0 1px;\n}\n.k-grid[dir=rtl] .k-group-indicator .k-button-flat, .k-rtl .k-grid .k-group-indicator .k-button-flat {\n  margin-left: -2px;\n  margin-right: 8px;\n}\n.k-grid[dir=rtl] .k-group-indicator .k-link .k-icon, .k-rtl .k-grid .k-group-indicator .k-link .k-icon {\n  margin-left: 4px;\n  margin-right: -2px;\n}\n.k-grid[dir=rtl] .k-group-indicator, .k-rtl .k-grid .k-group-indicator {\n  margin-right: 0;\n  margin-left: 4px;\n}\n.k-grid[dir=rtl] .k-group-indicator + .k-group-indicator, .k-rtl .k-grid .k-group-indicator + .k-group-indicator {\n  margin-right: 4px;\n}\n.k-grid[dir=rtl] .k-grid-content-locked,\n.k-grid[dir=rtl] .k-grid-footer-locked,\n.k-grid[dir=rtl] .k-grid-header-locked, .k-rtl .k-grid .k-grid-content-locked,\n.k-rtl .k-grid .k-grid-footer-locked,\n.k-rtl .k-grid .k-grid-header-locked {\n  border-left-width: 1px;\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] .k-grid-header-sticky,\n.k-grid[dir=rtl] .k-grid-content-sticky,\n.k-grid[dir=rtl] .k-grid-footer-sticky, .k-rtl .k-grid .k-grid-header-sticky,\n.k-rtl .k-grid .k-grid-content-sticky,\n.k-rtl .k-grid .k-grid-footer-sticky {\n  border-left-width: 1px;\n}\n.k-grid[dir=rtl] .k-grid-header-sticky:not([style*=\"display: none\"]) + td,\n.k-grid[dir=rtl] .k-grid-header-sticky:not([style*=\"display: none\"]) + th,\n.k-grid[dir=rtl] .k-grid-content-sticky:not([style*=\"display: none\"]) + td,\n.k-grid[dir=rtl] .k-grid-content-sticky:not([style*=\"display: none\"]) + th, .k-rtl .k-grid .k-grid-header-sticky:not([style*=\"display: none\"]) + td,\n.k-rtl .k-grid .k-grid-header-sticky:not([style*=\"display: none\"]) + th,\n.k-rtl .k-grid .k-grid-content-sticky:not([style*=\"display: none\"]) + td,\n.k-rtl .k-grid .k-grid-content-sticky:not([style*=\"display: none\"]) + th {\n  border-left-width: 1px;\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] .k-grid-header-sticky.k-header:first-child, .k-rtl .k-grid .k-grid-header-sticky.k-header:first-child {\n  border-left-width: 1px;\n}\n.k-grid[dir=rtl] .k-grid-row-sticky, .k-rtl .k-grid .k-grid-row-sticky {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n}\n.k-grid[dir=rtl] th, .k-rtl .k-grid th {\n  border-width: 0 1px 1px 0;\n}\n.k-grid[dir=rtl] th:first-child, .k-rtl .k-grid th:first-child {\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] td, .k-rtl .k-grid td {\n  border-width: 0 1px 0 0;\n}\n.k-grid[dir=rtl] td:first-child, .k-rtl .k-grid td:first-child {\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] td.k-hierarchy-cell, .k-rtl .k-grid td.k-hierarchy-cell {\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] .k-hierarchy-cell + td, .k-rtl .k-grid .k-hierarchy-cell + td {\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] .k-grid-header .k-header, .k-rtl .k-grid .k-grid-header .k-header {\n  z-index: 1;\n}\n.k-grid[dir=rtl] .k-grid-header .k-header.k-first, .k-rtl .k-grid .k-grid-header .k-header.k-first {\n  border-left-width: 0;\n  border-right-width: 1px;\n}\n.k-grid[dir=rtl] .k-grid-header .k-with-icon,\n.k-grid[dir=rtl] .k-grid-header .k-filterable, .k-rtl .k-grid .k-grid-header .k-with-icon,\n.k-rtl .k-grid .k-grid-header .k-filterable {\n  padding-left: calc( calc( 1.4285714286em + 8px + 2px ) + 4px );\n  padding-right: 12px;\n}\n.k-grid[dir=rtl] .k-grid-header .k-grid-filter,\n.k-grid[dir=rtl] .k-grid-header .k-header-column-menu,\n.k-grid[dir=rtl] .k-grid-header .k-grid-header-menu, .k-rtl .k-grid .k-grid-header .k-grid-filter,\n.k-rtl .k-grid .k-grid-header .k-header-column-menu,\n.k-rtl .k-grid .k-grid-header .k-grid-header-menu {\n  right: auto;\n  left: 4px;\n}\n.k-grid[dir=rtl] .k-grid-header-sticky.k-header.k-first, .k-rtl .k-grid .k-grid-header-sticky.k-header.k-first {\n  border-left-width: 1px;\n}\n.k-grid[dir=rtl] .k-grid-header-sticky.k-header.k-grid-no-left-border.k-first, .k-rtl .k-grid .k-grid-header-sticky.k-header.k-grid-no-left-border.k-first {\n  border-left-width: 1px;\n  border-right-width: 0;\n}\n.k-grid[dir=rtl] .k-dirty, .k-rtl .k-grid .k-dirty {\n  border-color: currentColor currentColor transparent transparent;\n  left: auto;\n  right: 0;\n}\n.k-grid[dir=rtl] .k-grid-header-wrap,\n.k-grid[dir=rtl] .k-grid-footer-wrap, .k-rtl .k-grid .k-grid-header-wrap,\n.k-rtl .k-grid .k-grid-footer-wrap {\n  margin-left: -1px;\n  margin-right: 0;\n}\n.k-grid[dir=rtl] .k-grid-header-locked + .k-grid-header-wrap.k-auto-scrollable, .k-rtl .k-grid .k-grid-header-locked + .k-grid-header-wrap.k-auto-scrollable {\n  margin-left: 0;\n}\n.k-grid[dir=rtl] .k-group-footer td, .k-rtl .k-grid .k-group-footer td {\n  border-width: 1px 0;\n}\n.k-grid[dir=rtl] .k-group-footer .k-group-cell + td, .k-rtl .k-grid .k-group-footer .k-group-cell + td {\n  border-right-width: 1px;\n}\n.k-grid[dir=rtl] .k-grouping-row .k-icon, .k-rtl .k-grid .k-grouping-row .k-icon {\n  margin-left: 8px;\n  margin-right: calc( 8px - 12px );\n}\n.k-grid[dir=rtl] .k-column-resizer, .k-rtl .k-grid .k-column-resizer {\n  left: 0;\n  right: auto;\n}\n.k-grid .k-dirty-cell {\n  position: relative;\n}\n.k-grid .k-dirty-cell.k-edit-cell {\n  position: static;\n}\n.k-grid .k-dirty-cell.k-grid-content-sticky {\n  position: sticky;\n}\n.k-grid .k-dirty {\n  border-width: 5px;\n  border-color: currentColor transparent transparent currentColor;\n  left: 0;\n  right: auto;\n}\n.k-grid .k-grid-content-locked + .k-grid-content {\n  box-sizing: content-box;\n}\n.k-grid .k-grid-content-expander {\n  position: absolute;\n  visibility: hidden;\n  height: 1px;\n  bottom: 1px;\n}\n.k-grid .k-grid-filter,\n.k-grid .k-header-column-menu,\n.k-grid .k-grid-header-menu,\n.k-grid .k-hierarchy-cell .k-icon {\n  border-width: 0;\n}\n.k-grid .k-drag-col {\n  padding: 0;\n  width: 36px;\n}\n.k-grid .k-drag-cell {\n  cursor: move;\n}\n\n.k-grid-toolbar {\n  border-width: 0 0 1px;\n  flex-shrink: 0;\n}\n\n.k-grid-toolbar-bottom {\n  border-width: 1px 0 0;\n}\n\n.k-grouping-header {\n  padding: 8px 8px;\n  border-width: 0 0 1px;\n  border-style: solid;\n  border-color: inherit;\n  white-space: normal;\n  flex-shrink: 0;\n  display: block;\n  position: relative;\n}\n.k-grouping-header::before {\n  content: \"\";\n  height: calc( 1.4285714286em + 8px + 2px );\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.k-grouping-header-flex {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  gap: 8px;\n}\n.k-grouping-header-flex::before {\n  margin-left: -8px;\n}\n.k-grouping-header-flex .k-group-indicator {\n  margin: 0;\n}\n\n.k-grid .k-indicator-container {\n  margin: -8px 0;\n  padding: 8px 0;\n}\n\n.k-grid .k-indicator-container:last-child {\n  flex-grow: 1;\n}\n\n.k-group-indicator {\n  border-radius: 4px;\n  margin: 0;\n  padding: 4px 8px;\n  border-width: 1px;\n  border-style: solid;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  vertical-align: top;\n  box-sizing: border-box;\n}\n.k-group-indicator .k-link,\n.k-group-indicator .k-button-flat {\n  padding: 0;\n  border-width: 0;\n  display: inline-flex;\n  align-items: center;\n}\n.k-group-indicator .k-link .k-icon {\n  margin-left: -2px;\n  margin-right: 4px;\n}\n.k-group-indicator .k-button-flat {\n  margin-left: 8px;\n  margin-right: -2px;\n  padding: 0;\n  width: auto;\n  height: auto;\n  opacity: 0.5;\n}\n.k-group-indicator .k-button-flat::before, .k-group-indicator .k-button-flat::after {\n  display: none;\n}\n.k-group-indicator .k-button-flat:hover {\n  opacity: 1;\n}\n\n.k-group-indicator + .k-group-indicator {\n  margin-left: 4px;\n}\n\n.k-grouping-dropclue {\n  width: 12px;\n  height: calc( 1.4285714286em + 8px + 2px );\n  position: absolute;\n  top: 3px;\n  box-sizing: content-box;\n}\n.k-grouping-dropclue::before, .k-grouping-dropclue::after {\n  display: inline-block;\n  content: \"\";\n  position: absolute;\n}\n.k-grouping-dropclue::before {\n  border-width: 6px;\n  border-style: solid;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  top: 0;\n}\n.k-grouping-dropclue::after {\n  width: 2px;\n  height: calc(100% - 6px);\n  top: 6px;\n  left: calc( 6px - 1px );\n}\n\n.k-grid-header-wrap,\n.k-grid-footer-wrap {\n  margin-right: -1px;\n  width: 100%;\n  border-width: 0 1px 0 0;\n  border-style: solid;\n  border-color: inherit;\n  position: relative;\n  overflow: hidden;\n}\n\n.k-grid-header-locked + .k-grid-header-wrap.k-auto-scrollable {\n  margin-right: 0;\n}\n.k-ie .k-grid-header-locked + .k-grid-header-wrap.k-auto-scrollable {\n  display: inline-block;\n}\n\n.k-grid-header,\n.k-grid-footer {\n  padding-inline-start: 0;\n  padding-inline-end: var(--kendo-scrollbar-width, 17px);\n  border-width: 0;\n  border-style: solid;\n  border-color: inherit;\n  flex: 0 0 auto;\n}\n.k-grid-header table,\n.k-grid-footer table {\n  table-layout: fixed;\n}\n\ndiv.k-grid-header,\ndiv.k-grid-footer {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n\n.k-grid-header {\n  border-bottom-width: 1px;\n}\n.k-grid-header table {\n  margin-bottom: -1px;\n}\n.k-grid-header.k-grid-draggable-header {\n  user-select: none;\n  touch-action: none;\n}\n.k-grid-header .k-header {\n  position: relative;\n  vertical-align: bottom;\n  cursor: default;\n}\n.k-grid-header .k-header:first-child {\n  border-left-width: 0;\n}\n.k-grid-header .k-header.k-first {\n  border-left-width: 1px;\n}\n.k-grid-header .k-header > .k-link {\n  margin: -8px -12px;\n  padding: 8px 12px;\n  line-height: inherit;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  outline: 0;\n}\n.k-ie .k-grid-header .k-header > .k-link {\n  margin: 0;\n  padding: 0;\n}\n.k-grid-header .k-with-icon,\n.k-grid-header .k-filterable {\n  padding-right: calc( calc( 1.4285714286em + 8px + 2px ) + 4px );\n}\n.k-ie .k-grid-header .k-with-icon,\n.k-ie .k-grid-header .k-filterable {\n  padding-right: calc( calc( 1.4285714286em + 8px + 2px ) + 4px);\n}\n.k-grid-header .k-header > .k-link:focus {\n  text-decoration: none;\n}\n.k-grid-header .k-grid-filter,\n.k-grid-header .k-header-column-menu,\n.k-grid-header .k-grid-header-menu {\n  padding: 4px;\n  width: calc( 1.4285714286em + 8px + 2px );\n  height: calc( 1.4285714286em + 8px + 2px );\n  box-sizing: border-box;\n  outline: 0;\n  line-height: 1.4285714286;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  position: absolute;\n  right: 4px;\n  bottom: calc( 8px + calc( 1.4285714286 * 1em )/2 - calc( 1.4285714286em + 8px )/2 );\n  z-index: 1;\n}\n.k-grid-header .k-grid-filter:hover,\n.k-grid-header .k-header-column-menu:hover,\n.k-grid-header .k-grid-header-menu:hover {\n  cursor: pointer;\n}\n.k-grid-header .k-cell-inner > .k-link > .k-icon.k-i-sort-desc-sm, .k-grid-header .k-cell-inner > .k-link > .k-icon.k-i-sort-asc-sm, .k-grid-header .k-cell-inner > .k-link > .k-icon.k-i-sort-asc-small, .k-grid-header .k-cell-inner > .k-link > .k-icon.k-i-sort-desc-small {\n  vertical-align: text-top;\n  margin-inline-start: calc( 8px - 1px );\n}\n.k-grid-header .k-sort-order {\n  display: inline-block;\n  vertical-align: top;\n  height: 16px;\n  font-size: 12px;\n  margin-top: 2px;\n  margin-inline-start: -2px;\n}\n\n.k-column-resizer {\n  width: 0.5em;\n  height: 1000%;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: col-resize;\n}\n\n.k-grid-footer {\n  border-top-width: 1px;\n}\n.k-grid-footer td {\n  height: calc( 1.4285714286 * 1em );\n}\n\n.k-grid-footer td,\n.k-group-footer td,\n.k-grouping-row td {\n  font-weight: bold;\n}\n\n.k-grid-filter-popup {\n  min-width: 200px;\n}\n\n.k-grid-column-menu-standalone a.k-grid-filter {\n  position: initial;\n  display: inline-block;\n  margin: -4px 0;\n  padding: 4px 8px;\n}\n\n.k-filter-row {\n  line-height: 1.4285714286;\n}\n.k-filter-row td,\n.k-filter-row th {\n  border-width: 0 0 1px 1px;\n  white-space: nowrap;\n  padding: 8px 8px;\n}\n.k-filter-row td:first-child {\n  border-left-width: 0;\n}\n.k-filter-row .k-multiselect {\n  height: auto;\n}\n\n.k-filtercell {\n  width: auto;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n}\n.k-filtercell > span,\n.k-filtercell .k-filtercell-wrapper {\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 4px;\n  flex: 1 1 auto;\n}\n.k-filtercell > span > .k-button,\n.k-filtercell .k-filtercell-wrapper > .k-button {\n  flex: none;\n}\n.k-filtercell .k-input,\n.k-filtercell .k-picker {\n  width: auto;\n  flex: 1 1 auto;\n}\n.k-filtercell .k-color-picker,\n.k-filtercell .k-dropdown-operator {\n  width: min-content;\n  flex: none;\n}\n\n.k-grid-content,\n.k-grid-content-locked {\n  border-color: inherit;\n  outline: 0;\n}\n.k-grid-content table,\n.k-grid-content-locked table {\n  table-layout: fixed;\n}\n.k-grid-content tr:last-child > td,\n.k-grid-content-locked tr:last-child > td {\n  border-bottom-width: 0;\n}\n\n.k-grid-content {\n  width: 100%;\n  min-height: 0;\n  overflow: auto;\n  overflow-x: auto;\n  overflow-y: scroll;\n  position: relative;\n  flex: 1;\n}\n\n.k-virtual-scrollable-wrap {\n  height: 100%;\n  overflow-y: hidden;\n  position: relative;\n}\n\n.k-grid th > .k-radio,\n.k-grid th > .k-radio-wrap,\n.k-grid th > .k-checkbox,\n.k-grid th > .k-checkbox-wrap,\n.k-grid td > .k-radio,\n.k-grid td > .k-radio-wrap,\n.k-grid td > .k-checkbox,\n.k-grid td > .k-checkbox-wrap {\n  vertical-align: top;\n}\n\n.k-grid .k-edit-cell,\n.k-grid .k-command-cell,\n.k-grid .k-grid-edit-row td {\n  padding: 3px 12px;\n  text-overflow: clip;\n}\n\n.k-grid .k-edit-cell > input:not([type=checkbox]):not([type=radio]),\n.k-grid .k-edit-cell > select,\n.k-grid .k-edit-cell > .k-widget:not(.k-switch),\n.k-grid .k-grid-edit-row td > input:not([type=checkbox]):not([type=radio]),\n.k-grid .k-grid-edit-row td > select,\n.k-grid .k-grid-edit-row td > .k-widget:not(.k-switch) {\n  width: 100%;\n  vertical-align: middle;\n  box-sizing: border-box;\n}\n.k-grid .k-edit-cell > .k-radio,\n.k-grid .k-edit-cell > .k-checkbox,\n.k-grid .k-edit-cell > .k-radio-wrap,\n.k-grid .k-edit-cell > .k-checkbox-wrap,\n.k-grid .k-grid-edit-row td > .k-radio,\n.k-grid .k-grid-edit-row td > .k-checkbox,\n.k-grid .k-grid-edit-row td > .k-radio-wrap,\n.k-grid .k-grid-edit-row td > .k-checkbox-wrap {\n  vertical-align: middle;\n}\n\n.k-grid .k-command-cell > .k-button {\n  vertical-align: middle;\n}\n\n.k-grid .k-command-cell > .k-button + .k-button {\n  margin-left: 8px;\n  margin-inline-end: unset;\n  margin-inline-start: 8px;\n}\n\n.k-grid > .k-resize-handle,\n.k-grid-header .k-resize-handle {\n  height: 25px;\n  cursor: col-resize;\n  position: absolute;\n  z-index: 2;\n}\n\n.k-grid-pager {\n  border-width: 1px 0 0;\n  border-color: inherit;\n  font-size: inherit;\n}\n\n.k-grid-pager-top {\n  border-width: 0 0 1px;\n}\n\n.k-pager-input .k-numerictextbox {\n  margin: 0 7px;\n  width: 3em;\n}\n\n.k-grid-virtual .k-grid-content .k-grid-table-wrap {\n  float: left;\n  width: 100%;\n}\n.k-grid-virtual .k-grid-content .k-grid-table {\n  position: relative;\n  float: left;\n  z-index: 1;\n}\n.k-grid-virtual .k-grid-content > .k-height-container {\n  position: relative;\n  float: left;\n}\n.k-grid-virtual .k-grid-content::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.k-width-container {\n  position: absolute;\n  visibility: hidden;\n}\n\n.k-width-container div {\n  height: 1px;\n}\n\n.k-grid-virtual[dir=rtl] .k-grid-content .k-grid-table,\n.k-grid-virtual.k-rtl .k-grid-content .k-grid-table {\n  float: right;\n}\n\n.k-grid-add-row td {\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n}\n\n.k-grid-lockedcolumns {\n  white-space: nowrap;\n}\n\n.k-grid-content,\n.k-grid-content-locked {\n  white-space: normal;\n}\n\n.k-grid-content-locked,\n.k-grid-footer-locked,\n.k-grid-header-locked {\n  flex: 0 0 auto;\n  display: inline-block;\n  vertical-align: top;\n  overflow: hidden;\n  position: relative;\n  border-style: solid;\n  border-width: 0 1px 0 0;\n  box-sizing: content-box;\n}\n.k-grid-content-locked + .k-grid-content.k-auto-scrollable,\n.k-grid-footer-locked + .k-grid-content.k-auto-scrollable,\n.k-grid-header-locked + .k-grid-content.k-auto-scrollable {\n  display: inline-block;\n}\n\n.k-grid-content,\n.k-grid-footer-wrap,\n.k-grid-header-wrap {\n  flex: 1 1 auto;\n  display: inline-block;\n  vertical-align: top;\n}\n.k-grid-content.k-auto-scrollable,\n.k-grid-footer-wrap.k-auto-scrollable,\n.k-grid-header-wrap.k-auto-scrollable {\n  display: block;\n}\n\n.k-grid-header-locked > table,\n.k-grid-header-wrap > table {\n  margin-bottom: -1px;\n}\n\n.k-grid-header .k-header.k-grid-header-sticky,\n.k-grid-header .k-filter-row .k-grid-header-sticky,\n.k-grid-content-sticky,\n.k-grid-row-sticky,\n.k-grid-footer-sticky {\n  position: sticky;\n  z-index: 2;\n}\n.k-grid-header .k-header.k-grid-header-sticky.k-edit-cell,\n.k-grid-header .k-filter-row .k-grid-header-sticky.k-edit-cell,\n.k-grid-content-sticky.k-edit-cell,\n.k-grid-row-sticky.k-edit-cell,\n.k-grid-footer-sticky.k-edit-cell {\n  overflow: visible;\n  z-index: 3;\n}\n\nkendo-grid tr.k-grid-row-sticky {\n  border: 0;\n  position: static;\n  z-index: auto;\n}\nkendo-grid .k-grid-row-sticky td {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n  position: sticky;\n  top: inherit;\n  bottom: inherit;\n}\nkendo-grid .k-grid-row-sticky td {\n  z-index: 2;\n}\nkendo-grid .k-grid-row-sticky td.k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky.k-alt td.k-grid-content-sticky {\n  z-index: 3;\n}\nkendo-grid .k-grid-header-locked th.k-grid-header-sticky:last-child,\nkendo-grid .k-grid-content-locked tr .k-grid-content-sticky:last-child {\n  border-right: 0;\n}\nkendo-grid .k-grid-header .k-grid-column-menu,\nkendo-grid .k-grid-header .k-grid-header-menu {\n  z-index: 1;\n}\n\n.k-grid-content-sticky.k-grid-row-sticky {\n  z-index: 3;\n}\n\n.k-grid .k-grid-header-sticky,\n.k-grid .k-grid-content-sticky,\n.k-grid .k-grid-footer-sticky {\n  border-right-width: 1px;\n}\n.k-grid .k-grid-header-sticky:not([style*=\"display: none\"]) + td, .k-grid .k-grid-header-sticky:not([style*=\"display: none\"]) + th,\n.k-grid .k-grid-content-sticky:not([style*=\"display: none\"]) + td,\n.k-grid .k-grid-content-sticky:not([style*=\"display: none\"]) + th,\n.k-grid .k-grid-footer-sticky:not([style*=\"display: none\"]) + td,\n.k-grid .k-grid-footer-sticky:not([style*=\"display: none\"]) + th {\n  border-left-width: 0;\n}\n\n.k-grid .k-grid-row-sticky {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n}\n\n.k-grid-header-sticky.k-header.k-grid-no-left-border.k-first {\n  border-left-width: 0;\n}\n\n.k-grid.k-grid-no-scrollbar .k-grid-header-wrap,\n.k-grid.k-grid-no-scrollbar .k-grid-footer-wrap {\n  margin: 0;\n  border-width: 0;\n}\n.k-grid.k-grid-no-scrollbar .k-grid-header,\n.k-grid.k-grid-no-scrollbar .k-grid-footer {\n  padding: 0;\n}\n.k-grid.k-grid-no-scrollbar .k-grid-content {\n  overflow-y: auto;\n}\n\n.k-grid-norecords {\n  text-align: center;\n}\n\ndiv.k-grid-norecords {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.k-grid-norecords-template {\n  box-sizing: border-box;\n  margin: 0 auto;\n  width: 20em;\n  height: 4em;\n  border: 1px solid;\n  line-height: 4em;\n}\n\n.k-header > .k-cell-inner {\n  margin: -8px -12px;\n}\n\n.k-filterable > .k-cell-inner {\n  margin-inline-end: calc(-1 * calc( calc( 1.4285714286em + 8px + 2px ) + 4px ));\n}\n.k-filterable > .k-cell-inner .k-link {\n  padding-inline-end: 0;\n}\n\n.k-cell-inner {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: inherit;\n  overflow: hidden;\n}\n.k-cell-inner > .k-link {\n  padding: 8px 12px;\n  width: auto;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: inherit;\n  flex: 1;\n  overflow: hidden;\n}\n.k-cell-inner > .k-link > .k-icon.k-i-sort-desc-sm,\n.k-cell-inner > .k-link > .k-icon.k-i-sort-asc-sm {\n  margin-left: 0;\n  display: inline-block;\n  flex-shrink: 0;\n}\n.k-cell-inner .k-sort-order {\n  flex-shrink: 0;\n  line-height: normal;\n}\n.k-cell-inner .k-grid-filter,\n.k-cell-inner .k-header-column-menu,\n.k-cell-inner .k-grid-header-menu {\n  position: static;\n  margin-inline-end: 4px;\n}\n.k-cell-inner .k-grid-filter,\n.k-cell-inner .k-header-column-menu,\n.k-cell-inner .k-grid-header-menu,\n.k-cell-inner .k-hierarchy-cell .k-icon {\n  text-align: center;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.k-column-title {\n  min-width: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 1;\n  overflow: hidden;\n}\n\n.k-loading-pdf-mask {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 100;\n}\n.k-loading-pdf-mask > .k-i-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 64px;\n}\n.k-loading-pdf-mask .k-loading-pdf-progress {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.k-pdf-export .k-loading-pdf-mask {\n  display: none;\n}\n\n.k-grid-pdf-export-element {\n  position: absolute;\n  left: -10000px;\n  top: -10000px;\n}\n.k-grid-pdf-export-element .k-filter-row {\n  display: none;\n}\n\n.k-pdf-export-shadow .k-grid {\n  float: left;\n  width: auto !important;\n}\n.k-pdf-export-shadow .k-grid,\n.k-pdf-export-shadow .k-grid-content,\n.k-pdf-export-shadow .k-grid-content-locked {\n  height: auto !important;\n  overflow: visible;\n}\n.k-pdf-export-shadow .k-grid-header-locked + .k-grid-header-wrap, .k-pdf-export-shadow .k-grid-header-locked + .k-grid-content, .k-pdf-export-shadow .k-grid-header-locked + .k-grid-footer-wrap {\n  width: auto !important;\n}\n.k-pdf-export-shadow .k-grid-header,\n.k-pdf-export-shadow .k-grid[data-role=grid] .k-grid-footer {\n  padding: 0 !important;\n}\n\n.k-filter-menu-popup {\n  width: 230px;\n}\n\n.k-filter-menu {\n  box-sizing: border-box;\n}\n\n.k-filter-menu-container {\n  padding: 8px;\n  box-sizing: border-box;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: stretch;\n  gap: 8px;\n}\n.k-filter-menu-container .k-filter-and {\n  width: min-content;\n  align-self: start;\n}\n.k-filter-menu-container .k-actions, .k-filter-menu-container .k-edit-buttons,\n.k-filter-menu-container .k-action-buttons,\n.k-filter-menu-container .k-columnmenu-actions, .k-filter-menu-container .k-form-buttons {\n  margin: 0;\n  padding: 0;\n}\n.k-filter-menu-container kendo-numeric-filter-menu,\n.k-filter-menu-container kendo-grid-string-filter-menu,\n.k-filter-menu-container kendo-grid-date-filter-menu,\n.k-filter-menu-container kendo-grid-numeric-filter-menu,\n.k-filter-menu-container kendo-grid-filter-menu-input-wrapper {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.k-ie .k-filter-menu-container > * {\n  margin-top: 8px;\n}\n.k-ie .k-filter-menu-container > :first-child {\n  margin-top: 0;\n}\n.k-ie .k-filter-menu-container .k-filter-and,\n.k-ie .k-filter-menu-container kendo-grid-filter-menu-input-wrapper > * {\n  margin-top: 8px;\n}\n.k-ie .k-filter-menu-container kendo-grid-filter-menu-input-wrapper > :first-child {\n  margin-top: 0;\n}\n\n.k-filter-menu.k-popup .k-filter-menu-container,\n.k-grid-filter-popup.k-popup .k-filter-menu-container {\n  width: 230px;\n}\n\n.k-popup .k-multicheck-wrap {\n  margin: 0;\n  padding: 0;\n  max-height: 300px;\n  white-space: nowrap;\n  overflow: auto;\n  list-style: none;\n}\n.k-popup .k-multicheck-wrap .k-item,\n.k-popup .k-multicheck-wrap .k-check-all-wrap {\n  padding: 4px 8px;\n  display: flex;\n  flex-flow: row nowrap;\n}\n\n.k-filter-selected-items {\n  font-weight: bold;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.k-autofitting {\n  width: auto !important;\n  table-layout: auto !important;\n}\n.k-autofitting th.k-header,\n.k-autofitting td {\n  white-space: nowrap !important;\n}\n.k-autofitting .k-detail-row {\n  display: none !important;\n}\n\n.k-column-menu-popup,\n.k-grid-columnmenu-popup {\n  width: 230px;\n  box-sizing: border-box;\n}\n.k-popup > .k-column-menu-popup,\n.k-popup > .k-grid-columnmenu-popup {\n  max-width: 100%;\n}\n.k-column-menu-popup .k-actions, .k-column-menu-popup .k-edit-buttons,\n.k-column-menu-popup .k-action-buttons,\n.k-column-menu-popup .k-columnmenu-actions, .k-column-menu-popup .k-form-buttons,\n.k-grid-columnmenu-popup .k-actions,\n.k-grid-columnmenu-popup .k-edit-buttons,\n.k-grid-columnmenu-popup .k-action-buttons,\n.k-grid-columnmenu-popup .k-columnmenu-actions,\n.k-grid-columnmenu-popup .k-form-buttons {\n  margin: 0;\n}\n\n.k-column-menu {\n  box-sizing: border-box;\n}\n.k-column-menu .k-menu:not(.k-context-menu) {\n  font-weight: 400;\n}\n.k-column-menu .k-expander {\n  border: 0;\n  background: inherit;\n}\n.k-column-menu .k-expander .k-columnmenu-item {\n  display: flex;\n  align-items: center;\n}\n\n.k-column-list {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  max-height: 200px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.k-column-chooser-title,\n.k-column-list-item {\n  padding: 4px 8px;\n}\n\n.k-column-list-item {\n  margin: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  position: relative;\n}\n.k-column-list-item .k-checkbox-label {\n  margin: 0;\n}\n\n.k-columns-items-wrap {\n  padding: 6px 0;\n}\n\n.k-columnmenu-item {\n  padding: 4px 8px;\n  outline: 0;\n  cursor: pointer;\n}\n.k-columnmenu-item > .k-icon {\n  margin-right: 4px;\n}\n\n.k-columnmenu-item-wrapper + .k-columnmenu-item-wrapper {\n  border-top: 1px solid;\n  border-top-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-columnmenu-item-content {\n  overflow: hidden;\n}\n\n.k-column-menu-group-header {\n  padding: 4px 8px;\n  display: flex;\n  flex: 0 0 auto;\n  position: relative;\n  user-select: none;\n}\n\n.k-column-menu-group-header-text {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  font-size: 12px;\n  line-height: 1.4285714286;\n  font-weight: bold;\n  text-transform: uppercase;\n  flex: 1 1 auto;\n}\n\n[dir=rtl] .k-columnmenu-item > .k-icon,\n.k-rtl .k-columnmenu-item > .k-icon {\n  margin-left: 4px;\n  margin-right: 0;\n}\n\n.k-ie .k-grid-header,\n.k-ie .k-grid-footer {\n  padding-right: 17px;\n  padding-left: 0;\n  display: block;\n}\n.k-ie [dir=rtl] .k-grid-header,\n.k-ie [dir=rtl] .k-grid-footer,\n.k-ie .k-rtl .k-grid-header,\n.k-ie .k-rtl .k-grid-footer {\n  padding-right: 0;\n  padding-left: 17px;\n}\n\n.k-grid-header,\n.k-header,\nth.k-header,\n.k-grid-header-wrap,\n.k-grouping-header,\n.k-grouping-header .k-group-indicator,\n.k-grid td,\n.k-grid-footer,\n.k-grid-footer-wrap,\n.k-grid-content-locked,\n.k-grid-footer-locked,\n.k-grid-header-locked,\n.k-filter-row > td,\n.k-filter-row > th {\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-grid-header,\n.k-grouping-header,\n.k-grid-add-row,\n.k-grid-footer {\n  color: #424242;\n  background-color: #fafafa;\n}\n\n.k-grid-toolbar {\n  border-color: inherit;\n  box-shadow: none;\n}\n\n.k-grid-content {\n  background-color: #ffffff;\n}\n\n.k-group-footer td,\n.k-grouping-row td,\ntbody .k-group-cell {\n  color: #424242;\n  background-color: #fafafa;\n}\n\n.k-grouping-dropclue::before {\n  border-color: #424242 transparent transparent;\n}\n.k-grouping-dropclue::after {\n  background-color: #424242;\n}\n\n.k-grid {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-grid tr.k-alt {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.k-grid tbody > tr:not(.k-detail-row):hover,\n.k-grid tbody > tr:not(.k-detail-row).k-hover {\n  background-color: #ededed;\n}\n.k-grid td.k-selected,\n.k-grid tr.k-selected > td {\n  background-color: rgba(255, 99, 88, 0.25);\n}\n.k-grid td:focus,\n.k-grid td.k-focus,\n.k-grid th:focus,\n.k-grid th.k-focus,\n.k-grid .k-master-row > td:focus,\n.k-grid .k-grouping-row > td:focus,\n.k-grid .k-detail-row > td:focus,\n.k-grid .k-group-footer > td:focus,\n.k-grid .k-grid-pager.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n.k-grid .k-grid-filter,\n.k-grid .k-header-column-menu,\n.k-grid .k-grid-header-menu,\n.k-grid .k-hierarchy-cell .k-icon {\n  color: #424242;\n}\n.k-grid .k-grouping-row {\n  background-color: #fafafa;\n}\n.k-grid .k-grouping-row .k-icon {\n  color: #424242;\n}\n.k-grid .k-grouping-row .k-grid-content-sticky {\n  border-color: rgba(0, 0, 0, 0.3);\n  border-top-color: rgba(0, 0, 0, 0.08);\n}\n.k-grid .k-grid-header-locked,\n.k-grid .k-grid-content-locked,\n.k-grid .k-grid-header-locked .k-header,\n.k-grid .k-grid-content-locked td {\n  border-color: rgba(0, 0, 0, 0.3);\n}\n.k-grid .k-grid-content-locked .k-group-footer td,\n.k-grid .k-grid-content-locked .k-group-cell {\n  border-color: rgba(0, 0, 0, 0.08);\n}\n.k-grid .k-grid-content-locked .k-grouping-row + tr td {\n  border-top-color: rgba(0, 0, 0, 0.08);\n}\n.k-grid .k-grid-content-locked .k-selected td {\n  background-color: #ffd8d5;\n}\n.k-grid .k-grid-content-locked .k-selected.k-alt td {\n  background-color: #f7d1ce;\n}\n.k-grid .k-grid-content-locked .k-selected:hover td,\n.k-grid .k-grid-content-locked .k-selected.k-hover td {\n  background-color: #f1ccc9;\n}\n.k-grid .k-grid-header-locked .k-header {\n  border-bottom-color: rgba(0, 0, 0, 0.08);\n}\n.k-grid[dir=rtl] th.k-hierarchy-cell,\n.k-grid[dir=rtl] td.k-hierarchy-cell, .k-grid.k-rtl th.k-hierarchy-cell,\n.k-grid.k-rtl td.k-hierarchy-cell {\n  border-left-color: transparent;\n}\n\ncol.k-sorted,\nth.k-sorted {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.k-grid-header .k-i-sort-asc-sm,\n.k-grid-header .k-i-sort-desc-sm,\n.k-grid-header .k-i-sort-asc-small,\n.k-grid-header .k-i-sort-desc-small,\n.k-grid-header .k-sort-order {\n  color: #ff6358;\n}\n.k-grid-header .k-grid-filter:hover,\n.k-grid-header .k-header-column-menu:hover,\n.k-grid-header .k-grid-header-menu:hover,\n.k-grid-header .k-hierarchy-cell .k-icon:hover {\n  background-color: #ebebeb;\n}\n.k-grid-header .k-grid-filter:focus, .k-grid-header .k-grid-filter.k-focus,\n.k-grid-header .k-header-column-menu:focus,\n.k-grid-header .k-header-column-menu.k-focus,\n.k-grid-header .k-grid-header-menu:focus,\n.k-grid-header .k-grid-header-menu.k-focus,\n.k-grid-header .k-hierarchy-cell .k-icon:focus,\n.k-grid-header .k-hierarchy-cell .k-icon.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n.k-grid-header .k-grid-filter.k-active,\n.k-grid-header .k-header-column-menu.k-active,\n.k-grid-header .k-grid-header-menu.k-active,\n.k-grid-header .k-hierarchy-cell .k-icon.k-active {\n  color: white;\n  background-color: #ff6358;\n}\n.k-grid-header th.k-grid-header-sticky,\n.k-grid-header td.k-grid-header-sticky,\n.k-grid-header .k-grid-header-sticky.k-sorted {\n  color: #424242;\n  background-color: #fafafa;\n  border-right-color: rgba(0, 0, 0, 0.3);\n  border-left-color: rgba(0, 0, 0, 0.3);\n}\n\n.k-grid-footer {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #fafafa;\n}\n.k-grid-footer .k-grid-footer-sticky {\n  border-left-color: rgba(0, 0, 0, 0.3);\n  border-right-color: rgba(0, 0, 0, 0.3);\n  background-color: #fafafa;\n}\n\n.k-master-row .k-grid-content-sticky {\n  border-color: rgba(0, 0, 0, 0.3);\n  border-top-color: rgba(0, 0, 0, 0.08);\n  background-color: #ffffff;\n}\n.k-master-row .k-grid-row-sticky {\n  border-top-color: rgba(0, 0, 0, 0.3);\n  border-bottom-color: rgba(0, 0, 0, 0.3);\n  background-color: #ffffff;\n}\n.k-master-row.k-alt .k-grid-content-sticky,\n.k-master-row.k-alt .k-grid-row-sticky {\n  background-color: #f6f6f6;\n}\n.k-master-row.k-selected .k-grid-content-sticky, .k-master-row.k-selected .k-grid-row-sticky,\n.k-master-row td.k-grid-content-sticky.k-selected {\n  background-color: #ffd8d5;\n}\n.k-master-row.k-selected.k-alt .k-grid-content-sticky, .k-master-row.k-selected.k-alt .k-grid-row-sticky, .k-master-row.k-alt td.k-grid-content-sticky.k-selected {\n  background-color: #f7d1ce;\n}\n.k-master-row:hover .k-grid-content-sticky, .k-master-row:hover .k-grid-row-sticky, .k-master-row.k-hover .k-grid-content-sticky, .k-master-row.k-hover .k-grid-row-sticky {\n  background-color: #ebebeb;\n}\n.k-master-row.k-selected:hover .k-grid-content-sticky, .k-master-row.k-selected:hover .k-grid-row-sticky, .k-master-row.k-selected.k-hover .k-grid-content-sticky, .k-master-row.k-selected.k-hover .k-grid-row-sticky, .k-master-row:hover td.k-grid-content-sticky.k-selected, .k-master-row.k-hover td.k-grid-content-sticky.k-selected {\n  background-color: #f1ccc9;\n}\n\nkendo-grid .k-grid-content-sticky {\n  border-top-color: rgba(0, 0, 0, 0.08);\n  border-left-color: rgba(0, 0, 0, 0.3);\n  border-right-color: rgba(0, 0, 0, 0.3);\n  background-color: #ffffff;\n}\nkendo-grid .k-grid-content-sticky:hover, kendo-grid .k-grid-content-sticky.k-hover {\n  background-color: #ebebeb;\n}\nkendo-grid .k-grid-row-sticky td {\n  border-top-color: rgba(0, 0, 0, 0.3);\n  border-bottom-color: rgba(0, 0, 0, 0.3);\n  background-color: #ffffff;\n}\nkendo-grid .k-grid-row-sticky:hover td, kendo-grid .k-grid-row-sticky.k-hover td {\n  background-color: #ebebeb;\n}\nkendo-grid .k-alt .k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky.k-alt td {\n  background-color: #f6f6f6;\n}\nkendo-grid tr.k-selected .k-grid-content-sticky,\nkendo-grid .k-selected.k-grid-row-sticky td,\nkendo-grid .k-grid-row-sticky td.k-selected,\nkendo-grid .k-selected.k-grid-content-sticky {\n  background-color: #ffd8d5;\n}\nkendo-grid tr.k-selected.k-alt .k-grid-content-sticky,\nkendo-grid .k-selected.k-alt.k-grid-row-sticky td,\nkendo-grid .k-alt .k-selected.k-grid-content-sticky {\n  background-color: #f7d1ce;\n}\nkendo-grid tr:hover .k-grid-content-sticky,\nkendo-grid tr.k-hover .k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky:hover td,\nkendo-grid .k-grid-row-sticky.k-hover td,\nkendo-grid .k-grid-row-sticky.k-alt:hover td,\nkendo-grid .k-grid-row-sticky.k-alt.k-hover td,\nkendo-grid .k-alt:hover .k-grid-content-sticky,\nkendo-grid .k-alt.k-hover .k-grid-content-sticky {\n  background-color: #ebebeb;\n}\nkendo-grid tr.k-selected:hover .k-grid-content-sticky,\nkendo-grid tr.k-selected.k-hover .k-grid-content-sticky,\nkendo-grid .k-selected.k-grid-row-sticky:hover td,\nkendo-grid .k-selected.k-grid-row-sticky.k-hover td,\nkendo-grid .k-selected.k-alt.k-grid-row-sticky:hover td,\nkendo-grid .k-selected.k-alt.k-grid-row-sticky.k-hover td,\nkendo-grid tr.k-selected.k-alt:hover .k-grid-content-sticky,\nkendo-grid tr.k-selected.k-alt.k-hover .k-grid-content-sticky,\nkendo-grid .k-grid-row-sticky:hover td.k-selected,\nkendo-grid .k-grid-row-sticky.k-hover td.k-selected,\nkendo-grid tr:hover .k-grid-content-sticky.k-selected,\nkendo-grid tr.k-hover .k-grid-content-sticky.k-selected {\n  background-color: #f1ccc9;\n}\n\n.k-grouping-row .k-grid-content-sticky {\n  background-color: #fafafa;\n}\n.k-grouping-row:hover .k-grid-content-sticky, .k-grouping-row.k-hover .k-grid-content-sticky {\n  background-color: #ebebeb;\n}\n\n.k-column-list-item:hover,\n.k-columnmenu-item:hover {\n  color: #424242;\n  background-color: #f0f0f0;\n}\n\n.k-columnmenu-item:focus,\n.k-columnmenu-item.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n\n.k-columnmenu-item.k-selected {\n  color: white;\n  background-color: #ff6358;\n}\n\n.k-column-menu .k-menu:not(.k-context-menu) {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n  background-color: #ffffff;\n}\n.k-column-menu .k-menu:not(.k-context-menu) .k-item:hover, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-hover {\n  color: #424242;\n  background-color: #f0f0f0;\n}\n.k-column-menu .k-menu:not(.k-context-menu) .k-item.k-selected {\n  color: white;\n  background-color: #ff6358;\n}\n.k-column-menu .k-menu:not(.k-context-menu) .k-item:focus, .k-column-menu .k-menu:not(.k-context-menu) .k-item.k-focus {\n  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.12);\n}\n\n.k-column-menu-group-header-text {\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #424242;\n}\n\n.k-check-all-wrap {\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.k-grid-norecords-template {\n  background-color: #ffffff;\n  border-color: rgba(0, 0, 0, 0.08);\n}";
styleInject(css_248z);

var reactIs$5 = {exports: {}};

var reactIs_production_min$3 = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$5=Symbol.for("react.element"),c$3=Symbol.for("react.portal"),d$3=Symbol.for("react.fragment"),e$3=Symbol.for("react.strict_mode"),f$4=Symbol.for("react.profiler"),g$6=Symbol.for("react.provider"),h$4=Symbol.for("react.context"),k$5=Symbol.for("react.server_context"),l$3=Symbol.for("react.forward_ref"),m$4=Symbol.for("react.suspense"),n$4=Symbol.for("react.suspense_list"),p$4=Symbol.for("react.memo"),q$6=Symbol.for("react.lazy"),t$3=Symbol.for("react.offscreen"),u$1;u$1=Symbol.for("react.module.reference");
function v$5(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b$5:switch(a=a.type,a){case d$3:case f$4:case e$3:case m$4:case n$4:return a;default:switch(a=a&&a.$$typeof,a){case k$5:case h$4:case l$3:case q$6:case p$4:case g$6:return a;default:return r}}case c$3:return r}}}reactIs_production_min$3.ContextConsumer=h$4;reactIs_production_min$3.ContextProvider=g$6;reactIs_production_min$3.Element=b$5;reactIs_production_min$3.ForwardRef=l$3;reactIs_production_min$3.Fragment=d$3;reactIs_production_min$3.Lazy=q$6;reactIs_production_min$3.Memo=p$4;reactIs_production_min$3.Portal=c$3;reactIs_production_min$3.Profiler=f$4;reactIs_production_min$3.StrictMode=e$3;reactIs_production_min$3.Suspense=m$4;
reactIs_production_min$3.SuspenseList=n$4;reactIs_production_min$3.isAsyncMode=function(){return !1};reactIs_production_min$3.isConcurrentMode=function(){return !1};reactIs_production_min$3.isContextConsumer=function(a){return v$5(a)===h$4};reactIs_production_min$3.isContextProvider=function(a){return v$5(a)===g$6};reactIs_production_min$3.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$5};reactIs_production_min$3.isForwardRef=function(a){return v$5(a)===l$3};reactIs_production_min$3.isFragment=function(a){return v$5(a)===d$3};reactIs_production_min$3.isLazy=function(a){return v$5(a)===q$6};reactIs_production_min$3.isMemo=function(a){return v$5(a)===p$4};
reactIs_production_min$3.isPortal=function(a){return v$5(a)===c$3};reactIs_production_min$3.isProfiler=function(a){return v$5(a)===f$4};reactIs_production_min$3.isStrictMode=function(a){return v$5(a)===e$3};reactIs_production_min$3.isSuspense=function(a){return v$5(a)===m$4};reactIs_production_min$3.isSuspenseList=function(a){return v$5(a)===n$4};
reactIs_production_min$3.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$3||a===f$4||a===e$3||a===m$4||a===n$4||a===t$3||"object"===typeof a&&null!==a&&(a.$$typeof===q$6||a.$$typeof===p$4||a.$$typeof===g$6||a.$$typeof===h$4||a.$$typeof===l$3||a.$$typeof===u$1||void 0!==a.getModuleId)?!0:!1};reactIs_production_min$3.typeOf=v$5;

var reactIs_development$3 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE = Symbol.for('react.element');
var REACT_PORTAL_TYPE = Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
var REACT_CONTEXT_TYPE = Symbol.for('react.context');
var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE = Symbol.for('react.memo');
var REACT_LAZY_TYPE = Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_SERVER_CONTEXT_TYPE:
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
function isSuspenseList(object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
}

reactIs_development$3.ContextConsumer = ContextConsumer;
reactIs_development$3.ContextProvider = ContextProvider;
reactIs_development$3.Element = Element;
reactIs_development$3.ForwardRef = ForwardRef;
reactIs_development$3.Fragment = Fragment;
reactIs_development$3.Lazy = Lazy;
reactIs_development$3.Memo = Memo;
reactIs_development$3.Portal = Portal;
reactIs_development$3.Profiler = Profiler;
reactIs_development$3.StrictMode = StrictMode;
reactIs_development$3.Suspense = Suspense;
reactIs_development$3.SuspenseList = SuspenseList;
reactIs_development$3.isAsyncMode = isAsyncMode;
reactIs_development$3.isConcurrentMode = isConcurrentMode;
reactIs_development$3.isContextConsumer = isContextConsumer;
reactIs_development$3.isContextProvider = isContextProvider;
reactIs_development$3.isElement = isElement;
reactIs_development$3.isForwardRef = isForwardRef;
reactIs_development$3.isFragment = isFragment;
reactIs_development$3.isLazy = isLazy;
reactIs_development$3.isMemo = isMemo;
reactIs_development$3.isPortal = isPortal;
reactIs_development$3.isProfiler = isProfiler;
reactIs_development$3.isStrictMode = isStrictMode;
reactIs_development$3.isSuspense = isSuspense;
reactIs_development$3.isSuspenseList = isSuspenseList;
reactIs_development$3.isValidElementType = isValidElementType;
reactIs_development$3.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$5.exports = reactIs_production_min$3;
} else {
  reactIs$5.exports = reactIs_development$3;
}

function stylis_min$1 (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys$1 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid$1 = /* #__PURE__ */memoize$1(function (prop) {
  return reactPropsRegex$1.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs$4 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$4="function"===typeof Symbol&&Symbol.for,c$2=b$4?Symbol.for("react.element"):60103,d$2=b$4?Symbol.for("react.portal"):60106,e$2=b$4?Symbol.for("react.fragment"):60107,f$3=b$4?Symbol.for("react.strict_mode"):60108,g$5=b$4?Symbol.for("react.profiler"):60114,h$3=b$4?Symbol.for("react.provider"):60109,k$4=b$4?Symbol.for("react.context"):60110,l$2=b$4?Symbol.for("react.async_mode"):60111,m$3=b$4?Symbol.for("react.concurrent_mode"):60111,n$3=b$4?Symbol.for("react.forward_ref"):60112,p$3=b$4?Symbol.for("react.suspense"):60113,q$5=b$4?
Symbol.for("react.suspense_list"):60120,r$1=b$4?Symbol.for("react.memo"):60115,t$2=b$4?Symbol.for("react.lazy"):60116,v$4=b$4?Symbol.for("react.block"):60121,w$3=b$4?Symbol.for("react.fundamental"):60117,x$3=b$4?Symbol.for("react.responder"):60118,y$3=b$4?Symbol.for("react.scope"):60119;
function z$3(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$2:case m$3:case e$2:case g$5:case f$3:case p$3:return a;default:switch(a=a&&a.$$typeof,a){case k$4:case n$3:case t$2:case r$1:case h$3:return a;default:return u}}case d$2:return u}}}function A$1(a){return z$3(a)===m$3}reactIs_production_min$2.AsyncMode=l$2;reactIs_production_min$2.ConcurrentMode=m$3;reactIs_production_min$2.ContextConsumer=k$4;reactIs_production_min$2.ContextProvider=h$3;reactIs_production_min$2.Element=c$2;reactIs_production_min$2.ForwardRef=n$3;reactIs_production_min$2.Fragment=e$2;reactIs_production_min$2.Lazy=t$2;reactIs_production_min$2.Memo=r$1;reactIs_production_min$2.Portal=d$2;
reactIs_production_min$2.Profiler=g$5;reactIs_production_min$2.StrictMode=f$3;reactIs_production_min$2.Suspense=p$3;reactIs_production_min$2.isAsyncMode=function(a){return A$1(a)||z$3(a)===l$2};reactIs_production_min$2.isConcurrentMode=A$1;reactIs_production_min$2.isContextConsumer=function(a){return z$3(a)===k$4};reactIs_production_min$2.isContextProvider=function(a){return z$3(a)===h$3};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};reactIs_production_min$2.isForwardRef=function(a){return z$3(a)===n$3};reactIs_production_min$2.isFragment=function(a){return z$3(a)===e$2};reactIs_production_min$2.isLazy=function(a){return z$3(a)===t$2};
reactIs_production_min$2.isMemo=function(a){return z$3(a)===r$1};reactIs_production_min$2.isPortal=function(a){return z$3(a)===d$2};reactIs_production_min$2.isProfiler=function(a){return z$3(a)===g$5};reactIs_production_min$2.isStrictMode=function(a){return z$3(a)===f$3};reactIs_production_min$2.isSuspense=function(a){return z$3(a)===p$3};
reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$3||a===g$5||a===f$3||a===p$3||a===q$5||"object"===typeof a&&null!==a&&(a.$$typeof===t$2||a.$$typeof===r$1||a.$$typeof===h$3||a.$$typeof===k$4||a.$$typeof===n$3||a.$$typeof===w$3||a.$$typeof===x$3||a.$$typeof===y$3||a.$$typeof===v$4)};reactIs_production_min$2.typeOf=z$3;

var reactIs_development$2 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$2.AsyncMode = AsyncMode;
reactIs_development$2.ConcurrentMode = ConcurrentMode;
reactIs_development$2.ContextConsumer = ContextConsumer;
reactIs_development$2.ContextProvider = ContextProvider;
reactIs_development$2.Element = Element;
reactIs_development$2.ForwardRef = ForwardRef;
reactIs_development$2.Fragment = Fragment;
reactIs_development$2.Lazy = Lazy;
reactIs_development$2.Memo = Memo;
reactIs_development$2.Portal = Portal;
reactIs_development$2.Profiler = Profiler;
reactIs_development$2.StrictMode = StrictMode;
reactIs_development$2.Suspense = Suspense;
reactIs_development$2.isAsyncMode = isAsyncMode;
reactIs_development$2.isConcurrentMode = isConcurrentMode;
reactIs_development$2.isContextConsumer = isContextConsumer;
reactIs_development$2.isContextProvider = isContextProvider;
reactIs_development$2.isElement = isElement;
reactIs_development$2.isForwardRef = isForwardRef;
reactIs_development$2.isFragment = isFragment;
reactIs_development$2.isLazy = isLazy;
reactIs_development$2.isMemo = isMemo;
reactIs_development$2.isPortal = isPortal;
reactIs_development$2.isProfiler = isProfiler;
reactIs_development$2.isStrictMode = isStrictMode;
reactIs_development$2.isSuspense = isSuspense;
reactIs_development$2.isValidElementType = isValidElementType;
reactIs_development$2.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$4.exports = reactIs_production_min$2;
} else {
  reactIs$4.exports = reactIs_development$2;
}

var reactIs$3 = reactIs$4.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS$1 = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$1 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS$1 = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS$1 = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS$1 = {};
TYPE_STATICS$1[reactIs$3.ForwardRef] = FORWARD_REF_STATICS$1;
TYPE_STATICS$1[reactIs$3.Memo] = MEMO_STATICS$1;

function getStatics$1(component) {
  // React v16.11 and below
  if (reactIs$3.isMemo(component)) {
    return MEMO_STATICS$1;
  } // React v16.12 and above


  return TYPE_STATICS$1[component['$$typeof']] || REACT_STATICS$1;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype$1 = Object.prototype;
function hoistNonReactStatics$1(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype$1) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype$1) {
        hoistNonReactStatics$1(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$1(sourceComponent);

    if (getOwnPropertySymbols$2) {
      keys = keys.concat(getOwnPropertySymbols$2(sourceComponent));
    }

    var targetStatics = getStatics$1(targetComponent);
    var sourceStatics = getStatics$1(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS$1[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs$1 = hoistNonReactStatics$1;

function y$2(){return (y$2=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var v$3=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g$4=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIs$5.exports.typeOf(t)},S$1=Object.freeze([]),w$2=Object.freeze({});function E$1(e){return "function"==typeof e}function b$3(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function _$1(e){return e&&"string"==typeof e.styledComponentId}var N$1="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C$1="undefined"!=typeof window&&"HTMLElement"in window,I$1=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),O$1="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R$1(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t);})),e}function D$1(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw "production"===process.env.NODE_ENV?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R$1.apply(void 0,[O$1[e]].concat(n)).trim())}var j$1=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D$1(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T$1=new Map,x$2=new Map,k$3=1,V$1=function(e){if(T$1.has(e))return T$1.get(e);for(;x$2.has(k$3);)k$3++;var t=k$3++;return "production"!==process.env.NODE_ENV&&((0|t)<0||t>1<<30)&&D$1(16,""+t),T$1.set(e,t),x$2.set(t,e),t},z$2=function(e){return x$2.get(e)},B$1=function(e,t){t>=k$3&&(k$3=t+1),T$1.set(e,t),x$2.set(t,e);},M$1="style["+N$1+'][data-styled-version="5.3.6"]',G$1=new RegExp("^"+N$1+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L$1=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},F$1=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G$1);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(B$1(u,c),L$1(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},Y$1=function(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null},q$4=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N$1))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N$1,"active"),r.setAttribute("data-styled-version","5.3.6");var i=Y$1();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H$1=function(){function e(e){var t=this.element=q$4(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D$1(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$$1=function(){function e(e){var t=this.element=q$4(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return !1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W$1=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U$1=C$1,J$1={isServer:!C$1,useCSSOMInjection:!I$1},X$1=function(){function e(e,t,n){void 0===e&&(e=w$2),void 0===t&&(t={}),this.options=y$2({},J$1,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C$1&&U$1&&(U$1=!1,function(e){for(var t=document.querySelectorAll(M$1),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N$1)&&(F$1(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return V$1(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y$2({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W$1(o):r?new H$1(o):new $$1(o),new j$1(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V$1(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V$1(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(V$1(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z$2(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N$1+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),Z$1=/(a)(d)/gi,K$1=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q$1(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K$1(t%52)+n;return (K$1(t%52)+n).replace(Z$1,"$1-$2")}var ee$1=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te$1=function(e){return ee$1(5381,e)};function ne$1(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E$1(n)&&!_$1(n))return !1}return !0}var re$1=te$1("5.3.6"),oe$1=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&ne$1(e),this.componentId=t,this.baseHash=ee$1(re$1,t),this.baseStyle=n,X$1.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=_e$1(this.rules,e,t,n).join(""),i=Q$1(ee$1(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=ee$1(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!==process.env.NODE_ENV&&(u=ee$1(u,h+d));else if(h){var p=_e$1(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee$1(u,f+d),l+=f;}}if(l){var m=Q$1(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y);}o.push(m);}}return o.join(" ")},e}(),se$1=/^\s*\/\/.*$/gm,ie$1=[":","[",".","#"];function ae$1(e){var t,n,r,o,s=void 0===e?w$2:e,i=s.options,a=void 0===i?w$2:i,c=s.plugins,u=void 0===c?S$1:c,l=new stylis_min$1(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t);}}}((function(e){d.push(e);})),f=function(e,r,s){return 0===r&&-1!==ie$1.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se$1,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D$1(15),ee$1(e,t.name)}),5381).toString():"",m}var ce$1=React__default.createContext();ce$1.Consumer;var le$1=React__default.createContext(),de$1=(le$1.Consumer,new X$1),he$1=ae$1();function pe$1(){return useContext(ce$1)||de$1}function fe$1(){return useContext(le$1)||he$1}var ye$1=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he$1);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return D$1(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=he$1),this.name+e.hash},e}(),ve$1=/([A-Z])/,ge$1=/([A-Z])/g,Se$1=/^ms-/,we$1=function(e){return "-"+e.toLowerCase()};function Ee$1(e){return ve$1.test(e)?e.replace(ge$1,we$1).replace(Se$1,"-ms-"):e}var be$1=function(e){return null==e||!1===e||""===e};function _e$1(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e$1(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be$1(e))return "";if(_$1(e))return "."+e.styledComponentId;if(E$1(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return "production"!==process.env.NODE_ENV&&reactIs$5.exports.isElement(u)&&console.warn(b$3(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),_e$1(u,n,r,o)}var l;return e instanceof ye$1?r?(e.inject(r,o),e.getName(o)):e:g$4(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be$1(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E$1(t[i])?s.push(Ee$1(i)+":",t[i],";"):g$4(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee$1(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys$1?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne$1=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae$1(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E$1(e)||g$4(e)?Ne$1(_e$1(v$3(S$1,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne$1(_e$1(v$3(e,n)))}var Ce$1=/invalid hook call/i,Ie$1=new Set,Pe$1=function(e,t){if("production"!==process.env.NODE_ENV){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",r=console.error;try{var o=!0;console.error=function(e){if(Ce$1.test(e))o=!1,Ie$1.delete(n);else {for(var t=arguments.length,s=new Array(t>1?t-1:0),i=1;i<t;i++)s[i-1]=arguments[i];r.apply(void 0,[e].concat(s));}},useRef(),o&&!Ie$1.has(n)&&(console.warn(n),Ie$1.add(n));}catch(e){Ce$1.test(e.message)&&Ie$1.delete(n);}finally{console.error=r;}}},Oe$1=function(e,t,n){return void 0===n&&(n=w$2),e.theme!==n.theme&&e.theme||t||n.theme},Re$1=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De$1=/(^-|-$)/g;function je$1(e){return e.replace(Re$1,"-").replace(De$1,"")}var Te$1=function(e){return Q$1(te$1(e)>>>0)};function xe$1(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var ke$1=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve$1=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze$1(e,t,n){var r=e[n];ke$1(t)&&ke$1(r)?Be$1(r,t):e[n]=t;}function Be$1(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke$1(i))for(var a in i)Ve$1(a)&&ze$1(e,i[a],a);}return e}var Me$1=React__default.createContext();Me$1.Consumer;var Fe$1={};function Ye$1(e,t,n){var o=_$1(e),i=!xe$1(e),a=t.attrs,c=void 0===a?S$1:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":je$1(e);Fe$1[n]=(Fe$1[n]||0)+1;var r=n+"-"+Te$1("5.3.6"+n+Fe$1[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,v=void 0===p?function(e){return xe$1(e)?"styled."+e:"Styled("+b$3(e)+")"}(e):p,g=t.displayName&&t.componentId?je$1(t.displayName)+"-"+t.componentId:t.componentId||h,N=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new oe$1(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target;"production"!==process.env.NODE_ENV&&useDebugValue(h);var m=function(e,t,n){void 0===e&&(e=w$2);var r=y$2({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E$1(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Oe$1(t,useContext(Me$1),a)||w$2,t,o),v=m[0],g=m[1],S=function(e,t,n,r){var o=pe$1(),s=fe$1(),i=t?e.generateAndInjectStyles(w$2,o,s):e.generateAndInjectStyles(n,o,s);return "production"!==process.env.NODE_ENV&&useDebugValue(i),"production"!==process.env.NODE_ENV&&!t&&r&&r(i),i}(i,r,v,"production"!==process.env.NODE_ENV?e.warnTooManyClasses:void 0),b=n,_=g.$as||t.$as||g.as||t.as||p,N=xe$1(_),A=g!==t?y$2({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,isPropValid$1,_):!N||isPropValid$1(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=y$2({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=b,createElement(_,C)}(C,e,t,P)};return O.displayName=v,(C=React__default.forwardRef(O)).attrs=N,C.componentStyle=I,C.displayName=v,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S$1,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe$1(e)?e:je$1(b$3(e)));return Ye$1(e,y$2({},o,{attrs:N,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Be$1({},e.defaultProps,t):t;}}),"production"!==process.env.NODE_ENV&&(Pe$1(v,g),C.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={};}}}(v,g)),C.toString=function(){return "."+C.styledComponentId},i&&hoistNonReactStatics_cjs$1(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var qe$1=function(e){return function e(t,r,o){if(void 0===o&&(o=w$2),!reactIs$5.exports.isValidElementType(r))return D$1(1,String(r));var s=function(){return t(r,o,Ae$1.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y$2({},o,{},n))},s.attrs=function(n){return e(t,r,y$2({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye$1,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe$1[e]=qe$1(e);}));"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1);var styled = qe$1;

var convertPctToAlpha = function (pct) { return (pct / 100).toFixed(1); };
var palette = {
    white: "#ffffff",
    gray: {
        "5": "#F9F9F9",
        "10": "#F5F5F5",
        "15": "#EEEEEE",
        "20": "#DDDDDD",
        "30": "#CCCCCC",
        "40": "#BBBBBB",
        "60": "#AAAAAA",
        "70": "#999999",
        "80": "#888888",
        "100": "#666666",
        "110": "#424242",
        "120": "#333333",
        "130": "#222222",
        "140": "#00000029",
        "150": "#495057",
    },
    primary: {
        "5": "#FDF2F4",
        "10": "#FBE6EA",
        "15": "#F9D9DF",
        "20": "#F7CCD4",
        "30": "#F2B3BF",
        "40": "#ED99A9",
        "60": "#E3667F",
        "70": "#E34D6A",
        "80": "#DE3355",
        "100": "#D6002A",
        "120": "#AB0021",
        "130": "#92001C",
    },
    secondary: {
        "5": "#F7F9FB",
        "10": "#F0F3F8",
        "15": "#E9EDF3",
        "20": "#CCE3EC",
        "30": "#B3D5E2",
        "40": "#99C7D8",
        "60": "#66AAC5",
        "70": "#4D9DBC",
        "80": "#338EB1",
        "100": "#00729E",
        "120": "#005B7E",
        "130": "#004F6E",
    },
    info: {
        "5": "#F2F8FA",
        "10": "#E6F1F6",
        "15": "#D9EAF1",
        "20": "#CCE3EC",
        "30": "#B3D5E2",
        "40": "#99C7D8",
        "60": "#66AAC5",
        "70": "#4D9DBC",
        "80": "#338EB1",
        "100": "#00729E",
        "120": "#005B7E",
        "130": "#004F6E",
        "140": "#007EB3",
        "150": "#00729e33",
        "160": "#00729e1a",
        "170": "#adb5bd",
        "180": "#1e7bd8",
    },
    success: {
        "5": "#F2F9F6",
        "10": "#E7F5EE",
        "15": "#DAEFE4",
        "20": "#CDE9DB",
        "30": "#B5DFCA",
        "40": "#9BD3B7",
        "60": "#6ABE94",
        "70": "#51B382",
        "80": "#38A870",
        "100": "#06924C",
        "120": "#04743C",
        "130": "#046635",
        "140": "#0A8543",
        "150": "#43ff64d9",
    },
    warning: {
        "5": "#FDF9F2",
        "10": "#FDF5E6",
        "15": "#FBEFD9",
        "20": "#FAE9CC",
        "30": "#F8DFB3",
        "40": "#F5D499",
        "60": "#EFBE66",
        "70": "#EDB44D",
        "80": "#EAA933",
        "100": "#E59300",
        "120": "#B77500",
        "130": "#A06600",
        "140": "#e03131",
        "150": "#F08C00",
        "160": "#95001D",
    },
    error: {
        "5": "#FCF3F3",
        "10": "#F9E9E9",
        "15": "#F6DDDD",
        "20": "#F3D2D2",
        "30": "#EDBCBC",
        "40": "#E7A5A5",
        "60": "#DB7777",
        "70": "#D56161",
        "80": "#CF4A4A",
        "100": "#C31D1D",
        "120": "#9B1717",
        "130": "#881414",
    },
    subtle: {
        "5": "#00729e33"
    }
};
var EDMColors = {
    teal: {
        primary: '#008080',
        dark: '#007070',
        darkest: '#006060',
        getPrimaryShade: function (opacityPercent) {
            return "rgba(0, 128, 128, ".concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
    red: {
        primary: '#D10029',
        dark: '#AB0021',
        darkest: '#95001D',
        tertiary: '#D6002A',
    },
    gradient: {
        from: '#04A464',
        to: '#20A7DB'
    },
    gray: {
        white: '#FFFFFF',
        disabled: '#EEEEEE',
        getPrimaryShade: function (opacityPercent) {
            return "".concat(palette.gray[130], ", ").concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
    success: {
        primary: '#06924c',
        dark: '#007836',
        darkest: '#006C2A',
        getPrimaryShade: function (opacityPercent) {
            return "".concat(palette.success[140], ", ").concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
    info: {
        primary: '#007EB3',
        dark: '#0071A6',
        darkest: '#00659A',
        getPrimaryShade: function (opacityPercent) {
            return "".concat(palette.info[140], ", ").concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
    warning: {
        primary: '#F08C00',
        dark: '#E37F00',
        darkest: '#D77300',
        getPrimaryShade: function (opacityPercent) {
            return "".concat(palette.warning[150], ", ").concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
    error: {
        primary: '#c31d1d',
        dark: '#D32424',
        darkest: '#C71818',
        hover: '#9b1717',
        getPrimaryShade: function (opacityPercent) {
            return "".concat(palette.warning[140], ", ").concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
    text: {
        primary: '#333333',
        secondary: '#666666',
        white: '#FFFFFF'
    },
    focus: "#66AAC5",
    secondary: {
        primary: '#00729E',
        getPrimaryShade: function (opacityPercent) {
            return "".concat(palette.secondary[100], ",").concat(convertPctToAlpha(opacityPercent), ")");
        }
    },
};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2=Symbol.for("react.element"),c$1=Symbol.for("react.portal"),d$1=Symbol.for("react.fragment"),e$1=Symbol.for("react.strict_mode"),f$2=Symbol.for("react.profiler"),g$3=Symbol.for("react.provider"),h$2=Symbol.for("react.context"),k$2=Symbol.for("react.server_context"),l$1=Symbol.for("react.forward_ref"),m$2=Symbol.for("react.suspense"),n$2=Symbol.for("react.suspense_list"),p$2=Symbol.for("react.memo"),q$3=Symbol.for("react.lazy"),t$1=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v$2(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b$2:switch(a=a.type,a){case d$1:case f$2:case e$1:case m$2:case n$2:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case h$2:case l$1:case q$3:case p$2:case g$3:return a;default:return r}}case c$1:return r}}}reactIs_production_min$1.ContextConsumer=h$2;reactIs_production_min$1.ContextProvider=g$3;reactIs_production_min$1.Element=b$2;reactIs_production_min$1.ForwardRef=l$1;reactIs_production_min$1.Fragment=d$1;reactIs_production_min$1.Lazy=q$3;reactIs_production_min$1.Memo=p$2;reactIs_production_min$1.Portal=c$1;reactIs_production_min$1.Profiler=f$2;reactIs_production_min$1.StrictMode=e$1;reactIs_production_min$1.Suspense=m$2;
reactIs_production_min$1.SuspenseList=n$2;reactIs_production_min$1.isAsyncMode=function(){return !1};reactIs_production_min$1.isConcurrentMode=function(){return !1};reactIs_production_min$1.isContextConsumer=function(a){return v$2(a)===h$2};reactIs_production_min$1.isContextProvider=function(a){return v$2(a)===g$3};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$2};reactIs_production_min$1.isForwardRef=function(a){return v$2(a)===l$1};reactIs_production_min$1.isFragment=function(a){return v$2(a)===d$1};reactIs_production_min$1.isLazy=function(a){return v$2(a)===q$3};reactIs_production_min$1.isMemo=function(a){return v$2(a)===p$2};
reactIs_production_min$1.isPortal=function(a){return v$2(a)===c$1};reactIs_production_min$1.isProfiler=function(a){return v$2(a)===f$2};reactIs_production_min$1.isStrictMode=function(a){return v$2(a)===e$1};reactIs_production_min$1.isSuspense=function(a){return v$2(a)===m$2};reactIs_production_min$1.isSuspenseList=function(a){return v$2(a)===n$2};
reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$2||a===e$1||a===m$2||a===n$2||a===t$1||"object"===typeof a&&null!==a&&(a.$$typeof===q$3||a.$$typeof===p$2||a.$$typeof===g$3||a.$$typeof===h$2||a.$$typeof===l$1||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min$1.typeOf=v$2;

var reactIs_development$1 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE = Symbol.for('react.element');
var REACT_PORTAL_TYPE = Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
var REACT_CONTEXT_TYPE = Symbol.for('react.context');
var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE = Symbol.for('react.memo');
var REACT_LAZY_TYPE = Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_SERVER_CONTEXT_TYPE:
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
function isSuspenseList(object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
}

reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.SuspenseList = SuspenseList;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isSuspenseList = isSuspenseList;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$1;
} else {
  reactIs$2.exports = reactIs_development$1;
}

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c=b$1?Symbol.for("react.element"):60103,d=b$1?Symbol.for("react.portal"):60106,e=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$2=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$2=b$1?
Symbol.for("react.suspense_list"):60120,r=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m$1:case e:case g$2:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t:case r:case h$1:return a;default:return u}}case d:return u}}}function A(a){return z$1(a)===m$1}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h$1;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n$1;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g$2;reactIs_production_min.StrictMode=f$1;reactIs_production_min.Suspense=p$1;reactIs_production_min.isAsyncMode=function(a){return A(a)||z$1(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z$1(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z$1(a)===h$1};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z$1(a)===n$1};reactIs_production_min.isFragment=function(a){return z$1(a)===e};reactIs_production_min.isLazy=function(a){return z$1(a)===t};
reactIs_production_min.isMemo=function(a){return z$1(a)===r};reactIs_production_min.isPortal=function(a){return z$1(a)===d};reactIs_production_min.isProfiler=function(a){return z$1(a)===g$2};reactIs_production_min.isStrictMode=function(a){return z$1(a)===f$1};reactIs_production_min.isSuspense=function(a){return z$1(a)===p$1};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m$1||a===g$2||a===f$1||a===p$1||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};reactIs_production_min.typeOf=z$1;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function y(){return (y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g$1=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIs$2.exports.typeOf(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return "function"==typeof e}function b(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),P={},O="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t);})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw "production"===process.env.NODE_ENV?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R.apply(void 0,[O[e]].concat(n)).trim())}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return "production"!==process.env.NODE_ENV&&((0|t)<0||t>1<<30)&&D(16,""+t),T.set(e,t),x.set(t,e),t},z=function(e){return x.get(e)},B=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e);},M="style["+N+'][data-styled-version="5.3.6"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(B(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},Y=function(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null},q$1=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.6");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q$1(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q$1(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return !1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return (K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return !1}return !0}var re=te("5.3.6"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!==process.env.NODE_ENV&&(u=ee(u,h+d));else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f;}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y);}o.push(m);}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_min(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t);}}}((function(e){d.push(e);})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=React__default.createContext();ce.Consumer;var le=React__default.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return useContext(ce)||de}function fe(){return useContext(le)||he}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return "-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return "";if(_(e))return "."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return "production"!==process.env.NODE_ENV&&reactIs$2.exports.isElement(u)&&console.warn(b(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g$1(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g$1(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g$1(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if("production"!==process.env.NODE_ENV){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",r=console.error;try{var o=!0;console.error=function(e){if(Ce.test(e))o=!1,Ie.delete(n);else {for(var t=arguments.length,s=new Array(t>1?t-1:0),i=1;i<t;i++)s[i-1]=arguments[i];r.apply(void 0,[e].concat(s));}},useRef(),o&&!Ie.has(n)&&(console.warn(n),Ie.add(n));}catch(e){Ce.test(e.message)&&Ie.delete(n);}finally{console.error=r;}}},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var ke=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];ke(t)&&ke(r)?Be(r,t):e[n]=t;}function Be(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&ze(e,i[a],a);}return e}var Me=React__default.createContext();Me.Consumer;var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.6"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,v=void 0===p?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):p,g=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||h,N=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new oe(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target;"production"!==process.env.NODE_ENV&&useDebugValue(h);var m=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Oe(t,useContext(Me),a)||w,t,o),v=m[0],g=m[1],S=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return "production"!==process.env.NODE_ENV&&useDebugValue(i),"production"!==process.env.NODE_ENV&&!t&&r&&r(i),i}(i,r,v,"production"!==process.env.NODE_ENV?e.warnTooManyClasses:void 0),b=n,_=g.$as||t.$as||g.as||t.as||p,N=xe(_),A=g!==t?y({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,isPropValid,_):!N||isPropValid(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=y({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=b,createElement(_,C)}(C,e,t,P)};return O.displayName=v,(C=React__default.forwardRef(O)).attrs=N,C.componentStyle=I,C.displayName=v,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:N,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Be({},e.defaultProps,t):t;}}),"production"!==process.env.NODE_ENV&&(Pe(v,g),C.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={};}}}(v,g)),C.toString=function(){return "."+C.styledComponentId},i&&hoistNonReactStatics_cjs(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!reactIs$2.exports.isValidElementType(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e);}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1);}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o);},t.removeStyles=function(e,t){t.clearRules(this.componentId+e);},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r);},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function l(e){var t=pe(),n=fe(),o=useContext(Me),u=useRef(t.allocateGSInstance(a)).current;return "production"!==process.env.NODE_ENV&&React__default.Children.count(e.children)&&console.warn("The global style component "+a+" was given child JSX. createGlobalStyle does not render children."),"production"!==process.env.NODE_ENV&&i.some((function(e){return "string"==typeof e&&-1!==e.indexOf("@import")}))&&console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."),t.server&&d(u,e,t,o,n),null}function d(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else {var s=y({},t,{theme:Oe(t,r,l.defaultProps)});u.renderStyles(e,s,n,o);}}return "production"!==process.env.NODE_ENV&&Pe(a),React__default.memo(l)}"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1);

var fontFamily = Ae(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n"], ["\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n"])));
var bodyFontSize = Ae(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n"], ["\n  font-size: 16px;\n"])));
Ae(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 300;\n"], ["\n  font-weight: 300;\n"])));
var weightRegular = Ae(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 400;\n"], ["\n  font-weight: 400;\n"])));
Ae(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
var weightBold = Ae(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: 700;\n"], ["\n  font-weight: 700;\n"])));
Ae(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-style: italic;\n"], ["\n  font-style: italic;\n"])));
Ae(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n  font-size: 32px;\n  line-height: 40px;\n"], ["\n  ", "\n  font-size: 32px;\n  line-height: 40px;\n"])), weightBold);
Ae(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n  font-size: 28px;\n  line-height: 36px;\n"], ["\n  ", "\n  font-size: 28px;\n  line-height: 36px;\n"])), weightBold);
Ae(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n  font-size: 24px;\n  line-height: 32px;\n"], ["\n  ", "\n  font-size: 24px;\n  line-height: 32px;\n"])), weightBold);
Ae(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n  font-size: 20px;\n  line-height: 28px;\n"], ["\n  ", "\n  font-size: 20px;\n  line-height: 28px;\n"])), weightBold);
Ae(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n  font-size: 18px;\n  line-height: 28px;\n"], ["\n  ", "\n  font-size: 18px;\n  line-height: 28px;\n"])), weightBold);
Ae(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n  font-size: 16px;\n  line-height: 24px;\n"], ["\n  ", "\n  font-size: 16px;\n  line-height: 24px;\n"])), weightBold);
Ae(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n  font-size: 16px;\n  line-height: 24px;\n"], ["\n  ", "\n  font-size: 16px;\n  line-height: 24px;\n"])), weightRegular);
Ae(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", "\n  font-size: 14px;\n  line-height: 20px;\n"], ["\n  ", "\n  font-size: 14px;\n  line-height: 20px;\n"])), weightRegular);
var textMD = Ae(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  ", "\n  font-size: 13px;\n  line-height: 20px;\n"], ["\n  ", "\n  font-size: 13px;\n  line-height: 20px;\n"])), weightRegular);
Ae(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  ", "\n  font-size: 12px;\n  line-height: 16px;\n"], ["\n  ", "\n  font-size: 12px;\n  line-height: 16px;\n"])), weightRegular);
Ae(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  ", "\n  font-size: 10px;\n  line-height: 16px;\n"], ["\n  ", "\n  font-size: 10px;\n  line-height: 16px;\n"])), weightRegular);
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;

$e(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n body {\n   ", "\n   ", "\n   padding: 0!important;\n } \n"], ["\n body {\n   ", "\n   ", "\n   padding: 0!important;\n } \n"])), fontFamily, bodyFontSize);
var templateObject_1$2;
var setAttribute = function (componentRef, attr, value) {
    if (componentRef && componentRef.current && componentRef.current.element) {
        componentRef.current.element.setAttribute("".concat(attr), "".concat(value));
    }
};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=React__default,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

var reactJsxRuntime_development = {};

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

var React = React__default;
var _assign = objectAssign;

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}
}(reactJsxRuntime_development));

if (process.env.NODE_ENV === 'production') ;

var StyledGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", "\n  .k-grid-header {\n    font-size: 13px;\n    line-height: 20px;\n    ", ";\n    border-left-width: 0;\n    background: \"#F9F9F9\";\n    .k-link {\n      padding: 4px 0px 4px 8px;\n      height: 38px;\n    }\n  }\n\n  .k-grid-table tbody tr:hover{\n    background-color: rgba(230, 241, 246, 1) !important;\n  }\n\n.k-selected  > td{\n background-color: rgba(204, 227, 236, 1) !important;\n  }\n\n  .k-selected:hover  > td{\n background-color: rgb(179, 213, 226) !important;\n  }\n  \n  .k-grid td {\n    font-size: 13px;\n    line-height: 20px;\n    ", "\n  }\n  &.k-grid tr.k-state-selected > td {\n    background-color: #b3d5e2;\n  }\n  &.k-grid tr.k-state-selected:hover > td {\n    background-color: #99c7d8;\n  }\n  .disable-selection input {\n    pointer-events: none;\n    visibility: hidden;\n  }\n  &.edit-mode .k-grid-header tr {\n    th:first-child input.k-checkbox {\n      pointer-events: none;\n      visibility: hidden;\n    }\n  }\n  &.k-grid\n    .k-grid-edit-row\n    td\n    > input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n  &.k-grid .k-grid-edit-row td .k-input {\n    border: 1px solid #bbbbbb;\n    border-radius: 2px;\n  }\n  .k-checkbox {\n    background-color: #ffffff;\n    border: 1px solid #bbbbbb;\n    border-radius: 4px;\n    margin-left: 4px;\n  }\n  .k-checkbox:checked {\n    background-color: #222222;\n  }\n  .k-checkbox.k-checked:active,\n  .k-checkbox.k-checked:focus {\n    box-shadow: inset 0 0px 2px 0 #66ac5;\n  }\n  .k-checkbox:active,\n  .k-checkbox:focus {\n    box-shadow: inset 0 0px 2px 0 #66ac5;\n  }\n  .k-pager-wrap {\n    height: 40px;\n    background: #f5f5f5;\n    font-size: 12px;\n    .k-pager-numbers-wrap {\n      font-size: 10px;\n    }\n  }\n  .k-pager-numbers .k-link.k-pager-first,\n  .k-pager-numbers .k-link:link,\n  .k-pager-numbers .k-link.k-state-selected {\n    color: ", " !important;\n  }\n  .k-pager-numbers .k-link.k-state-selected {\n    background-color: ", " !important;\n    border-radius: 4px;\n    color: ", " !important;\n  }\n  .k-pager-numbers .k-link:hover,\n  .k-pager-numbers .k-link.k-state-hover {\n    color: ", ";\n    background-color: ", ";\n    box-shadow: none;\n  }\n  .k-pager-wrap .k-pager-info {\n    border-left: solid 1px ", ";\n  }\n  .k-pager-wrap .k-pager-sizes {\n    flex-direction: row-reverse;\n    margin-left: 0;\n    text-transform: capitalize;\n    > span {\n      background-image: none;\n      margin-left: 10px;\n      border: none;\n      width: 4em;\n    }\n    .k-picker-md .k-input-inner {\n      padding-right: 0;\n      padding-top: 0px;\n      padding-bottom: 0px;\n      font-size: 12px;\n    }\n    .k-picker:focus,\n    .k-picker.k-focus {\n      box-shadow: none;\n    }\n  }\n  .k-pager-info:before {\n    content: \"Showing\";\n    padding-right: 5px;\n  }\n  .k-list-item.k-selected,\n  .k-selected.k-list-optionlabel {\n    color: ", " !important;\n    background-color: ", " !important;\n  }\n"], ["\n  ", ";\n  ", "\n  .k-grid-header {\n    font-size: 13px;\n    line-height: 20px;\n    ", ";\n    border-left-width: 0;\n    background: \"#F9F9F9\";\n    .k-link {\n      padding: 4px 0px 4px 8px;\n      height: 38px;\n    }\n  }\n\n  .k-grid-table tbody tr:hover{\n    background-color: rgba(230, 241, 246, 1) !important;\n  }\n\n.k-selected  > td{\n background-color: rgba(204, 227, 236, 1) !important;\n  }\n\n  .k-selected:hover  > td{\n background-color: rgb(179, 213, 226) !important;\n  }\n  \n  .k-grid td {\n    font-size: 13px;\n    line-height: 20px;\n    ", "\n  }\n  &.k-grid tr.k-state-selected > td {\n    background-color: #b3d5e2;\n  }\n  &.k-grid tr.k-state-selected:hover > td {\n    background-color: #99c7d8;\n  }\n  .disable-selection input {\n    pointer-events: none;\n    visibility: hidden;\n  }\n  &.edit-mode .k-grid-header tr {\n    th:first-child input.k-checkbox {\n      pointer-events: none;\n      visibility: hidden;\n    }\n  }\n  &.k-grid\n    .k-grid-edit-row\n    td\n    > input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n  &.k-grid .k-grid-edit-row td .k-input {\n    border: 1px solid #bbbbbb;\n    border-radius: 2px;\n  }\n  .k-checkbox {\n    background-color: #ffffff;\n    border: 1px solid #bbbbbb;\n    border-radius: 4px;\n    margin-left: 4px;\n  }\n  .k-checkbox:checked {\n    background-color: #222222;\n  }\n  .k-checkbox.k-checked:active,\n  .k-checkbox.k-checked:focus {\n    box-shadow: inset 0 0px 2px 0 #66ac5;\n  }\n  .k-checkbox:active,\n  .k-checkbox:focus {\n    box-shadow: inset 0 0px 2px 0 #66ac5;\n  }\n  .k-pager-wrap {\n    height: 40px;\n    background: #f5f5f5;\n    font-size: 12px;\n    .k-pager-numbers-wrap {\n      font-size: 10px;\n    }\n  }\n  .k-pager-numbers .k-link.k-pager-first,\n  .k-pager-numbers .k-link:link,\n  .k-pager-numbers .k-link.k-state-selected {\n    color: ", " !important;\n  }\n  .k-pager-numbers .k-link.k-state-selected {\n    background-color: ", " !important;\n    border-radius: 4px;\n    color: ", " !important;\n  }\n  .k-pager-numbers .k-link:hover,\n  .k-pager-numbers .k-link.k-state-hover {\n    color: ", ";\n    background-color: ", ";\n    box-shadow: none;\n  }\n  .k-pager-wrap .k-pager-info {\n    border-left: solid 1px ", ";\n  }\n  .k-pager-wrap .k-pager-sizes {\n    flex-direction: row-reverse;\n    margin-left: 0;\n    text-transform: capitalize;\n    > span {\n      background-image: none;\n      margin-left: 10px;\n      border: none;\n      width: 4em;\n    }\n    .k-picker-md .k-input-inner {\n      padding-right: 0;\n      padding-top: 0px;\n      padding-bottom: 0px;\n      font-size: 12px;\n    }\n    .k-picker:focus,\n    .k-picker.k-focus {\n      box-shadow: none;\n    }\n  }\n  .k-pager-info:before {\n    content: \"Showing\";\n    padding-right: 5px;\n  }\n  .k-list-item.k-selected,\n  .k-selected.k-list-optionlabel {\n    color: ", " !important;\n    background-color: ", " !important;\n  }\n"])), fontFamily, textMD, weightBold, weightRegular, palette.gray[80], EDMColors.text.primary, EDMColors.text.white, palette.gray[80], palette.gray[10], palette.gray[15], EDMColors.text.white, palette.gray[80]);
var templateObject_1;

var LoadingPanel = function () {
    var loadingPanel = (jsxRuntime.exports.jsx(React.Fragment, { children: jsxRuntime.exports.jsxs("div", __assign$Y({ className: "k-loading-mask" }, { children: [jsxRuntime.exports.jsx("span", __assign$Y({ className: "k-loading-text" }, { children: "Loading" })), jsxRuntime.exports.jsx("div", { className: "k-loading-image" }), jsxRuntime.exports.jsx("div", { className: "k-loading-color" })] })) }));
    var gridContent = document && document.querySelector(".k-grid-content");
    return gridContent
        ? ReactDOM.createPortal(loadingPanel, gridContent)
        : loadingPanel;
};

var ColumnMenu = function (props) {
    return (jsxRuntime.exports.jsx(React.Fragment, { children: jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(GridColumnMenuSort, __assign$Y({}, props)), jsxRuntime.exports.jsx(GridColumnMenuFilter, __assign$Y({}, props))] }) }));
};
var ColumnMenuCheckboxFilter = function (props) {
    return (jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsx(GridColumnMenuSort, __assign$Y({}, props)), jsxRuntime.exports.jsx(GridColumnMenuCheckboxFilter, __assign$Y({}, props, { data: props.data }))] }));
};

/** @hidden */
var ZIndexContext = React.createContext(0);
ZIndexContext.displayName = 'KendoReactZIndexContext';

/**
 * @hidden
 */
var canUseDOM = Boolean(
// from fbjs
typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);

/**
 * @hidden
 */
var classNames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    var addLeafKeys = function (arg) { return typeof arg === 'object' ? Object
        .keys(arg)
        .forEach(function (key) {
        result[key] = arg[key];
    }) : result[arg] = true; };
    var addKeys = function (list) { return list
        .filter(function (arg) { return arg !== true && !!arg; })
        .map(function (arg) {
        return Array.isArray(arg) ?
            addKeys(arg) :
            addLeafKeys(arg);
    }); };
    addKeys(args);
    return Object
        .keys(result)
        .map(function (key) { return (result[key] && key) || null; })
        .filter(function (el) { return el !== null; })
        .join(' ');
};

/* eslint-disable no-bitwise */
/**
 * @hidden
 */
var guid = function () {
    var id = '';
    var i;
    var random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            id += '-';
        }
        id += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return id;
};

/**
 * @hidden
 */
var Keys = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    esc: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46
};

/**
 * @hidden
 */
function validatePackage(packageMetadata) {
    if (typeof licensing !== 'undefined') {
        validatePackage$4(packageMetadata);
    }
    else {
        var message = "License activation failed for " + packageMetadata.name + "\n";
        message += 'The @progress/kendo-licensing script is not loaded.\n';
        message += "See " + packageMetadata.licensingDocsUrl + " for more information.\n";
        console.warn(message);
    }
}

/**
 * @hidden
 * Dispatches a new event based on an event that was already internally dispatched to KendoReact users.
 *
 * @param eventHandler - The public event handler that is assigned by the user.
 * When undefined, the method is not an option.
 * @param dispatchedEvent - The event that was already dispatched internally.
 * @param target - The target component of the new event.
 * @param eventData - The additional data that will be passed through the new event.
 * When the new event has no additional data
 *  other than the `BaseEvent` arguments, pass `undefined`.
 */
function dispatchEvent(eventHandler, dispatchedEvent, target, eventData) {
    if (eventHandler) {
        var eventBaseData = {
            syntheticEvent: dispatchedEvent,
            nativeEvent: dispatchedEvent.nativeEvent,
            target: target
        };
        eventHandler.call(undefined, Object.assign(eventBaseData, eventData));
    }
}

/** @hidden */
var kendoThemeMaps = {
    sizeMap: {
        small: 'sm',
        medium: 'md',
        large: 'lg'
    },
    roundedMap: {
        small: 'sm',
        medium: 'md',
        large: 'lg'
    }
};

/**
 * @hidden
 */
var packageMetadata$2 = {
    name: '@progress/kendo-react-buttons',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1646224832,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$4 = (undefined && undefined.__assign) || function () {
    __assign$4 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/**
 * @hidden
 */
function iconElement(_a) {
    var imageUrl = _a.imageUrl, icon = _a.icon, iconClass = _a.iconClass, imageAlt = _a.imageAlt;
    if (imageUrl) {
        return (React.createElement("img", { role: "presentation", className: 'k-button-icon', alt: imageAlt, src: imageUrl }));
    }
    else if (icon) {
        var iconClasses = classNames('k-button-icon k-icon', 'k-i-' + icon);
        return (React.createElement("span", { role: "presentation", className: iconClasses }));
    }
    else if (iconClass) {
        return (React.createElement("span", { role: "presentation", className: classNames('k-button-icon', iconClass) }));
    }
    return null;
}
var Button = /** @class */ (function (_super) {
    __extends$3(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this._element = null;
        _this.handleClick = function (event) {
            _this.toggleIfApplicable();
            if (_this.props.onClick) {
                _this.props.onClick.call(undefined, event);
            }
        };
        validatePackage(packageMetadata$2);
        _this.state = { selected: _this.props.togglable === true && _this.props.selected === true };
        return _this;
    }
    Object.defineProperty(Button.prototype, "element", {
        /**
         * Gets the DOM element of the Button component.
         */
        get: function () {
            return this._element;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "selected", {
        /**
         * Returns `true` when the component is togglable and selected ([see example]({% slug toggleable_button %})).
         * Otherwise, returns `false`.
         */
        get: function () {
            return this._selectedTemp !== undefined ? this._selectedTemp : this.state.selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    Button.getDerivedStateFromProps = function (props, state) {
        if (props.togglable && props.selected !== undefined && props.selected !== state.selected) {
            return { selected: props.selected };
        }
        return null;
    };
    /**
     * @hidden
     */
    Button.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, children = _b.children, togglable = _b.togglable, icon = _b.icon, iconClass = _b.iconClass, imageUrl = _b.imageUrl, imageAlt = _b.imageAlt; _b.className; _b.onClick; var _c = _b.size, size = _c === void 0 ? Button.defaultProps.size : _c, _d = _b.shape, shape = _d === void 0 ? Button.defaultProps.shape : _d, _e = _b.rounded, rounded = _e === void 0 ? Button.defaultProps.rounded : _e, _f = _b.fillMode, fillMode = _f === void 0 ? Button.defaultProps.fillMode : _f, _g = _b.themeColor, themeColor = _g === void 0 ? Button.defaultProps.themeColor : _g, htmlAttributes = __rest(_b, ["children", "togglable", "icon", "iconClass", "imageUrl", "imageAlt", "className", "onClick", "size", "shape", "rounded", "fillMode", "themeColor"]);
        var hasIcon = (icon !== undefined || iconClass !== undefined || imageUrl !== undefined);
        var hasChildren = children !== undefined;
        var iconEl = iconElement({
            icon: icon,
            iconClass: iconClass,
            imageUrl: imageUrl,
            imageAlt: imageAlt
        });
        return (React.createElement("button", __assign$4({ ref: function (button) { return _this._element = button; }, role: togglable ? 'checkbox' : undefined, "aria-disabled": this.props.disabled || undefined, "aria-checked": togglable ? this.state.selected : undefined }, htmlAttributes, { onClick: this.handleClick, className: classNames('k-button', (_a = {},
                _a["k-button-" + (kendoThemeMaps.sizeMap[size] || size)] = size,
                _a["k-button-" + shape] = shape,
                _a["k-button-" + fillMode] = fillMode,
                _a["k-button-" + fillMode + "-" + themeColor] = Boolean(fillMode && themeColor),
                _a["k-rounded-" + (kendoThemeMaps.roundedMap[rounded] || rounded)] = rounded,
                _a['k-icon-button'] = !hasChildren && hasIcon,
                _a['k-disabled'] = this.props.disabled,
                _a['k-selected'] = this.state.selected,
                _a['k-rtl'] = this.props.dir === 'rtl',
                _a), this.props.className) }),
            iconEl,
            children && (React.createElement("span", { className: "k-button-text" }, children))));
    };
    Button.prototype.toggleIfApplicable = function () {
        var _this = this;
        if (this.props.togglable && this.props.selected === undefined) {
            var selected = !this.state.selected;
            this._selectedTemp = selected;
            this.setState({ selected: selected }, function () { return _this._selectedTemp = undefined; });
        }
    };
    /**
     * @hidden
     */
    Button.propTypes = {
        children: propTypes.exports.node,
        selected: propTypes.exports.bool,
        togglable: propTypes.exports.bool,
        icon: propTypes.exports.string,
        iconClass: propTypes.exports.string,
        imageUrl: propTypes.exports.string,
        imageAlt: propTypes.exports.string,
        size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
        shape: propTypes.exports.oneOf([null, 'rectangle', 'square']),
        rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
        fillMode: propTypes.exports.oneOf([null, 'flat', 'link', 'outline', 'solid']),
        // eslint-disable-next-line max-len
        themeColor: propTypes.exports.oneOf([null, 'base', 'primary', 'secondary', 'tertiary', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse'])
    };
    /**
     * @hidden
     */
    Button.defaultProps = {
        togglable: false,
        size: 'medium',
        shape: 'rectangle',
        rounded: 'medium',
        fillMode: 'solid',
        themeColor: 'base'
    };
    return Button;
}(React.Component));
var Button$1 = Button;

/**
 * @hidden
 */
var ButtonItem = function (props) {
    var _a;
    var handleClick = React.useCallback(function (event) {
        props.onClick(event, props.index);
    }, [props]);
    var As = props.dataItem.render || props.item || (props.item === undefined ? props.render : null);
    var text = props.dataItem.text !== undefined ? props.dataItem.text : (props.textField ? props.dataItem[props.textField] : props.dataItem);
    var item = (React.createElement("li", { id: props.id, className: classNames('k-item', props.className, { 'k-focus': props.focused }), onClick: handleClick, onMouseDown: props.onDown, onPointerDown: props.onDown, role: "menuitem", "aria-disabled": props.dataItem.disabled || undefined }, (React.createElement("span", { tabIndex: -1, className: classNames('k-link k-menu-link', {
            'k-selected': props.dataItem.selected,
            'k-disabled': props.dataItem.disabled
        }), key: "icon" }, As
        ? (React.createElement(As, { item: props.dataItem, itemIndex: props.index }))
        : (React.createElement(React.Fragment, null,
            (props.dataItem.icon || props.dataItem.iconClass) && (React.createElement("span", { className: classNames('k-icon', (_a = {},
                    _a["k-i-" + props.dataItem.icon] = props.dataItem.icon,
                    _a["" + props.dataItem.iconClass] = props.dataItem.iconClass,
                    _a)) })),
            (props.dataItem.imageUrl) && (React.createElement("img", { role: "presentation", alt: "", src: props.dataItem.imageUrl, className: 'k-icon' })),
            (text) && (React.createElement("span", { className: "k-menu-link-text" }, text))))))));
    return ((props.item !== undefined && /* to be removed in 5.0.0 */
        props.render !== undefined) ? props.render.call(undefined, item, props) : item);
};
ButtonItem.displayName = 'KendoReactButtonItem';
var ButtonItem$1 = ButtonItem;

/**
 * @hidden
 */
var navigate = function (focusedIndex, keyCode, altKey, total) {
    if (altKey) {
        return focusedIndex;
    }
    switch (keyCode) {
        case Keys.enter:
        case Keys.space:
        case Keys.esc:
            return -1;
        case Keys.up:
        case Keys.left:
            return Math.max(0, focusedIndex - 1);
        case Keys.down:
        case Keys.right:
            return Math.min(total - 1, focusedIndex + 1);
        default:
            return focusedIndex;
    }
};
var navigation = navigate;

var clearSlide = function (element) {
    element.style.transitionDuration = '';
    Array.from(element.classList).forEach(function (c) {
        if (c.startsWith('k-slide-')) {
            element.classList.remove(c);
        }
    });
};
var firefox = typeof window !== 'undefined' &&
    /Firefox/.test(window.navigator.userAgent);
/**
 * @hidden
 */
var slide = function (element, direction, duration, type, callback) {
    if (duration === 0) {
        return callback();
    }
    var slideClass = 'k-slide-' + direction + '-' + type;
    var slideActiveClass = slideClass + '-active';
    var transitionend = function (e) {
        // if event is attached using react,
        // the animation does not work well in firefox,
        // when the show/hide button is toggled quickly.
        if (e.target === element) {
            element.removeEventListener('transitionend', transitionend);
            clearSlide(element);
            callback();
        }
    };
    element.addEventListener('transitionend', transitionend);
    var ownerDocument = element.ownerDocument;
    if (!ownerDocument) {
        return;
    }
    var defaultView = ownerDocument.defaultView;
    if (!defaultView) {
        return;
    }
    var animate = function () {
        clearSlide(element);
        element.classList.add(slideClass);
        defaultView.requestAnimationFrame(function () {
            element.style.transitionDuration = duration + 'ms';
            element.classList.add(slideActiveClass);
        });
    };
    if (firefox) {
        defaultView.requestAnimationFrame(animate);
    }
    else {
        animate();
    }
};

/**
 * @hidden
 */
/**
 * @hidden
 */
var FRAME_DURATION = 1000 / 60; // 1000ms divided by 60fps
/**
 * @hidden
 */
var throttle = function (func, wait, options) {
    if (options === void 0) { options = {}; }
    var timeout, context, args, result;
    var previous = 0;
    options = options || {};
    var later = function () {
        previous = options.leading === false ? 0 : new Date().getTime();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) {
            context = args = null;
        }
    };
    var throttled = function () {
        var now = new Date().getTime();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) {
                context = args = null;
            }
        }
        else if (!timeout && options.trailing !== false) {
            timeout = window.setTimeout(later, remaining);
        }
        return result;
    };
    return throttled;
};

/**
 * @hidden
 */
var packageMetadata$1 = {
    name: '@progress/kendo-react-popup',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1646224809,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$3 = (undefined && undefined.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
var DEFAULT_POPUP_ZINDEX = 100;
var ZINDEX_POPUP_STEP = 1;
function isEquivalent(a, b) {
    if (a === b) {
        return true;
    }
    if (!!a !== !!b) {
        return false;
    }
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
var DEFAULT_OFFSET = {
    left: -1000,
    top: 0
};
var Status;
(function (Status) {
    Status["hiding"] = "hiding";
    Status["hidden"] = "hidden";
    Status["showing"] = "showing";
    Status["shown"] = "shown";
    Status["reposition"] = "reposition";
})(Status || (Status = {}));
var ANIMATION_CONTAINER = 'k-animation-container';
var ANIMATION_CONTAINER_SHOWN = 'k-animation-container-shown';
var ANIMATION_CONTAINER_RELATIVE = 'k-animation-container-relative';
var ANIMATION_CONTAINER_CHILD = 'k-child-animation-container';
var K_POPUP = 'k-popup';
/**
 * @hidden
 */
var PopupWithoutContext = /** @class */ (function (_super) {
    __extends$2(PopupWithoutContext, _super);
    function PopupWithoutContext(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.state = { current: Status.hidden, previous: Status.hidden, props: {} };
        _this._popup = null;
        _this.show = function (popup) {
            _this.setPosition(popup);
            _this.animate(popup.firstChild, 'enter', _this.onOpened);
            _this.setState({ current: Status.shown, previous: _this.state.current });
        };
        _this.setPosition = function (popup) {
            var _a = _this.props, anchorAlign = _a.anchorAlign, popupAlign = _a.popupAlign, collision = _a.collision, offset = _a.offset, anchor = _a.anchor, margin = _a.margin, scale = _a.scale, positionMode = _a.positionMode;
            var alignedOffset = alignElement({
                anchor: anchor,
                anchorAlign: anchorAlign,
                element: popup,
                elementAlign: popupAlign,
                offset: offset,
                margin: margin,
                positionMode: positionMode,
                scale: scale
            });
            var position = positionElement({
                anchor: anchor,
                anchorAlign: anchorAlign,
                element: popup,
                elementAlign: popupAlign,
                collisions: collision,
                currentLocation: alignedOffset,
                margin: _this.props.margin
            });
            popup.style.top = position.offset.top + 'px';
            popup.style.left = position.offset.left + 'px';
            _this._collisions = {
                fit: position.fit,
                fitted: position.fitted,
                flip: position.flip,
                flipped: position.flipped
            };
            if (_this.props.onPosition) {
                var event_1 = {
                    target: _this,
                    flipped: position.flipped,
                    fitted: position.fitted
                };
                _this.props.onPosition.call(undefined, event_1);
            }
        };
        _this.onOpened = function () {
            var element = _this._popup;
            if (!element) {
                return;
            }
            if (_this.props.show) {
                element.classList.add(ANIMATION_CONTAINER_SHOWN);
            }
            _this.attachRepositionHandlers(element);
            if (_this.props.onOpen) {
                _this.props.onOpen.call(undefined, { target: _this });
            }
        };
        _this.animate = function (element, type, callback) {
            if (!_this.props.popupAlign) {
                return;
            }
            var animationDirection;
            var _a = _this.props.popupAlign, horizontal = _a.horizontal, vertical = _a.vertical;
            if (horizontal === 'left' && vertical === 'center') {
                animationDirection = 'right';
            }
            else if (horizontal === 'right' && vertical === 'center') {
                animationDirection = 'left';
            }
            else if (vertical === 'top') {
                animationDirection = 'down';
            }
            else {
                animationDirection = 'up';
            }
            var flipPositions = {
                down: 'up',
                up: 'down',
                left: 'right',
                right: 'left'
            };
            if (_this._collisions && _this._collisions.flipped) {
                animationDirection = flipPositions[animationDirection];
            }
            slide(element, animationDirection, _this.animationDuration[type], type, callback);
        };
        _this.onClosing = function (popup) {
            if (!_this.props.show) {
                popup.classList.remove(ANIMATION_CONTAINER_SHOWN);
            }
            _this.detachRepositionHandlers();
        };
        _this.onClosed = function () {
            if (_this.state.current === Status.hiding && _this.state.previous === Status.shown) {
                _this.setState({ current: Status.hidden, previous: _this.state.current });
            }
            if (_this.props.onClose) {
                _this.props.onClose.call(undefined, { target: _this });
            }
        };
        _this.getCurrentZIndex = function () {
            return _this.context ? _this.context + ZINDEX_POPUP_STEP : DEFAULT_POPUP_ZINDEX;
        };
        validatePackage(packageMetadata$1);
        _this.reposition = throttle(_this.reposition.bind(_this), FRAME_DURATION);
        return _this;
    }
    /**
     * @hidden
     */
    PopupWithoutContext.getDerivedStateFromProps = function (props, state) {
        var show = props.show, anchor = props.anchor, anchorAlign = props.anchorAlign, appendTo = props.appendTo, collision = props.collision, popupAlign = props.popupAlign, className = props.className, popupClass = props.popupClass, style = props.style, offset = props.offset, contentKey = props.contentKey;
        var nextState = __assign$3({}, state, { props: {
                show: show, anchor: anchor, anchorAlign: anchorAlign, appendTo: appendTo, collision: collision, popupAlign: popupAlign, className: className, popupClass: popupClass, style: style, offset: offset, contentKey: contentKey
            } });
        if (props.show) {
            if (state.current === Status.hidden || state.current === Status.hiding) {
                return __assign$3({}, nextState, { current: Status.showing, previous: state.current });
            }
            if (state.current === Status.showing) {
                return __assign$3({}, nextState, { current: Status.shown, previous: state.current });
            }
            if (state.current === Status.shown &&
                (!isEquivalent(offset, state.props.offset) ||
                    !isEquivalent(anchorAlign, state.props.anchorAlign) ||
                    !isEquivalent(appendTo, state.props.appendTo) ||
                    !isEquivalent(collision, state.props.collision) ||
                    !isEquivalent(popupAlign, state.props.popupAlign) ||
                    !isEquivalent(style, state.props.style) ||
                    anchor !== state.props.anchor ||
                    popupClass !== state.props.popupClass ||
                    className !== state.props.className)) {
                return __assign$3({}, nextState, { current: Status.reposition, previous: state.current });
            }
            return nextState;
        }
        if (state.current === Status.hiding || state.current === Status.hidden) {
            return __assign$3({}, nextState, { current: Status.hidden, previous: state.current });
        }
        return __assign$3({}, nextState, { current: Status.hiding, previous: state.current });
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.componentDidUpdate = function (prevProps) {
        if (this.state.current === Status.showing && this._popup) {
            this.show(this._popup);
        }
        else if (this.state.current === Status.hiding && this._popup) {
            this.onClosing(this._popup);
            this.animate(this._popup.firstChild, 'exit', this.onClosed);
        }
        else if (this.state.current === Status.reposition && this.state.previous === Status.shown) {
            this.setState({ current: Status.shown, previous: this.state.current });
        }
        else if (this.state.current === Status.shown &&
            prevProps.contentKey !== this.props.contentKey && this._popup) {
            this.setPosition(this._popup);
        }
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.componentDidMount = function () {
        if (this.state.current === Status.showing && this._popup) {
            this.show(this._popup);
        }
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.componentWillUnmount = function () {
        this.detachRepositionHandlers();
    };
    /**
     * @hidden
     */
    PopupWithoutContext.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, popupClass = _a.popupClass, show = _a.show, id = _a.id, positionMode = _a.positionMode;
        var calculatedAppendTo = this.props.appendTo ?
            this.props.appendTo :
            canUseDOM ?
                (this.props.anchor && this.props.anchor.ownerDocument ? this.props.anchor.ownerDocument.body : document.body)
                : undefined;
        if (this.state.current === Status.reposition && this.state.previous === Status.shown && this._popup) {
            this.setPosition(this._popup);
        }
        var style = Object.assign({}, { position: positionMode, top: 0, left: -10000 }, this.props.style || {});
        var closing = this.state.current === Status.hiding;
        if ((show || closing) && calculatedAppendTo) {
            var currentZIndex = this.getCurrentZIndex();
            var popupElement = (React.createElement(ZIndexContext.Provider, { value: currentZIndex },
                React.createElement("div", { className: classNames(ANIMATION_CONTAINER, ANIMATION_CONTAINER_RELATIVE, className), id: id, ref: function (e) { return _this._popup = e; }, style: __assign$3({ zIndex: currentZIndex }, style) },
                    React.createElement("div", { className: classNames(K_POPUP, popupClass, ANIMATION_CONTAINER_CHILD), style: { transitionDelay: '0ms' } }, children))));
            return this.props.appendTo !== null ?
                ReactDOM.createPortal(popupElement, calculatedAppendTo) :
                popupElement;
        }
        return null;
    };
    Object.defineProperty(PopupWithoutContext.prototype, "animationDuration", {
        get: function () {
            var animate = this.props.animate;
            var enter = 0;
            var exit = 0;
            if (animate) {
                if (animate === true) {
                    enter = exit = 300;
                }
                else {
                    enter = animate.openDuration || 0;
                    exit = animate.closeDuration || 0;
                }
            }
            return { enter: enter, exit: exit };
        },
        enumerable: true,
        configurable: true
    });
    PopupWithoutContext.prototype.attachRepositionHandlers = function (element) {
        var _this = this;
        this.detachRepositionHandlers();
        this._scrollableParents = domUtils.scrollableParents(this.props.anchor || element);
        this._scrollableParents.map(function (p) { return p.addEventListener('scroll', _this.reposition); });
        window.addEventListener('resize', this.reposition);
    };
    PopupWithoutContext.prototype.detachRepositionHandlers = function () {
        var _this = this;
        if (this._scrollableParents) {
            this._scrollableParents.map(function (p) { return p.removeEventListener('scroll', _this.reposition); });
            this._scrollableParents = undefined;
        }
        window.removeEventListener('resize', this.reposition);
    };
    PopupWithoutContext.prototype.reposition = function () {
        this.setState({ current: Status.reposition, previous: this.state.current });
    };
    /**
     * @hidden
     */
    PopupWithoutContext.propTypes = {
        anchor: function (props) {
            var anchor = props.anchor;
            if (anchor && typeof anchor.nodeType !== 'number') {
                return new Error('Invalid prop `anchor` supplied to `Kendo React Popup`. Validation failed.');
            }
            return null;
        },
        appendTo: function (props) {
            var element = props.appendTo;
            if (element && typeof element.nodeType !== 'number') {
                return new Error('Invalid prop `appendTo` supplied to `Kendo React Popup`. Validation failed.');
            }
            return null;
        },
        className: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.arrayOf(propTypes.exports.string),
            propTypes.exports.object
        ]),
        id: propTypes.exports.string,
        popupClass: propTypes.exports.oneOfType([
            propTypes.exports.string,
            propTypes.exports.arrayOf(propTypes.exports.string),
            propTypes.exports.object
        ]),
        collision: propTypes.exports.shape({
            horizontal: propTypes.exports.oneOf([
                CollisionEnum.fit,
                CollisionEnum.flip,
                CollisionEnum.none
            ]),
            vertical: propTypes.exports.oneOf([
                CollisionEnum.fit,
                CollisionEnum.flip,
                CollisionEnum.none
            ])
        }),
        anchorAlign: propTypes.exports.shape({
            horizontal: propTypes.exports.oneOf([
                AlignPoint.left,
                AlignPoint.center,
                AlignPoint.right
            ]),
            vertical: propTypes.exports.oneOf([
                AlignPoint.top,
                AlignPoint.center,
                AlignPoint.bottom
            ])
        }),
        popupAlign: propTypes.exports.shape({
            horizontal: propTypes.exports.oneOf([
                AlignPoint.left,
                AlignPoint.center,
                AlignPoint.right
            ]),
            vertical: propTypes.exports.oneOf([
                AlignPoint.top,
                AlignPoint.center,
                AlignPoint.bottom
            ])
        }),
        offset: propTypes.exports.shape({
            left: propTypes.exports.number,
            top: propTypes.exports.number
        }),
        children: propTypes.exports.oneOfType([
            propTypes.exports.element,
            propTypes.exports.node
        ]),
        show: propTypes.exports.bool,
        animate: propTypes.exports.oneOfType([
            propTypes.exports.bool,
            propTypes.exports.shape({
                openDuration: propTypes.exports.number,
                closeDuration: propTypes.exports.number
            })
        ]),
        margin: propTypes.exports.shape({
            horizontal: propTypes.exports.number,
            vertical: propTypes.exports.number
        }),
        positionMode: propTypes.exports.oneOf([
            'fixed',
            'absolute'
        ]),
        scale: propTypes.exports.number,
        style: propTypes.exports.object,
        onClose: propTypes.exports.func,
        onPosition: propTypes.exports.func,
        onOpen: propTypes.exports.func
    };
    /**
     * @hidden
     */
    PopupWithoutContext.defaultProps = {
        collision: {
            horizontal: CollisionEnum.fit,
            vertical: CollisionEnum.flip
        },
        anchorAlign: {
            horizontal: AlignPoint.left,
            vertical: AlignPoint.bottom
        },
        popupAlign: {
            horizontal: AlignPoint.left,
            vertical: AlignPoint.top
        },
        offset: DEFAULT_OFFSET,
        animate: true,
        show: false,
        margin: {
            horizontal: 0,
            vertical: 0
        },
        positionMode: 'absolute'
    };
    /**
     * @hidden
     */
    PopupWithoutContext.contextType = ZIndexContext;
    /**
     * @hidden
     */
    PopupWithoutContext.displayName = 'PopupComponent';
    return PopupWithoutContext;
}(React.Component));

var __assign$2 = (undefined && undefined.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
/**
 * The PopupPropsContext. It allows to configure the Popup props from a wrapper component.
 *
 * @example
 * ```jsx-no-run
 *  <PopupPropsContext.Provider value={props => ({ ...props, appendTo: document.querySelector('myPopupsContainer') })}>
 *      <DropDownList />
 *      <Editor />
 *  </PopupPropsContext.Provider>
 * ```
 */
var PopupPropsContext = React.createContext(function (props) { return props; });
/**
 * The KendoReact Popup component.
 */
var Popup = React.forwardRef(function (props, ref) {
    var contextPropsCallback = React.useContext(PopupPropsContext);
    var popupProps = contextPropsCallback.call(undefined, props);
    return (React.createElement(PopupWithoutContext, __assign$2({ ref: ref }, popupProps)));
});
Popup.displayName = 'Popup';

/**
 * @hidden
 */
function getAnchorAlign(isDirectionRightToLeft) {
    var align = { horizontal: 'left', vertical: 'bottom' };
    if (isDirectionRightToLeft) {
        align.horizontal = 'right';
    }
    return align;
}
/**
 * @hidden
 */
function getPopupAlign(isDirectionRightToLeft) {
    var align = { horizontal: 'left', vertical: 'top' };
    if (isDirectionRightToLeft) {
        align.horizontal = 'right';
    }
    return align;
}

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DropDownButtonItem = /** @class */ (function (_super) {
    __extends$1(DropDownButtonItem, _super);
    function DropDownButtonItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    DropDownButtonItem.prototype.render = function () {
        return null;
    };
    /**
     * @hidden
     */
    DropDownButtonItem.propTypes = {
        text: propTypes.exports.string,
        icon: propTypes.exports.string,
        iconClass: propTypes.exports.string,
        imageUrl: propTypes.exports.string,
        selected: propTypes.exports.bool,
        disabled: propTypes.exports.bool,
        render: propTypes.exports.any
    };
    return DropDownButtonItem;
}(React.Component));
var DropDownButtonItem$1 = DropDownButtonItem;

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
/**
 * Represents the [KendoReact DropDownButton component]({% slug overview_dropdownbutton %}).
 *
 * @example
 * ```jsx
 * class App extends React.Component {
 *    render() {
 *        return (
 *            <DropDownButton text="Act">
 *                <DropDownButtonItem text="Item1" />
 *                <DropDownButtonItem text="Item2" />
 *                <DropDownButtonItem text="Item3" />
 *            </DropDownButton>
 *        );
 *    }
 * }
 * ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var DropDownButton = /** @class */ (function (_super) {
    __extends(DropDownButton, _super);
    function DropDownButton(props) {
        var _this = _super.call(this, props) || this;
        /**
         * @hidden
         */
        _this.state = {
            opened: false,
            focused: false,
            focusedIndex: -1
        };
        _this.wrapper = null;
        _this.mainButton = null;
        _this.guid = guid();
        _this.buttonsData = [];
        _this.onKeyDown = function (event) {
            var focusedIndex = _this.state.focusedIndex;
            if (event.altKey) {
                if (!_this.opened && event.keyCode === Keys.down) {
                    _this.dispatchPopupEvent(event, true);
                    _this.setState({ focusedIndex: 0, opened: true });
                }
                else if (_this.opened && event.keyCode === Keys.up) {
                    _this.dispatchPopupEvent(event, false);
                    _this.setState({ focusedIndex: -1, opened: false });
                }
                return;
            }
            var newState = __assign$1({}, _this.state);
            if (event.keyCode === Keys.enter || event.keyCode === Keys.space) {
                if (focusedIndex >= 0) {
                    _this.dispatchClickEvent(event, focusedIndex);
                }
                // Prevent default because otherwise when an item is selected
                // click on the default button gets emitted which opens the popup again.
                event.preventDefault();
                newState.focusedIndex = _this.opened ? -1 : 0,
                    newState.opened = !_this.opened;
                _this.dispatchPopupEvent(event, newState.opened);
            }
            else if (_this.opened && event.keyCode === Keys.esc) {
                newState.focusedIndex = -1;
                newState.opened = false;
                _this.dispatchPopupEvent(event, newState.opened);
            }
            if (_this.opened) {
                var newFocused = navigation(focusedIndex, event.keyCode, event.altKey, _this.buttonsData.length);
                newState.focusedIndex = newFocused;
                var arrowKey = event.keyCode === Keys.up || event.keyCode === Keys.down ||
                    event.keyCode === Keys.left || event.keyCode === Keys.right;
                if (!event.altKey && arrowKey) {
                    // Needed to notify the parent listeners that event is handled.
                    event.preventDefault();
                }
            }
            _this.setState(newState);
        };
        _this.handleFocus = function (event) {
            _this.setState({ focused: true, focusedIndex: _this.opened ? 0 : -1 });
            dispatchEvent(_this.props.onFocus, event, _this, undefined);
        };
        _this.handleBlur = function (event) {
            _this.setState({ focused: false, opened: false, focusedIndex: -1 });
            dispatchEvent(_this.props.onBlur, event, _this, undefined);
            var fireCloseEvent = _this.opened;
            if (fireCloseEvent) {
                _this.dispatchPopupEvent(event, false);
            }
        };
        _this.onItemClick = function (event, clickedItemIndex) {
            _this.setState({ focusedIndex: -1, opened: false });
            _this.dispatchClickEvent(event, clickedItemIndex);
            _this.dispatchPopupEvent(event, false);
        };
        _this.onItemDown = function (event) {
            if (document.activeElement === _this.element) {
                event.preventDefault();
            }
        };
        _this.mouseDown = function (event) {
            event.preventDefault();
        };
        _this.onClickMainButton = function (event) {
            if (!_this.buttonsData.length) {
                return;
            }
            var toOpen = !_this.opened;
            _this.setState({
                opened: toOpen,
                focused: true,
                focusedIndex: toOpen ? 0 : -1
            });
            _this.dispatchPopupEvent(event, toOpen);
        };
        _this.dispatchPopupEvent = function (dispatchedEvent, open) {
            dispatchEvent(open ? _this.props.onOpen : _this.props.onClose, dispatchedEvent, _this, undefined);
        };
        validatePackage(packageMetadata$2);
        return _this;
    }
    Object.defineProperty(DropDownButton.prototype, "opened", {
        get: function () {
            return this.props.opened === undefined ? this.state.opened : this.props.opened;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    DropDownButton.prototype.render = function () {
        var _this = this;
        var rtl = this.isRtl();
        var dir = rtl ? 'rtl' : undefined;
        var _a = this.props, tabIndex = _a.tabIndex, disabled = _a.disabled;
        var focusedIndex = this.state.focusedIndex;
        this.buttonsData = this.props.items ||
            React.Children.toArray(this.props.children)
                .filter(function (child) { return child && child.type === DropDownButtonItem$1; })
                .map(function (child) { return child.props; });
        return (React.createElement("div", { className: classNames('k-dropdown-button', {
                'k-focus': this.state.focused
            }, this.props.className), onKeyDown: this.onKeyDown, onFocus: this.handleFocus, onBlur: this.handleBlur, dir: dir, ref: function (el) { return _this.wrapper = el; } },
            React.createElement(Button$1, { size: this.props.size, shape: this.props.shape, rounded: this.props.rounded, fillMode: this.props.fillMode, themeColor: this.props.themeColor, onClick: this.onClickMainButton, onMouseDown: this.mouseDown, disabled: disabled || undefined, tabIndex: tabIndex, accessKey: this.props.accessKey, icon: this.props.icon, iconClass: this.props.iconClass, className: this.props.buttonClass, imageUrl: this.props.imageUrl, dir: dir, ref: function (btn) { return _this.mainButton = btn && btn.element; }, type: "button", "aria-disabled": disabled, "aria-haspopup": true, "aria-expanded": this.opened, "aria-label": this.props.text + " dropdownbutton", "aria-owns": this.guid, "aria-activedescendant": focusedIndex >= 0 ? this.guid + "-" + focusedIndex : undefined }, this.props.text),
            this.renderPopup(rtl)));
    };
    /**
     * @hidden
     */
    DropDownButton.prototype.componentDidMount = function () {
        // If this.props.opened is true during the initial render, the popup is not aligned.
        if ((this.props.dir === undefined && this.isRtl()) || this.opened) {
            this.forceUpdate();
        }
    };
    /**
     * @hidden
     */
    DropDownButton.prototype.componentDidUpdate = function () {
        if (this.state.focused && this.element) {
            // firefox in mac does not focus on mouse-down, next line fixes this
            this.element.focus();
        }
    };
    Object.defineProperty(DropDownButton.prototype, "element", {
        /**
         * The DOM element of main button.
         */
        get: function () {
            return this.mainButton;
        },
        enumerable: true,
        configurable: true
    });
    DropDownButton.prototype.dispatchClickEvent = function (dispatchedEvent, index) {
        if (!this.isItemDisabled(index)) {
            dispatchEvent(this.props.onItemClick, dispatchedEvent, this, {
                item: this.buttonsData[index],
                itemIndex: index
            });
        }
    };
    DropDownButton.prototype.renderPopup = function (rtl) {
        var _a;
        var _b = this.props.popupSettings, popupSettings = _b === void 0 ? {} : _b;
        return (React.createElement(Popup, { anchor: this.wrapper, show: this.opened, animate: popupSettings.animate, popupClass: classNames('k-menu-popup', popupSettings.popupClass), anchorAlign: popupSettings.anchorAlign || getAnchorAlign(rtl), popupAlign: popupSettings.popupAlign || getPopupAlign(rtl), style: rtl ? { direction: 'rtl' } : undefined },
            React.createElement("ul", { role: "menu", id: this.guid, className: classNames('k-group k-menu-group k-reset', (_a = {},
                    _a["k-menu-group-" + (kendoThemeMaps.sizeMap[this.props.size] || this.props.size)] = this.props.size,
                    _a)) }, this.renderChildItems())));
    };
    DropDownButton.prototype.renderChildItems = function () {
        var _this = this;
        var _a = this.props, item = _a.item, itemRender = _a.itemRender, textField = _a.textField;
        return this.buttonsData.length > 0 ? (this.buttonsData.map(function (dataItem, index) {
            return (React.createElement(ButtonItem$1, { className: "k-menu-item", dataItem: dataItem, textField: textField, focused: _this.state.focusedIndex === index, onClick: _this.onItemClick, onDown: _this.onItemDown, render: itemRender, item: item, index: index, key: index, id: _this.guid + "-" + index }));
        })) : null;
    };
    DropDownButton.prototype.isItemDisabled = function (index) {
        return this.buttonsData[index] ? this.buttonsData[index].disabled : this.props.disabled;
    };
    DropDownButton.prototype.isRtl = function () {
        return this.props.dir !== undefined ? this.props.dir === 'rtl' :
            !!this.wrapper && getComputedStyle(this.wrapper).direction === 'rtl';
    };
    /**
     * @hidden
     */
    DropDownButton.propTypes = {
        accessKey: propTypes.exports.string,
        onFocus: propTypes.exports.func,
        onBlur: propTypes.exports.func,
        onItemClick: propTypes.exports.func,
        onOpen: propTypes.exports.func,
        onClose: propTypes.exports.func,
        items: propTypes.exports.arrayOf(propTypes.exports.any),
        textField: propTypes.exports.string,
        tabIndex: propTypes.exports.number,
        disabled: propTypes.exports.bool,
        icon: propTypes.exports.string,
        iconClass: propTypes.exports.string,
        imageUrl: propTypes.exports.string,
        popupSettings: propTypes.exports.object,
        itemRender: propTypes.exports.func,
        item: propTypes.exports.func,
        className: propTypes.exports.string,
        buttonClass: propTypes.exports.string,
        dir: propTypes.exports.string
    };
    return DropDownButton;
}(React.Component));
var DropDownButton$1 = DropDownButton;

/**
 * @hidden
 */
var packageMetadata = {
    name: '@progress/kendo-react-indicators',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1666771487,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning'
};

/**
 * Represents the [KendoReact Badge component]({% slug overview_badge %}).
 *
 * @example
 * ```jsx
 * const App = () => {
 *   return (
 *       <Badge>99+</Badge>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var Badge = React.forwardRef(function (props, target) {
    validatePackage$2(packageMetadata);
    var children = props.children, className = props.className, style = props.style;
    var elementRef = React.useRef(null);
    var focusElement = React.useCallback(function () {
        if (elementRef.current) {
            elementRef.current.focus();
        }
    }, []);
    React.useImperativeHandle(target, function () { return ({
        element: elementRef.current,
        focus: focusElement
    }); });
    var dir = useDir(elementRef, props.dir);
    var size = React.useMemo(function () {
        if (props.size === null) {
            return null;
        }
        else {
            return props.size || defaultProps.size;
        }
    }, [props.size]);
    var fillMode = React.useMemo(function () {
        if (props.fillMode === null) {
            return null;
        }
        else if (props.fill === null) {
            return null;
        }
        else {
            return props.fill || props.fillMode || defaultProps.fillMode;
        }
    }, [props.fillMode, props.fill]);
    var themeColor = React.useMemo(function () { return props.themeColor || defaultProps.themeColor; }, [props.themeColor]);
    var rounded = React.useMemo(function () {
        if (props.rounded !== undefined) {
            return props.rounded || 'medium';
        }
        else if (props.shape !== undefined) {
            switch (props.shape) {
                case 'rounded':
                    return 'md';
                case 'rectangle':
                    return null;
                default:
                    return 'full';
            }
        }
        return 'medium';
    }, [props.rounded, props.shape]);
    var _a = props.cutoutBorder, cutoutBorder = _a === void 0 ? defaultProps.cutoutBorder : _a, _b = props.position, position = _b === void 0 ? defaultProps.position : _b, _c = props.align, align = _c === void 0 ? defaultProps.align : _c;
    var badgeClasses = React.useMemo(function () {
        var _a;
        return classNames$2('k-badge', (_a = {
                'k-badge-sm': size === 'small',
                'k-badge-md': size === 'medium',
                'k-badge-lg': size === 'large'
            },
            _a["k-badge-".concat(fillMode)] = fillMode,
            _a["k-badge-".concat(fillMode, "-").concat(themeColor)] = Boolean(fillMode && themeColor),
            _a["k-rounded-".concat(kendoThemeMaps$1.roundedMap[rounded] || rounded)] = rounded,
            _a['k-badge-border-cutout'] = cutoutBorder,
            _a["k-badge-".concat(position)] = position,
            _a['k-top-start'] = align.vertical === 'top' && align.horizontal === 'start',
            _a['k-top-end'] = align.vertical === 'top' && align.horizontal === 'end',
            _a['k-bottom-start'] = align.vertical === 'bottom' && align.horizontal === 'start',
            _a['k-bottom-end'] = align.vertical === 'bottom' && align.horizontal === 'end',
            _a), className);
    }, [
        size, fillMode, themeColor,
        rounded, cutoutBorder, align,
        position, className
    ]);
    return (React.createElement("span", { className: badgeClasses, style: style, dir: dir }, children));
});
Badge.propTypes = {
    className: propTypes.exports.string,
    dir: propTypes.exports.string,
    style: propTypes.exports.object,
    align: propTypes.exports.shape({
        vertical: propTypes.exports.oneOf(['top', 'bottom']),
        horizontal: propTypes.exports.oneOf(['start', 'end'])
    }),
    size: propTypes.exports.oneOf([null, 'small', 'medium', 'large']),
    fillMode: propTypes.exports.oneOf([null, 'solid', 'outline']),
    fill: propTypes.exports.oneOf([null, 'solid', 'outline']),
    themeColor: propTypes.exports.oneOf([null,
        'primary', 'secondary', 'tertiary',
        'info', 'success', 'warning',
        'error', 'dark', 'light', 'inverse', 'inherit'
    ]),
    shape: propTypes.exports.oneOf(['circle', 'rectangle', 'rounded', 'dot', 'pill']),
    rounded: propTypes.exports.oneOf([null, 'small', 'medium', 'large', 'full']),
    position: propTypes.exports.oneOf(['edge', 'outside', 'inside']),
    cutoutBorder: propTypes.exports.bool
};
var defaultProps = {
    size: 'medium',
    fillMode: 'solid',
    themeColor: 'primary',
    position: 'edge',
    align: { vertical: 'top', horizontal: 'end' },
    cutoutBorder: false
};
Badge.defaultProps = defaultProps;
Badge.displayName = 'KendoBadge';

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Represents the [KendoReact BadgeContainer component]({% slug overview_badge %}).
 *
 * @example
 * ```jsx
 * const App = () => {
 *   return (
 *       <BadgeContainer>
 *           <Avatar shape="circle" type="image">
 *               <img src={'https://demos.telerik.com/kendo-ui/content/web/Customers/RICSU.jpg'} />
 *           </Avatar>
 *           <Badge cornerPlacement="edge" position="topEnd" shape="dot">
 *       </BadgeContainer>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
var BadgeContainer = React.forwardRef(function (props, target) {
    var children = props.children, className = props.className, style = props.style;
    var elementRef = React.useRef(null);
    var focusElement = React.useCallback(function () {
        if (elementRef.current) {
            elementRef.current.focus();
        }
    }, []);
    React.useImperativeHandle(target, function () { return ({
        element: elementRef.current,
        focus: focusElement
    }); });
    var dir = useDir(elementRef, props.dir);
    var containerClasses = React.useMemo(function () { return classNames$2('k-badge-container', className); }, [className]);
    var containerStyles = React.useMemo(function () { return (__assign({ display: 'inline-block' }, style)); }, [style]);
    return (React.createElement("span", { className: containerClasses, style: containerStyles, dir: dir }, children));
});
BadgeContainer.propTypes = {
    className: propTypes.exports.string,
    dir: propTypes.exports.string,
    style: propTypes.exports.object
};
BadgeContainer.displayName = 'KendoBadgeContainer';

var setAccesiblityAttribute = function (componentRef) {
    var _a, _b;
    if (componentRef && componentRef.current && componentRef.current.element) {
        var gridDropDown = (_b = (_a = componentRef === null || componentRef === void 0 ? void 0 : componentRef.current) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.getElementsByClassName("k-dropdownlist");
        if (gridDropDown && gridDropDown.length > 0) {
            Array.from(gridDropDown).forEach(function (element, index) {
                element.setAttribute("aria-label", "grid-pager-dropdown-button-".concat(index));
            });
        }
    }
};
var aggregates = [
    { field: "UnitsInStock", aggregate: "sum" },
    { field: "UnitPrice", aggregate: "average" },
];
var processWithGroups = function (data, groups) {
    if (groups) {
        groups.forEach(function (group) { return (group.aggregates = aggregates); });
    }
    var newDataState = groupBy(data, groups);
    setGroupIds({ data: newDataState, group: groups });
    return newDataState;
};
//transforming sort info to grid sort format
var processWithSort = function (sortData) {
    var transformedSort;
    transformedSort = sortData === null || sortData === void 0 ? void 0 : sortData.map(function (sortField) {
        return {
            field: sortField.field,
            dir: sortField.direction === "DESC" ? "desc" : "asc",
        };
    });
    return transformedSort;
};
var itemRender = function (props) {
    var _a, _b;
    return (jsxRuntime.exports.jsx("div", { children: (_b = (_a = props === null || props === void 0 ? void 0 : props.item) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.map(function (appliedFilter, index) { return (jsxRuntime.exports.jsxs("div", { children: [index > 0 ? (jsxRuntime.exports.jsx("h4", __assign$Y({ style: {
                        width: "100%",
                        textAlign: "center",
                        borderBottom: "1px solid #000",
                        lineHeight: "0.1em",
                    } }, { children: jsxRuntime.exports.jsx("span", __assign$Y({ style: {
                            background: "#fff",
                        } }, { children: props.item.logic })) }))) : null, jsxRuntime.exports.jsx("div", { children: jsxRuntime.exports.jsxs("div", { children: [jsxRuntime.exports.jsxs("span", __assign$Y({ style: { fontWeight: "bolder", paddingLeft: "5px" } }, { children: [appliedFilter.operator, ":", " "] })), jsxRuntime.exports.jsx("span", { children: appliedFilter.value })] }) })] }, "filter-operator-".concat(index))); }) }, "filter-item-".concat(props === null || props === void 0 ? void 0 : props.itemIndex)));
};
var DataGrid = function (_a) {
    var _b, _c;
    var id = _a.id, headers = _a.headers, gridHeight = _a.gridHeight, data = _a.data, total = _a.total, skip = _a.skip, take = _a.take, group = _a.group, sort = _a.sort, sortable = _a.sortable, filterable = _a.filterable, filter = _a.filter, pageSizes = _a.pageSizes, reorderable = _a.reorderable, resizable = _a.resizable, pageable = _a.pageable, rowRender = _a.rowRender, cellRender = _a.cellRender, 
    // filterable,
    // groupable,
    showloader = _a.showloader, allowUnsort = _a.allowUnsort, sortingMode = _a.sortingMode, editField = _a.editField, editMode = _a.editMode, selectedField = _a.selectedField, allowEditing = _a.allowEditing, checkboxTypeFilter = _a.checkboxTypeFilter, onItemChangeHandler = _a.onItemChangeHandler, onSelectionChangeHandler = _a.onSelectionChangeHandler, onHeaderSelectionChangeHandler = _a.onHeaderSelectionChangeHandler, onRowClickHandler = _a.onRowClickHandler, pageChangeHandler = _a.pageChangeHandler, sortChangeHandler = _a.sortChangeHandler, filterChangeHandler = _a.filterChangeHandler;
    var gridRef = React__default.useRef(null);
    var _d = React__default.useState([]), collapsedState = _d[0], setCollapsedState = _d[1];
    var _e = React__default.useState(group), gridGroup = _e[0], setGridGroup = _e[1];
    var _f = React__default.useState(processWithSort(sort)), sortData = _f[0], setSortData = _f[1];
    React__default.useEffect(function () {
        setAttribute(gridRef, "data-testid", id);
        setAccesiblityAttribute(gridRef);
    });
    React__default.useEffect(function () {
        setSortData(processWithSort(sort));
    }, [sort]);
    var sortChange = function (event) {
        if (sortChangeHandler) {
            var sortedData = event.sort.map(function (sortField) {
                return {
                    field: sortField.field,
                    direction: sortField.dir === "desc" ? "DESC" : "ASC",
                };
            });
            sortChangeHandler(sortedData);
        }
    };
    var pageChange = function (event) {
        if (pageChangeHandler) {
            pageChangeHandler(event.page.skip, event.page.take);
        }
    };
    var filterChange = function (event) {
        if (filterChangeHandler) {
            filterChangeHandler(event.filter);
        }
    };
    var onGroupChange = function (event) {
        setGridGroup(event.group);
    };
    var onExpandChange = function (event) {
        var item = event.dataItem;
        if (item.groupId) {
            var newCollapsedIds = !event.value
                ? __spreadArray$b(__spreadArray$b([], collapsedState, true), [item.groupId], false) : collapsedState.filter(function (groupId) { return groupId !== item.groupId; });
            setCollapsedState(newCollapsedIds);
        }
    };
    var removeFilter = function (index) {
        if (filter) {
            var currFilter = __assign$Y({}, filter);
            currFilter.filters.splice(index, 1);
            if (filterChangeHandler) {
                filterChangeHandler(currFilter);
            }
        }
    };
    var removeAllFilter = function () {
        if (filter) {
            var currFilter = __assign$Y(__assign$Y({}, filter), { filters: [] });
            if (filterChangeHandler) {
                filterChangeHandler(currFilter);
            }
        }
    };
    var gridData = setExpandedState({
        data: processWithGroups(data, gridGroup),
        collapsedIds: collapsedState,
    });
    var CheckboxColumnMenu = function (props) { return jsxRuntime.exports.jsx(ColumnMenuCheckboxFilter, __assign$Y({}, props, { data: gridData })); };
    var customColumnMenu = (sortable && filterable) ? checkboxTypeFilter ? CheckboxColumnMenu : ColumnMenu : undefined;
    return (jsxRuntime.exports.jsxs(React__default.Fragment, { children: [jsxRuntime.exports.jsxs(StyledGrid, __assign$Y({ ref: gridRef, reorderable: reorderable, resizable: resizable, rowRender: rowRender, cellRender: cellRender, onExpandChange: onExpandChange, expandField: "expanded", onGroupChange: onGroupChange, style: { height: gridHeight }, data: gridData, total: total, pageable: pageable ? {
                    buttonCount: 5,
                    info: true,
                    type: "numeric",
                    pageSizes: pageSizes,
                    previousNext: true,
                } : false, skip: skip, take: take, group: gridGroup, onPageChange: pageChange, sortable: {
                    mode: sortingMode,
                    allowUnsort: allowUnsort,
                }, selectedField: selectedField, selectable: {
                    enabled: editMode,
                    drag: false,
                    cell: false,
                    mode: "multiple",
                }, editField: editField, onItemChange: onItemChangeHandler, sort: sortData, onSortChange: sortChange, filter: filter, onSelectionChange: onSelectionChangeHandler, onRowClick: onRowClickHandler, onHeaderSelectionChange: onHeaderSelectionChangeHandler, onFilterChange: filterChange, className: allowEditing && !editMode ? "edit-mode" : "" }, { children: [filter && ((_b = filter.filters) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (jsxRuntime.exports.jsxs(GridToolbar, { children: [jsxRuntime.exports.jsx("div", __assign$Y({ style: { flexGrow: "1" } }, { children: (_c = filter === null || filter === void 0 ? void 0 : filter.filters) === null || _c === void 0 ? void 0 : _c.map(function (filterArray, i) {
                                    var _a, _b;
                                    if (((_a = filterArray === null || filterArray === void 0 ? void 0 : filterArray.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                        return (jsxRuntime.exports.jsx("div", __assign$Y({ style: { paddingRight: "15px" } }, { children: jsxRuntime.exports.jsxs(BadgeContainer, { children: [jsxRuntime.exports.jsx(Badge, __assign$Y({ style: {
                                                            height: "15px",
                                                            width: "15px",
                                                            border: "solid black 1px",
                                                            backgroundColor: "black",
                                                            transform: "translate(30%, -30%)",
                                                        }, themeColor: "tertiary" }, { children: jsxRuntime.exports.jsx("span", { id: "".concat(id, "-grid-clear-filter"), style: { fontSize: "10px" }, className: "k-icon k-i-close", onClick: function () {
                                                                removeFilter(i);
                                                            } }) })), jsxRuntime.exports.jsx(DropDownButton$1, { text: (_b = headers === null || headers === void 0 ? void 0 : headers.find(function (x) {
                                                            return x.name.toLowerCase() ==
                                                                filterArray.filters[0].field.toLowerCase();
                                                        })) === null || _b === void 0 ? void 0 : _b.headerName, itemRender: itemRender, items: [filterArray] })] }) }), "filter-badge-element-".concat(i)));
                                    }
                                    else {
                                        return null;
                                    }
                                }) })), jsxRuntime.exports.jsx(Button$1, __assign$Y({ id: "".concat(id, "-grid-clear-all"), onClick: removeAllFilter, themeColor: "primary" }, { children: "Clear all filters" }))] })) : null, allowEditing && (jsxRuntime.exports.jsx(GridColumn, { className: editMode ? "" : "disable-selection", field: selectedField, headerSelectionValue: data.every(function (row) {
                            return selectedField ? row[selectedField] : false;
                        }) })), headers === null || headers === void 0 ? void 0 : headers.map(function (header, i) {
                        return (jsxRuntime.exports.jsx(GridColumn, { field: header.name, title: header.headerName, filter: header.type, editor: header.type, editable: header.editable, format: header.format, width: header.width, columnMenu: customColumnMenu, cell: header.cell }, i));
                    })] })), showloader ? jsxRuntime.exports.jsx(LoadingPanel, {}) : null] }));
};

var DataGridProps = /** @class */ (function () {
    function DataGridProps() {
        this.id = "";
        this.headers = [];
        this.data = [];
        this.sortable = false;
        this.filterable = false;
        this.pageSizes = [];
        this.pageable = false;
        this.gridHeight = "400px";
        this.reorderable = false;
        this.resizable = false;
        this.showloader = false;
        this.allowUnsort = true;
        this.allowEditing = false;
        this.checkboxTypeFilter = false;
    }
    return DataGridProps;
}());

export { DataGrid, DataGridProps };
